/******/ (() => {
  // webpackBootstrap
  /******/ var __webpack_modules__ = {
    /***/ "./node_modules/@splidejs/splide/dist/js/splide.esm.js":
      /*!*************************************************************!*\
  !*** ./node_modules/@splidejs/splide/dist/js/splide.esm.js ***!
  \*************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ CLASSES: () => /* binding */ CLASSES,
          /* harmony export */ CLASS_ACTIVE: () => /* binding */ CLASS_ACTIVE,
          /* harmony export */ CLASS_ARROW: () => /* binding */ CLASS_ARROW,
          /* harmony export */ CLASS_ARROWS: () => /* binding */ CLASS_ARROWS,
          /* harmony export */ CLASS_ARROW_NEXT: () =>
            /* binding */ CLASS_ARROW_NEXT,
          /* harmony export */ CLASS_ARROW_PREV: () =>
            /* binding */ CLASS_ARROW_PREV,
          /* harmony export */ CLASS_CLONE: () => /* binding */ CLASS_CLONE,
          /* harmony export */ CLASS_CONTAINER: () =>
            /* binding */ CLASS_CONTAINER,
          /* harmony export */ CLASS_FOCUS_IN: () =>
            /* binding */ CLASS_FOCUS_IN,
          /* harmony export */ CLASS_INITIALIZED: () =>
            /* binding */ CLASS_INITIALIZED,
          /* harmony export */ CLASS_LIST: () => /* binding */ CLASS_LIST,
          /* harmony export */ CLASS_LOADING: () => /* binding */ CLASS_LOADING,
          /* harmony export */ CLASS_NEXT: () => /* binding */ CLASS_NEXT,
          /* harmony export */ CLASS_OVERFLOW: () =>
            /* binding */ CLASS_OVERFLOW,
          /* harmony export */ CLASS_PAGINATION: () =>
            /* binding */ CLASS_PAGINATION,
          /* harmony export */ CLASS_PAGINATION_PAGE: () =>
            /* binding */ CLASS_PAGINATION_PAGE,
          /* harmony export */ CLASS_PREV: () => /* binding */ CLASS_PREV,
          /* harmony export */ CLASS_PROGRESS: () =>
            /* binding */ CLASS_PROGRESS,
          /* harmony export */ CLASS_PROGRESS_BAR: () =>
            /* binding */ CLASS_PROGRESS_BAR,
          /* harmony export */ CLASS_ROOT: () => /* binding */ CLASS_ROOT,
          /* harmony export */ CLASS_SLIDE: () => /* binding */ CLASS_SLIDE,
          /* harmony export */ CLASS_SPINNER: () => /* binding */ CLASS_SPINNER,
          /* harmony export */ CLASS_SR: () => /* binding */ CLASS_SR,
          /* harmony export */ CLASS_TOGGLE: () => /* binding */ CLASS_TOGGLE,
          /* harmony export */ CLASS_TOGGLE_PAUSE: () =>
            /* binding */ CLASS_TOGGLE_PAUSE,
          /* harmony export */ CLASS_TOGGLE_PLAY: () =>
            /* binding */ CLASS_TOGGLE_PLAY,
          /* harmony export */ CLASS_TRACK: () => /* binding */ CLASS_TRACK,
          /* harmony export */ CLASS_VISIBLE: () => /* binding */ CLASS_VISIBLE,
          /* harmony export */ DEFAULTS: () => /* binding */ DEFAULTS,
          /* harmony export */ EVENT_ACTIVE: () => /* binding */ EVENT_ACTIVE,
          /* harmony export */ EVENT_ARROWS_MOUNTED: () =>
            /* binding */ EVENT_ARROWS_MOUNTED,
          /* harmony export */ EVENT_ARROWS_UPDATED: () =>
            /* binding */ EVENT_ARROWS_UPDATED,
          /* harmony export */ EVENT_AUTOPLAY_PAUSE: () =>
            /* binding */ EVENT_AUTOPLAY_PAUSE,
          /* harmony export */ EVENT_AUTOPLAY_PLAY: () =>
            /* binding */ EVENT_AUTOPLAY_PLAY,
          /* harmony export */ EVENT_AUTOPLAY_PLAYING: () =>
            /* binding */ EVENT_AUTOPLAY_PLAYING,
          /* harmony export */ EVENT_CLICK: () => /* binding */ EVENT_CLICK,
          /* harmony export */ EVENT_DESTROY: () => /* binding */ EVENT_DESTROY,
          /* harmony export */ EVENT_DRAG: () => /* binding */ EVENT_DRAG,
          /* harmony export */ EVENT_DRAGGED: () => /* binding */ EVENT_DRAGGED,
          /* harmony export */ EVENT_DRAGGING: () =>
            /* binding */ EVENT_DRAGGING,
          /* harmony export */ EVENT_END_INDEX_CHANGED: () =>
            /* binding */ EVENT_END_INDEX_CHANGED,
          /* harmony export */ EVENT_HIDDEN: () => /* binding */ EVENT_HIDDEN,
          /* harmony export */ EVENT_INACTIVE: () =>
            /* binding */ EVENT_INACTIVE,
          /* harmony export */ EVENT_LAZYLOAD_LOADED: () =>
            /* binding */ EVENT_LAZYLOAD_LOADED,
          /* harmony export */ EVENT_MOUNTED: () => /* binding */ EVENT_MOUNTED,
          /* harmony export */ EVENT_MOVE: () => /* binding */ EVENT_MOVE,
          /* harmony export */ EVENT_MOVED: () => /* binding */ EVENT_MOVED,
          /* harmony export */ EVENT_NAVIGATION_MOUNTED: () =>
            /* binding */ EVENT_NAVIGATION_MOUNTED,
          /* harmony export */ EVENT_OVERFLOW: () =>
            /* binding */ EVENT_OVERFLOW,
          /* harmony export */ EVENT_PAGINATION_MOUNTED: () =>
            /* binding */ EVENT_PAGINATION_MOUNTED,
          /* harmony export */ EVENT_PAGINATION_UPDATED: () =>
            /* binding */ EVENT_PAGINATION_UPDATED,
          /* harmony export */ EVENT_READY: () => /* binding */ EVENT_READY,
          /* harmony export */ EVENT_REFRESH: () => /* binding */ EVENT_REFRESH,
          /* harmony export */ EVENT_RESIZE: () => /* binding */ EVENT_RESIZE,
          /* harmony export */ EVENT_RESIZED: () => /* binding */ EVENT_RESIZED,
          /* harmony export */ EVENT_SCROLL: () => /* binding */ EVENT_SCROLL,
          /* harmony export */ EVENT_SCROLLED: () =>
            /* binding */ EVENT_SCROLLED,
          /* harmony export */ EVENT_SHIFTED: () => /* binding */ EVENT_SHIFTED,
          /* harmony export */ EVENT_SLIDE_KEYDOWN: () =>
            /* binding */ EVENT_SLIDE_KEYDOWN,
          /* harmony export */ EVENT_UPDATED: () => /* binding */ EVENT_UPDATED,
          /* harmony export */ EVENT_VISIBLE: () => /* binding */ EVENT_VISIBLE,
          /* harmony export */ EventBinder: () => /* binding */ EventBinder,
          /* harmony export */ EventInterface: () =>
            /* binding */ EventInterface,
          /* harmony export */ FADE: () => /* binding */ FADE,
          /* harmony export */ LOOP: () => /* binding */ LOOP,
          /* harmony export */ LTR: () => /* binding */ LTR,
          /* harmony export */ RTL: () => /* binding */ RTL,
          /* harmony export */ RequestInterval: () =>
            /* binding */ RequestInterval,
          /* harmony export */ SLIDE: () => /* binding */ SLIDE,
          /* harmony export */ STATUS_CLASSES: () =>
            /* binding */ STATUS_CLASSES,
          /* harmony export */ Splide: () => /* binding */ Splide,
          /* harmony export */ SplideRenderer: () =>
            /* binding */ SplideRenderer,
          /* harmony export */ State: () => /* binding */ State,
          /* harmony export */ TTB: () => /* binding */ TTB,
          /* harmony export */ Throttle: () => /* binding */ Throttle,
          /* harmony export */ default: () => /* binding */ Splide,
          /* harmony export */
        });
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          Object.defineProperty(Constructor, "prototype", { writable: false });
          return Constructor;
        }

        /*!
         * Splide.js
         * Version  : 4.1.4
         * License  : MIT
         * Copyright: 2022 Naotoshi Fujita
         */
        var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
        var CREATED = 1;
        var MOUNTED = 2;
        var IDLE = 3;
        var MOVING = 4;
        var SCROLLING = 5;
        var DRAGGING = 6;
        var DESTROYED = 7;
        var STATES = {
          CREATED: CREATED,
          MOUNTED: MOUNTED,
          IDLE: IDLE,
          MOVING: MOVING,
          SCROLLING: SCROLLING,
          DRAGGING: DRAGGING,
          DESTROYED: DESTROYED,
        };

        function empty(array) {
          array.length = 0;
        }

        function slice(arrayLike, start, end) {
          return Array.prototype.slice.call(arrayLike, start, end);
        }

        function apply(func) {
          return func.bind.apply(func, [null].concat(slice(arguments, 1)));
        }

        var nextTick = setTimeout;

        var noop = function noop() {};

        function raf(func) {
          return requestAnimationFrame(func);
        }

        function typeOf(type, subject) {
          return typeof subject === type;
        }

        function isObject(subject) {
          return !isNull(subject) && typeOf("object", subject);
        }

        var isArray = Array.isArray;
        var isFunction = apply(typeOf, "function");
        var isString = apply(typeOf, "string");
        var isUndefined = apply(typeOf, "undefined");

        function isNull(subject) {
          return subject === null;
        }

        function isHTMLElement(subject) {
          try {
            return (
              subject instanceof
              (subject.ownerDocument.defaultView || window).HTMLElement
            );
          } catch (e) {
            return false;
          }
        }

        function toArray(value) {
          return isArray(value) ? value : [value];
        }

        function forEach(values, iteratee) {
          toArray(values).forEach(iteratee);
        }

        function includes(array, value) {
          return array.indexOf(value) > -1;
        }

        function push(array, items) {
          array.push.apply(array, toArray(items));
          return array;
        }

        function toggleClass(elm, classes, add) {
          if (elm) {
            forEach(classes, function (name) {
              if (name) {
                elm.classList[add ? "add" : "remove"](name);
              }
            });
          }
        }

        function addClass(elm, classes) {
          toggleClass(
            elm,
            isString(classes) ? classes.split(" ") : classes,
            true
          );
        }

        function append(parent, children) {
          forEach(children, parent.appendChild.bind(parent));
        }

        function before(nodes, ref) {
          forEach(nodes, function (node) {
            var parent = (ref || node).parentNode;

            if (parent) {
              parent.insertBefore(node, ref);
            }
          });
        }

        function matches(elm, selector) {
          return (
            isHTMLElement(elm) &&
            (elm["msMatchesSelector"] || elm.matches).call(elm, selector)
          );
        }

        function children(parent, selector) {
          var children2 = parent ? slice(parent.children) : [];
          return selector
            ? children2.filter(function (child) {
                return matches(child, selector);
              })
            : children2;
        }

        function child(parent, selector) {
          return selector
            ? children(parent, selector)[0]
            : parent.firstElementChild;
        }

        var ownKeys = Object.keys;

        function forOwn(object, iteratee, right) {
          if (object) {
            (right ? ownKeys(object).reverse() : ownKeys(object)).forEach(
              function (key) {
                key !== "__proto__" && iteratee(object[key], key);
              }
            );
          }

          return object;
        }

        function assign(object) {
          slice(arguments, 1).forEach(function (source) {
            forOwn(source, function (value, key) {
              object[key] = source[key];
            });
          });
          return object;
        }

        function merge(object) {
          slice(arguments, 1).forEach(function (source) {
            forOwn(source, function (value, key) {
              if (isArray(value)) {
                object[key] = value.slice();
              } else if (isObject(value)) {
                object[key] = merge(
                  {},
                  isObject(object[key]) ? object[key] : {},
                  value
                );
              } else {
                object[key] = value;
              }
            });
          });
          return object;
        }

        function omit(object, keys) {
          forEach(keys || ownKeys(object), function (key) {
            delete object[key];
          });
        }

        function removeAttribute(elms, attrs) {
          forEach(elms, function (elm) {
            forEach(attrs, function (attr) {
              elm && elm.removeAttribute(attr);
            });
          });
        }

        function setAttribute(elms, attrs, value) {
          if (isObject(attrs)) {
            forOwn(attrs, function (value2, name) {
              setAttribute(elms, name, value2);
            });
          } else {
            forEach(elms, function (elm) {
              isNull(value) || value === ""
                ? removeAttribute(elm, attrs)
                : elm.setAttribute(attrs, String(value));
            });
          }
        }

        function create(tag, attrs, parent) {
          var elm = document.createElement(tag);

          if (attrs) {
            isString(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
          }

          parent && append(parent, elm);
          return elm;
        }

        function style(elm, prop, value) {
          if (isUndefined(value)) {
            return getComputedStyle(elm)[prop];
          }

          if (!isNull(value)) {
            elm.style[prop] = "" + value;
          }
        }

        function display(elm, display2) {
          style(elm, "display", display2);
        }

        function focus(elm) {
          (elm["setActive"] && elm["setActive"]()) ||
            elm.focus({
              preventScroll: true,
            });
        }

        function getAttribute(elm, attr) {
          return elm.getAttribute(attr);
        }

        function hasClass(elm, className) {
          return elm && elm.classList.contains(className);
        }

        function rect(target) {
          return target.getBoundingClientRect();
        }

        function remove(nodes) {
          forEach(nodes, function (node) {
            if (node && node.parentNode) {
              node.parentNode.removeChild(node);
            }
          });
        }

        function parseHtml(html) {
          return child(new DOMParser().parseFromString(html, "text/html").body);
        }

        function prevent(e, stopPropagation) {
          e.preventDefault();

          if (stopPropagation) {
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        }

        function query(parent, selector) {
          return parent && parent.querySelector(selector);
        }

        function queryAll(parent, selector) {
          return selector ? slice(parent.querySelectorAll(selector)) : [];
        }

        function removeClass(elm, classes) {
          toggleClass(elm, classes, false);
        }

        function timeOf(e) {
          return e.timeStamp;
        }

        function unit(value) {
          return isString(value) ? value : value ? value + "px" : "";
        }

        var PROJECT_CODE = "splide";
        var DATA_ATTRIBUTE = "data-" + PROJECT_CODE;

        function assert(condition, message) {
          if (!condition) {
            throw new Error("[" + PROJECT_CODE + "] " + (message || ""));
          }
        }

        var min = Math.min,
          max = Math.max,
          floor = Math.floor,
          ceil = Math.ceil,
          abs = Math.abs;

        function approximatelyEqual(x, y, epsilon) {
          return abs(x - y) < epsilon;
        }

        function between(number, x, y, exclusive) {
          var minimum = min(x, y);
          var maximum = max(x, y);
          return exclusive
            ? minimum < number && number < maximum
            : minimum <= number && number <= maximum;
        }

        function clamp(number, x, y) {
          var minimum = min(x, y);
          var maximum = max(x, y);
          return min(max(minimum, number), maximum);
        }

        function sign(x) {
          return +(x > 0) - +(x < 0);
        }

        function camelToKebab(string) {
          return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        }

        function format(string, replacements) {
          forEach(replacements, function (replacement) {
            string = string.replace("%s", "" + replacement);
          });
          return string;
        }

        function pad(number) {
          return number < 10 ? "0" + number : "" + number;
        }

        var ids = {};

        function uniqueId(prefix) {
          return "" + prefix + pad((ids[prefix] = (ids[prefix] || 0) + 1));
        }

        function EventBinder() {
          var listeners = [];

          function bind(targets, events, callback, options) {
            forEachEvent(targets, events, function (target, event, namespace) {
              var isEventTarget = "addEventListener" in target;
              var remover = isEventTarget
                ? target.removeEventListener.bind(
                    target,
                    event,
                    callback,
                    options
                  )
                : target["removeListener"].bind(target, callback);
              isEventTarget
                ? target.addEventListener(event, callback, options)
                : target["addListener"](callback);
              listeners.push([target, event, namespace, callback, remover]);
            });
          }

          function unbind(targets, events, callback) {
            forEachEvent(targets, events, function (target, event, namespace) {
              listeners = listeners.filter(function (listener) {
                if (
                  listener[0] === target &&
                  listener[1] === event &&
                  listener[2] === namespace &&
                  (!callback || listener[3] === callback)
                ) {
                  listener[4]();
                  return false;
                }

                return true;
              });
            });
          }

          function dispatch(target, type, detail) {
            var e;
            var bubbles = true;

            if (typeof CustomEvent === "function") {
              e = new CustomEvent(type, {
                bubbles: bubbles,
                detail: detail,
              });
            } else {
              e = document.createEvent("CustomEvent");
              e.initCustomEvent(type, bubbles, false, detail);
            }

            target.dispatchEvent(e);
            return e;
          }

          function forEachEvent(targets, events, iteratee) {
            forEach(targets, function (target) {
              target &&
                forEach(events, function (events2) {
                  events2.split(" ").forEach(function (eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                  });
                });
            });
          }

          function destroy() {
            listeners.forEach(function (data) {
              data[4]();
            });
            empty(listeners);
          }

          return {
            bind: bind,
            unbind: unbind,
            dispatch: dispatch,
            destroy: destroy,
          };
        }

        var EVENT_MOUNTED = "mounted";
        var EVENT_READY = "ready";
        var EVENT_MOVE = "move";
        var EVENT_MOVED = "moved";
        var EVENT_CLICK = "click";
        var EVENT_ACTIVE = "active";
        var EVENT_INACTIVE = "inactive";
        var EVENT_VISIBLE = "visible";
        var EVENT_HIDDEN = "hidden";
        var EVENT_REFRESH = "refresh";
        var EVENT_UPDATED = "updated";
        var EVENT_RESIZE = "resize";
        var EVENT_RESIZED = "resized";
        var EVENT_DRAG = "drag";
        var EVENT_DRAGGING = "dragging";
        var EVENT_DRAGGED = "dragged";
        var EVENT_SCROLL = "scroll";
        var EVENT_SCROLLED = "scrolled";
        var EVENT_OVERFLOW = "overflow";
        var EVENT_DESTROY = "destroy";
        var EVENT_ARROWS_MOUNTED = "arrows:mounted";
        var EVENT_ARROWS_UPDATED = "arrows:updated";
        var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
        var EVENT_PAGINATION_UPDATED = "pagination:updated";
        var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
        var EVENT_AUTOPLAY_PLAY = "autoplay:play";
        var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
        var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
        var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";
        var EVENT_SLIDE_KEYDOWN = "sk";
        var EVENT_SHIFTED = "sh";
        var EVENT_END_INDEX_CHANGED = "ei";

        function EventInterface(Splide2) {
          var bus = Splide2
            ? Splide2.event.bus
            : document.createDocumentFragment();
          var binder = EventBinder();

          function on(events, callback) {
            binder.bind(bus, toArray(events).join(" "), function (e) {
              callback.apply(callback, isArray(e.detail) ? e.detail : []);
            });
          }

          function emit(event) {
            binder.dispatch(bus, event, slice(arguments, 1));
          }

          if (Splide2) {
            Splide2.event.on(EVENT_DESTROY, binder.destroy);
          }

          return assign(binder, {
            bus: bus,
            on: on,
            off: apply(binder.unbind, bus),
            emit: emit,
          });
        }

        function RequestInterval(interval, onInterval, onUpdate, limit) {
          var now = Date.now;
          var startTime;
          var rate = 0;
          var id;
          var paused = true;
          var count = 0;

          function update() {
            if (!paused) {
              rate = interval ? min((now() - startTime) / interval, 1) : 1;
              onUpdate && onUpdate(rate);

              if (rate >= 1) {
                onInterval();
                startTime = now();

                if (limit && ++count >= limit) {
                  return pause();
                }
              }

              id = raf(update);
            }
          }

          function start(resume) {
            resume || cancel();
            startTime = now() - (resume ? rate * interval : 0);
            paused = false;
            id = raf(update);
          }

          function pause() {
            paused = true;
          }

          function rewind() {
            startTime = now();
            rate = 0;

            if (onUpdate) {
              onUpdate(rate);
            }
          }

          function cancel() {
            id && cancelAnimationFrame(id);
            rate = 0;
            id = 0;
            paused = true;
          }

          function set(time) {
            interval = time;
          }

          function isPaused() {
            return paused;
          }

          return {
            start: start,
            rewind: rewind,
            pause: pause,
            cancel: cancel,
            set: set,
            isPaused: isPaused,
          };
        }

        function State(initialState) {
          var state = initialState;

          function set(value) {
            state = value;
          }

          function is(states) {
            return includes(toArray(states), state);
          }

          return {
            set: set,
            is: is,
          };
        }

        function Throttle(func, duration) {
          var interval = RequestInterval(duration || 0, func, null, 1);
          return function () {
            interval.isPaused() && interval.start();
          };
        }

        function Media(Splide2, Components2, options) {
          var state = Splide2.state;
          var breakpoints = options.breakpoints || {};
          var reducedMotion = options.reducedMotion || {};
          var binder = EventBinder();
          var queries = [];

          function setup() {
            var isMin = options.mediaQuery === "min";
            ownKeys(breakpoints)
              .sort(function (n, m) {
                return isMin ? +n - +m : +m - +n;
              })
              .forEach(function (key) {
                register(
                  breakpoints[key],
                  "(" + (isMin ? "min" : "max") + "-width:" + key + "px)"
                );
              });
            register(reducedMotion, MEDIA_PREFERS_REDUCED_MOTION);
            update();
          }

          function destroy(completely) {
            if (completely) {
              binder.destroy();
            }
          }

          function register(options2, query) {
            var queryList = matchMedia(query);
            binder.bind(queryList, "change", update);
            queries.push([options2, queryList]);
          }

          function update() {
            var destroyed = state.is(DESTROYED);
            var direction = options.direction;
            var merged = queries.reduce(function (merged2, entry) {
              return merge(merged2, entry[1].matches ? entry[0] : {});
            }, {});
            omit(options);
            set(merged);

            if (options.destroy) {
              Splide2.destroy(options.destroy === "completely");
            } else if (destroyed) {
              destroy(true);
              Splide2.mount();
            } else {
              direction !== options.direction && Splide2.refresh();
            }
          }

          function reduce(enable) {
            if (matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches) {
              enable
                ? merge(options, reducedMotion)
                : omit(options, ownKeys(reducedMotion));
            }
          }

          function set(opts, base, notify) {
            merge(options, opts);
            base && merge(Object.getPrototypeOf(options), opts);

            if (notify || !state.is(CREATED)) {
              Splide2.emit(EVENT_UPDATED, options);
            }
          }

          return {
            setup: setup,
            destroy: destroy,
            reduce: reduce,
            set: set,
          };
        }

        var ARROW = "Arrow";
        var ARROW_LEFT = ARROW + "Left";
        var ARROW_RIGHT = ARROW + "Right";
        var ARROW_UP = ARROW + "Up";
        var ARROW_DOWN = ARROW + "Down";
        var LTR = "ltr";
        var RTL = "rtl";
        var TTB = "ttb";
        var ORIENTATION_MAP = {
          width: ["height"],
          left: ["top", "right"],
          right: ["bottom", "left"],
          x: ["y"],
          X: ["Y"],
          Y: ["X"],
          ArrowLeft: [ARROW_UP, ARROW_RIGHT],
          ArrowRight: [ARROW_DOWN, ARROW_LEFT],
        };

        function Direction(Splide2, Components2, options) {
          function resolve(prop, axisOnly, direction) {
            direction = direction || options.direction;
            var index =
              direction === RTL && !axisOnly ? 1 : direction === TTB ? 0 : -1;
            return (
              (ORIENTATION_MAP[prop] && ORIENTATION_MAP[prop][index]) ||
              prop.replace(/width|left|right/i, function (match, offset) {
                var replacement =
                  ORIENTATION_MAP[match.toLowerCase()][index] || match;
                return offset > 0
                  ? replacement.charAt(0).toUpperCase() + replacement.slice(1)
                  : replacement;
              })
            );
          }

          function orient(value) {
            return value * (options.direction === RTL ? 1 : -1);
          }

          return {
            resolve: resolve,
            orient: orient,
          };
        }

        var ROLE = "role";
        var TAB_INDEX = "tabindex";
        var DISABLED = "disabled";
        var ARIA_PREFIX = "aria-";
        var ARIA_CONTROLS = ARIA_PREFIX + "controls";
        var ARIA_CURRENT = ARIA_PREFIX + "current";
        var ARIA_SELECTED = ARIA_PREFIX + "selected";
        var ARIA_LABEL = ARIA_PREFIX + "label";
        var ARIA_LABELLEDBY = ARIA_PREFIX + "labelledby";
        var ARIA_HIDDEN = ARIA_PREFIX + "hidden";
        var ARIA_ORIENTATION = ARIA_PREFIX + "orientation";
        var ARIA_ROLEDESCRIPTION = ARIA_PREFIX + "roledescription";
        var ARIA_LIVE = ARIA_PREFIX + "live";
        var ARIA_BUSY = ARIA_PREFIX + "busy";
        var ARIA_ATOMIC = ARIA_PREFIX + "atomic";
        var ALL_ATTRIBUTES = [
          ROLE,
          TAB_INDEX,
          DISABLED,
          ARIA_CONTROLS,
          ARIA_CURRENT,
          ARIA_LABEL,
          ARIA_LABELLEDBY,
          ARIA_HIDDEN,
          ARIA_ORIENTATION,
          ARIA_ROLEDESCRIPTION,
        ];
        var CLASS_PREFIX = PROJECT_CODE + "__";
        var STATUS_CLASS_PREFIX = "is-";
        var CLASS_ROOT = PROJECT_CODE;
        var CLASS_TRACK = CLASS_PREFIX + "track";
        var CLASS_LIST = CLASS_PREFIX + "list";
        var CLASS_SLIDE = CLASS_PREFIX + "slide";
        var CLASS_CLONE = CLASS_SLIDE + "--clone";
        var CLASS_CONTAINER = CLASS_SLIDE + "__container";
        var CLASS_ARROWS = CLASS_PREFIX + "arrows";
        var CLASS_ARROW = CLASS_PREFIX + "arrow";
        var CLASS_ARROW_PREV = CLASS_ARROW + "--prev";
        var CLASS_ARROW_NEXT = CLASS_ARROW + "--next";
        var CLASS_PAGINATION = CLASS_PREFIX + "pagination";
        var CLASS_PAGINATION_PAGE = CLASS_PAGINATION + "__page";
        var CLASS_PROGRESS = CLASS_PREFIX + "progress";
        var CLASS_PROGRESS_BAR = CLASS_PROGRESS + "__bar";
        var CLASS_TOGGLE = CLASS_PREFIX + "toggle";
        var CLASS_TOGGLE_PLAY = CLASS_TOGGLE + "__play";
        var CLASS_TOGGLE_PAUSE = CLASS_TOGGLE + "__pause";
        var CLASS_SPINNER = CLASS_PREFIX + "spinner";
        var CLASS_SR = CLASS_PREFIX + "sr";
        var CLASS_INITIALIZED = STATUS_CLASS_PREFIX + "initialized";
        var CLASS_ACTIVE = STATUS_CLASS_PREFIX + "active";
        var CLASS_PREV = STATUS_CLASS_PREFIX + "prev";
        var CLASS_NEXT = STATUS_CLASS_PREFIX + "next";
        var CLASS_VISIBLE = STATUS_CLASS_PREFIX + "visible";
        var CLASS_LOADING = STATUS_CLASS_PREFIX + "loading";
        var CLASS_FOCUS_IN = STATUS_CLASS_PREFIX + "focus-in";
        var CLASS_OVERFLOW = STATUS_CLASS_PREFIX + "overflow";
        var STATUS_CLASSES = [
          CLASS_ACTIVE,
          CLASS_VISIBLE,
          CLASS_PREV,
          CLASS_NEXT,
          CLASS_LOADING,
          CLASS_FOCUS_IN,
          CLASS_OVERFLOW,
        ];
        var CLASSES = {
          slide: CLASS_SLIDE,
          clone: CLASS_CLONE,
          arrows: CLASS_ARROWS,
          arrow: CLASS_ARROW,
          prev: CLASS_ARROW_PREV,
          next: CLASS_ARROW_NEXT,
          pagination: CLASS_PAGINATION,
          page: CLASS_PAGINATION_PAGE,
          spinner: CLASS_SPINNER,
        };

        function closest(from, selector) {
          if (isFunction(from.closest)) {
            return from.closest(selector);
          }

          var elm = from;

          while (elm && elm.nodeType === 1) {
            if (matches(elm, selector)) {
              break;
            }

            elm = elm.parentElement;
          }

          return elm;
        }

        var FRICTION = 5;
        var LOG_INTERVAL = 200;
        var POINTER_DOWN_EVENTS = "touchstart mousedown";
        var POINTER_MOVE_EVENTS = "touchmove mousemove";
        var POINTER_UP_EVENTS = "touchend touchcancel mouseup click";

        function Elements(Splide2, Components2, options) {
          var _EventInterface = EventInterface(Splide2),
            on = _EventInterface.on,
            bind = _EventInterface.bind;

          var root = Splide2.root;
          var i18n = options.i18n;
          var elements = {};
          var slides = [];
          var rootClasses = [];
          var trackClasses = [];
          var track;
          var list;
          var isUsingKey;

          function setup() {
            collect();
            init();
            update();
          }

          function mount() {
            on(EVENT_REFRESH, destroy);
            on(EVENT_REFRESH, setup);
            on(EVENT_UPDATED, update);
            bind(
              document,
              POINTER_DOWN_EVENTS + " keydown",
              function (e) {
                isUsingKey = e.type === "keydown";
              },
              {
                capture: true,
              }
            );
            bind(root, "focusin", function () {
              toggleClass(root, CLASS_FOCUS_IN, !!isUsingKey);
            });
          }

          function destroy(completely) {
            var attrs = ALL_ATTRIBUTES.concat("style");
            empty(slides);
            removeClass(root, rootClasses);
            removeClass(track, trackClasses);
            removeAttribute([track, list], attrs);
            removeAttribute(
              root,
              completely ? attrs : ["style", ARIA_ROLEDESCRIPTION]
            );
          }

          function update() {
            removeClass(root, rootClasses);
            removeClass(track, trackClasses);
            rootClasses = getClasses(CLASS_ROOT);
            trackClasses = getClasses(CLASS_TRACK);
            addClass(root, rootClasses);
            addClass(track, trackClasses);
            setAttribute(root, ARIA_LABEL, options.label);
            setAttribute(root, ARIA_LABELLEDBY, options.labelledby);
          }

          function collect() {
            track = find("." + CLASS_TRACK);
            list = child(track, "." + CLASS_LIST);
            assert(track && list, "A track/list element is missing.");
            push(
              slides,
              children(list, "." + CLASS_SLIDE + ":not(." + CLASS_CLONE + ")")
            );
            forOwn(
              {
                arrows: CLASS_ARROWS,
                pagination: CLASS_PAGINATION,
                prev: CLASS_ARROW_PREV,
                next: CLASS_ARROW_NEXT,
                bar: CLASS_PROGRESS_BAR,
                toggle: CLASS_TOGGLE,
              },
              function (className, key) {
                elements[key] = find("." + className);
              }
            );
            assign(elements, {
              root: root,
              track: track,
              list: list,
              slides: slides,
            });
          }

          function init() {
            var id = root.id || uniqueId(PROJECT_CODE);
            var role = options.role;
            root.id = id;
            track.id = track.id || id + "-track";
            list.id = list.id || id + "-list";

            if (
              !getAttribute(root, ROLE) &&
              root.tagName !== "SECTION" &&
              role
            ) {
              setAttribute(root, ROLE, role);
            }

            setAttribute(root, ARIA_ROLEDESCRIPTION, i18n.carousel);
            setAttribute(list, ROLE, "presentation");
          }

          function find(selector) {
            var elm = query(root, selector);
            return elm && closest(elm, "." + CLASS_ROOT) === root
              ? elm
              : void 0;
          }

          function getClasses(base) {
            return [
              base + "--" + options.type,
              base + "--" + options.direction,
              options.drag && base + "--draggable",
              options.isNavigation && base + "--nav",
              base === CLASS_ROOT && CLASS_ACTIVE,
            ];
          }

          return assign(elements, {
            setup: setup,
            mount: mount,
            destroy: destroy,
          });
        }

        var SLIDE = "slide";
        var LOOP = "loop";
        var FADE = "fade";

        function Slide$1(Splide2, index, slideIndex, slide) {
          var event = EventInterface(Splide2);
          var on = event.on,
            emit = event.emit,
            bind = event.bind;
          var Components = Splide2.Components,
            root = Splide2.root,
            options = Splide2.options;
          var isNavigation = options.isNavigation,
            updateOnMove = options.updateOnMove,
            i18n = options.i18n,
            pagination = options.pagination,
            slideFocus = options.slideFocus;
          var resolve = Components.Direction.resolve;
          var styles = getAttribute(slide, "style");
          var label = getAttribute(slide, ARIA_LABEL);
          var isClone = slideIndex > -1;
          var container = child(slide, "." + CLASS_CONTAINER);
          var destroyed;

          function mount() {
            if (!isClone) {
              slide.id = root.id + "-slide" + pad(index + 1);
              setAttribute(slide, ROLE, pagination ? "tabpanel" : "group");
              setAttribute(slide, ARIA_ROLEDESCRIPTION, i18n.slide);
              setAttribute(
                slide,
                ARIA_LABEL,
                label || format(i18n.slideLabel, [index + 1, Splide2.length])
              );
            }

            listen();
          }

          function listen() {
            bind(slide, "click", apply(emit, EVENT_CLICK, self));
            bind(slide, "keydown", apply(emit, EVENT_SLIDE_KEYDOWN, self));
            on([EVENT_MOVED, EVENT_SHIFTED, EVENT_SCROLLED], update);
            on(EVENT_NAVIGATION_MOUNTED, initNavigation);

            if (updateOnMove) {
              on(EVENT_MOVE, onMove);
            }
          }

          function destroy() {
            destroyed = true;
            event.destroy();
            removeClass(slide, STATUS_CLASSES);
            removeAttribute(slide, ALL_ATTRIBUTES);
            setAttribute(slide, "style", styles);
            setAttribute(slide, ARIA_LABEL, label || "");
          }

          function initNavigation() {
            var controls = Splide2.splides
              .map(function (target) {
                var Slide2 = target.splide.Components.Slides.getAt(index);
                return Slide2 ? Slide2.slide.id : "";
              })
              .join(" ");
            setAttribute(
              slide,
              ARIA_LABEL,
              format(i18n.slideX, (isClone ? slideIndex : index) + 1)
            );
            setAttribute(slide, ARIA_CONTROLS, controls);
            setAttribute(slide, ROLE, slideFocus ? "button" : "");
            slideFocus && removeAttribute(slide, ARIA_ROLEDESCRIPTION);
          }

          function onMove() {
            if (!destroyed) {
              update();
            }
          }

          function update() {
            if (!destroyed) {
              var curr = Splide2.index;
              updateActivity();
              updateVisibility();
              toggleClass(slide, CLASS_PREV, index === curr - 1);
              toggleClass(slide, CLASS_NEXT, index === curr + 1);
            }
          }

          function updateActivity() {
            var active = isActive();

            if (active !== hasClass(slide, CLASS_ACTIVE)) {
              toggleClass(slide, CLASS_ACTIVE, active);
              setAttribute(slide, ARIA_CURRENT, (isNavigation && active) || "");
              emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, self);
            }
          }

          function updateVisibility() {
            var visible = isVisible();
            var hidden = !visible && (!isActive() || isClone);

            if (!Splide2.state.is([MOVING, SCROLLING])) {
              setAttribute(slide, ARIA_HIDDEN, hidden || "");
            }

            setAttribute(
              queryAll(slide, options.focusableNodes || ""),
              TAB_INDEX,
              hidden ? -1 : ""
            );

            if (slideFocus) {
              setAttribute(slide, TAB_INDEX, hidden ? -1 : 0);
            }

            if (visible !== hasClass(slide, CLASS_VISIBLE)) {
              toggleClass(slide, CLASS_VISIBLE, visible);
              emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, self);
            }

            if (!visible && document.activeElement === slide) {
              var Slide2 = Components.Slides.getAt(Splide2.index);
              Slide2 && focus(Slide2.slide);
            }
          }

          function style$1(prop, value, useContainer) {
            style((useContainer && container) || slide, prop, value);
          }

          function isActive() {
            var curr = Splide2.index;
            return (
              curr === index || (options.cloneStatus && curr === slideIndex)
            );
          }

          function isVisible() {
            if (Splide2.is(FADE)) {
              return isActive();
            }

            var trackRect = rect(Components.Elements.track);
            var slideRect = rect(slide);
            var left = resolve("left", true);
            var right = resolve("right", true);
            return (
              floor(trackRect[left]) <= ceil(slideRect[left]) &&
              floor(slideRect[right]) <= ceil(trackRect[right])
            );
          }

          function isWithin(from, distance) {
            var diff = abs(from - index);

            if (!isClone && (options.rewind || Splide2.is(LOOP))) {
              diff = min(diff, Splide2.length - diff);
            }

            return diff <= distance;
          }

          var self = {
            index: index,
            slideIndex: slideIndex,
            slide: slide,
            container: container,
            isClone: isClone,
            mount: mount,
            destroy: destroy,
            update: update,
            style: style$1,
            isWithin: isWithin,
          };
          return self;
        }

        function Slides(Splide2, Components2, options) {
          var _EventInterface2 = EventInterface(Splide2),
            on = _EventInterface2.on,
            emit = _EventInterface2.emit,
            bind = _EventInterface2.bind;

          var _Components2$Elements = Components2.Elements,
            slides = _Components2$Elements.slides,
            list = _Components2$Elements.list;
          var Slides2 = [];

          function mount() {
            init();
            on(EVENT_REFRESH, destroy);
            on(EVENT_REFRESH, init);
          }

          function init() {
            slides.forEach(function (slide, index) {
              register(slide, index, -1);
            });
          }

          function destroy() {
            forEach$1(function (Slide2) {
              Slide2.destroy();
            });
            empty(Slides2);
          }

          function update() {
            forEach$1(function (Slide2) {
              Slide2.update();
            });
          }

          function register(slide, index, slideIndex) {
            var object = Slide$1(Splide2, index, slideIndex, slide);
            object.mount();
            Slides2.push(object);
            Slides2.sort(function (Slide1, Slide2) {
              return Slide1.index - Slide2.index;
            });
          }

          function get(excludeClones) {
            return excludeClones
              ? filter(function (Slide2) {
                  return !Slide2.isClone;
                })
              : Slides2;
          }

          function getIn(page) {
            var Controller = Components2.Controller;
            var index = Controller.toIndex(page);
            var max = Controller.hasFocus() ? 1 : options.perPage;
            return filter(function (Slide2) {
              return between(Slide2.index, index, index + max - 1);
            });
          }

          function getAt(index) {
            return filter(index)[0];
          }

          function add(items, index) {
            forEach(items, function (slide) {
              if (isString(slide)) {
                slide = parseHtml(slide);
              }

              if (isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? before(slide, ref) : append(list, slide);
                addClass(slide, options.classes.slide);
                observeImages(slide, apply(emit, EVENT_RESIZE));
              }
            });
            emit(EVENT_REFRESH);
          }

          function remove$1(matcher) {
            remove(
              filter(matcher).map(function (Slide2) {
                return Slide2.slide;
              })
            );
            emit(EVENT_REFRESH);
          }

          function forEach$1(iteratee, excludeClones) {
            get(excludeClones).forEach(iteratee);
          }

          function filter(matcher) {
            return Slides2.filter(
              isFunction(matcher)
                ? matcher
                : function (Slide2) {
                    return isString(matcher)
                      ? matches(Slide2.slide, matcher)
                      : includes(toArray(matcher), Slide2.index);
                  }
            );
          }

          function style(prop, value, useContainer) {
            forEach$1(function (Slide2) {
              Slide2.style(prop, value, useContainer);
            });
          }

          function observeImages(elm, callback) {
            var images = queryAll(elm, "img");
            var length = images.length;

            if (length) {
              images.forEach(function (img) {
                bind(img, "load error", function () {
                  if (!--length) {
                    callback();
                  }
                });
              });
            } else {
              callback();
            }
          }

          function getLength(excludeClones) {
            return excludeClones ? slides.length : Slides2.length;
          }

          function isEnough() {
            return Slides2.length > options.perPage;
          }

          return {
            mount: mount,
            destroy: destroy,
            update: update,
            register: register,
            get: get,
            getIn: getIn,
            getAt: getAt,
            add: add,
            remove: remove$1,
            forEach: forEach$1,
            filter: filter,
            style: style,
            getLength: getLength,
            isEnough: isEnough,
          };
        }

        function Layout(Splide2, Components2, options) {
          var _EventInterface3 = EventInterface(Splide2),
            on = _EventInterface3.on,
            bind = _EventInterface3.bind,
            emit = _EventInterface3.emit;

          var Slides = Components2.Slides;
          var resolve = Components2.Direction.resolve;
          var _Components2$Elements2 = Components2.Elements,
            root = _Components2$Elements2.root,
            track = _Components2$Elements2.track,
            list = _Components2$Elements2.list;
          var getAt = Slides.getAt,
            styleSlides = Slides.style;
          var vertical;
          var rootRect;
          var overflow;

          function mount() {
            init();
            bind(window, "resize load", Throttle(apply(emit, EVENT_RESIZE)));
            on([EVENT_UPDATED, EVENT_REFRESH], init);
            on(EVENT_RESIZE, resize);
          }

          function init() {
            vertical = options.direction === TTB;
            style(root, "maxWidth", unit(options.width));
            style(track, resolve("paddingLeft"), cssPadding(false));
            style(track, resolve("paddingRight"), cssPadding(true));
            resize(true);
          }

          function resize(force) {
            var newRect = rect(root);

            if (
              force ||
              rootRect.width !== newRect.width ||
              rootRect.height !== newRect.height
            ) {
              style(track, "height", cssTrackHeight());
              styleSlides(resolve("marginRight"), unit(options.gap));
              styleSlides("width", cssSlideWidth());
              styleSlides("height", cssSlideHeight(), true);
              rootRect = newRect;
              emit(EVENT_RESIZED);

              if (overflow !== (overflow = isOverflow())) {
                toggleClass(root, CLASS_OVERFLOW, overflow);
                emit(EVENT_OVERFLOW, overflow);
              }
            }
          }

          function cssPadding(right) {
            var padding = options.padding;
            var prop = resolve(right ? "right" : "left");
            return (
              (padding &&
                unit(padding[prop] || (isObject(padding) ? 0 : padding))) ||
              "0px"
            );
          }

          function cssTrackHeight() {
            var height = "";

            if (vertical) {
              height = cssHeight();
              assert(height, "height or heightRatio is missing.");
              height =
                "calc(" +
                height +
                " - " +
                cssPadding(false) +
                " - " +
                cssPadding(true) +
                ")";
            }

            return height;
          }

          function cssHeight() {
            return unit(
              options.height || rect(list).width * options.heightRatio
            );
          }

          function cssSlideWidth() {
            return options.autoWidth
              ? null
              : unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
          }

          function cssSlideHeight() {
            return (
              unit(options.fixedHeight) ||
              (vertical
                ? options.autoHeight
                  ? null
                  : cssSlideSize()
                : cssHeight())
            );
          }

          function cssSlideSize() {
            var gap = unit(options.gap);
            return (
              "calc((100%" +
              (gap && " + " + gap) +
              ")/" +
              (options.perPage || 1) +
              (gap && " - " + gap) +
              ")"
            );
          }

          function listSize() {
            return rect(list)[resolve("width")];
          }

          function slideSize(index, withoutGap) {
            var Slide = getAt(index || 0);
            return Slide
              ? rect(Slide.slide)[resolve("width")] +
                  (withoutGap ? 0 : getGap())
              : 0;
          }

          function totalSize(index, withoutGap) {
            var Slide = getAt(index);

            if (Slide) {
              var right = rect(Slide.slide)[resolve("right")];
              var left = rect(list)[resolve("left")];
              return abs(right - left) + (withoutGap ? 0 : getGap());
            }

            return 0;
          }

          function sliderSize(withoutGap) {
            return (
              totalSize(Splide2.length - 1) -
              totalSize(0) +
              slideSize(0, withoutGap)
            );
          }

          function getGap() {
            var Slide = getAt(0);
            return (
              (Slide &&
                parseFloat(style(Slide.slide, resolve("marginRight")))) ||
              0
            );
          }

          function getPadding(right) {
            return (
              parseFloat(
                style(track, resolve("padding" + (right ? "Right" : "Left")))
              ) || 0
            );
          }

          function isOverflow() {
            return Splide2.is(FADE) || sliderSize(true) > listSize();
          }

          return {
            mount: mount,
            resize: resize,
            listSize: listSize,
            slideSize: slideSize,
            sliderSize: sliderSize,
            totalSize: totalSize,
            getPadding: getPadding,
            isOverflow: isOverflow,
          };
        }

        var MULTIPLIER = 2;

        function Clones(Splide2, Components2, options) {
          var event = EventInterface(Splide2);
          var on = event.on;
          var Elements = Components2.Elements,
            Slides = Components2.Slides;
          var resolve = Components2.Direction.resolve;
          var clones = [];
          var cloneCount;

          function mount() {
            on(EVENT_REFRESH, remount);
            on([EVENT_UPDATED, EVENT_RESIZE], observe);

            if ((cloneCount = computeCloneCount())) {
              generate(cloneCount);
              Components2.Layout.resize(true);
            }
          }

          function remount() {
            destroy();
            mount();
          }

          function destroy() {
            remove(clones);
            empty(clones);
            event.destroy();
          }

          function observe() {
            var count = computeCloneCount();

            if (cloneCount !== count) {
              if (cloneCount < count || !count) {
                event.emit(EVENT_REFRESH);
              }
            }
          }

          function generate(count) {
            var slides = Slides.get().slice();
            var length = slides.length;

            if (length) {
              while (slides.length < count) {
                push(slides, slides);
              }

              push(slides.slice(-count), slides.slice(0, count)).forEach(
                function (Slide, index) {
                  var isHead = index < count;
                  var clone = cloneDeep(Slide.slide, index);
                  isHead
                    ? before(clone, slides[0].slide)
                    : append(Elements.list, clone);
                  push(clones, clone);
                  Slides.register(
                    clone,
                    index - count + (isHead ? 0 : length),
                    Slide.index
                  );
                }
              );
            }
          }

          function cloneDeep(elm, index) {
            var clone = elm.cloneNode(true);
            addClass(clone, options.classes.clone);
            clone.id = Splide2.root.id + "-clone" + pad(index + 1);
            return clone;
          }

          function computeCloneCount() {
            var clones2 = options.clones;

            if (!Splide2.is(LOOP)) {
              clones2 = 0;
            } else if (isUndefined(clones2)) {
              var fixedSize =
                options[resolve("fixedWidth")] &&
                Components2.Layout.slideSize(0);
              var fixedCount =
                fixedSize &&
                ceil(rect(Elements.track)[resolve("width")] / fixedSize);
              clones2 =
                fixedCount ||
                (options[resolve("autoWidth")] && Splide2.length) ||
                options.perPage * MULTIPLIER;
            }

            return clones2;
          }

          return {
            mount: mount,
            destroy: destroy,
          };
        }

        function Move(Splide2, Components2, options) {
          var _EventInterface4 = EventInterface(Splide2),
            on = _EventInterface4.on,
            emit = _EventInterface4.emit;

          var set = Splide2.state.set;
          var _Components2$Layout = Components2.Layout,
            slideSize = _Components2$Layout.slideSize,
            getPadding = _Components2$Layout.getPadding,
            totalSize = _Components2$Layout.totalSize,
            listSize = _Components2$Layout.listSize,
            sliderSize = _Components2$Layout.sliderSize;
          var _Components2$Directio = Components2.Direction,
            resolve = _Components2$Directio.resolve,
            orient = _Components2$Directio.orient;
          var _Components2$Elements3 = Components2.Elements,
            list = _Components2$Elements3.list,
            track = _Components2$Elements3.track;
          var Transition;

          function mount() {
            Transition = Components2.Transition;
            on(
              [EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED, EVENT_REFRESH],
              reposition
            );
          }

          function reposition() {
            if (!Components2.Controller.isBusy()) {
              Components2.Scroll.cancel();
              jump(Splide2.index);
              Components2.Slides.update();
            }
          }

          function move(dest, index, prev, callback) {
            if (dest !== index && canShift(dest > prev)) {
              cancel();
              translate(shift(getPosition(), dest > prev), true);
            }

            set(MOVING);
            emit(EVENT_MOVE, index, prev, dest);
            Transition.start(index, function () {
              set(IDLE);
              emit(EVENT_MOVED, index, prev, dest);
              callback && callback();
            });
          }

          function jump(index) {
            translate(toPosition(index, true));
          }

          function translate(position, preventLoop) {
            if (!Splide2.is(FADE)) {
              var destination = preventLoop ? position : loop(position);
              style(
                list,
                "transform",
                "translate" + resolve("X") + "(" + destination + "px)"
              );
              position !== destination && emit(EVENT_SHIFTED);
            }
          }

          function loop(position) {
            if (Splide2.is(LOOP)) {
              var index = toIndex(position);
              var exceededMax = index > Components2.Controller.getEnd();
              var exceededMin = index < 0;

              if (exceededMin || exceededMax) {
                position = shift(position, exceededMax);
              }
            }

            return position;
          }

          function shift(position, backwards) {
            var excess = position - getLimit(backwards);
            var size = sliderSize();
            position -=
              orient(size * (ceil(abs(excess) / size) || 1)) *
              (backwards ? 1 : -1);
            return position;
          }

          function cancel() {
            translate(getPosition(), true);
            Transition.cancel();
          }

          function toIndex(position) {
            var Slides = Components2.Slides.get();
            var index = 0;
            var minDistance = Infinity;

            for (var i = 0; i < Slides.length; i++) {
              var slideIndex = Slides[i].index;
              var distance = abs(toPosition(slideIndex, true) - position);

              if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
              } else {
                break;
              }
            }

            return index;
          }

          function toPosition(index, trimming) {
            var position = orient(totalSize(index - 1) - offset(index));
            return trimming ? trim(position) : position;
          }

          function getPosition() {
            var left = resolve("left");
            return (
              rect(list)[left] - rect(track)[left] + orient(getPadding(false))
            );
          }

          function trim(position) {
            if (options.trimSpace && Splide2.is(SLIDE)) {
              position = clamp(
                position,
                0,
                orient(sliderSize(true) - listSize())
              );
            }

            return position;
          }

          function offset(index) {
            var focus = options.focus;
            return focus === "center"
              ? (listSize() - slideSize(index, true)) / 2
              : +focus * slideSize(index) || 0;
          }

          function getLimit(max) {
            return toPosition(
              max ? Components2.Controller.getEnd() : 0,
              !!options.trimSpace
            );
          }

          function canShift(backwards) {
            var shifted = orient(shift(getPosition(), backwards));
            return backwards
              ? shifted >= 0
              : shifted <=
                  list[resolve("scrollWidth")] - rect(track)[resolve("width")];
          }

          function exceededLimit(max, position) {
            position = isUndefined(position) ? getPosition() : position;
            var exceededMin =
              max !== true && orient(position) < orient(getLimit(false));
            var exceededMax =
              max !== false && orient(position) > orient(getLimit(true));
            return exceededMin || exceededMax;
          }

          return {
            mount: mount,
            move: move,
            jump: jump,
            translate: translate,
            shift: shift,
            cancel: cancel,
            toIndex: toIndex,
            toPosition: toPosition,
            getPosition: getPosition,
            getLimit: getLimit,
            exceededLimit: exceededLimit,
            reposition: reposition,
          };
        }

        function Controller(Splide2, Components2, options) {
          var _EventInterface5 = EventInterface(Splide2),
            on = _EventInterface5.on,
            emit = _EventInterface5.emit;

          var Move = Components2.Move;
          var getPosition = Move.getPosition,
            getLimit = Move.getLimit,
            toPosition = Move.toPosition;
          var _Components2$Slides = Components2.Slides,
            isEnough = _Components2$Slides.isEnough,
            getLength = _Components2$Slides.getLength;
          var omitEnd = options.omitEnd;
          var isLoop = Splide2.is(LOOP);
          var isSlide = Splide2.is(SLIDE);
          var getNext = apply(getAdjacent, false);
          var getPrev = apply(getAdjacent, true);
          var currIndex = options.start || 0;
          var endIndex;
          var prevIndex = currIndex;
          var slideCount;
          var perMove;
          var perPage;

          function mount() {
            init();
            on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], init);
            on(EVENT_RESIZED, onResized);
          }

          function init() {
            slideCount = getLength(true);
            perMove = options.perMove;
            perPage = options.perPage;
            endIndex = getEnd();
            var index = clamp(
              currIndex,
              0,
              omitEnd ? endIndex : slideCount - 1
            );

            if (index !== currIndex) {
              currIndex = index;
              Move.reposition();
            }
          }

          function onResized() {
            if (endIndex !== getEnd()) {
              emit(EVENT_END_INDEX_CHANGED);
            }
          }

          function go(control, allowSameIndex, callback) {
            if (!isBusy()) {
              var dest = parse(control);
              var index = loop(dest);

              if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
              }
            }
          }

          function scroll(destination, duration, snap, callback) {
            Components2.Scroll.scroll(destination, duration, snap, function () {
              var index = loop(Move.toIndex(getPosition()));
              setIndex(omitEnd ? min(index, endIndex) : index);
              callback && callback();
            });
          }

          function parse(control) {
            var index = currIndex;

            if (isString(control)) {
              var _ref = control.match(/([+\-<>])(\d+)?/) || [],
                indicator = _ref[1],
                number = _ref[2];

              if (indicator === "+" || indicator === "-") {
                index = computeDestIndex(
                  currIndex + +("" + indicator + (+number || 1)),
                  currIndex
                );
              } else if (indicator === ">") {
                index = number ? toIndex(+number) : getNext(true);
              } else if (indicator === "<") {
                index = getPrev(true);
              }
            } else {
              index = isLoop ? control : clamp(control, 0, endIndex);
            }

            return index;
          }

          function getAdjacent(prev, destination) {
            var number = perMove || (hasFocus() ? 1 : perPage);
            var dest = computeDestIndex(
              currIndex + number * (prev ? -1 : 1),
              currIndex,
              !(perMove || hasFocus())
            );

            if (dest === -1 && isSlide) {
              if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) {
                return prev ? 0 : endIndex;
              }
            }

            return destination ? dest : loop(dest);
          }

          function computeDestIndex(dest, from, snapPage) {
            if (isEnough() || hasFocus()) {
              var index = computeMovableDestIndex(dest);

              if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
              }

              if (dest < 0 || dest > endIndex) {
                if (
                  !perMove &&
                  (between(0, dest, from, true) ||
                    between(endIndex, from, dest, true))
                ) {
                  dest = toIndex(toPage(dest));
                } else {
                  if (isLoop) {
                    dest = snapPage
                      ? dest < 0
                        ? -(slideCount % perPage || perPage)
                        : slideCount
                      : dest;
                  } else if (options.rewind) {
                    dest = dest < 0 ? endIndex : 0;
                  } else {
                    dest = -1;
                  }
                }
              } else {
                if (snapPage && dest !== from) {
                  dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
                }
              }
            } else {
              dest = -1;
            }

            return dest;
          }

          function computeMovableDestIndex(dest) {
            if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
              var position = getPosition();

              while (
                position === toPosition(dest, true) &&
                between(dest, 0, Splide2.length - 1, !options.rewind)
              ) {
                dest < currIndex ? --dest : ++dest;
              }
            }

            return dest;
          }

          function loop(index) {
            return isLoop ? (index + slideCount) % slideCount || 0 : index;
          }

          function getEnd() {
            var end =
              slideCount - (hasFocus() || (isLoop && perMove) ? 1 : perPage);

            while (omitEnd && end-- > 0) {
              if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
                end++;
                break;
              }
            }

            return clamp(end, 0, slideCount - 1);
          }

          function toIndex(page) {
            return clamp(hasFocus() ? page : perPage * page, 0, endIndex);
          }

          function toPage(index) {
            return hasFocus()
              ? min(index, endIndex)
              : floor((index >= endIndex ? slideCount - 1 : index) / perPage);
          }

          function toDest(destination) {
            var closest = Move.toIndex(destination);
            return isSlide ? clamp(closest, 0, endIndex) : closest;
          }

          function setIndex(index) {
            if (index !== currIndex) {
              prevIndex = currIndex;
              currIndex = index;
            }
          }

          function getIndex(prev) {
            return prev ? prevIndex : currIndex;
          }

          function hasFocus() {
            return !isUndefined(options.focus) || options.isNavigation;
          }

          function isBusy() {
            return (
              Splide2.state.is([MOVING, SCROLLING]) &&
              !!options.waitForTransition
            );
          }

          return {
            mount: mount,
            go: go,
            scroll: scroll,
            getNext: getNext,
            getPrev: getPrev,
            getAdjacent: getAdjacent,
            getEnd: getEnd,
            setIndex: setIndex,
            getIndex: getIndex,
            toIndex: toIndex,
            toPage: toPage,
            toDest: toDest,
            hasFocus: hasFocus,
            isBusy: isBusy,
          };
        }

        var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
        var PATH =
          "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
        var SIZE = 40;

        function Arrows(Splide2, Components2, options) {
          var event = EventInterface(Splide2);
          var on = event.on,
            bind = event.bind,
            emit = event.emit;
          var classes = options.classes,
            i18n = options.i18n;
          var Elements = Components2.Elements,
            Controller = Components2.Controller;
          var placeholder = Elements.arrows,
            track = Elements.track;
          var wrapper = placeholder;
          var prev = Elements.prev;
          var next = Elements.next;
          var created;
          var wrapperClasses;
          var arrows = {};

          function mount() {
            init();
            on(EVENT_UPDATED, remount);
          }

          function remount() {
            destroy();
            mount();
          }

          function init() {
            var enabled = options.arrows;

            if (enabled && !(prev && next)) {
              createArrows();
            }

            if (prev && next) {
              assign(arrows, {
                prev: prev,
                next: next,
              });
              display(wrapper, enabled ? "" : "none");
              addClass(
                wrapper,
                (wrapperClasses = CLASS_ARROWS + "--" + options.direction)
              );

              if (enabled) {
                listen();
                update();
                setAttribute([prev, next], ARIA_CONTROLS, track.id);
                emit(EVENT_ARROWS_MOUNTED, prev, next);
              }
            }
          }

          function destroy() {
            event.destroy();
            removeClass(wrapper, wrapperClasses);

            if (created) {
              remove(placeholder ? [prev, next] : wrapper);
              prev = next = null;
            } else {
              removeAttribute([prev, next], ALL_ATTRIBUTES);
            }
          }

          function listen() {
            on(
              [
                EVENT_MOUNTED,
                EVENT_MOVED,
                EVENT_REFRESH,
                EVENT_SCROLLED,
                EVENT_END_INDEX_CHANGED,
              ],
              update
            );
            bind(next, "click", apply(go, ">"));
            bind(prev, "click", apply(go, "<"));
          }

          function go(control) {
            Controller.go(control, true);
          }

          function createArrows() {
            wrapper = placeholder || create("div", classes.arrows);
            prev = createArrow(true);
            next = createArrow(false);
            created = true;
            append(wrapper, [prev, next]);
            !placeholder && before(wrapper, track);
          }

          function createArrow(prev2) {
            var arrow =
              '<button class="' +
              classes.arrow +
              " " +
              (prev2 ? classes.prev : classes.next) +
              '" type="button"><svg xmlns="' +
              XML_NAME_SPACE +
              '" viewBox="0 0 ' +
              SIZE +
              " " +
              SIZE +
              '" width="' +
              SIZE +
              '" height="' +
              SIZE +
              '" focusable="false"><path d="' +
              (options.arrowPath || PATH) +
              '" />';
            return parseHtml(arrow);
          }

          function update() {
            if (prev && next) {
              var index = Splide2.index;
              var prevIndex = Controller.getPrev();
              var nextIndex = Controller.getNext();
              var prevLabel =
                prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
              var nextLabel =
                nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
              prev.disabled = prevIndex < 0;
              next.disabled = nextIndex < 0;
              setAttribute(prev, ARIA_LABEL, prevLabel);
              setAttribute(next, ARIA_LABEL, nextLabel);
              emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
            }
          }

          return {
            arrows: arrows,
            mount: mount,
            destroy: destroy,
            update: update,
          };
        }

        var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-interval";

        function Autoplay(Splide2, Components2, options) {
          var _EventInterface6 = EventInterface(Splide2),
            on = _EventInterface6.on,
            bind = _EventInterface6.bind,
            emit = _EventInterface6.emit;

          var interval = RequestInterval(
            options.interval,
            Splide2.go.bind(Splide2, ">"),
            onAnimationFrame
          );
          var isPaused = interval.isPaused;
          var Elements = Components2.Elements,
            _Components2$Elements4 = Components2.Elements,
            root = _Components2$Elements4.root,
            toggle = _Components2$Elements4.toggle;
          var autoplay = options.autoplay;
          var hovered;
          var focused;
          var stopped = autoplay === "pause";

          function mount() {
            if (autoplay) {
              listen();
              toggle && setAttribute(toggle, ARIA_CONTROLS, Elements.track.id);
              stopped || play();
              update();
            }
          }

          function listen() {
            if (options.pauseOnHover) {
              bind(root, "mouseenter mouseleave", function (e) {
                hovered = e.type === "mouseenter";
                autoToggle();
              });
            }

            if (options.pauseOnFocus) {
              bind(root, "focusin focusout", function (e) {
                focused = e.type === "focusin";
                autoToggle();
              });
            }

            if (toggle) {
              bind(toggle, "click", function () {
                stopped ? play() : pause(true);
              });
            }

            on([EVENT_MOVE, EVENT_SCROLL, EVENT_REFRESH], interval.rewind);
            on(EVENT_MOVE, onMove);
          }

          function play() {
            if (isPaused() && Components2.Slides.isEnough()) {
              interval.start(!options.resetProgress);
              focused = hovered = stopped = false;
              update();
              emit(EVENT_AUTOPLAY_PLAY);
            }
          }

          function pause(stop) {
            if (stop === void 0) {
              stop = true;
            }

            stopped = !!stop;
            update();

            if (!isPaused()) {
              interval.pause();
              emit(EVENT_AUTOPLAY_PAUSE);
            }
          }

          function autoToggle() {
            if (!stopped) {
              hovered || focused ? pause(false) : play();
            }
          }

          function update() {
            if (toggle) {
              toggleClass(toggle, CLASS_ACTIVE, !stopped);
              setAttribute(
                toggle,
                ARIA_LABEL,
                options.i18n[stopped ? "play" : "pause"]
              );
            }
          }

          function onAnimationFrame(rate) {
            var bar = Elements.bar;
            bar && style(bar, "width", rate * 100 + "%");
            emit(EVENT_AUTOPLAY_PLAYING, rate);
          }

          function onMove(index) {
            var Slide = Components2.Slides.getAt(index);
            interval.set(
              (Slide && +getAttribute(Slide.slide, INTERVAL_DATA_ATTRIBUTE)) ||
                options.interval
            );
          }

          return {
            mount: mount,
            destroy: interval.cancel,
            play: play,
            pause: pause,
            isPaused: isPaused,
          };
        }

        function Cover(Splide2, Components2, options) {
          var _EventInterface7 = EventInterface(Splide2),
            on = _EventInterface7.on;

          function mount() {
            if (options.cover) {
              on(EVENT_LAZYLOAD_LOADED, apply(toggle, true));
              on(
                [EVENT_MOUNTED, EVENT_UPDATED, EVENT_REFRESH],
                apply(cover, true)
              );
            }
          }

          function cover(cover2) {
            Components2.Slides.forEach(function (Slide) {
              var img = child(Slide.container || Slide.slide, "img");

              if (img && img.src) {
                toggle(cover2, img, Slide);
              }
            });
          }

          function toggle(cover2, img, Slide) {
            Slide.style(
              "background",
              cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "",
              true
            );
            display(img, cover2 ? "none" : "");
          }

          return {
            mount: mount,
            destroy: apply(cover, false),
          };
        }

        var BOUNCE_DIFF_THRESHOLD = 10;
        var BOUNCE_DURATION = 600;
        var FRICTION_FACTOR = 0.6;
        var BASE_VELOCITY = 1.5;
        var MIN_DURATION = 800;

        function Scroll(Splide2, Components2, options) {
          var _EventInterface8 = EventInterface(Splide2),
            on = _EventInterface8.on,
            emit = _EventInterface8.emit;

          var set = Splide2.state.set;
          var Move = Components2.Move;
          var getPosition = Move.getPosition,
            getLimit = Move.getLimit,
            exceededLimit = Move.exceededLimit,
            translate = Move.translate;
          var isSlide = Splide2.is(SLIDE);
          var interval;
          var callback;
          var friction = 1;

          function mount() {
            on(EVENT_MOVE, clear);
            on([EVENT_UPDATED, EVENT_REFRESH], cancel);
          }

          function scroll(
            destination,
            duration,
            snap,
            onScrolled,
            noConstrain
          ) {
            var from = getPosition();
            clear();

            if (snap && (!isSlide || !exceededLimit())) {
              var size = Components2.Layout.sliderSize();
              var offset =
                sign(destination) * size * floor(abs(destination) / size) || 0;
              destination =
                Move.toPosition(
                  Components2.Controller.toDest(destination % size)
                ) + offset;
            }

            var noDistance = approximatelyEqual(from, destination, 1);
            friction = 1;
            duration = noDistance
              ? 0
              : duration ||
                max(abs(destination - from) / BASE_VELOCITY, MIN_DURATION);
            callback = onScrolled;
            interval = RequestInterval(
              duration,
              onEnd,
              apply(update, from, destination, noConstrain),
              1
            );
            set(SCROLLING);
            emit(EVENT_SCROLL);
            interval.start();
          }

          function onEnd() {
            set(IDLE);
            callback && callback();
            emit(EVENT_SCROLLED);
          }

          function update(from, to, noConstrain, rate) {
            var position = getPosition();
            var target = from + (to - from) * easing(rate);
            var diff = (target - position) * friction;
            translate(position + diff);

            if (isSlide && !noConstrain && exceededLimit()) {
              friction *= FRICTION_FACTOR;

              if (abs(diff) < BOUNCE_DIFF_THRESHOLD) {
                scroll(
                  getLimit(exceededLimit(true)),
                  BOUNCE_DURATION,
                  false,
                  callback,
                  true
                );
              }
            }
          }

          function clear() {
            if (interval) {
              interval.cancel();
            }
          }

          function cancel() {
            if (interval && !interval.isPaused()) {
              clear();
              onEnd();
            }
          }

          function easing(t) {
            var easingFunc = options.easingFunc;
            return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
          }

          return {
            mount: mount,
            destroy: clear,
            scroll: scroll,
            cancel: cancel,
          };
        }

        var SCROLL_LISTENER_OPTIONS = {
          passive: false,
          capture: true,
        };

        function Drag(Splide2, Components2, options) {
          var _EventInterface9 = EventInterface(Splide2),
            on = _EventInterface9.on,
            emit = _EventInterface9.emit,
            bind = _EventInterface9.bind,
            unbind = _EventInterface9.unbind;

          var state = Splide2.state;
          var Move = Components2.Move,
            Scroll = Components2.Scroll,
            Controller = Components2.Controller,
            track = Components2.Elements.track,
            reduce = Components2.Media.reduce;
          var _Components2$Directio2 = Components2.Direction,
            resolve = _Components2$Directio2.resolve,
            orient = _Components2$Directio2.orient;
          var getPosition = Move.getPosition,
            exceededLimit = Move.exceededLimit;
          var basePosition;
          var baseEvent;
          var prevBaseEvent;
          var isFree;
          var dragging;
          var exceeded = false;
          var clickPrevented;
          var disabled;
          var target;

          function mount() {
            bind(track, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
            bind(track, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
            bind(
              track,
              POINTER_DOWN_EVENTS,
              onPointerDown,
              SCROLL_LISTENER_OPTIONS
            );
            bind(track, "click", onClick, {
              capture: true,
            });
            bind(track, "dragstart", prevent);
            on([EVENT_MOUNTED, EVENT_UPDATED], init);
          }

          function init() {
            var drag = options.drag;
            disable(!drag);
            isFree = drag === "free";
          }

          function onPointerDown(e) {
            clickPrevented = false;

            if (!disabled) {
              var isTouch = isTouchEvent(e);

              if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                  target = isTouch ? track : window;
                  dragging = state.is([MOVING, SCROLLING]);
                  prevBaseEvent = null;
                  bind(
                    target,
                    POINTER_MOVE_EVENTS,
                    onPointerMove,
                    SCROLL_LISTENER_OPTIONS
                  );
                  bind(
                    target,
                    POINTER_UP_EVENTS,
                    onPointerUp,
                    SCROLL_LISTENER_OPTIONS
                  );
                  Move.cancel();
                  Scroll.cancel();
                  save(e);
                } else {
                  prevent(e, true);
                }
              }
            }
          }

          function onPointerMove(e) {
            if (!state.is(DRAGGING)) {
              state.set(DRAGGING);
              emit(EVENT_DRAG);
            }

            if (e.cancelable) {
              if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());

                if (expired || hasExceeded) {
                  save(e);
                }

                clickPrevented = true;
                emit(EVENT_DRAGGING);
                prevent(e);
              } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                prevent(e);
              }
            }
          }

          function onPointerUp(e) {
            if (state.is(DRAGGING)) {
              state.set(IDLE);
              emit(EVENT_DRAGGED);
            }

            if (dragging) {
              move(e);
              prevent(e);
            }

            unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
            unbind(target, POINTER_UP_EVENTS, onPointerUp);
            dragging = false;
          }

          function onClick(e) {
            if (!disabled && clickPrevented) {
              prevent(e, true);
            }
          }

          function save(e) {
            prevBaseEvent = baseEvent;
            baseEvent = e;
            basePosition = getPosition();
          }

          function move(e) {
            var velocity = computeVelocity(e);
            var destination = computeDestination(velocity);
            var rewind = options.rewind && options.rewindByDrag;
            reduce(false);

            if (isFree) {
              Controller.scroll(destination, 0, options.snap);
            } else if (Splide2.is(FADE)) {
              Controller.go(
                orient(sign(velocity)) < 0
                  ? rewind
                    ? "<"
                    : "-"
                  : rewind
                  ? ">"
                  : "+"
              );
            } else if (Splide2.is(SLIDE) && exceeded && rewind) {
              Controller.go(exceededLimit(true) ? ">" : "<");
            } else {
              Controller.go(Controller.toDest(destination), true);
            }

            reduce(true);
          }

          function shouldStart(e) {
            var thresholds = options.dragMinThreshold;
            var isObj = isObject(thresholds);
            var mouse = (isObj && thresholds.mouse) || 0;
            var touch = (isObj ? thresholds.touch : +thresholds) || 10;
            return abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
          }

          function isSliderDirection(e) {
            return abs(diffCoord(e)) > abs(diffCoord(e, true));
          }

          function computeVelocity(e) {
            if (Splide2.is(LOOP) || !exceeded) {
              var time = diffTime(e);

              if (time && time < LOG_INTERVAL) {
                return diffCoord(e) / time;
              }
            }

            return 0;
          }

          function computeDestination(velocity) {
            return (
              getPosition() +
              sign(velocity) *
                min(
                  abs(velocity) * (options.flickPower || 600),
                  isFree
                    ? Infinity
                    : Components2.Layout.listSize() *
                        (options.flickMaxPages || 1)
                )
            );
          }

          function diffCoord(e, orthogonal) {
            return (
              coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal)
            );
          }

          function diffTime(e) {
            return timeOf(e) - timeOf(getBaseEvent(e));
          }

          function getBaseEvent(e) {
            return (baseEvent === e && prevBaseEvent) || baseEvent;
          }

          function coordOf(e, orthogonal) {
            return (isTouchEvent(e) ? e.changedTouches[0] : e)[
              "page" + resolve(orthogonal ? "Y" : "X")
            ];
          }

          function constrain(diff) {
            return diff / (exceeded && Splide2.is(SLIDE) ? FRICTION : 1);
          }

          function isDraggable(target2) {
            var noDrag = options.noDrag;
            return (
              !matches(
                target2,
                "." + CLASS_PAGINATION_PAGE + ", ." + CLASS_ARROW
              ) &&
              (!noDrag || !matches(target2, noDrag))
            );
          }

          function isTouchEvent(e) {
            return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
          }

          function isDragging() {
            return dragging;
          }

          function disable(value) {
            disabled = value;
          }

          return {
            mount: mount,
            disable: disable,
            isDragging: isDragging,
          };
        }

        var NORMALIZATION_MAP = {
          Spacebar: " ",
          Right: ARROW_RIGHT,
          Left: ARROW_LEFT,
          Up: ARROW_UP,
          Down: ARROW_DOWN,
        };

        function normalizeKey(key) {
          key = isString(key) ? key : key.key;
          return NORMALIZATION_MAP[key] || key;
        }

        var KEYBOARD_EVENT = "keydown";

        function Keyboard(Splide2, Components2, options) {
          var _EventInterface10 = EventInterface(Splide2),
            on = _EventInterface10.on,
            bind = _EventInterface10.bind,
            unbind = _EventInterface10.unbind;

          var root = Splide2.root;
          var resolve = Components2.Direction.resolve;
          var target;
          var disabled;

          function mount() {
            init();
            on(EVENT_UPDATED, destroy);
            on(EVENT_UPDATED, init);
            on(EVENT_MOVE, onMove);
          }

          function init() {
            var keyboard = options.keyboard;

            if (keyboard) {
              target = keyboard === "global" ? window : root;
              bind(target, KEYBOARD_EVENT, onKeydown);
            }
          }

          function destroy() {
            unbind(target, KEYBOARD_EVENT);
          }

          function disable(value) {
            disabled = value;
          }

          function onMove() {
            var _disabled = disabled;
            disabled = true;
            nextTick(function () {
              disabled = _disabled;
            });
          }

          function onKeydown(e) {
            if (!disabled) {
              var key = normalizeKey(e);

              if (key === resolve(ARROW_LEFT)) {
                Splide2.go("<");
              } else if (key === resolve(ARROW_RIGHT)) {
                Splide2.go(">");
              }
            }
          }

          return {
            mount: mount,
            destroy: destroy,
            disable: disable,
          };
        }

        var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-lazy";
        var SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + "-srcset";
        var IMAGE_SELECTOR =
          "[" + SRC_DATA_ATTRIBUTE + "], [" + SRCSET_DATA_ATTRIBUTE + "]";

        function LazyLoad(Splide2, Components2, options) {
          var _EventInterface11 = EventInterface(Splide2),
            on = _EventInterface11.on,
            off = _EventInterface11.off,
            bind = _EventInterface11.bind,
            emit = _EventInterface11.emit;

          var isSequential = options.lazyLoad === "sequential";
          var events = [EVENT_MOVED, EVENT_SCROLLED];
          var entries = [];

          function mount() {
            if (options.lazyLoad) {
              init();
              on(EVENT_REFRESH, init);
            }
          }

          function init() {
            empty(entries);
            register();

            if (isSequential) {
              loadNext();
            } else {
              off(events);
              on(events, check);
              check();
            }
          }

          function register() {
            Components2.Slides.forEach(function (Slide) {
              queryAll(Slide.slide, IMAGE_SELECTOR).forEach(function (img) {
                var src = getAttribute(img, SRC_DATA_ATTRIBUTE);
                var srcset = getAttribute(img, SRCSET_DATA_ATTRIBUTE);

                if (src !== img.src || srcset !== img.srcset) {
                  var className = options.classes.spinner;
                  var parent = img.parentElement;
                  var spinner =
                    child(parent, "." + className) ||
                    create("span", className, parent);
                  entries.push([img, Slide, spinner]);
                  img.src || display(img, "none");
                }
              });
            });
          }

          function check() {
            entries = entries.filter(function (data) {
              var distance =
                options.perPage * ((options.preloadPages || 1) + 1) - 1;
              return data[1].isWithin(Splide2.index, distance)
                ? load(data)
                : true;
            });
            entries.length || off(events);
          }

          function load(data) {
            var img = data[0];
            addClass(data[1].slide, CLASS_LOADING);
            bind(img, "load error", apply(onLoad, data));
            setAttribute(img, "src", getAttribute(img, SRC_DATA_ATTRIBUTE));
            setAttribute(
              img,
              "srcset",
              getAttribute(img, SRCSET_DATA_ATTRIBUTE)
            );
            removeAttribute(img, SRC_DATA_ATTRIBUTE);
            removeAttribute(img, SRCSET_DATA_ATTRIBUTE);
          }

          function onLoad(data, e) {
            var img = data[0],
              Slide = data[1];
            removeClass(Slide.slide, CLASS_LOADING);

            if (e.type !== "error") {
              remove(data[2]);
              display(img, "");
              emit(EVENT_LAZYLOAD_LOADED, img, Slide);
              emit(EVENT_RESIZE);
            }

            isSequential && loadNext();
          }

          function loadNext() {
            entries.length && load(entries.shift());
          }

          return {
            mount: mount,
            destroy: apply(empty, entries),
            check: check,
          };
        }

        function Pagination(Splide2, Components2, options) {
          var event = EventInterface(Splide2);
          var on = event.on,
            emit = event.emit,
            bind = event.bind;
          var Slides = Components2.Slides,
            Elements = Components2.Elements,
            Controller = Components2.Controller;
          var hasFocus = Controller.hasFocus,
            getIndex = Controller.getIndex,
            go = Controller.go;
          var resolve = Components2.Direction.resolve;
          var placeholder = Elements.pagination;
          var items = [];
          var list;
          var paginationClasses;

          function mount() {
            destroy();
            on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], mount);
            var enabled = options.pagination;
            placeholder && display(placeholder, enabled ? "" : "none");

            if (enabled) {
              on([EVENT_MOVE, EVENT_SCROLL, EVENT_SCROLLED], update);
              createPagination();
              update();
              emit(
                EVENT_PAGINATION_MOUNTED,
                {
                  list: list,
                  items: items,
                },
                getAt(Splide2.index)
              );
            }
          }

          function destroy() {
            if (list) {
              remove(placeholder ? slice(list.children) : list);
              removeClass(list, paginationClasses);
              empty(items);
              list = null;
            }

            event.destroy();
          }

          function createPagination() {
            var length = Splide2.length;
            var classes = options.classes,
              i18n = options.i18n,
              perPage = options.perPage;
            var max = hasFocus()
              ? Controller.getEnd() + 1
              : ceil(length / perPage);
            list =
              placeholder ||
              create("ul", classes.pagination, Elements.track.parentElement);
            addClass(
              list,
              (paginationClasses = CLASS_PAGINATION + "--" + getDirection())
            );
            setAttribute(list, ROLE, "tablist");
            setAttribute(list, ARIA_LABEL, i18n.select);
            setAttribute(
              list,
              ARIA_ORIENTATION,
              getDirection() === TTB ? "vertical" : ""
            );

            for (var i = 0; i < max; i++) {
              var li = create("li", null, list);
              var button = create(
                "button",
                {
                  class: classes.page,
                  type: "button",
                },
                li
              );
              var controls = Slides.getIn(i).map(function (Slide) {
                return Slide.slide.id;
              });
              var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
              bind(button, "click", apply(onClick, i));

              if (options.paginationKeyboard) {
                bind(button, "keydown", apply(onKeydown, i));
              }

              setAttribute(li, ROLE, "presentation");
              setAttribute(button, ROLE, "tab");
              setAttribute(button, ARIA_CONTROLS, controls.join(" "));
              setAttribute(button, ARIA_LABEL, format(text, i + 1));
              setAttribute(button, TAB_INDEX, -1);
              items.push({
                li: li,
                button: button,
                page: i,
              });
            }
          }

          function onClick(page) {
            go(">" + page, true);
          }

          function onKeydown(page, e) {
            var length = items.length;
            var key = normalizeKey(e);
            var dir = getDirection();
            var nextPage = -1;

            if (key === resolve(ARROW_RIGHT, false, dir)) {
              nextPage = ++page % length;
            } else if (key === resolve(ARROW_LEFT, false, dir)) {
              nextPage = (--page + length) % length;
            } else if (key === "Home") {
              nextPage = 0;
            } else if (key === "End") {
              nextPage = length - 1;
            }

            var item = items[nextPage];

            if (item) {
              focus(item.button);
              go(">" + nextPage);
              prevent(e, true);
            }
          }

          function getDirection() {
            return options.paginationDirection || options.direction;
          }

          function getAt(index) {
            return items[Controller.toPage(index)];
          }

          function update() {
            var prev = getAt(getIndex(true));
            var curr = getAt(getIndex());

            if (prev) {
              var button = prev.button;
              removeClass(button, CLASS_ACTIVE);
              removeAttribute(button, ARIA_SELECTED);
              setAttribute(button, TAB_INDEX, -1);
            }

            if (curr) {
              var _button = curr.button;
              addClass(_button, CLASS_ACTIVE);
              setAttribute(_button, ARIA_SELECTED, true);
              setAttribute(_button, TAB_INDEX, "");
            }

            emit(
              EVENT_PAGINATION_UPDATED,
              {
                list: list,
                items: items,
              },
              prev,
              curr
            );
          }

          return {
            items: items,
            mount: mount,
            destroy: destroy,
            getAt: getAt,
            update: update,
          };
        }

        var TRIGGER_KEYS = [" ", "Enter"];

        function Sync(Splide2, Components2, options) {
          var isNavigation = options.isNavigation,
            slideFocus = options.slideFocus;
          var events = [];

          function mount() {
            Splide2.splides.forEach(function (target) {
              if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
              }
            });

            if (isNavigation) {
              navigate();
            }
          }

          function destroy() {
            events.forEach(function (event) {
              event.destroy();
            });
            empty(events);
          }

          function remount() {
            destroy();
            mount();
          }

          function sync(splide, target) {
            var event = EventInterface(splide);
            event.on(EVENT_MOVE, function (index, prev, dest) {
              target.go(target.is(LOOP) ? dest : index);
            });
            events.push(event);
          }

          function navigate() {
            var event = EventInterface(Splide2);
            var on = event.on;
            on(EVENT_CLICK, onClick);
            on(EVENT_SLIDE_KEYDOWN, onKeydown);
            on([EVENT_MOUNTED, EVENT_UPDATED], update);
            events.push(event);
            event.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
          }

          function update() {
            setAttribute(
              Components2.Elements.list,
              ARIA_ORIENTATION,
              options.direction === TTB ? "vertical" : ""
            );
          }

          function onClick(Slide) {
            Splide2.go(Slide.index);
          }

          function onKeydown(Slide, e) {
            if (includes(TRIGGER_KEYS, normalizeKey(e))) {
              onClick(Slide);
              prevent(e);
            }
          }

          return {
            setup: apply(
              Components2.Media.set,
              {
                slideFocus: isUndefined(slideFocus) ? isNavigation : slideFocus,
              },
              true
            ),
            mount: mount,
            destroy: destroy,
            remount: remount,
          };
        }

        function Wheel(Splide2, Components2, options) {
          var _EventInterface12 = EventInterface(Splide2),
            bind = _EventInterface12.bind;

          var lastTime = 0;

          function mount() {
            if (options.wheel) {
              bind(
                Components2.Elements.track,
                "wheel",
                onWheel,
                SCROLL_LISTENER_OPTIONS
              );
            }
          }

          function onWheel(e) {
            if (e.cancelable) {
              var deltaY = e.deltaY;
              var backwards = deltaY < 0;
              var timeStamp = timeOf(e);

              var _min = options.wheelMinThreshold || 0;

              var sleep = options.wheelSleep || 0;

              if (abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
              }

              shouldPrevent(backwards) && prevent(e);
            }
          }

          function shouldPrevent(backwards) {
            return (
              !options.releaseWheel ||
              Splide2.state.is(MOVING) ||
              Components2.Controller.getAdjacent(backwards) !== -1
            );
          }

          return {
            mount: mount,
          };
        }

        var SR_REMOVAL_DELAY = 90;

        function Live(Splide2, Components2, options) {
          var _EventInterface13 = EventInterface(Splide2),
            on = _EventInterface13.on;

          var track = Components2.Elements.track;
          var enabled = options.live && !options.isNavigation;
          var sr = create("span", CLASS_SR);
          var interval = RequestInterval(
            SR_REMOVAL_DELAY,
            apply(toggle, false)
          );

          function mount() {
            if (enabled) {
              disable(!Components2.Autoplay.isPaused());
              setAttribute(track, ARIA_ATOMIC, true);
              sr.textContent = "\u2026";
              on(EVENT_AUTOPLAY_PLAY, apply(disable, true));
              on(EVENT_AUTOPLAY_PAUSE, apply(disable, false));
              on([EVENT_MOVED, EVENT_SCROLLED], apply(toggle, true));
            }
          }

          function toggle(active) {
            setAttribute(track, ARIA_BUSY, active);

            if (active) {
              append(track, sr);
              interval.start();
            } else {
              remove(sr);
              interval.cancel();
            }
          }

          function destroy() {
            removeAttribute(track, [ARIA_LIVE, ARIA_ATOMIC, ARIA_BUSY]);
            remove(sr);
          }

          function disable(disabled) {
            if (enabled) {
              setAttribute(track, ARIA_LIVE, disabled ? "off" : "polite");
            }
          }

          return {
            mount: mount,
            disable: disable,
            destroy: destroy,
          };
        }

        var ComponentConstructors = /*#__PURE__*/ Object.freeze({
          __proto__: null,
          Media: Media,
          Direction: Direction,
          Elements: Elements,
          Slides: Slides,
          Layout: Layout,
          Clones: Clones,
          Move: Move,
          Controller: Controller,
          Arrows: Arrows,
          Autoplay: Autoplay,
          Cover: Cover,
          Scroll: Scroll,
          Drag: Drag,
          Keyboard: Keyboard,
          LazyLoad: LazyLoad,
          Pagination: Pagination,
          Sync: Sync,
          Wheel: Wheel,
          Live: Live,
        });
        var I18N = {
          prev: "Previous slide",
          next: "Next slide",
          first: "Go to first slide",
          last: "Go to last slide",
          slideX: "Go to slide %s",
          pageX: "Go to page %s",
          play: "Start autoplay",
          pause: "Pause autoplay",
          carousel: "carousel",
          slide: "slide",
          select: "Select a slide to show",
          slideLabel: "%s of %s",
        };
        var DEFAULTS = {
          type: "slide",
          role: "region",
          speed: 400,
          perPage: 1,
          cloneStatus: true,
          arrows: true,
          pagination: true,
          paginationKeyboard: true,
          interval: 5e3,
          pauseOnHover: true,
          pauseOnFocus: true,
          resetProgress: true,
          easing: "cubic-bezier(0.25, 1, 0.5, 1)",
          drag: true,
          direction: "ltr",
          trimSpace: true,
          focusableNodes: "a, button, textarea, input, select, iframe",
          live: true,
          classes: CLASSES,
          i18n: I18N,
          reducedMotion: {
            speed: 0,
            rewindSpeed: 0,
            autoplay: "pause",
          },
        };

        function Fade(Splide2, Components2, options) {
          var Slides = Components2.Slides;

          function mount() {
            EventInterface(Splide2).on([EVENT_MOUNTED, EVENT_REFRESH], init);
          }

          function init() {
            Slides.forEach(function (Slide) {
              Slide.style(
                "transform",
                "translateX(-" + 100 * Slide.index + "%)"
              );
            });
          }

          function start(index, done) {
            Slides.style(
              "transition",
              "opacity " + options.speed + "ms " + options.easing
            );
            nextTick(done);
          }

          return {
            mount: mount,
            start: start,
            cancel: noop,
          };
        }

        function Slide(Splide2, Components2, options) {
          var Move = Components2.Move,
            Controller = Components2.Controller,
            Scroll = Components2.Scroll;
          var list = Components2.Elements.list;
          var transition = apply(style, list, "transition");
          var endCallback;

          function mount() {
            EventInterface(Splide2).bind(list, "transitionend", function (e) {
              if (e.target === list && endCallback) {
                cancel();
                endCallback();
              }
            });
          }

          function start(index, done) {
            var destination = Move.toPosition(index, true);
            var position = Move.getPosition();
            var speed = getSpeed(index);

            if (abs(destination - position) >= 1 && speed >= 1) {
              if (options.useScroll) {
                Scroll.scroll(destination, speed, false, done);
              } else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
              }
            } else {
              Move.jump(index);
              done();
            }
          }

          function cancel() {
            transition("");
            Scroll.cancel();
          }

          function getSpeed(index) {
            var rewindSpeed = options.rewindSpeed;

            if (Splide2.is(SLIDE) && rewindSpeed) {
              var prev = Controller.getIndex(true);
              var end = Controller.getEnd();

              if (
                (prev === 0 && index >= end) ||
                (prev >= end && index === 0)
              ) {
                return rewindSpeed;
              }
            }

            return options.speed;
          }

          return {
            mount: mount,
            start: start,
            cancel: cancel,
          };
        }

        var _Splide = /*#__PURE__*/ (function () {
          function _Splide(target, options) {
            this.event = EventInterface();
            this.Components = {};
            this.state = State(CREATED);
            this.splides = [];
            this._o = {};
            this._E = {};
            var root = isString(target) ? query(document, target) : target;
            assert(root, root + " is invalid.");
            this.root = root;
            options = merge(
              {
                label: getAttribute(root, ARIA_LABEL) || "",
                labelledby: getAttribute(root, ARIA_LABELLEDBY) || "",
              },
              DEFAULTS,
              _Splide.defaults,
              options || {}
            );

            try {
              merge(options, JSON.parse(getAttribute(root, DATA_ATTRIBUTE)));
            } catch (e) {
              assert(false, "Invalid JSON");
            }

            this._o = Object.create(merge({}, options));
          }

          var _proto = _Splide.prototype;

          _proto.mount = function mount(Extensions, Transition) {
            var _this = this;

            var state = this.state,
              Components2 = this.Components;
            assert(state.is([CREATED, DESTROYED]), "Already mounted!");
            state.set(CREATED);
            this._C = Components2;
            this._T = Transition || this._T || (this.is(FADE) ? Fade : Slide);
            this._E = Extensions || this._E;
            var Constructors = assign({}, ComponentConstructors, this._E, {
              Transition: this._T,
            });
            forOwn(Constructors, function (Component, key) {
              var component = Component(_this, Components2, _this._o);
              Components2[key] = component;
              component.setup && component.setup();
            });
            forOwn(Components2, function (component) {
              component.mount && component.mount();
            });
            this.emit(EVENT_MOUNTED);
            addClass(this.root, CLASS_INITIALIZED);
            state.set(IDLE);
            this.emit(EVENT_READY);
            return this;
          };

          _proto.sync = function sync(splide) {
            this.splides.push({
              splide: splide,
            });
            splide.splides.push({
              splide: this,
              isParent: true,
            });

            if (this.state.is(IDLE)) {
              this._C.Sync.remount();

              splide.Components.Sync.remount();
            }

            return this;
          };

          _proto.go = function go(control) {
            this._C.Controller.go(control);

            return this;
          };

          _proto.on = function on(events, callback) {
            this.event.on(events, callback);
            return this;
          };

          _proto.off = function off(events) {
            this.event.off(events);
            return this;
          };

          _proto.emit = function emit(event) {
            var _this$event;

            (_this$event = this.event).emit.apply(
              _this$event,
              [event].concat(slice(arguments, 1))
            );

            return this;
          };

          _proto.add = function add(slides, index) {
            this._C.Slides.add(slides, index);

            return this;
          };

          _proto.remove = function remove(matcher) {
            this._C.Slides.remove(matcher);

            return this;
          };

          _proto.is = function is(type) {
            return this._o.type === type;
          };

          _proto.refresh = function refresh() {
            this.emit(EVENT_REFRESH);
            return this;
          };

          _proto.destroy = function destroy(completely) {
            if (completely === void 0) {
              completely = true;
            }

            var event = this.event,
              state = this.state;

            if (state.is(CREATED)) {
              EventInterface(this).on(
                EVENT_READY,
                this.destroy.bind(this, completely)
              );
            } else {
              forOwn(
                this._C,
                function (component) {
                  component.destroy && component.destroy(completely);
                },
                true
              );
              event.emit(EVENT_DESTROY);
              event.destroy();
              completely && empty(this.splides);
              state.set(DESTROYED);
            }

            return this;
          };

          _createClass(_Splide, [
            {
              key: "options",
              get: function get() {
                return this._o;
              },
              set: function set(options) {
                this._C.Media.set(options, true, true);
              },
            },
            {
              key: "length",
              get: function get() {
                return this._C.Slides.getLength(true);
              },
            },
            {
              key: "index",
              get: function get() {
                return this._C.Controller.getIndex();
              },
            },
          ]);

          return _Splide;
        })();

        var Splide = _Splide;
        Splide.defaults = {};
        Splide.STATES = STATES;
        var CLASS_RENDERED = "is-rendered";
        var RENDERER_DEFAULT_CONFIG = {
          listTag: "ul",
          slideTag: "li",
        };

        var Style = /*#__PURE__*/ (function () {
          function Style(id, options) {
            this.styles = {};
            this.id = id;
            this.options = options;
          }

          var _proto2 = Style.prototype;

          _proto2.rule = function rule(selector, prop, value, breakpoint) {
            breakpoint = breakpoint || "default";
            var selectors = (this.styles[breakpoint] =
              this.styles[breakpoint] || {});
            var styles = (selectors[selector] = selectors[selector] || {});
            styles[prop] = value;
          };

          _proto2.build = function build() {
            var _this2 = this;

            var css = "";

            if (this.styles.default) {
              css += this.buildSelectors(this.styles.default);
            }

            Object.keys(this.styles)
              .sort(function (n, m) {
                return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
              })
              .forEach(function (breakpoint) {
                if (breakpoint !== "default") {
                  css +=
                    "@media screen and (max-width: " + breakpoint + "px) {";
                  css += _this2.buildSelectors(_this2.styles[breakpoint]);
                  css += "}";
                }
              });
            return css;
          };

          _proto2.buildSelectors = function buildSelectors(selectors) {
            var _this3 = this;

            var css = "";
            forOwn(selectors, function (styles, selector) {
              selector = ("#" + _this3.id + " " + selector).trim();
              css += selector + " {";
              forOwn(styles, function (value, prop) {
                if (value || value === 0) {
                  css += prop + ": " + value + ";";
                }
              });
              css += "}";
            });
            return css;
          };

          return Style;
        })();

        var SplideRenderer = /*#__PURE__*/ (function () {
          function SplideRenderer(contents, options, config, defaults) {
            this.slides = [];
            this.options = {};
            this.breakpoints = [];
            merge(DEFAULTS, defaults || {});
            merge(merge(this.options, DEFAULTS), options || {});
            this.contents = contents;
            this.config = assign({}, RENDERER_DEFAULT_CONFIG, config || {});
            this.id = this.config.id || uniqueId("splide");
            this.Style = new Style(this.id, this.options);
            this.Direction = Direction(null, null, this.options);
            assert(this.contents.length, "Provide at least 1 content.");
            this.init();
          }

          SplideRenderer.clean = function clean(splide) {
            var _EventInterface14 = EventInterface(splide),
              on = _EventInterface14.on;

            var root = splide.root;
            var clones = queryAll(root, "." + CLASS_CLONE);
            on(EVENT_MOUNTED, function () {
              remove(child(root, "style"));
            });
            remove(clones);
          };

          var _proto3 = SplideRenderer.prototype;

          _proto3.init = function init() {
            this.parseBreakpoints();
            this.initSlides();
            this.registerRootStyles();
            this.registerTrackStyles();
            this.registerSlideStyles();
            this.registerListStyles();
          };

          _proto3.initSlides = function initSlides() {
            var _this4 = this;

            push(
              this.slides,
              this.contents.map(function (content, index) {
                content = isString(content)
                  ? {
                      html: content,
                    }
                  : content;
                content.styles = content.styles || {};
                content.attrs = content.attrs || {};

                _this4.cover(content);

                var classes =
                  _this4.options.classes.slide +
                  " " +
                  (index === 0 ? CLASS_ACTIVE : "");
                assign(content.attrs, {
                  class: (classes + " " + (content.attrs.class || "")).trim(),
                  style: _this4.buildStyles(content.styles),
                });
                return content;
              })
            );

            if (this.isLoop()) {
              this.generateClones(this.slides);
            }
          };

          _proto3.registerRootStyles = function registerRootStyles() {
            var _this5 = this;

            this.breakpoints.forEach(function (_ref2) {
              var width = _ref2[0],
                options = _ref2[1];

              _this5.Style.rule(" ", "max-width", unit(options.width), width);
            });
          };

          _proto3.registerTrackStyles = function registerTrackStyles() {
            var _this6 = this;

            var Style2 = this.Style;
            var selector = "." + CLASS_TRACK;
            this.breakpoints.forEach(function (_ref3) {
              var width = _ref3[0],
                options = _ref3[1];
              Style2.rule(
                selector,
                _this6.resolve("paddingLeft"),
                _this6.cssPadding(options, false),
                width
              );
              Style2.rule(
                selector,
                _this6.resolve("paddingRight"),
                _this6.cssPadding(options, true),
                width
              );
              Style2.rule(
                selector,
                "height",
                _this6.cssTrackHeight(options),
                width
              );
            });
          };

          _proto3.registerListStyles = function registerListStyles() {
            var _this7 = this;

            var Style2 = this.Style;
            var selector = "." + CLASS_LIST;
            this.breakpoints.forEach(function (_ref4) {
              var width = _ref4[0],
                options = _ref4[1];
              Style2.rule(
                selector,
                "transform",
                _this7.buildTranslate(options),
                width
              );

              if (!_this7.cssSlideHeight(options)) {
                Style2.rule(
                  selector,
                  "aspect-ratio",
                  _this7.cssAspectRatio(options),
                  width
                );
              }
            });
          };

          _proto3.registerSlideStyles = function registerSlideStyles() {
            var _this8 = this;

            var Style2 = this.Style;
            var selector = "." + CLASS_SLIDE;
            this.breakpoints.forEach(function (_ref5) {
              var width = _ref5[0],
                options = _ref5[1];
              Style2.rule(
                selector,
                "width",
                _this8.cssSlideWidth(options),
                width
              );
              Style2.rule(
                selector,
                "height",
                _this8.cssSlideHeight(options) || "100%",
                width
              );
              Style2.rule(
                selector,
                _this8.resolve("marginRight"),
                unit(options.gap) || "0px",
                width
              );
              Style2.rule(
                selector + " > img",
                "display",
                options.cover ? "none" : "inline",
                width
              );
            });
          };

          _proto3.buildTranslate = function buildTranslate(options) {
            var _this$Direction = this.Direction,
              resolve = _this$Direction.resolve,
              orient = _this$Direction.orient;
            var values = [];
            values.push(this.cssOffsetClones(options));
            values.push(this.cssOffsetGaps(options));

            if (this.isCenter(options)) {
              values.push(this.buildCssValue(orient(-50), "%"));
              values.push.apply(values, this.cssOffsetCenter(options));
            }

            return values
              .filter(Boolean)
              .map(function (value) {
                return "translate" + resolve("X") + "(" + value + ")";
              })
              .join(" ");
          };

          _proto3.cssOffsetClones = function cssOffsetClones(options) {
            var _this$Direction2 = this.Direction,
              resolve = _this$Direction2.resolve,
              orient = _this$Direction2.orient;
            var cloneCount = this.getCloneCount();

            if (this.isFixedWidth(options)) {
              var _this$parseCssValue = this.parseCssValue(
                  options[resolve("fixedWidth")]
                ),
                value = _this$parseCssValue.value,
                unit2 = _this$parseCssValue.unit;

              return this.buildCssValue(orient(value) * cloneCount, unit2);
            }

            var percent = (100 * cloneCount) / options.perPage;
            return orient(percent) + "%";
          };

          _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
            var _this$Direction3 = this.Direction,
              resolve = _this$Direction3.resolve,
              orient = _this$Direction3.orient;

            if (this.isFixedWidth(options)) {
              var _this$parseCssValue2 = this.parseCssValue(
                  options[resolve("fixedWidth")]
                ),
                value = _this$parseCssValue2.value,
                unit2 = _this$parseCssValue2.unit;

              return [this.buildCssValue(orient(value / 2), unit2)];
            }

            var values = [];
            var perPage = options.perPage,
              gap = options.gap;
            values.push(orient(50 / perPage) + "%");

            if (gap) {
              var _this$parseCssValue3 = this.parseCssValue(gap),
                _value = _this$parseCssValue3.value,
                _unit = _this$parseCssValue3.unit;

              var gapOffset = (_value / perPage - _value) / 2;
              values.push(this.buildCssValue(orient(gapOffset), _unit));
            }

            return values;
          };

          _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
            var cloneCount = this.getCloneCount();

            if (cloneCount && options.gap) {
              var orient = this.Direction.orient;

              var _this$parseCssValue4 = this.parseCssValue(options.gap),
                value = _this$parseCssValue4.value,
                unit2 = _this$parseCssValue4.unit;

              if (this.isFixedWidth(options)) {
                return this.buildCssValue(orient(value * cloneCount), unit2);
              }

              var perPage = options.perPage;
              var gaps = cloneCount / perPage;
              return this.buildCssValue(orient(gaps * value), unit2);
            }

            return "";
          };

          _proto3.resolve = function resolve(prop) {
            return camelToKebab(this.Direction.resolve(prop));
          };

          _proto3.cssPadding = function cssPadding(options, right) {
            var padding = options.padding;
            var prop = this.Direction.resolve(right ? "right" : "left", true);
            return (
              (padding &&
                unit(padding[prop] || (isObject(padding) ? 0 : padding))) ||
              "0px"
            );
          };

          _proto3.cssTrackHeight = function cssTrackHeight(options) {
            var height = "";

            if (this.isVertical()) {
              height = this.cssHeight(options);
              assert(height, '"height" is missing.');
              height =
                "calc(" +
                height +
                " - " +
                this.cssPadding(options, false) +
                " - " +
                this.cssPadding(options, true) +
                ")";
            }

            return height;
          };

          _proto3.cssHeight = function cssHeight(options) {
            return unit(options.height);
          };

          _proto3.cssSlideWidth = function cssSlideWidth(options) {
            return options.autoWidth
              ? ""
              : unit(options.fixedWidth) ||
                  (this.isVertical() ? "" : this.cssSlideSize(options));
          };

          _proto3.cssSlideHeight = function cssSlideHeight(options) {
            return (
              unit(options.fixedHeight) ||
              (this.isVertical()
                ? options.autoHeight
                  ? ""
                  : this.cssSlideSize(options)
                : this.cssHeight(options))
            );
          };

          _proto3.cssSlideSize = function cssSlideSize(options) {
            var gap = unit(options.gap);
            return (
              "calc((100%" +
              (gap && " + " + gap) +
              ")/" +
              (options.perPage || 1) +
              (gap && " - " + gap) +
              ")"
            );
          };

          _proto3.cssAspectRatio = function cssAspectRatio(options) {
            var heightRatio = options.heightRatio;
            return heightRatio ? "" + 1 / heightRatio : "";
          };

          _proto3.buildCssValue = function buildCssValue(value, unit2) {
            return "" + value + unit2;
          };

          _proto3.parseCssValue = function parseCssValue(value) {
            if (isString(value)) {
              var number = parseFloat(value) || 0;
              var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
              return {
                value: number,
                unit: unit2,
              };
            }

            return {
              value: value,
              unit: "px",
            };
          };

          _proto3.parseBreakpoints = function parseBreakpoints() {
            var _this9 = this;

            var breakpoints = this.options.breakpoints;
            this.breakpoints.push(["default", this.options]);

            if (breakpoints) {
              forOwn(breakpoints, function (options, width) {
                _this9.breakpoints.push([
                  width,
                  merge(merge({}, _this9.options), options),
                ]);
              });
            }
          };

          _proto3.isFixedWidth = function isFixedWidth(options) {
            return !!options[this.Direction.resolve("fixedWidth")];
          };

          _proto3.isLoop = function isLoop() {
            return this.options.type === LOOP;
          };

          _proto3.isCenter = function isCenter(options) {
            if (options.focus === "center") {
              if (this.isLoop()) {
                return true;
              }

              if (this.options.type === SLIDE) {
                return !this.options.trimSpace;
              }
            }

            return false;
          };

          _proto3.isVertical = function isVertical() {
            return this.options.direction === TTB;
          };

          _proto3.buildClasses = function buildClasses() {
            var options = this.options;
            return [
              CLASS_ROOT,
              CLASS_ROOT + "--" + options.type,
              CLASS_ROOT + "--" + options.direction,
              options.drag && CLASS_ROOT + "--draggable",
              options.isNavigation && CLASS_ROOT + "--nav",
              CLASS_ACTIVE,
              !this.config.hidden && CLASS_RENDERED,
            ]
              .filter(Boolean)
              .join(" ");
          };

          _proto3.buildAttrs = function buildAttrs(attrs) {
            var attr = "";
            forOwn(attrs, function (value, key) {
              attr += value ? " " + camelToKebab(key) + '="' + value + '"' : "";
            });
            return attr.trim();
          };

          _proto3.buildStyles = function buildStyles(styles) {
            var style = "";
            forOwn(styles, function (value, key) {
              style += " " + camelToKebab(key) + ":" + value + ";";
            });
            return style.trim();
          };

          _proto3.renderSlides = function renderSlides() {
            var _this10 = this;

            var tag = this.config.slideTag;
            return this.slides
              .map(function (content) {
                return (
                  "<" +
                  tag +
                  " " +
                  _this10.buildAttrs(content.attrs) +
                  ">" +
                  (content.html || "") +
                  "</" +
                  tag +
                  ">"
                );
              })
              .join("");
          };

          _proto3.cover = function cover(content) {
            var styles = content.styles,
              _content$html = content.html,
              html = _content$html === void 0 ? "" : _content$html;

            if (this.options.cover && !this.options.lazyLoad) {
              var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);

              if (src && src[2]) {
                styles.background =
                  "center/cover no-repeat url('" + src[2] + "')";
              }
            }
          };

          _proto3.generateClones = function generateClones(contents) {
            var classes = this.options.classes;
            var count = this.getCloneCount();
            var slides = contents.slice();

            while (slides.length < count) {
              push(slides, slides);
            }

            push(
              slides.slice(-count).reverse(),
              slides.slice(0, count)
            ).forEach(function (content, index) {
              var attrs = assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone,
              });
              var clone = assign({}, content, {
                attrs: attrs,
              });
              index < count ? contents.unshift(clone) : contents.push(clone);
            });
          };

          _proto3.getCloneCount = function getCloneCount() {
            if (this.isLoop()) {
              var options = this.options;

              if (options.clones) {
                return options.clones;
              }

              var perPage = max.apply(
                void 0,
                this.breakpoints.map(function (_ref6) {
                  var options2 = _ref6[1];
                  return options2.perPage;
                })
              );
              return perPage * ((options.flickMaxPages || 1) + 1);
            }

            return 0;
          };

          _proto3.renderArrows = function renderArrows() {
            var html = "";
            html += '<div class="' + this.options.classes.arrows + '">';
            html += this.renderArrow(true);
            html += this.renderArrow(false);
            html += "</div>";
            return html;
          };

          _proto3.renderArrow = function renderArrow(prev) {
            var _this$options = this.options,
              classes = _this$options.classes,
              i18n = _this$options.i18n;
            var attrs = {
              class: classes.arrow + " " + (prev ? classes.prev : classes.next),
              type: "button",
              ariaLabel: prev ? i18n.prev : i18n.next,
            };
            return (
              "<button " +
              this.buildAttrs(attrs) +
              '><svg xmlns="' +
              XML_NAME_SPACE +
              '" viewBox="0 0 ' +
              SIZE +
              " " +
              SIZE +
              '" width="' +
              SIZE +
              '" height="' +
              SIZE +
              '"><path d="' +
              (this.options.arrowPath || PATH) +
              '" /></svg></button>'
            );
          };

          _proto3.html = function html() {
            var _this$config = this.config,
              rootClass = _this$config.rootClass,
              listTag = _this$config.listTag,
              arrows = _this$config.arrows,
              beforeTrack = _this$config.beforeTrack,
              afterTrack = _this$config.afterTrack,
              slider = _this$config.slider,
              beforeSlider = _this$config.beforeSlider,
              afterSlider = _this$config.afterSlider;
            var html = "";
            html +=
              '<div id="' +
              this.id +
              '" class="' +
              this.buildClasses() +
              " " +
              (rootClass || "") +
              '">';
            html += "<style>" + this.Style.build() + "</style>";

            if (slider) {
              html += beforeSlider || "";
              html += '<div class="splide__slider">';
            }

            html += beforeTrack || "";

            if (arrows) {
              html += this.renderArrows();
            }

            html += '<div class="splide__track">';
            html += "<" + listTag + ' class="splide__list">';
            html += this.renderSlides();
            html += "</" + listTag + ">";
            html += "</div>";
            html += afterTrack || "";

            if (slider) {
              html += "</div>";
              html += afterSlider || "";
            }

            html += "</div>";
            return html;
          };

          return SplideRenderer;
        })();

        /***/
      },

    /***/ "./node_modules/alpinejs/dist/module.esm.js":
      /*!**************************************************!*\
  !*** ./node_modules/alpinejs/dist/module.esm.js ***!
  \**************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ module_default,
          /* harmony export */
        });
        // packages/alpinejs/src/scheduler.js
        var flushPending = false;
        var flushing = false;
        var queue = [];
        var lastFlushedIndex = -1;
        function scheduler(callback) {
          queueJob(callback);
        }
        function queueJob(job) {
          if (!queue.includes(job)) queue.push(job);
          queueFlush();
        }
        function dequeueJob(job) {
          let index = queue.indexOf(job);
          if (index !== -1 && index > lastFlushedIndex) queue.splice(index, 1);
        }
        function queueFlush() {
          if (!flushing && !flushPending) {
            flushPending = true;
            queueMicrotask(flushJobs);
          }
        }
        function flushJobs() {
          flushPending = false;
          flushing = true;
          for (let i = 0; i < queue.length; i++) {
            queue[i]();
            lastFlushedIndex = i;
          }
          queue.length = 0;
          lastFlushedIndex = -1;
          flushing = false;
        }

        // packages/alpinejs/src/reactivity.js
        var reactive;
        var effect;
        var release;
        var raw;
        var shouldSchedule = true;
        function disableEffectScheduling(callback) {
          shouldSchedule = false;
          callback();
          shouldSchedule = true;
        }
        function setReactivityEngine(engine) {
          reactive = engine.reactive;
          release = engine.release;
          effect = (callback) =>
            engine.effect(callback, {
              scheduler: (task) => {
                if (shouldSchedule) {
                  scheduler(task);
                } else {
                  task();
                }
              },
            });
          raw = engine.raw;
        }
        function overrideEffect(override) {
          effect = override;
        }
        function elementBoundEffect(el) {
          let cleanup2 = () => {};
          let wrappedEffect = (callback) => {
            let effectReference = effect(callback);
            if (!el._x_effects) {
              el._x_effects = /* @__PURE__ */ new Set();
              el._x_runEffects = () => {
                el._x_effects.forEach((i) => i());
              };
            }
            el._x_effects.add(effectReference);
            cleanup2 = () => {
              if (effectReference === void 0) return;
              el._x_effects.delete(effectReference);
              release(effectReference);
            };
            return effectReference;
          };
          return [
            wrappedEffect,
            () => {
              cleanup2();
            },
          ];
        }

        // packages/alpinejs/src/utils/dispatch.js
        function dispatch(el, name, detail = {}) {
          el.dispatchEvent(
            new CustomEvent(name, {
              detail,
              bubbles: true,
              // Allows events to pass the shadow DOM barrier.
              composed: true,
              cancelable: true,
            })
          );
        }

        // packages/alpinejs/src/utils/walk.js
        function walk(el, callback) {
          if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
            Array.from(el.children).forEach((el2) => walk(el2, callback));
            return;
          }
          let skip = false;
          callback(el, () => (skip = true));
          if (skip) return;
          let node = el.firstElementChild;
          while (node) {
            walk(node, callback, false);
            node = node.nextElementSibling;
          }
        }

        // packages/alpinejs/src/utils/warn.js
        function warn(message, ...args) {
          console.warn(`Alpine Warning: ${message}`, ...args);
        }

        // packages/alpinejs/src/lifecycle.js
        var started = false;
        function start() {
          if (started)
            warn(
              "Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems."
            );
          started = true;
          if (!document.body)
            warn(
              "Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"
            );
          dispatch(document, "alpine:init");
          dispatch(document, "alpine:initializing");
          startObservingMutations();
          onElAdded((el) => initTree(el, walk));
          onElRemoved((el) => destroyTree(el));
          onAttributesAdded((el, attrs) => {
            directives(el, attrs).forEach((handle) => handle());
          });
          let outNestedComponents = (el) =>
            !closestRoot(el.parentElement, true);
          Array.from(document.querySelectorAll(allSelectors()))
            .filter(outNestedComponents)
            .forEach((el) => {
              initTree(el);
            });
          dispatch(document, "alpine:initialized");
        }
        var rootSelectorCallbacks = [];
        var initSelectorCallbacks = [];
        function rootSelectors() {
          return rootSelectorCallbacks.map((fn) => fn());
        }
        function allSelectors() {
          return rootSelectorCallbacks
            .concat(initSelectorCallbacks)
            .map((fn) => fn());
        }
        function addRootSelector(selectorCallback) {
          rootSelectorCallbacks.push(selectorCallback);
        }
        function addInitSelector(selectorCallback) {
          initSelectorCallbacks.push(selectorCallback);
        }
        function closestRoot(el, includeInitSelectors = false) {
          return findClosest(el, (element) => {
            const selectors = includeInitSelectors
              ? allSelectors()
              : rootSelectors();
            if (selectors.some((selector) => element.matches(selector)))
              return true;
          });
        }
        function findClosest(el, callback) {
          if (!el) return;
          if (callback(el)) return el;
          if (el._x_teleportBack) el = el._x_teleportBack;
          if (!el.parentElement) return;
          return findClosest(el.parentElement, callback);
        }
        function isRoot(el) {
          return rootSelectors().some((selector) => el.matches(selector));
        }
        var initInterceptors = [];
        function interceptInit(callback) {
          initInterceptors.push(callback);
        }
        function initTree(el, walker = walk, intercept = () => {}) {
          deferHandlingDirectives(() => {
            walker(el, (el2, skip) => {
              intercept(el2, skip);
              initInterceptors.forEach((i) => i(el2, skip));
              directives(el2, el2.attributes).forEach((handle) => handle());
              el2._x_ignore && skip();
            });
          });
        }
        function destroyTree(root) {
          walk(root, (el) => {
            cleanupAttributes(el);
            cleanupElement(el);
          });
        }

        // packages/alpinejs/src/mutation.js
        var onAttributeAddeds = [];
        var onElRemoveds = [];
        var onElAddeds = [];
        function onElAdded(callback) {
          onElAddeds.push(callback);
        }
        function onElRemoved(el, callback) {
          if (typeof callback === "function") {
            if (!el._x_cleanups) el._x_cleanups = [];
            el._x_cleanups.push(callback);
          } else {
            callback = el;
            onElRemoveds.push(callback);
          }
        }
        function onAttributesAdded(callback) {
          onAttributeAddeds.push(callback);
        }
        function onAttributeRemoved(el, name, callback) {
          if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
          if (!el._x_attributeCleanups[name])
            el._x_attributeCleanups[name] = [];
          el._x_attributeCleanups[name].push(callback);
        }
        function cleanupAttributes(el, names) {
          if (!el._x_attributeCleanups) return;
          Object.entries(el._x_attributeCleanups).forEach(([name, value]) => {
            if (names === void 0 || names.includes(name)) {
              value.forEach((i) => i());
              delete el._x_attributeCleanups[name];
            }
          });
        }
        function cleanupElement(el) {
          if (el._x_cleanups) {
            while (el._x_cleanups.length) el._x_cleanups.pop()();
          }
        }
        var observer = new MutationObserver(onMutate);
        var currentlyObserving = false;
        function startObservingMutations() {
          observer.observe(document, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeOldValue: true,
          });
          currentlyObserving = true;
        }
        function stopObservingMutations() {
          flushObserver();
          observer.disconnect();
          currentlyObserving = false;
        }
        var recordQueue = [];
        var willProcessRecordQueue = false;
        function flushObserver() {
          recordQueue = recordQueue.concat(observer.takeRecords());
          if (recordQueue.length && !willProcessRecordQueue) {
            willProcessRecordQueue = true;
            queueMicrotask(() => {
              processRecordQueue();
              willProcessRecordQueue = false;
            });
          }
        }
        function processRecordQueue() {
          onMutate(recordQueue);
          recordQueue.length = 0;
        }
        function mutateDom(callback) {
          if (!currentlyObserving) return callback();
          stopObservingMutations();
          let result = callback();
          startObservingMutations();
          return result;
        }
        var isCollecting = false;
        var deferredMutations = [];
        function deferMutations() {
          isCollecting = true;
        }
        function flushAndStopDeferringMutations() {
          isCollecting = false;
          onMutate(deferredMutations);
          deferredMutations = [];
        }
        function onMutate(mutations) {
          if (isCollecting) {
            deferredMutations = deferredMutations.concat(mutations);
            return;
          }
          let addedNodes = [];
          let removedNodes = [];
          let addedAttributes = /* @__PURE__ */ new Map();
          let removedAttributes = /* @__PURE__ */ new Map();
          for (let i = 0; i < mutations.length; i++) {
            if (mutations[i].target._x_ignoreMutationObserver) continue;
            if (mutations[i].type === "childList") {
              mutations[i].addedNodes.forEach(
                (node) => node.nodeType === 1 && addedNodes.push(node)
              );
              mutations[i].removedNodes.forEach(
                (node) => node.nodeType === 1 && removedNodes.push(node)
              );
            }
            if (mutations[i].type === "attributes") {
              let el = mutations[i].target;
              let name = mutations[i].attributeName;
              let oldValue = mutations[i].oldValue;
              let add2 = () => {
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes
                  .get(el)
                  .push({ name, value: el.getAttribute(name) });
              };
              let remove = () => {
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
              };
              if (el.hasAttribute(name) && oldValue === null) {
                add2();
              } else if (el.hasAttribute(name)) {
                remove();
                add2();
              } else {
                remove();
              }
            }
          }
          removedAttributes.forEach((attrs, el) => {
            cleanupAttributes(el, attrs);
          });
          addedAttributes.forEach((attrs, el) => {
            onAttributeAddeds.forEach((i) => i(el, attrs));
          });
          for (let node of removedNodes) {
            if (addedNodes.includes(node)) continue;
            onElRemoveds.forEach((i) => i(node));
            destroyTree(node);
          }
          addedNodes.forEach((node) => {
            node._x_ignoreSelf = true;
            node._x_ignore = true;
          });
          for (let node of addedNodes) {
            if (removedNodes.includes(node)) continue;
            if (!node.isConnected) continue;
            delete node._x_ignoreSelf;
            delete node._x_ignore;
            onElAddeds.forEach((i) => i(node));
            node._x_ignore = true;
            node._x_ignoreSelf = true;
          }
          addedNodes.forEach((node) => {
            delete node._x_ignoreSelf;
            delete node._x_ignore;
          });
          addedNodes = null;
          removedNodes = null;
          addedAttributes = null;
          removedAttributes = null;
        }

        // packages/alpinejs/src/scope.js
        function scope(node) {
          return mergeProxies(closestDataStack(node));
        }
        function addScopeToNode(node, data2, referenceNode) {
          node._x_dataStack = [
            data2,
            ...closestDataStack(referenceNode || node),
          ];
          return () => {
            node._x_dataStack = node._x_dataStack.filter((i) => i !== data2);
          };
        }
        function closestDataStack(node) {
          if (node._x_dataStack) return node._x_dataStack;
          if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) {
            return closestDataStack(node.host);
          }
          if (!node.parentNode) {
            return [];
          }
          return closestDataStack(node.parentNode);
        }
        function mergeProxies(objects) {
          return new Proxy({ objects }, mergeProxyTrap);
        }
        var mergeProxyTrap = {
          ownKeys({ objects }) {
            return Array.from(new Set(objects.flatMap((i) => Object.keys(i))));
          },
          has({ objects }, name) {
            if (name == Symbol.unscopables) return false;
            return objects.some((obj) =>
              Object.prototype.hasOwnProperty.call(obj, name)
            );
          },
          get({ objects }, name, thisProxy) {
            if (name == "toJSON") return collapseProxies;
            return Reflect.get(
              objects.find((obj) =>
                Object.prototype.hasOwnProperty.call(obj, name)
              ) || {},
              name,
              thisProxy
            );
          },
          set({ objects }, name, value, thisProxy) {
            const target =
              objects.find((obj) =>
                Object.prototype.hasOwnProperty.call(obj, name)
              ) || objects[objects.length - 1];
            const descriptor = Object.getOwnPropertyDescriptor(target, name);
            if (descriptor?.set && descriptor?.get)
              return Reflect.set(target, name, value, thisProxy);
            return Reflect.set(target, name, value);
          },
        };
        function collapseProxies() {
          let keys = Reflect.ownKeys(this);
          return keys.reduce((acc, key) => {
            acc[key] = Reflect.get(this, key);
            return acc;
          }, {});
        }

        // packages/alpinejs/src/interceptor.js
        function initInterceptors2(data2) {
          let isObject2 = (val) =>
            typeof val === "object" && !Array.isArray(val) && val !== null;
          let recurse = (obj, basePath = "") => {
            Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(
              ([key, { value, enumerable }]) => {
                if (enumerable === false || value === void 0) return;
                let path = basePath === "" ? key : `${basePath}.${key}`;
                if (
                  typeof value === "object" &&
                  value !== null &&
                  value._x_interceptor
                ) {
                  obj[key] = value.initialize(data2, path, key);
                } else {
                  if (
                    isObject2(value) &&
                    value !== obj &&
                    !(value instanceof Element)
                  ) {
                    recurse(value, path);
                  }
                }
              }
            );
          };
          return recurse(data2);
        }
        function interceptor(callback, mutateObj = () => {}) {
          let obj = {
            initialValue: void 0,
            _x_interceptor: true,
            initialize(data2, path, key) {
              return callback(
                this.initialValue,
                () => get(data2, path),
                (value) => set(data2, path, value),
                path,
                key
              );
            },
          };
          mutateObj(obj);
          return (initialValue) => {
            if (
              typeof initialValue === "object" &&
              initialValue !== null &&
              initialValue._x_interceptor
            ) {
              let initialize = obj.initialize.bind(obj);
              obj.initialize = (data2, path, key) => {
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
              };
            } else {
              obj.initialValue = initialValue;
            }
            return obj;
          };
        }
        function get(obj, path) {
          return path
            .split(".")
            .reduce((carry, segment) => carry[segment], obj);
        }
        function set(obj, path, value) {
          if (typeof path === "string") path = path.split(".");
          if (path.length === 1) obj[path[0]] = value;
          else if (path.length === 0) throw error;
          else {
            if (obj[path[0]]) return set(obj[path[0]], path.slice(1), value);
            else {
              obj[path[0]] = {};
              return set(obj[path[0]], path.slice(1), value);
            }
          }
        }

        // packages/alpinejs/src/magics.js
        var magics = {};
        function magic(name, callback) {
          magics[name] = callback;
        }
        function injectMagics(obj, el) {
          Object.entries(magics).forEach(([name, callback]) => {
            let memoizedUtilities = null;
            function getUtilities() {
              if (memoizedUtilities) {
                return memoizedUtilities;
              } else {
                let [utilities, cleanup2] = getElementBoundUtilities(el);
                memoizedUtilities = { interceptor, ...utilities };
                onElRemoved(el, cleanup2);
                return memoizedUtilities;
              }
            }
            Object.defineProperty(obj, `$${name}`, {
              get() {
                return callback(el, getUtilities());
              },
              enumerable: false,
            });
          });
          return obj;
        }

        // packages/alpinejs/src/utils/error.js
        function tryCatch(el, expression, callback, ...args) {
          try {
            return callback(...args);
          } catch (e) {
            handleError(e, el, expression);
          }
        }
        function handleError(error2, el, expression = void 0) {
          Object.assign(error2, { el, expression });
          console.warn(
            `Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`,
            el
          );
          setTimeout(() => {
            throw error2;
          }, 0);
        }

        // packages/alpinejs/src/evaluator.js
        var shouldAutoEvaluateFunctions = true;
        function dontAutoEvaluateFunctions(callback) {
          let cache = shouldAutoEvaluateFunctions;
          shouldAutoEvaluateFunctions = false;
          let result = callback();
          shouldAutoEvaluateFunctions = cache;
          return result;
        }
        function evaluate(el, expression, extras = {}) {
          let result;
          evaluateLater(el, expression)((value) => (result = value), extras);
          return result;
        }
        function evaluateLater(...args) {
          return theEvaluatorFunction(...args);
        }
        var theEvaluatorFunction = normalEvaluator;
        function setEvaluator(newEvaluator) {
          theEvaluatorFunction = newEvaluator;
        }
        function normalEvaluator(el, expression) {
          let overriddenMagics = {};
          injectMagics(overriddenMagics, el);
          let dataStack = [overriddenMagics, ...closestDataStack(el)];
          let evaluator =
            typeof expression === "function"
              ? generateEvaluatorFromFunction(dataStack, expression)
              : generateEvaluatorFromString(dataStack, expression, el);
          return tryCatch.bind(null, el, expression, evaluator);
        }
        function generateEvaluatorFromFunction(dataStack, func) {
          return (
            receiver = () => {},
            { scope: scope2 = {}, params = [] } = {}
          ) => {
            let result = func.apply(
              mergeProxies([scope2, ...dataStack]),
              params
            );
            runIfTypeOfFunction(receiver, result);
          };
        }
        var evaluatorMemo = {};
        function generateFunctionFromString(expression, el) {
          if (evaluatorMemo[expression]) {
            return evaluatorMemo[expression];
          }
          let AsyncFunction = Object.getPrototypeOf(
            async function () {}
          ).constructor;
          let rightSideSafeExpression =
            /^[\n\s]*if.*\(.*\)/.test(expression.trim()) ||
            /^(let|const)\s/.test(expression.trim())
              ? `(async()=>{ ${expression} })()`
              : expression;
          const safeAsyncFunction = () => {
            try {
              let func2 = new AsyncFunction(
                ["__self", "scope"],
                `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`
              );
              Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`,
              });
              return func2;
            } catch (error2) {
              handleError(error2, el, expression);
              return Promise.resolve();
            }
          };
          let func = safeAsyncFunction();
          evaluatorMemo[expression] = func;
          return func;
        }
        function generateEvaluatorFromString(dataStack, expression, el) {
          let func = generateFunctionFromString(expression, el);
          return (
            receiver = () => {},
            { scope: scope2 = {}, params = [] } = {}
          ) => {
            func.result = void 0;
            func.finished = false;
            let completeScope = mergeProxies([scope2, ...dataStack]);
            if (typeof func === "function") {
              let promise = func(func, completeScope).catch((error2) =>
                handleError(error2, el, expression)
              );
              if (func.finished) {
                runIfTypeOfFunction(
                  receiver,
                  func.result,
                  completeScope,
                  params,
                  el
                );
                func.result = void 0;
              } else {
                promise
                  .then((result) => {
                    runIfTypeOfFunction(
                      receiver,
                      result,
                      completeScope,
                      params,
                      el
                    );
                  })
                  .catch((error2) => handleError(error2, el, expression))
                  .finally(() => (func.result = void 0));
              }
            }
          };
        }
        function runIfTypeOfFunction(receiver, value, scope2, params, el) {
          if (shouldAutoEvaluateFunctions && typeof value === "function") {
            let result = value.apply(scope2, params);
            if (result instanceof Promise) {
              result
                .then((i) => runIfTypeOfFunction(receiver, i, scope2, params))
                .catch((error2) => handleError(error2, el, value));
            } else {
              receiver(result);
            }
          } else if (typeof value === "object" && value instanceof Promise) {
            value.then((i) => receiver(i));
          } else {
            receiver(value);
          }
        }

        // packages/alpinejs/src/directives.js
        var prefixAsString = "x-";
        function prefix(subject = "") {
          return prefixAsString + subject;
        }
        function setPrefix(newPrefix) {
          prefixAsString = newPrefix;
        }
        var directiveHandlers = {};
        function directive(name, callback) {
          directiveHandlers[name] = callback;
          return {
            before(directive2) {
              if (!directiveHandlers[directive2]) {
                console.warn(
                  "Cannot find directive `${directive}`. `${name}` will use the default order of execution"
                );
                return;
              }
              const pos = directiveOrder.indexOf(directive2);
              directiveOrder.splice(
                pos >= 0 ? pos : directiveOrder.indexOf("DEFAULT"),
                0,
                name
              );
            },
          };
        }
        function directives(el, attributes, originalAttributeOverride) {
          attributes = Array.from(attributes);
          if (el._x_virtualDirectives) {
            let vAttributes = Object.entries(el._x_virtualDirectives).map(
              ([name, value]) => ({ name, value })
            );
            let staticAttributes = attributesOnly(vAttributes);
            vAttributes = vAttributes.map((attribute) => {
              if (
                staticAttributes.find((attr) => attr.name === attribute.name)
              ) {
                return {
                  name: `x-bind:${attribute.name}`,
                  value: `"${attribute.value}"`,
                };
              }
              return attribute;
            });
            attributes = attributes.concat(vAttributes);
          }
          let transformedAttributeMap = {};
          let directives2 = attributes
            .map(
              toTransformedAttributes(
                (newName, oldName) =>
                  (transformedAttributeMap[newName] = oldName)
              )
            )
            .filter(outNonAlpineAttributes)
            .map(
              toParsedDirectives(
                transformedAttributeMap,
                originalAttributeOverride
              )
            )
            .sort(byPriority);
          return directives2.map((directive2) => {
            return getDirectiveHandler(el, directive2);
          });
        }
        function attributesOnly(attributes) {
          return Array.from(attributes)
            .map(toTransformedAttributes())
            .filter((attr) => !outNonAlpineAttributes(attr));
        }
        var isDeferringHandlers = false;
        var directiveHandlerStacks = /* @__PURE__ */ new Map();
        var currentHandlerStackKey = Symbol();
        function deferHandlingDirectives(callback) {
          isDeferringHandlers = true;
          let key = Symbol();
          currentHandlerStackKey = key;
          directiveHandlerStacks.set(key, []);
          let flushHandlers = () => {
            while (directiveHandlerStacks.get(key).length)
              directiveHandlerStacks.get(key).shift()();
            directiveHandlerStacks.delete(key);
          };
          let stopDeferring = () => {
            isDeferringHandlers = false;
            flushHandlers();
          };
          callback(flushHandlers);
          stopDeferring();
        }
        function getElementBoundUtilities(el) {
          let cleanups = [];
          let cleanup2 = (callback) => cleanups.push(callback);
          let [effect3, cleanupEffect] = elementBoundEffect(el);
          cleanups.push(cleanupEffect);
          let utilities = {
            Alpine: alpine_default,
            effect: effect3,
            cleanup: cleanup2,
            evaluateLater: evaluateLater.bind(evaluateLater, el),
            evaluate: evaluate.bind(evaluate, el),
          };
          let doCleanup = () => cleanups.forEach((i) => i());
          return [utilities, doCleanup];
        }
        function getDirectiveHandler(el, directive2) {
          let noop = () => {};
          let handler4 = directiveHandlers[directive2.type] || noop;
          let [utilities, cleanup2] = getElementBoundUtilities(el);
          onAttributeRemoved(el, directive2.original, cleanup2);
          let fullHandler = () => {
            if (el._x_ignore || el._x_ignoreSelf) return;
            handler4.inline && handler4.inline(el, directive2, utilities);
            handler4 = handler4.bind(handler4, el, directive2, utilities);
            isDeferringHandlers
              ? directiveHandlerStacks
                  .get(currentHandlerStackKey)
                  .push(handler4)
              : handler4();
          };
          fullHandler.runCleanups = cleanup2;
          return fullHandler;
        }
        var startingWith =
          (subject, replacement) =>
          ({ name, value }) => {
            if (name.startsWith(subject))
              name = name.replace(subject, replacement);
            return { name, value };
          };
        var into = (i) => i;
        function toTransformedAttributes(callback = () => {}) {
          return ({ name, value }) => {
            let { name: newName, value: newValue } =
              attributeTransformers.reduce(
                (carry, transform) => {
                  return transform(carry);
                },
                { name, value }
              );
            if (newName !== name) callback(newName, name);
            return { name: newName, value: newValue };
          };
        }
        var attributeTransformers = [];
        function mapAttributes(callback) {
          attributeTransformers.push(callback);
        }
        function outNonAlpineAttributes({ name }) {
          return alpineAttributeRegex().test(name);
        }
        var alpineAttributeRegex = () =>
          new RegExp(`^${prefixAsString}([^:^.]+)\\b`);
        function toParsedDirectives(
          transformedAttributeMap,
          originalAttributeOverride
        ) {
          return ({ name, value }) => {
            let typeMatch = name.match(alpineAttributeRegex());
            let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
            let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
            let original =
              originalAttributeOverride ||
              transformedAttributeMap[name] ||
              name;
            return {
              type: typeMatch ? typeMatch[1] : null,
              value: valueMatch ? valueMatch[1] : null,
              modifiers: modifiers.map((i) => i.replace(".", "")),
              expression: value,
              original,
            };
          };
        }
        var DEFAULT = "DEFAULT";
        var directiveOrder = [
          "ignore",
          "ref",
          "data",
          "id",
          "bind",
          "init",
          "for",
          "model",
          "modelable",
          "transition",
          "show",
          "if",
          DEFAULT,
          "teleport",
        ];
        function byPriority(a, b) {
          let typeA = directiveOrder.indexOf(a.type) === -1 ? DEFAULT : a.type;
          let typeB = directiveOrder.indexOf(b.type) === -1 ? DEFAULT : b.type;
          return directiveOrder.indexOf(typeA) - directiveOrder.indexOf(typeB);
        }

        // packages/alpinejs/src/nextTick.js
        var tickStack = [];
        var isHolding = false;
        function nextTick(callback = () => {}) {
          queueMicrotask(() => {
            isHolding ||
              setTimeout(() => {
                releaseNextTicks();
              });
          });
          return new Promise((res) => {
            tickStack.push(() => {
              callback();
              res();
            });
          });
        }
        function releaseNextTicks() {
          isHolding = false;
          while (tickStack.length) tickStack.shift()();
        }
        function holdNextTicks() {
          isHolding = true;
        }

        // packages/alpinejs/src/utils/classes.js
        function setClasses(el, value) {
          if (Array.isArray(value)) {
            return setClassesFromString(el, value.join(" "));
          } else if (typeof value === "object" && value !== null) {
            return setClassesFromObject(el, value);
          } else if (typeof value === "function") {
            return setClasses(el, value());
          }
          return setClassesFromString(el, value);
        }
        function setClassesFromString(el, classString) {
          let split = (classString2) => classString2.split(" ").filter(Boolean);
          let missingClasses = (classString2) =>
            classString2
              .split(" ")
              .filter((i) => !el.classList.contains(i))
              .filter(Boolean);
          let addClassesAndReturnUndo = (classes) => {
            el.classList.add(...classes);
            return () => {
              el.classList.remove(...classes);
            };
          };
          classString =
            classString === true ? (classString = "") : classString || "";
          return addClassesAndReturnUndo(missingClasses(classString));
        }
        function setClassesFromObject(el, classObject) {
          let split = (classString) => classString.split(" ").filter(Boolean);
          let forAdd = Object.entries(classObject)
            .flatMap(([classString, bool]) =>
              bool ? split(classString) : false
            )
            .filter(Boolean);
          let forRemove = Object.entries(classObject)
            .flatMap(([classString, bool]) =>
              !bool ? split(classString) : false
            )
            .filter(Boolean);
          let added = [];
          let removed = [];
          forRemove.forEach((i) => {
            if (el.classList.contains(i)) {
              el.classList.remove(i);
              removed.push(i);
            }
          });
          forAdd.forEach((i) => {
            if (!el.classList.contains(i)) {
              el.classList.add(i);
              added.push(i);
            }
          });
          return () => {
            removed.forEach((i) => el.classList.add(i));
            added.forEach((i) => el.classList.remove(i));
          };
        }

        // packages/alpinejs/src/utils/styles.js
        function setStyles(el, value) {
          if (typeof value === "object" && value !== null) {
            return setStylesFromObject(el, value);
          }
          return setStylesFromString(el, value);
        }
        function setStylesFromObject(el, value) {
          let previousStyles = {};
          Object.entries(value).forEach(([key, value2]) => {
            previousStyles[key] = el.style[key];
            if (!key.startsWith("--")) {
              key = kebabCase(key);
            }
            el.style.setProperty(key, value2);
          });
          setTimeout(() => {
            if (el.style.length === 0) {
              el.removeAttribute("style");
            }
          });
          return () => {
            setStyles(el, previousStyles);
          };
        }
        function setStylesFromString(el, value) {
          let cache = el.getAttribute("style", value);
          el.setAttribute("style", value);
          return () => {
            el.setAttribute("style", cache || "");
          };
        }
        function kebabCase(subject) {
          return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }

        // packages/alpinejs/src/utils/once.js
        function once(callback, fallback = () => {}) {
          let called = false;
          return function () {
            if (!called) {
              called = true;
              callback.apply(this, arguments);
            } else {
              fallback.apply(this, arguments);
            }
          };
        }

        // packages/alpinejs/src/directives/x-transition.js
        directive(
          "transition",
          (el, { value, modifiers, expression }, { evaluate: evaluate2 }) => {
            if (typeof expression === "function")
              expression = evaluate2(expression);
            if (expression === false) return;
            if (!expression || typeof expression === "boolean") {
              registerTransitionsFromHelper(el, modifiers, value);
            } else {
              registerTransitionsFromClassString(el, expression, value);
            }
          }
        );
        function registerTransitionsFromClassString(el, classString, stage) {
          registerTransitionObject(el, setClasses, "");
          let directiveStorageMap = {
            enter: (classes) => {
              el._x_transition.enter.during = classes;
            },
            "enter-start": (classes) => {
              el._x_transition.enter.start = classes;
            },
            "enter-end": (classes) => {
              el._x_transition.enter.end = classes;
            },
            leave: (classes) => {
              el._x_transition.leave.during = classes;
            },
            "leave-start": (classes) => {
              el._x_transition.leave.start = classes;
            },
            "leave-end": (classes) => {
              el._x_transition.leave.end = classes;
            },
          };
          directiveStorageMap[stage](classString);
        }
        function registerTransitionsFromHelper(el, modifiers, stage) {
          registerTransitionObject(el, setStyles);
          let doesntSpecify =
            !modifiers.includes("in") && !modifiers.includes("out") && !stage;
          let transitioningIn =
            doesntSpecify ||
            modifiers.includes("in") ||
            ["enter"].includes(stage);
          let transitioningOut =
            doesntSpecify ||
            modifiers.includes("out") ||
            ["leave"].includes(stage);
          if (modifiers.includes("in") && !doesntSpecify) {
            modifiers = modifiers.filter(
              (i, index) => index < modifiers.indexOf("out")
            );
          }
          if (modifiers.includes("out") && !doesntSpecify) {
            modifiers = modifiers.filter(
              (i, index) => index > modifiers.indexOf("out")
            );
          }
          let wantsAll =
            !modifiers.includes("opacity") && !modifiers.includes("scale");
          let wantsOpacity = wantsAll || modifiers.includes("opacity");
          let wantsScale = wantsAll || modifiers.includes("scale");
          let opacityValue = wantsOpacity ? 0 : 1;
          let scaleValue = wantsScale
            ? modifierValue(modifiers, "scale", 95) / 100
            : 1;
          let delay = modifierValue(modifiers, "delay", 0) / 1e3;
          let origin = modifierValue(modifiers, "origin", "center");
          let property = "opacity, transform";
          let durationIn = modifierValue(modifiers, "duration", 150) / 1e3;
          let durationOut = modifierValue(modifiers, "duration", 75) / 1e3;
          let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
          if (transitioningIn) {
            el._x_transition.enter.during = {
              transformOrigin: origin,
              transitionDelay: `${delay}s`,
              transitionProperty: property,
              transitionDuration: `${durationIn}s`,
              transitionTimingFunction: easing,
            };
            el._x_transition.enter.start = {
              opacity: opacityValue,
              transform: `scale(${scaleValue})`,
            };
            el._x_transition.enter.end = {
              opacity: 1,
              transform: `scale(1)`,
            };
          }
          if (transitioningOut) {
            el._x_transition.leave.during = {
              transformOrigin: origin,
              transitionDelay: `${delay}s`,
              transitionProperty: property,
              transitionDuration: `${durationOut}s`,
              transitionTimingFunction: easing,
            };
            el._x_transition.leave.start = {
              opacity: 1,
              transform: `scale(1)`,
            };
            el._x_transition.leave.end = {
              opacity: opacityValue,
              transform: `scale(${scaleValue})`,
            };
          }
        }
        function registerTransitionObject(el, setFunction, defaultValue = {}) {
          if (!el._x_transition)
            el._x_transition = {
              enter: {
                during: defaultValue,
                start: defaultValue,
                end: defaultValue,
              },
              leave: {
                during: defaultValue,
                start: defaultValue,
                end: defaultValue,
              },
              in(before = () => {}, after = () => {}) {
                transition(
                  el,
                  setFunction,
                  {
                    during: this.enter.during,
                    start: this.enter.start,
                    end: this.enter.end,
                  },
                  before,
                  after
                );
              },
              out(before = () => {}, after = () => {}) {
                transition(
                  el,
                  setFunction,
                  {
                    during: this.leave.during,
                    start: this.leave.start,
                    end: this.leave.end,
                  },
                  before,
                  after
                );
              },
            };
        }
        window.Element.prototype._x_toggleAndCascadeWithTransitions = function (
          el,
          value,
          show,
          hide
        ) {
          const nextTick2 =
            document.visibilityState === "visible"
              ? requestAnimationFrame
              : setTimeout;
          let clickAwayCompatibleShow = () => nextTick2(show);
          if (value) {
            if (
              el._x_transition &&
              (el._x_transition.enter || el._x_transition.leave)
            ) {
              el._x_transition.enter &&
              (Object.entries(el._x_transition.enter.during).length ||
                Object.entries(el._x_transition.enter.start).length ||
                Object.entries(el._x_transition.enter.end).length)
                ? el._x_transition.in(show)
                : clickAwayCompatibleShow();
            } else {
              el._x_transition
                ? el._x_transition.in(show)
                : clickAwayCompatibleShow();
            }
            return;
          }
          el._x_hidePromise = el._x_transition
            ? new Promise((resolve, reject) => {
                el._x_transition.out(
                  () => {},
                  () => resolve(hide)
                );
                el._x_transitioning.beforeCancel(() =>
                  reject({ isFromCancelledTransition: true })
                );
              })
            : Promise.resolve(hide);
          queueMicrotask(() => {
            let closest = closestHide(el);
            if (closest) {
              if (!closest._x_hideChildren) closest._x_hideChildren = [];
              closest._x_hideChildren.push(el);
            } else {
              nextTick2(() => {
                let hideAfterChildren = (el2) => {
                  let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren),
                  ]).then(([i]) => i());
                  delete el2._x_hidePromise;
                  delete el2._x_hideChildren;
                  return carry;
                };
                hideAfterChildren(el).catch((e) => {
                  if (!e.isFromCancelledTransition) throw e;
                });
              });
            }
          });
        };
        function closestHide(el) {
          let parent = el.parentNode;
          if (!parent) return;
          return parent._x_hidePromise ? parent : closestHide(parent);
        }
        function transition(
          el,
          setFunction,
          { during, start: start2, end } = {},
          before = () => {},
          after = () => {}
        ) {
          if (el._x_transitioning) el._x_transitioning.cancel();
          if (
            Object.keys(during).length === 0 &&
            Object.keys(start2).length === 0 &&
            Object.keys(end).length === 0
          ) {
            before();
            after();
            return;
          }
          let undoStart, undoDuring, undoEnd;
          performTransition(el, {
            start() {
              undoStart = setFunction(el, start2);
            },
            during() {
              undoDuring = setFunction(el, during);
            },
            before,
            end() {
              undoStart();
              undoEnd = setFunction(el, end);
            },
            after,
            cleanup() {
              undoDuring();
              undoEnd();
            },
          });
        }
        function performTransition(el, stages) {
          let interrupted, reachedBefore, reachedEnd;
          let finish = once(() => {
            mutateDom(() => {
              interrupted = true;
              if (!reachedBefore) stages.before();
              if (!reachedEnd) {
                stages.end();
                releaseNextTicks();
              }
              stages.after();
              if (el.isConnected) stages.cleanup();
              delete el._x_transitioning;
            });
          });
          el._x_transitioning = {
            beforeCancels: [],
            beforeCancel(callback) {
              this.beforeCancels.push(callback);
            },
            cancel: once(function () {
              while (this.beforeCancels.length) {
                this.beforeCancels.shift()();
              }
              finish();
            }),
            finish,
          };
          mutateDom(() => {
            stages.start();
            stages.during();
          });
          holdNextTicks();
          requestAnimationFrame(() => {
            if (interrupted) return;
            let duration =
              Number(
                getComputedStyle(el)
                  .transitionDuration.replace(/,.*/, "")
                  .replace("s", "")
              ) * 1e3;
            let delay =
              Number(
                getComputedStyle(el)
                  .transitionDelay.replace(/,.*/, "")
                  .replace("s", "")
              ) * 1e3;
            if (duration === 0)
              duration =
                Number(
                  getComputedStyle(el).animationDuration.replace("s", "")
                ) * 1e3;
            mutateDom(() => {
              stages.before();
            });
            reachedBefore = true;
            requestAnimationFrame(() => {
              if (interrupted) return;
              mutateDom(() => {
                stages.end();
              });
              releaseNextTicks();
              setTimeout(el._x_transitioning.finish, duration + delay);
              reachedEnd = true;
            });
          });
        }
        function modifierValue(modifiers, key, fallback) {
          if (modifiers.indexOf(key) === -1) return fallback;
          const rawValue = modifiers[modifiers.indexOf(key) + 1];
          if (!rawValue) return fallback;
          if (key === "scale") {
            if (isNaN(rawValue)) return fallback;
          }
          if (key === "duration" || key === "delay") {
            let match = rawValue.match(/([0-9]+)ms/);
            if (match) return match[1];
          }
          if (key === "origin") {
            if (
              ["top", "right", "left", "center", "bottom"].includes(
                modifiers[modifiers.indexOf(key) + 2]
              )
            ) {
              return [rawValue, modifiers[modifiers.indexOf(key) + 2]].join(
                " "
              );
            }
          }
          return rawValue;
        }

        // packages/alpinejs/src/clone.js
        var isCloning = false;
        function skipDuringClone(callback, fallback = () => {}) {
          return (...args) =>
            isCloning ? fallback(...args) : callback(...args);
        }
        function onlyDuringClone(callback) {
          return (...args) => isCloning && callback(...args);
        }
        function cloneNode(from, to) {
          if (from._x_dataStack) {
            to._x_dataStack = from._x_dataStack;
            to.setAttribute("data-has-alpine-state", true);
          }
          isCloning = true;
          dontRegisterReactiveSideEffects(() => {
            initTree(to, (el, callback) => {
              callback(el, () => {});
            });
          });
          isCloning = false;
        }
        var isCloningLegacy = false;
        function clone(oldEl, newEl) {
          if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
          isCloning = true;
          isCloningLegacy = true;
          dontRegisterReactiveSideEffects(() => {
            cloneTree(newEl);
          });
          isCloning = false;
          isCloningLegacy = false;
        }
        function cloneTree(el) {
          let hasRunThroughFirstEl = false;
          let shallowWalker = (el2, callback) => {
            walk(el2, (el3, skip) => {
              if (hasRunThroughFirstEl && isRoot(el3)) return skip();
              hasRunThroughFirstEl = true;
              callback(el3, skip);
            });
          };
          initTree(el, shallowWalker);
        }
        function dontRegisterReactiveSideEffects(callback) {
          let cache = effect;
          overrideEffect((callback2, el) => {
            let storedEffect = cache(callback2);
            release(storedEffect);
            return () => {};
          });
          callback();
          overrideEffect(cache);
        }
        function shouldSkipRegisteringDataDuringClone(el) {
          if (!isCloning) return false;
          if (isCloningLegacy) return true;
          return el.hasAttribute("data-has-alpine-state");
        }

        // packages/alpinejs/src/utils/bind.js
        function bind(el, name, value, modifiers = []) {
          if (!el._x_bindings) el._x_bindings = reactive({});
          el._x_bindings[name] = value;
          name = modifiers.includes("camel") ? camelCase(name) : name;
          switch (name) {
            case "value":
              bindInputValue(el, value);
              break;
            case "style":
              bindStyles(el, value);
              break;
            case "class":
              bindClasses(el, value);
              break;
            case "selected":
            case "checked":
              bindAttributeAndProperty(el, name, value);
              break;
            default:
              bindAttribute(el, name, value);
              break;
          }
        }
        function bindInputValue(el, value) {
          if (el.type === "radio") {
            if (el.attributes.value === void 0) {
              el.value = value;
            }
            if (window.fromModel) {
              el.checked = checkedAttrLooseCompare(el.value, value);
            }
          } else if (el.type === "checkbox") {
            if (Number.isInteger(value)) {
              el.value = value;
            } else if (
              !Array.isArray(value) &&
              typeof value !== "boolean" &&
              ![null, void 0].includes(value)
            ) {
              el.value = String(value);
            } else {
              if (Array.isArray(value)) {
                el.checked = value.some((val) =>
                  checkedAttrLooseCompare(val, el.value)
                );
              } else {
                el.checked = !!value;
              }
            }
          } else if (el.tagName === "SELECT") {
            updateSelect(el, value);
          } else {
            if (el.value === value) return;
            el.value = value === void 0 ? "" : value;
          }
        }
        function bindClasses(el, value) {
          if (el._x_undoAddedClasses) el._x_undoAddedClasses();
          el._x_undoAddedClasses = setClasses(el, value);
        }
        function bindStyles(el, value) {
          if (el._x_undoAddedStyles) el._x_undoAddedStyles();
          el._x_undoAddedStyles = setStyles(el, value);
        }
        function bindAttributeAndProperty(el, name, value) {
          bindAttribute(el, name, value);
          setPropertyIfChanged(el, name, value);
        }
        function bindAttribute(el, name, value) {
          if (
            [null, void 0, false].includes(value) &&
            attributeShouldntBePreservedIfFalsy(name)
          ) {
            el.removeAttribute(name);
          } else {
            if (isBooleanAttr(name)) value = name;
            setIfChanged(el, name, value);
          }
        }
        function setIfChanged(el, attrName, value) {
          if (el.getAttribute(attrName) != value) {
            el.setAttribute(attrName, value);
          }
        }
        function setPropertyIfChanged(el, propName, value) {
          if (el[propName] !== value) {
            el[propName] = value;
          }
        }
        function updateSelect(el, value) {
          const arrayWrappedValue = [].concat(value).map((value2) => {
            return value2 + "";
          });
          Array.from(el.options).forEach((option) => {
            option.selected = arrayWrappedValue.includes(option.value);
          });
        }
        function camelCase(subject) {
          return subject
            .toLowerCase()
            .replace(/-(\w)/g, (match, char) => char.toUpperCase());
        }
        function checkedAttrLooseCompare(valueA, valueB) {
          return valueA == valueB;
        }
        function isBooleanAttr(attrName) {
          const booleanAttributes = [
            "disabled",
            "checked",
            "required",
            "readonly",
            "hidden",
            "open",
            "selected",
            "autofocus",
            "itemscope",
            "multiple",
            "novalidate",
            "allowfullscreen",
            "allowpaymentrequest",
            "formnovalidate",
            "autoplay",
            "controls",
            "loop",
            "muted",
            "playsinline",
            "default",
            "ismap",
            "reversed",
            "async",
            "defer",
            "nomodule",
          ];
          return booleanAttributes.includes(attrName);
        }
        function attributeShouldntBePreservedIfFalsy(name) {
          return ![
            "aria-pressed",
            "aria-checked",
            "aria-expanded",
            "aria-selected",
          ].includes(name);
        }
        function getBinding(el, name, fallback) {
          if (el._x_bindings && el._x_bindings[name] !== void 0)
            return el._x_bindings[name];
          return getAttributeBinding(el, name, fallback);
        }
        function extractProp(el, name, fallback, extract = true) {
          if (el._x_bindings && el._x_bindings[name] !== void 0)
            return el._x_bindings[name];
          if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
            let binding = el._x_inlineBindings[name];
            binding.extract = extract;
            return dontAutoEvaluateFunctions(() => {
              return evaluate(el, binding.expression);
            });
          }
          return getAttributeBinding(el, name, fallback);
        }
        function getAttributeBinding(el, name, fallback) {
          let attr = el.getAttribute(name);
          if (attr === null)
            return typeof fallback === "function" ? fallback() : fallback;
          if (attr === "") return true;
          if (isBooleanAttr(name)) {
            return !![name, "true"].includes(attr);
          }
          return attr;
        }

        // packages/alpinejs/src/utils/debounce.js
        function debounce(func, wait) {
          var timeout;
          return function () {
            var context = this,
              args = arguments;
            var later = function () {
              timeout = null;
              func.apply(context, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
          };
        }

        // packages/alpinejs/src/utils/throttle.js
        function throttle(func, limit) {
          let inThrottle;
          return function () {
            let context = this,
              args = arguments;
            if (!inThrottle) {
              func.apply(context, args);
              inThrottle = true;
              setTimeout(() => (inThrottle = false), limit);
            }
          };
        }

        // packages/alpinejs/src/entangle.js
        function entangle(
          { get: outerGet, set: outerSet },
          { get: innerGet, set: innerSet }
        ) {
          let firstRun = true;
          let outerHash;
          let reference = effect(() => {
            const outer = outerGet();
            const inner = innerGet();
            if (firstRun) {
              innerSet(cloneIfObject(outer));
              firstRun = false;
              outerHash = JSON.stringify(outer);
            } else {
              const outerHashLatest = JSON.stringify(outer);
              if (outerHashLatest !== outerHash) {
                innerSet(cloneIfObject(outer));
                outerHash = outerHashLatest;
              } else {
                outerSet(cloneIfObject(inner));
                outerHash = JSON.stringify(inner);
              }
            }
            JSON.stringify(innerGet());
            JSON.stringify(outerGet());
          });
          return () => {
            release(reference);
          };
        }
        function cloneIfObject(value) {
          return typeof value === "object"
            ? JSON.parse(JSON.stringify(value))
            : value;
        }

        // packages/alpinejs/src/plugin.js
        function plugin(callback) {
          let callbacks = Array.isArray(callback) ? callback : [callback];
          callbacks.forEach((i) => i(alpine_default));
        }

        // packages/alpinejs/src/store.js
        var stores = {};
        var isReactive = false;
        function store(name, value) {
          if (!isReactive) {
            stores = reactive(stores);
            isReactive = true;
          }
          if (value === void 0) {
            return stores[name];
          }
          stores[name] = value;
          if (
            typeof value === "object" &&
            value !== null &&
            value.hasOwnProperty("init") &&
            typeof value.init === "function"
          ) {
            stores[name].init();
          }
          initInterceptors2(stores[name]);
        }
        function getStores() {
          return stores;
        }

        // packages/alpinejs/src/binds.js
        var binds = {};
        function bind2(name, bindings) {
          let getBindings =
            typeof bindings !== "function" ? () => bindings : bindings;
          if (name instanceof Element) {
            return applyBindingsObject(name, getBindings());
          } else {
            binds[name] = getBindings;
          }
          return () => {};
        }
        function injectBindingProviders(obj) {
          Object.entries(binds).forEach(([name, callback]) => {
            Object.defineProperty(obj, name, {
              get() {
                return (...args) => {
                  return callback(...args);
                };
              },
            });
          });
          return obj;
        }
        function applyBindingsObject(el, obj, original) {
          let cleanupRunners = [];
          while (cleanupRunners.length) cleanupRunners.pop()();
          let attributes = Object.entries(obj).map(([name, value]) => ({
            name,
            value,
          }));
          let staticAttributes = attributesOnly(attributes);
          attributes = attributes.map((attribute) => {
            if (staticAttributes.find((attr) => attr.name === attribute.name)) {
              return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`,
              };
            }
            return attribute;
          });
          directives(el, attributes, original).map((handle) => {
            cleanupRunners.push(handle.runCleanups);
            handle();
          });
          return () => {
            while (cleanupRunners.length) cleanupRunners.pop()();
          };
        }

        // packages/alpinejs/src/datas.js
        var datas = {};
        function data(name, callback) {
          datas[name] = callback;
        }
        function injectDataProviders(obj, context) {
          Object.entries(datas).forEach(([name, callback]) => {
            Object.defineProperty(obj, name, {
              get() {
                return (...args) => {
                  return callback.bind(context)(...args);
                };
              },
              enumerable: false,
            });
          });
          return obj;
        }

        // packages/alpinejs/src/alpine.js
        var Alpine = {
          get reactive() {
            return reactive;
          },
          get release() {
            return release;
          },
          get effect() {
            return effect;
          },
          get raw() {
            return raw;
          },
          version: "3.13.2",
          flushAndStopDeferringMutations,
          dontAutoEvaluateFunctions,
          disableEffectScheduling,
          startObservingMutations,
          stopObservingMutations,
          setReactivityEngine,
          onAttributeRemoved,
          onAttributesAdded,
          closestDataStack,
          skipDuringClone,
          onlyDuringClone,
          addRootSelector,
          addInitSelector,
          addScopeToNode,
          deferMutations,
          mapAttributes,
          evaluateLater,
          interceptInit,
          setEvaluator,
          mergeProxies,
          extractProp,
          findClosest,
          onElRemoved,
          closestRoot,
          destroyTree,
          interceptor,
          // INTERNAL: not public API and is subject to change without major release.
          transition,
          // INTERNAL
          setStyles,
          // INTERNAL
          mutateDom,
          directive,
          entangle,
          throttle,
          debounce,
          evaluate,
          initTree,
          nextTick,
          prefixed: prefix,
          prefix: setPrefix,
          plugin,
          magic,
          store,
          start,
          clone,
          // INTERNAL
          cloneNode,
          // INTERNAL
          bound: getBinding,
          $data: scope,
          walk,
          data,
          bind: bind2,
        };
        var alpine_default = Alpine;

        // node_modules/@vue/shared/dist/shared.esm-bundler.js
        function makeMap(str, expectsLowerCase) {
          const map = /* @__PURE__ */ Object.create(null);
          const list = str.split(",");
          for (let i = 0; i < list.length; i++) {
            map[list[i]] = true;
          }
          return expectsLowerCase
            ? (val) => !!map[val.toLowerCase()]
            : (val) => !!map[val];
        }
        var specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
        var isBooleanAttr2 = /* @__PURE__ */ makeMap(
          specialBooleanAttrs +
            `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`
        );
        var EMPTY_OBJ = true ? Object.freeze({}) : 0;
        var EMPTY_ARR = true ? Object.freeze([]) : 0;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var hasOwn = (val, key) => hasOwnProperty.call(val, key);
        var isArray = Array.isArray;
        var isMap = (val) => toTypeString(val) === "[object Map]";
        var isString = (val) => typeof val === "string";
        var isSymbol = (val) => typeof val === "symbol";
        var isObject = (val) => val !== null && typeof val === "object";
        var objectToString = Object.prototype.toString;
        var toTypeString = (value) => objectToString.call(value);
        var toRawType = (value) => {
          return toTypeString(value).slice(8, -1);
        };
        var isIntegerKey = (key) =>
          isString(key) &&
          key !== "NaN" &&
          key[0] !== "-" &&
          "" + parseInt(key, 10) === key;
        var cacheStringFunction = (fn) => {
          const cache = /* @__PURE__ */ Object.create(null);
          return (str) => {
            const hit = cache[str];
            return hit || (cache[str] = fn(str));
          };
        };
        var camelizeRE = /-(\w)/g;
        var camelize = cacheStringFunction((str) => {
          return str.replace(camelizeRE, (_, c) => (c ? c.toUpperCase() : ""));
        });
        var hyphenateRE = /\B([A-Z])/g;
        var hyphenate = cacheStringFunction((str) =>
          str.replace(hyphenateRE, "-$1").toLowerCase()
        );
        var capitalize = cacheStringFunction(
          (str) => str.charAt(0).toUpperCase() + str.slice(1)
        );
        var toHandlerKey = cacheStringFunction((str) =>
          str ? `on${capitalize(str)}` : ``
        );
        var hasChanged = (value, oldValue) =>
          value !== oldValue && (value === value || oldValue === oldValue);

        // node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
        var targetMap = /* @__PURE__ */ new WeakMap();
        var effectStack = [];
        var activeEffect;
        var ITERATE_KEY = Symbol(true ? "iterate" : 0);
        var MAP_KEY_ITERATE_KEY = Symbol(true ? "Map key iterate" : 0);
        function isEffect(fn) {
          return fn && fn._isEffect === true;
        }
        function effect2(fn, options = EMPTY_OBJ) {
          if (isEffect(fn)) {
            fn = fn.raw;
          }
          const effect3 = createReactiveEffect(fn, options);
          if (!options.lazy) {
            effect3();
          }
          return effect3;
        }
        function stop(effect3) {
          if (effect3.active) {
            cleanup(effect3);
            if (effect3.options.onStop) {
              effect3.options.onStop();
            }
            effect3.active = false;
          }
        }
        var uid = 0;
        function createReactiveEffect(fn, options) {
          const effect3 = function reactiveEffect() {
            if (!effect3.active) {
              return fn();
            }
            if (!effectStack.includes(effect3)) {
              cleanup(effect3);
              try {
                enableTracking();
                effectStack.push(effect3);
                activeEffect = effect3;
                return fn();
              } finally {
                effectStack.pop();
                resetTracking();
                activeEffect = effectStack[effectStack.length - 1];
              }
            }
          };
          effect3.id = uid++;
          effect3.allowRecurse = !!options.allowRecurse;
          effect3._isEffect = true;
          effect3.active = true;
          effect3.raw = fn;
          effect3.deps = [];
          effect3.options = options;
          return effect3;
        }
        function cleanup(effect3) {
          const { deps } = effect3;
          if (deps.length) {
            for (let i = 0; i < deps.length; i++) {
              deps[i].delete(effect3);
            }
            deps.length = 0;
          }
        }
        var shouldTrack = true;
        var trackStack = [];
        function pauseTracking() {
          trackStack.push(shouldTrack);
          shouldTrack = false;
        }
        function enableTracking() {
          trackStack.push(shouldTrack);
          shouldTrack = true;
        }
        function resetTracking() {
          const last = trackStack.pop();
          shouldTrack = last === void 0 ? true : last;
        }
        function track(target, type, key) {
          if (!shouldTrack || activeEffect === void 0) {
            return;
          }
          let depsMap = targetMap.get(target);
          if (!depsMap) {
            targetMap.set(target, (depsMap = /* @__PURE__ */ new Map()));
          }
          let dep = depsMap.get(key);
          if (!dep) {
            depsMap.set(key, (dep = /* @__PURE__ */ new Set()));
          }
          if (!dep.has(activeEffect)) {
            dep.add(activeEffect);
            activeEffect.deps.push(dep);
            if (activeEffect.options.onTrack) {
              activeEffect.options.onTrack({
                effect: activeEffect,
                target,
                type,
                key,
              });
            }
          }
        }
        function trigger(target, type, key, newValue, oldValue, oldTarget) {
          const depsMap = targetMap.get(target);
          if (!depsMap) {
            return;
          }
          const effects = /* @__PURE__ */ new Set();
          const add2 = (effectsToAdd) => {
            if (effectsToAdd) {
              effectsToAdd.forEach((effect3) => {
                if (effect3 !== activeEffect || effect3.allowRecurse) {
                  effects.add(effect3);
                }
              });
            }
          };
          if (type === "clear") {
            depsMap.forEach(add2);
          } else if (key === "length" && isArray(target)) {
            depsMap.forEach((dep, key2) => {
              if (key2 === "length" || key2 >= newValue) {
                add2(dep);
              }
            });
          } else {
            if (key !== void 0) {
              add2(depsMap.get(key));
            }
            switch (type) {
              case "add":
                if (!isArray(target)) {
                  add2(depsMap.get(ITERATE_KEY));
                  if (isMap(target)) {
                    add2(depsMap.get(MAP_KEY_ITERATE_KEY));
                  }
                } else if (isIntegerKey(key)) {
                  add2(depsMap.get("length"));
                }
                break;
              case "delete":
                if (!isArray(target)) {
                  add2(depsMap.get(ITERATE_KEY));
                  if (isMap(target)) {
                    add2(depsMap.get(MAP_KEY_ITERATE_KEY));
                  }
                }
                break;
              case "set":
                if (isMap(target)) {
                  add2(depsMap.get(ITERATE_KEY));
                }
                break;
            }
          }
          const run = (effect3) => {
            if (effect3.options.onTrigger) {
              effect3.options.onTrigger({
                effect: effect3,
                target,
                key,
                type,
                newValue,
                oldValue,
                oldTarget,
              });
            }
            if (effect3.options.scheduler) {
              effect3.options.scheduler(effect3);
            } else {
              effect3();
            }
          };
          effects.forEach(run);
        }
        var isNonTrackableKeys = /* @__PURE__ */ makeMap(
          `__proto__,__v_isRef,__isVue`
        );
        var builtInSymbols = new Set(
          Object.getOwnPropertyNames(Symbol)
            .map((key) => Symbol[key])
            .filter(isSymbol)
        );
        var get2 = /* @__PURE__ */ createGetter();
        var readonlyGet = /* @__PURE__ */ createGetter(true);
        var arrayInstrumentations =
          /* @__PURE__ */ createArrayInstrumentations();
        function createArrayInstrumentations() {
          const instrumentations = {};
          ["includes", "indexOf", "lastIndexOf"].forEach((key) => {
            instrumentations[key] = function (...args) {
              const arr = toRaw(this);
              for (let i = 0, l = this.length; i < l; i++) {
                track(arr, "get", i + "");
              }
              const res = arr[key](...args);
              if (res === -1 || res === false) {
                return arr[key](...args.map(toRaw));
              } else {
                return res;
              }
            };
          });
          ["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
            instrumentations[key] = function (...args) {
              pauseTracking();
              const res = toRaw(this)[key].apply(this, args);
              resetTracking();
              return res;
            };
          });
          return instrumentations;
        }
        function createGetter(isReadonly = false, shallow = false) {
          return function get3(target, key, receiver) {
            if (key === "__v_isReactive") {
              return !isReadonly;
            } else if (key === "__v_isReadonly") {
              return isReadonly;
            } else if (
              key === "__v_raw" &&
              receiver ===
                (isReadonly
                  ? shallow
                    ? shallowReadonlyMap
                    : readonlyMap
                  : shallow
                  ? shallowReactiveMap
                  : reactiveMap
                ).get(target)
            ) {
              return target;
            }
            const targetIsArray = isArray(target);
            if (
              !isReadonly &&
              targetIsArray &&
              hasOwn(arrayInstrumentations, key)
            ) {
              return Reflect.get(arrayInstrumentations, key, receiver);
            }
            const res = Reflect.get(target, key, receiver);
            if (
              isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)
            ) {
              return res;
            }
            if (!isReadonly) {
              track(target, "get", key);
            }
            if (shallow) {
              return res;
            }
            if (isRef(res)) {
              const shouldUnwrap = !targetIsArray || !isIntegerKey(key);
              return shouldUnwrap ? res.value : res;
            }
            if (isObject(res)) {
              return isReadonly ? readonly(res) : reactive2(res);
            }
            return res;
          };
        }
        var set2 = /* @__PURE__ */ createSetter();
        function createSetter(shallow = false) {
          return function set3(target, key, value, receiver) {
            let oldValue = target[key];
            if (!shallow) {
              value = toRaw(value);
              oldValue = toRaw(oldValue);
              if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
                oldValue.value = value;
                return true;
              }
            }
            const hadKey =
              isArray(target) && isIntegerKey(key)
                ? Number(key) < target.length
                : hasOwn(target, key);
            const result = Reflect.set(target, key, value, receiver);
            if (target === toRaw(receiver)) {
              if (!hadKey) {
                trigger(target, "add", key, value);
              } else if (hasChanged(value, oldValue)) {
                trigger(target, "set", key, value, oldValue);
              }
            }
            return result;
          };
        }
        function deleteProperty(target, key) {
          const hadKey = hasOwn(target, key);
          const oldValue = target[key];
          const result = Reflect.deleteProperty(target, key);
          if (result && hadKey) {
            trigger(target, "delete", key, void 0, oldValue);
          }
          return result;
        }
        function has(target, key) {
          const result = Reflect.has(target, key);
          if (!isSymbol(key) || !builtInSymbols.has(key)) {
            track(target, "has", key);
          }
          return result;
        }
        function ownKeys(target) {
          track(target, "iterate", isArray(target) ? "length" : ITERATE_KEY);
          return Reflect.ownKeys(target);
        }
        var mutableHandlers = {
          get: get2,
          set: set2,
          deleteProperty,
          has,
          ownKeys,
        };
        var readonlyHandlers = {
          get: readonlyGet,
          set(target, key) {
            if (true) {
              console.warn(
                `Set operation on key "${String(
                  key
                )}" failed: target is readonly.`,
                target
              );
            }
            return true;
          },
          deleteProperty(target, key) {
            if (true) {
              console.warn(
                `Delete operation on key "${String(
                  key
                )}" failed: target is readonly.`,
                target
              );
            }
            return true;
          },
        };
        var toReactive = (value) =>
          isObject(value) ? reactive2(value) : value;
        var toReadonly = (value) => (isObject(value) ? readonly(value) : value);
        var toShallow = (value) => value;
        var getProto = (v) => Reflect.getPrototypeOf(v);
        function get$1(target, key, isReadonly = false, isShallow = false) {
          target =
            target[
              "__v_raw"
              /* RAW */
            ];
          const rawTarget = toRaw(target);
          const rawKey = toRaw(key);
          if (key !== rawKey) {
            !isReadonly && track(rawTarget, "get", key);
          }
          !isReadonly && track(rawTarget, "get", rawKey);
          const { has: has2 } = getProto(rawTarget);
          const wrap = isShallow
            ? toShallow
            : isReadonly
            ? toReadonly
            : toReactive;
          if (has2.call(rawTarget, key)) {
            return wrap(target.get(key));
          } else if (has2.call(rawTarget, rawKey)) {
            return wrap(target.get(rawKey));
          } else if (target !== rawTarget) {
            target.get(key);
          }
        }
        function has$1(key, isReadonly = false) {
          const target =
            this[
              "__v_raw"
              /* RAW */
            ];
          const rawTarget = toRaw(target);
          const rawKey = toRaw(key);
          if (key !== rawKey) {
            !isReadonly && track(rawTarget, "has", key);
          }
          !isReadonly && track(rawTarget, "has", rawKey);
          return key === rawKey
            ? target.has(key)
            : target.has(key) || target.has(rawKey);
        }
        function size(target, isReadonly = false) {
          target =
            target[
              "__v_raw"
              /* RAW */
            ];
          !isReadonly && track(toRaw(target), "iterate", ITERATE_KEY);
          return Reflect.get(target, "size", target);
        }
        function add(value) {
          value = toRaw(value);
          const target = toRaw(this);
          const proto = getProto(target);
          const hadKey = proto.has.call(target, value);
          if (!hadKey) {
            target.add(value);
            trigger(target, "add", value, value);
          }
          return this;
        }
        function set$1(key, value) {
          value = toRaw(value);
          const target = toRaw(this);
          const { has: has2, get: get3 } = getProto(target);
          let hadKey = has2.call(target, key);
          if (!hadKey) {
            key = toRaw(key);
            hadKey = has2.call(target, key);
          } else if (true) {
            checkIdentityKeys(target, has2, key);
          }
          const oldValue = get3.call(target, key);
          target.set(key, value);
          if (!hadKey) {
            trigger(target, "add", key, value);
          } else if (hasChanged(value, oldValue)) {
            trigger(target, "set", key, value, oldValue);
          }
          return this;
        }
        function deleteEntry(key) {
          const target = toRaw(this);
          const { has: has2, get: get3 } = getProto(target);
          let hadKey = has2.call(target, key);
          if (!hadKey) {
            key = toRaw(key);
            hadKey = has2.call(target, key);
          } else if (true) {
            checkIdentityKeys(target, has2, key);
          }
          const oldValue = get3 ? get3.call(target, key) : void 0;
          const result = target.delete(key);
          if (hadKey) {
            trigger(target, "delete", key, void 0, oldValue);
          }
          return result;
        }
        function clear() {
          const target = toRaw(this);
          const hadItems = target.size !== 0;
          const oldTarget = true
            ? isMap(target)
              ? new Map(target)
              : new Set(target)
            : 0;
          const result = target.clear();
          if (hadItems) {
            trigger(target, "clear", void 0, void 0, oldTarget);
          }
          return result;
        }
        function createForEach(isReadonly, isShallow) {
          return function forEach(callback, thisArg) {
            const observed = this;
            const target =
              observed[
                "__v_raw"
                /* RAW */
              ];
            const rawTarget = toRaw(target);
            const wrap = isShallow
              ? toShallow
              : isReadonly
              ? toReadonly
              : toReactive;
            !isReadonly && track(rawTarget, "iterate", ITERATE_KEY);
            return target.forEach((value, key) => {
              return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
          };
        }
        function createIterableMethod(method, isReadonly, isShallow) {
          return function (...args) {
            const target =
              this[
                "__v_raw"
                /* RAW */
              ];
            const rawTarget = toRaw(target);
            const targetIsMap = isMap(rawTarget);
            const isPair =
              method === "entries" ||
              (method === Symbol.iterator && targetIsMap);
            const isKeyOnly = method === "keys" && targetIsMap;
            const innerIterator = target[method](...args);
            const wrap = isShallow
              ? toShallow
              : isReadonly
              ? toReadonly
              : toReactive;
            !isReadonly &&
              track(
                rawTarget,
                "iterate",
                isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY
              );
            return {
              // iterator protocol
              next() {
                const { value, done } = innerIterator.next();
                return done
                  ? { value, done }
                  : {
                      value: isPair
                        ? [wrap(value[0]), wrap(value[1])]
                        : wrap(value),
                      done,
                    };
              },
              // iterable protocol
              [Symbol.iterator]() {
                return this;
              },
            };
          };
        }
        function createReadonlyMethod(type) {
          return function (...args) {
            if (true) {
              const key = args[0] ? `on key "${args[0]}" ` : ``;
              console.warn(
                `${capitalize(
                  type
                )} operation ${key}failed: target is readonly.`,
                toRaw(this)
              );
            }
            return type === "delete" ? false : this;
          };
        }
        function createInstrumentations() {
          const mutableInstrumentations2 = {
            get(key) {
              return get$1(this, key);
            },
            get size() {
              return size(this);
            },
            has: has$1,
            add,
            set: set$1,
            delete: deleteEntry,
            clear,
            forEach: createForEach(false, false),
          };
          const shallowInstrumentations2 = {
            get(key) {
              return get$1(this, key, false, true);
            },
            get size() {
              return size(this);
            },
            has: has$1,
            add,
            set: set$1,
            delete: deleteEntry,
            clear,
            forEach: createForEach(false, true),
          };
          const readonlyInstrumentations2 = {
            get(key) {
              return get$1(this, key, true);
            },
            get size() {
              return size(this, true);
            },
            has(key) {
              return has$1.call(this, key, true);
            },
            add: createReadonlyMethod(
              "add"
              /* ADD */
            ),
            set: createReadonlyMethod(
              "set"
              /* SET */
            ),
            delete: createReadonlyMethod(
              "delete"
              /* DELETE */
            ),
            clear: createReadonlyMethod(
              "clear"
              /* CLEAR */
            ),
            forEach: createForEach(true, false),
          };
          const shallowReadonlyInstrumentations2 = {
            get(key) {
              return get$1(this, key, true, true);
            },
            get size() {
              return size(this, true);
            },
            has(key) {
              return has$1.call(this, key, true);
            },
            add: createReadonlyMethod(
              "add"
              /* ADD */
            ),
            set: createReadonlyMethod(
              "set"
              /* SET */
            ),
            delete: createReadonlyMethod(
              "delete"
              /* DELETE */
            ),
            clear: createReadonlyMethod(
              "clear"
              /* CLEAR */
            ),
            forEach: createForEach(true, true),
          };
          const iteratorMethods = [
            "keys",
            "values",
            "entries",
            Symbol.iterator,
          ];
          iteratorMethods.forEach((method) => {
            mutableInstrumentations2[method] = createIterableMethod(
              method,
              false,
              false
            );
            readonlyInstrumentations2[method] = createIterableMethod(
              method,
              true,
              false
            );
            shallowInstrumentations2[method] = createIterableMethod(
              method,
              false,
              true
            );
            shallowReadonlyInstrumentations2[method] = createIterableMethod(
              method,
              true,
              true
            );
          });
          return [
            mutableInstrumentations2,
            readonlyInstrumentations2,
            shallowInstrumentations2,
            shallowReadonlyInstrumentations2,
          ];
        }
        var [
          mutableInstrumentations,
          readonlyInstrumentations,
          shallowInstrumentations,
          shallowReadonlyInstrumentations,
        ] = /* @__PURE__ */ createInstrumentations();
        function createInstrumentationGetter(isReadonly, shallow) {
          const instrumentations = shallow
            ? isReadonly
              ? shallowReadonlyInstrumentations
              : shallowInstrumentations
            : isReadonly
            ? readonlyInstrumentations
            : mutableInstrumentations;
          return (target, key, receiver) => {
            if (key === "__v_isReactive") {
              return !isReadonly;
            } else if (key === "__v_isReadonly") {
              return isReadonly;
            } else if (key === "__v_raw") {
              return target;
            }
            return Reflect.get(
              hasOwn(instrumentations, key) && key in target
                ? instrumentations
                : target,
              key,
              receiver
            );
          };
        }
        var mutableCollectionHandlers = {
          get: /* @__PURE__ */ createInstrumentationGetter(false, false),
        };
        var readonlyCollectionHandlers = {
          get: /* @__PURE__ */ createInstrumentationGetter(true, false),
        };
        function checkIdentityKeys(target, has2, key) {
          const rawKey = toRaw(key);
          if (rawKey !== key && has2.call(target, rawKey)) {
            const type = toRawType(target);
            console.warn(
              `Reactive ${type} contains both the raw and reactive versions of the same object${
                type === `Map` ? ` as keys` : ``
              }, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
            );
          }
        }
        var reactiveMap = /* @__PURE__ */ new WeakMap();
        var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
        var readonlyMap = /* @__PURE__ */ new WeakMap();
        var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
        function targetTypeMap(rawType) {
          switch (rawType) {
            case "Object":
            case "Array":
              return 1;
            case "Map":
            case "Set":
            case "WeakMap":
            case "WeakSet":
              return 2;
            default:
              return 0;
          }
        }
        function getTargetType(value) {
          return value[
            "__v_skip"
            /* SKIP */
          ] || !Object.isExtensible(value)
            ? 0
            : targetTypeMap(toRawType(value));
        }
        function reactive2(target) {
          if (
            target &&
            target[
              "__v_isReadonly"
              /* IS_READONLY */
            ]
          ) {
            return target;
          }
          return createReactiveObject(
            target,
            false,
            mutableHandlers,
            mutableCollectionHandlers,
            reactiveMap
          );
        }
        function readonly(target) {
          return createReactiveObject(
            target,
            true,
            readonlyHandlers,
            readonlyCollectionHandlers,
            readonlyMap
          );
        }
        function createReactiveObject(
          target,
          isReadonly,
          baseHandlers,
          collectionHandlers,
          proxyMap
        ) {
          if (!isObject(target)) {
            if (true) {
              console.warn(`value cannot be made reactive: ${String(target)}`);
            }
            return target;
          }
          if (
            target[
              "__v_raw"
              /* RAW */
            ] &&
            !(
              isReadonly &&
              target[
                "__v_isReactive"
                /* IS_REACTIVE */
              ]
            )
          ) {
            return target;
          }
          const existingProxy = proxyMap.get(target);
          if (existingProxy) {
            return existingProxy;
          }
          const targetType = getTargetType(target);
          if (targetType === 0) {
            return target;
          }
          const proxy = new Proxy(
            target,
            targetType === 2 ? collectionHandlers : baseHandlers
          );
          proxyMap.set(target, proxy);
          return proxy;
        }
        function toRaw(observed) {
          return (
            (observed &&
              toRaw(
                observed[
                  "__v_raw"
                  /* RAW */
                ]
              )) ||
            observed
          );
        }
        function isRef(r) {
          return Boolean(r && r.__v_isRef === true);
        }

        // packages/alpinejs/src/magics/$nextTick.js
        magic("nextTick", () => nextTick);

        // packages/alpinejs/src/magics/$dispatch.js
        magic("dispatch", (el) => dispatch.bind(dispatch, el));

        // packages/alpinejs/src/magics/$watch.js
        magic(
          "watch",
          (el, { evaluateLater: evaluateLater2, effect: effect3 }) =>
            (key, callback) => {
              let evaluate2 = evaluateLater2(key);
              let firstTime = true;
              let oldValue;
              let effectReference = effect3(() =>
                evaluate2((value) => {
                  JSON.stringify(value);
                  if (!firstTime) {
                    queueMicrotask(() => {
                      callback(value, oldValue);
                      oldValue = value;
                    });
                  } else {
                    oldValue = value;
                  }
                  firstTime = false;
                })
              );
              el._x_effects.delete(effectReference);
            }
        );

        // packages/alpinejs/src/magics/$store.js
        magic("store", getStores);

        // packages/alpinejs/src/magics/$data.js
        magic("data", (el) => scope(el));

        // packages/alpinejs/src/magics/$root.js
        magic("root", (el) => closestRoot(el));

        // packages/alpinejs/src/magics/$refs.js
        magic("refs", (el) => {
          if (el._x_refs_proxy) return el._x_refs_proxy;
          el._x_refs_proxy = mergeProxies(getArrayOfRefObject(el));
          return el._x_refs_proxy;
        });
        function getArrayOfRefObject(el) {
          let refObjects = [];
          let currentEl = el;
          while (currentEl) {
            if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
            currentEl = currentEl.parentNode;
          }
          return refObjects;
        }

        // packages/alpinejs/src/ids.js
        var globalIdMemo = {};
        function findAndIncrementId(name) {
          if (!globalIdMemo[name]) globalIdMemo[name] = 0;
          return ++globalIdMemo[name];
        }
        function closestIdRoot(el, name) {
          return findClosest(el, (element) => {
            if (element._x_ids && element._x_ids[name]) return true;
          });
        }
        function setIdRoot(el, name) {
          if (!el._x_ids) el._x_ids = {};
          if (!el._x_ids[name]) el._x_ids[name] = findAndIncrementId(name);
        }

        // packages/alpinejs/src/magics/$id.js
        magic("id", (el) => (name, key = null) => {
          let root = closestIdRoot(el, name);
          let id = root ? root._x_ids[name] : findAndIncrementId(name);
          return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });

        // packages/alpinejs/src/magics/$el.js
        magic("el", (el) => el);

        // packages/alpinejs/src/magics/index.js
        warnMissingPluginMagic("Focus", "focus", "focus");
        warnMissingPluginMagic("Persist", "persist", "persist");
        function warnMissingPluginMagic(name, magicName, slug) {
          magic(magicName, (el) =>
            warn(
              `You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`,
              el
            )
          );
        }

        // packages/alpinejs/src/directives/x-modelable.js
        directive(
          "modelable",
          (
            el,
            { expression },
            {
              effect: effect3,
              evaluateLater: evaluateLater2,
              cleanup: cleanup2,
            }
          ) => {
            let func = evaluateLater2(expression);
            let innerGet = () => {
              let result;
              func((i) => (result = i));
              return result;
            };
            let evaluateInnerSet = evaluateLater2(
              `${expression} = __placeholder`
            );
            let innerSet = (val) =>
              evaluateInnerSet(() => {}, { scope: { __placeholder: val } });
            let initialValue = innerGet();
            innerSet(initialValue);
            queueMicrotask(() => {
              if (!el._x_model) return;
              el._x_removeModelListeners["default"]();
              let outerGet = el._x_model.get;
              let outerSet = el._x_model.set;
              let releaseEntanglement = entangle(
                {
                  get() {
                    return outerGet();
                  },
                  set(value) {
                    outerSet(value);
                  },
                },
                {
                  get() {
                    return innerGet();
                  },
                  set(value) {
                    innerSet(value);
                  },
                }
              );
              cleanup2(releaseEntanglement);
            });
          }
        );

        // packages/alpinejs/src/directives/x-teleport.js
        directive(
          "teleport",
          (el, { modifiers, expression }, { cleanup: cleanup2 }) => {
            if (el.tagName.toLowerCase() !== "template")
              warn("x-teleport can only be used on a <template> tag", el);
            let target = getTarget(expression);
            let clone2 = el.content.cloneNode(true).firstElementChild;
            el._x_teleport = clone2;
            clone2._x_teleportBack = el;
            el.setAttribute("data-teleport-template", true);
            clone2.setAttribute("data-teleport-target", true);
            if (el._x_forwardEvents) {
              el._x_forwardEvents.forEach((eventName) => {
                clone2.addEventListener(eventName, (e) => {
                  e.stopPropagation();
                  el.dispatchEvent(new e.constructor(e.type, e));
                });
              });
            }
            addScopeToNode(clone2, {}, el);
            let placeInDom = (clone3, target2, modifiers2) => {
              if (modifiers2.includes("prepend")) {
                target2.parentNode.insertBefore(clone3, target2);
              } else if (modifiers2.includes("append")) {
                target2.parentNode.insertBefore(clone3, target2.nextSibling);
              } else {
                target2.appendChild(clone3);
              }
            };
            mutateDom(() => {
              placeInDom(clone2, target, modifiers);
              initTree(clone2);
              clone2._x_ignore = true;
            });
            el._x_teleportPutBack = () => {
              let target2 = getTarget(expression);
              mutateDom(() => {
                placeInDom(el._x_teleport, target2, modifiers);
              });
            };
            cleanup2(() => clone2.remove());
          }
        );
        var teleportContainerDuringClone = document.createElement("div");
        function getTarget(expression) {
          let target = skipDuringClone(
            () => {
              return document.querySelector(expression);
            },
            () => {
              return teleportContainerDuringClone;
            }
          )();
          if (!target)
            warn(
              `Cannot find x-teleport element for selector: "${expression}"`
            );
          return target;
        }

        // packages/alpinejs/src/directives/x-ignore.js
        var handler = () => {};
        handler.inline = (el, { modifiers }, { cleanup: cleanup2 }) => {
          modifiers.includes("self")
            ? (el._x_ignoreSelf = true)
            : (el._x_ignore = true);
          cleanup2(() => {
            modifiers.includes("self")
              ? delete el._x_ignoreSelf
              : delete el._x_ignore;
          });
        };
        directive("ignore", handler);

        // packages/alpinejs/src/directives/x-effect.js
        directive("effect", (el, { expression }, { effect: effect3 }) =>
          effect3(evaluateLater(el, expression))
        );

        // packages/alpinejs/src/utils/on.js
        function on(el, event, modifiers, callback) {
          let listenerTarget = el;
          let handler4 = (e) => callback(e);
          let options = {};
          let wrapHandler = (callback2, wrapper) => (e) =>
            wrapper(callback2, e);
          if (modifiers.includes("dot")) event = dotSyntax(event);
          if (modifiers.includes("camel")) event = camelCase2(event);
          if (modifiers.includes("passive")) options.passive = true;
          if (modifiers.includes("capture")) options.capture = true;
          if (modifiers.includes("window")) listenerTarget = window;
          if (modifiers.includes("document")) listenerTarget = document;
          if (modifiers.includes("debounce")) {
            let nextModifier =
              modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
            let wait = isNumeric(nextModifier.split("ms")[0])
              ? Number(nextModifier.split("ms")[0])
              : 250;
            handler4 = debounce(handler4, wait);
          }
          if (modifiers.includes("throttle")) {
            let nextModifier =
              modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
            let wait = isNumeric(nextModifier.split("ms")[0])
              ? Number(nextModifier.split("ms")[0])
              : 250;
            handler4 = throttle(handler4, wait);
          }
          if (modifiers.includes("prevent"))
            handler4 = wrapHandler(handler4, (next, e) => {
              e.preventDefault();
              next(e);
            });
          if (modifiers.includes("stop"))
            handler4 = wrapHandler(handler4, (next, e) => {
              e.stopPropagation();
              next(e);
            });
          if (modifiers.includes("self"))
            handler4 = wrapHandler(handler4, (next, e) => {
              e.target === el && next(e);
            });
          if (modifiers.includes("away") || modifiers.includes("outside")) {
            listenerTarget = document;
            handler4 = wrapHandler(handler4, (next, e) => {
              if (el.contains(e.target)) return;
              if (e.target.isConnected === false) return;
              if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
              if (el._x_isShown === false) return;
              next(e);
            });
          }
          if (modifiers.includes("once")) {
            handler4 = wrapHandler(handler4, (next, e) => {
              next(e);
              listenerTarget.removeEventListener(event, handler4, options);
            });
          }
          handler4 = wrapHandler(handler4, (next, e) => {
            if (isKeyEvent(event)) {
              if (
                isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)
              ) {
                return;
              }
            }
            next(e);
          });
          listenerTarget.addEventListener(event, handler4, options);
          return () => {
            listenerTarget.removeEventListener(event, handler4, options);
          };
        }
        function dotSyntax(subject) {
          return subject.replace(/-/g, ".");
        }
        function camelCase2(subject) {
          return subject
            .toLowerCase()
            .replace(/-(\w)/g, (match, char) => char.toUpperCase());
        }
        function isNumeric(subject) {
          return !Array.isArray(subject) && !isNaN(subject);
        }
        function kebabCase2(subject) {
          if ([" ", "_"].includes(subject)) return subject;
          return subject
            .replace(/([a-z])([A-Z])/g, "$1-$2")
            .replace(/[_\s]/, "-")
            .toLowerCase();
        }
        function isKeyEvent(event) {
          return ["keydown", "keyup"].includes(event);
        }
        function isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
          let keyModifiers = modifiers.filter((i) => {
            return ![
              "window",
              "document",
              "prevent",
              "stop",
              "once",
              "capture",
            ].includes(i);
          });
          if (keyModifiers.includes("debounce")) {
            let debounceIndex = keyModifiers.indexOf("debounce");
            keyModifiers.splice(
              debounceIndex,
              isNumeric(
                (keyModifiers[debounceIndex + 1] || "invalid-wait").split(
                  "ms"
                )[0]
              )
                ? 2
                : 1
            );
          }
          if (keyModifiers.includes("throttle")) {
            let debounceIndex = keyModifiers.indexOf("throttle");
            keyModifiers.splice(
              debounceIndex,
              isNumeric(
                (keyModifiers[debounceIndex + 1] || "invalid-wait").split(
                  "ms"
                )[0]
              )
                ? 2
                : 1
            );
          }
          if (keyModifiers.length === 0) return false;
          if (
            keyModifiers.length === 1 &&
            keyToModifiers(e.key).includes(keyModifiers[0])
          )
            return false;
          const systemKeyModifiers = [
            "ctrl",
            "shift",
            "alt",
            "meta",
            "cmd",
            "super",
          ];
          const selectedSystemKeyModifiers = systemKeyModifiers.filter(
            (modifier) => keyModifiers.includes(modifier)
          );
          keyModifiers = keyModifiers.filter(
            (i) => !selectedSystemKeyModifiers.includes(i)
          );
          if (selectedSystemKeyModifiers.length > 0) {
            const activelyPressedKeyModifiers =
              selectedSystemKeyModifiers.filter((modifier) => {
                if (modifier === "cmd" || modifier === "super")
                  modifier = "meta";
                return e[`${modifier}Key`];
              });
            if (
              activelyPressedKeyModifiers.length ===
              selectedSystemKeyModifiers.length
            ) {
              if (keyToModifiers(e.key).includes(keyModifiers[0])) return false;
            }
          }
          return true;
        }
        function keyToModifiers(key) {
          if (!key) return [];
          key = kebabCase2(key);
          let modifierToKeyMap = {
            ctrl: "control",
            slash: "/",
            space: " ",
            spacebar: " ",
            cmd: "meta",
            esc: "escape",
            up: "arrow-up",
            down: "arrow-down",
            left: "arrow-left",
            right: "arrow-right",
            period: ".",
            equal: "=",
            minus: "-",
            underscore: "_",
          };
          modifierToKeyMap[key] = key;
          return Object.keys(modifierToKeyMap)
            .map((modifier) => {
              if (modifierToKeyMap[modifier] === key) return modifier;
            })
            .filter((modifier) => modifier);
        }

        // packages/alpinejs/src/directives/x-model.js
        directive(
          "model",
          (
            el,
            { modifiers, expression },
            { effect: effect3, cleanup: cleanup2 }
          ) => {
            let scopeTarget = el;
            if (modifiers.includes("parent")) {
              scopeTarget = el.parentNode;
            }
            let evaluateGet = evaluateLater(scopeTarget, expression);
            let evaluateSet;
            if (typeof expression === "string") {
              evaluateSet = evaluateLater(
                scopeTarget,
                `${expression} = __placeholder`
              );
            } else if (
              typeof expression === "function" &&
              typeof expression() === "string"
            ) {
              evaluateSet = evaluateLater(
                scopeTarget,
                `${expression()} = __placeholder`
              );
            } else {
              evaluateSet = () => {};
            }
            let getValue = () => {
              let result;
              evaluateGet((value) => (result = value));
              return isGetterSetter(result) ? result.get() : result;
            };
            let setValue = (value) => {
              let result;
              evaluateGet((value2) => (result = value2));
              if (isGetterSetter(result)) {
                result.set(value);
              } else {
                evaluateSet(() => {}, {
                  scope: { __placeholder: value },
                });
              }
            };
            if (typeof expression === "string" && el.type === "radio") {
              mutateDom(() => {
                if (!el.hasAttribute("name"))
                  el.setAttribute("name", expression);
              });
            }
            var event =
              el.tagName.toLowerCase() === "select" ||
              ["checkbox", "radio"].includes(el.type) ||
              modifiers.includes("lazy")
                ? "change"
                : "input";
            let removeListener = isCloning
              ? () => {}
              : on(el, event, modifiers, (e) => {
                  setValue(getInputValue(el, modifiers, e, getValue()));
                });
            if (modifiers.includes("fill")) {
              if (
                [null, ""].includes(getValue()) ||
                (el.type === "checkbox" && Array.isArray(getValue()))
              ) {
                el.dispatchEvent(new Event(event, {}));
              }
            }
            if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
            el._x_removeModelListeners["default"] = removeListener;
            cleanup2(() => el._x_removeModelListeners["default"]());
            if (el.form) {
              let removeResetListener = on(el.form, "reset", [], (e) => {
                nextTick(() => el._x_model && el._x_model.set(el.value));
              });
              cleanup2(() => removeResetListener());
            }
            el._x_model = {
              get() {
                return getValue();
              },
              set(value) {
                setValue(value);
              },
            };
            el._x_forceModelUpdate = (value) => {
              if (
                value === void 0 &&
                typeof expression === "string" &&
                expression.match(/\./)
              )
                value = "";
              window.fromModel = true;
              mutateDom(() => bind(el, "value", value));
              delete window.fromModel;
            };
            effect3(() => {
              let value = getValue();
              if (
                modifiers.includes("unintrusive") &&
                document.activeElement.isSameNode(el)
              )
                return;
              el._x_forceModelUpdate(value);
            });
          }
        );
        function getInputValue(el, modifiers, event, currentValue) {
          return mutateDom(() => {
            if (event instanceof CustomEvent && event.detail !== void 0)
              return event.detail !== null && event.detail !== void 0
                ? event.detail
                : event.target.value;
            else if (el.type === "checkbox") {
              if (Array.isArray(currentValue)) {
                let newValue = modifiers.includes("number")
                  ? safeParseNumber(event.target.value)
                  : event.target.value;
                return event.target.checked
                  ? currentValue.concat([newValue])
                  : currentValue.filter(
                      (el2) => !checkedAttrLooseCompare2(el2, newValue)
                    );
              } else {
                return event.target.checked;
              }
            } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
              return modifiers.includes("number")
                ? Array.from(event.target.selectedOptions).map((option) => {
                    let rawValue = option.value || option.text;
                    return safeParseNumber(rawValue);
                  })
                : Array.from(event.target.selectedOptions).map((option) => {
                    return option.value || option.text;
                  });
            } else {
              let rawValue = event.target.value;
              return modifiers.includes("number")
                ? safeParseNumber(rawValue)
                : modifiers.includes("trim")
                ? rawValue.trim()
                : rawValue;
            }
          });
        }
        function safeParseNumber(rawValue) {
          let number = rawValue ? parseFloat(rawValue) : null;
          return isNumeric2(number) ? number : rawValue;
        }
        function checkedAttrLooseCompare2(valueA, valueB) {
          return valueA == valueB;
        }
        function isNumeric2(subject) {
          return !Array.isArray(subject) && !isNaN(subject);
        }
        function isGetterSetter(value) {
          return (
            value !== null &&
            typeof value === "object" &&
            typeof value.get === "function" &&
            typeof value.set === "function"
          );
        }

        // packages/alpinejs/src/directives/x-cloak.js
        directive("cloak", (el) =>
          queueMicrotask(() =>
            mutateDom(() => el.removeAttribute(prefix("cloak")))
          )
        );

        // packages/alpinejs/src/directives/x-init.js
        addInitSelector(() => `[${prefix("init")}]`);
        directive(
          "init",
          skipDuringClone((el, { expression }, { evaluate: evaluate2 }) => {
            if (typeof expression === "string") {
              return !!expression.trim() && evaluate2(expression, {}, false);
            }
            return evaluate2(expression, {}, false);
          })
        );

        // packages/alpinejs/src/directives/x-text.js
        directive(
          "text",
          (
            el,
            { expression },
            { effect: effect3, evaluateLater: evaluateLater2 }
          ) => {
            let evaluate2 = evaluateLater2(expression);
            effect3(() => {
              evaluate2((value) => {
                mutateDom(() => {
                  el.textContent = value;
                });
              });
            });
          }
        );

        // packages/alpinejs/src/directives/x-html.js
        directive(
          "html",
          (
            el,
            { expression },
            { effect: effect3, evaluateLater: evaluateLater2 }
          ) => {
            let evaluate2 = evaluateLater2(expression);
            effect3(() => {
              evaluate2((value) => {
                mutateDom(() => {
                  el.innerHTML = value;
                  el._x_ignoreSelf = true;
                  initTree(el);
                  delete el._x_ignoreSelf;
                });
              });
            });
          }
        );

        // packages/alpinejs/src/directives/x-bind.js
        mapAttributes(startingWith(":", into(prefix("bind:"))));
        var handler2 = (
          el,
          { value, modifiers, expression, original },
          { effect: effect3 }
        ) => {
          if (!value) {
            let bindingProviders = {};
            injectBindingProviders(bindingProviders);
            let getBindings = evaluateLater(el, expression);
            getBindings(
              (bindings) => {
                applyBindingsObject(el, bindings, original);
              },
              { scope: bindingProviders }
            );
            return;
          }
          if (value === "key") return storeKeyForXFor(el, expression);
          if (
            el._x_inlineBindings &&
            el._x_inlineBindings[value] &&
            el._x_inlineBindings[value].extract
          ) {
            return;
          }
          let evaluate2 = evaluateLater(el, expression);
          effect3(() =>
            evaluate2((result) => {
              if (
                result === void 0 &&
                typeof expression === "string" &&
                expression.match(/\./)
              ) {
                result = "";
              }
              mutateDom(() => bind(el, value, result, modifiers));
            })
          );
        };
        handler2.inline = (el, { value, modifiers, expression }) => {
          if (!value) return;
          if (!el._x_inlineBindings) el._x_inlineBindings = {};
          el._x_inlineBindings[value] = { expression, extract: false };
        };
        directive("bind", handler2);
        function storeKeyForXFor(el, expression) {
          el._x_keyExpression = expression;
        }

        // packages/alpinejs/src/directives/x-data.js
        addRootSelector(() => `[${prefix("data")}]`);
        directive("data", (el, { expression }, { cleanup: cleanup2 }) => {
          if (shouldSkipRegisteringDataDuringClone(el)) return;
          expression = expression === "" ? "{}" : expression;
          let magicContext = {};
          injectMagics(magicContext, el);
          let dataProviderContext = {};
          injectDataProviders(dataProviderContext, magicContext);
          let data2 = evaluate(el, expression, { scope: dataProviderContext });
          if (data2 === void 0 || data2 === true) data2 = {};
          injectMagics(data2, el);
          let reactiveData = reactive(data2);
          initInterceptors2(reactiveData);
          let undo = addScopeToNode(el, reactiveData);
          reactiveData["init"] && evaluate(el, reactiveData["init"]);
          cleanup2(() => {
            reactiveData["destroy"] && evaluate(el, reactiveData["destroy"]);
            undo();
          });
        });

        // packages/alpinejs/src/directives/x-show.js
        directive(
          "show",
          (el, { modifiers, expression }, { effect: effect3 }) => {
            let evaluate2 = evaluateLater(el, expression);
            if (!el._x_doHide)
              el._x_doHide = () => {
                mutateDom(() => {
                  el.style.setProperty(
                    "display",
                    "none",
                    modifiers.includes("important") ? "important" : void 0
                  );
                });
              };
            if (!el._x_doShow)
              el._x_doShow = () => {
                mutateDom(() => {
                  if (el.style.length === 1 && el.style.display === "none") {
                    el.removeAttribute("style");
                  } else {
                    el.style.removeProperty("display");
                  }
                });
              };
            let hide = () => {
              el._x_doHide();
              el._x_isShown = false;
            };
            let show = () => {
              el._x_doShow();
              el._x_isShown = true;
            };
            let clickAwayCompatibleShow = () => setTimeout(show);
            let toggle = once(
              (value) => (value ? show() : hide()),
              (value) => {
                if (
                  typeof el._x_toggleAndCascadeWithTransitions === "function"
                ) {
                  el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
                } else {
                  value ? clickAwayCompatibleShow() : hide();
                }
              }
            );
            let oldValue;
            let firstTime = true;
            effect3(() =>
              evaluate2((value) => {
                if (!firstTime && value === oldValue) return;
                if (modifiers.includes("immediate"))
                  value ? clickAwayCompatibleShow() : hide();
                toggle(value);
                oldValue = value;
                firstTime = false;
              })
            );
          }
        );

        // packages/alpinejs/src/directives/x-for.js
        directive(
          "for",
          (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
            let iteratorNames = parseForExpression(expression);
            let evaluateItems = evaluateLater(el, iteratorNames.items);
            let evaluateKey = evaluateLater(
              el,
              // the x-bind:key expression is stored for our use instead of evaluated.
              el._x_keyExpression || "index"
            );
            el._x_prevKeys = [];
            el._x_lookup = {};
            effect3(() => loop(el, iteratorNames, evaluateItems, evaluateKey));
            cleanup2(() => {
              Object.values(el._x_lookup).forEach((el2) => el2.remove());
              delete el._x_prevKeys;
              delete el._x_lookup;
            });
          }
        );
        function loop(el, iteratorNames, evaluateItems, evaluateKey) {
          let isObject2 = (i) => typeof i === "object" && !Array.isArray(i);
          let templateEl = el;
          evaluateItems((items) => {
            if (isNumeric3(items) && items >= 0) {
              items = Array.from(Array(items).keys(), (i) => i + 1);
            }
            if (items === void 0) items = [];
            let lookup = el._x_lookup;
            let prevKeys = el._x_prevKeys;
            let scopes = [];
            let keys = [];
            if (isObject2(items)) {
              items = Object.entries(items).map(([key, value]) => {
                let scope2 = getIterationScopeVariables(
                  iteratorNames,
                  value,
                  key,
                  items
                );
                evaluateKey((value2) => keys.push(value2), {
                  scope: { index: key, ...scope2 },
                });
                scopes.push(scope2);
              });
            } else {
              for (let i = 0; i < items.length; i++) {
                let scope2 = getIterationScopeVariables(
                  iteratorNames,
                  items[i],
                  i,
                  items
                );
                evaluateKey((value) => keys.push(value), {
                  scope: { index: i, ...scope2 },
                });
                scopes.push(scope2);
              }
            }
            let adds = [];
            let moves = [];
            let removes = [];
            let sames = [];
            for (let i = 0; i < prevKeys.length; i++) {
              let key = prevKeys[i];
              if (keys.indexOf(key) === -1) removes.push(key);
            }
            prevKeys = prevKeys.filter((key) => !removes.includes(key));
            let lastKey = "template";
            for (let i = 0; i < keys.length; i++) {
              let key = keys[i];
              let prevIndex = prevKeys.indexOf(key);
              if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([lastKey, i]);
              } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([keyInSpot, keyForSpot]);
              } else {
                sames.push(key);
              }
              lastKey = key;
            }
            for (let i = 0; i < removes.length; i++) {
              let key = removes[i];
              if (!!lookup[key]._x_effects) {
                lookup[key]._x_effects.forEach(dequeueJob);
              }
              lookup[key].remove();
              lookup[key] = null;
              delete lookup[key];
            }
            for (let i = 0; i < moves.length; i++) {
              let [keyInSpot, keyForSpot] = moves[i];
              let elInSpot = lookup[keyInSpot];
              let elForSpot = lookup[keyForSpot];
              let marker = document.createElement("div");
              mutateDom(() => {
                if (!elForSpot)
                  warn(`x-for ":key" is undefined or invalid`, templateEl);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl &&
                  elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl &&
                  elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
              });
              elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
            }
            for (let i = 0; i < adds.length; i++) {
              let [lastKey2, index] = adds[i];
              let lastEl =
                lastKey2 === "template" ? templateEl : lookup[lastKey2];
              if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
              let scope2 = scopes[index];
              let key = keys[index];
              let clone2 = document.importNode(
                templateEl.content,
                true
              ).firstElementChild;
              let reactiveScope = reactive(scope2);
              addScopeToNode(clone2, reactiveScope, templateEl);
              clone2._x_refreshXForScope = (newScope) => {
                Object.entries(newScope).forEach(([key2, value]) => {
                  reactiveScope[key2] = value;
                });
              };
              mutateDom(() => {
                lastEl.after(clone2);
                initTree(clone2);
              });
              if (typeof key === "object") {
                warn(
                  "x-for key cannot be an object, it must be a string or an integer",
                  templateEl
                );
              }
              lookup[key] = clone2;
            }
            for (let i = 0; i < sames.length; i++) {
              lookup[sames[i]]._x_refreshXForScope(
                scopes[keys.indexOf(sames[i])]
              );
            }
            templateEl._x_prevKeys = keys;
          });
        }
        function parseForExpression(expression) {
          let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
          let stripParensRE = /^\s*\(|\)\s*$/g;
          let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
          let inMatch = expression.match(forAliasRE);
          if (!inMatch) return;
          let res = {};
          res.items = inMatch[2].trim();
          let item = inMatch[1].replace(stripParensRE, "").trim();
          let iteratorMatch = item.match(forIteratorRE);
          if (iteratorMatch) {
            res.item = item.replace(forIteratorRE, "").trim();
            res.index = iteratorMatch[1].trim();
            if (iteratorMatch[2]) {
              res.collection = iteratorMatch[2].trim();
            }
          } else {
            res.item = item;
          }
          return res;
        }
        function getIterationScopeVariables(iteratorNames, item, index, items) {
          let scopeVariables = {};
          if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
            let names = iteratorNames.item
              .replace("[", "")
              .replace("]", "")
              .split(",")
              .map((i) => i.trim());
            names.forEach((name, i) => {
              scopeVariables[name] = item[i];
            });
          } else if (
            /^\{.*\}$/.test(iteratorNames.item) &&
            !Array.isArray(item) &&
            typeof item === "object"
          ) {
            let names = iteratorNames.item
              .replace("{", "")
              .replace("}", "")
              .split(",")
              .map((i) => i.trim());
            names.forEach((name) => {
              scopeVariables[name] = item[name];
            });
          } else {
            scopeVariables[iteratorNames.item] = item;
          }
          if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
          if (iteratorNames.collection)
            scopeVariables[iteratorNames.collection] = items;
          return scopeVariables;
        }
        function isNumeric3(subject) {
          return !Array.isArray(subject) && !isNaN(subject);
        }

        // packages/alpinejs/src/directives/x-ref.js
        function handler3() {}
        handler3.inline = (el, { expression }, { cleanup: cleanup2 }) => {
          let root = closestRoot(el);
          if (!root._x_refs) root._x_refs = {};
          root._x_refs[expression] = el;
          cleanup2(() => delete root._x_refs[expression]);
        };
        directive("ref", handler3);

        // packages/alpinejs/src/directives/x-if.js
        directive(
          "if",
          (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
            if (el.tagName.toLowerCase() !== "template")
              warn("x-if can only be used on a <template> tag", el);
            let evaluate2 = evaluateLater(el, expression);
            let show = () => {
              if (el._x_currentIfEl) return el._x_currentIfEl;
              let clone2 = el.content.cloneNode(true).firstElementChild;
              addScopeToNode(clone2, {}, el);
              mutateDom(() => {
                el.after(clone2);
                initTree(clone2);
              });
              el._x_currentIfEl = clone2;
              el._x_undoIf = () => {
                walk(clone2, (node) => {
                  if (!!node._x_effects) {
                    node._x_effects.forEach(dequeueJob);
                  }
                });
                clone2.remove();
                delete el._x_currentIfEl;
              };
              return clone2;
            };
            let hide = () => {
              if (!el._x_undoIf) return;
              el._x_undoIf();
              delete el._x_undoIf;
            };
            effect3(() =>
              evaluate2((value) => {
                value ? show() : hide();
              })
            );
            cleanup2(() => el._x_undoIf && el._x_undoIf());
          }
        );

        // packages/alpinejs/src/directives/x-id.js
        directive("id", (el, { expression }, { evaluate: evaluate2 }) => {
          let names = evaluate2(expression);
          names.forEach((name) => setIdRoot(el, name));
        });

        // packages/alpinejs/src/directives/x-on.js
        mapAttributes(startingWith("@", into(prefix("on:"))));
        directive(
          "on",
          skipDuringClone(
            (el, { value, modifiers, expression }, { cleanup: cleanup2 }) => {
              let evaluate2 = expression
                ? evaluateLater(el, expression)
                : () => {};
              if (el.tagName.toLowerCase() === "template") {
                if (!el._x_forwardEvents) el._x_forwardEvents = [];
                if (!el._x_forwardEvents.includes(value))
                  el._x_forwardEvents.push(value);
              }
              let removeListener = on(el, value, modifiers, (e) => {
                evaluate2(() => {}, { scope: { $event: e }, params: [e] });
              });
              cleanup2(() => removeListener());
            }
          )
        );

        // packages/alpinejs/src/directives/index.js
        warnMissingPluginDirective("Collapse", "collapse", "collapse");
        warnMissingPluginDirective("Intersect", "intersect", "intersect");
        warnMissingPluginDirective("Focus", "trap", "focus");
        warnMissingPluginDirective("Mask", "mask", "mask");
        function warnMissingPluginDirective(name, directiveName, slug) {
          directive(directiveName, (el) =>
            warn(
              `You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`,
              el
            )
          );
        }

        // packages/alpinejs/src/index.js
        alpine_default.setEvaluator(normalEvaluator);
        alpine_default.setReactivityEngine({
          reactive: reactive2,
          effect: effect2,
          release: stop,
          raw: toRaw,
        });
        var src_default = alpine_default;

        // packages/alpinejs/builds/module.js
        var module_default = src_default;

        /***/
      },

    /***/ "./src/scripts/components/modal.js":
      /*!*****************************************!*\
  !*** ./src/scripts/components/modal.js ***!
  \*****************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var youtube_player__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! youtube-player */ "./node_modules/youtube-player/dist/index.js"
          );
        /* harmony import */ var youtube_player__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            youtube_player__WEBPACK_IMPORTED_MODULE_0__
          );

        var Modal = function Modal() {
          return {
            isModalOpened: false,
            ytVideo: null,
            handleBodyClick: function handleBodyClick() {
              if (this.isModalOpened) this.closeVideoAndModal();
            },
            toggleModal: function toggleModal(state) {
              var videoId =
                arguments.length > 1 && arguments[1] !== undefined
                  ? arguments[1]
                  : null;
              if (state === undefined) {
                this.isModalOpened = !this.isModalOpened;
                return;
              }
              if (state) {
                this.openModalAndPlayVideo(videoId);
              } else {
                this.closeVideoAndModal();
              }
            },
            openModalAndPlayVideo: function openModalAndPlayVideo(videoId) {
              this.isModalOpened = true;
              if (videoId && !this.ytVideo) {
                this.ytVideo =
                  youtube_player__WEBPACK_IMPORTED_MODULE_0___default()(
                    "ytVideo",
                    {
                      videoId: videoId,
                    }
                  );
                this.ytVideo.on("ready", function () {
                  console.log("Video ready");
                });
              } else {
                var _this$ytVideo;
                (_this$ytVideo = this.ytVideo) === null ||
                  _this$ytVideo === void 0 ||
                  _this$ytVideo.playVideo();
              }
            },
            closeVideoAndModal: function closeVideoAndModal() {
              var _this = this;
              if (this.ytVideo) {
                this.ytVideo.pauseVideo().then(function () {
                  _this.isModalOpened = false;
                });
              } else {
                this.isModalOpened = false;
              }
            },
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = Modal;

        /***/
      },

    /***/ "./src/scripts/components/scrollBar.js":
      /*!*********************************************!*\
  !*** ./src/scripts/components/scrollBar.js ***!
  \*********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var smooth_scrollbar__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! smooth-scrollbar */ "./node_modules/smooth-scrollbar/index.js"
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function () {
            return {
              init: function init() {
                var elem = document.getElementById("scrollBar");
                var scrollbar =
                  smooth_scrollbar__WEBPACK_IMPORTED_MODULE_0__["default"].init(
                    elem
                  );
              },
            };
          };

        /***/
      },

    /***/ "./src/scripts/components/swiper-carousel.js":
      /*!***************************************************!*\
  !*** ./src/scripts/components/swiper-carousel.js ***!
  \***************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.mjs");
        /* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! swiper/modules */ "./node_modules/swiper/modules/index.mjs"
          );
        /* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! swiper/css */ "./node_modules/swiper/swiper.css"
          );
        /* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! swiper/css/scrollbar */ "./node_modules/swiper/modules/scrollbar.css"
          );

        var Carousel = function Carousel(_ref) {
          var _ref$showScrollbarDes = _ref.showScrollbarDesktop,
            showScrollbarDesktop =
              _ref$showScrollbarDes === void 0 ? false : _ref$showScrollbarDes,
            _ref$showScrollbarMob = _ref.showScrollbarMobile,
            showScrollbarMobile =
              _ref$showScrollbarMob === void 0 ? true : _ref$showScrollbarMob,
            _ref$slidesPerViewDes = _ref.slidesPerViewDesktop,
            slidesPerViewDesktop =
              _ref$slidesPerViewDes === void 0 ? 3 : _ref$slidesPerViewDes,
            _ref$slidesPerViewMob = _ref.slidesPerViewMobile,
            slidesPerViewMobile =
              _ref$slidesPerViewMob === void 0 ? 1.5 : _ref$slidesPerViewMob,
            _ref$slidesPerViewTab = _ref.slidesPerViewTablet,
            slidesPerViewTablet =
              _ref$slidesPerViewTab === void 0 ? 2.5 : _ref$slidesPerViewTab,
            _ref$spaceBetweenDesk = _ref.spaceBetweenDesktop,
            spaceBetweenDesktop =
              _ref$spaceBetweenDesk === void 0 ? 30 : _ref$spaceBetweenDesk,
            _ref$spaceBetweenMobi = _ref.spaceBetweenMobile,
            spaceBetweenMobile =
              _ref$spaceBetweenMobi === void 0 ? 8 : _ref$spaceBetweenMobi,
            _ref$slidesOffsetAfte = _ref.slidesOffsetAfterDesktop,
            slidesOffsetAfterDesktop =
              _ref$slidesOffsetAfte === void 0 ? 0 : _ref$slidesOffsetAfte,
            _ref$slidesOffsetBefo = _ref.slidesOffsetBeforeDesktop,
            slidesOffsetBeforeDesktop =
              _ref$slidesOffsetBefo === void 0 ? 0 : _ref$slidesOffsetBefo,
            _ref$slidesOffsetAfte2 = _ref.slidesOffsetAfterTablet,
            slidesOffsetAfterTablet =
              _ref$slidesOffsetAfte2 === void 0 ? 0 : _ref$slidesOffsetAfte2,
            _ref$slidesOffsetBefo2 = _ref.slidesOffsetBeforeTablet,
            slidesOffsetBeforeTablet =
              _ref$slidesOffsetBefo2 === void 0 ? 0 : _ref$slidesOffsetBefo2,
            _ref$slidesOffsetAfte3 = _ref.slidesOffsetAfterMobile,
            slidesOffsetAfterMobile =
              _ref$slidesOffsetAfte3 === void 0 ? 0 : _ref$slidesOffsetAfte3,
            _ref$slidesOffsetBefo3 = _ref.slidesOffsetBeforeMobile,
            slidesOffsetBeforeMobile =
              _ref$slidesOffsetBefo3 === void 0 ? 0 : _ref$slidesOffsetBefo3;
          return {
            init: function init() {
              this.initSwiper();
            },
            swiper: null,
            initSwiper: function initSwiper() {
              this.swiper = new swiper__WEBPACK_IMPORTED_MODULE_0__["default"](
                this.$refs.swiper,
                {
                  breakpoints: {
                    990: {
                      scrollbar: {
                        enabled: showScrollbarDesktop,
                      },
                      spaceBetween: spaceBetweenDesktop,
                      slidesOffsetAfter: slidesOffsetAfterDesktop,
                      slidesOffsetBefore: slidesOffsetBeforeDesktop,
                      slidesPerView: slidesPerViewDesktop,
                    },
                    768: {
                      slidesOffsetAfter: slidesOffsetAfterTablet,
                      slidesOffsetBefore: slidesOffsetBeforeTablet,
                      slidesPerView: slidesPerViewTablet,
                    },
                  },
                  scrollbar: {
                    draggable: true,
                    enabled: showScrollbarMobile,
                    el: ".swiper-scrollbar",
                  },
                  modules: [
                    swiper_modules__WEBPACK_IMPORTED_MODULE_1__.Scrollbar,
                  ],
                  slidesOffsetAfter: slidesOffsetAfterMobile,
                  slidesOffsetBefore: slidesOffsetBeforeMobile,
                  spaceBetween: spaceBetweenMobile,
                  slidesPerView: slidesPerViewMobile,
                  resistanceRatio: 0,
                }
              );
            },
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          Carousel;

        /***/
      },

    /***/ "./src/scripts/customer.js":
      /*!*********************************!*\
  !*** ./src/scripts/customer.js ***!
  \*********************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function () {
            return {
              showEditForm: false,
              showAddNewAddressForm: false,
              showAddressesListModal: false,
              showOverlay: false,
              currentPage: null,
              activeTab: "account",
              init: function init() {
                this.currentPage = window.location.pathname;
              },
              toggleAddNewAddressForm: function toggleAddNewAddressForm() {
                this.showAddNewAddressForm = !this.showAddNewAddressForm;
                this.toggleOverlay(this.showAddNewAddressForm);
              },
              toggleEditAddressForm: function toggleEditAddressForm(index) {
                this.showOverlay = !this.showOverlay;
                this.showEditForm !== index
                  ? (this.showEditForm = index)
                  : (this.showEditForm = null);
                this.toggleOverlay(this.showEditForm !== null);
              },
              toggleOverlay: function toggleOverlay(flag) {
                var body = document.querySelector("body");
                this.showOverlay = flag;
                if (this.showOverlay) {
                  body.classList.add("overflow-hidden");
                } else {
                  body.classList.remove("overflow-hidden");
                }
              },
              switchAccountView: function switchAccountView(tabName) {
                this.activeTab = tabName;
                window.location.hash = tabName;
              },
              navigateToSelectedURL: function navigateToSelectedURL(event) {
                window.location.href = event.target.value;
              },
            };
          };

        /***/
      },

    /***/ "./src/scripts/main.js":
      /*!*****************************!*\
  !*** ./src/scripts/main.js ***!
  \*****************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var alpinejs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! alpinejs */ "./node_modules/alpinejs/dist/module.esm.js"
          );
        /* harmony import */ var _components_swiper_carousel__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./components/swiper-carousel */ "./src/scripts/components/swiper-carousel.js"
          );
        /* harmony import */ var _components_modal__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./components/modal */ "./src/scripts/components/modal.js"
          );
        /* harmony import */ var _components_scrollBar__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./components/scrollBar */ "./src/scripts/components/scrollBar.js"
          );
        /* harmony import */ var _objects_price_range__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./objects/price-range */ "./src/scripts/objects/price-range.js"
          );
        /* harmony import */ var _objects_product_gallery__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./objects/product-gallery */ "./src/scripts/objects/product-gallery.js"
          );
        /* harmony import */ var _objects_quantity_field__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./objects/quantity-field */ "./src/scripts/objects/quantity-field.js"
          );
        /* harmony import */ var _objects_product_complementary__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ./objects/product-complementary */ "./src/scripts/objects/product-complementary.js"
          );
        /* harmony import */ var _objects_cart_item__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! ./objects/cart-item */ "./src/scripts/objects/cart-item.js"
          );
        /* harmony import */ var _objects_facets_main__WEBPACK_IMPORTED_MODULE_9__ =
          __webpack_require__(
            /*! ./objects/facets-main */ "./src/scripts/objects/facets-main.js"
          );
        /* harmony import */ var _sections_header_main__WEBPACK_IMPORTED_MODULE_10__ =
          __webpack_require__(
            /*! ./sections/header-main */ "./src/scripts/sections/header-main.js"
          );
        /* harmony import */ var _sections_product_main__WEBPACK_IMPORTED_MODULE_11__ =
          __webpack_require__(
            /*! ./sections/product-main */ "./src/scripts/sections/product-main.js"
          );
        /* harmony import */ var _sections_product_recommendations__WEBPACK_IMPORTED_MODULE_12__ =
          __webpack_require__(
            /*! ./sections/product-recommendations */ "./src/scripts/sections/product-recommendations.js"
          );
        /* harmony import */ var _sections_usp_carousel__WEBPACK_IMPORTED_MODULE_13__ =
          __webpack_require__(
            /*! ./sections/usp-carousel */ "./src/scripts/sections/usp-carousel.js"
          );
        /* harmony import */ var _customer__WEBPACK_IMPORTED_MODULE_14__ =
          __webpack_require__(/*! ./customer */ "./src/scripts/customer.js");
        /* harmony import */ var _sections_simple_video__WEBPACK_IMPORTED_MODULE_15__ =
          __webpack_require__(
            /*! ./sections/simple_video */ "./src/scripts/sections/simple_video.js"
          );
        /* harmony import */ var _sections_klaviyo_newsletter__WEBPACK_IMPORTED_MODULE_16__ =
          __webpack_require__(
            /*! ./sections/klaviyo-newsletter */ "./src/scripts/sections/klaviyo-newsletter.js"
          );
        /* harmony import */ var _sections_trage_klaviyo_register__WEBPACK_IMPORTED_MODULE_17__ =
          __webpack_require__(
            /*! ./sections/trage-klaviyo-register */ "./src/scripts/sections/trage-klaviyo-register.js"
          );
        /* harmony import */ var _store_cart_store__WEBPACK_IMPORTED_MODULE_18__ =
          __webpack_require__(
            /*! ./store/cart-store */ "./src/scripts/store/cart-store.js"
          );
        /* harmony import */ var _store_localization_store__WEBPACK_IMPORTED_MODULE_19__ =
          __webpack_require__(
            /*! ./store/localization-store */ "./src/scripts/store/localization-store.js"
          );

        window.Alpine = alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"];
        document.addEventListener("alpine:init", function () {
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "carousel",
            _components_swiper_carousel__WEBPACK_IMPORTED_MODULE_1__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "modal",
            _components_modal__WEBPACK_IMPORTED_MODULE_2__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "scrollBar",
            _components_scrollBar__WEBPACK_IMPORTED_MODULE_3__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "priceRange",
            _objects_price_range__WEBPACK_IMPORTED_MODULE_4__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "productGallery",
            _objects_product_gallery__WEBPACK_IMPORTED_MODULE_5__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "productComplementary",
            _objects_product_complementary__WEBPACK_IMPORTED_MODULE_7__[
              "default"
            ]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "quantityField",
            _objects_quantity_field__WEBPACK_IMPORTED_MODULE_6__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "facetsMain",
            _objects_facets_main__WEBPACK_IMPORTED_MODULE_9__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "cartItem",
            _objects_cart_item__WEBPACK_IMPORTED_MODULE_8__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "headerMain",
            _sections_header_main__WEBPACK_IMPORTED_MODULE_10__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "productMain",
            _sections_product_main__WEBPACK_IMPORTED_MODULE_11__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "productRecommendations",
            _sections_product_recommendations__WEBPACK_IMPORTED_MODULE_12__[
              "default"
            ]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "uspCarousel",
            _sections_usp_carousel__WEBPACK_IMPORTED_MODULE_13__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "customer",
            _customer__WEBPACK_IMPORTED_MODULE_14__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "simple_video",
            _sections_simple_video__WEBPACK_IMPORTED_MODULE_15__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "klaviyoNewsletter",
            _sections_klaviyo_newsletter__WEBPACK_IMPORTED_MODULE_16__[
              "default"
            ]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].data(
            "tardeKlaviyoRegisterForm",
            _sections_trage_klaviyo_register__WEBPACK_IMPORTED_MODULE_17__[
              "default"
            ]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].store(
            "cart",
            _store_cart_store__WEBPACK_IMPORTED_MODULE_18__["default"]
          );
          alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].store(
            "localization",
            _store_localization_store__WEBPACK_IMPORTED_MODULE_19__["default"]
          );
        });
        alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].start();

        /***/
      },

    /***/ "./src/scripts/objects/cart-item.js":
      /*!******************************************!*\
  !*** ./src/scripts/objects/cart-item.js ***!
  \******************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! lodash-es */ "./node_modules/lodash-es/fromPairs.js"
          );
        /* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! lodash-es */ "./node_modules/lodash-es/debounce.js"
          );
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _regeneratorRuntime() {
          "use strict";
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime =
            function _regeneratorRuntime() {
              return e;
            };
          var t,
            e = {},
            r = Object.prototype,
            n = r.hasOwnProperty,
            o =
              Object.defineProperty ||
              function (t, e, r) {
                t[e] = r.value;
              },
            i = "function" == typeof Symbol ? Symbol : {},
            a = i.iterator || "@@iterator",
            c = i.asyncIterator || "@@asyncIterator",
            u = i.toStringTag || "@@toStringTag";
          function define(t, e, r) {
            return (
              Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              }),
              t[e]
            );
          }
          try {
            define({}, "");
          } catch (t) {
            define = function define(t, e, r) {
              return (t[e] = r);
            };
          }
          function wrap(t, e, r, n) {
            var i = e && e.prototype instanceof Generator ? e : Generator,
              a = Object.create(i.prototype),
              c = new Context(n || []);
            return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a;
          }
          function tryCatch(t, e, r) {
            try {
              return { type: "normal", arg: t.call(e, r) };
            } catch (t) {
              return { type: "throw", arg: t };
            }
          }
          e.wrap = wrap;
          var h = "suspendedStart",
            l = "suspendedYield",
            f = "executing",
            s = "completed",
            y = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          var p = {};
          define(p, a, function () {
            return this;
          });
          var d = Object.getPrototypeOf,
            v = d && d(d(values([])));
          v && v !== r && n.call(v, a) && (p = v);
          var g =
            (GeneratorFunctionPrototype.prototype =
            Generator.prototype =
              Object.create(p));
          function defineIteratorMethods(t) {
            ["next", "throw", "return"].forEach(function (e) {
              define(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function AsyncIterator(t, e) {
            function invoke(r, o, i, a) {
              var c = tryCatch(t[r], t, o);
              if ("throw" !== c.type) {
                var u = c.arg,
                  h = u.value;
                return h && "object" == _typeof(h) && n.call(h, "__await")
                  ? e.resolve(h.__await).then(
                      function (t) {
                        invoke("next", t, i, a);
                      },
                      function (t) {
                        invoke("throw", t, i, a);
                      }
                    )
                  : e.resolve(h).then(
                      function (t) {
                        (u.value = t), i(u);
                      },
                      function (t) {
                        return invoke("throw", t, i, a);
                      }
                    );
              }
              a(c.arg);
            }
            var r;
            o(this, "_invoke", {
              value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                  return new e(function (e, r) {
                    invoke(t, n, e, r);
                  });
                }
                return (r = r
                  ? r.then(
                      callInvokeWithMethodAndArg,
                      callInvokeWithMethodAndArg
                    )
                  : callInvokeWithMethodAndArg());
              },
            });
          }
          function makeInvokeMethod(e, r, n) {
            var o = h;
            return function (i, a) {
              if (o === f) throw new Error("Generator is already running");
              if (o === s) {
                if ("throw" === i) throw a;
                return { value: t, done: !0 };
              }
              for (n.method = i, n.arg = a; ; ) {
                var c = n.delegate;
                if (c) {
                  var u = maybeInvokeDelegate(c, n);
                  if (u) {
                    if (u === y) continue;
                    return u;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                  if (o === h) throw ((o = s), n.arg);
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                  if (((o = n.done ? s : l), p.arg === y)) continue;
                  return { value: p.arg, done: n.done };
                }
                "throw" === p.type &&
                  ((o = s), (n.method = "throw"), (n.arg = p.arg));
              }
            };
          }
          function maybeInvokeDelegate(e, r) {
            var n = r.method,
              o = e.iterator[n];
            if (o === t)
              return (
                (r.delegate = null),
                ("throw" === n &&
                  e.iterator["return"] &&
                  ((r.method = "return"),
                  (r.arg = t),
                  maybeInvokeDelegate(e, r),
                  "throw" === r.method)) ||
                  ("return" !== n &&
                    ((r.method = "throw"),
                    (r.arg = new TypeError(
                      "The iterator does not provide a '" + n + "' method"
                    )))),
                y
              );
            var i = tryCatch(o, e.iterator, r.arg);
            if ("throw" === i.type)
              return (
                (r.method = "throw"), (r.arg = i.arg), (r.delegate = null), y
              );
            var a = i.arg;
            return a
              ? a.done
                ? ((r[e.resultName] = a.value),
                  (r.next = e.nextLoc),
                  "return" !== r.method && ((r.method = "next"), (r.arg = t)),
                  (r.delegate = null),
                  y)
                : a
              : ((r.method = "throw"),
                (r.arg = new TypeError("iterator result is not an object")),
                (r.delegate = null),
                y);
          }
          function pushTryEntry(t) {
            var e = { tryLoc: t[0] };
            1 in t && (e.catchLoc = t[1]),
              2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
              this.tryEntries.push(e);
          }
          function resetTryEntry(t) {
            var e = t.completion || {};
            (e.type = "normal"), delete e.arg, (t.completion = e);
          }
          function Context(t) {
            (this.tryEntries = [{ tryLoc: "root" }]),
              t.forEach(pushTryEntry, this),
              this.reset(!0);
          }
          function values(e) {
            if (e || "" === e) {
              var r = e[a];
              if (r) return r.call(e);
              if ("function" == typeof e.next) return e;
              if (!isNaN(e.length)) {
                var o = -1,
                  i = function next() {
                    for (; ++o < e.length; )
                      if (n.call(e, o))
                        return (next.value = e[o]), (next.done = !1), next;
                    return (next.value = t), (next.done = !0), next;
                  };
                return (i.next = i);
              }
            }
            throw new TypeError(_typeof(e) + " is not iterable");
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            o(g, "constructor", {
              value: GeneratorFunctionPrototype,
              configurable: !0,
            }),
            o(GeneratorFunctionPrototype, "constructor", {
              value: GeneratorFunction,
              configurable: !0,
            }),
            (GeneratorFunction.displayName = define(
              GeneratorFunctionPrototype,
              u,
              "GeneratorFunction"
            )),
            (e.isGeneratorFunction = function (t) {
              var e = "function" == typeof t && t.constructor;
              return (
                !!e &&
                (e === GeneratorFunction ||
                  "GeneratorFunction" === (e.displayName || e.name))
              );
            }),
            (e.mark = function (t) {
              return (
                Object.setPrototypeOf
                  ? Object.setPrototypeOf(t, GeneratorFunctionPrototype)
                  : ((t.__proto__ = GeneratorFunctionPrototype),
                    define(t, u, "GeneratorFunction")),
                (t.prototype = Object.create(g)),
                t
              );
            }),
            (e.awrap = function (t) {
              return { __await: t };
            }),
            defineIteratorMethods(AsyncIterator.prototype),
            define(AsyncIterator.prototype, c, function () {
              return this;
            }),
            (e.AsyncIterator = AsyncIterator),
            (e.async = function (t, r, n, o, i) {
              void 0 === i && (i = Promise);
              var a = new AsyncIterator(wrap(t, r, n, o), i);
              return e.isGeneratorFunction(r)
                ? a
                : a.next().then(function (t) {
                    return t.done ? t.value : a.next();
                  });
            }),
            defineIteratorMethods(g),
            define(g, u, "Generator"),
            define(g, a, function () {
              return this;
            }),
            define(g, "toString", function () {
              return "[object Generator]";
            }),
            (e.keys = function (t) {
              var e = Object(t),
                r = [];
              for (var n in e) r.push(n);
              return (
                r.reverse(),
                function next() {
                  for (; r.length; ) {
                    var t = r.pop();
                    if (t in e) return (next.value = t), (next.done = !1), next;
                  }
                  return (next.done = !0), next;
                }
              );
            }),
            (e.values = values),
            (Context.prototype = {
              constructor: Context,
              reset: function reset(e) {
                if (
                  ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = t),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = t),
                  this.tryEntries.forEach(resetTryEntry),
                  !e)
                )
                  for (var r in this)
                    "t" === r.charAt(0) &&
                      n.call(this, r) &&
                      !isNaN(+r.slice(1)) &&
                      (this[r] = t);
              },
              stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var r = this;
                function handle(n, o) {
                  return (
                    (a.type = "throw"),
                    (a.arg = e),
                    (r.next = n),
                    o && ((r.method = "next"), (r.arg = t)),
                    !!o
                  );
                }
                for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                  var i = this.tryEntries[o],
                    a = i.completion;
                  if ("root" === i.tryLoc) return handle("end");
                  if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"),
                      u = n.call(i, "finallyLoc");
                    if (c && u) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                      if (!u)
                        throw new Error(
                          "try statement without catch or finally"
                        );
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(t, e) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var o = this.tryEntries[r];
                  if (
                    o.tryLoc <= this.prev &&
                    n.call(o, "finallyLoc") &&
                    this.prev < o.finallyLoc
                  ) {
                    var i = o;
                    break;
                  }
                }
                i &&
                  ("break" === t || "continue" === t) &&
                  i.tryLoc <= e &&
                  e <= i.finallyLoc &&
                  (i = null);
                var a = i ? i.completion : {};
                return (
                  (a.type = t),
                  (a.arg = e),
                  i
                    ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                    : this.complete(a)
                );
              },
              complete: function complete(t, e) {
                if ("throw" === t.type) throw t.arg;
                return (
                  "break" === t.type || "continue" === t.type
                    ? (this.next = t.arg)
                    : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                  y
                );
              },
              finish: function finish(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.finallyLoc === t)
                    return (
                      this.complete(r.completion, r.afterLoc),
                      resetTryEntry(r),
                      y
                    );
                }
              },
              catch: function _catch(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                      var o = n.arg;
                      resetTryEntry(r);
                    }
                    return o;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(e, r, n) {
                return (
                  (this.delegate = {
                    iterator: values(e),
                    resultName: r,
                    nextLoc: n,
                  }),
                  "next" === this.method && (this.arg = t),
                  y
                );
              },
            }),
            e
          );
        }
        function asyncGeneratorStep(
          gen,
          resolve,
          reject,
          _next,
          _throw,
          key,
          arg
        ) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }
        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
              args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);
              function _next(value) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "next",
                  value
                );
              }
              function _throw(err) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "throw",
                  err
                );
              }
              _next(undefined);
            });
          };
        }

        var CartItem = function CartItem(_ref) {
          var item = _ref.item;
          return {
            isLoading: Alpine.store("cart").isUpdating,
            quantity: item.quantity,
            itemProperties: (0,
            lodash_es__WEBPACK_IMPORTED_MODULE_0__["default"])(item.properties),
            isGiftWrap: false,
            giftVariant: null,
            noGiftVariant: null,
            giftWrapMessage: "",
            isGiftWrapMessageEnabled: true,
            isGiftWrapMessageShowing: false,
            hasGiftWrapMessage: false,
            isGiftWrapSaveEnabled: false,
            init: function init() {
              this.setIsGiftWrap();
            },
            handleQuantityChange: (0,
            lodash_es__WEBPACK_IMPORTED_MODULE_1__["default"])(
              /*#__PURE__*/ (function () {
                var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/ _regeneratorRuntime().mark(function _callee(
                    $event
                  ) {
                    return _regeneratorRuntime().wrap(
                      function _callee$(_context) {
                        while (1)
                          switch ((_context.prev = _context.next)) {
                            case 0:
                              if ($event.detail.value) {
                                _context.next = 2;
                                break;
                              }
                              return _context.abrupt("return");
                            case 2:
                              this.quantity = $event.detail.value;
                              this.isLoading = true;
                              _context.next = 6;
                              return Alpine.store("cart").updateCart({
                                key: item.key,
                                quantity: this.quantity,
                                showFetchCartLoading: false,
                              });
                            case 6:
                              this.isLoading = false;
                            case 7:
                            case "end":
                              return _context.stop();
                          }
                      },
                      _callee,
                      this
                    );
                  })
                );
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              })(),
              250
            ),
            handleItemRemove: function handleItemRemove() {
              var _this = this;
              return _asyncToGenerator(
                /*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
                  return _regeneratorRuntime().wrap(function _callee2$(
                    _context2
                  ) {
                    while (1)
                      switch ((_context2.prev = _context2.next)) {
                        case 0:
                          _this.isLoading = true;
                          _context2.next = 3;
                          return Alpine.store("cart").updateCart({
                            key: item.key,
                            quantity: 0,
                            showFetchCartLoading: false,
                          });
                        case 3:
                          _this.isLoading = false;
                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                  },
                  _callee2);
                })
              )();
            },
            setIsGiftWrap: function setIsGiftWrap() {
              var isGiftWrapTemplate =
                item.product_template_suffix === "gift-wrap";
              this.giftVariant = item.product_variants.find(function (variant) {
                return variant.title.toLowerCase() === "gift wrap";
              });
              this.noGiftVariant = item.product_variants.find(function (
                variant
              ) {
                return variant.title.toLowerCase() === "no gift wrap";
              });
              this.isGiftWrap =
                isGiftWrapTemplate && this.giftVariant && this.noGiftVariant;
              if (!this.isGiftWrap) return;
              this.giftWrapMessage = this.itemProperties["Gift wrap message"];
              this.hasGiftWrapMessage = this.giftWrapMessage !== undefined;
              this.isGiftWrapMessageEnabled =
                this.giftVariant.id === item.variant.id;
            },
            handleGiftWrapChange: function handleGiftWrapChange() {
              var _this2 = this;
              return _asyncToGenerator(
                /*#__PURE__*/ _regeneratorRuntime().mark(function _callee3() {
                  return _regeneratorRuntime().wrap(function _callee3$(
                    _context3
                  ) {
                    while (1)
                      switch ((_context3.prev = _context3.next)) {
                        case 0:
                          if (
                            !(
                              !_this2.isGiftWrap &&
                              !_this2.giftVariant &&
                              !_this2.noGiftVariant
                            )
                          ) {
                            _context3.next = 2;
                            break;
                          }
                          return _context3.abrupt("return");
                        case 2:
                          _this2.isGiftWrapMessageEnabled =
                            !_this2.isGiftWrapMessageEnabled;
                          _this2.isLoading = true;
                          _context3.next = 6;
                          return Alpine.store("cart").updateCart({
                            key: item.key,
                            quantity: 0,
                            shouldFetchCart: false,
                            showFetchCartLoading: false,
                          });
                        case 6:
                          _context3.next = 8;
                          return Alpine.store("cart").addToCart({
                            variantId: _this2.isGiftWrapMessageEnabled
                              ? _this2.giftVariant.id
                              : _this2.noGiftVariant.id,
                            quantity: item.quantity,
                            properties: _this2.isGiftWrapMessageEnabled
                              ? _this2.itemProperties
                              : {},
                            shouldFetchCart: true,
                            showFetchCartLoading: false,
                            showMiniCartOnSuccess: false,
                          });
                        case 8:
                          _this2.isLoading = false;
                        case 9:
                        case "end":
                          return _context3.stop();
                      }
                  },
                  _callee3);
                })
              )();
            },
            handleGiftWrapMessageInput: function handleGiftWrapMessageInput() {
              if (!this.isGiftWrap && !this.itemProperties["Gift wrap message"])
                return;
              this.isGiftWrapSaveEnabled =
                this.itemProperties["Gift wrap message"] !==
                this.giftWrapMessage;
            },
            handleGiftWrapSubmit: function handleGiftWrapSubmit() {
              var _this3 = this;
              return _asyncToGenerator(
                /*#__PURE__*/ _regeneratorRuntime().mark(function _callee4() {
                  return _regeneratorRuntime().wrap(function _callee4$(
                    _context4
                  ) {
                    while (1)
                      switch ((_context4.prev = _context4.next)) {
                        case 0:
                          if (_this3.isGiftWrap) {
                            _context4.next = 2;
                            break;
                          }
                          return _context4.abrupt("return");
                        case 2:
                          _this3.isLoading = true;
                          _context4.next = 5;
                          return Alpine.store("cart").changeCart({
                            line: item.line,
                            quantity: _this3.quantity,
                            properties: {
                              "Gift wrap message": _this3.giftWrapMessage,
                            },
                            showFetchCartLoading: false,
                          });
                        case 5:
                          _this3.isLoading = true;
                        case 6:
                        case "end":
                          return _context4.stop();
                      }
                  },
                  _callee4);
                })
              )();
            },
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          CartItem;

        /***/
      },

    /***/ "./src/scripts/objects/facets-main.js":
      /*!********************************************!*\
  !*** ./src/scripts/objects/facets-main.js ***!
  \********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");
        /* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/helpers */ "./src/scripts/utils/helpers.js"
          );
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _regeneratorRuntime() {
          "use strict";
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime =
            function _regeneratorRuntime() {
              return e;
            };
          var t,
            e = {},
            r = Object.prototype,
            n = r.hasOwnProperty,
            o =
              Object.defineProperty ||
              function (t, e, r) {
                t[e] = r.value;
              },
            i = "function" == typeof Symbol ? Symbol : {},
            a = i.iterator || "@@iterator",
            c = i.asyncIterator || "@@asyncIterator",
            u = i.toStringTag || "@@toStringTag";
          function define(t, e, r) {
            return (
              Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              }),
              t[e]
            );
          }
          try {
            define({}, "");
          } catch (t) {
            define = function define(t, e, r) {
              return (t[e] = r);
            };
          }
          function wrap(t, e, r, n) {
            var i = e && e.prototype instanceof Generator ? e : Generator,
              a = Object.create(i.prototype),
              c = new Context(n || []);
            return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a;
          }
          function tryCatch(t, e, r) {
            try {
              return { type: "normal", arg: t.call(e, r) };
            } catch (t) {
              return { type: "throw", arg: t };
            }
          }
          e.wrap = wrap;
          var h = "suspendedStart",
            l = "suspendedYield",
            f = "executing",
            s = "completed",
            y = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          var p = {};
          define(p, a, function () {
            return this;
          });
          var d = Object.getPrototypeOf,
            v = d && d(d(values([])));
          v && v !== r && n.call(v, a) && (p = v);
          var g =
            (GeneratorFunctionPrototype.prototype =
            Generator.prototype =
              Object.create(p));
          function defineIteratorMethods(t) {
            ["next", "throw", "return"].forEach(function (e) {
              define(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function AsyncIterator(t, e) {
            function invoke(r, o, i, a) {
              var c = tryCatch(t[r], t, o);
              if ("throw" !== c.type) {
                var u = c.arg,
                  h = u.value;
                return h && "object" == _typeof(h) && n.call(h, "__await")
                  ? e.resolve(h.__await).then(
                      function (t) {
                        invoke("next", t, i, a);
                      },
                      function (t) {
                        invoke("throw", t, i, a);
                      }
                    )
                  : e.resolve(h).then(
                      function (t) {
                        (u.value = t), i(u);
                      },
                      function (t) {
                        return invoke("throw", t, i, a);
                      }
                    );
              }
              a(c.arg);
            }
            var r;
            o(this, "_invoke", {
              value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                  return new e(function (e, r) {
                    invoke(t, n, e, r);
                  });
                }
                return (r = r
                  ? r.then(
                      callInvokeWithMethodAndArg,
                      callInvokeWithMethodAndArg
                    )
                  : callInvokeWithMethodAndArg());
              },
            });
          }
          function makeInvokeMethod(e, r, n) {
            var o = h;
            return function (i, a) {
              if (o === f) throw new Error("Generator is already running");
              if (o === s) {
                if ("throw" === i) throw a;
                return { value: t, done: !0 };
              }
              for (n.method = i, n.arg = a; ; ) {
                var c = n.delegate;
                if (c) {
                  var u = maybeInvokeDelegate(c, n);
                  if (u) {
                    if (u === y) continue;
                    return u;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                  if (o === h) throw ((o = s), n.arg);
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                  if (((o = n.done ? s : l), p.arg === y)) continue;
                  return { value: p.arg, done: n.done };
                }
                "throw" === p.type &&
                  ((o = s), (n.method = "throw"), (n.arg = p.arg));
              }
            };
          }
          function maybeInvokeDelegate(e, r) {
            var n = r.method,
              o = e.iterator[n];
            if (o === t)
              return (
                (r.delegate = null),
                ("throw" === n &&
                  e.iterator["return"] &&
                  ((r.method = "return"),
                  (r.arg = t),
                  maybeInvokeDelegate(e, r),
                  "throw" === r.method)) ||
                  ("return" !== n &&
                    ((r.method = "throw"),
                    (r.arg = new TypeError(
                      "The iterator does not provide a '" + n + "' method"
                    )))),
                y
              );
            var i = tryCatch(o, e.iterator, r.arg);
            if ("throw" === i.type)
              return (
                (r.method = "throw"), (r.arg = i.arg), (r.delegate = null), y
              );
            var a = i.arg;
            return a
              ? a.done
                ? ((r[e.resultName] = a.value),
                  (r.next = e.nextLoc),
                  "return" !== r.method && ((r.method = "next"), (r.arg = t)),
                  (r.delegate = null),
                  y)
                : a
              : ((r.method = "throw"),
                (r.arg = new TypeError("iterator result is not an object")),
                (r.delegate = null),
                y);
          }
          function pushTryEntry(t) {
            var e = { tryLoc: t[0] };
            1 in t && (e.catchLoc = t[1]),
              2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
              this.tryEntries.push(e);
          }
          function resetTryEntry(t) {
            var e = t.completion || {};
            (e.type = "normal"), delete e.arg, (t.completion = e);
          }
          function Context(t) {
            (this.tryEntries = [{ tryLoc: "root" }]),
              t.forEach(pushTryEntry, this),
              this.reset(!0);
          }
          function values(e) {
            if (e || "" === e) {
              var r = e[a];
              if (r) return r.call(e);
              if ("function" == typeof e.next) return e;
              if (!isNaN(e.length)) {
                var o = -1,
                  i = function next() {
                    for (; ++o < e.length; )
                      if (n.call(e, o))
                        return (next.value = e[o]), (next.done = !1), next;
                    return (next.value = t), (next.done = !0), next;
                  };
                return (i.next = i);
              }
            }
            throw new TypeError(_typeof(e) + " is not iterable");
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            o(g, "constructor", {
              value: GeneratorFunctionPrototype,
              configurable: !0,
            }),
            o(GeneratorFunctionPrototype, "constructor", {
              value: GeneratorFunction,
              configurable: !0,
            }),
            (GeneratorFunction.displayName = define(
              GeneratorFunctionPrototype,
              u,
              "GeneratorFunction"
            )),
            (e.isGeneratorFunction = function (t) {
              var e = "function" == typeof t && t.constructor;
              return (
                !!e &&
                (e === GeneratorFunction ||
                  "GeneratorFunction" === (e.displayName || e.name))
              );
            }),
            (e.mark = function (t) {
              return (
                Object.setPrototypeOf
                  ? Object.setPrototypeOf(t, GeneratorFunctionPrototype)
                  : ((t.__proto__ = GeneratorFunctionPrototype),
                    define(t, u, "GeneratorFunction")),
                (t.prototype = Object.create(g)),
                t
              );
            }),
            (e.awrap = function (t) {
              return { __await: t };
            }),
            defineIteratorMethods(AsyncIterator.prototype),
            define(AsyncIterator.prototype, c, function () {
              return this;
            }),
            (e.AsyncIterator = AsyncIterator),
            (e.async = function (t, r, n, o, i) {
              void 0 === i && (i = Promise);
              var a = new AsyncIterator(wrap(t, r, n, o), i);
              return e.isGeneratorFunction(r)
                ? a
                : a.next().then(function (t) {
                    return t.done ? t.value : a.next();
                  });
            }),
            defineIteratorMethods(g),
            define(g, u, "Generator"),
            define(g, a, function () {
              return this;
            }),
            define(g, "toString", function () {
              return "[object Generator]";
            }),
            (e.keys = function (t) {
              var e = Object(t),
                r = [];
              for (var n in e) r.push(n);
              return (
                r.reverse(),
                function next() {
                  for (; r.length; ) {
                    var t = r.pop();
                    if (t in e) return (next.value = t), (next.done = !1), next;
                  }
                  return (next.done = !0), next;
                }
              );
            }),
            (e.values = values),
            (Context.prototype = {
              constructor: Context,
              reset: function reset(e) {
                if (
                  ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = t),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = t),
                  this.tryEntries.forEach(resetTryEntry),
                  !e)
                )
                  for (var r in this)
                    "t" === r.charAt(0) &&
                      n.call(this, r) &&
                      !isNaN(+r.slice(1)) &&
                      (this[r] = t);
              },
              stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var r = this;
                function handle(n, o) {
                  return (
                    (a.type = "throw"),
                    (a.arg = e),
                    (r.next = n),
                    o && ((r.method = "next"), (r.arg = t)),
                    !!o
                  );
                }
                for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                  var i = this.tryEntries[o],
                    a = i.completion;
                  if ("root" === i.tryLoc) return handle("end");
                  if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"),
                      u = n.call(i, "finallyLoc");
                    if (c && u) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                      if (!u)
                        throw new Error(
                          "try statement without catch or finally"
                        );
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(t, e) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var o = this.tryEntries[r];
                  if (
                    o.tryLoc <= this.prev &&
                    n.call(o, "finallyLoc") &&
                    this.prev < o.finallyLoc
                  ) {
                    var i = o;
                    break;
                  }
                }
                i &&
                  ("break" === t || "continue" === t) &&
                  i.tryLoc <= e &&
                  e <= i.finallyLoc &&
                  (i = null);
                var a = i ? i.completion : {};
                return (
                  (a.type = t),
                  (a.arg = e),
                  i
                    ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                    : this.complete(a)
                );
              },
              complete: function complete(t, e) {
                if ("throw" === t.type) throw t.arg;
                return (
                  "break" === t.type || "continue" === t.type
                    ? (this.next = t.arg)
                    : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                  y
                );
              },
              finish: function finish(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.finallyLoc === t)
                    return (
                      this.complete(r.completion, r.afterLoc),
                      resetTryEntry(r),
                      y
                    );
                }
              },
              catch: function _catch(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                      var o = n.arg;
                      resetTryEntry(r);
                    }
                    return o;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(e, r, n) {
                return (
                  (this.delegate = {
                    iterator: values(e),
                    resultName: r,
                    nextLoc: n,
                  }),
                  "next" === this.method && (this.arg = t),
                  y
                );
              },
            }),
            e
          );
        }
        function asyncGeneratorStep(
          gen,
          resolve,
          reject,
          _next,
          _throw,
          key,
          arg
        ) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }
        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
              args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);
              function _next(value) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "next",
                  value
                );
              }
              function _throw(err) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "throw",
                  err
                );
              }
              _next(undefined);
            });
          };
        }
        function _slicedToArray(arr, i) {
          return (
            _arrayWithHoles(arr) ||
            _iterableToArrayLimit(arr, i) ||
            _unsupportedIterableToArray(arr, i) ||
            _nonIterableRest()
          );
        }
        function _nonIterableRest() {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        }
        function _iterableToArrayLimit(r, l) {
          var t =
            null == r
              ? null
              : ("undefined" != typeof Symbol && r[Symbol.iterator]) ||
                r["@@iterator"];
          if (null != t) {
            var e,
              n,
              i,
              u,
              a = [],
              f = !0,
              o = !1;
            try {
              if (((i = (t = t.call(r)).next), 0 === l)) {
                if (Object(t) !== t) return;
                f = !1;
              } else
                for (
                  ;
                  !(f = (e = i.call(t)).done) &&
                  (a.push(e.value), a.length !== l);
                  f = !0
                );
            } catch (r) {
              (o = !0), (n = r);
            } finally {
              try {
                if (
                  !f &&
                  null != t["return"] &&
                  ((u = t["return"]()), Object(u) !== u)
                )
                  return;
              } finally {
                if (o) throw n;
              }
            }
            return a;
          }
        }
        function _arrayWithHoles(arr) {
          if (Array.isArray(arr)) return arr;
        }
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it =
            (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
            o["@@iterator"];
          if (!it) {
            if (
              Array.isArray(o) ||
              (it = _unsupportedIterableToArray(o)) ||
              (allowArrayLike && o && typeof o.length === "number")
            ) {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return { done: true };
                  return { done: false, value: o[i++] };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }
        function ownKeys(e, r) {
          var t = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r &&
              (o = o.filter(function (r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
              })),
              t.push.apply(t, o);
          }
          return t;
        }
        function _objectSpread(e) {
          for (var r = 1; r < arguments.length; r++) {
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2
              ? ownKeys(Object(t), !0).forEach(function (r) {
                  _defineProperty(e, r, t[r]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
              : ownKeys(Object(t)).forEach(function (r) {
                  Object.defineProperty(
                    e,
                    r,
                    Object.getOwnPropertyDescriptor(t, r)
                  );
                });
          }
          return e;
        }
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }

        var ELEMENTS_TO_UPDATE_CONTENT = [
          "[data-facets-products-grid]",
          "[data-facets-pagination]",
          "[data-facets-products-count-desktop]",
          "[data-facets-products-count-mobile]",
          "[data-facets-filters]",
          "[data-facets-sort]",
        ];
        var facetsMain = function facetsMain(_ref) {
          var sectionId = _ref.sectionId,
            activeSort = _ref.activeSort,
            _ref$isSearch = _ref.isSearch,
            isSearch = _ref$isSearch === void 0 ? false : _ref$isSearch,
            _ref$q = _ref.q,
            q = _ref$q === void 0 ? null : _ref$q;
          return {
            activeSort: activeSort,
            sectionId: sectionId,
            filterSortParams: {},
            isFilterDrawerOpen: false,
            isLoading: false,
            init: function init() {
              this.filterSortParams = this.defaultParams();
            },
            defaultParams: function defaultParams() {
              return _objectSpread(
                {
                  section_id: this.sectionId,
                  sort_by: this.activeSort,
                },
                isSearch &&
                  q && {
                    q: q,
                    "options['prefix']": "last",
                  }
              );
            },
            handleSortChange: function handleSortChange(e) {
              this.activeSort = e.target.value;
              this.filterSortParams = _objectSpread(
                _objectSpread({}, this.filterSortParams),
                {},
                {
                  sort_by: this.activeSort,
                }
              );
              this.handleFormSubmit();
            },
            toggleFilterDrawer: function toggleFilterDrawer() {
              this.isFilterDrawerOpen = !this.isFilterDrawerOpen;
            },
            handleFilterChange: function handleFilterChange() {
              var formElement = this.$refs.filterForm;
              var formData = new FormData(formElement);
              var dataObject = {};
              var _iterator = _createForOfIteratorHelper(formData.entries()),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                  var _step$value = _slicedToArray(_step.value, 2),
                    key = _step$value[0],
                    value = _step$value[1];
                  if (dataObject[key] && Array.isArray(dataObject[key])) {
                    dataObject[key].push(value);
                  } else if (dataObject[key]) {
                    dataObject[key] = [dataObject[key], value];
                  } else {
                    dataObject[key] = value;
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              this.filterSortParams = _objectSpread(
                _objectSpread({}, this.defaultParams()),
                dataObject
              );
              this.handleFormSubmit();
            },
            handlePriceInput: function handlePriceInput(event) {
              var _event$detail = event.detail,
                field = _event$detail.field,
                value = _event$detail.value;
              this.filterSortParams[
                field === "from" ? "filter.v.price.gte" : "filter.v.price.lte"
              ] = value;
              this.handleFormSubmit();
            },
            handleClearClick: function handleClearClick() {
              var resetPriceOnly =
                arguments.length > 0 && arguments[0] !== undefined
                  ? arguments[0]
                  : false;
              if (resetPriceOnly === true) {
                this.filterSortParams["filter.v.price.gte"] = "";
                this.filterSortParams["filter.v.price.lte"] = "";
              } else {
                this.filterSortParams = this.defaultParams();
              }
              this.handleFormSubmit();
            },
            getRequestParams: function getRequestParams() {
              return _objectSpread(
                _objectSpread({}, this.filterSortParams),
                {},
                {
                  section_id: this.sectionId,
                }
              );
            },
            handleFormSubmit: function handleFormSubmit() {
              var _this = this;
              return _asyncToGenerator(
                /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                  var baseEndpoint, serializedParams, fullUrl, response;
                  return _regeneratorRuntime().wrap(
                    function _callee$(_context) {
                      while (1)
                        switch ((_context.prev = _context.next)) {
                          case 0:
                            baseEndpoint = window.location.pathname;
                            serializedParams = (0,
                            _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.toUrlParams)(
                              _this.getRequestParams()
                            );
                            fullUrl = ""
                              .concat(baseEndpoint, "?")
                              .concat(serializedParams);
                            _context.prev = 3;
                            _this.isLoading = true;
                            _context.next = 7;
                            return axios__WEBPACK_IMPORTED_MODULE_1__[
                              "default"
                            ].get(fullUrl);
                          case 7:
                            response = _context.sent;
                            ELEMENTS_TO_UPDATE_CONTENT.forEach(function (el) {
                              return (0,
                              _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.updateDOMContent)(el, response.data);
                            });
                            (0,
                            _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.updateURL)(
                              ""
                                .concat(baseEndpoint, "?")
                                .concat(
                                  (0,
                                  _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.toFilteredUrlParams)(
                                    _this.getRequestParams()
                                  )
                                )
                            );
                            _context.next = 15;
                            break;
                          case 12:
                            _context.prev = 12;
                            _context.t0 = _context["catch"](3);
                            throw new Error("Error in `handleFormSubmit`");
                          case 15:
                            _context.prev = 15;
                            _this.isLoading = false;
                            return _context.finish(15);
                          case 18:
                          case "end":
                            return _context.stop();
                        }
                    },
                    _callee,
                    null,
                    [[3, 12, 15, 18]]
                  );
                })
              )();
            },
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          facetsMain;

        /***/
      },

    /***/ "./src/scripts/objects/price-range.js":
      /*!********************************************!*\
  !*** ./src/scripts/objects/price-range.js ***!
  \********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! lodash-es */ "./node_modules/lodash-es/debounce.js"
          );

        var PriceRange = function PriceRange(_ref) {
          var maxInputAllowed = _ref.maxInputAllowed,
            initialFromValue = _ref.initialFromValue,
            initialToValue = _ref.initialToValue;
          return {
            maxInputAllowed: Number(maxInputAllowed) || 0,
            fromValue: Number(initialFromValue) || "",
            toValue: Number(initialToValue) || "",
            constrainValue: function constrainValue(value) {
              if (value <= 0) return 0;
              if (value > this.maxInputAllowed) return this.maxInputAllowed;
              return Number(value);
            },
            handleFromValueInput: (0,
            lodash_es__WEBPACK_IMPORTED_MODULE_0__["default"])(function () {
              this.fromValue = this.constrainValue(this.fromValue);
              this.$dispatch("price-input", {
                field: "from",
                value: this.fromValue,
              });
            }, 500),
            handleToValueInput: (0,
            lodash_es__WEBPACK_IMPORTED_MODULE_0__["default"])(function () {
              this.toValue = this.constrainValue(this.toValue);
              this.$dispatch("price-input", {
                field: "to",
                value: this.toValue,
              });
            }, 500),
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          PriceRange;

        /***/
      },

    /***/ "./src/scripts/objects/product-complementary.js":
      /*!******************************************************!*\
  !*** ./src/scripts/objects/product-complementary.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _regeneratorRuntime() {
          "use strict";
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime =
            function _regeneratorRuntime() {
              return e;
            };
          var t,
            e = {},
            r = Object.prototype,
            n = r.hasOwnProperty,
            o =
              Object.defineProperty ||
              function (t, e, r) {
                t[e] = r.value;
              },
            i = "function" == typeof Symbol ? Symbol : {},
            a = i.iterator || "@@iterator",
            c = i.asyncIterator || "@@asyncIterator",
            u = i.toStringTag || "@@toStringTag";
          function define(t, e, r) {
            return (
              Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              }),
              t[e]
            );
          }
          try {
            define({}, "");
          } catch (t) {
            define = function define(t, e, r) {
              return (t[e] = r);
            };
          }
          function wrap(t, e, r, n) {
            var i = e && e.prototype instanceof Generator ? e : Generator,
              a = Object.create(i.prototype),
              c = new Context(n || []);
            return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a;
          }
          function tryCatch(t, e, r) {
            try {
              return { type: "normal", arg: t.call(e, r) };
            } catch (t) {
              return { type: "throw", arg: t };
            }
          }
          e.wrap = wrap;
          var h = "suspendedStart",
            l = "suspendedYield",
            f = "executing",
            s = "completed",
            y = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          var p = {};
          define(p, a, function () {
            return this;
          });
          var d = Object.getPrototypeOf,
            v = d && d(d(values([])));
          v && v !== r && n.call(v, a) && (p = v);
          var g =
            (GeneratorFunctionPrototype.prototype =
            Generator.prototype =
              Object.create(p));
          function defineIteratorMethods(t) {
            ["next", "throw", "return"].forEach(function (e) {
              define(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function AsyncIterator(t, e) {
            function invoke(r, o, i, a) {
              var c = tryCatch(t[r], t, o);
              if ("throw" !== c.type) {
                var u = c.arg,
                  h = u.value;
                return h && "object" == _typeof(h) && n.call(h, "__await")
                  ? e.resolve(h.__await).then(
                      function (t) {
                        invoke("next", t, i, a);
                      },
                      function (t) {
                        invoke("throw", t, i, a);
                      }
                    )
                  : e.resolve(h).then(
                      function (t) {
                        (u.value = t), i(u);
                      },
                      function (t) {
                        return invoke("throw", t, i, a);
                      }
                    );
              }
              a(c.arg);
            }
            var r;
            o(this, "_invoke", {
              value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                  return new e(function (e, r) {
                    invoke(t, n, e, r);
                  });
                }
                return (r = r
                  ? r.then(
                      callInvokeWithMethodAndArg,
                      callInvokeWithMethodAndArg
                    )
                  : callInvokeWithMethodAndArg());
              },
            });
          }
          function makeInvokeMethod(e, r, n) {
            var o = h;
            return function (i, a) {
              if (o === f) throw new Error("Generator is already running");
              if (o === s) {
                if ("throw" === i) throw a;
                return { value: t, done: !0 };
              }
              for (n.method = i, n.arg = a; ; ) {
                var c = n.delegate;
                if (c) {
                  var u = maybeInvokeDelegate(c, n);
                  if (u) {
                    if (u === y) continue;
                    return u;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                  if (o === h) throw ((o = s), n.arg);
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                  if (((o = n.done ? s : l), p.arg === y)) continue;
                  return { value: p.arg, done: n.done };
                }
                "throw" === p.type &&
                  ((o = s), (n.method = "throw"), (n.arg = p.arg));
              }
            };
          }
          function maybeInvokeDelegate(e, r) {
            var n = r.method,
              o = e.iterator[n];
            if (o === t)
              return (
                (r.delegate = null),
                ("throw" === n &&
                  e.iterator["return"] &&
                  ((r.method = "return"),
                  (r.arg = t),
                  maybeInvokeDelegate(e, r),
                  "throw" === r.method)) ||
                  ("return" !== n &&
                    ((r.method = "throw"),
                    (r.arg = new TypeError(
                      "The iterator does not provide a '" + n + "' method"
                    )))),
                y
              );
            var i = tryCatch(o, e.iterator, r.arg);
            if ("throw" === i.type)
              return (
                (r.method = "throw"), (r.arg = i.arg), (r.delegate = null), y
              );
            var a = i.arg;
            return a
              ? a.done
                ? ((r[e.resultName] = a.value),
                  (r.next = e.nextLoc),
                  "return" !== r.method && ((r.method = "next"), (r.arg = t)),
                  (r.delegate = null),
                  y)
                : a
              : ((r.method = "throw"),
                (r.arg = new TypeError("iterator result is not an object")),
                (r.delegate = null),
                y);
          }
          function pushTryEntry(t) {
            var e = { tryLoc: t[0] };
            1 in t && (e.catchLoc = t[1]),
              2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
              this.tryEntries.push(e);
          }
          function resetTryEntry(t) {
            var e = t.completion || {};
            (e.type = "normal"), delete e.arg, (t.completion = e);
          }
          function Context(t) {
            (this.tryEntries = [{ tryLoc: "root" }]),
              t.forEach(pushTryEntry, this),
              this.reset(!0);
          }
          function values(e) {
            if (e || "" === e) {
              var r = e[a];
              if (r) return r.call(e);
              if ("function" == typeof e.next) return e;
              if (!isNaN(e.length)) {
                var o = -1,
                  i = function next() {
                    for (; ++o < e.length; )
                      if (n.call(e, o))
                        return (next.value = e[o]), (next.done = !1), next;
                    return (next.value = t), (next.done = !0), next;
                  };
                return (i.next = i);
              }
            }
            throw new TypeError(_typeof(e) + " is not iterable");
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            o(g, "constructor", {
              value: GeneratorFunctionPrototype,
              configurable: !0,
            }),
            o(GeneratorFunctionPrototype, "constructor", {
              value: GeneratorFunction,
              configurable: !0,
            }),
            (GeneratorFunction.displayName = define(
              GeneratorFunctionPrototype,
              u,
              "GeneratorFunction"
            )),
            (e.isGeneratorFunction = function (t) {
              var e = "function" == typeof t && t.constructor;
              return (
                !!e &&
                (e === GeneratorFunction ||
                  "GeneratorFunction" === (e.displayName || e.name))
              );
            }),
            (e.mark = function (t) {
              return (
                Object.setPrototypeOf
                  ? Object.setPrototypeOf(t, GeneratorFunctionPrototype)
                  : ((t.__proto__ = GeneratorFunctionPrototype),
                    define(t, u, "GeneratorFunction")),
                (t.prototype = Object.create(g)),
                t
              );
            }),
            (e.awrap = function (t) {
              return { __await: t };
            }),
            defineIteratorMethods(AsyncIterator.prototype),
            define(AsyncIterator.prototype, c, function () {
              return this;
            }),
            (e.AsyncIterator = AsyncIterator),
            (e.async = function (t, r, n, o, i) {
              void 0 === i && (i = Promise);
              var a = new AsyncIterator(wrap(t, r, n, o), i);
              return e.isGeneratorFunction(r)
                ? a
                : a.next().then(function (t) {
                    return t.done ? t.value : a.next();
                  });
            }),
            defineIteratorMethods(g),
            define(g, u, "Generator"),
            define(g, a, function () {
              return this;
            }),
            define(g, "toString", function () {
              return "[object Generator]";
            }),
            (e.keys = function (t) {
              var e = Object(t),
                r = [];
              for (var n in e) r.push(n);
              return (
                r.reverse(),
                function next() {
                  for (; r.length; ) {
                    var t = r.pop();
                    if (t in e) return (next.value = t), (next.done = !1), next;
                  }
                  return (next.done = !0), next;
                }
              );
            }),
            (e.values = values),
            (Context.prototype = {
              constructor: Context,
              reset: function reset(e) {
                if (
                  ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = t),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = t),
                  this.tryEntries.forEach(resetTryEntry),
                  !e)
                )
                  for (var r in this)
                    "t" === r.charAt(0) &&
                      n.call(this, r) &&
                      !isNaN(+r.slice(1)) &&
                      (this[r] = t);
              },
              stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var r = this;
                function handle(n, o) {
                  return (
                    (a.type = "throw"),
                    (a.arg = e),
                    (r.next = n),
                    o && ((r.method = "next"), (r.arg = t)),
                    !!o
                  );
                }
                for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                  var i = this.tryEntries[o],
                    a = i.completion;
                  if ("root" === i.tryLoc) return handle("end");
                  if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"),
                      u = n.call(i, "finallyLoc");
                    if (c && u) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                      if (!u)
                        throw new Error(
                          "try statement without catch or finally"
                        );
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(t, e) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var o = this.tryEntries[r];
                  if (
                    o.tryLoc <= this.prev &&
                    n.call(o, "finallyLoc") &&
                    this.prev < o.finallyLoc
                  ) {
                    var i = o;
                    break;
                  }
                }
                i &&
                  ("break" === t || "continue" === t) &&
                  i.tryLoc <= e &&
                  e <= i.finallyLoc &&
                  (i = null);
                var a = i ? i.completion : {};
                return (
                  (a.type = t),
                  (a.arg = e),
                  i
                    ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                    : this.complete(a)
                );
              },
              complete: function complete(t, e) {
                if ("throw" === t.type) throw t.arg;
                return (
                  "break" === t.type || "continue" === t.type
                    ? (this.next = t.arg)
                    : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                  y
                );
              },
              finish: function finish(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.finallyLoc === t)
                    return (
                      this.complete(r.completion, r.afterLoc),
                      resetTryEntry(r),
                      y
                    );
                }
              },
              catch: function _catch(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                      var o = n.arg;
                      resetTryEntry(r);
                    }
                    return o;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(e, r, n) {
                return (
                  (this.delegate = {
                    iterator: values(e),
                    resultName: r,
                    nextLoc: n,
                  }),
                  "next" === this.method && (this.arg = t),
                  y
                );
              },
            }),
            e
          );
        }
        function asyncGeneratorStep(
          gen,
          resolve,
          reject,
          _next,
          _throw,
          key,
          arg
        ) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }
        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
              args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);
              function _next(value) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "next",
                  value
                );
              }
              function _throw(err) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "throw",
                  err
                );
              }
              _next(undefined);
            });
          };
        }

        var ProductComplementary = function ProductComplementary(_ref) {
          var variantId = _ref.variantId;
          return {
            isAddingToCart: false,
            handleAddToCart: function handleAddToCart() {
              var _this = this;
              return _asyncToGenerator(
                /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                  var _yield$Alpine$store$a, success;
                  return _regeneratorRuntime().wrap(
                    function _callee$(_context) {
                      while (1)
                        switch ((_context.prev = _context.next)) {
                          case 0:
                            if (window.cartAddUrl) {
                              _context.next = 2;
                              break;
                            }
                            return _context.abrupt("return");
                          case 2:
                            _context.prev = 2;
                            _this.isAddingToCart = true;
                            _context.next = 6;
                            return Alpine.store("cart").addToCart({
                              quantity: 1,
                              variantId: variantId,
                            });
                          case 6:
                            _yield$Alpine$store$a = _context.sent;
                            success = _yield$Alpine$store$a.success;
                            if (!(success === false)) {
                              _context.next = 10;
                              break;
                            }
                            throw new Error(
                              "Error in adding complementary product to cart"
                            );
                          case 10:
                            _context.next = 16;
                            break;
                          case 12:
                            _context.prev = 12;
                            _context.t0 = _context["catch"](2);
                            if (_context.t0.response.data.description) {
                              alert(_context.t0.response.data.description);
                            }
                            console.log("Error in adding to cart");
                          case 16:
                            _context.prev = 16;
                            _this.isAddingToCart = false;
                            return _context.finish(16);
                          case 19:
                          case "end":
                            return _context.stop();
                        }
                    },
                    _callee,
                    null,
                    [[2, 12, 16, 19]]
                  );
                })
              )();
            },
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          ProductComplementary;

        /***/
      },

    /***/ "./src/scripts/objects/product-gallery.js":
      /*!************************************************!*\
  !*** ./src/scripts/objects/product-gallery.js ***!
  \************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.mjs");
        /* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! swiper/modules */ "./node_modules/swiper/modules/index.mjs"
          );
        /* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! swiper/css */ "./node_modules/swiper/swiper.css"
          );
        /* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! swiper/css/scrollbar */ "./node_modules/swiper/modules/scrollbar.css"
          );
        /* harmony import */ var swiper_css_thumbs__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! swiper/css/thumbs */ "./node_modules/swiper/modules/thumbs.css"
          );
        /* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! swiper/css/navigation */ "./node_modules/swiper/modules/navigation.css"
          );

        var ProductGallery = function ProductGallery(_ref) {
          var activeMedia = _ref.activeMedia;
          return {
            activeMedia: activeMedia,
            init: function init() {
              var _this = this;
              this.initGallery();
              document.addEventListener(
                "active-media-change",
                function (event) {
                  _this.activeMedia = event.detail.activeMedia;
                  if (!_this.mainGallery) return;
                  _this.mainGallery.slideTo(_this.activeMedia - 1);
                }
              );
            },
            mainGallery: null,
            navGallery: null,
            initGallery: function initGallery() {
              this.navGallery = new swiper__WEBPACK_IMPORTED_MODULE_0__[
                "default"
              ](this.$refs.navSwiper, {
                direction: "vertical",
                grabCursor: true,
                resistanceRatio: 0,
                slidesPerView: 5,
                spaceBetween: 16,
                watchSlidesProgress: true,
              });
              this.mainGallery = new swiper__WEBPACK_IMPORTED_MODULE_0__[
                "default"
              ](this.$refs.mainSwiper, {
                breakpoints: {
                  990: {
                    scrollbar: {
                      enabled: false,
                    },
                    navigation: {
                      enabled: true,
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    },
                  },
                },
                grabCursor: true,
                modules: [
                  swiper_modules__WEBPACK_IMPORTED_MODULE_1__.Scrollbar,
                  swiper_modules__WEBPACK_IMPORTED_MODULE_1__.Thumbs,
                  swiper_modules__WEBPACK_IMPORTED_MODULE_1__.Navigation,
                ],
                navigation: {
                  enabled: false,
                },
                resistanceRatio: 0,
                scrollbar: {
                  draggable: true,
                  enabled: true,
                  el: ".swiper-scrollbar",
                },
                spaceBetween: 0,
                thumbs: {
                  swiper: this.navGallery,
                },
              });
            },
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          ProductGallery;

        /***/
      },

    /***/ "./src/scripts/objects/quantity-field.js":
      /*!***********************************************!*\
  !*** ./src/scripts/objects/quantity-field.js ***!
  \***********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        var QuantityField = function QuantityField(_ref) {
          var max = _ref.max,
            value = _ref.value,
            _ref$min = _ref.min,
            min = _ref$min === void 0 ? 0 : _ref$min;
          return {
            value: Number(value),
            isMaxReached: max === 0 || Number(value) === max,
            isMinReached: max === 0 || Number(value) === min,
            clampValue: function clampValue(inputValue) {
              if (inputValue > max) return max;
              if (inputValue < min || inputValue < 0) return min;
              return inputValue;
            },
            updateMinMaxFlags: function updateMinMaxFlags() {
              this.isMaxReached = this.value === max;
              this.isMinReached = this.value === min;
            },
            handleInputChange: function handleInputChange() {
              // Accept only numbers
              if (!/^\d*$/.test(this.value)) {
                this.value = this.value.replace(/\D/g, "");
                return;
              }
              this.value = this.clampValue(Number(this.value));
              this.updateMinMaxFlags();
              this.$dispatch("quantity-change", {
                value: this.value,
              });
            },
            handleButtonClick: function handleButtonClick(direction) {
              if (direction === "minus") {
                this.value = this.clampValue(this.value - 1);
              } else if (direction === "plus") {
                this.value = this.clampValue(this.value + 1);
              }
              this.updateMinMaxFlags();
              this.$dispatch("quantity-change", {
                value: this.value,
              });
            },
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          QuantityField;

        /***/
      },

    /***/ "./src/scripts/sections/header-main.js":
      /*!*********************************************!*\
  !*** ./src/scripts/sections/header-main.js ***!
  \*********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! lodash-es */ "./node_modules/lodash-es/throttle.js"
          );
        /* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/helpers */ "./src/scripts/utils/helpers.js"
          );
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }

        var HeaderMain = function HeaderMain() {
          return {
            hasScrolled: false,
            isMainMenuOpen: false,
            activeParentMenu: null,
            activeSubmenu: null,
            isHeaderSearchOpen: false,
            init: function init() {
              this.checkScrollPosition();
              window.addEventListener(
                "scroll",
                (0, lodash_es__WEBPACK_IMPORTED_MODULE_1__["default"])(
                  this.checkScrollPosition.bind(this),
                  150
                )
              );
            },
            checkScrollPosition: function checkScrollPosition() {
              var announcementBarHeight = parseFloat(
                getComputedStyle(document.documentElement).getPropertyValue(
                  "--announcement-bar-height"
                )
              );
              if (window.scrollY > announcementBarHeight) {
                this.hasScrolled = true;
              } else {
                this.hasScrolled = false;
              }
            },
            toggleMainMenu: function toggleMainMenu() {
              this.isMainMenuOpen = !this.isMainMenuOpen;
              this.isHeaderSearchOpen = false;
              if (this.isMainMenuOpen === false) {
                this.activeSubmenu = null;
                this.activeParentMenu = null;
                Alpine.store("localization").isCountrySelectorOpen = false;
              }
              document.body.classList.toggle("no-scroll", this.isMainMenuOpen);
            },
            setActiveParentMenu: function setActiveParentMenu(e) {
              var linkHandle =
                arguments.length > 1 && arguments[1] !== undefined
                  ? arguments[1]
                  : null;
              if (
                window.matchMedia("(min-width: 990px)").matches === false &&
                e.type === "click"
              ) {
                e.preventDefault();
              }
              this.activeParentMenu =
                typeof linkHandle === "string" ||
                _typeof(linkHandle) === undefined
                  ? linkHandle
                  : null;
              document.body.classList.toggle(
                "no-scroll",
                this.activeParentMenu !== null
              );
            },
            toggleHeaderSearch: function toggleHeaderSearch(state) {
              var _this = this;
              this.isMainMenuOpen = false;
              if (state === undefined) {
                this.isHeaderSearchOpen = state;
                return;
              }
              this.isHeaderSearchOpen = !this.isHeaderSearchOpen;
              if (this.isHeaderSearchOpen === true) {
                this.$nextTick(function () {
                  _this.$refs.searchInput.focus();
                });
              }
            },
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          HeaderMain;

        /***/
      },

    /***/ "./src/scripts/sections/klaviyo-newsletter.js":
      /*!****************************************************!*\
  !*** ./src/scripts/sections/klaviyo-newsletter.js ***!
  \****************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");
        /* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/helpers */ "./src/scripts/utils/helpers.js"
          );
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _regeneratorRuntime() {
          "use strict";
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime =
            function _regeneratorRuntime() {
              return e;
            };
          var t,
            e = {},
            r = Object.prototype,
            n = r.hasOwnProperty,
            o =
              Object.defineProperty ||
              function (t, e, r) {
                t[e] = r.value;
              },
            i = "function" == typeof Symbol ? Symbol : {},
            a = i.iterator || "@@iterator",
            c = i.asyncIterator || "@@asyncIterator",
            u = i.toStringTag || "@@toStringTag";
          function define(t, e, r) {
            return (
              Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              }),
              t[e]
            );
          }
          try {
            define({}, "");
          } catch (t) {
            define = function define(t, e, r) {
              return (t[e] = r);
            };
          }
          function wrap(t, e, r, n) {
            var i = e && e.prototype instanceof Generator ? e : Generator,
              a = Object.create(i.prototype),
              c = new Context(n || []);
            return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a;
          }
          function tryCatch(t, e, r) {
            try {
              return { type: "normal", arg: t.call(e, r) };
            } catch (t) {
              return { type: "throw", arg: t };
            }
          }
          e.wrap = wrap;
          var h = "suspendedStart",
            l = "suspendedYield",
            f = "executing",
            s = "completed",
            y = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          var p = {};
          define(p, a, function () {
            return this;
          });
          var d = Object.getPrototypeOf,
            v = d && d(d(values([])));
          v && v !== r && n.call(v, a) && (p = v);
          var g =
            (GeneratorFunctionPrototype.prototype =
            Generator.prototype =
              Object.create(p));
          function defineIteratorMethods(t) {
            ["next", "throw", "return"].forEach(function (e) {
              define(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function AsyncIterator(t, e) {
            function invoke(r, o, i, a) {
              var c = tryCatch(t[r], t, o);
              if ("throw" !== c.type) {
                var u = c.arg,
                  h = u.value;
                return h && "object" == _typeof(h) && n.call(h, "__await")
                  ? e.resolve(h.__await).then(
                      function (t) {
                        invoke("next", t, i, a);
                      },
                      function (t) {
                        invoke("throw", t, i, a);
                      }
                    )
                  : e.resolve(h).then(
                      function (t) {
                        (u.value = t), i(u);
                      },
                      function (t) {
                        return invoke("throw", t, i, a);
                      }
                    );
              }
              a(c.arg);
            }
            var r;
            o(this, "_invoke", {
              value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                  return new e(function (e, r) {
                    invoke(t, n, e, r);
                  });
                }
                return (r = r
                  ? r.then(
                      callInvokeWithMethodAndArg,
                      callInvokeWithMethodAndArg
                    )
                  : callInvokeWithMethodAndArg());
              },
            });
          }
          function makeInvokeMethod(e, r, n) {
            var o = h;
            return function (i, a) {
              if (o === f) throw new Error("Generator is already running");
              if (o === s) {
                if ("throw" === i) throw a;
                return { value: t, done: !0 };
              }
              for (n.method = i, n.arg = a; ; ) {
                var c = n.delegate;
                if (c) {
                  var u = maybeInvokeDelegate(c, n);
                  if (u) {
                    if (u === y) continue;
                    return u;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                  if (o === h) throw ((o = s), n.arg);
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                  if (((o = n.done ? s : l), p.arg === y)) continue;
                  return { value: p.arg, done: n.done };
                }
                "throw" === p.type &&
                  ((o = s), (n.method = "throw"), (n.arg = p.arg));
              }
            };
          }
          function maybeInvokeDelegate(e, r) {
            var n = r.method,
              o = e.iterator[n];
            if (o === t)
              return (
                (r.delegate = null),
                ("throw" === n &&
                  e.iterator["return"] &&
                  ((r.method = "return"),
                  (r.arg = t),
                  maybeInvokeDelegate(e, r),
                  "throw" === r.method)) ||
                  ("return" !== n &&
                    ((r.method = "throw"),
                    (r.arg = new TypeError(
                      "The iterator does not provide a '" + n + "' method"
                    )))),
                y
              );
            var i = tryCatch(o, e.iterator, r.arg);
            if ("throw" === i.type)
              return (
                (r.method = "throw"), (r.arg = i.arg), (r.delegate = null), y
              );
            var a = i.arg;
            return a
              ? a.done
                ? ((r[e.resultName] = a.value),
                  (r.next = e.nextLoc),
                  "return" !== r.method && ((r.method = "next"), (r.arg = t)),
                  (r.delegate = null),
                  y)
                : a
              : ((r.method = "throw"),
                (r.arg = new TypeError("iterator result is not an object")),
                (r.delegate = null),
                y);
          }
          function pushTryEntry(t) {
            var e = { tryLoc: t[0] };
            1 in t && (e.catchLoc = t[1]),
              2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
              this.tryEntries.push(e);
          }
          function resetTryEntry(t) {
            var e = t.completion || {};
            (e.type = "normal"), delete e.arg, (t.completion = e);
          }
          function Context(t) {
            (this.tryEntries = [{ tryLoc: "root" }]),
              t.forEach(pushTryEntry, this),
              this.reset(!0);
          }
          function values(e) {
            if (e || "" === e) {
              var r = e[a];
              if (r) return r.call(e);
              if ("function" == typeof e.next) return e;
              if (!isNaN(e.length)) {
                var o = -1,
                  i = function next() {
                    for (; ++o < e.length; )
                      if (n.call(e, o))
                        return (next.value = e[o]), (next.done = !1), next;
                    return (next.value = t), (next.done = !0), next;
                  };
                return (i.next = i);
              }
            }
            throw new TypeError(_typeof(e) + " is not iterable");
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            o(g, "constructor", {
              value: GeneratorFunctionPrototype,
              configurable: !0,
            }),
            o(GeneratorFunctionPrototype, "constructor", {
              value: GeneratorFunction,
              configurable: !0,
            }),
            (GeneratorFunction.displayName = define(
              GeneratorFunctionPrototype,
              u,
              "GeneratorFunction"
            )),
            (e.isGeneratorFunction = function (t) {
              var e = "function" == typeof t && t.constructor;
              return (
                !!e &&
                (e === GeneratorFunction ||
                  "GeneratorFunction" === (e.displayName || e.name))
              );
            }),
            (e.mark = function (t) {
              return (
                Object.setPrototypeOf
                  ? Object.setPrototypeOf(t, GeneratorFunctionPrototype)
                  : ((t.__proto__ = GeneratorFunctionPrototype),
                    define(t, u, "GeneratorFunction")),
                (t.prototype = Object.create(g)),
                t
              );
            }),
            (e.awrap = function (t) {
              return { __await: t };
            }),
            defineIteratorMethods(AsyncIterator.prototype),
            define(AsyncIterator.prototype, c, function () {
              return this;
            }),
            (e.AsyncIterator = AsyncIterator),
            (e.async = function (t, r, n, o, i) {
              void 0 === i && (i = Promise);
              var a = new AsyncIterator(wrap(t, r, n, o), i);
              return e.isGeneratorFunction(r)
                ? a
                : a.next().then(function (t) {
                    return t.done ? t.value : a.next();
                  });
            }),
            defineIteratorMethods(g),
            define(g, u, "Generator"),
            define(g, a, function () {
              return this;
            }),
            define(g, "toString", function () {
              return "[object Generator]";
            }),
            (e.keys = function (t) {
              var e = Object(t),
                r = [];
              for (var n in e) r.push(n);
              return (
                r.reverse(),
                function next() {
                  for (; r.length; ) {
                    var t = r.pop();
                    if (t in e) return (next.value = t), (next.done = !1), next;
                  }
                  return (next.done = !0), next;
                }
              );
            }),
            (e.values = values),
            (Context.prototype = {
              constructor: Context,
              reset: function reset(e) {
                if (
                  ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = t),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = t),
                  this.tryEntries.forEach(resetTryEntry),
                  !e)
                )
                  for (var r in this)
                    "t" === r.charAt(0) &&
                      n.call(this, r) &&
                      !isNaN(+r.slice(1)) &&
                      (this[r] = t);
              },
              stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var r = this;
                function handle(n, o) {
                  return (
                    (a.type = "throw"),
                    (a.arg = e),
                    (r.next = n),
                    o && ((r.method = "next"), (r.arg = t)),
                    !!o
                  );
                }
                for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                  var i = this.tryEntries[o],
                    a = i.completion;
                  if ("root" === i.tryLoc) return handle("end");
                  if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"),
                      u = n.call(i, "finallyLoc");
                    if (c && u) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                      if (!u)
                        throw new Error(
                          "try statement without catch or finally"
                        );
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(t, e) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var o = this.tryEntries[r];
                  if (
                    o.tryLoc <= this.prev &&
                    n.call(o, "finallyLoc") &&
                    this.prev < o.finallyLoc
                  ) {
                    var i = o;
                    break;
                  }
                }
                i &&
                  ("break" === t || "continue" === t) &&
                  i.tryLoc <= e &&
                  e <= i.finallyLoc &&
                  (i = null);
                var a = i ? i.completion : {};
                return (
                  (a.type = t),
                  (a.arg = e),
                  i
                    ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                    : this.complete(a)
                );
              },
              complete: function complete(t, e) {
                if ("throw" === t.type) throw t.arg;
                return (
                  "break" === t.type || "continue" === t.type
                    ? (this.next = t.arg)
                    : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                  y
                );
              },
              finish: function finish(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.finallyLoc === t)
                    return (
                      this.complete(r.completion, r.afterLoc),
                      resetTryEntry(r),
                      y
                    );
                }
              },
              catch: function _catch(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                      var o = n.arg;
                      resetTryEntry(r);
                    }
                    return o;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(e, r, n) {
                return (
                  (this.delegate = {
                    iterator: values(e),
                    resultName: r,
                    nextLoc: n,
                  }),
                  "next" === this.method && (this.arg = t),
                  y
                );
              },
            }),
            e
          );
        }
        function asyncGeneratorStep(
          gen,
          resolve,
          reject,
          _next,
          _throw,
          key,
          arg
        ) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }
        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
              args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);
              function _next(value) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "next",
                  value
                );
              }
              function _throw(err) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "throw",
                  err
                );
              }
              _next(undefined);
            });
          };
        }

        var KlaviyoNewsletter = function KlaviyoNewsletter(_ref) {
          var klaviyoListId = _ref.klaviyoListId;
          return {
            isLoading: false,
            isSubmittedOnce: false,
            isSubmitSuccess: false,
            hasError: false,
            email: "",
            handleInput: function handleInput() {
              if (this.isSubmittedOnce) {
                this.hasError = !(0,
                _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.isEmailValid)(
                  this.email
                );
                console.log(this.hasError, "has er");
              }
            },
            handleFormSubmit: function handleFormSubmit() {
              var _this = this;
              return _asyncToGenerator(
                /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                  var reqParams, response, data;
                  return _regeneratorRuntime().wrap(
                    function _callee$(_context) {
                      while (1)
                        switch ((_context.prev = _context.next)) {
                          case 0:
                            _this.isSubmittedOnce = true;
                            if (
                              !(
                                !(0,
                                _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.isEmailValid)(
                                  _this.email
                                ) ||
                                _this.email === "" ||
                                _this.hasError ||
                                !klaviyoListId
                              )
                            ) {
                              _context.next = 4;
                              break;
                            }
                            _this.hasError = true;
                            return _context.abrupt("return");
                          case 4:
                            _this.isSubmittedOnce = true;
                            _this.isLoading = true;
                            reqParams = {
                              g: klaviyoListId,
                              email: _this.email,
                            };
                            _context.prev = 7;
                            _context.next = 10;
                            return axios__WEBPACK_IMPORTED_MODULE_1__[
                              "default"
                            ].post(
                              "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
                              new URLSearchParams(reqParams).toString(),
                              {
                                headers: {
                                  "Content-Type":
                                    "application/x-www-form-urlencoded",
                                  "Cache-Control": "no-cache",
                                },
                              }
                            );
                          case 10:
                            response = _context.sent;
                            data = response.data;
                            if (data.success) {
                              _this.isSubmitSuccess = true;
                              _this.hasError = false;
                            }
                            _context.next = 20;
                            break;
                          case 15:
                            _context.prev = 15;
                            _context.t0 = _context["catch"](7);
                            console.error("Error:", _context.t0);
                            _this.isSubmitSuccess = false;
                            _this.hasError = true;
                          case 20:
                            _context.prev = 20;
                            _this.isLoading = false;
                            return _context.finish(20);
                          case 23:
                          case "end":
                            return _context.stop();
                        }
                    },
                    _callee,
                    null,
                    [[7, 15, 20, 23]]
                  );
                })
              )();
            },
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          KlaviyoNewsletter;

        /***/
      },

    /***/ "./src/scripts/sections/product-main.js":
      /*!**********************************************!*\
  !*** ./src/scripts/sections/product-main.js ***!
  \**********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");
        /* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/helpers */ "./src/scripts/utils/helpers.js"
          );
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }
        function ownKeys(e, r) {
          var t = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r &&
              (o = o.filter(function (r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
              })),
              t.push.apply(t, o);
          }
          return t;
        }
        function _objectSpread(e) {
          for (var r = 1; r < arguments.length; r++) {
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2
              ? ownKeys(Object(t), !0).forEach(function (r) {
                  _defineProperty(e, r, t[r]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
              : ownKeys(Object(t)).forEach(function (r) {
                  Object.defineProperty(
                    e,
                    r,
                    Object.getOwnPropertyDescriptor(t, r)
                  );
                });
          }
          return e;
        }
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }
        function _regeneratorRuntime() {
          "use strict";
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime =
            function _regeneratorRuntime() {
              return e;
            };
          var t,
            e = {},
            r = Object.prototype,
            n = r.hasOwnProperty,
            o =
              Object.defineProperty ||
              function (t, e, r) {
                t[e] = r.value;
              },
            i = "function" == typeof Symbol ? Symbol : {},
            a = i.iterator || "@@iterator",
            c = i.asyncIterator || "@@asyncIterator",
            u = i.toStringTag || "@@toStringTag";
          function define(t, e, r) {
            return (
              Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              }),
              t[e]
            );
          }
          try {
            define({}, "");
          } catch (t) {
            define = function define(t, e, r) {
              return (t[e] = r);
            };
          }
          function wrap(t, e, r, n) {
            var i = e && e.prototype instanceof Generator ? e : Generator,
              a = Object.create(i.prototype),
              c = new Context(n || []);
            return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a;
          }
          function tryCatch(t, e, r) {
            try {
              return { type: "normal", arg: t.call(e, r) };
            } catch (t) {
              return { type: "throw", arg: t };
            }
          }
          e.wrap = wrap;
          var h = "suspendedStart",
            l = "suspendedYield",
            f = "executing",
            s = "completed",
            y = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          var p = {};
          define(p, a, function () {
            return this;
          });
          var d = Object.getPrototypeOf,
            v = d && d(d(values([])));
          v && v !== r && n.call(v, a) && (p = v);
          var g =
            (GeneratorFunctionPrototype.prototype =
            Generator.prototype =
              Object.create(p));
          function defineIteratorMethods(t) {
            ["next", "throw", "return"].forEach(function (e) {
              define(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function AsyncIterator(t, e) {
            function invoke(r, o, i, a) {
              var c = tryCatch(t[r], t, o);
              if ("throw" !== c.type) {
                var u = c.arg,
                  h = u.value;
                return h && "object" == _typeof(h) && n.call(h, "__await")
                  ? e.resolve(h.__await).then(
                      function (t) {
                        invoke("next", t, i, a);
                      },
                      function (t) {
                        invoke("throw", t, i, a);
                      }
                    )
                  : e.resolve(h).then(
                      function (t) {
                        (u.value = t), i(u);
                      },
                      function (t) {
                        return invoke("throw", t, i, a);
                      }
                    );
              }
              a(c.arg);
            }
            var r;
            o(this, "_invoke", {
              value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                  return new e(function (e, r) {
                    invoke(t, n, e, r);
                  });
                }
                return (r = r
                  ? r.then(
                      callInvokeWithMethodAndArg,
                      callInvokeWithMethodAndArg
                    )
                  : callInvokeWithMethodAndArg());
              },
            });
          }
          function makeInvokeMethod(e, r, n) {
            var o = h;
            return function (i, a) {
              if (o === f) throw new Error("Generator is already running");
              if (o === s) {
                if ("throw" === i) throw a;
                return { value: t, done: !0 };
              }
              for (n.method = i, n.arg = a; ; ) {
                var c = n.delegate;
                if (c) {
                  var u = maybeInvokeDelegate(c, n);
                  if (u) {
                    if (u === y) continue;
                    return u;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                  if (o === h) throw ((o = s), n.arg);
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                  if (((o = n.done ? s : l), p.arg === y)) continue;
                  return { value: p.arg, done: n.done };
                }
                "throw" === p.type &&
                  ((o = s), (n.method = "throw"), (n.arg = p.arg));
              }
            };
          }
          function maybeInvokeDelegate(e, r) {
            var n = r.method,
              o = e.iterator[n];
            if (o === t)
              return (
                (r.delegate = null),
                ("throw" === n &&
                  e.iterator["return"] &&
                  ((r.method = "return"),
                  (r.arg = t),
                  maybeInvokeDelegate(e, r),
                  "throw" === r.method)) ||
                  ("return" !== n &&
                    ((r.method = "throw"),
                    (r.arg = new TypeError(
                      "The iterator does not provide a '" + n + "' method"
                    )))),
                y
              );
            var i = tryCatch(o, e.iterator, r.arg);
            if ("throw" === i.type)
              return (
                (r.method = "throw"), (r.arg = i.arg), (r.delegate = null), y
              );
            var a = i.arg;
            return a
              ? a.done
                ? ((r[e.resultName] = a.value),
                  (r.next = e.nextLoc),
                  "return" !== r.method && ((r.method = "next"), (r.arg = t)),
                  (r.delegate = null),
                  y)
                : a
              : ((r.method = "throw"),
                (r.arg = new TypeError("iterator result is not an object")),
                (r.delegate = null),
                y);
          }
          function pushTryEntry(t) {
            var e = { tryLoc: t[0] };
            1 in t && (e.catchLoc = t[1]),
              2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
              this.tryEntries.push(e);
          }
          function resetTryEntry(t) {
            var e = t.completion || {};
            (e.type = "normal"), delete e.arg, (t.completion = e);
          }
          function Context(t) {
            (this.tryEntries = [{ tryLoc: "root" }]),
              t.forEach(pushTryEntry, this),
              this.reset(!0);
          }
          function values(e) {
            if (e || "" === e) {
              var r = e[a];
              if (r) return r.call(e);
              if ("function" == typeof e.next) return e;
              if (!isNaN(e.length)) {
                var o = -1,
                  i = function next() {
                    for (; ++o < e.length; )
                      if (n.call(e, o))
                        return (next.value = e[o]), (next.done = !1), next;
                    return (next.value = t), (next.done = !0), next;
                  };
                return (i.next = i);
              }
            }
            throw new TypeError(_typeof(e) + " is not iterable");
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            o(g, "constructor", {
              value: GeneratorFunctionPrototype,
              configurable: !0,
            }),
            o(GeneratorFunctionPrototype, "constructor", {
              value: GeneratorFunction,
              configurable: !0,
            }),
            (GeneratorFunction.displayName = define(
              GeneratorFunctionPrototype,
              u,
              "GeneratorFunction"
            )),
            (e.isGeneratorFunction = function (t) {
              var e = "function" == typeof t && t.constructor;
              return (
                !!e &&
                (e === GeneratorFunction ||
                  "GeneratorFunction" === (e.displayName || e.name))
              );
            }),
            (e.mark = function (t) {
              return (
                Object.setPrototypeOf
                  ? Object.setPrototypeOf(t, GeneratorFunctionPrototype)
                  : ((t.__proto__ = GeneratorFunctionPrototype),
                    define(t, u, "GeneratorFunction")),
                (t.prototype = Object.create(g)),
                t
              );
            }),
            (e.awrap = function (t) {
              return { __await: t };
            }),
            defineIteratorMethods(AsyncIterator.prototype),
            define(AsyncIterator.prototype, c, function () {
              return this;
            }),
            (e.AsyncIterator = AsyncIterator),
            (e.async = function (t, r, n, o, i) {
              void 0 === i && (i = Promise);
              var a = new AsyncIterator(wrap(t, r, n, o), i);
              return e.isGeneratorFunction(r)
                ? a
                : a.next().then(function (t) {
                    return t.done ? t.value : a.next();
                  });
            }),
            defineIteratorMethods(g),
            define(g, u, "Generator"),
            define(g, a, function () {
              return this;
            }),
            define(g, "toString", function () {
              return "[object Generator]";
            }),
            (e.keys = function (t) {
              var e = Object(t),
                r = [];
              for (var n in e) r.push(n);
              return (
                r.reverse(),
                function next() {
                  for (; r.length; ) {
                    var t = r.pop();
                    if (t in e) return (next.value = t), (next.done = !1), next;
                  }
                  return (next.done = !0), next;
                }
              );
            }),
            (e.values = values),
            (Context.prototype = {
              constructor: Context,
              reset: function reset(e) {
                if (
                  ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = t),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = t),
                  this.tryEntries.forEach(resetTryEntry),
                  !e)
                )
                  for (var r in this)
                    "t" === r.charAt(0) &&
                      n.call(this, r) &&
                      !isNaN(+r.slice(1)) &&
                      (this[r] = t);
              },
              stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var r = this;
                function handle(n, o) {
                  return (
                    (a.type = "throw"),
                    (a.arg = e),
                    (r.next = n),
                    o && ((r.method = "next"), (r.arg = t)),
                    !!o
                  );
                }
                for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                  var i = this.tryEntries[o],
                    a = i.completion;
                  if ("root" === i.tryLoc) return handle("end");
                  if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"),
                      u = n.call(i, "finallyLoc");
                    if (c && u) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                      if (!u)
                        throw new Error(
                          "try statement without catch or finally"
                        );
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(t, e) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var o = this.tryEntries[r];
                  if (
                    o.tryLoc <= this.prev &&
                    n.call(o, "finallyLoc") &&
                    this.prev < o.finallyLoc
                  ) {
                    var i = o;
                    break;
                  }
                }
                i &&
                  ("break" === t || "continue" === t) &&
                  i.tryLoc <= e &&
                  e <= i.finallyLoc &&
                  (i = null);
                var a = i ? i.completion : {};
                return (
                  (a.type = t),
                  (a.arg = e),
                  i
                    ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                    : this.complete(a)
                );
              },
              complete: function complete(t, e) {
                if ("throw" === t.type) throw t.arg;
                return (
                  "break" === t.type || "continue" === t.type
                    ? (this.next = t.arg)
                    : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                  y
                );
              },
              finish: function finish(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.finallyLoc === t)
                    return (
                      this.complete(r.completion, r.afterLoc),
                      resetTryEntry(r),
                      y
                    );
                }
              },
              catch: function _catch(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                      var o = n.arg;
                      resetTryEntry(r);
                    }
                    return o;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(e, r, n) {
                return (
                  (this.delegate = {
                    iterator: values(e),
                    resultName: r,
                    nextLoc: n,
                  }),
                  "next" === this.method && (this.arg = t),
                  y
                );
              },
            }),
            e
          );
        }
        function asyncGeneratorStep(
          gen,
          resolve,
          reject,
          _next,
          _throw,
          key,
          arg
        ) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }
        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
              args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);
              function _next(value) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "next",
                  value
                );
              }
              function _throw(err) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "throw",
                  err
                );
              }
              _next(undefined);
            });
          };
        }

        var ELEMENTS_TO_UPDATE_CONTENT = [
          "[data-product-fieldsets]",
          "[data-submit-wrapper]",
          "[data-gift-wrap]",
          "[data-product-price]",
        ];
        var ProductMain = function ProductMain(_ref) {
          var optionsWithValues = _ref.optionsWithValues,
            firstAvailableVariant = _ref.firstAvailableVariant,
            product = _ref.product,
            sectionId = _ref.sectionId,
            _ref$isGiftCard = _ref.isGiftCard,
            isGiftCard = _ref$isGiftCard === void 0 ? false : _ref$isGiftCard;
          return {
            activeMedia: 0,
            currentVariant: null,
            selectedOptions: [],
            isOptionsUpdating: false,
            quantity: 1,
            purchaseOption: "one-time",
            sellingPlan: "",
            subscribeDiscount: "",
            giftWrapMessage: "",
            giftCardRecipientEmail: "",
            isGiftCardEmailInvalid: false,
            hasFormSubmittedOnce: false,
            isAddingToCart: false,
            init: function init() {
              /*
               * Uncomment this block of code if the feature of
               * moving the slide on init to the featured_media is required
               *
               * This is removed as of now to only move the swiper when an option
               * is selected
               */
              // this.$watch("currentVariant", (value) => {
              // this.activeMedia = value.featured_media?.position || this.activeMedia
              // if (this.hasProductInit) {
              //   console.log("init")
              //   document.dispatchEvent(
              //     new CustomEvent("active-media-change", {
              //       detail: { activeMedia: this.activeMedia },
              //     })
              //   )
              // }
              // })

              this.setCurrentVariant();
              this.setSelectedOptions();
              this.setSubscribeDiscount(
                document.querySelector("[data-selling-plan]:checked")
              );
            },
            getRequestParams: function getRequestParams() {
              return {
                section_id: sectionId,
                variant: this.currentVariant.id,
              };
            },
            setCurrentVariant: function setCurrentVariant(variantId) {
              if (variantId) {
                var variant = product.variants.find(function (variant) {
                  return variant.id === parseInt(urlVariant);
                });
                this.currentVariant = variant || product.variants[0];
                return;
              }
              var searchParams = new URLSearchParams(window.location.search);
              var urlVariant = searchParams.get("variant");
              if (urlVariant) {
                var _variant = product.variants.find(function (variant) {
                  return variant.id === parseInt(urlVariant);
                });
                this.currentVariant = _variant || product.variants[0];
              } else {
                this.currentVariant =
                  firstAvailableVariant || product.variants[0];
              }
            },
            setSelectedOptions: function setSelectedOptions() {
              if (!this.currentVariant) return;
              this.selectedOptions = [
                this.currentVariant.option1,
                this.currentVariant.option2,
                this.currentVariant.option3,
              ].filter(Boolean);
            },
            handleInputChange: function handleInputChange() {
              var checkedOptions = Array.from(
                this.$refs.productForm.querySelectorAll("[data-option]")
              ).filter(function (input) {
                return input.checked;
              });
              this.selectedOptions = checkedOptions.map(function (input) {
                return input.value;
              });
              this.findVariant();
            },
            handleQuantityChange: function handleQuantityChange($event) {
              this.quantity = $event.detail.value;
            },
            findVariant: function findVariant() {
              var _this = this;
              var matchingVariant = product.variants.find(function (variant) {
                return (
                  variant.option1 === _this.selectedOptions[0] &&
                  (!_this.selectedOptions[1] ||
                    variant.option2 === _this.selectedOptions[1]) &&
                  (!_this.selectedOptions[2] ||
                    variant.option3 === _this.selectedOptions[2])
                );
              });
              if (!matchingVariant) {
                matchingVariant = product.variants.find(function (variant) {
                  return variant.option1 === _this.selectedOptions[0];
                });
              }
              this.currentVariant = matchingVariant;
              this.fetchVariant();
            },
            fetchVariant: function fetchVariant() {
              var _arguments = arguments,
                _this2 = this;
              return _asyncToGenerator(
                /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                  var setOptions,
                    baseEndpoint,
                    serializedParams,
                    fullUrl,
                    _this2$currentVariant,
                    response;
                  return _regeneratorRuntime().wrap(
                    function _callee$(_context) {
                      while (1)
                        switch ((_context.prev = _context.next)) {
                          case 0:
                            setOptions =
                              _arguments.length > 0 &&
                              _arguments[0] !== undefined
                                ? _arguments[0]
                                : true;
                            baseEndpoint = window.location.pathname;
                            serializedParams = (0,
                            _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.toUrlParams)(
                              _this2.getRequestParams()
                            );
                            fullUrl = ""
                              .concat(baseEndpoint, "?")
                              .concat(serializedParams);
                            _context.prev = 4;
                            _this2.isOptionsUpdating = true;
                            _context.next = 8;
                            return axios__WEBPACK_IMPORTED_MODULE_1__[
                              "default"
                            ].get(fullUrl);
                          case 8:
                            response = _context.sent;
                            ELEMENTS_TO_UPDATE_CONTENT.forEach(function (el) {
                              (0,
                              _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.updateDOMContent)(el, response.data);
                            });
                            (0,
                            _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.updateURL)(
                              ""
                                .concat(baseEndpoint, "?")
                                .concat(
                                  (0,
                                  _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.toFilteredUrlParams)(
                                    _this2.getRequestParams()
                                  )
                                )
                            );
                            if (setOptions) {
                              _this2.setSelectedOptions();
                            }
                            _this2.activeMedia =
                              ((_this2$currentVariant =
                                _this2.currentVariant.featured_media) ===
                                null || _this2$currentVariant === void 0
                                ? void 0
                                : _this2$currentVariant.position) ||
                              _this2.activeMedia;
                            document.dispatchEvent(
                              new CustomEvent("active-media-change", {
                                detail: {
                                  activeMedia: _this2.activeMedia,
                                },
                              })
                            );
                            _context.next = 19;
                            break;
                          case 16:
                            _context.prev = 16;
                            _context.t0 = _context["catch"](4);
                            throw new Error("Error in updating options");
                          case 19:
                            _context.prev = 19;
                            _this2.isOptionsUpdating = false;
                            return _context.finish(19);
                          case 22:
                          case "end":
                            return _context.stop();
                        }
                    },
                    _callee,
                    null,
                    [[4, 16, 19, 22]]
                  );
                })
              )();
            },
            handleGiftCardEmailInput: function handleGiftCardEmailInput() {
              if (this.giftCardRecipientEmail === "") {
                this.isGiftCardEmailInvalid = false;
                return;
              }
              if (this.hasFormSubmittedOnce) {
                this.isGiftCardEmailInvalid = !(0,
                _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.isEmailValid)(
                  this.giftCardRecipientEmail
                );
              }
            },
            handleFormSubmit: function handleFormSubmit() {
              var _this3 = this;
              return _asyncToGenerator(
                /*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
                  var _yield$Alpine$store$a, success;
                  return _regeneratorRuntime().wrap(
                    function _callee2$(_context2) {
                      while (1)
                        switch ((_context2.prev = _context2.next)) {
                          case 0:
                            if (window.cartAddUrl) {
                              _context2.next = 2;
                              break;
                            }
                            return _context2.abrupt("return");
                          case 2:
                            if (
                              !(
                                isGiftCard &&
                                _this3.giftCardRecipientEmail &&
                                !(0,
                                _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.isEmailValid)(
                                  _this3.giftCardRecipientEmail
                                )
                              )
                            ) {
                              _context2.next = 6;
                              break;
                            }
                            _this3.isGiftCardEmailInvalid = true;
                            _this3.hasFormSubmittedOnce = true;
                            return _context2.abrupt("return");
                          case 6:
                            _this3.isGiftCardEmailInvalid = false;
                            _context2.prev = 7;
                            _this3.isAddingToCart = true;
                            _this3.isOptionsUpdating = true;
                            _context2.next = 12;
                            return Alpine.store("cart").addToCart(
                              _objectSpread(
                                _objectSpread(
                                  _objectSpread(
                                    {
                                      quantity: _this3.quantity,
                                      variantId: _this3.currentVariant.id,
                                    },
                                    _this3.sellingPlan && {
                                      selling_plan: _this3.sellingPlan,
                                    }
                                  ),
                                  isGiftCard && {
                                    Denominations: _this3.currentVariant.title,
                                    "product-id": product.id,
                                  }
                                ),
                                {},
                                {
                                  properties: _objectSpread(
                                    _objectSpread(
                                      _objectSpread(
                                        {},
                                        _this3.giftWrapMessage && {
                                          "Gift wrap message":
                                            _this3.giftWrapMessage,
                                        }
                                      ),
                                      _this3.giftCardRecipientEmail && {
                                        __shopify_send_gift_card_to_recipient:
                                          "on",
                                        __shopify_offset: new Date()
                                          .getTimezoneOffset()
                                          .toString(),
                                        "Recipient email":
                                          _this3.giftCardRecipientEmail,
                                      }
                                    ),
                                    _this3.giftMessage && {
                                      "Gift Card Message": _this3.giftMessage, // Add giftMessage here
                                    }
                                  ),
                                }
                              )
                            );
                          case 12:
                            _yield$Alpine$store$a = _context2.sent;
                            success = _yield$Alpine$store$a.success;
                            _context2.next = 19;
                            break;
                          case 16:
                            _context2.prev = 16;
                            _context2.t0 = _context2["catch"](7);
                            console.log(_context2.t0);
                          case 19:
                            _context2.prev = 19;
                            _this3.isAddingToCart = false;
                            _this3.isOptionsUpdating = false;
                            _this3.giftWrapMessage = "";
                            _this3.giftCardRecipientEmail = "";
                            _this3.isGiftCardEmailInvalid = false;
                            _this3.hasFormSubmittedOnce = false;
                            return _context2.finish(19);
                          case 27:
                          case "end":
                            return _context2.stop();
                        }
                    },
                    _callee2,
                    null,
                    [[7, 16, 19, 27]]
                  );
                })
              )();
            },
            handlePurchaseOptionChange: function handlePurchaseOptionChange(
              $event
            ) {
              if (!($event !== null && $event !== void 0 && $event.target))
                return;
              var value = $event.target.value;
              this.purchaseOption = value;
              if (value === "one-time") {
                this.sellingPlan = "";
                return;
              }
              var checkedSellingPlanInput = document.querySelector(
                "[data-selling-plan]:checked"
              );
              if (checkedSellingPlanInput) {
                this.sellingPlan = Number(checkedSellingPlanInput.value);
              }
              this.setSubscribeDiscount(checkedSellingPlanInput);
            },
            handleSellingPlanChange: function handleSellingPlanChange($event) {
              if (!($event !== null && $event !== void 0 && $event.target))
                return;
              var target = $event.target;
              var value = target.value;
              this.sellingPlan = Number(value);
              this.setSubscribeDiscount(target);
            },
            handleGiftWrapChange: function handleGiftWrapChange($event) {
              if (!($event !== null && $event !== void 0 && $event.target))
                return;
              var target = $event.target;
              var targetVariantId;
              if (target.checked) {
                targetVariantId = Number(
                  target.getAttribute("data-gift-wrap-variant-id")
                );
              } else {
                targetVariantId = Number(
                  target.getAttribute("data-no-gift-wrap-variant-id")
                );
                this.giftWrapMessage = "";
              }
              if (!targetVariantId) return;
              var newCurrentVariant = product.variants.find(function (variant) {
                return variant.id === targetVariantId;
              });
              if (!newCurrentVariant) return;
              this.selectedOptions = newCurrentVariant.options;
              this.currentVariant = newCurrentVariant;
              this.fetchVariant(false);
            },
            setSubscribeDiscount: function setSubscribeDiscount(input) {
              if (!input) return;
              if (input.getAttribute("data-percent-discount")) {
                this.subscribeDiscount = input.getAttribute(
                  "data-percent-discount"
                );
              }
            },
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          ProductMain;

        /***/
      },

    /***/ "./src/scripts/sections/product-recommendations.js":
      /*!*********************************************************!*\
  !*** ./src/scripts/sections/product-recommendations.js ***!
  \*********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");
        /* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/helpers */ "./src/scripts/utils/helpers.js"
          );
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _regeneratorRuntime() {
          "use strict";
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime =
            function _regeneratorRuntime() {
              return e;
            };
          var t,
            e = {},
            r = Object.prototype,
            n = r.hasOwnProperty,
            o =
              Object.defineProperty ||
              function (t, e, r) {
                t[e] = r.value;
              },
            i = "function" == typeof Symbol ? Symbol : {},
            a = i.iterator || "@@iterator",
            c = i.asyncIterator || "@@asyncIterator",
            u = i.toStringTag || "@@toStringTag";
          function define(t, e, r) {
            return (
              Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              }),
              t[e]
            );
          }
          try {
            define({}, "");
          } catch (t) {
            define = function define(t, e, r) {
              return (t[e] = r);
            };
          }
          function wrap(t, e, r, n) {
            var i = e && e.prototype instanceof Generator ? e : Generator,
              a = Object.create(i.prototype),
              c = new Context(n || []);
            return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a;
          }
          function tryCatch(t, e, r) {
            try {
              return { type: "normal", arg: t.call(e, r) };
            } catch (t) {
              return { type: "throw", arg: t };
            }
          }
          e.wrap = wrap;
          var h = "suspendedStart",
            l = "suspendedYield",
            f = "executing",
            s = "completed",
            y = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          var p = {};
          define(p, a, function () {
            return this;
          });
          var d = Object.getPrototypeOf,
            v = d && d(d(values([])));
          v && v !== r && n.call(v, a) && (p = v);
          var g =
            (GeneratorFunctionPrototype.prototype =
            Generator.prototype =
              Object.create(p));
          function defineIteratorMethods(t) {
            ["next", "throw", "return"].forEach(function (e) {
              define(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function AsyncIterator(t, e) {
            function invoke(r, o, i, a) {
              var c = tryCatch(t[r], t, o);
              if ("throw" !== c.type) {
                var u = c.arg,
                  h = u.value;
                return h && "object" == _typeof(h) && n.call(h, "__await")
                  ? e.resolve(h.__await).then(
                      function (t) {
                        invoke("next", t, i, a);
                      },
                      function (t) {
                        invoke("throw", t, i, a);
                      }
                    )
                  : e.resolve(h).then(
                      function (t) {
                        (u.value = t), i(u);
                      },
                      function (t) {
                        return invoke("throw", t, i, a);
                      }
                    );
              }
              a(c.arg);
            }
            var r;
            o(this, "_invoke", {
              value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                  return new e(function (e, r) {
                    invoke(t, n, e, r);
                  });
                }
                return (r = r
                  ? r.then(
                      callInvokeWithMethodAndArg,
                      callInvokeWithMethodAndArg
                    )
                  : callInvokeWithMethodAndArg());
              },
            });
          }
          function makeInvokeMethod(e, r, n) {
            var o = h;
            return function (i, a) {
              if (o === f) throw new Error("Generator is already running");
              if (o === s) {
                if ("throw" === i) throw a;
                return { value: t, done: !0 };
              }
              for (n.method = i, n.arg = a; ; ) {
                var c = n.delegate;
                if (c) {
                  var u = maybeInvokeDelegate(c, n);
                  if (u) {
                    if (u === y) continue;
                    return u;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                  if (o === h) throw ((o = s), n.arg);
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                  if (((o = n.done ? s : l), p.arg === y)) continue;
                  return { value: p.arg, done: n.done };
                }
                "throw" === p.type &&
                  ((o = s), (n.method = "throw"), (n.arg = p.arg));
              }
            };
          }
          function maybeInvokeDelegate(e, r) {
            var n = r.method,
              o = e.iterator[n];
            if (o === t)
              return (
                (r.delegate = null),
                ("throw" === n &&
                  e.iterator["return"] &&
                  ((r.method = "return"),
                  (r.arg = t),
                  maybeInvokeDelegate(e, r),
                  "throw" === r.method)) ||
                  ("return" !== n &&
                    ((r.method = "throw"),
                    (r.arg = new TypeError(
                      "The iterator does not provide a '" + n + "' method"
                    )))),
                y
              );
            var i = tryCatch(o, e.iterator, r.arg);
            if ("throw" === i.type)
              return (
                (r.method = "throw"), (r.arg = i.arg), (r.delegate = null), y
              );
            var a = i.arg;
            return a
              ? a.done
                ? ((r[e.resultName] = a.value),
                  (r.next = e.nextLoc),
                  "return" !== r.method && ((r.method = "next"), (r.arg = t)),
                  (r.delegate = null),
                  y)
                : a
              : ((r.method = "throw"),
                (r.arg = new TypeError("iterator result is not an object")),
                (r.delegate = null),
                y);
          }
          function pushTryEntry(t) {
            var e = { tryLoc: t[0] };
            1 in t && (e.catchLoc = t[1]),
              2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
              this.tryEntries.push(e);
          }
          function resetTryEntry(t) {
            var e = t.completion || {};
            (e.type = "normal"), delete e.arg, (t.completion = e);
          }
          function Context(t) {
            (this.tryEntries = [{ tryLoc: "root" }]),
              t.forEach(pushTryEntry, this),
              this.reset(!0);
          }
          function values(e) {
            if (e || "" === e) {
              var r = e[a];
              if (r) return r.call(e);
              if ("function" == typeof e.next) return e;
              if (!isNaN(e.length)) {
                var o = -1,
                  i = function next() {
                    for (; ++o < e.length; )
                      if (n.call(e, o))
                        return (next.value = e[o]), (next.done = !1), next;
                    return (next.value = t), (next.done = !0), next;
                  };
                return (i.next = i);
              }
            }
            throw new TypeError(_typeof(e) + " is not iterable");
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            o(g, "constructor", {
              value: GeneratorFunctionPrototype,
              configurable: !0,
            }),
            o(GeneratorFunctionPrototype, "constructor", {
              value: GeneratorFunction,
              configurable: !0,
            }),
            (GeneratorFunction.displayName = define(
              GeneratorFunctionPrototype,
              u,
              "GeneratorFunction"
            )),
            (e.isGeneratorFunction = function (t) {
              var e = "function" == typeof t && t.constructor;
              return (
                !!e &&
                (e === GeneratorFunction ||
                  "GeneratorFunction" === (e.displayName || e.name))
              );
            }),
            (e.mark = function (t) {
              return (
                Object.setPrototypeOf
                  ? Object.setPrototypeOf(t, GeneratorFunctionPrototype)
                  : ((t.__proto__ = GeneratorFunctionPrototype),
                    define(t, u, "GeneratorFunction")),
                (t.prototype = Object.create(g)),
                t
              );
            }),
            (e.awrap = function (t) {
              return { __await: t };
            }),
            defineIteratorMethods(AsyncIterator.prototype),
            define(AsyncIterator.prototype, c, function () {
              return this;
            }),
            (e.AsyncIterator = AsyncIterator),
            (e.async = function (t, r, n, o, i) {
              void 0 === i && (i = Promise);
              var a = new AsyncIterator(wrap(t, r, n, o), i);
              return e.isGeneratorFunction(r)
                ? a
                : a.next().then(function (t) {
                    return t.done ? t.value : a.next();
                  });
            }),
            defineIteratorMethods(g),
            define(g, u, "Generator"),
            define(g, a, function () {
              return this;
            }),
            define(g, "toString", function () {
              return "[object Generator]";
            }),
            (e.keys = function (t) {
              var e = Object(t),
                r = [];
              for (var n in e) r.push(n);
              return (
                r.reverse(),
                function next() {
                  for (; r.length; ) {
                    var t = r.pop();
                    if (t in e) return (next.value = t), (next.done = !1), next;
                  }
                  return (next.done = !0), next;
                }
              );
            }),
            (e.values = values),
            (Context.prototype = {
              constructor: Context,
              reset: function reset(e) {
                if (
                  ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = t),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = t),
                  this.tryEntries.forEach(resetTryEntry),
                  !e)
                )
                  for (var r in this)
                    "t" === r.charAt(0) &&
                      n.call(this, r) &&
                      !isNaN(+r.slice(1)) &&
                      (this[r] = t);
              },
              stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var r = this;
                function handle(n, o) {
                  return (
                    (a.type = "throw"),
                    (a.arg = e),
                    (r.next = n),
                    o && ((r.method = "next"), (r.arg = t)),
                    !!o
                  );
                }
                for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                  var i = this.tryEntries[o],
                    a = i.completion;
                  if ("root" === i.tryLoc) return handle("end");
                  if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"),
                      u = n.call(i, "finallyLoc");
                    if (c && u) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                      if (!u)
                        throw new Error(
                          "try statement without catch or finally"
                        );
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(t, e) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var o = this.tryEntries[r];
                  if (
                    o.tryLoc <= this.prev &&
                    n.call(o, "finallyLoc") &&
                    this.prev < o.finallyLoc
                  ) {
                    var i = o;
                    break;
                  }
                }
                i &&
                  ("break" === t || "continue" === t) &&
                  i.tryLoc <= e &&
                  e <= i.finallyLoc &&
                  (i = null);
                var a = i ? i.completion : {};
                return (
                  (a.type = t),
                  (a.arg = e),
                  i
                    ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                    : this.complete(a)
                );
              },
              complete: function complete(t, e) {
                if ("throw" === t.type) throw t.arg;
                return (
                  "break" === t.type || "continue" === t.type
                    ? (this.next = t.arg)
                    : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                  y
                );
              },
              finish: function finish(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.finallyLoc === t)
                    return (
                      this.complete(r.completion, r.afterLoc),
                      resetTryEntry(r),
                      y
                    );
                }
              },
              catch: function _catch(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                      var o = n.arg;
                      resetTryEntry(r);
                    }
                    return o;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(e, r, n) {
                return (
                  (this.delegate = {
                    iterator: values(e),
                    resultName: r,
                    nextLoc: n,
                  }),
                  "next" === this.method && (this.arg = t),
                  y
                );
              },
            }),
            e
          );
        }
        function asyncGeneratorStep(
          gen,
          resolve,
          reject,
          _next,
          _throw,
          key,
          arg
        ) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }
        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
              args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);
              function _next(value) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "next",
                  value
                );
              }
              function _throw(err) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "throw",
                  err
                );
              }
              _next(undefined);
            });
          };
        }

        var ProductRecommendations = function ProductRecommendations(_ref) {
          var url = _ref.url;
          return {
            init: function init() {
              return _asyncToGenerator(
                /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                  var response;
                  return _regeneratorRuntime().wrap(
                    function _callee$(_context) {
                      while (1)
                        switch ((_context.prev = _context.next)) {
                          case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return axios__WEBPACK_IMPORTED_MODULE_1__[
                              "default"
                            ].get(url);
                          case 3:
                            response = _context.sent;
                            if (response.data) {
                              (0,
                              _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.updateDOMContent)(
                                "[data-product-recommendations]",
                                response.data
                              );
                            }
                            _context.next = 10;
                            break;
                          case 7:
                            _context.prev = 7;
                            _context.t0 = _context["catch"](0);
                            console.error(
                              _context.t0,
                              "Error in fetching recommendations"
                            );
                          case 10:
                          case "end":
                            return _context.stop();
                        }
                    },
                    _callee,
                    null,
                    [[0, 7]]
                  );
                })
              )();
            },
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          ProductRecommendations;

        /***/
      },

    /***/ "./src/scripts/sections/simple_video.js":
      /*!**********************************************!*\
  !*** ./src/scripts/sections/simple_video.js ***!
  \**********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }
        function _defineAccessor(e, r, n, t) {
          var c = { configurable: !0, enumerable: !0 };
          return (c[e] = t), Object.defineProperty(r, n, c);
        }
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function () {
            var _ref;
            return (
              (_ref = {
                isPlaying: false,
                isDesktopPlaying: false,
                isMobilePlaying: false,
                isMobile: false,
              }),
              _defineAccessor("get", _ref, "isPlaying", function () {
                return this.isMobile
                  ? this.isMobilePlaying
                  : this.isDesktopPlaying;
              }),
              _defineProperty(_ref, "init", function init() {
                this.updateMobileFlag();
              }),
              _defineProperty(
                _ref,
                "updateMobileFlag",
                function updateMobileFlag() {
                  this.isMobile =
                    window.matchMedia("(max-width: 767px)").matches;
                }
              ),
              _defineProperty(
                _ref,
                "playPauseToggle",
                function playPauseToggle(evt) {
                  var _this$$refs = this.$refs,
                    thisParentContainer = _this$$refs.thisParentContainer,
                    desktopVideo = _this$$refs.desktopVideo,
                    mobileVideo = _this$$refs.mobileVideo;
                  if (this.isPlaying) {
                    if (desktopVideo) {
                      desktopVideo.pause();
                    }
                    if (mobileVideo) {
                      mobileVideo.pause();
                    }
                  } else {
                    if (desktopVideo) {
                      desktopVideo.play();
                    }
                    if (mobileVideo) {
                      mobileVideo.play();
                    }
                  }
                }
              ),
              _ref
            );
          };

        /***/
      },

    /***/ "./src/scripts/sections/trage-klaviyo-register.js":
      /*!********************************************************!*\
  !*** ./src/scripts/sections/trage-klaviyo-register.js ***!
  \********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function () {
            return {
              init: function init() {},
              tardeKlaviyoRegisterForm: function tardeKlaviyoRegisterForm(
                list
              ) {
                var first_name = document.getElementById("first_name").value;
                var last_name = document.getElementById("last_name").value;
                var email = document.getElementById("email").value;
                var phone = document.getElementById("phone").value;
                var business_name =
                  document.getElementById("business_name").value;
                var street_address =
                  document.getElementById("street_address").value;
                var city = document.getElementById("city").value;
                var country = document.getElementById("country").value;
                var post_code = document.getElementById("post_code").value;
                var company_registered_number = document.getElementById(
                  "company_registered_number"
                ).value;
                var preferences = document.getElementById("preferences");
                var notes = document.getElementById("notes").value;
                var checkboxValue = "";
                preferences
                  .querySelectorAll('input[type="checkbox"]:checked')
                  .forEach(function (checkbox) {
                    checkboxValue = checkboxValue + checkbox.value + " ";
                  });
                var settings = {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Cache-Control": "no-cache",
                  },
                  body: new URLSearchParams({
                    g: list,
                    email: email,
                    $first_name: first_name,
                    $last_name: last_name,
                    $phone_number: phone,
                    $business_name: business_name,
                    $street_address: street_address,
                    $city: city,
                    $country: country,
                    $zip: post_code,
                    $company_registered_number: company_registered_number,
                    $message: notes,
                    $sector: checkboxValue,
                    Location: "United Kingdom",
                    $fields:
                      "$business_name,$street_address,$password,$sector,$message",
                  }),
                };
                fetch(
                  "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
                  settings
                )
                  .then(function (response) {
                    return response.text();
                  })
                  .then(function (result) {
                    var contactForm = document
                      .getElementById("formtrade")
                      .querySelector("form");
                    if (contactForm) {
                      contactForm.submit();
                    }
                  })
                  ["catch"](function (error) {
                    console.error("Error:", error);
                  });
              },
            };
          };

        /***/
      },

    /***/ "./src/scripts/sections/usp-carousel.js":
      /*!**********************************************!*\
  !*** ./src/scripts/sections/usp-carousel.js ***!
  \**********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _splidejs_splide__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! @splidejs/splide */ "./node_modules/@splidejs/splide/dist/js/splide.esm.js"
          );
        /* harmony import */ var _splidejs_splide_css__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! @splidejs/splide/css */ "./node_modules/@splidejs/splide/dist/css/splide.min.css"
          );
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }
        function ownKeys(e, r) {
          var t = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r &&
              (o = o.filter(function (r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
              })),
              t.push.apply(t, o);
          }
          return t;
        }
        function _objectSpread(e) {
          for (var r = 1; r < arguments.length; r++) {
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2
              ? ownKeys(Object(t), !0).forEach(function (r) {
                  _defineProperty(e, r, t[r]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
              : ownKeys(Object(t)).forEach(function (r) {
                  Object.defineProperty(
                    e,
                    r,
                    Object.getOwnPropertyDescriptor(t, r)
                  );
                });
          }
          return e;
        }
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }
        /*
         * This section uses Splide.js library to create the carousel component.
         * Splide.js was installed and used over Swiper because Swiper does not consistently
         * support features like auto-width slides, auto-play, and loop when enabled at the same time.
         */

        var UspCarousel = function UspCarousel(_ref) {
          var _ref$autoPlayDesktop = _ref.autoPlayDesktop,
            autoPlayDesktop =
              _ref$autoPlayDesktop === void 0 ? false : _ref$autoPlayDesktop,
            _ref$autoPlayMobile = _ref.autoPlayMobile,
            autoPlayMobile =
              _ref$autoPlayMobile === void 0 ? false : _ref$autoPlayMobile,
            _ref$autoPlayDelay = _ref.autoPlayDelay,
            autoPlayDelay =
              _ref$autoPlayDelay === void 0 ? 3000 : _ref$autoPlayDelay;
          return {
            swiper: null,
            init: function init() {
              var splideOptions = {
                autoplay: false,
                arrows: false,
                autoWidth: true,
                breakpoints: {
                  991: {
                    gap: 124,
                    padding: 0,
                  },
                },
                gap: 48,
                padding: 20,
                pagination: false,
                type: "loop",
                mediaQuery: "min",
              };
              if (autoPlayDesktop && autoPlayMobile) {
                splideOptions.autoplay = true;
                splideOptions.interval = autoPlayDelay;
              } else if (autoPlayDesktop) {
                splideOptions.breakpoints[991] = _objectSpread(
                  _objectSpread({}, splideOptions.breakpoints[991]),
                  {},
                  {
                    autoplay: true,
                    interval: autoPlayDelay,
                  }
                );
              } else if (autoPlayMobile) {
                splideOptions.breakpoints[991] = _objectSpread(
                  _objectSpread({}, splideOptions.breakpoints[991]),
                  {},
                  {
                    autoplay: false,
                  }
                );
                splideOptions.autoplay = true;
                splideOptions.interval = autoPlayDelay;
              }
              this.swiper = new _splidejs_splide__WEBPACK_IMPORTED_MODULE_0__[
                "default"
              ](this.$refs.splide, splideOptions);
              this.swiper.mount();
            },
          };
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          UspCarousel;

        /***/
      },

    /***/ "./src/scripts/store/cart-store.js":
      /*!*****************************************!*\
  !*** ./src/scripts/store/cart-store.js ***!
  \*****************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");
        /* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/helpers */ "./src/scripts/utils/helpers.js"
          );
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }
        var _excluded = [
          "variantId",
          "quantity",
          "properties",
          "shouldFetchCart",
          "showFetchCartLoading",
          "showMiniCartOnSuccess",
        ];
        function ownKeys(e, r) {
          var t = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r &&
              (o = o.filter(function (r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
              })),
              t.push.apply(t, o);
          }
          return t;
        }
        function _objectSpread(e) {
          for (var r = 1; r < arguments.length; r++) {
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2
              ? ownKeys(Object(t), !0).forEach(function (r) {
                  _defineProperty(e, r, t[r]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
              : ownKeys(Object(t)).forEach(function (r) {
                  Object.defineProperty(
                    e,
                    r,
                    Object.getOwnPropertyDescriptor(t, r)
                  );
                });
          }
          return e;
        }
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }
        function _objectWithoutProperties(source, excluded) {
          if (source == null) return {};
          var target = _objectWithoutPropertiesLoose(source, excluded);
          var key, i;
          if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for (i = 0; i < sourceSymbolKeys.length; i++) {
              key = sourceSymbolKeys[i];
              if (excluded.indexOf(key) >= 0) continue;
              if (!Object.prototype.propertyIsEnumerable.call(source, key))
                continue;
              target[key] = source[key];
            }
          }
          return target;
        }
        function _objectWithoutPropertiesLoose(source, excluded) {
          if (source == null) return {};
          var target = {};
          var sourceKeys = Object.keys(source);
          var key, i;
          for (i = 0; i < sourceKeys.length; i++) {
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
          }
          return target;
        }
        function _regeneratorRuntime() {
          "use strict";
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime =
            function _regeneratorRuntime() {
              return e;
            };
          var t,
            e = {},
            r = Object.prototype,
            n = r.hasOwnProperty,
            o =
              Object.defineProperty ||
              function (t, e, r) {
                t[e] = r.value;
              },
            i = "function" == typeof Symbol ? Symbol : {},
            a = i.iterator || "@@iterator",
            c = i.asyncIterator || "@@asyncIterator",
            u = i.toStringTag || "@@toStringTag";
          function define(t, e, r) {
            return (
              Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              }),
              t[e]
            );
          }
          try {
            define({}, "");
          } catch (t) {
            define = function define(t, e, r) {
              return (t[e] = r);
            };
          }
          function wrap(t, e, r, n) {
            var i = e && e.prototype instanceof Generator ? e : Generator,
              a = Object.create(i.prototype),
              c = new Context(n || []);
            return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a;
          }
          function tryCatch(t, e, r) {
            try {
              return { type: "normal", arg: t.call(e, r) };
            } catch (t) {
              return { type: "throw", arg: t };
            }
          }
          e.wrap = wrap;
          var h = "suspendedStart",
            l = "suspendedYield",
            f = "executing",
            s = "completed",
            y = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          var p = {};
          define(p, a, function () {
            return this;
          });
          var d = Object.getPrototypeOf,
            v = d && d(d(values([])));
          v && v !== r && n.call(v, a) && (p = v);
          var g =
            (GeneratorFunctionPrototype.prototype =
            Generator.prototype =
              Object.create(p));
          function defineIteratorMethods(t) {
            ["next", "throw", "return"].forEach(function (e) {
              define(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function AsyncIterator(t, e) {
            function invoke(r, o, i, a) {
              var c = tryCatch(t[r], t, o);
              if ("throw" !== c.type) {
                var u = c.arg,
                  h = u.value;
                return h && "object" == _typeof(h) && n.call(h, "__await")
                  ? e.resolve(h.__await).then(
                      function (t) {
                        invoke("next", t, i, a);
                      },
                      function (t) {
                        invoke("throw", t, i, a);
                      }
                    )
                  : e.resolve(h).then(
                      function (t) {
                        (u.value = t), i(u);
                      },
                      function (t) {
                        return invoke("throw", t, i, a);
                      }
                    );
              }
              a(c.arg);
            }
            var r;
            o(this, "_invoke", {
              value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                  return new e(function (e, r) {
                    invoke(t, n, e, r);
                  });
                }
                return (r = r
                  ? r.then(
                      callInvokeWithMethodAndArg,
                      callInvokeWithMethodAndArg
                    )
                  : callInvokeWithMethodAndArg());
              },
            });
          }
          function makeInvokeMethod(e, r, n) {
            var o = h;
            return function (i, a) {
              if (o === f) throw new Error("Generator is already running");
              if (o === s) {
                if ("throw" === i) throw a;
                return { value: t, done: !0 };
              }
              for (n.method = i, n.arg = a; ; ) {
                var c = n.delegate;
                if (c) {
                  var u = maybeInvokeDelegate(c, n);
                  if (u) {
                    if (u === y) continue;
                    return u;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                  if (o === h) throw ((o = s), n.arg);
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                  if (((o = n.done ? s : l), p.arg === y)) continue;
                  return { value: p.arg, done: n.done };
                }
                "throw" === p.type &&
                  ((o = s), (n.method = "throw"), (n.arg = p.arg));
              }
            };
          }
          function maybeInvokeDelegate(e, r) {
            var n = r.method,
              o = e.iterator[n];
            if (o === t)
              return (
                (r.delegate = null),
                ("throw" === n &&
                  e.iterator["return"] &&
                  ((r.method = "return"),
                  (r.arg = t),
                  maybeInvokeDelegate(e, r),
                  "throw" === r.method)) ||
                  ("return" !== n &&
                    ((r.method = "throw"),
                    (r.arg = new TypeError(
                      "The iterator does not provide a '" + n + "' method"
                    )))),
                y
              );
            var i = tryCatch(o, e.iterator, r.arg);
            if ("throw" === i.type)
              return (
                (r.method = "throw"), (r.arg = i.arg), (r.delegate = null), y
              );
            var a = i.arg;
            return a
              ? a.done
                ? ((r[e.resultName] = a.value),
                  (r.next = e.nextLoc),
                  "return" !== r.method && ((r.method = "next"), (r.arg = t)),
                  (r.delegate = null),
                  y)
                : a
              : ((r.method = "throw"),
                (r.arg = new TypeError("iterator result is not an object")),
                (r.delegate = null),
                y);
          }
          function pushTryEntry(t) {
            var e = { tryLoc: t[0] };
            1 in t && (e.catchLoc = t[1]),
              2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
              this.tryEntries.push(e);
          }
          function resetTryEntry(t) {
            var e = t.completion || {};
            (e.type = "normal"), delete e.arg, (t.completion = e);
          }
          function Context(t) {
            (this.tryEntries = [{ tryLoc: "root" }]),
              t.forEach(pushTryEntry, this),
              this.reset(!0);
          }
          function values(e) {
            if (e || "" === e) {
              var r = e[a];
              if (r) return r.call(e);
              if ("function" == typeof e.next) return e;
              if (!isNaN(e.length)) {
                var o = -1,
                  i = function next() {
                    for (; ++o < e.length; )
                      if (n.call(e, o))
                        return (next.value = e[o]), (next.done = !1), next;
                    return (next.value = t), (next.done = !0), next;
                  };
                return (i.next = i);
              }
            }
            throw new TypeError(_typeof(e) + " is not iterable");
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            o(g, "constructor", {
              value: GeneratorFunctionPrototype,
              configurable: !0,
            }),
            o(GeneratorFunctionPrototype, "constructor", {
              value: GeneratorFunction,
              configurable: !0,
            }),
            (GeneratorFunction.displayName = define(
              GeneratorFunctionPrototype,
              u,
              "GeneratorFunction"
            )),
            (e.isGeneratorFunction = function (t) {
              var e = "function" == typeof t && t.constructor;
              return (
                !!e &&
                (e === GeneratorFunction ||
                  "GeneratorFunction" === (e.displayName || e.name))
              );
            }),
            (e.mark = function (t) {
              return (
                Object.setPrototypeOf
                  ? Object.setPrototypeOf(t, GeneratorFunctionPrototype)
                  : ((t.__proto__ = GeneratorFunctionPrototype),
                    define(t, u, "GeneratorFunction")),
                (t.prototype = Object.create(g)),
                t
              );
            }),
            (e.awrap = function (t) {
              return { __await: t };
            }),
            defineIteratorMethods(AsyncIterator.prototype),
            define(AsyncIterator.prototype, c, function () {
              return this;
            }),
            (e.AsyncIterator = AsyncIterator),
            (e.async = function (t, r, n, o, i) {
              void 0 === i && (i = Promise);
              var a = new AsyncIterator(wrap(t, r, n, o), i);
              return e.isGeneratorFunction(r)
                ? a
                : a.next().then(function (t) {
                    return t.done ? t.value : a.next();
                  });
            }),
            defineIteratorMethods(g),
            define(g, u, "Generator"),
            define(g, a, function () {
              return this;
            }),
            define(g, "toString", function () {
              return "[object Generator]";
            }),
            (e.keys = function (t) {
              var e = Object(t),
                r = [];
              for (var n in e) r.push(n);
              return (
                r.reverse(),
                function next() {
                  for (; r.length; ) {
                    var t = r.pop();
                    if (t in e) return (next.value = t), (next.done = !1), next;
                  }
                  return (next.done = !0), next;
                }
              );
            }),
            (e.values = values),
            (Context.prototype = {
              constructor: Context,
              reset: function reset(e) {
                if (
                  ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = t),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = t),
                  this.tryEntries.forEach(resetTryEntry),
                  !e)
                )
                  for (var r in this)
                    "t" === r.charAt(0) &&
                      n.call(this, r) &&
                      !isNaN(+r.slice(1)) &&
                      (this[r] = t);
              },
              stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var r = this;
                function handle(n, o) {
                  return (
                    (a.type = "throw"),
                    (a.arg = e),
                    (r.next = n),
                    o && ((r.method = "next"), (r.arg = t)),
                    !!o
                  );
                }
                for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                  var i = this.tryEntries[o],
                    a = i.completion;
                  if ("root" === i.tryLoc) return handle("end");
                  if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"),
                      u = n.call(i, "finallyLoc");
                    if (c && u) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                      if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                      if (!u)
                        throw new Error(
                          "try statement without catch or finally"
                        );
                      if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(t, e) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var o = this.tryEntries[r];
                  if (
                    o.tryLoc <= this.prev &&
                    n.call(o, "finallyLoc") &&
                    this.prev < o.finallyLoc
                  ) {
                    var i = o;
                    break;
                  }
                }
                i &&
                  ("break" === t || "continue" === t) &&
                  i.tryLoc <= e &&
                  e <= i.finallyLoc &&
                  (i = null);
                var a = i ? i.completion : {};
                return (
                  (a.type = t),
                  (a.arg = e),
                  i
                    ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                    : this.complete(a)
                );
              },
              complete: function complete(t, e) {
                if ("throw" === t.type) throw t.arg;
                return (
                  "break" === t.type || "continue" === t.type
                    ? (this.next = t.arg)
                    : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                  y
                );
              },
              finish: function finish(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.finallyLoc === t)
                    return (
                      this.complete(r.completion, r.afterLoc),
                      resetTryEntry(r),
                      y
                    );
                }
              },
              catch: function _catch(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                      var o = n.arg;
                      resetTryEntry(r);
                    }
                    return o;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(e, r, n) {
                return (
                  (this.delegate = {
                    iterator: values(e),
                    resultName: r,
                    nextLoc: n,
                  }),
                  "next" === this.method && (this.arg = t),
                  y
                );
              },
            }),
            e
          );
        }
        function asyncGeneratorStep(
          gen,
          resolve,
          reject,
          _next,
          _throw,
          key,
          arg
        ) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }
        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
              args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);
              function _next(value) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "next",
                  value
                );
              }
              function _throw(err) {
                asyncGeneratorStep(
                  gen,
                  resolve,
                  reject,
                  _next,
                  _throw,
                  "throw",
                  err
                );
              }
              _next(undefined);
            });
          };
        }

        var cartAxiosInstace = axios__WEBPACK_IMPORTED_MODULE_1__[
          "default"
        ].create({
          baseURL: "/",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        });
        var CartStore = {
          isMiniCartOpen: false,
          isFetchingCart: true,
          isAddingToCart: false,
          isChangingCart: false,
          isUpdatingCart: false,
          cart: null,
          promotionFreeShipping: null,
          promotionRemaining: null,
          promotionRemainingPercent: null,
          promotionText: null,
          promotionEligible: false,
          userCountry: null,
          init: function init() {
            this.fetchCart({});
            this.getUserCountry();
          },
          getUserCountry: function getUserCountry() {
            var _this = this;
            return _asyncToGenerator(
              /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                var res;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1)
                    switch ((_context.prev = _context.next)) {
                      case 0:
                        _context.next = 2;
                        return axios__WEBPACK_IMPORTED_MODULE_1__[
                          "default"
                        ].get("/browsing_context_suggestions.json");
                      case 2:
                        res = _context.sent;
                        if (!(res.status !== 200)) {
                          _context.next = 5;
                          break;
                        }
                        return _context.abrupt("return");
                      case 5:
                        _this.userCountry =
                          res.data.detected_values.country.handle;
                        if (_this.cart) _this.initPromotion();
                      case 6:
                      case "end":
                        return _context.stop();
                    }
                }, _callee);
              })
            )();
          },
          initPromotion: function initPromotion() {
            var cartCurrency = this.cart && this.cart.currency;
            var threshold = null;
            if (cartCurrency === "GBP" && this.userCountry === "GB") {
              threshold = window.promotionFreeShippingGB || null;
            } else if (cartCurrency === "EUR" && this.userCountry === "IE") {
              threshold = window.promotionFreeShippingIE || null;
            }
            if (!threshold) {
              this.promotionFreeShipping = null;
              this.promotionEligible = false;
              return;
            }
            this.promotionFreeShipping = threshold;
            var isEligible =
              this.cart.total_price_unformatted >= this.promotionFreeShipping;
            this.promotionEligible = isEligible;
            if (isEligible) {
              this.promotionRemaining = 0;
              this.promotionRemainingPercent = "100%";
              this.promotionText = window.promotionFreeShippingSuccess;
            } else {
              this.promotionRemaining =
                this.promotionFreeShipping - this.cart.total_price_unformatted;
              this.promotionRemainingPercent = "".concat(
                (this.cart.total_price_unformatted /
                  this.promotionFreeShipping) *
                  100,
                "%"
              );
              var formattedMoney = (0,
              _utils_helpers__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(
                this.promotionRemaining
              );
              this.promotionText =
                window.promotionFreeShippingNotEligible.replace(
                  "{{ amount }}",
                  formattedMoney
                );
            }
          },
          fireShippingConfetti: function fireShippingConfetti() {
            if (typeof window.confetti !== "function") return;
            if (
              window.matchMedia &&
              window.matchMedia("(prefers-reduced-motion: reduce)").matches
            ) {
              return;
            }
            var colors = ["#7BAE3C", "#F4E27A", "#D94F4F", "#FFFFFF"];
            // Single small burst from the top-right corner (near the cart drawer header)
            window.confetti({
              particleCount: 40,
              angle: 225,
              spread: 70,
              startVelocity: 25,
              ticks: 60,
              scalar: 0.8,
              origin: { x: 0.92, y: 0.08 },
              zIndex: 9999,
              colors: colors,
            });
          },
          toggleMiniCart: function toggleMiniCart(state) {
            if (state === undefined) {
              this.isMiniCartOpen = !this.isMiniCartOpen;
              return;
            }
            this.isMiniCartOpen = state;
          },
          fetchCart: function fetchCart(_ref) {
            var _this2 = this;
            return _asyncToGenerator(
              /*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
                var _ref$showLoading, showLoading, response;
                return _regeneratorRuntime().wrap(
                  function _callee2$(_context2) {
                    while (1)
                      switch ((_context2.prev = _context2.next)) {
                        case 0:
                          (_ref$showLoading = _ref.showLoading),
                            (showLoading =
                              _ref$showLoading === void 0
                                ? true
                                : _ref$showLoading);
                          if (showLoading) {
                            _this2.isFetchingCart = true;
                          }
                          _context2.prev = 2;
                          _context2.next = 5;
                          return axios__WEBPACK_IMPORTED_MODULE_1__[
                            "default"
                          ].get("/cart?view=data");
                        case 5:
                          response = _context2.sent;
                          _this2.cart = response.data;
                          _this2.initPromotion();
                          _context2.next = 13;
                          break;
                        case 10:
                          _context2.prev = 10;
                          _context2.t0 = _context2["catch"](2);
                          console.error(_context2.t0, "Error in fetching cart");
                        case 13:
                          _context2.prev = 13;
                          _this2.isFetchingCart = false;
                          return _context2.finish(13);
                        case 16:
                        case "end":
                          return _context2.stop();
                      }
                  },
                  _callee2,
                  null,
                  [[2, 10, 13, 16]]
                );
              })
            )();
          },
          addToCart: function addToCart(_ref2) {
            var _this3 = this;
            return _asyncToGenerator(
              /*#__PURE__*/ _regeneratorRuntime().mark(function _callee3() {
                var variantId,
                  _ref2$quantity,
                  quantity,
                  _ref2$properties,
                  properties,
                  _ref2$shouldFetchCart,
                  shouldFetchCart,
                  _ref2$showFetchCartLo,
                  showFetchCartLoading,
                  _ref2$showMiniCartOnS,
                  showMiniCartOnSuccess,
                  params,
                  data;
                return _regeneratorRuntime().wrap(function _callee3$(
                  _context3
                ) {
                  while (1)
                    switch ((_context3.prev = _context3.next)) {
                      case 0:
                        (variantId = _ref2.variantId),
                          (_ref2$quantity = _ref2.quantity),
                          (quantity =
                            _ref2$quantity === void 0 ? 1 : _ref2$quantity),
                          (_ref2$properties = _ref2.properties),
                          (properties =
                            _ref2$properties === void 0
                              ? {}
                              : _ref2$properties),
                          (_ref2$shouldFetchCart = _ref2.shouldFetchCart),
                          (shouldFetchCart =
                            _ref2$shouldFetchCart === void 0
                              ? true
                              : _ref2$shouldFetchCart),
                          (_ref2$showFetchCartLo = _ref2.showFetchCartLoading),
                          (showFetchCartLoading =
                            _ref2$showFetchCartLo === void 0
                              ? true
                              : _ref2$showFetchCartLo),
                          (_ref2$showMiniCartOnS = _ref2.showMiniCartOnSuccess),
                          (showMiniCartOnSuccess =
                            _ref2$showMiniCartOnS === void 0
                              ? true
                              : _ref2$showMiniCartOnS),
                          (params = _objectWithoutProperties(_ref2, _excluded));
                        if (variantId) {
                          _context3.next = 3;
                          break;
                        }
                        return _context3.abrupt("return");
                      case 3:
                        _this3.isAddingToCart = !_this3.isAddingToCart;
                        data = _objectSpread(
                          _objectSpread(
                            {
                              quantity: quantity,
                              id: variantId,
                            },
                            params
                          ),
                          properties && {
                            properties: properties,
                          }
                        );
                        _context3.next = 7;
                        return cartAxiosInstace
                          .post("/cart/add.js", data)
                          .then(function (res) {
                            if (showMiniCartOnSuccess) {
                              _this3.toggleMiniCart(true);
                            }
                            if (shouldFetchCart) {
                              _this3.fetchCart({
                                showLoading: showFetchCartLoading,
                              });
                            }
                            return {
                              success: true,
                              res: res,
                            };
                          })
                          ["catch"](function (error) {
                            console.error(error, "error");
                            if (
                              error.response.data.description &&
                              error.response.status === 422
                            ) {
                              alert(error.response.data.description);
                            }
                            return {
                              success: false,
                            };
                          })
                          ["finally"](function () {
                            _this3.isAddingToCart = false;
                          });
                      case 7:
                        return _context3.abrupt("return", _context3.sent);
                      case 8:
                      case "end":
                        return _context3.stop();
                    }
                },
                _callee3);
              })
            )();
          },
          /**
           * Used for updating the quantity
           *
           * @param {string, number, boolean} { key, quantity, shouldFetchCart = true }
           * @return {*}
           */
          updateCart: function updateCart(_ref3) {
            var _this4 = this;
            return _asyncToGenerator(
              /*#__PURE__*/ _regeneratorRuntime().mark(function _callee5() {
                var key,
                  quantity,
                  _ref3$shouldFetchCart,
                  shouldFetchCart,
                  _ref3$showFetchCartLo,
                  showFetchCartLoading,
                  updates;
                return _regeneratorRuntime().wrap(function _callee5$(
                  _context5
                ) {
                  while (1)
                    switch ((_context5.prev = _context5.next)) {
                      case 0:
                        (key = _ref3.key),
                          (quantity = _ref3.quantity),
                          (_ref3$shouldFetchCart = _ref3.shouldFetchCart),
                          (shouldFetchCart =
                            _ref3$shouldFetchCart === void 0
                              ? true
                              : _ref3$shouldFetchCart),
                          (_ref3$showFetchCartLo = _ref3.showFetchCartLoading),
                          (showFetchCartLoading =
                            _ref3$showFetchCartLo === void 0
                              ? true
                              : _ref3$showFetchCartLo);
                        if (key) {
                          _context5.next = 3;
                          break;
                        }
                        return _context5.abrupt("return");
                      case 3:
                        _this4.isUpdatingCart = true;
                        updates = _defineProperty({}, key, quantity);
                        _context5.next = 7;
                        return cartAxiosInstace
                          .post("/cart/update.js", {
                            updates: updates,
                          })
                          .then(
                            /*#__PURE__*/ (function () {
                              var _ref4 = _asyncToGenerator(
                                /*#__PURE__*/ _regeneratorRuntime().mark(
                                  function _callee4(res) {
                                    return _regeneratorRuntime().wrap(
                                      function _callee4$(_context4) {
                                        while (1)
                                          switch (
                                            (_context4.prev = _context4.next)
                                          ) {
                                            case 0:
                                              if (!shouldFetchCart) {
                                                _context4.next = 3;
                                                break;
                                              }
                                              _context4.next = 3;
                                              return _this4.fetchCart({
                                                showLoading:
                                                  showFetchCartLoading,
                                              });
                                            case 3:
                                              return _context4.abrupt(
                                                "return",
                                                {
                                                  success: true,
                                                }
                                              );
                                            case 4:
                                            case "end":
                                              return _context4.stop();
                                          }
                                      },
                                      _callee4
                                    );
                                  }
                                )
                              );
                              return function (_x) {
                                return _ref4.apply(this, arguments);
                              };
                            })()
                          )
                          ["catch"](function (error) {
                            if (
                              error.response.data.description &&
                              error.response.status === 422
                            ) {
                              alert(error.response.data.description);
                            }
                            return {
                              success: false,
                            };
                          })
                          ["finally"](function () {
                            _this4.isUpdatingCart = false;
                            if (window.feks_appsettings)
                              window.discosLoadOfferSettings();
                          });
                      case 7:
                        return _context5.abrupt("return", _context5.sent);
                      case 8:
                      case "end":
                        return _context5.stop();
                    }
                },
                _callee5);
              })
            )();
          },
          /**
           * Used for updating the line item properties
           *
           * @param {string, number, object, boolean} { line, quantity, properties, shouldFetchCart = true }
           * @return {*}
           */
          changeCart: function changeCart(_ref5) {
            var _this5 = this;
            return _asyncToGenerator(
              /*#__PURE__*/ _regeneratorRuntime().mark(function _callee7() {
                var line,
                  quantity,
                  properties,
                  _ref5$shouldFetchCart,
                  shouldFetchCart,
                  _ref5$showFetchCartLo,
                  showFetchCartLoading;
                return _regeneratorRuntime().wrap(function _callee7$(
                  _context7
                ) {
                  while (1)
                    switch ((_context7.prev = _context7.next)) {
                      case 0:
                        (line = _ref5.line),
                          (quantity = _ref5.quantity),
                          (properties = _ref5.properties),
                          (_ref5$shouldFetchCart = _ref5.shouldFetchCart),
                          (shouldFetchCart =
                            _ref5$shouldFetchCart === void 0
                              ? true
                              : _ref5$shouldFetchCart),
                          (_ref5$showFetchCartLo = _ref5.showFetchCartLoading),
                          (showFetchCartLoading =
                            _ref5$showFetchCartLo === void 0
                              ? true
                              : _ref5$showFetchCartLo);
                        if (line) {
                          _context7.next = 3;
                          break;
                        }
                        return _context7.abrupt("return");
                      case 3:
                        _this5.isChangingCart = true;
                        _context7.next = 6;
                        return cartAxiosInstace
                          .post("/cart/change.js", {
                            line: line,
                            quantity: quantity,
                            properties: properties,
                          })
                          .then(
                            /*#__PURE__*/ _asyncToGenerator(
                              /*#__PURE__*/ _regeneratorRuntime().mark(
                                function _callee6() {
                                  return _regeneratorRuntime().wrap(
                                    function _callee6$(_context6) {
                                      while (1)
                                        switch (
                                          (_context6.prev = _context6.next)
                                        ) {
                                          case 0:
                                            if (!shouldFetchCart) {
                                              _context6.next = 3;
                                              break;
                                            }
                                            _context6.next = 3;
                                            return _this5.fetchCart({
                                              showLoading: showFetchCartLoading,
                                            });
                                          case 3:
                                            return _context6.abrupt("return", {
                                              success: true,
                                            });
                                          case 4:
                                          case "end":
                                            return _context6.stop();
                                        }
                                    },
                                    _callee6
                                  );
                                }
                              )
                            )
                          )
                          ["catch"](function (error) {
                            throw new Error(
                              error.message,
                              "Error in changing cart"
                            );
                          })
                          ["finally"](function () {
                            _this5.isChangingCart = false;
                          });
                      case 6:
                        return _context7.abrupt("return", _context7.sent);
                      case 7:
                      case "end":
                        return _context7.stop();
                    }
                },
                _callee7);
              })
            )();
          },
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          CartStore;

        /***/
      },

    /***/ "./src/scripts/store/localization-store.js":
      /*!*************************************************!*\
  !*** ./src/scripts/store/localization-store.js ***!
  \*************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        var LocalizationStore = {
          isCountrySelectorOpen: false,
          onItemClick: function onItemClick(value) {
            var form = event.target.closest("form");
            if (form) {
              var countryCodeHiddenInput = form.querySelector(
                "[data-selected-country]"
              );
              if (countryCodeHiddenInput) {
                countryCodeHiddenInput.value = value;
                form.submit();
              }
            }
          },
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          LocalizationStore;

        /***/
      },

    /***/ "./src/scripts/utils/helpers.js":
      /*!**************************************!*\
  !*** ./src/scripts/utils/helpers.js ***!
  \**************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ formatMoney: () => /* binding */ formatMoney,
          /* harmony export */ isEmailValid: () => /* binding */ isEmailValid,
          /* harmony export */ toFilteredUrlParams: () =>
            /* binding */ toFilteredUrlParams,
          /* harmony export */ toUrlParams: () => /* binding */ toUrlParams,
          /* harmony export */ updateDOMContent: () =>
            /* binding */ updateDOMContent,
          /* harmony export */ updateURL: () => /* binding */ updateURL,
          /* harmony export */
        });
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it =
            (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
            o["@@iterator"];
          if (!it) {
            if (
              Array.isArray(o) ||
              (it = _unsupportedIterableToArray(o)) ||
              (allowArrayLike && o && typeof o.length === "number")
            ) {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return { done: true };
                  return { done: false, value: o[i++] };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }
        /**
         * Convert an object into URL parameter format.
         *
         * @param {Object} obj - The object to convert.
         * @returns {string} The URL parameter representation of the object.
         *
         * @example
         * const urlParamsObj = {
         *     section_id: 'someId',
         *     sort_by: 'someSort',
         *     sampleArray: ['val1','val2']
         * };
         * console.log(toUrlParams(urlParamsObj));
         * // Output: section_id=someId&sort_by=someSort&sampleArray=val1&sampleArray=val2
         */
        function toUrlParams(obj) {
          var params = [];
          var _loop = function _loop(key) {
            if (obj.hasOwnProperty(key)) {
              // If the property value is an array, create multiple parameters
              if (Array.isArray(obj[key])) {
                obj[key].forEach(function (value) {
                  params.push(
                    ""
                      .concat(encodeURIComponent(key), "=")
                      .concat(encodeURIComponent(value))
                  );
                });
              } else {
                // For non-array values, just add the key-value pair as a parameter
                params.push(
                  ""
                    .concat(encodeURIComponent(key), "=")
                    .concat(encodeURIComponent(obj[key]))
                );
              }
            }
          };
          for (var key in obj) {
            _loop(key);
          }
          return params.join("&");
        }

        /**
         * Converts an object into a filtered URL parameter format.
         * Filters out "section_id" key.
         *
         * @param {Object} params - The object containing parameters to convert.
         * @returns {string} The filtered URL parameter representation of the object.
         *
         * @example
         * const paramsObj = {
         *     section_id: '12345',
         *     sort_by: 'date',
         *     tags: ['red', 'large']
         * };
         * console.log(toFilteredUrlParams(paramsObj));
         * // Output: sort_by=date&tags=red&tags=large
         */
        function toFilteredUrlParams(params) {
          var url = new URLSearchParams();
          for (var key in params) {
            if (key !== "section_id") {
              if (Array.isArray(params[key])) {
                // If the property is an array, add each item individually
                var _iterator = _createForOfIteratorHelper(params[key]),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                    var value = _step.value;
                    url.append(key, value);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              } else {
                url.append(key, params[key]);
              }
            }
          }
          return url.toString();
        }

        /**
         * Updates a DOM element with new content from a given HTML string.
         *
         * @param {string} selector - The selector of the element to update.
         * @param {string} responseHTML - The HTML string containing the updated content.
         */
        function updateDOMContent(selector, responseHTML) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(responseHTML, "text/html");
          var newContentElement = doc.querySelector(selector);
          var newContent = newContentElement
            ? newContentElement.innerHTML
            : null;
          var currentElement = document.querySelector(selector);
          if (currentElement) {
            if (newContent) {
              currentElement.innerHTML = newContent;
              currentElement.style.display = "";
            } else {
              currentElement.innerHTML = "";
              currentElement.style.display = "none";
            }
          }
        }
        function updateURL(newURL) {
          history.pushState({}, "", newURL);
        }
        function isEmailValid(email) {
          var pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
          return pattern.test(email);
        }

        /**
         * Format an integer to a money format with the current currency symbol.
         *
         * @param {number} amount - The integer to format as money.
         * @returns {string} - The formatted money string.
         */
        function formatMoney(amount) {
          if (
            typeof window.shopCurrencySymbol !== "string" ||
            typeof amount !== "number"
          ) {
            throw new Error(
              "Invalid input. Amount must be a number, and window.shopCurrencySymbol must be defined and a string."
            );
          }
          var formattedAmount = (amount / 100).toFixed(2); // Assuming the integer represents cents
          return window.shopCurrencySymbol + formattedAmount;
        }

        window.formatMoney = formatMoney;

        /***/
      },

    /***/ "./node_modules/base64-js/index.js":
      /*!*****************************************!*\
  !*** ./node_modules/base64-js/index.js ***!
  \*****************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        exports.byteLength = byteLength;
        exports.toByteArray = toByteArray;
        exports.fromByteArray = fromByteArray;

        var lookup = [];
        var revLookup = [];
        var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;

        var code =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        for (var i = 0, len = code.length; i < len; ++i) {
          lookup[i] = code[i];
          revLookup[code.charCodeAt(i)] = i;
        }

        // Support decoding URL-safe base64 strings, as Node.js does.
        // See: https://en.wikipedia.org/wiki/Base64#URL_applications
        revLookup["-".charCodeAt(0)] = 62;
        revLookup["_".charCodeAt(0)] = 63;

        function getLens(b64) {
          var len = b64.length;

          if (len % 4 > 0) {
            throw new Error("Invalid string. Length must be a multiple of 4");
          }

          // Trim off extra bytes after placeholder bytes are found
          // See: https://github.com/beatgammit/base64-js/issues/42
          var validLen = b64.indexOf("=");
          if (validLen === -1) validLen = len;

          var placeHoldersLen = validLen === len ? 0 : 4 - (validLen % 4);

          return [validLen, placeHoldersLen];
        }

        // base64 is 4/3 + up to two characters of the original data
        function byteLength(b64) {
          var lens = getLens(b64);
          var validLen = lens[0];
          var placeHoldersLen = lens[1];
          return ((validLen + placeHoldersLen) * 3) / 4 - placeHoldersLen;
        }

        function _byteLength(b64, validLen, placeHoldersLen) {
          return ((validLen + placeHoldersLen) * 3) / 4 - placeHoldersLen;
        }

        function toByteArray(b64) {
          var tmp;
          var lens = getLens(b64);
          var validLen = lens[0];
          var placeHoldersLen = lens[1];

          var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));

          var curByte = 0;

          // if there are placeholders, only get up to the last complete 4 chars
          var len = placeHoldersLen > 0 ? validLen - 4 : validLen;

          var i;
          for (i = 0; i < len; i += 4) {
            tmp =
              (revLookup[b64.charCodeAt(i)] << 18) |
              (revLookup[b64.charCodeAt(i + 1)] << 12) |
              (revLookup[b64.charCodeAt(i + 2)] << 6) |
              revLookup[b64.charCodeAt(i + 3)];
            arr[curByte++] = (tmp >> 16) & 0xff;
            arr[curByte++] = (tmp >> 8) & 0xff;
            arr[curByte++] = tmp & 0xff;
          }

          if (placeHoldersLen === 2) {
            tmp =
              (revLookup[b64.charCodeAt(i)] << 2) |
              (revLookup[b64.charCodeAt(i + 1)] >> 4);
            arr[curByte++] = tmp & 0xff;
          }

          if (placeHoldersLen === 1) {
            tmp =
              (revLookup[b64.charCodeAt(i)] << 10) |
              (revLookup[b64.charCodeAt(i + 1)] << 4) |
              (revLookup[b64.charCodeAt(i + 2)] >> 2);
            arr[curByte++] = (tmp >> 8) & 0xff;
            arr[curByte++] = tmp & 0xff;
          }

          return arr;
        }

        function tripletToBase64(num) {
          return (
            lookup[(num >> 18) & 0x3f] +
            lookup[(num >> 12) & 0x3f] +
            lookup[(num >> 6) & 0x3f] +
            lookup[num & 0x3f]
          );
        }

        function encodeChunk(uint8, start, end) {
          var tmp;
          var output = [];
          for (var i = start; i < end; i += 3) {
            tmp =
              ((uint8[i] << 16) & 0xff0000) +
              ((uint8[i + 1] << 8) & 0xff00) +
              (uint8[i + 2] & 0xff);
            output.push(tripletToBase64(tmp));
          }
          return output.join("");
        }

        function fromByteArray(uint8) {
          var tmp;
          var len = uint8.length;
          var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
          var parts = [];
          var maxChunkLength = 16383; // must be multiple of 3

          // go through the array every three bytes, we'll deal with trailing stuff later
          for (
            var i = 0, len2 = len - extraBytes;
            i < len2;
            i += maxChunkLength
          ) {
            parts.push(
              encodeChunk(
                uint8,
                i,
                i + maxChunkLength > len2 ? len2 : i + maxChunkLength
              )
            );
          }

          // pad the end with zeros, but make sure to not forget the extra bytes
          if (extraBytes === 1) {
            tmp = uint8[len - 1];
            parts.push(lookup[tmp >> 2] + lookup[(tmp << 4) & 0x3f] + "==");
          } else if (extraBytes === 2) {
            tmp = (uint8[len - 2] << 8) + uint8[len - 1];
            parts.push(
              lookup[tmp >> 10] +
                lookup[(tmp >> 4) & 0x3f] +
                lookup[(tmp << 2) & 0x3f] +
                "="
            );
          }

          return parts.join("");
        }

        /***/
      },

    /***/ "./node_modules/buffer/index.js":
      /*!**************************************!*\
  !*** ./node_modules/buffer/index.js ***!
  \**************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";
        /*!
         * The buffer module from node.js, for the browser.
         *
         * @author   Feross Aboukhadijeh <http://feross.org>
         * @license  MIT
         */
        /* eslint-disable no-proto */

        var base64 = __webpack_require__(
          /*! base64-js */ "./node_modules/base64-js/index.js"
        );
        var ieee754 = __webpack_require__(
          /*! ieee754 */ "./node_modules/ieee754/index.js"
        );
        var isArray = __webpack_require__(
          /*! isarray */ "./node_modules/isarray/index.js"
        );

        exports.Buffer = Buffer;
        exports.SlowBuffer = SlowBuffer;
        exports.INSPECT_MAX_BYTES = 50;

        /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
        Buffer.TYPED_ARRAY_SUPPORT =
          __webpack_require__.g.TYPED_ARRAY_SUPPORT !== undefined
            ? __webpack_require__.g.TYPED_ARRAY_SUPPORT
            : typedArraySupport();

        /*
         * Export kMaxLength after typed array support is determined.
         */
        exports.kMaxLength = kMaxLength();

        function typedArraySupport() {
          try {
            var arr = new Uint8Array(1);
            arr.__proto__ = {
              __proto__: Uint8Array.prototype,
              foo: function () {
                return 42;
              },
            };
            return (
              arr.foo() === 42 && // typed array instances can be augmented
              typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
              arr.subarray(1, 1).byteLength === 0
            ); // ie10 has broken `subarray`
          } catch (e) {
            return false;
          }
        }

        function kMaxLength() {
          return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
        }

        function createBuffer(that, length) {
          if (kMaxLength() < length) {
            throw new RangeError("Invalid typed array length");
          }
          if (Buffer.TYPED_ARRAY_SUPPORT) {
            // Return an augmented `Uint8Array` instance, for best performance
            that = new Uint8Array(length);
            that.__proto__ = Buffer.prototype;
          } else {
            // Fallback: Return an object instance of the Buffer class
            if (that === null) {
              that = new Buffer(length);
            }
            that.length = length;
          }

          return that;
        }

        /**
         * The Buffer constructor returns instances of `Uint8Array` that have their
         * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
         * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
         * and the `Uint8Array` methods. Square bracket notation works as expected -- it
         * returns a single octet.
         *
         * The `Uint8Array` prototype remains unmodified.
         */

        function Buffer(arg, encodingOrOffset, length) {
          if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
            return new Buffer(arg, encodingOrOffset, length);
          }

          // Common case.
          if (typeof arg === "number") {
            if (typeof encodingOrOffset === "string") {
              throw new Error(
                "If encoding is specified then the first argument must be a string"
              );
            }
            return allocUnsafe(this, arg);
          }
          return from(this, arg, encodingOrOffset, length);
        }

        Buffer.poolSize = 8192; // not used by this implementation

        // TODO: Legacy, not needed anymore. Remove in next major version.
        Buffer._augment = function (arr) {
          arr.__proto__ = Buffer.prototype;
          return arr;
        };

        function from(that, value, encodingOrOffset, length) {
          if (typeof value === "number") {
            throw new TypeError('"value" argument must not be a number');
          }

          if (
            typeof ArrayBuffer !== "undefined" &&
            value instanceof ArrayBuffer
          ) {
            return fromArrayBuffer(that, value, encodingOrOffset, length);
          }

          if (typeof value === "string") {
            return fromString(that, value, encodingOrOffset);
          }

          return fromObject(that, value);
        }

        /**
         * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
         * if value is a number.
         * Buffer.from(str[, encoding])
         * Buffer.from(array)
         * Buffer.from(buffer)
         * Buffer.from(arrayBuffer[, byteOffset[, length]])
         **/
        Buffer.from = function (value, encodingOrOffset, length) {
          return from(null, value, encodingOrOffset, length);
        };

        if (Buffer.TYPED_ARRAY_SUPPORT) {
          Buffer.prototype.__proto__ = Uint8Array.prototype;
          Buffer.__proto__ = Uint8Array;
          if (
            typeof Symbol !== "undefined" &&
            Symbol.species &&
            Buffer[Symbol.species] === Buffer
          ) {
            // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
            Object.defineProperty(Buffer, Symbol.species, {
              value: null,
              configurable: true,
            });
          }
        }

        function assertSize(size) {
          if (typeof size !== "number") {
            throw new TypeError('"size" argument must be a number');
          } else if (size < 0) {
            throw new RangeError('"size" argument must not be negative');
          }
        }

        function alloc(that, size, fill, encoding) {
          assertSize(size);
          if (size <= 0) {
            return createBuffer(that, size);
          }
          if (fill !== undefined) {
            // Only pay attention to encoding if it's a string. This
            // prevents accidentally sending in a number that would
            // be interpretted as a start offset.
            return typeof encoding === "string"
              ? createBuffer(that, size).fill(fill, encoding)
              : createBuffer(that, size).fill(fill);
          }
          return createBuffer(that, size);
        }

        /**
         * Creates a new filled Buffer instance.
         * alloc(size[, fill[, encoding]])
         **/
        Buffer.alloc = function (size, fill, encoding) {
          return alloc(null, size, fill, encoding);
        };

        function allocUnsafe(that, size) {
          assertSize(size);
          that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
          if (!Buffer.TYPED_ARRAY_SUPPORT) {
            for (var i = 0; i < size; ++i) {
              that[i] = 0;
            }
          }
          return that;
        }

        /**
         * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
         * */
        Buffer.allocUnsafe = function (size) {
          return allocUnsafe(null, size);
        };
        /**
         * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
         */
        Buffer.allocUnsafeSlow = function (size) {
          return allocUnsafe(null, size);
        };

        function fromString(that, string, encoding) {
          if (typeof encoding !== "string" || encoding === "") {
            encoding = "utf8";
          }

          if (!Buffer.isEncoding(encoding)) {
            throw new TypeError('"encoding" must be a valid string encoding');
          }

          var length = byteLength(string, encoding) | 0;
          that = createBuffer(that, length);

          var actual = that.write(string, encoding);

          if (actual !== length) {
            // Writing a hex string, for example, that contains invalid characters will
            // cause everything after the first invalid character to be ignored. (e.g.
            // 'abxxcd' will be treated as 'ab')
            that = that.slice(0, actual);
          }

          return that;
        }

        function fromArrayLike(that, array) {
          var length = array.length < 0 ? 0 : checked(array.length) | 0;
          that = createBuffer(that, length);
          for (var i = 0; i < length; i += 1) {
            that[i] = array[i] & 255;
          }
          return that;
        }

        function fromArrayBuffer(that, array, byteOffset, length) {
          array.byteLength; // this throws if `array` is not a valid ArrayBuffer

          if (byteOffset < 0 || array.byteLength < byteOffset) {
            throw new RangeError("'offset' is out of bounds");
          }

          if (array.byteLength < byteOffset + (length || 0)) {
            throw new RangeError("'length' is out of bounds");
          }

          if (byteOffset === undefined && length === undefined) {
            array = new Uint8Array(array);
          } else if (length === undefined) {
            array = new Uint8Array(array, byteOffset);
          } else {
            array = new Uint8Array(array, byteOffset, length);
          }

          if (Buffer.TYPED_ARRAY_SUPPORT) {
            // Return an augmented `Uint8Array` instance, for best performance
            that = array;
            that.__proto__ = Buffer.prototype;
          } else {
            // Fallback: Return an object instance of the Buffer class
            that = fromArrayLike(that, array);
          }
          return that;
        }

        function fromObject(that, obj) {
          if (Buffer.isBuffer(obj)) {
            var len = checked(obj.length) | 0;
            that = createBuffer(that, len);

            if (that.length === 0) {
              return that;
            }

            obj.copy(that, 0, 0, len);
            return that;
          }

          if (obj) {
            if (
              (typeof ArrayBuffer !== "undefined" &&
                obj.buffer instanceof ArrayBuffer) ||
              "length" in obj
            ) {
              if (typeof obj.length !== "number" || isnan(obj.length)) {
                return createBuffer(that, 0);
              }
              return fromArrayLike(that, obj);
            }

            if (obj.type === "Buffer" && isArray(obj.data)) {
              return fromArrayLike(that, obj.data);
            }
          }

          throw new TypeError(
            "First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object."
          );
        }

        function checked(length) {
          // Note: cannot use `length < kMaxLength()` here because that fails when
          // length is NaN (which is otherwise coerced to zero.)
          if (length >= kMaxLength()) {
            throw new RangeError(
              "Attempt to allocate Buffer larger than maximum " +
                "size: 0x" +
                kMaxLength().toString(16) +
                " bytes"
            );
          }
          return length | 0;
        }

        function SlowBuffer(length) {
          if (+length != length) {
            // eslint-disable-line eqeqeq
            length = 0;
          }
          return Buffer.alloc(+length);
        }

        Buffer.isBuffer = function isBuffer(b) {
          return !!(b != null && b._isBuffer);
        };

        Buffer.compare = function compare(a, b) {
          if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
            throw new TypeError("Arguments must be Buffers");
          }

          if (a === b) return 0;

          var x = a.length;
          var y = b.length;

          for (var i = 0, len = Math.min(x, y); i < len; ++i) {
            if (a[i] !== b[i]) {
              x = a[i];
              y = b[i];
              break;
            }
          }

          if (x < y) return -1;
          if (y < x) return 1;
          return 0;
        };

        Buffer.isEncoding = function isEncoding(encoding) {
          switch (String(encoding).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return true;
            default:
              return false;
          }
        };

        Buffer.concat = function concat(list, length) {
          if (!isArray(list)) {
            throw new TypeError('"list" argument must be an Array of Buffers');
          }

          if (list.length === 0) {
            return Buffer.alloc(0);
          }

          var i;
          if (length === undefined) {
            length = 0;
            for (i = 0; i < list.length; ++i) {
              length += list[i].length;
            }
          }

          var buffer = Buffer.allocUnsafe(length);
          var pos = 0;
          for (i = 0; i < list.length; ++i) {
            var buf = list[i];
            if (!Buffer.isBuffer(buf)) {
              throw new TypeError(
                '"list" argument must be an Array of Buffers'
              );
            }
            buf.copy(buffer, pos);
            pos += buf.length;
          }
          return buffer;
        };

        function byteLength(string, encoding) {
          if (Buffer.isBuffer(string)) {
            return string.length;
          }
          if (
            typeof ArrayBuffer !== "undefined" &&
            typeof ArrayBuffer.isView === "function" &&
            (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)
          ) {
            return string.byteLength;
          }
          if (typeof string !== "string") {
            string = "" + string;
          }

          var len = string.length;
          if (len === 0) return 0;

          // Use a for loop to avoid recursion
          var loweredCase = false;
          for (;;) {
            switch (encoding) {
              case "ascii":
              case "latin1":
              case "binary":
                return len;
              case "utf8":
              case "utf-8":
              case undefined:
                return utf8ToBytes(string).length;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return len * 2;
              case "hex":
                return len >>> 1;
              case "base64":
                return base64ToBytes(string).length;
              default:
                if (loweredCase) return utf8ToBytes(string).length; // assume utf8
                encoding = ("" + encoding).toLowerCase();
                loweredCase = true;
            }
          }
        }
        Buffer.byteLength = byteLength;

        function slowToString(encoding, start, end) {
          var loweredCase = false;

          // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
          // property of a typed array.

          // This behaves neither like String nor Uint8Array in that we set start/end
          // to their upper/lower bounds if the value passed is out of range.
          // undefined is handled specially as per ECMA-262 6th Edition,
          // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
          if (start === undefined || start < 0) {
            start = 0;
          }
          // Return early if start > this.length. Done here to prevent potential uint32
          // coercion fail below.
          if (start > this.length) {
            return "";
          }

          if (end === undefined || end > this.length) {
            end = this.length;
          }

          if (end <= 0) {
            return "";
          }

          // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
          end >>>= 0;
          start >>>= 0;

          if (end <= start) {
            return "";
          }

          if (!encoding) encoding = "utf8";

          while (true) {
            switch (encoding) {
              case "hex":
                return hexSlice(this, start, end);

              case "utf8":
              case "utf-8":
                return utf8Slice(this, start, end);

              case "ascii":
                return asciiSlice(this, start, end);

              case "latin1":
              case "binary":
                return latin1Slice(this, start, end);

              case "base64":
                return base64Slice(this, start, end);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return utf16leSlice(this, start, end);

              default:
                if (loweredCase)
                  throw new TypeError("Unknown encoding: " + encoding);
                encoding = (encoding + "").toLowerCase();
                loweredCase = true;
            }
          }
        }

        // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
        // Buffer instances.
        Buffer.prototype._isBuffer = true;

        function swap(b, n, m) {
          var i = b[n];
          b[n] = b[m];
          b[m] = i;
        }

        Buffer.prototype.swap16 = function swap16() {
          var len = this.length;
          if (len % 2 !== 0) {
            throw new RangeError("Buffer size must be a multiple of 16-bits");
          }
          for (var i = 0; i < len; i += 2) {
            swap(this, i, i + 1);
          }
          return this;
        };

        Buffer.prototype.swap32 = function swap32() {
          var len = this.length;
          if (len % 4 !== 0) {
            throw new RangeError("Buffer size must be a multiple of 32-bits");
          }
          for (var i = 0; i < len; i += 4) {
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
          }
          return this;
        };

        Buffer.prototype.swap64 = function swap64() {
          var len = this.length;
          if (len % 8 !== 0) {
            throw new RangeError("Buffer size must be a multiple of 64-bits");
          }
          for (var i = 0; i < len; i += 8) {
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
          }
          return this;
        };

        Buffer.prototype.toString = function toString() {
          var length = this.length | 0;
          if (length === 0) return "";
          if (arguments.length === 0) return utf8Slice(this, 0, length);
          return slowToString.apply(this, arguments);
        };

        Buffer.prototype.equals = function equals(b) {
          if (!Buffer.isBuffer(b))
            throw new TypeError("Argument must be a Buffer");
          if (this === b) return true;
          return Buffer.compare(this, b) === 0;
        };

        Buffer.prototype.inspect = function inspect() {
          var str = "";
          var max = exports.INSPECT_MAX_BYTES;
          if (this.length > 0) {
            str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
            if (this.length > max) str += " ... ";
          }
          return "<Buffer " + str + ">";
        };

        Buffer.prototype.compare = function compare(
          target,
          start,
          end,
          thisStart,
          thisEnd
        ) {
          if (!Buffer.isBuffer(target)) {
            throw new TypeError("Argument must be a Buffer");
          }

          if (start === undefined) {
            start = 0;
          }
          if (end === undefined) {
            end = target ? target.length : 0;
          }
          if (thisStart === undefined) {
            thisStart = 0;
          }
          if (thisEnd === undefined) {
            thisEnd = this.length;
          }

          if (
            start < 0 ||
            end > target.length ||
            thisStart < 0 ||
            thisEnd > this.length
          ) {
            throw new RangeError("out of range index");
          }

          if (thisStart >= thisEnd && start >= end) {
            return 0;
          }
          if (thisStart >= thisEnd) {
            return -1;
          }
          if (start >= end) {
            return 1;
          }

          start >>>= 0;
          end >>>= 0;
          thisStart >>>= 0;
          thisEnd >>>= 0;

          if (this === target) return 0;

          var x = thisEnd - thisStart;
          var y = end - start;
          var len = Math.min(x, y);

          var thisCopy = this.slice(thisStart, thisEnd);
          var targetCopy = target.slice(start, end);

          for (var i = 0; i < len; ++i) {
            if (thisCopy[i] !== targetCopy[i]) {
              x = thisCopy[i];
              y = targetCopy[i];
              break;
            }
          }

          if (x < y) return -1;
          if (y < x) return 1;
          return 0;
        };

        // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
        // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
        //
        // Arguments:
        // - buffer - a Buffer to search
        // - val - a string, Buffer, or number
        // - byteOffset - an index into `buffer`; will be clamped to an int32
        // - encoding - an optional encoding, relevant is val is a string
        // - dir - true for indexOf, false for lastIndexOf
        function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
          // Empty buffer means no match
          if (buffer.length === 0) return -1;

          // Normalize byteOffset
          if (typeof byteOffset === "string") {
            encoding = byteOffset;
            byteOffset = 0;
          } else if (byteOffset > 0x7fffffff) {
            byteOffset = 0x7fffffff;
          } else if (byteOffset < -0x80000000) {
            byteOffset = -0x80000000;
          }
          byteOffset = +byteOffset; // Coerce to Number.
          if (isNaN(byteOffset)) {
            // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
            byteOffset = dir ? 0 : buffer.length - 1;
          }

          // Normalize byteOffset: negative offsets start from the end of the buffer
          if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
          if (byteOffset >= buffer.length) {
            if (dir) return -1;
            else byteOffset = buffer.length - 1;
          } else if (byteOffset < 0) {
            if (dir) byteOffset = 0;
            else return -1;
          }

          // Normalize val
          if (typeof val === "string") {
            val = Buffer.from(val, encoding);
          }

          // Finally, search either indexOf (if dir is true) or lastIndexOf
          if (Buffer.isBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) {
              return -1;
            }
            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
          } else if (typeof val === "number") {
            val = val & 0xff; // Search for a byte value [0-255]
            if (
              Buffer.TYPED_ARRAY_SUPPORT &&
              typeof Uint8Array.prototype.indexOf === "function"
            ) {
              if (dir) {
                return Uint8Array.prototype.indexOf.call(
                  buffer,
                  val,
                  byteOffset
                );
              } else {
                return Uint8Array.prototype.lastIndexOf.call(
                  buffer,
                  val,
                  byteOffset
                );
              }
            }
            return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
          }

          throw new TypeError("val must be string, number or Buffer");
        }

        function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
          var indexSize = 1;
          var arrLength = arr.length;
          var valLength = val.length;

          if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();
            if (
              encoding === "ucs2" ||
              encoding === "ucs-2" ||
              encoding === "utf16le" ||
              encoding === "utf-16le"
            ) {
              if (arr.length < 2 || val.length < 2) {
                return -1;
              }
              indexSize = 2;
              arrLength /= 2;
              valLength /= 2;
              byteOffset /= 2;
            }
          }

          function read(buf, i) {
            if (indexSize === 1) {
              return buf[i];
            } else {
              return buf.readUInt16BE(i * indexSize);
            }
          }

          var i;
          if (dir) {
            var foundIndex = -1;
            for (i = byteOffset; i < arrLength; i++) {
              if (
                read(arr, i) ===
                read(val, foundIndex === -1 ? 0 : i - foundIndex)
              ) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength)
                  return foundIndex * indexSize;
              } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
              }
            }
          } else {
            if (byteOffset + valLength > arrLength)
              byteOffset = arrLength - valLength;
            for (i = byteOffset; i >= 0; i--) {
              var found = true;
              for (var j = 0; j < valLength; j++) {
                if (read(arr, i + j) !== read(val, j)) {
                  found = false;
                  break;
                }
              }
              if (found) return i;
            }
          }

          return -1;
        }

        Buffer.prototype.includes = function includes(
          val,
          byteOffset,
          encoding
        ) {
          return this.indexOf(val, byteOffset, encoding) !== -1;
        };

        Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
          return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
        };

        Buffer.prototype.lastIndexOf = function lastIndexOf(
          val,
          byteOffset,
          encoding
        ) {
          return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
        };

        function hexWrite(buf, string, offset, length) {
          offset = Number(offset) || 0;
          var remaining = buf.length - offset;
          if (!length) {
            length = remaining;
          } else {
            length = Number(length);
            if (length > remaining) {
              length = remaining;
            }
          }

          // must be an even number of digits
          var strLen = string.length;
          if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");

          if (length > strLen / 2) {
            length = strLen / 2;
          }
          for (var i = 0; i < length; ++i) {
            var parsed = parseInt(string.substr(i * 2, 2), 16);
            if (isNaN(parsed)) return i;
            buf[offset + i] = parsed;
          }
          return i;
        }

        function utf8Write(buf, string, offset, length) {
          return blitBuffer(
            utf8ToBytes(string, buf.length - offset),
            buf,
            offset,
            length
          );
        }

        function asciiWrite(buf, string, offset, length) {
          return blitBuffer(asciiToBytes(string), buf, offset, length);
        }

        function latin1Write(buf, string, offset, length) {
          return asciiWrite(buf, string, offset, length);
        }

        function base64Write(buf, string, offset, length) {
          return blitBuffer(base64ToBytes(string), buf, offset, length);
        }

        function ucs2Write(buf, string, offset, length) {
          return blitBuffer(
            utf16leToBytes(string, buf.length - offset),
            buf,
            offset,
            length
          );
        }

        Buffer.prototype.write = function write(
          string,
          offset,
          length,
          encoding
        ) {
          // Buffer#write(string)
          if (offset === undefined) {
            encoding = "utf8";
            length = this.length;
            offset = 0;
            // Buffer#write(string, encoding)
          } else if (length === undefined && typeof offset === "string") {
            encoding = offset;
            length = this.length;
            offset = 0;
            // Buffer#write(string, offset[, length][, encoding])
          } else if (isFinite(offset)) {
            offset = offset | 0;
            if (isFinite(length)) {
              length = length | 0;
              if (encoding === undefined) encoding = "utf8";
            } else {
              encoding = length;
              length = undefined;
            }
            // legacy write(string, encoding, offset, length) - remove in v0.13
          } else {
            throw new Error(
              "Buffer.write(string, encoding, offset[, length]) is no longer supported"
            );
          }

          var remaining = this.length - offset;
          if (length === undefined || length > remaining) length = remaining;

          if (
            (string.length > 0 && (length < 0 || offset < 0)) ||
            offset > this.length
          ) {
            throw new RangeError("Attempt to write outside buffer bounds");
          }

          if (!encoding) encoding = "utf8";

          var loweredCase = false;
          for (;;) {
            switch (encoding) {
              case "hex":
                return hexWrite(this, string, offset, length);

              case "utf8":
              case "utf-8":
                return utf8Write(this, string, offset, length);

              case "ascii":
                return asciiWrite(this, string, offset, length);

              case "latin1":
              case "binary":
                return latin1Write(this, string, offset, length);

              case "base64":
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return ucs2Write(this, string, offset, length);

              default:
                if (loweredCase)
                  throw new TypeError("Unknown encoding: " + encoding);
                encoding = ("" + encoding).toLowerCase();
                loweredCase = true;
            }
          }
        };

        Buffer.prototype.toJSON = function toJSON() {
          return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0),
          };
        };

        function base64Slice(buf, start, end) {
          if (start === 0 && end === buf.length) {
            return base64.fromByteArray(buf);
          } else {
            return base64.fromByteArray(buf.slice(start, end));
          }
        }

        function utf8Slice(buf, start, end) {
          end = Math.min(buf.length, end);
          var res = [];

          var i = start;
          while (i < end) {
            var firstByte = buf[i];
            var codePoint = null;
            var bytesPerSequence =
              firstByte > 0xef
                ? 4
                : firstByte > 0xdf
                ? 3
                : firstByte > 0xbf
                ? 2
                : 1;

            if (i + bytesPerSequence <= end) {
              var secondByte, thirdByte, fourthByte, tempCodePoint;

              switch (bytesPerSequence) {
                case 1:
                  if (firstByte < 0x80) {
                    codePoint = firstByte;
                  }
                  break;
                case 2:
                  secondByte = buf[i + 1];
                  if ((secondByte & 0xc0) === 0x80) {
                    tempCodePoint =
                      ((firstByte & 0x1f) << 0x6) | (secondByte & 0x3f);
                    if (tempCodePoint > 0x7f) {
                      codePoint = tempCodePoint;
                    }
                  }
                  break;
                case 3:
                  secondByte = buf[i + 1];
                  thirdByte = buf[i + 2];
                  if (
                    (secondByte & 0xc0) === 0x80 &&
                    (thirdByte & 0xc0) === 0x80
                  ) {
                    tempCodePoint =
                      ((firstByte & 0xf) << 0xc) |
                      ((secondByte & 0x3f) << 0x6) |
                      (thirdByte & 0x3f);
                    if (
                      tempCodePoint > 0x7ff &&
                      (tempCodePoint < 0xd800 || tempCodePoint > 0xdfff)
                    ) {
                      codePoint = tempCodePoint;
                    }
                  }
                  break;
                case 4:
                  secondByte = buf[i + 1];
                  thirdByte = buf[i + 2];
                  fourthByte = buf[i + 3];
                  if (
                    (secondByte & 0xc0) === 0x80 &&
                    (thirdByte & 0xc0) === 0x80 &&
                    (fourthByte & 0xc0) === 0x80
                  ) {
                    tempCodePoint =
                      ((firstByte & 0xf) << 0x12) |
                      ((secondByte & 0x3f) << 0xc) |
                      ((thirdByte & 0x3f) << 0x6) |
                      (fourthByte & 0x3f);
                    if (tempCodePoint > 0xffff && tempCodePoint < 0x110000) {
                      codePoint = tempCodePoint;
                    }
                  }
              }
            }

            if (codePoint === null) {
              // we did not generate a valid codePoint so insert a
              // replacement char (U+FFFD) and advance only 1 byte
              codePoint = 0xfffd;
              bytesPerSequence = 1;
            } else if (codePoint > 0xffff) {
              // encode to utf16 (surrogate pair dance)
              codePoint -= 0x10000;
              res.push(((codePoint >>> 10) & 0x3ff) | 0xd800);
              codePoint = 0xdc00 | (codePoint & 0x3ff);
            }

            res.push(codePoint);
            i += bytesPerSequence;
          }

          return decodeCodePointsArray(res);
        }

        // Based on http://stackoverflow.com/a/22747272/680742, the browser with
        // the lowest limit is Chrome, with 0x10000 args.
        // We go 1 magnitude less, for safety
        var MAX_ARGUMENTS_LENGTH = 0x1000;

        function decodeCodePointsArray(codePoints) {
          var len = codePoints.length;
          if (len <= MAX_ARGUMENTS_LENGTH) {
            return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
          }

          // Decode in chunks to avoid "call stack size exceeded".
          var res = "";
          var i = 0;
          while (i < len) {
            res += String.fromCharCode.apply(
              String,
              codePoints.slice(i, (i += MAX_ARGUMENTS_LENGTH))
            );
          }
          return res;
        }

        function asciiSlice(buf, start, end) {
          var ret = "";
          end = Math.min(buf.length, end);

          for (var i = start; i < end; ++i) {
            ret += String.fromCharCode(buf[i] & 0x7f);
          }
          return ret;
        }

        function latin1Slice(buf, start, end) {
          var ret = "";
          end = Math.min(buf.length, end);

          for (var i = start; i < end; ++i) {
            ret += String.fromCharCode(buf[i]);
          }
          return ret;
        }

        function hexSlice(buf, start, end) {
          var len = buf.length;

          if (!start || start < 0) start = 0;
          if (!end || end < 0 || end > len) end = len;

          var out = "";
          for (var i = start; i < end; ++i) {
            out += toHex(buf[i]);
          }
          return out;
        }

        function utf16leSlice(buf, start, end) {
          var bytes = buf.slice(start, end);
          var res = "";
          for (var i = 0; i < bytes.length; i += 2) {
            res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
          }
          return res;
        }

        Buffer.prototype.slice = function slice(start, end) {
          var len = this.length;
          start = ~~start;
          end = end === undefined ? len : ~~end;

          if (start < 0) {
            start += len;
            if (start < 0) start = 0;
          } else if (start > len) {
            start = len;
          }

          if (end < 0) {
            end += len;
            if (end < 0) end = 0;
          } else if (end > len) {
            end = len;
          }

          if (end < start) end = start;

          var newBuf;
          if (Buffer.TYPED_ARRAY_SUPPORT) {
            newBuf = this.subarray(start, end);
            newBuf.__proto__ = Buffer.prototype;
          } else {
            var sliceLen = end - start;
            newBuf = new Buffer(sliceLen, undefined);
            for (var i = 0; i < sliceLen; ++i) {
              newBuf[i] = this[i + start];
            }
          }

          return newBuf;
        };

        /*
         * Need to make sure that buffer isn't trying to write out of bounds.
         */
        function checkOffset(offset, ext, length) {
          if (offset % 1 !== 0 || offset < 0)
            throw new RangeError("offset is not uint");
          if (offset + ext > length)
            throw new RangeError("Trying to access beyond buffer length");
        }

        Buffer.prototype.readUIntLE = function readUIntLE(
          offset,
          byteLength,
          noAssert
        ) {
          offset = offset | 0;
          byteLength = byteLength | 0;
          if (!noAssert) checkOffset(offset, byteLength, this.length);

          var val = this[offset];
          var mul = 1;
          var i = 0;
          while (++i < byteLength && (mul *= 0x100)) {
            val += this[offset + i] * mul;
          }

          return val;
        };

        Buffer.prototype.readUIntBE = function readUIntBE(
          offset,
          byteLength,
          noAssert
        ) {
          offset = offset | 0;
          byteLength = byteLength | 0;
          if (!noAssert) {
            checkOffset(offset, byteLength, this.length);
          }

          var val = this[offset + --byteLength];
          var mul = 1;
          while (byteLength > 0 && (mul *= 0x100)) {
            val += this[offset + --byteLength] * mul;
          }

          return val;
        };

        Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
          if (!noAssert) checkOffset(offset, 1, this.length);
          return this[offset];
        };

        Buffer.prototype.readUInt16LE = function readUInt16LE(
          offset,
          noAssert
        ) {
          if (!noAssert) checkOffset(offset, 2, this.length);
          return this[offset] | (this[offset + 1] << 8);
        };

        Buffer.prototype.readUInt16BE = function readUInt16BE(
          offset,
          noAssert
        ) {
          if (!noAssert) checkOffset(offset, 2, this.length);
          return (this[offset] << 8) | this[offset + 1];
        };

        Buffer.prototype.readUInt32LE = function readUInt32LE(
          offset,
          noAssert
        ) {
          if (!noAssert) checkOffset(offset, 4, this.length);

          return (
            (this[offset] |
              (this[offset + 1] << 8) |
              (this[offset + 2] << 16)) +
            this[offset + 3] * 0x1000000
          );
        };

        Buffer.prototype.readUInt32BE = function readUInt32BE(
          offset,
          noAssert
        ) {
          if (!noAssert) checkOffset(offset, 4, this.length);

          return (
            this[offset] * 0x1000000 +
            ((this[offset + 1] << 16) |
              (this[offset + 2] << 8) |
              this[offset + 3])
          );
        };

        Buffer.prototype.readIntLE = function readIntLE(
          offset,
          byteLength,
          noAssert
        ) {
          offset = offset | 0;
          byteLength = byteLength | 0;
          if (!noAssert) checkOffset(offset, byteLength, this.length);

          var val = this[offset];
          var mul = 1;
          var i = 0;
          while (++i < byteLength && (mul *= 0x100)) {
            val += this[offset + i] * mul;
          }
          mul *= 0x80;

          if (val >= mul) val -= Math.pow(2, 8 * byteLength);

          return val;
        };

        Buffer.prototype.readIntBE = function readIntBE(
          offset,
          byteLength,
          noAssert
        ) {
          offset = offset | 0;
          byteLength = byteLength | 0;
          if (!noAssert) checkOffset(offset, byteLength, this.length);

          var i = byteLength;
          var mul = 1;
          var val = this[offset + --i];
          while (i > 0 && (mul *= 0x100)) {
            val += this[offset + --i] * mul;
          }
          mul *= 0x80;

          if (val >= mul) val -= Math.pow(2, 8 * byteLength);

          return val;
        };

        Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
          if (!noAssert) checkOffset(offset, 1, this.length);
          if (!(this[offset] & 0x80)) return this[offset];
          return (0xff - this[offset] + 1) * -1;
        };

        Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
          if (!noAssert) checkOffset(offset, 2, this.length);
          var val = this[offset] | (this[offset + 1] << 8);
          return val & 0x8000 ? val | 0xffff0000 : val;
        };

        Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
          if (!noAssert) checkOffset(offset, 2, this.length);
          var val = this[offset + 1] | (this[offset] << 8);
          return val & 0x8000 ? val | 0xffff0000 : val;
        };

        Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
          if (!noAssert) checkOffset(offset, 4, this.length);

          return (
            this[offset] |
            (this[offset + 1] << 8) |
            (this[offset + 2] << 16) |
            (this[offset + 3] << 24)
          );
        };

        Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
          if (!noAssert) checkOffset(offset, 4, this.length);

          return (
            (this[offset] << 24) |
            (this[offset + 1] << 16) |
            (this[offset + 2] << 8) |
            this[offset + 3]
          );
        };

        Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
          if (!noAssert) checkOffset(offset, 4, this.length);
          return ieee754.read(this, offset, true, 23, 4);
        };

        Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
          if (!noAssert) checkOffset(offset, 4, this.length);
          return ieee754.read(this, offset, false, 23, 4);
        };

        Buffer.prototype.readDoubleLE = function readDoubleLE(
          offset,
          noAssert
        ) {
          if (!noAssert) checkOffset(offset, 8, this.length);
          return ieee754.read(this, offset, true, 52, 8);
        };

        Buffer.prototype.readDoubleBE = function readDoubleBE(
          offset,
          noAssert
        ) {
          if (!noAssert) checkOffset(offset, 8, this.length);
          return ieee754.read(this, offset, false, 52, 8);
        };

        function checkInt(buf, value, offset, ext, max, min) {
          if (!Buffer.isBuffer(buf))
            throw new TypeError('"buffer" argument must be a Buffer instance');
          if (value > max || value < min)
            throw new RangeError('"value" argument is out of bounds');
          if (offset + ext > buf.length)
            throw new RangeError("Index out of range");
        }

        Buffer.prototype.writeUIntLE = function writeUIntLE(
          value,
          offset,
          byteLength,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          byteLength = byteLength | 0;
          if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
          }

          var mul = 1;
          var i = 0;
          this[offset] = value & 0xff;
          while (++i < byteLength && (mul *= 0x100)) {
            this[offset + i] = (value / mul) & 0xff;
          }

          return offset + byteLength;
        };

        Buffer.prototype.writeUIntBE = function writeUIntBE(
          value,
          offset,
          byteLength,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          byteLength = byteLength | 0;
          if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
          }

          var i = byteLength - 1;
          var mul = 1;
          this[offset + i] = value & 0xff;
          while (--i >= 0 && (mul *= 0x100)) {
            this[offset + i] = (value / mul) & 0xff;
          }

          return offset + byteLength;
        };

        Buffer.prototype.writeUInt8 = function writeUInt8(
          value,
          offset,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
          if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
          this[offset] = value & 0xff;
          return offset + 1;
        };

        function objectWriteUInt16(buf, value, offset, littleEndian) {
          if (value < 0) value = 0xffff + value + 1;
          for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
            buf[offset + i] =
              (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
              ((littleEndian ? i : 1 - i) * 8);
          }
        }

        Buffer.prototype.writeUInt16LE = function writeUInt16LE(
          value,
          offset,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
          if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value & 0xff;
            this[offset + 1] = value >>> 8;
          } else {
            objectWriteUInt16(this, value, offset, true);
          }
          return offset + 2;
        };

        Buffer.prototype.writeUInt16BE = function writeUInt16BE(
          value,
          offset,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
          if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value >>> 8;
            this[offset + 1] = value & 0xff;
          } else {
            objectWriteUInt16(this, value, offset, false);
          }
          return offset + 2;
        };

        function objectWriteUInt32(buf, value, offset, littleEndian) {
          if (value < 0) value = 0xffffffff + value + 1;
          for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
            buf[offset + i] =
              (value >>> ((littleEndian ? i : 3 - i) * 8)) & 0xff;
          }
        }

        Buffer.prototype.writeUInt32LE = function writeUInt32LE(
          value,
          offset,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
          if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset + 3] = value >>> 24;
            this[offset + 2] = value >>> 16;
            this[offset + 1] = value >>> 8;
            this[offset] = value & 0xff;
          } else {
            objectWriteUInt32(this, value, offset, true);
          }
          return offset + 4;
        };

        Buffer.prototype.writeUInt32BE = function writeUInt32BE(
          value,
          offset,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
          if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value >>> 24;
            this[offset + 1] = value >>> 16;
            this[offset + 2] = value >>> 8;
            this[offset + 3] = value & 0xff;
          } else {
            objectWriteUInt32(this, value, offset, false);
          }
          return offset + 4;
        };

        Buffer.prototype.writeIntLE = function writeIntLE(
          value,
          offset,
          byteLength,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);

            checkInt(this, value, offset, byteLength, limit - 1, -limit);
          }

          var i = 0;
          var mul = 1;
          var sub = 0;
          this[offset] = value & 0xff;
          while (++i < byteLength && (mul *= 0x100)) {
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
              sub = 1;
            }
            this[offset + i] = (((value / mul) >> 0) - sub) & 0xff;
          }

          return offset + byteLength;
        };

        Buffer.prototype.writeIntBE = function writeIntBE(
          value,
          offset,
          byteLength,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);

            checkInt(this, value, offset, byteLength, limit - 1, -limit);
          }

          var i = byteLength - 1;
          var mul = 1;
          var sub = 0;
          this[offset + i] = value & 0xff;
          while (--i >= 0 && (mul *= 0x100)) {
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
              sub = 1;
            }
            this[offset + i] = (((value / mul) >> 0) - sub) & 0xff;
          }

          return offset + byteLength;
        };

        Buffer.prototype.writeInt8 = function writeInt8(
          value,
          offset,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
          if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
          if (value < 0) value = 0xff + value + 1;
          this[offset] = value & 0xff;
          return offset + 1;
        };

        Buffer.prototype.writeInt16LE = function writeInt16LE(
          value,
          offset,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
          if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value & 0xff;
            this[offset + 1] = value >>> 8;
          } else {
            objectWriteUInt16(this, value, offset, true);
          }
          return offset + 2;
        };

        Buffer.prototype.writeInt16BE = function writeInt16BE(
          value,
          offset,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
          if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value >>> 8;
            this[offset + 1] = value & 0xff;
          } else {
            objectWriteUInt16(this, value, offset, false);
          }
          return offset + 2;
        };

        Buffer.prototype.writeInt32LE = function writeInt32LE(
          value,
          offset,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          if (!noAssert)
            checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
          if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value & 0xff;
            this[offset + 1] = value >>> 8;
            this[offset + 2] = value >>> 16;
            this[offset + 3] = value >>> 24;
          } else {
            objectWriteUInt32(this, value, offset, true);
          }
          return offset + 4;
        };

        Buffer.prototype.writeInt32BE = function writeInt32BE(
          value,
          offset,
          noAssert
        ) {
          value = +value;
          offset = offset | 0;
          if (!noAssert)
            checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
          if (value < 0) value = 0xffffffff + value + 1;
          if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value >>> 24;
            this[offset + 1] = value >>> 16;
            this[offset + 2] = value >>> 8;
            this[offset + 3] = value & 0xff;
          } else {
            objectWriteUInt32(this, value, offset, false);
          }
          return offset + 4;
        };

        function checkIEEE754(buf, value, offset, ext, max, min) {
          if (offset + ext > buf.length)
            throw new RangeError("Index out of range");
          if (offset < 0) throw new RangeError("Index out of range");
        }

        function writeFloat(buf, value, offset, littleEndian, noAssert) {
          if (!noAssert) {
            checkIEEE754(
              buf,
              value,
              offset,
              4,
              3.4028234663852886e38,
              -3.4028234663852886e38
            );
          }
          ieee754.write(buf, value, offset, littleEndian, 23, 4);
          return offset + 4;
        }

        Buffer.prototype.writeFloatLE = function writeFloatLE(
          value,
          offset,
          noAssert
        ) {
          return writeFloat(this, value, offset, true, noAssert);
        };

        Buffer.prototype.writeFloatBE = function writeFloatBE(
          value,
          offset,
          noAssert
        ) {
          return writeFloat(this, value, offset, false, noAssert);
        };

        function writeDouble(buf, value, offset, littleEndian, noAssert) {
          if (!noAssert) {
            checkIEEE754(
              buf,
              value,
              offset,
              8,
              1.7976931348623157e308,
              -1.7976931348623157e308
            );
          }
          ieee754.write(buf, value, offset, littleEndian, 52, 8);
          return offset + 8;
        }

        Buffer.prototype.writeDoubleLE = function writeDoubleLE(
          value,
          offset,
          noAssert
        ) {
          return writeDouble(this, value, offset, true, noAssert);
        };

        Buffer.prototype.writeDoubleBE = function writeDoubleBE(
          value,
          offset,
          noAssert
        ) {
          return writeDouble(this, value, offset, false, noAssert);
        };

        // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
        Buffer.prototype.copy = function copy(target, targetStart, start, end) {
          if (!start) start = 0;
          if (!end && end !== 0) end = this.length;
          if (targetStart >= target.length) targetStart = target.length;
          if (!targetStart) targetStart = 0;
          if (end > 0 && end < start) end = start;

          // Copy 0 bytes; we're done
          if (end === start) return 0;
          if (target.length === 0 || this.length === 0) return 0;

          // Fatal error conditions
          if (targetStart < 0) {
            throw new RangeError("targetStart out of bounds");
          }
          if (start < 0 || start >= this.length)
            throw new RangeError("sourceStart out of bounds");
          if (end < 0) throw new RangeError("sourceEnd out of bounds");

          // Are we oob?
          if (end > this.length) end = this.length;
          if (target.length - targetStart < end - start) {
            end = target.length - targetStart + start;
          }

          var len = end - start;
          var i;

          if (this === target && start < targetStart && targetStart < end) {
            // descending copy from end
            for (i = len - 1; i >= 0; --i) {
              target[i + targetStart] = this[i + start];
            }
          } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
            // ascending copy from start
            for (i = 0; i < len; ++i) {
              target[i + targetStart] = this[i + start];
            }
          } else {
            Uint8Array.prototype.set.call(
              target,
              this.subarray(start, start + len),
              targetStart
            );
          }

          return len;
        };

        // Usage:
        //    buffer.fill(number[, offset[, end]])
        //    buffer.fill(buffer[, offset[, end]])
        //    buffer.fill(string[, offset[, end]][, encoding])
        Buffer.prototype.fill = function fill(val, start, end, encoding) {
          // Handle string cases:
          if (typeof val === "string") {
            if (typeof start === "string") {
              encoding = start;
              start = 0;
              end = this.length;
            } else if (typeof end === "string") {
              encoding = end;
              end = this.length;
            }
            if (val.length === 1) {
              var code = val.charCodeAt(0);
              if (code < 256) {
                val = code;
              }
            }
            if (encoding !== undefined && typeof encoding !== "string") {
              throw new TypeError("encoding must be a string");
            }
            if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) {
              throw new TypeError("Unknown encoding: " + encoding);
            }
          } else if (typeof val === "number") {
            val = val & 255;
          }

          // Invalid ranges are not set to a default, so can range check early.
          if (start < 0 || this.length < start || this.length < end) {
            throw new RangeError("Out of range index");
          }

          if (end <= start) {
            return this;
          }

          start = start >>> 0;
          end = end === undefined ? this.length : end >>> 0;

          if (!val) val = 0;

          var i;
          if (typeof val === "number") {
            for (i = start; i < end; ++i) {
              this[i] = val;
            }
          } else {
            var bytes = Buffer.isBuffer(val)
              ? val
              : utf8ToBytes(new Buffer(val, encoding).toString());
            var len = bytes.length;
            for (i = 0; i < end - start; ++i) {
              this[i + start] = bytes[i % len];
            }
          }

          return this;
        };

        // HELPER FUNCTIONS
        // ================

        var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

        function base64clean(str) {
          // Node strips out invalid characters like \n and \t from the string, base64-js does not
          str = stringtrim(str).replace(INVALID_BASE64_RE, "");
          // Node converts strings with length < 2 to ''
          if (str.length < 2) return "";
          // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
          while (str.length % 4 !== 0) {
            str = str + "=";
          }
          return str;
        }

        function stringtrim(str) {
          if (str.trim) return str.trim();
          return str.replace(/^\s+|\s+$/g, "");
        }

        function toHex(n) {
          if (n < 16) return "0" + n.toString(16);
          return n.toString(16);
        }

        function utf8ToBytes(string, units) {
          units = units || Infinity;
          var codePoint;
          var length = string.length;
          var leadSurrogate = null;
          var bytes = [];

          for (var i = 0; i < length; ++i) {
            codePoint = string.charCodeAt(i);

            // is surrogate component
            if (codePoint > 0xd7ff && codePoint < 0xe000) {
              // last char was a lead
              if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xdbff) {
                  // unexpected trail
                  if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                  continue;
                } else if (i + 1 === length) {
                  // unpaired lead
                  if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                  continue;
                }

                // valid lead
                leadSurrogate = codePoint;

                continue;
              }

              // 2 leads in a row
              if (codePoint < 0xdc00) {
                if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                leadSurrogate = codePoint;
                continue;
              }

              // valid surrogate pair
              codePoint =
                (((leadSurrogate - 0xd800) << 10) | (codePoint - 0xdc00)) +
                0x10000;
            } else if (leadSurrogate) {
              // valid bmp char, but last char was a lead
              if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
            }

            leadSurrogate = null;

            // encode utf8
            if (codePoint < 0x80) {
              if ((units -= 1) < 0) break;
              bytes.push(codePoint);
            } else if (codePoint < 0x800) {
              if ((units -= 2) < 0) break;
              bytes.push((codePoint >> 0x6) | 0xc0, (codePoint & 0x3f) | 0x80);
            } else if (codePoint < 0x10000) {
              if ((units -= 3) < 0) break;
              bytes.push(
                (codePoint >> 0xc) | 0xe0,
                ((codePoint >> 0x6) & 0x3f) | 0x80,
                (codePoint & 0x3f) | 0x80
              );
            } else if (codePoint < 0x110000) {
              if ((units -= 4) < 0) break;
              bytes.push(
                (codePoint >> 0x12) | 0xf0,
                ((codePoint >> 0xc) & 0x3f) | 0x80,
                ((codePoint >> 0x6) & 0x3f) | 0x80,
                (codePoint & 0x3f) | 0x80
              );
            } else {
              throw new Error("Invalid code point");
            }
          }

          return bytes;
        }

        function asciiToBytes(str) {
          var byteArray = [];
          for (var i = 0; i < str.length; ++i) {
            // Node's code seems to be doing this and not & 0x7F..
            byteArray.push(str.charCodeAt(i) & 0xff);
          }
          return byteArray;
        }

        function utf16leToBytes(str, units) {
          var c, hi, lo;
          var byteArray = [];
          for (var i = 0; i < str.length; ++i) {
            if ((units -= 2) < 0) break;

            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
          }

          return byteArray;
        }

        function base64ToBytes(str) {
          return base64.toByteArray(base64clean(str));
        }

        function blitBuffer(src, dst, offset, length) {
          for (var i = 0; i < length; ++i) {
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
          }
          return i;
        }

        function isnan(val) {
          return val !== val; // eslint-disable-line no-self-compare
        }

        /***/
      },

    /***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/@splidejs/splide/dist/css/splide.min.css":
      /*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/@splidejs/splide/dist/css/splide.min.css ***!
  \*************************************************************************************************************************************************************************************************************************/
      /***/ (module, __webpack_exports__, __webpack_require__) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../../../../css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js"
          );
        /* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__
          );
        // Imports

        var ___CSS_LOADER_EXPORT___ =
          _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(
            function (i) {
              return i[1];
            }
          );
        // Module
        ___CSS_LOADER_EXPORT___.push([
          module.id,
          ".splide__container{box-sizing:border-box;position:relative}.splide__list{backface-visibility:hidden;display:-ms-flexbox;display:flex;height:100%;margin:0!important;padding:0!important}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide:not(.is-overflow) .splide__pagination{display:none}.splide__progress__bar{width:0}.splide{position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{backface-visibility:hidden;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0;list-style-type:none!important;margin:0;position:relative}.splide__slide img{vertical-align:bottom}.splide__spinner{animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;bottom:0;contain:strict;display:inline-block;height:20px;left:0;margin:auto;position:absolute;right:0;top:0;width:20px}.splide__sr{clip:rect(0 0 0 0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.splide__toggle.is-active .splide__toggle__play,.splide__toggle__pause{display:none}.splide__toggle.is-active .splide__toggle__pause{display:inline}.splide__track{overflow:hidden;position:relative;z-index:0}@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide__track--draggable{-webkit-touch-callout:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.splide__track--fade>.splide__list>.splide__slide{margin:0!important;opacity:0;z-index:0}.splide__track--fade>.splide__list>.splide__slide.is-active{opacity:1;z-index:1}.splide--rtl{direction:rtl}.splide__track--ttb>.splide__list{display:block}.splide__arrow{-ms-flex-align:center;align-items:center;background:#ccc;border:0;border-radius:50%;cursor:pointer;display:-ms-flexbox;display:flex;height:2em;-ms-flex-pack:center;justify-content:center;opacity:.7;padding:0;position:absolute;top:50%;transform:translateY(-50%);width:2em;z-index:1}.splide__arrow svg{fill:#000;height:1.2em;width:1.2em}.splide__arrow:hover:not(:disabled){opacity:.9}.splide__arrow:disabled{opacity:.3}.splide__arrow:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide__arrow--prev{left:1em}.splide__arrow--prev svg{transform:scaleX(-1)}.splide__arrow--next{right:1em}.splide.is-focus-in .splide__arrow:focus{outline:3px solid #0bf;outline-offset:3px}.splide__pagination{bottom:.5em;left:0;padding:0 1em;position:absolute;right:0;z-index:1}.splide__pagination__page{background:#ccc;border:0;border-radius:50%;display:inline-block;height:8px;margin:3px;opacity:.7;padding:0;position:relative;transition:transform .2s linear;width:8px}.splide__pagination__page.is-active{background:#fff;transform:scale(1.4);z-index:1}.splide__pagination__page:hover{cursor:pointer;opacity:.9}.splide__pagination__page:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide.is-focus-in .splide__pagination__page:focus{outline:3px solid #0bf;outline-offset:3px}.splide__progress__bar{background:#ccc;height:3px}.splide__slide{-webkit-tap-highlight-color:rgba(0,0,0,0)}.splide__slide:focus{outline:0}@supports(outline-offset:-3px){.splide__slide:focus-visible{outline:3px solid #0bf;outline-offset:-3px}}@media screen and (-ms-high-contrast:none){.splide__slide:focus-visible{border:3px solid #0bf}}@supports(outline-offset:-3px){.splide.is-focus-in .splide__slide:focus{outline:3px solid #0bf;outline-offset:-3px}}@media screen and (-ms-high-contrast:none){.splide.is-focus-in .splide__slide:focus{border:3px solid #0bf}.splide.is-focus-in .splide__track>.splide__list>.splide__slide:focus{border-color:#0bf}}.splide__toggle{cursor:pointer}.splide__toggle:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide.is-focus-in .splide__toggle:focus{outline:3px solid #0bf;outline-offset:3px}.splide__track--nav>.splide__list>.splide__slide{border:3px solid transparent;cursor:pointer}.splide__track--nav>.splide__list>.splide__slide.is-active{border:3px solid #000}.splide__arrows--rtl .splide__arrow--prev{left:auto;right:1em}.splide__arrows--rtl .splide__arrow--prev svg{transform:scaleX(1)}.splide__arrows--rtl .splide__arrow--next{left:1em;right:auto}.splide__arrows--rtl .splide__arrow--next svg{transform:scaleX(-1)}.splide__arrows--ttb .splide__arrow{left:50%;transform:translate(-50%)}.splide__arrows--ttb .splide__arrow--prev{top:1em}.splide__arrows--ttb .splide__arrow--prev svg{transform:rotate(-90deg)}.splide__arrows--ttb .splide__arrow--next{bottom:1em;top:auto}.splide__arrows--ttb .splide__arrow--next svg{transform:rotate(90deg)}.splide__pagination--ttb{bottom:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;left:auto;padding:1em 0;right:.5em;top:0}",
          "",
        ]);
        // Exports
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          ___CSS_LOADER_EXPORT___;

        /***/
      },

    /***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/swiper/modules/navigation.css":
      /*!**************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/swiper/modules/navigation.css ***!
  \**************************************************************************************************************************************************************************************************************/
      /***/ (module, __webpack_exports__, __webpack_require__) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../../css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js"
          );
        /* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__
          );
        // Imports

        var ___CSS_LOADER_EXPORT___ =
          _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(
            function (i) {
              return i[1];
            }
          );
        // Module
        ___CSS_LOADER_EXPORT___.push([
          module.id,
          ":root {\n  --swiper-navigation-size: 44px;\n  /*\n  --swiper-navigation-top-offset: 50%;\n  --swiper-navigation-sides-offset: 10px;\n  --swiper-navigation-color: var(--swiper-theme-color);\n  */\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: var(--swiper-navigation-top-offset, 50%);\n  width: calc(var(--swiper-navigation-size) / 44 * 27);\n  height: var(--swiper-navigation-size);\n  margin-top: calc(0px - (var(--swiper-navigation-size) / 2));\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--swiper-navigation-color, var(--swiper-theme-color));\n}\n.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-button-prev.swiper-button-hidden,\n.swiper-button-next.swiper-button-hidden {\n  opacity: 0;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-navigation-disabled .swiper-button-prev,\n.swiper-navigation-disabled .swiper-button-next {\n  display: none !important;\n}\n.swiper-button-prev svg,\n.swiper-button-next svg {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n     object-fit: contain;\n  transform-origin: center;\n}\n.swiper-rtl .swiper-button-prev svg,\n.swiper-rtl .swiper-button-next svg {\n  transform: rotate(180deg);\n}\n.swiper-button-prev,\n.swiper-rtl .swiper-button-next {\n  left: var(--swiper-navigation-sides-offset, 10px);\n  right: auto;\n}\n.swiper-button-next,\n.swiper-rtl .swiper-button-prev {\n  right: var(--swiper-navigation-sides-offset, 10px);\n  left: auto;\n}\n.swiper-button-lock {\n  display: none;\n}\n/* Navigation font start */\n.swiper-button-prev:after,\n.swiper-button-next:after {\n  font-family: swiper-icons;\n  font-size: var(--swiper-navigation-size);\n  text-transform: none !important;\n  letter-spacing: 0;\n  font-variant: initial;\n  line-height: 1;\n}\n.swiper-button-prev:after,\n.swiper-rtl .swiper-button-next:after {\n  content: 'prev';\n}\n.swiper-button-next,\n.swiper-rtl .swiper-button-prev {\n  right: var(--swiper-navigation-sides-offset, 10px);\n  left: auto;\n}\n.swiper-button-next:after,\n.swiper-rtl .swiper-button-prev:after {\n  content: 'next';\n}\n/* Navigation font end */\n",
          "",
        ]);
        // Exports
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          ___CSS_LOADER_EXPORT___;

        /***/
      },

    /***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/swiper/modules/scrollbar.css":
      /*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/swiper/modules/scrollbar.css ***!
  \*************************************************************************************************************************************************************************************************************/
      /***/ (module, __webpack_exports__, __webpack_require__) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../../css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js"
          );
        /* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__
          );
        // Imports

        var ___CSS_LOADER_EXPORT___ =
          _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(
            function (i) {
              return i[1];
            }
          );
        // Module
        ___CSS_LOADER_EXPORT___.push([
          module.id,
          ":root {\n  /*\n  --swiper-scrollbar-border-radius: 10px;\n  --swiper-scrollbar-top: auto;\n  --swiper-scrollbar-bottom: 4px;\n  --swiper-scrollbar-left: auto;\n  --swiper-scrollbar-right: 4px;\n  --swiper-scrollbar-sides-offset: 1%;\n  --swiper-scrollbar-bg-color: rgba(0, 0, 0, 0.1);\n  --swiper-scrollbar-drag-bg-color: rgba(0, 0, 0, 0.5);\n  --swiper-scrollbar-size: 4px;\n  */\n}\n.swiper-scrollbar {\n  border-radius: var(--swiper-scrollbar-border-radius, 10px);\n  position: relative;\n  touch-action: none;\n  background: var(--swiper-scrollbar-bg-color, rgba(0, 0, 0, 0.1));\n}\n.swiper-scrollbar-disabled > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-disabled {\n  display: none !important;\n}\n.swiper-horizontal > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-horizontal {\n  position: absolute;\n  left: var(--swiper-scrollbar-sides-offset, 1%);\n  bottom: var(--swiper-scrollbar-bottom, 4px);\n  top: var(--swiper-scrollbar-top, auto);\n  z-index: 50;\n  height: var(--swiper-scrollbar-size, 4px);\n  width: calc(100% - 2 * var(--swiper-scrollbar-sides-offset, 1%));\n}\n.swiper-vertical > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-vertical {\n  position: absolute;\n  left: var(--swiper-scrollbar-left, auto);\n  right: var(--swiper-scrollbar-right, 4px);\n  top: var(--swiper-scrollbar-sides-offset, 1%);\n  z-index: 50;\n  width: var(--swiper-scrollbar-size, 4px);\n  height: calc(100% - 2 * var(--swiper-scrollbar-sides-offset, 1%));\n}\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: var(--swiper-scrollbar-drag-bg-color, rgba(0, 0, 0, 0.5));\n  border-radius: var(--swiper-scrollbar-border-radius, 10px);\n  left: 0;\n  top: 0;\n}\n.swiper-scrollbar-cursor-drag {\n  cursor: move;\n}\n.swiper-scrollbar-lock {\n  display: none;\n}\n",
          "",
        ]);
        // Exports
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          ___CSS_LOADER_EXPORT___;

        /***/
      },

    /***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/swiper/modules/thumbs.css":
      /*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/swiper/modules/thumbs.css ***!
  \**********************************************************************************************************************************************************************************************************/
      /***/ (module, __webpack_exports__, __webpack_require__) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../../css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js"
          );
        /* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__
          );
        // Imports

        var ___CSS_LOADER_EXPORT___ =
          _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(
            function (i) {
              return i[1];
            }
          );
        // Module
        ___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
        // Exports
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          ___CSS_LOADER_EXPORT___;

        /***/
      },

    /***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/swiper/swiper.css":
      /*!**************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/swiper/swiper.css ***!
  \**************************************************************************************************************************************************************************************************/
      /***/ (module, __webpack_exports__, __webpack_require__) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js"
          );
        /* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__
          );
        // Imports

        var ___CSS_LOADER_EXPORT___ =
          _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(
            function (i) {
              return i[1];
            }
          );
        // Module
        ___CSS_LOADER_EXPORT___.push([
          module.id,
          "/**\n * Swiper 10.3.1\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2023 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: September 28, 2023\n */\n\n/* FONT_START */\n@font-face {\n  font-family: 'swiper-icons';\n  src: url('data:application/font-woff;charset=utf-8;base64, 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');\n  font-weight: 400;\n  font-style: normal;\n}\n/* FONT_END */\n:root {\n  --swiper-theme-color: #007aff;\n  /*\n  --swiper-preloader-color: var(--swiper-theme-color);\n  --swiper-wrapper-transition-timing-function: initial;\n  */\n}\n:host {\n  position: relative;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  z-index: 1;\n}\n.swiper {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  overflow: clip;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n  display: block;\n}\n.swiper-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);\n  box-sizing: content-box;\n}\n.swiper-android .swiper-slide,\n.swiper-ios .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-horizontal {\n  touch-action: pan-y;\n}\n.swiper-vertical {\n  touch-action: pan-x;\n}\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n  display: block;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-autoheight,\n.swiper-autoheight .swiper-slide {\n  height: auto;\n}\n.swiper-autoheight .swiper-wrapper {\n  align-items: flex-start;\n  transition-property: transform, height;\n}\n.swiper-backface-hidden .swiper-slide {\n  transform: translateZ(0);\n  backface-visibility: hidden;\n}\n/* 3D Effects */\n.swiper-3d.swiper-css-mode .swiper-wrapper {\n  perspective: 1200px;\n}\n.swiper-3d .swiper-wrapper {\n  transform-style: preserve-3d;\n}\n.swiper-3d {\n  perspective: 1200px;\n}\n.swiper-3d .swiper-slide,\n.swiper-3d .swiper-cube-shadow {\n  transform-style: preserve-3d;\n}\n/* CSS Mode */\n.swiper-css-mode > .swiper-wrapper {\n  overflow: auto;\n  scrollbar-width: none;\n  /* For Firefox */\n  -ms-overflow-style: none;\n  /* For Internet Explorer and Edge */\n}\n.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {\n  display: none;\n}\n.swiper-css-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: start start;\n}\n.swiper-css-mode.swiper-horizontal > .swiper-wrapper {\n  scroll-snap-type: x mandatory;\n}\n.swiper-css-mode.swiper-vertical > .swiper-wrapper {\n  scroll-snap-type: y mandatory;\n}\n.swiper-css-mode.swiper-free-mode > .swiper-wrapper {\n  scroll-snap-type: none;\n}\n.swiper-css-mode.swiper-free-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: none;\n}\n.swiper-css-mode.swiper-centered > .swiper-wrapper::before {\n  content: '';\n  flex-shrink: 0;\n  order: 9999;\n}\n.swiper-css-mode.swiper-centered > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: center center;\n  scroll-snap-stop: always;\n}\n.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {\n  margin-inline-start: var(--swiper-centered-offset-before);\n}\n.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper::before {\n  height: 100%;\n  min-height: 1px;\n  width: var(--swiper-centered-offset-after);\n}\n.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {\n  margin-block-start: var(--swiper-centered-offset-before);\n}\n.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper::before {\n  width: 100%;\n  min-width: 1px;\n  height: var(--swiper-centered-offset-after);\n}\n/* Slide styles start */\n/* 3D Shadows */\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-slide-shadow-bottom,\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n.swiper-3d .swiper-slide-shadow {\n  background: rgba(0, 0, 0, 0.15);\n}\n.swiper-3d .swiper-slide-shadow-left {\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-right {\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-top {\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-bottom {\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-lazy-preloader {\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -21px;\n  margin-top: -21px;\n  z-index: 10;\n  transform-origin: 50%;\n  box-sizing: border-box;\n  border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));\n  border-radius: 50%;\n  border-top-color: transparent;\n}\n.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,\n.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader {\n  animation: swiper-preloader-spin 1s infinite linear;\n}\n.swiper-lazy-preloader-white {\n  --swiper-preloader-color: #fff;\n}\n.swiper-lazy-preloader-black {\n  --swiper-preloader-color: #000;\n}\n@keyframes swiper-preloader-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/* Slide styles end */\n",
          "",
        ]);
        // Exports
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          ___CSS_LOADER_EXPORT___;

        /***/
      },

    /***/ "./node_modules/css-loader/dist/runtime/api.js":
      /*!*****************************************************!*\
  !*** ./node_modules/css-loader/dist/runtime/api.js ***!
  \*****************************************************/
      /***/ (module) => {
        "use strict";

        /*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
        // css base code, injected by the css-loader
        // eslint-disable-next-line func-names
        module.exports = function (cssWithMappingToString) {
          var list = []; // return the list of modules as css string

          list.toString = function toString() {
            return this.map(function (item) {
              var content = cssWithMappingToString(item);

              if (item[2]) {
                return "@media ".concat(item[2], " {").concat(content, "}");
              }

              return content;
            }).join("");
          }; // import a list of modules into the list
          // eslint-disable-next-line func-names

          list.i = function (modules, mediaQuery, dedupe) {
            if (typeof modules === "string") {
              // eslint-disable-next-line no-param-reassign
              modules = [[null, modules, ""]];
            }

            var alreadyImportedModules = {};

            if (dedupe) {
              for (var i = 0; i < this.length; i++) {
                // eslint-disable-next-line prefer-destructuring
                var id = this[i][0];

                if (id != null) {
                  alreadyImportedModules[id] = true;
                }
              }
            }

            for (var _i = 0; _i < modules.length; _i++) {
              var item = [].concat(modules[_i]);

              if (dedupe && alreadyImportedModules[item[0]]) {
                // eslint-disable-next-line no-continue
                continue;
              }

              if (mediaQuery) {
                if (!item[2]) {
                  item[2] = mediaQuery;
                } else {
                  item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
                }
              }

              list.push(item);
            }
          };

          return list;
        };

        /***/
      },

    /***/ "./node_modules/ieee754/index.js":
      /*!***************************************!*\
  !*** ./node_modules/ieee754/index.js ***!
  \***************************************/
      /***/ (__unused_webpack_module, exports) => {
        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
        exports.read = function (buffer, offset, isLE, mLen, nBytes) {
          var e, m;
          var eLen = nBytes * 8 - mLen - 1;
          var eMax = (1 << eLen) - 1;
          var eBias = eMax >> 1;
          var nBits = -7;
          var i = isLE ? nBytes - 1 : 0;
          var d = isLE ? -1 : 1;
          var s = buffer[offset + i];

          i += d;

          e = s & ((1 << -nBits) - 1);
          s >>= -nBits;
          nBits += eLen;
          for (
            ;
            nBits > 0;
            e = e * 256 + buffer[offset + i], i += d, nBits -= 8
          ) {}

          m = e & ((1 << -nBits) - 1);
          e >>= -nBits;
          nBits += mLen;
          for (
            ;
            nBits > 0;
            m = m * 256 + buffer[offset + i], i += d, nBits -= 8
          ) {}

          if (e === 0) {
            e = 1 - eBias;
          } else if (e === eMax) {
            return m ? NaN : (s ? -1 : 1) * Infinity;
          } else {
            m = m + Math.pow(2, mLen);
            e = e - eBias;
          }
          return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
        };

        exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
          var e, m, c;
          var eLen = nBytes * 8 - mLen - 1;
          var eMax = (1 << eLen) - 1;
          var eBias = eMax >> 1;
          var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
          var i = isLE ? 0 : nBytes - 1;
          var d = isLE ? 1 : -1;
          var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

          value = Math.abs(value);

          if (isNaN(value) || value === Infinity) {
            m = isNaN(value) ? 1 : 0;
            e = eMax;
          } else {
            e = Math.floor(Math.log(value) / Math.LN2);
            if (value * (c = Math.pow(2, -e)) < 1) {
              e--;
              c *= 2;
            }
            if (e + eBias >= 1) {
              value += rt / c;
            } else {
              value += rt * Math.pow(2, 1 - eBias);
            }
            if (value * c >= 2) {
              e++;
              c /= 2;
            }

            if (e + eBias >= eMax) {
              m = 0;
              e = eMax;
            } else if (e + eBias >= 1) {
              m = (value * c - 1) * Math.pow(2, mLen);
              e = e + eBias;
            } else {
              m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
              e = 0;
            }
          }

          for (
            ;
            mLen >= 8;
            buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8
          ) {}

          e = (e << mLen) | m;
          eLen += mLen;
          for (
            ;
            eLen > 0;
            buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8
          ) {}

          buffer[offset + i - d] |= s * 128;
        };

        /***/
      },

    /***/ "./node_modules/isarray/index.js":
      /*!***************************************!*\
  !*** ./node_modules/isarray/index.js ***!
  \***************************************/
      /***/ (module) => {
        var toString = {}.toString;

        module.exports =
          Array.isArray ||
          function (arr) {
            return toString.call(arr) == "[object Array]";
          };

        /***/
      },

    /***/ "./node_modules/load-script/index.js":
      /*!*******************************************!*\
  !*** ./node_modules/load-script/index.js ***!
  \*******************************************/
      /***/ (module) => {
        module.exports = function load(src, opts, cb) {
          var head = document.head || document.getElementsByTagName("head")[0];
          var script = document.createElement("script");

          if (typeof opts === "function") {
            cb = opts;
            opts = {};
          }

          opts = opts || {};
          cb = cb || function () {};

          script.type = opts.type || "text/javascript";
          script.charset = opts.charset || "utf8";
          script.async = "async" in opts ? !!opts.async : true;
          script.src = src;

          if (opts.attrs) {
            setAttributes(script, opts.attrs);
          }

          if (opts.text) {
            script.text = "" + opts.text;
          }

          var onend = "onload" in script ? stdOnEnd : ieOnEnd;
          onend(script, cb);

          // some good legacy browsers (firefox) fail the 'in' detection above
          // so as a fallback we always set onload
          // old IE will ignore this and new IE will set onload
          if (!script.onload) {
            stdOnEnd(script, cb);
          }

          head.appendChild(script);
        };

        function setAttributes(script, attrs) {
          for (var attr in attrs) {
            script.setAttribute(attr, attrs[attr]);
          }
        }

        function stdOnEnd(script, cb) {
          script.onload = function () {
            this.onerror = this.onload = null;
            cb(null, script);
          };
          script.onerror = function () {
            // this.onload = null here is necessary
            // because even IE9 works not like others
            this.onerror = this.onload = null;
            cb(new Error("Failed to load " + this.src), script);
          };
        }

        function ieOnEnd(script, cb) {
          script.onreadystatechange = function () {
            if (this.readyState != "complete" && this.readyState != "loaded")
              return;
            this.onreadystatechange = null;
            cb(null, script); // there is no way to catch loading errors in IE8
          };
        }

        /***/
      },

    /***/ "./src/styles/main.scss":
      /*!******************************!*\
  !*** ./src/styles/main.scss ***!
  \******************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        // extracted by mini-css-extract-plugin

        /***/
      },

    /***/ "./src/styles/gift-card.scss":
      /*!***********************************!*\
  !*** ./src/styles/gift-card.scss ***!
  \***********************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        // extracted by mini-css-extract-plugin

        /***/
      },

    /***/ "./node_modules/process/browser.js":
      /*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
      /***/ (module) => {
        // shim for using process in browser
        var process = (module.exports = {});

        // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.

        var cachedSetTimeout;
        var cachedClearTimeout;

        function defaultSetTimout() {
          throw new Error("setTimeout has not been defined");
        }
        function defaultClearTimeout() {
          throw new Error("clearTimeout has not been defined");
        }
        (function () {
          try {
            if (typeof setTimeout === "function") {
              cachedSetTimeout = setTimeout;
            } else {
              cachedSetTimeout = defaultSetTimout;
            }
          } catch (e) {
            cachedSetTimeout = defaultSetTimout;
          }
          try {
            if (typeof clearTimeout === "function") {
              cachedClearTimeout = clearTimeout;
            } else {
              cachedClearTimeout = defaultClearTimeout;
            }
          } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
          }
        })();
        function runTimeout(fun) {
          if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
          }
          // if setTimeout wasn't available but was latter defined
          if (
            (cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) &&
            setTimeout
          ) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
            }
          }
        }
        function runClearTimeout(marker) {
          if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
          }
          // if clearTimeout wasn't available but was latter defined
          if (
            (cachedClearTimeout === defaultClearTimeout ||
              !cachedClearTimeout) &&
            clearTimeout
          ) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
            }
          }
        }
        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;

        function cleanUpNextTick() {
          if (!draining || !currentQueue) {
            return;
          }
          draining = false;
          if (currentQueue.length) {
            queue = currentQueue.concat(queue);
          } else {
            queueIndex = -1;
          }
          if (queue.length) {
            drainQueue();
          }
        }

        function drainQueue() {
          if (draining) {
            return;
          }
          var timeout = runTimeout(cleanUpNextTick);
          draining = true;

          var len = queue.length;
          while (len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
              if (currentQueue) {
                currentQueue[queueIndex].run();
              }
            }
            queueIndex = -1;
            len = queue.length;
          }
          currentQueue = null;
          draining = false;
          runClearTimeout(timeout);
        }

        process.nextTick = function (fun) {
          var args = new Array(arguments.length - 1);
          if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
            }
          }
          queue.push(new Item(fun, args));
          if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
          }
        };

        // v8 likes predictible objects
        function Item(fun, array) {
          this.fun = fun;
          this.array = array;
        }
        Item.prototype.run = function () {
          this.fun.apply(null, this.array);
        };
        process.title = "browser";
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ""; // empty string to avoid regexp issues
        process.versions = {};

        function noop() {}

        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;

        process.listeners = function (name) {
          return [];
        };

        process.binding = function (name) {
          throw new Error("process.binding is not supported");
        };

        process.cwd = function () {
          return "/";
        };
        process.chdir = function (dir) {
          throw new Error("process.chdir is not supported");
        };
        process.umask = function () {
          return 0;
        };

        /***/
      },

    /***/ "./node_modules/sister/src/sister.js":
      /*!*******************************************!*\
  !*** ./node_modules/sister/src/sister.js ***!
  \*******************************************/
      /***/ (module) => {
        "use strict";

        var Sister;

        /**
         * @link https://github.com/gajus/sister for the canonical source repository
         * @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
         */
        Sister = function () {
          var sister = {},
            events = {};

          /**
           * @name handler
           * @function
           * @param {Object} data Event data.
           */

          /**
           * @param {String} name Event name.
           * @param {handler} handler
           * @return {listener}
           */
          sister.on = function (name, handler) {
            var listener = { name: name, handler: handler };
            events[name] = events[name] || [];
            events[name].unshift(listener);
            return listener;
          };

          /**
           * @param {listener}
           */
          sister.off = function (listener) {
            var index = events[listener.name].indexOf(listener);

            if (index !== -1) {
              events[listener.name].splice(index, 1);
            }
          };

          /**
           * @param {String} name Event name.
           * @param {Object} data Event data.
           */
          sister.trigger = function (name, data) {
            var listeners = events[name],
              i;

            if (listeners) {
              i = listeners.length;
              while (i--) {
                listeners[i].handler(data);
              }
            }
          };

          return sister;
        };

        module.exports = Sister;

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/decorators/boolean.js":
      /*!*************************************************************!*\
  !*** ./node_modules/smooth-scrollbar/decorators/boolean.js ***!
  \*************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ boolean: () => /* binding */ boolean,
          /* harmony export */
        });
        function boolean(proto, key) {
          var alias = "_" + key;
          Object.defineProperty(proto, key, {
            get: function () {
              return this[alias];
            },
            set: function (val) {
              Object.defineProperty(this, alias, {
                value: !!val,
                enumerable: false,
                writable: true,
                configurable: true,
              });
            },
            enumerable: true,
            configurable: true,
          });
        }
        //# sourceMappingURL=boolean.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/decorators/debounce.js":
      /*!**************************************************************!*\
  !*** ./node_modules/smooth-scrollbar/decorators/debounce.js ***!
  \**************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ debounce: () => /* binding */ debounce,
          /* harmony export */
        });
        /* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! tslib */ "./node_modules/smooth-scrollbar/node_modules/tslib/tslib.es6.js"
          );
        /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        function debounce() {
          var options = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            options[_i] = arguments[_i];
          }
          return function (_proto, key, descriptor) {
            var fn = descriptor.value;
            return {
              get: function () {
                if (!this.hasOwnProperty(key)) {
                  Object.defineProperty(this, key, {
                    value: _utils__WEBPACK_IMPORTED_MODULE_0__.debounce.apply(
                      void 0,
                      (0, tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArrays)(
                        [fn],
                        options
                      )
                    ),
                  });
                }
                return this[key];
              },
            };
          };
        }
        //# sourceMappingURL=debounce.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/decorators/index.js":
      /*!***********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/decorators/index.js ***!
  \***********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ boolean: () =>
            /* reexport safe */ _boolean__WEBPACK_IMPORTED_MODULE_1__.boolean,
          /* harmony export */ debounce: () =>
            /* reexport safe */ _debounce__WEBPACK_IMPORTED_MODULE_2__.debounce,
          /* harmony export */ range: () =>
            /* reexport safe */ _range__WEBPACK_IMPORTED_MODULE_0__.range,
          /* harmony export */
        });
        /* harmony import */ var _range__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./range */ "./node_modules/smooth-scrollbar/decorators/range.js"
          );
        /* harmony import */ var _boolean__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./boolean */ "./node_modules/smooth-scrollbar/decorators/boolean.js"
          );
        /* harmony import */ var _debounce__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./debounce */ "./node_modules/smooth-scrollbar/decorators/debounce.js"
          );

        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/decorators/range.js":
      /*!***********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/decorators/range.js ***!
  \***********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ range: () => /* binding */ range,
          /* harmony export */
        });
        /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        function range(min, max) {
          if (min === void 0) {
            min = -Infinity;
          }
          if (max === void 0) {
            max = Infinity;
          }
          return function (proto, key) {
            var alias = "_" + key;
            Object.defineProperty(proto, key, {
              get: function () {
                return this[alias];
              },
              set: function (val) {
                Object.defineProperty(this, alias, {
                  value: (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clamp)(
                    val,
                    min,
                    max
                  ),
                  enumerable: false,
                  writable: true,
                  configurable: true,
                });
              },
              enumerable: true,
              configurable: true,
            });
          };
        }
        //# sourceMappingURL=range.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/events/index.js":
      /*!*******************************************************!*\
  !*** ./node_modules/smooth-scrollbar/events/index.js ***!
  \*******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ keyboardHandler: () =>
            /* reexport safe */ _keyboard__WEBPACK_IMPORTED_MODULE_0__.keyboardHandler,
          /* harmony export */ mouseHandler: () =>
            /* reexport safe */ _mouse__WEBPACK_IMPORTED_MODULE_1__.mouseHandler,
          /* harmony export */ resizeHandler: () =>
            /* reexport safe */ _resize__WEBPACK_IMPORTED_MODULE_2__.resizeHandler,
          /* harmony export */ selectHandler: () =>
            /* reexport safe */ _select__WEBPACK_IMPORTED_MODULE_3__.selectHandler,
          /* harmony export */ touchHandler: () =>
            /* reexport safe */ _touch__WEBPACK_IMPORTED_MODULE_4__.touchHandler,
          /* harmony export */ wheelHandler: () =>
            /* reexport safe */ _wheel__WEBPACK_IMPORTED_MODULE_5__.wheelHandler,
          /* harmony export */
        });
        /* harmony import */ var _keyboard__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./keyboard */ "./node_modules/smooth-scrollbar/events/keyboard.js"
          );
        /* harmony import */ var _mouse__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./mouse */ "./node_modules/smooth-scrollbar/events/mouse.js"
          );
        /* harmony import */ var _resize__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./resize */ "./node_modules/smooth-scrollbar/events/resize.js"
          );
        /* harmony import */ var _select__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./select */ "./node_modules/smooth-scrollbar/events/select.js"
          );
        /* harmony import */ var _touch__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./touch */ "./node_modules/smooth-scrollbar/events/touch.js"
          );
        /* harmony import */ var _wheel__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./wheel */ "./node_modules/smooth-scrollbar/events/wheel.js"
          );

        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/events/keyboard.js":
      /*!**********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/events/keyboard.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ keyboardHandler: () =>
            /* binding */ keyboardHandler,
          /* harmony export */
        });
        /* harmony import */ var _utils___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/ */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        var KEY_CODE;
        (function (KEY_CODE) {
          KEY_CODE[(KEY_CODE["TAB"] = 9)] = "TAB";
          KEY_CODE[(KEY_CODE["SPACE"] = 32)] = "SPACE";
          KEY_CODE[(KEY_CODE["PAGE_UP"] = 33)] = "PAGE_UP";
          KEY_CODE[(KEY_CODE["PAGE_DOWN"] = 34)] = "PAGE_DOWN";
          KEY_CODE[(KEY_CODE["END"] = 35)] = "END";
          KEY_CODE[(KEY_CODE["HOME"] = 36)] = "HOME";
          KEY_CODE[(KEY_CODE["LEFT"] = 37)] = "LEFT";
          KEY_CODE[(KEY_CODE["UP"] = 38)] = "UP";
          KEY_CODE[(KEY_CODE["RIGHT"] = 39)] = "RIGHT";
          KEY_CODE[(KEY_CODE["DOWN"] = 40)] = "DOWN";
        })(KEY_CODE || (KEY_CODE = {}));
        function keyboardHandler(scrollbar) {
          var addEvent = (0, _utils___WEBPACK_IMPORTED_MODULE_0__.eventScope)(
            scrollbar
          );
          var container = scrollbar.containerEl;
          addEvent(container, "keydown", function (evt) {
            var activeElement = document.activeElement;
            if (
              activeElement !== container &&
              !container.contains(activeElement)
            ) {
              return;
            }
            if (isEditable(activeElement)) {
              return;
            }
            var delta = getKeyDelta(scrollbar, evt.keyCode || evt.which);
            if (!delta) {
              return;
            }
            var x = delta[0],
              y = delta[1];
            scrollbar.addTransformableMomentum(
              x,
              y,
              evt,
              function (willScroll) {
                if (willScroll) {
                  evt.preventDefault();
                } else {
                  scrollbar.containerEl.blur();
                  if (scrollbar.parent) {
                    scrollbar.parent.containerEl.focus();
                  }
                }
              }
            );
          });
        }
        function getKeyDelta(scrollbar, keyCode) {
          var size = scrollbar.size,
            limit = scrollbar.limit,
            offset = scrollbar.offset;
          switch (keyCode) {
            case KEY_CODE.TAB:
              return handleTabKey(scrollbar);
            case KEY_CODE.SPACE:
              return [0, 200];
            case KEY_CODE.PAGE_UP:
              return [0, -size.container.height + 40];
            case KEY_CODE.PAGE_DOWN:
              return [0, size.container.height - 40];
            case KEY_CODE.END:
              return [0, limit.y - offset.y];
            case KEY_CODE.HOME:
              return [0, -offset.y];
            case KEY_CODE.LEFT:
              return [-40, 0];
            case KEY_CODE.UP:
              return [0, -40];
            case KEY_CODE.RIGHT:
              return [40, 0];
            case KEY_CODE.DOWN:
              return [0, 40];
            default:
              return null;
          }
        }
        function handleTabKey(scrollbar) {
          // handle in next frame
          requestAnimationFrame(function () {
            scrollbar.scrollIntoView(document.activeElement, {
              offsetTop: scrollbar.size.container.height / 2,
              offsetLeft: scrollbar.size.container.width / 2,
              onlyScrollIfNeeded: true,
            });
          });
        }
        function isEditable(elem) {
          if (
            elem.tagName === "INPUT" ||
            elem.tagName === "SELECT" ||
            elem.tagName === "TEXTAREA" ||
            elem.isContentEditable
          ) {
            return !elem.disabled;
          }
          return false;
        }
        //# sourceMappingURL=keyboard.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/events/mouse.js":
      /*!*******************************************************!*\
  !*** ./node_modules/smooth-scrollbar/events/mouse.js ***!
  \*******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ mouseHandler: () => /* binding */ mouseHandler,
          /* harmony export */
        });
        /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/ */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        var Direction;
        (function (Direction) {
          Direction[(Direction["X"] = 0)] = "X";
          Direction[(Direction["Y"] = 1)] = "Y";
        })(Direction || (Direction = {}));
        function mouseHandler(scrollbar) {
          var addEvent = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.eventScope)(
            scrollbar
          );
          var container = scrollbar.containerEl;
          var _a = scrollbar.track,
            xAxis = _a.xAxis,
            yAxis = _a.yAxis;
          function calcMomentum(direction, clickPosition) {
            var size = scrollbar.size,
              limit = scrollbar.limit,
              offset = scrollbar.offset;
            if (direction === Direction.X) {
              var totalWidth =
                size.container.width +
                (xAxis.thumb.realSize - xAxis.thumb.displaySize);
              return (
                (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clamp)(
                  (clickPosition / totalWidth) * size.content.width,
                  0,
                  limit.x
                ) - offset.x
              );
            }
            if (direction === Direction.Y) {
              var totalHeight =
                size.container.height +
                (yAxis.thumb.realSize - yAxis.thumb.displaySize);
              return (
                (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clamp)(
                  (clickPosition / totalHeight) * size.content.height,
                  0,
                  limit.y
                ) - offset.y
              );
            }
            return 0;
          }
          function getTrackDirection(elem) {
            if (
              (0, _utils__WEBPACK_IMPORTED_MODULE_0__.isOneOf)(elem, [
                xAxis.element,
                xAxis.thumb.element,
              ])
            ) {
              return Direction.X;
            }
            if (
              (0, _utils__WEBPACK_IMPORTED_MODULE_0__.isOneOf)(elem, [
                yAxis.element,
                yAxis.thumb.element,
              ])
            ) {
              return Direction.Y;
            }
            return void 0;
          }
          var isMouseDown;
          var isMouseMoving;
          var startOffsetToThumb;
          var trackDirection;
          var containerRect;
          addEvent(container, "click", function (evt) {
            if (
              isMouseMoving ||
              !(0, _utils__WEBPACK_IMPORTED_MODULE_0__.isOneOf)(evt.target, [
                xAxis.element,
                yAxis.element,
              ])
            ) {
              return;
            }
            var track = evt.target;
            var direction = getTrackDirection(track);
            var rect = track.getBoundingClientRect();
            var clickPos = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.getPosition)(
              evt
            );
            if (direction === Direction.X) {
              var offsetOnTrack =
                clickPos.x - rect.left - xAxis.thumb.displaySize / 2;
              scrollbar.setMomentum(calcMomentum(direction, offsetOnTrack), 0);
            }
            if (direction === Direction.Y) {
              var offsetOnTrack =
                clickPos.y - rect.top - yAxis.thumb.displaySize / 2;
              scrollbar.setMomentum(0, calcMomentum(direction, offsetOnTrack));
            }
          });
          addEvent(container, "mousedown", function (evt) {
            if (
              !(0, _utils__WEBPACK_IMPORTED_MODULE_0__.isOneOf)(evt.target, [
                xAxis.thumb.element,
                yAxis.thumb.element,
              ])
            ) {
              return;
            }
            isMouseDown = true;
            var thumb = evt.target;
            var cursorPos = (0,
            _utils__WEBPACK_IMPORTED_MODULE_0__.getPosition)(evt);
            var thumbRect = thumb.getBoundingClientRect();
            trackDirection = getTrackDirection(thumb);
            // pointer offset to thumb
            startOffsetToThumb = {
              x: cursorPos.x - thumbRect.left,
              y: cursorPos.y - thumbRect.top,
            };
            // container bounding rectangle
            containerRect = container.getBoundingClientRect();
            // prevent selection, see:
            // https://github.com/idiotWu/smooth-scrollbar/issues/48
            (0,
            _utils__WEBPACK_IMPORTED_MODULE_0__.setStyle)(scrollbar.containerEl, {
              "-user-select": "none",
            });
          });
          addEvent(window, "mousemove", function (evt) {
            if (!isMouseDown) return;
            isMouseMoving = true;
            var cursorPos = (0,
            _utils__WEBPACK_IMPORTED_MODULE_0__.getPosition)(evt);
            if (trackDirection === Direction.X) {
              // get percentage of pointer position in track
              // then tranform to px
              // don't need easing
              var offsetOnTrack =
                cursorPos.x - startOffsetToThumb.x - containerRect.left;
              scrollbar.setMomentum(
                calcMomentum(trackDirection, offsetOnTrack),
                0
              );
            }
            if (trackDirection === Direction.Y) {
              var offsetOnTrack =
                cursorPos.y - startOffsetToThumb.y - containerRect.top;
              scrollbar.setMomentum(
                0,
                calcMomentum(trackDirection, offsetOnTrack)
              );
            }
          });
          addEvent(window, "mouseup blur", function () {
            isMouseDown = isMouseMoving = false;
            (0,
            _utils__WEBPACK_IMPORTED_MODULE_0__.setStyle)(scrollbar.containerEl, {
              "-user-select": "",
            });
          });
        }
        //# sourceMappingURL=mouse.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/events/resize.js":
      /*!********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/events/resize.js ***!
  \********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ resizeHandler: () => /* binding */ resizeHandler,
          /* harmony export */
        });
        /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/ */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        function resizeHandler(scrollbar) {
          var addEvent = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.eventScope)(
            scrollbar
          );
          addEvent(
            window,
            "resize",
            (0, _utils__WEBPACK_IMPORTED_MODULE_0__.debounce)(
              scrollbar.update.bind(scrollbar),
              300
            )
          );
        }
        //# sourceMappingURL=resize.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/events/select.js":
      /*!********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/events/select.js ***!
  \********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ selectHandler: () => /* binding */ selectHandler,
          /* harmony export */
        });
        /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/ */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        function selectHandler(scrollbar) {
          var addEvent = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.eventScope)(
            scrollbar
          );
          var containerEl = scrollbar.containerEl,
            contentEl = scrollbar.contentEl;
          var isSelected = false;
          var isContextMenuOpened = false; // flag to prevent selection when context menu is opened
          var animationID;
          function scroll(_a) {
            var x = _a.x,
              y = _a.y;
            if (!x && !y) return;
            var offset = scrollbar.offset,
              limit = scrollbar.limit;
            // DISALLOW delta transformation
            scrollbar.setMomentum(
              (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clamp)(
                offset.x + x,
                0,
                limit.x
              ) - offset.x,
              (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clamp)(
                offset.y + y,
                0,
                limit.y
              ) - offset.y
            );
            animationID = requestAnimationFrame(function () {
              scroll({ x: x, y: y });
            });
          }
          addEvent(window, "mousemove", function (evt) {
            if (!isSelected) return;
            cancelAnimationFrame(animationID);
            var dir = calcMomentum(scrollbar, evt);
            scroll(dir);
          });
          // prevent scrolling when context menu is opened
          // NOTE: `contextmenu` event may be fired
          //          1. BEFORE `selectstart`: when user right-clicks on the text content -> prevent future scrolling,
          //          2. AFTER `selectstart`: when user right-clicks on the blank area -> cancel current scrolling,
          //        so we need to both set the flag and cancel current scrolling
          addEvent(contentEl, "contextmenu", function () {
            // set the flag to prevent future scrolling
            isContextMenuOpened = true;
            // stop current scrolling
            cancelAnimationFrame(animationID);
            isSelected = false;
          });
          // reset context menu flag on mouse down
          // to ensure the scrolling is allowed in the next selection
          addEvent(contentEl, "mousedown", function () {
            isContextMenuOpened = false;
          });
          addEvent(contentEl, "selectstart", function () {
            if (isContextMenuOpened) {
              return;
            }
            cancelAnimationFrame(animationID);
            isSelected = true;
          });
          addEvent(window, "mouseup blur", function () {
            cancelAnimationFrame(animationID);
            isSelected = false;
            isContextMenuOpened = false;
          });
          // patch for touch devices
          addEvent(containerEl, "scroll", function (evt) {
            evt.preventDefault();
            containerEl.scrollTop = containerEl.scrollLeft = 0;
          });
        }
        function calcMomentum(scrollbar, evt) {
          var _a = scrollbar.bounding,
            top = _a.top,
            right = _a.right,
            bottom = _a.bottom,
            left = _a.left;
          var _b = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.getPosition)(evt),
            x = _b.x,
            y = _b.y;
          var res = {
            x: 0,
            y: 0,
          };
          var padding = 20;
          if (x === 0 && y === 0) return res;
          if (x > right - padding) {
            res.x = x - right + padding;
          } else if (x < left + padding) {
            res.x = x - left - padding;
          }
          if (y > bottom - padding) {
            res.y = y - bottom + padding;
          } else if (y < top + padding) {
            res.y = y - top - padding;
          }
          res.x *= 2;
          res.y *= 2;
          return res;
        }
        //# sourceMappingURL=select.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/events/touch.js":
      /*!*******************************************************!*\
  !*** ./node_modules/smooth-scrollbar/events/touch.js ***!
  \*******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ touchHandler: () => /* binding */ touchHandler,
          /* harmony export */
        });
        /* harmony import */ var _utils___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/ */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        var activeScrollbar;
        function touchHandler(scrollbar) {
          var target = scrollbar.options.delegateTo || scrollbar.containerEl;
          var touchRecord =
            new _utils___WEBPACK_IMPORTED_MODULE_0__.TouchRecord();
          var addEvent = (0, _utils___WEBPACK_IMPORTED_MODULE_0__.eventScope)(
            scrollbar
          );
          var damping;
          var pointerCount = 0;
          addEvent(target, "touchstart", function (evt) {
            // start records
            touchRecord.track(evt);
            // stop scrolling
            scrollbar.setMomentum(0, 0);
            // save damping
            if (pointerCount === 0) {
              damping = scrollbar.options.damping;
              scrollbar.options.damping = Math.max(damping, 0.5); // less frames on touchmove
            }
            pointerCount++;
          });
          addEvent(target, "touchmove", function (evt) {
            if (activeScrollbar && activeScrollbar !== scrollbar) return;
            touchRecord.update(evt);
            var _a = touchRecord.getDelta(),
              x = _a.x,
              y = _a.y;
            scrollbar.addTransformableMomentum(
              x,
              y,
              evt,
              function (willScroll) {
                if (willScroll && evt.cancelable) {
                  evt.preventDefault();
                  activeScrollbar = scrollbar;
                }
              }
            );
          });
          addEvent(target, "touchcancel touchend", function (evt) {
            var delta = touchRecord.getEasingDistance(damping);
            scrollbar.addTransformableMomentum(delta.x, delta.y, evt);
            pointerCount--;
            // restore damping
            if (pointerCount === 0) {
              scrollbar.options.damping = damping;
            }
            touchRecord.release(evt);
            activeScrollbar = null;
          });
        }
        //# sourceMappingURL=touch.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/events/wheel.js":
      /*!*******************************************************!*\
  !*** ./node_modules/smooth-scrollbar/events/wheel.js ***!
  \*******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ wheelHandler: () => /* binding */ wheelHandler,
          /* harmony export */
        });
        /* harmony import */ var _utils___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/ */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        function wheelHandler(scrollbar) {
          var addEvent = (0, _utils___WEBPACK_IMPORTED_MODULE_0__.eventScope)(
            scrollbar
          );
          var target = scrollbar.options.delegateTo || scrollbar.containerEl;
          var eventName =
            "onwheel" in window ||
            document.implementation.hasFeature("Events.wheel", "3.0")
              ? "wheel"
              : "mousewheel";
          addEvent(target, eventName, function (evt) {
            var _a = normalizeDelta(evt),
              x = _a.x,
              y = _a.y;
            scrollbar.addTransformableMomentum(
              x,
              y,
              evt,
              function (willScroll) {
                if (willScroll) {
                  evt.preventDefault();
                }
              }
            );
          });
        }
        // Normalizing wheel delta
        var DELTA_SCALE = {
          STANDARD: 1,
          OTHERS: -3,
        };
        var DELTA_MODE = [1.0, 28.0, 500.0];
        var getDeltaMode = function (mode) {
          return DELTA_MODE[mode] || DELTA_MODE[0];
        };
        function normalizeDelta(evt) {
          if ("deltaX" in evt) {
            var mode = getDeltaMode(evt.deltaMode);
            return {
              x: (evt.deltaX / DELTA_SCALE.STANDARD) * mode,
              y: (evt.deltaY / DELTA_SCALE.STANDARD) * mode,
            };
          }
          if ("wheelDeltaX" in evt) {
            return {
              x: evt.wheelDeltaX / DELTA_SCALE.OTHERS,
              y: evt.wheelDeltaY / DELTA_SCALE.OTHERS,
            };
          }
          // ie with touchpad
          return {
            x: 0,
            y: evt.wheelDelta / DELTA_SCALE.OTHERS,
          };
        }
        //# sourceMappingURL=wheel.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/geometry/get-size.js":
      /*!************************************************************!*\
  !*** ./node_modules/smooth-scrollbar/geometry/get-size.js ***!
  \************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ getSize: () => /* binding */ getSize,
          /* harmony export */
        });
        function getSize(scrollbar) {
          var containerEl = scrollbar.containerEl,
            contentEl = scrollbar.contentEl;
          var containerStyles = getComputedStyle(containerEl);
          var paddings = [
            "paddingTop",
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
          ].map(function (prop) {
            return containerStyles[prop]
              ? parseFloat(containerStyles[prop])
              : 0;
          });
          var verticalPadding = paddings[0] + paddings[1];
          var horizontalPadding = paddings[2] + paddings[3];
          return {
            container: {
              // requires `overflow: hidden`
              width: containerEl.clientWidth,
              height: containerEl.clientHeight,
            },
            content: {
              // border width and paddings should be included
              width:
                contentEl.offsetWidth -
                contentEl.clientWidth +
                contentEl.scrollWidth +
                horizontalPadding,
              height:
                contentEl.offsetHeight -
                contentEl.clientHeight +
                contentEl.scrollHeight +
                verticalPadding,
            },
          };
        }
        //# sourceMappingURL=get-size.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/geometry/index.js":
      /*!*********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/geometry/index.js ***!
  \*********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ getSize: () =>
            /* reexport safe */ _get_size__WEBPACK_IMPORTED_MODULE_0__.getSize,
          /* harmony export */ isVisible: () =>
            /* reexport safe */ _is_visible__WEBPACK_IMPORTED_MODULE_1__.isVisible,
          /* harmony export */ update: () =>
            /* reexport safe */ _update__WEBPACK_IMPORTED_MODULE_2__.update,
          /* harmony export */
        });
        /* harmony import */ var _get_size__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./get-size */ "./node_modules/smooth-scrollbar/geometry/get-size.js"
          );
        /* harmony import */ var _is_visible__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./is-visible */ "./node_modules/smooth-scrollbar/geometry/is-visible.js"
          );
        /* harmony import */ var _update__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./update */ "./node_modules/smooth-scrollbar/geometry/update.js"
          );

        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/geometry/is-visible.js":
      /*!**************************************************************!*\
  !*** ./node_modules/smooth-scrollbar/geometry/is-visible.js ***!
  \**************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ isVisible: () => /* binding */ isVisible,
          /* harmony export */
        });
        function isVisible(scrollbar, elem) {
          var bounding = scrollbar.bounding;
          var targetBounding = elem.getBoundingClientRect();
          // check overlapping
          var top = Math.max(bounding.top, targetBounding.top);
          var left = Math.max(bounding.left, targetBounding.left);
          var right = Math.min(bounding.right, targetBounding.right);
          var bottom = Math.min(bounding.bottom, targetBounding.bottom);
          return top < bottom && left < right;
        }
        //# sourceMappingURL=is-visible.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/geometry/update.js":
      /*!**********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/geometry/update.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ update: () => /* binding */ update,
          /* harmony export */
        });
        function update(scrollbar) {
          var newSize = scrollbar.getSize();
          var limit = {
            x: Math.max(newSize.content.width - newSize.container.width, 0),
            y: Math.max(newSize.content.height - newSize.container.height, 0),
          };
          // metrics
          var containerBounding = scrollbar.containerEl.getBoundingClientRect();
          var bounding = {
            top: Math.max(containerBounding.top, 0),
            right: Math.min(containerBounding.right, window.innerWidth),
            bottom: Math.min(containerBounding.bottom, window.innerHeight),
            left: Math.max(containerBounding.left, 0),
          };
          // assign props
          scrollbar.size = newSize;
          scrollbar.limit = limit;
          scrollbar.bounding = bounding;
          // update tracks
          scrollbar.track.update();
          // re-positioning
          scrollbar.setPosition();
        }
        //# sourceMappingURL=update.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/index.js":
      /*!************************************************!*\
  !*** ./node_modules/smooth-scrollbar/index.js ***!
  \************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ ScrollbarPlugin: () =>
            /* reexport safe */ _plugin__WEBPACK_IMPORTED_MODULE_2__.ScrollbarPlugin,
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! tslib */ "./node_modules/smooth-scrollbar/node_modules/tslib/tslib.es6.js"
          );
        /* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./polyfills */ "./node_modules/smooth-scrollbar/polyfills.js"
          );
        /* harmony import */ var _scrollbar__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./scrollbar */ "./node_modules/smooth-scrollbar/scrollbar.js"
          );
        /* harmony import */ var _plugin__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./plugin */ "./node_modules/smooth-scrollbar/plugin.js"
          );
        /* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./style */ "./node_modules/smooth-scrollbar/style.js"
          );

        /**
         * cast `I.Scrollbar` to `Scrollbar` to avoid error
         *
         * `I.Scrollbar` is not assignable to `Scrollbar`:
         *     "privateProp" is missing in `I.Scrollbar`
         *
         * @see https://github.com/Microsoft/TypeScript/issues/2672
         */
        var SmoothScrollbar = /** @class */ (function (_super) {
          (0, tslib__WEBPACK_IMPORTED_MODULE_4__.__extends)(
            SmoothScrollbar,
            _super
          );
          function SmoothScrollbar() {
            return (_super !== null && _super.apply(this, arguments)) || this;
          }
          /**
           * Initializes a scrollbar on the given element.
           *
           * @param elem The DOM element that you want to initialize scrollbar to
           * @param [options] Initial options
           */
          SmoothScrollbar.init = function (elem, options) {
            if (!elem || elem.nodeType !== 1) {
              throw new TypeError(
                "expect element to be DOM Element, but got " + elem
              );
            }
            // attach stylesheet
            (0, _style__WEBPACK_IMPORTED_MODULE_3__.attachStyle)();
            if (
              _scrollbar__WEBPACK_IMPORTED_MODULE_1__.scrollbarMap.has(elem)
            ) {
              return _scrollbar__WEBPACK_IMPORTED_MODULE_1__.scrollbarMap.get(
                elem
              );
            }
            return new _scrollbar__WEBPACK_IMPORTED_MODULE_1__.Scrollbar(
              elem,
              options
            );
          };
          /**
           * Automatically init scrollbar on all elements base on the selector `[data-scrollbar]`
           *
           * @param options Initial options
           */
          SmoothScrollbar.initAll = function (options) {
            return Array.from(
              document.querySelectorAll("[data-scrollbar]"),
              function (elem) {
                return SmoothScrollbar.init(elem, options);
              }
            );
          };
          /**
           * Check if there is a scrollbar on given element
           *
           * @param elem The DOM element that you want to check
           */
          SmoothScrollbar.has = function (elem) {
            return _scrollbar__WEBPACK_IMPORTED_MODULE_1__.scrollbarMap.has(
              elem
            );
          };
          /**
           * Gets scrollbar on the given element.
           * If no scrollbar instance exsits, returns `undefined`
           *
           * @param elem The DOM element that you want to check.
           */
          SmoothScrollbar.get = function (elem) {
            return _scrollbar__WEBPACK_IMPORTED_MODULE_1__.scrollbarMap.get(
              elem
            );
          };
          /**
           * Returns an array that contains all scrollbar instances
           */
          SmoothScrollbar.getAll = function () {
            return Array.from(
              _scrollbar__WEBPACK_IMPORTED_MODULE_1__.scrollbarMap.values()
            );
          };
          /**
           * Removes scrollbar on the given element
           */
          SmoothScrollbar.destroy = function (elem) {
            var scrollbar =
              _scrollbar__WEBPACK_IMPORTED_MODULE_1__.scrollbarMap.get(elem);
            if (scrollbar) {
              scrollbar.destroy();
            }
          };
          /**
           * Removes all scrollbar instances from current document
           */
          SmoothScrollbar.destroyAll = function () {
            _scrollbar__WEBPACK_IMPORTED_MODULE_1__.scrollbarMap.forEach(
              function (scrollbar) {
                scrollbar.destroy();
              }
            );
          };
          /**
           * Attaches plugins to scrollbars
           *
           * @param ...Plugins Scrollbar plugin classes
           */
          SmoothScrollbar.use = function () {
            var Plugins = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              Plugins[_i] = arguments[_i];
            }
            return _plugin__WEBPACK_IMPORTED_MODULE_2__.addPlugins.apply(
              void 0,
              Plugins
            );
          };
          /**
           * Attaches default style sheets to current document.
           * You don't need to call this method manually unless
           * you removed the default styles via `Scrollbar.detachStyle()`
           */
          SmoothScrollbar.attachStyle = function () {
            return (0, _style__WEBPACK_IMPORTED_MODULE_3__.attachStyle)();
          };
          /**
           * Removes default styles from current document.
           * Use this method when you want to use your own css for scrollbars.
           */
          SmoothScrollbar.detachStyle = function () {
            return (0, _style__WEBPACK_IMPORTED_MODULE_3__.detachStyle)();
          };
          SmoothScrollbar.version = "8.8.4";
          SmoothScrollbar.ScrollbarPlugin =
            _plugin__WEBPACK_IMPORTED_MODULE_2__.ScrollbarPlugin;
          return SmoothScrollbar;
        })(_scrollbar__WEBPACK_IMPORTED_MODULE_1__.Scrollbar);
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          SmoothScrollbar;
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/node_modules/tslib/tslib.es6.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/smooth-scrollbar/node_modules/tslib/tslib.es6.js ***!
  \***********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ __assign: () => /* binding */ __assign,
          /* harmony export */ __asyncDelegator: () =>
            /* binding */ __asyncDelegator,
          /* harmony export */ __asyncGenerator: () =>
            /* binding */ __asyncGenerator,
          /* harmony export */ __asyncValues: () => /* binding */ __asyncValues,
          /* harmony export */ __await: () => /* binding */ __await,
          /* harmony export */ __awaiter: () => /* binding */ __awaiter,
          /* harmony export */ __classPrivateFieldGet: () =>
            /* binding */ __classPrivateFieldGet,
          /* harmony export */ __classPrivateFieldSet: () =>
            /* binding */ __classPrivateFieldSet,
          /* harmony export */ __createBinding: () =>
            /* binding */ __createBinding,
          /* harmony export */ __decorate: () => /* binding */ __decorate,
          /* harmony export */ __exportStar: () => /* binding */ __exportStar,
          /* harmony export */ __extends: () => /* binding */ __extends,
          /* harmony export */ __generator: () => /* binding */ __generator,
          /* harmony export */ __importDefault: () =>
            /* binding */ __importDefault,
          /* harmony export */ __importStar: () => /* binding */ __importStar,
          /* harmony export */ __makeTemplateObject: () =>
            /* binding */ __makeTemplateObject,
          /* harmony export */ __metadata: () => /* binding */ __metadata,
          /* harmony export */ __param: () => /* binding */ __param,
          /* harmony export */ __read: () => /* binding */ __read,
          /* harmony export */ __rest: () => /* binding */ __rest,
          /* harmony export */ __spread: () => /* binding */ __spread,
          /* harmony export */ __spreadArrays: () =>
            /* binding */ __spreadArrays,
          /* harmony export */ __values: () => /* binding */ __values,
          /* harmony export */
        });
        /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
        /* global Reflect, Promise */

        var extendStatics = function (d, b) {
          extendStatics =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (d, b) {
                d.__proto__ = b;
              }) ||
            function (d, b) {
              for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
            };
          return extendStatics(d, b);
        };

        function __extends(d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype =
            b === null
              ? Object.create(b)
              : ((__.prototype = b.prototype), new __());
        }

        var __assign = function () {
          __assign =
            Object.assign ||
            function __assign(t) {
              for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s)
                  if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
              return t;
            };
          return __assign.apply(this, arguments);
        };

        function __rest(s, e) {
          var t = {};
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
              t[p] = s[p];
          if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (
              var i = 0, p = Object.getOwnPropertySymbols(s);
              i < p.length;
              i++
            ) {
              if (
                e.indexOf(p[i]) < 0 &&
                Object.prototype.propertyIsEnumerable.call(s, p[i])
              )
                t[p[i]] = s[p[i]];
            }
          return t;
        }

        function __decorate(decorators, target, key, desc) {
          var c = arguments.length,
            r =
              c < 3
                ? target
                : desc === null
                ? (desc = Object.getOwnPropertyDescriptor(target, key))
                : desc,
            d;
          if (
            typeof Reflect === "object" &&
            typeof Reflect.decorate === "function"
          )
            r = Reflect.decorate(decorators, target, key, desc);
          else
            for (var i = decorators.length - 1; i >= 0; i--)
              if ((d = decorators[i]))
                r =
                  (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) ||
                  r;
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        }

        function __param(paramIndex, decorator) {
          return function (target, key) {
            decorator(target, key, paramIndex);
          };
        }

        function __metadata(metadataKey, metadataValue) {
          if (
            typeof Reflect === "object" &&
            typeof Reflect.metadata === "function"
          )
            return Reflect.metadata(metadataKey, metadataValue);
        }

        function __awaiter(thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P
              ? value
              : new P(function (resolve) {
                  resolve(value);
                });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done
                ? resolve(result.value)
                : adopt(result.value).then(fulfilled, rejected);
            }
            step(
              (generator = generator.apply(thisArg, _arguments || [])).next()
            );
          });
        }

        function __generator(thisArg, body) {
          var _ = {
              label: 0,
              sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: [],
            },
            f,
            y,
            t,
            g;
          return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === "function" &&
              (g[Symbol.iterator] = function () {
                return this;
              }),
            g
          );
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_)
              try {
                if (
                  ((f = 1),
                  y &&
                    (t =
                      op[0] & 2
                        ? y["return"]
                        : op[0]
                        ? y["throw"] || ((t = y["return"]) && t.call(y), 0)
                        : y.next) &&
                    !(t = t.call(y, op[1])).done)
                )
                  return t;
                if (((y = 0), t)) op = [op[0] & 2, t.value];
                switch (op[0]) {
                  case 0:
                  case 1:
                    t = op;
                    break;
                  case 4:
                    _.label++;
                    return { value: op[1], done: false };
                  case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;
                  case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                  default:
                    if (
                      !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                      (op[0] === 6 || op[0] === 2)
                    ) {
                      _ = 0;
                      continue;
                    }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                      _.label = op[1];
                      break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                      _.label = t[1];
                      t = op;
                      break;
                    }
                    if (t && _.label < t[2]) {
                      _.label = t[2];
                      _.ops.push(op);
                      break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
                }
                op = body.call(thisArg, _);
              } catch (e) {
                op = [6, e];
                y = 0;
              } finally {
                f = t = 0;
              }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
          }
        }

        function __createBinding(o, m, k, k2) {
          if (k2 === undefined) k2 = k;
          o[k2] = m[k];
        }

        function __exportStar(m, exports) {
          for (var p in m)
            if (p !== "default" && !exports.hasOwnProperty(p))
              exports[p] = m[p];
        }

        function __values(o) {
          var s = typeof Symbol === "function" && Symbol.iterator,
            m = s && o[s],
            i = 0;
          if (m) return m.call(o);
          if (o && typeof o.length === "number")
            return {
              next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
              },
            };
          throw new TypeError(
            s ? "Object is not iterable." : "Symbol.iterator is not defined."
          );
        }

        function __read(o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
              ar.push(r.value);
          } catch (error) {
            e = { error: error };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        }

        function __spread() {
          for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
          return ar;
        }

        function __spreadArrays() {
          for (var s = 0, i = 0, il = arguments.length; i < il; i++)
            s += arguments[i].length;
          for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
              r[k] = a[j];
          return r;
        }

        function __await(v) {
          return this instanceof __await
            ? ((this.v = v), this)
            : new __await(v);
        }

        function __asyncGenerator(thisArg, _arguments, generator) {
          if (!Symbol.asyncIterator)
            throw new TypeError("Symbol.asyncIterator is not defined.");
          var g = generator.apply(thisArg, _arguments || []),
            i,
            q = [];
          return (
            (i = {}),
            verb("next"),
            verb("throw"),
            verb("return"),
            (i[Symbol.asyncIterator] = function () {
              return this;
            }),
            i
          );
          function verb(n) {
            if (g[n])
              i[n] = function (v) {
                return new Promise(function (a, b) {
                  q.push([n, v, a, b]) > 1 || resume(n, v);
                });
              };
          }
          function resume(n, v) {
            try {
              step(g[n](v));
            } catch (e) {
              settle(q[0][3], e);
            }
          }
          function step(r) {
            r.value instanceof __await
              ? Promise.resolve(r.value.v).then(fulfill, reject)
              : settle(q[0][2], r);
          }
          function fulfill(value) {
            resume("next", value);
          }
          function reject(value) {
            resume("throw", value);
          }
          function settle(f, v) {
            if ((f(v), q.shift(), q.length)) resume(q[0][0], q[0][1]);
          }
        }

        function __asyncDelegator(o) {
          var i, p;
          return (
            (i = {}),
            verb("next"),
            verb("throw", function (e) {
              throw e;
            }),
            verb("return"),
            (i[Symbol.iterator] = function () {
              return this;
            }),
            i
          );
          function verb(n, f) {
            i[n] = o[n]
              ? function (v) {
                  return (p = !p)
                    ? { value: __await(o[n](v)), done: n === "return" }
                    : f
                    ? f(v)
                    : v;
                }
              : f;
          }
        }

        function __asyncValues(o) {
          if (!Symbol.asyncIterator)
            throw new TypeError("Symbol.asyncIterator is not defined.");
          var m = o[Symbol.asyncIterator],
            i;
          return m
            ? m.call(o)
            : ((o =
                typeof __values === "function"
                  ? __values(o)
                  : o[Symbol.iterator]()),
              (i = {}),
              verb("next"),
              verb("throw"),
              verb("return"),
              (i[Symbol.asyncIterator] = function () {
                return this;
              }),
              i);
          function verb(n) {
            i[n] =
              o[n] &&
              function (v) {
                return new Promise(function (resolve, reject) {
                  (v = o[n](v)), settle(resolve, reject, v.done, v.value);
                });
              };
          }
          function settle(resolve, reject, d, v) {
            Promise.resolve(v).then(function (v) {
              resolve({ value: v, done: d });
            }, reject);
          }
        }

        function __makeTemplateObject(cooked, raw) {
          if (Object.defineProperty) {
            Object.defineProperty(cooked, "raw", { value: raw });
          } else {
            cooked.raw = raw;
          }
          return cooked;
        }

        function __importStar(mod) {
          if (mod && mod.__esModule) return mod;
          var result = {};
          if (mod != null)
            for (var k in mod)
              if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
          result.default = mod;
          return result;
        }

        function __importDefault(mod) {
          return mod && mod.__esModule ? mod : { default: mod };
        }

        function __classPrivateFieldGet(receiver, privateMap) {
          if (!privateMap.has(receiver)) {
            throw new TypeError(
              "attempted to get private field on non-instance"
            );
          }
          return privateMap.get(receiver);
        }

        function __classPrivateFieldSet(receiver, privateMap, value) {
          if (!privateMap.has(receiver)) {
            throw new TypeError(
              "attempted to set private field on non-instance"
            );
          }
          privateMap.set(receiver, value);
          return value;
        }

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/options.js":
      /*!**************************************************!*\
  !*** ./node_modules/smooth-scrollbar/options.js ***!
  \**************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ Options: () => /* binding */ Options,
          /* harmony export */
        });
        /* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! tslib */ "./node_modules/smooth-scrollbar/node_modules/tslib/tslib.es6.js"
          );
        /* harmony import */ var _decorators___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./decorators/ */ "./node_modules/smooth-scrollbar/decorators/index.js"
          );

        var Options = /** @class */ (function () {
          function Options(config) {
            var _this = this;
            if (config === void 0) {
              config = {};
            }
            /**
             * Momentum reduction damping factor, a float value between `(0, 1)`.
             * The lower the value is, the more smooth the scrolling will be
             * (also the more paint frames).
             */
            this.damping = 0.1;
            /**
             * Minimal size for scrollbar thumbs.
             */
            this.thumbMinSize = 20;
            /**
             * Render every frame in integer pixel values
             * set to `true` to improve scrolling performance.
             */
            this.renderByPixels = true;
            /**
             * Keep scrollbar tracks visible
             */
            this.alwaysShowTracks = false;
            /**
             * Set to `true` to allow outer scrollbars continue scrolling
             * when current scrollbar reaches edge.
             */
            this.continuousScrolling = true;
            /**
             * Delegate wheel events and touch events to the given element.
             * By default, the container element is used.
             * This option will be useful for dealing with fixed elements.
             */
            this.delegateTo = null;
            /**
             * Options for plugins. Syntax:
             *   plugins[pluginName] = pluginOptions: any
             */
            this.plugins = {};
            Object.keys(config).forEach(function (prop) {
              _this[prop] = config[prop];
            });
          }
          Object.defineProperty(Options.prototype, "wheelEventTarget", {
            get: function () {
              return this.delegateTo;
            },
            set: function (el) {
              console.warn(
                "[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead."
              );
              this.delegateTo = el;
            },
            enumerable: true,
            configurable: true,
          });
          (0, tslib__WEBPACK_IMPORTED_MODULE_1__.__decorate)(
            [(0, _decorators___WEBPACK_IMPORTED_MODULE_0__.range)(0, 1)],
            Options.prototype,
            "damping",
            void 0
          );
          (0, tslib__WEBPACK_IMPORTED_MODULE_1__.__decorate)(
            [(0, _decorators___WEBPACK_IMPORTED_MODULE_0__.range)(0, Infinity)],
            Options.prototype,
            "thumbMinSize",
            void 0
          );
          (0, tslib__WEBPACK_IMPORTED_MODULE_1__.__decorate)(
            [_decorators___WEBPACK_IMPORTED_MODULE_0__.boolean],
            Options.prototype,
            "renderByPixels",
            void 0
          );
          (0, tslib__WEBPACK_IMPORTED_MODULE_1__.__decorate)(
            [_decorators___WEBPACK_IMPORTED_MODULE_0__.boolean],
            Options.prototype,
            "alwaysShowTracks",
            void 0
          );
          (0, tslib__WEBPACK_IMPORTED_MODULE_1__.__decorate)(
            [_decorators___WEBPACK_IMPORTED_MODULE_0__.boolean],
            Options.prototype,
            "continuousScrolling",
            void 0
          );
          return Options;
        })();

        //# sourceMappingURL=options.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/plugin.js":
      /*!*************************************************!*\
  !*** ./node_modules/smooth-scrollbar/plugin.js ***!
  \*************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ ScrollbarPlugin: () =>
            /* binding */ ScrollbarPlugin,
          /* harmony export */ addPlugins: () => /* binding */ addPlugins,
          /* harmony export */ globalPlugins: () => /* binding */ globalPlugins,
          /* harmony export */ initPlugins: () => /* binding */ initPlugins,
          /* harmony export */
        });
        /* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! tslib */ "./node_modules/smooth-scrollbar/node_modules/tslib/tslib.es6.js"
          );

        var ScrollbarPlugin = /** @class */ (function () {
          function ScrollbarPlugin(scrollbar, options) {
            var _newTarget = this.constructor;
            this.scrollbar = scrollbar;
            this.name = _newTarget.pluginName;
            this.options = (0, tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)(
              (0, tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)(
                {},
                _newTarget.defaultOptions
              ),
              options
            );
          }
          ScrollbarPlugin.prototype.onInit = function () {};
          ScrollbarPlugin.prototype.onDestroy = function () {};
          ScrollbarPlugin.prototype.onUpdate = function () {};
          ScrollbarPlugin.prototype.onRender = function (_remainMomentum) {};
          ScrollbarPlugin.prototype.transformDelta = function (delta, _evt) {
            return (0, tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, delta);
          };
          ScrollbarPlugin.pluginName = "";
          ScrollbarPlugin.defaultOptions = {};
          return ScrollbarPlugin;
        })();

        var globalPlugins = {
          order: new Set(),
          constructors: {},
        };
        function addPlugins() {
          var Plugins = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            Plugins[_i] = arguments[_i];
          }
          Plugins.forEach(function (P) {
            var pluginName = P.pluginName;
            if (!pluginName) {
              throw new TypeError("plugin name is required");
            }
            globalPlugins.order.add(pluginName);
            globalPlugins.constructors[pluginName] = P;
          });
        }
        function initPlugins(scrollbar, options) {
          return Array.from(globalPlugins.order)
            .filter(function (pluginName) {
              return options[pluginName] !== false;
            })
            .map(function (pluginName) {
              var Plugin = globalPlugins.constructors[pluginName];
              var instance = new Plugin(scrollbar, options[pluginName]);
              // bind plugin options to `scrollbar.options`
              options[pluginName] = instance.options;
              return instance;
            });
        }
        //# sourceMappingURL=plugin.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/polyfills.js":
      /*!****************************************************!*\
  !*** ./node_modules/smooth-scrollbar/polyfills.js ***!
  \****************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var core_js_es_map__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! core-js/es/map */ "./node_modules/core-js/es/map/index.js"
          );
        /* harmony import */ var core_js_es_map__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            core_js_es_map__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var core_js_es_set__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! core-js/es/set */ "./node_modules/core-js/es/set/index.js"
          );
        /* harmony import */ var core_js_es_set__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            core_js_es_set__WEBPACK_IMPORTED_MODULE_1__
          );
        /* harmony import */ var core_js_es_weak_map__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! core-js/es/weak-map */ "./node_modules/core-js/es/weak-map/index.js"
          );
        /* harmony import */ var core_js_es_weak_map__WEBPACK_IMPORTED_MODULE_2___default =
          /*#__PURE__*/ __webpack_require__.n(
            core_js_es_weak_map__WEBPACK_IMPORTED_MODULE_2__
          );
        /* harmony import */ var core_js_es_array_from__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! core-js/es/array/from */ "./node_modules/core-js/es/array/from.js"
          );
        /* harmony import */ var core_js_es_array_from__WEBPACK_IMPORTED_MODULE_3___default =
          /*#__PURE__*/ __webpack_require__.n(
            core_js_es_array_from__WEBPACK_IMPORTED_MODULE_3__
          );
        /* harmony import */ var core_js_es_object_assign__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! core-js/es/object/assign */ "./node_modules/core-js/es/object/assign.js"
          );
        /* harmony import */ var core_js_es_object_assign__WEBPACK_IMPORTED_MODULE_4___default =
          /*#__PURE__*/ __webpack_require__.n(
            core_js_es_object_assign__WEBPACK_IMPORTED_MODULE_4__
          );

        //# sourceMappingURL=polyfills.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/scrollbar.js":
      /*!****************************************************!*\
  !*** ./node_modules/smooth-scrollbar/scrollbar.js ***!
  \****************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ Scrollbar: () => /* binding */ Scrollbar,
          /* harmony export */ scrollbarMap: () => /* binding */ scrollbarMap,
          /* harmony export */
        });
        /* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! tslib */ "./node_modules/smooth-scrollbar/node_modules/tslib/tslib.es6.js"
          );
        /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./utils/ */ "./node_modules/smooth-scrollbar/utils/index.js"
          );
        /* harmony import */ var _options__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./options */ "./node_modules/smooth-scrollbar/options.js"
          );
        /* harmony import */ var _decorators___WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./decorators/ */ "./node_modules/smooth-scrollbar/decorators/index.js"
          );
        /* harmony import */ var _track___WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./track/ */ "./node_modules/smooth-scrollbar/track/index.js"
          );
        /* harmony import */ var _geometry___WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./geometry/ */ "./node_modules/smooth-scrollbar/geometry/index.js"
          );
        /* harmony import */ var _scrolling___WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./scrolling/ */ "./node_modules/smooth-scrollbar/scrolling/index.js"
          );
        /* harmony import */ var _plugin__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./plugin */ "./node_modules/smooth-scrollbar/plugin.js"
          );
        /* harmony import */ var _events___WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ./events/ */ "./node_modules/smooth-scrollbar/events/index.js"
          );

        // DO NOT use WeakMap here
        // .getAll() methods requires `scrollbarMap.values()`
        var scrollbarMap = new Map();
        var Scrollbar = /** @class */ (function () {
          function Scrollbar(containerEl, options) {
            var _this = this;
            /**
             * Current scrolling offsets
             */
            this.offset = {
              x: 0,
              y: 0,
            };
            /**
             * Max-allowed scrolling offsets
             */
            this.limit = {
              x: Infinity,
              y: Infinity,
            };
            /**
             * Container bounding rect
             */
            this.bounding = {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            };
            // private _observer: ResizeObserver;
            this._plugins = [];
            this._momentum = { x: 0, y: 0 };
            this._listeners = new Set();
            this.containerEl = containerEl;
            var contentEl = (this.contentEl = document.createElement("div"));
            this.options = new _options__WEBPACK_IMPORTED_MODULE_1__.Options(
              options
            );
            // mark as a scroll element
            containerEl.setAttribute("data-scrollbar", "true");
            // make container focusable
            containerEl.setAttribute("tabindex", "-1");
            (0, _utils__WEBPACK_IMPORTED_MODULE_0__.setStyle)(containerEl, {
              overflow: "hidden",
              outline: "none",
            });
            // enable touch event capturing in IE, see:
            // https://github.com/idiotWu/smooth-scrollbar/issues/39
            if (window.navigator.msPointerEnabled) {
              containerEl.style.msTouchAction = "none";
            }
            // mount content
            contentEl.className = "scroll-content";
            Array.from(containerEl.childNodes).forEach(function (node) {
              contentEl.appendChild(node);
            });
            containerEl.appendChild(contentEl);
            // attach track
            this.track =
              new _track___WEBPACK_IMPORTED_MODULE_3__.TrackController(this);
            // initial measuring
            this.size = this.getSize();
            // init plugins
            this._plugins = (0,
            _plugin__WEBPACK_IMPORTED_MODULE_6__.initPlugins)(
              this,
              this.options.plugins
            );
            // preserve scroll offset
            var scrollLeft = containerEl.scrollLeft,
              scrollTop = containerEl.scrollTop;
            containerEl.scrollLeft = containerEl.scrollTop = 0;
            this.setPosition(scrollLeft, scrollTop, {
              withoutCallbacks: true,
            });
            // FIXME: update typescript
            var ResizeObserver = window.ResizeObserver;
            // observe
            if (typeof ResizeObserver === "function") {
              this._observer = new ResizeObserver(function () {
                _this.update();
              });
              this._observer.observe(contentEl);
            }
            scrollbarMap.set(containerEl, this);
            // wait for DOM ready
            requestAnimationFrame(function () {
              _this._init();
            });
          }
          Object.defineProperty(Scrollbar.prototype, "parent", {
            /**
             * Parent scrollbar
             */
            get: function () {
              var elem = this.containerEl.parentElement;
              while (elem) {
                var parentScrollbar = scrollbarMap.get(elem);
                if (parentScrollbar) {
                  return parentScrollbar;
                }
                elem = elem.parentElement;
              }
              return null;
            },
            enumerable: true,
            configurable: true,
          });
          Object.defineProperty(Scrollbar.prototype, "scrollTop", {
            /**
             * Gets or sets `scrollbar.offset.y`
             */
            get: function () {
              return this.offset.y;
            },
            set: function (y) {
              this.setPosition(this.scrollLeft, y);
            },
            enumerable: true,
            configurable: true,
          });
          Object.defineProperty(Scrollbar.prototype, "scrollLeft", {
            /**
             * Gets or sets `scrollbar.offset.x`
             */
            get: function () {
              return this.offset.x;
            },
            set: function (x) {
              this.setPosition(x, this.scrollTop);
            },
            enumerable: true,
            configurable: true,
          });
          /**
           * Returns the size of the scrollbar container element
           * and the content wrapper element
           */
          Scrollbar.prototype.getSize = function () {
            return (0, _geometry___WEBPACK_IMPORTED_MODULE_4__.getSize)(this);
          };
          /**
           * Forces scrollbar to update geometry infomation.
           *
           * By default, scrollbars are automatically updated with `100ms` debounce (or `MutationObserver` fires).
           * You can call this method to force an update when you modified contents
           */
          Scrollbar.prototype.update = function () {
            (0, _geometry___WEBPACK_IMPORTED_MODULE_4__.update)(this);
            this._plugins.forEach(function (plugin) {
              plugin.onUpdate();
            });
          };
          /**
           * Checks if an element is visible in the current view area
           */
          Scrollbar.prototype.isVisible = function (elem) {
            return (0, _geometry___WEBPACK_IMPORTED_MODULE_4__.isVisible)(
              this,
              elem
            );
          };
          /**
           * Sets the scrollbar to the given offset without easing
           */
          Scrollbar.prototype.setPosition = function (x, y, options) {
            var _this = this;
            if (x === void 0) {
              x = this.offset.x;
            }
            if (y === void 0) {
              y = this.offset.y;
            }
            if (options === void 0) {
              options = {};
            }
            var status = (0,
            _scrolling___WEBPACK_IMPORTED_MODULE_5__.setPosition)(this, x, y);
            if (!status || options.withoutCallbacks) {
              return;
            }
            this._listeners.forEach(function (fn) {
              fn.call(_this, status);
            });
          };
          /**
           * Scrolls to given position with easing function
           */
          Scrollbar.prototype.scrollTo = function (x, y, duration, options) {
            if (x === void 0) {
              x = this.offset.x;
            }
            if (y === void 0) {
              y = this.offset.y;
            }
            if (duration === void 0) {
              duration = 0;
            }
            if (options === void 0) {
              options = {};
            }
            (0, _scrolling___WEBPACK_IMPORTED_MODULE_5__.scrollTo)(
              this,
              x,
              y,
              duration,
              options
            );
          };
          /**
           * Scrolls the target element into visible area of scrollbar,
           * likes the DOM method `element.scrollIntoView().
           */
          Scrollbar.prototype.scrollIntoView = function (elem, options) {
            if (options === void 0) {
              options = {};
            }
            (0, _scrolling___WEBPACK_IMPORTED_MODULE_5__.scrollIntoView)(
              this,
              elem,
              options
            );
          };
          /**
           * Adds scrolling listener
           */
          Scrollbar.prototype.addListener = function (fn) {
            if (typeof fn !== "function") {
              throw new TypeError(
                "[smooth-scrollbar] scrolling listener should be a function"
              );
            }
            this._listeners.add(fn);
          };
          /**
           * Removes listener previously registered with `scrollbar.addListener()`
           */
          Scrollbar.prototype.removeListener = function (fn) {
            this._listeners.delete(fn);
          };
          /**
           * Adds momentum and applys delta transformers.
           */
          Scrollbar.prototype.addTransformableMomentum = function (
            x,
            y,
            fromEvent,
            callback
          ) {
            this._updateDebounced();
            var finalDelta = this._plugins.reduce(
              function (delta, plugin) {
                return plugin.transformDelta(delta, fromEvent) || delta;
              },
              { x: x, y: y }
            );
            var willScroll = !this._shouldPropagateMomentum(
              finalDelta.x,
              finalDelta.y
            );
            if (willScroll) {
              this.addMomentum(finalDelta.x, finalDelta.y);
            }
            if (callback) {
              callback.call(this, willScroll);
            }
          };
          /**
           * Increases scrollbar's momentum
           */
          Scrollbar.prototype.addMomentum = function (x, y) {
            this.setMomentum(this._momentum.x + x, this._momentum.y + y);
          };
          /**
           * Sets scrollbar's momentum to given value
           */
          Scrollbar.prototype.setMomentum = function (x, y) {
            if (this.limit.x === 0) {
              x = 0;
            }
            if (this.limit.y === 0) {
              y = 0;
            }
            if (this.options.renderByPixels) {
              x = Math.round(x);
              y = Math.round(y);
            }
            this._momentum.x = x;
            this._momentum.y = y;
          };
          /**
           * Update options for specific plugin
           *
           * @param pluginName Name of the plugin
           * @param [options] An object includes the properties that you want to update
           */
          Scrollbar.prototype.updatePluginOptions = function (
            pluginName,
            options
          ) {
            this._plugins.forEach(function (plugin) {
              if (plugin.name === pluginName) {
                Object.assign(plugin.options, options);
              }
            });
          };
          Scrollbar.prototype.destroy = function () {
            var _a = this,
              containerEl = _a.containerEl,
              contentEl = _a.contentEl;
            (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clearEventsOn)(this);
            this._listeners.clear();
            this.setMomentum(0, 0);
            cancelAnimationFrame(this._renderID);
            if (this._observer) {
              this._observer.disconnect();
            }
            scrollbarMap.delete(this.containerEl);
            // restore contents
            var childNodes = Array.from(contentEl.childNodes);
            while (containerEl.firstChild) {
              containerEl.removeChild(containerEl.firstChild);
            }
            childNodes.forEach(function (el) {
              containerEl.appendChild(el);
            });
            // reset scroll position
            (0, _utils__WEBPACK_IMPORTED_MODULE_0__.setStyle)(containerEl, {
              overflow: "",
            });
            containerEl.scrollTop = this.scrollTop;
            containerEl.scrollLeft = this.scrollLeft;
            // invoke plugin.onDestroy
            this._plugins.forEach(function (plugin) {
              plugin.onDestroy();
            });
            this._plugins.length = 0;
          };
          Scrollbar.prototype._init = function () {
            var _this = this;
            this.update();
            // init evet handlers
            Object.keys(_events___WEBPACK_IMPORTED_MODULE_7__).forEach(
              function (prop) {
                _events___WEBPACK_IMPORTED_MODULE_7__[prop](_this);
              }
            );
            // invoke `plugin.onInit`
            this._plugins.forEach(function (plugin) {
              plugin.onInit();
            });
            this._render();
          };
          Scrollbar.prototype._updateDebounced = function () {
            this.update();
          };
          // check whether to propagate monmentum to parent scrollbar
          // the following situations are considered as `true`:
          //         1. continuous scrolling is enabled (automatically disabled when overscroll is enabled)
          //         2. scrollbar reaches one side and is not about to scroll on the other direction
          Scrollbar.prototype._shouldPropagateMomentum = function (
            deltaX,
            deltaY
          ) {
            if (deltaX === void 0) {
              deltaX = 0;
            }
            if (deltaY === void 0) {
              deltaY = 0;
            }
            var _a = this,
              options = _a.options,
              offset = _a.offset,
              limit = _a.limit;
            if (!options.continuousScrolling) return false;
            // force an update when scrollbar is "unscrollable", see #106
            if (limit.x === 0 && limit.y === 0) {
              this._updateDebounced();
            }
            var destX = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clamp)(
              deltaX + offset.x,
              0,
              limit.x
            );
            var destY = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clamp)(
              deltaY + offset.y,
              0,
              limit.y
            );
            var res = true;
            // offsets are not about to change
            // `&=` operator is not allowed for boolean types
            res = res && destX === offset.x;
            res = res && destY === offset.y;
            // current offsets are on the edge
            res =
              res &&
              (offset.x === limit.x ||
                offset.x === 0 ||
                offset.y === limit.y ||
                offset.y === 0);
            return res;
          };
          Scrollbar.prototype._render = function () {
            var _momentum = this._momentum;
            if (_momentum.x || _momentum.y) {
              var nextX = this._nextTick("x");
              var nextY = this._nextTick("y");
              _momentum.x = nextX.momentum;
              _momentum.y = nextY.momentum;
              this.setPosition(nextX.position, nextY.position);
            }
            var remain = (0, tslib__WEBPACK_IMPORTED_MODULE_8__.__assign)(
              {},
              this._momentum
            );
            this._plugins.forEach(function (plugin) {
              plugin.onRender(remain);
            });
            this._renderID = requestAnimationFrame(this._render.bind(this));
          };
          Scrollbar.prototype._nextTick = function (direction) {
            var _a = this,
              options = _a.options,
              offset = _a.offset,
              _momentum = _a._momentum;
            var current = offset[direction];
            var remain = _momentum[direction];
            if (Math.abs(remain) <= 0.1) {
              return {
                momentum: 0,
                position: current + remain,
              };
            }
            var nextMomentum = remain * (1 - options.damping);
            if (options.renderByPixels) {
              nextMomentum |= 0;
            }
            return {
              momentum: nextMomentum,
              position: current + remain - nextMomentum,
            };
          };
          (0, tslib__WEBPACK_IMPORTED_MODULE_8__.__decorate)(
            [
              (0, _decorators___WEBPACK_IMPORTED_MODULE_2__.debounce)(
                100,
                true
              ),
            ],
            Scrollbar.prototype,
            "_updateDebounced",
            null
          );
          return Scrollbar;
        })();

        //# sourceMappingURL=scrollbar.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/scrolling/index.js":
      /*!**********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/scrolling/index.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ scrollIntoView: () =>
            /* reexport safe */ _scroll_into_view__WEBPACK_IMPORTED_MODULE_2__.scrollIntoView,
          /* harmony export */ scrollTo: () =>
            /* reexport safe */ _scroll_to__WEBPACK_IMPORTED_MODULE_1__.scrollTo,
          /* harmony export */ setPosition: () =>
            /* reexport safe */ _set_position__WEBPACK_IMPORTED_MODULE_0__.setPosition,
          /* harmony export */
        });
        /* harmony import */ var _set_position__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./set-position */ "./node_modules/smooth-scrollbar/scrolling/set-position.js"
          );
        /* harmony import */ var _scroll_to__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./scroll-to */ "./node_modules/smooth-scrollbar/scrolling/scroll-to.js"
          );
        /* harmony import */ var _scroll_into_view__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./scroll-into-view */ "./node_modules/smooth-scrollbar/scrolling/scroll-into-view.js"
          );

        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/scrolling/scroll-into-view.js":
      /*!*********************************************************************!*\
  !*** ./node_modules/smooth-scrollbar/scrolling/scroll-into-view.js ***!
  \*********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ scrollIntoView: () =>
            /* binding */ scrollIntoView,
          /* harmony export */
        });
        /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        function scrollIntoView(scrollbar, elem, _a) {
          var _b = _a === void 0 ? {} : _a,
            _c = _b.alignToTop,
            alignToTop = _c === void 0 ? true : _c,
            _d = _b.onlyScrollIfNeeded,
            onlyScrollIfNeeded = _d === void 0 ? false : _d,
            _e = _b.offsetTop,
            offsetTop = _e === void 0 ? 0 : _e,
            _f = _b.offsetLeft,
            offsetLeft = _f === void 0 ? 0 : _f,
            _g = _b.offsetBottom,
            offsetBottom = _g === void 0 ? 0 : _g;
          var containerEl = scrollbar.containerEl,
            bounding = scrollbar.bounding,
            offset = scrollbar.offset,
            limit = scrollbar.limit;
          if (!elem || !containerEl.contains(elem)) return;
          var targetBounding = elem.getBoundingClientRect();
          if (onlyScrollIfNeeded && scrollbar.isVisible(elem)) return;
          var delta = alignToTop
            ? targetBounding.top - bounding.top - offsetTop
            : targetBounding.bottom - bounding.bottom + offsetBottom;
          scrollbar.setMomentum(
            targetBounding.left - bounding.left - offsetLeft,
            (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clamp)(
              delta,
              -offset.y,
              limit.y - offset.y
            )
          );
        }
        //# sourceMappingURL=scroll-into-view.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/scrolling/scroll-to.js":
      /*!**************************************************************!*\
  !*** ./node_modules/smooth-scrollbar/scrolling/scroll-to.js ***!
  \**************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ scrollTo: () => /* binding */ scrollTo,
          /* harmony export */
        });
        /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        var animationIDStorage = new WeakMap();
        function scrollTo(scrollbar, x, y, duration, _a) {
          if (duration === void 0) {
            duration = 0;
          }
          var _b = _a === void 0 ? {} : _a,
            _c = _b.easing,
            easing = _c === void 0 ? defaultEasing : _c,
            callback = _b.callback;
          var options = scrollbar.options,
            offset = scrollbar.offset,
            limit = scrollbar.limit;
          if (options.renderByPixels) {
            // ensure resolved with integer
            x = Math.round(x);
            y = Math.round(y);
          }
          var startX = offset.x;
          var startY = offset.y;
          var disX =
            (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clamp)(x, 0, limit.x) -
            startX;
          var disY =
            (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clamp)(y, 0, limit.y) -
            startY;
          var start = Date.now();
          function scroll() {
            var elapse = Date.now() - start;
            var progress = duration
              ? easing(Math.min(elapse / duration, 1))
              : 1;
            scrollbar.setPosition(
              startX + disX * progress,
              startY + disY * progress
            );
            if (elapse >= duration) {
              if (typeof callback === "function") {
                callback.call(scrollbar);
              }
            } else {
              var animationID = requestAnimationFrame(scroll);
              animationIDStorage.set(scrollbar, animationID);
            }
          }
          cancelAnimationFrame(animationIDStorage.get(scrollbar));
          scroll();
        }
        /**
         * easeOutCubic
         */
        function defaultEasing(t) {
          return Math.pow(t - 1, 3) + 1;
        }
        //# sourceMappingURL=scroll-to.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/scrolling/set-position.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/smooth-scrollbar/scrolling/set-position.js ***!
  \*****************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ setPosition: () => /* binding */ setPosition,
          /* harmony export */
        });
        /* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! tslib */ "./node_modules/smooth-scrollbar/node_modules/tslib/tslib.es6.js"
          );
        /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/ */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        function setPosition(scrollbar, x, y) {
          var options = scrollbar.options,
            offset = scrollbar.offset,
            limit = scrollbar.limit,
            track = scrollbar.track,
            contentEl = scrollbar.contentEl;
          if (options.renderByPixels) {
            x = Math.round(x);
            y = Math.round(y);
          }
          x = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clamp)(x, 0, limit.x);
          y = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clamp)(y, 0, limit.y);
          // position changed -> show track for 300ms
          if (x !== offset.x) track.xAxis.show();
          if (y !== offset.y) track.yAxis.show();
          if (!options.alwaysShowTracks) {
            track.autoHideOnIdle();
          }
          if (x === offset.x && y === offset.y) {
            return null;
          }
          offset.x = x;
          offset.y = y;
          (0, _utils__WEBPACK_IMPORTED_MODULE_0__.setStyle)(contentEl, {
            "-transform": "translate3d(" + -x + "px, " + -y + "px, 0)",
          });
          track.update();
          return {
            offset: (0, tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)(
              {},
              offset
            ),
            limit: (0, tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, limit),
          };
        }
        //# sourceMappingURL=set-position.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/style.js":
      /*!************************************************!*\
  !*** ./node_modules/smooth-scrollbar/style.js ***!
  \************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ attachStyle: () => /* binding */ attachStyle,
          /* harmony export */ detachStyle: () => /* binding */ detachStyle,
          /* harmony export */
        });
        var TRACK_BG = "rgba(222, 222, 222, .75)";
        var THUMB_BG = "rgba(0, 0, 0, .5)";
        // sets content's display type to `flow-root` to suppress margin collapsing
        var SCROLLBAR_STYLE =
          "\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  display: flow-root;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: " +
          TRACK_BG +
          ";\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: " +
          THUMB_BG +
          ";\n  border-radius: 4px;\n}\n";
        var STYLE_ID = "smooth-scrollbar-style";
        var isStyleAttached = false;
        function attachStyle() {
          if (isStyleAttached || typeof window === "undefined") {
            return;
          }
          var styleEl = document.createElement("style");
          styleEl.id = STYLE_ID;
          styleEl.textContent = SCROLLBAR_STYLE;
          if (document.head) {
            document.head.appendChild(styleEl);
          }
          isStyleAttached = true;
        }
        function detachStyle() {
          if (!isStyleAttached || typeof window === "undefined") {
            return;
          }
          var styleEl = document.getElementById(STYLE_ID);
          if (!styleEl || !styleEl.parentNode) {
            return;
          }
          styleEl.parentNode.removeChild(styleEl);
          isStyleAttached = false;
        }
        //# sourceMappingURL=style.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/track/direction.js":
      /*!**********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/track/direction.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ TrackDirection: () =>
            /* binding */ TrackDirection,
          /* harmony export */
        });
        var TrackDirection;
        (function (TrackDirection) {
          TrackDirection["X"] = "x";
          TrackDirection["Y"] = "y";
        })(TrackDirection || (TrackDirection = {}));
        //# sourceMappingURL=direction.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/track/index.js":
      /*!******************************************************!*\
  !*** ./node_modules/smooth-scrollbar/track/index.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ TrackController: () =>
            /* binding */ TrackController,
          /* harmony export */
        });
        /* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! tslib */ "./node_modules/smooth-scrollbar/node_modules/tslib/tslib.es6.js"
          );
        /* harmony import */ var _track__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./track */ "./node_modules/smooth-scrollbar/track/track.js"
          );
        /* harmony import */ var _direction__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./direction */ "./node_modules/smooth-scrollbar/track/direction.js"
          );
        /* harmony import */ var _decorators___WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../decorators/ */ "./node_modules/smooth-scrollbar/decorators/index.js"
          );

        var TrackController = /** @class */ (function () {
          function TrackController(_scrollbar) {
            this._scrollbar = _scrollbar;
            var thumbMinSize = _scrollbar.options.thumbMinSize;
            this.xAxis = new _track__WEBPACK_IMPORTED_MODULE_0__.ScrollbarTrack(
              _direction__WEBPACK_IMPORTED_MODULE_1__.TrackDirection.X,
              thumbMinSize
            );
            this.yAxis = new _track__WEBPACK_IMPORTED_MODULE_0__.ScrollbarTrack(
              _direction__WEBPACK_IMPORTED_MODULE_1__.TrackDirection.Y,
              thumbMinSize
            );
            this.xAxis.attachTo(_scrollbar.containerEl);
            this.yAxis.attachTo(_scrollbar.containerEl);
            if (_scrollbar.options.alwaysShowTracks) {
              this.xAxis.show();
              this.yAxis.show();
            }
          }
          /**
           * Updates track appearance
           */
          TrackController.prototype.update = function () {
            var _a = this._scrollbar,
              size = _a.size,
              offset = _a.offset;
            this.xAxis.update(
              offset.x,
              size.container.width,
              size.content.width
            );
            this.yAxis.update(
              offset.y,
              size.container.height,
              size.content.height
            );
          };
          /**
           * Automatically hide tracks when scrollbar is in idle state
           */
          TrackController.prototype.autoHideOnIdle = function () {
            if (this._scrollbar.options.alwaysShowTracks) {
              return;
            }
            this.xAxis.hide();
            this.yAxis.hide();
          };
          (0, tslib__WEBPACK_IMPORTED_MODULE_3__.__decorate)(
            [(0, _decorators___WEBPACK_IMPORTED_MODULE_2__.debounce)(300)],
            TrackController.prototype,
            "autoHideOnIdle",
            null
          );
          return TrackController;
        })();

        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/track/thumb.js":
      /*!******************************************************!*\
  !*** ./node_modules/smooth-scrollbar/track/thumb.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ ScrollbarThumb: () =>
            /* binding */ ScrollbarThumb,
          /* harmony export */
        });
        /* harmony import */ var _direction__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./direction */ "./node_modules/smooth-scrollbar/track/direction.js"
          );
        /* harmony import */ var _utils___WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../utils/ */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        var ScrollbarThumb = /** @class */ (function () {
          function ScrollbarThumb(_direction, _minSize) {
            if (_minSize === void 0) {
              _minSize = 0;
            }
            this._direction = _direction;
            this._minSize = _minSize;
            /**
             * Thumb element
             */
            this.element = document.createElement("div");
            /**
             * Display size of the thumb
             * will always be greater than `scrollbar.options.thumbMinSize`
             */
            this.displaySize = 0;
            /**
             * Actual size of the thumb
             */
            this.realSize = 0;
            /**
             * Thumb offset to the top
             */
            this.offset = 0;
            this.element.className =
              "scrollbar-thumb scrollbar-thumb-" + _direction;
          }
          /**
           * Attach to track element
           *
           * @param trackEl Track element
           */
          ScrollbarThumb.prototype.attachTo = function (trackEl) {
            trackEl.appendChild(this.element);
          };
          ScrollbarThumb.prototype.update = function (
            scrollOffset,
            containerSize,
            pageSize
          ) {
            // calculate thumb size
            // pageSize > containerSize -> scrollable
            this.realSize =
              Math.min(containerSize / pageSize, 1) * containerSize;
            this.displaySize = Math.max(this.realSize, this._minSize);
            // calculate thumb offset
            this.offset =
              (scrollOffset / pageSize) *
              (containerSize + (this.realSize - this.displaySize));
            (0, _utils___WEBPACK_IMPORTED_MODULE_1__.setStyle)(
              this.element,
              this._getStyle()
            );
          };
          ScrollbarThumb.prototype._getStyle = function () {
            switch (this._direction) {
              case _direction__WEBPACK_IMPORTED_MODULE_0__.TrackDirection.X:
                return {
                  width: this.displaySize + "px",
                  "-transform": "translate3d(" + this.offset + "px, 0, 0)",
                };
              case _direction__WEBPACK_IMPORTED_MODULE_0__.TrackDirection.Y:
                return {
                  height: this.displaySize + "px",
                  "-transform": "translate3d(0, " + this.offset + "px, 0)",
                };
              default:
                return null;
            }
          };
          return ScrollbarThumb;
        })();

        //# sourceMappingURL=thumb.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/track/track.js":
      /*!******************************************************!*\
  !*** ./node_modules/smooth-scrollbar/track/track.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ ScrollbarTrack: () =>
            /* binding */ ScrollbarTrack,
          /* harmony export */
        });
        /* harmony import */ var _thumb__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./thumb */ "./node_modules/smooth-scrollbar/track/thumb.js"
          );
        /* harmony import */ var _utils___WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../utils/ */ "./node_modules/smooth-scrollbar/utils/index.js"
          );

        var ScrollbarTrack = /** @class */ (function () {
          function ScrollbarTrack(direction, thumbMinSize) {
            if (thumbMinSize === void 0) {
              thumbMinSize = 0;
            }
            /**
             * Track element
             */
            this.element = document.createElement("div");
            this._isShown = false;
            this.element.className =
              "scrollbar-track scrollbar-track-" + direction;
            this.thumb = new _thumb__WEBPACK_IMPORTED_MODULE_0__.ScrollbarThumb(
              direction,
              thumbMinSize
            );
            this.thumb.attachTo(this.element);
          }
          /**
           * Attach to scrollbar container element
           *
           * @param scrollbarContainer Scrollbar container element
           */
          ScrollbarTrack.prototype.attachTo = function (scrollbarContainer) {
            scrollbarContainer.appendChild(this.element);
          };
          /**
           * Show track immediately
           */
          ScrollbarTrack.prototype.show = function () {
            if (this._isShown) {
              return;
            }
            this._isShown = true;
            this.element.classList.add("show");
          };
          /**
           * Hide track immediately
           */
          ScrollbarTrack.prototype.hide = function () {
            if (!this._isShown) {
              return;
            }
            this._isShown = false;
            this.element.classList.remove("show");
          };
          ScrollbarTrack.prototype.update = function (
            scrollOffset,
            containerSize,
            pageSize
          ) {
            (0, _utils___WEBPACK_IMPORTED_MODULE_1__.setStyle)(this.element, {
              display: pageSize <= containerSize ? "none" : "block",
            });
            this.thumb.update(scrollOffset, containerSize, pageSize);
          };
          return ScrollbarTrack;
        })();

        //# sourceMappingURL=track.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/utils/clamp.js":
      /*!******************************************************!*\
  !*** ./node_modules/smooth-scrollbar/utils/clamp.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ clamp: () => /* binding */ clamp,
          /* harmony export */
        });
        function clamp(value, lower, upper) {
          return Math.max(lower, Math.min(upper, value));
        }
        //# sourceMappingURL=clamp.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/utils/debounce.js":
      /*!*********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/utils/debounce.js ***!
  \*********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ debounce: () => /* binding */ debounce,
          /* harmony export */
        });
        function debounce(fn, wait, leading) {
          if (wait === void 0) {
            wait = 0;
          }
          var timer;
          var lastCalledAt = -Infinity;
          return function debouncedFn() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            if (leading) {
              var now = Date.now();
              var elapsed = now - lastCalledAt;
              lastCalledAt = now;
              if (elapsed >= wait) {
                fn.apply(this, args);
              }
            }
            clearTimeout(timer);
            timer = setTimeout(function () {
              fn.apply(_this, args);
            }, wait);
          };
        }
        //# sourceMappingURL=debounce.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/utils/event-hub.js":
      /*!**********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/utils/event-hub.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ clearEventsOn: () => /* binding */ clearEventsOn,
          /* harmony export */ eventScope: () => /* binding */ eventScope,
          /* harmony export */
        });
        var eventListenerOptions;
        var eventMap = new WeakMap();
        function getOptions() {
          if (eventListenerOptions !== undefined) {
            return eventListenerOptions;
          }
          var supportPassiveEvent = false;
          try {
            var noop = function () {};
            var options = Object.defineProperty({}, "passive", {
              enumerable: true,
              get: function () {
                supportPassiveEvent = true;
                return true;
              },
            });
            window.addEventListener("testPassive", noop, options);
            window.removeEventListener("testPassive", noop, options);
          } catch (e) {}
          eventListenerOptions = supportPassiveEvent
            ? { passive: false }
            : false;
          return eventListenerOptions;
        }
        function eventScope(scrollbar) {
          var configs = eventMap.get(scrollbar) || [];
          eventMap.set(scrollbar, configs);
          return function addEvent(elem, events, fn) {
            function handler(event) {
              // ignore default prevented events
              if (event.defaultPrevented) {
                return;
              }
              fn(event);
            }
            events.split(/\s+/g).forEach(function (eventName) {
              configs.push({
                elem: elem,
                eventName: eventName,
                handler: handler,
              });
              elem.addEventListener(eventName, handler, getOptions());
            });
          };
        }
        function clearEventsOn(scrollbar) {
          var configs = eventMap.get(scrollbar);
          if (!configs) {
            return;
          }
          configs.forEach(function (_a) {
            var elem = _a.elem,
              eventName = _a.eventName,
              handler = _a.handler;
            elem.removeEventListener(eventName, handler, getOptions());
          });
          eventMap.delete(scrollbar);
        }
        //# sourceMappingURL=event-hub.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/utils/get-pointer-data.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/smooth-scrollbar/utils/get-pointer-data.js ***!
  \*****************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ getPointerData: () =>
            /* binding */ getPointerData,
          /* harmony export */
        });
        /**
         * Get pointer/touch data
         */
        function getPointerData(evt) {
          // if is touch event, return last item in touchList
          // else return original event
          return evt.touches ? evt.touches[evt.touches.length - 1] : evt;
        }
        //# sourceMappingURL=get-pointer-data.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/utils/get-position.js":
      /*!*************************************************************!*\
  !*** ./node_modules/smooth-scrollbar/utils/get-position.js ***!
  \*************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ getPosition: () => /* binding */ getPosition,
          /* harmony export */
        });
        /* harmony import */ var _get_pointer_data__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./get-pointer-data */ "./node_modules/smooth-scrollbar/utils/get-pointer-data.js"
          );

        /**
         * Get pointer/finger position
         */
        function getPosition(evt) {
          var data = (0,
          _get_pointer_data__WEBPACK_IMPORTED_MODULE_0__.getPointerData)(evt);
          return {
            x: data.clientX,
            y: data.clientY,
          };
        }
        //# sourceMappingURL=get-position.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/utils/index.js":
      /*!******************************************************!*\
  !*** ./node_modules/smooth-scrollbar/utils/index.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ TouchRecord: () =>
            /* reexport safe */ _touch_record__WEBPACK_IMPORTED_MODULE_5__.TouchRecord,
          /* harmony export */ Tracker: () =>
            /* reexport safe */ _touch_record__WEBPACK_IMPORTED_MODULE_5__.Tracker,
          /* harmony export */ clamp: () =>
            /* reexport safe */ _clamp__WEBPACK_IMPORTED_MODULE_6__.clamp,
          /* harmony export */ clearEventsOn: () =>
            /* reexport safe */ _event_hub__WEBPACK_IMPORTED_MODULE_0__.clearEventsOn,
          /* harmony export */ debounce: () =>
            /* reexport safe */ _debounce__WEBPACK_IMPORTED_MODULE_7__.debounce,
          /* harmony export */ eventScope: () =>
            /* reexport safe */ _event_hub__WEBPACK_IMPORTED_MODULE_0__.eventScope,
          /* harmony export */ getPointerData: () =>
            /* reexport safe */ _get_pointer_data__WEBPACK_IMPORTED_MODULE_1__.getPointerData,
          /* harmony export */ getPosition: () =>
            /* reexport safe */ _get_position__WEBPACK_IMPORTED_MODULE_2__.getPosition,
          /* harmony export */ isOneOf: () =>
            /* reexport safe */ _is_one_of__WEBPACK_IMPORTED_MODULE_3__.isOneOf,
          /* harmony export */ setStyle: () =>
            /* reexport safe */ _set_style__WEBPACK_IMPORTED_MODULE_4__.setStyle,
          /* harmony export */
        });
        /* harmony import */ var _event_hub__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./event-hub */ "./node_modules/smooth-scrollbar/utils/event-hub.js"
          );
        /* harmony import */ var _get_pointer_data__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./get-pointer-data */ "./node_modules/smooth-scrollbar/utils/get-pointer-data.js"
          );
        /* harmony import */ var _get_position__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./get-position */ "./node_modules/smooth-scrollbar/utils/get-position.js"
          );
        /* harmony import */ var _is_one_of__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./is-one-of */ "./node_modules/smooth-scrollbar/utils/is-one-of.js"
          );
        /* harmony import */ var _set_style__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./set-style */ "./node_modules/smooth-scrollbar/utils/set-style.js"
          );
        /* harmony import */ var _touch_record__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./touch-record */ "./node_modules/smooth-scrollbar/utils/touch-record.js"
          );
        /* harmony import */ var _clamp__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./clamp */ "./node_modules/smooth-scrollbar/utils/clamp.js"
          );
        /* harmony import */ var _debounce__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ./debounce */ "./node_modules/smooth-scrollbar/utils/debounce.js"
          );

        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/utils/is-one-of.js":
      /*!**********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/utils/is-one-of.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ isOneOf: () => /* binding */ isOneOf,
          /* harmony export */
        });
        /**
         * Check if `a` is one of `[...b]`
         */
        function isOneOf(a, b) {
          if (b === void 0) {
            b = [];
          }
          return b.some(function (v) {
            return a === v;
          });
        }
        //# sourceMappingURL=is-one-of.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/utils/set-style.js":
      /*!**********************************************************!*\
  !*** ./node_modules/smooth-scrollbar/utils/set-style.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ setStyle: () => /* binding */ setStyle,
          /* harmony export */
        });
        var VENDOR_PREFIX = ["webkit", "moz", "ms", "o"];
        var RE = new RegExp("^-(?!(?:" + VENDOR_PREFIX.join("|") + ")-)");
        function autoPrefix(styles) {
          var res = {};
          Object.keys(styles).forEach(function (prop) {
            if (!RE.test(prop)) {
              res[prop] = styles[prop];
              return;
            }
            var val = styles[prop];
            prop = prop.replace(/^-/, "");
            res[prop] = val;
            VENDOR_PREFIX.forEach(function (prefix) {
              res["-" + prefix + "-" + prop] = val;
            });
          });
          return res;
        }
        function setStyle(elem, styles) {
          styles = autoPrefix(styles);
          Object.keys(styles).forEach(function (prop) {
            var cssProp = prop
              .replace(/^-/, "")
              .replace(/-([a-z])/g, function (_, $1) {
                return $1.toUpperCase();
              });
            elem.style[cssProp] = styles[prop];
          });
        }
        //# sourceMappingURL=set-style.js.map

        /***/
      },

    /***/ "./node_modules/smooth-scrollbar/utils/touch-record.js":
      /*!*************************************************************!*\
  !*** ./node_modules/smooth-scrollbar/utils/touch-record.js ***!
  \*************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ TouchRecord: () => /* binding */ TouchRecord,
          /* harmony export */ Tracker: () => /* binding */ Tracker,
          /* harmony export */
        });
        /* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! tslib */ "./node_modules/smooth-scrollbar/node_modules/tslib/tslib.es6.js"
          );
        /* harmony import */ var _get_position__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./get-position */ "./node_modules/smooth-scrollbar/utils/get-position.js"
          );

        var Tracker = /** @class */ (function () {
          function Tracker(touch) {
            this.velocityMultiplier = window.devicePixelRatio;
            this.updateTime = Date.now();
            this.delta = { x: 0, y: 0 };
            this.velocity = { x: 0, y: 0 };
            this.lastPosition = { x: 0, y: 0 };
            this.lastPosition = (0,
            _get_position__WEBPACK_IMPORTED_MODULE_0__.getPosition)(touch);
          }
          Tracker.prototype.update = function (touch) {
            var _a = this,
              velocity = _a.velocity,
              updateTime = _a.updateTime,
              lastPosition = _a.lastPosition;
            var now = Date.now();
            var position = (0,
            _get_position__WEBPACK_IMPORTED_MODULE_0__.getPosition)(touch);
            var delta = {
              x: -(position.x - lastPosition.x),
              y: -(position.y - lastPosition.y),
            };
            var duration = now - updateTime || 16.7;
            var vx = (delta.x / duration) * 16.7;
            var vy = (delta.y / duration) * 16.7;
            velocity.x = vx * this.velocityMultiplier;
            velocity.y = vy * this.velocityMultiplier;
            this.delta = delta;
            this.updateTime = now;
            this.lastPosition = position;
          };
          return Tracker;
        })();

        var TouchRecord = /** @class */ (function () {
          function TouchRecord() {
            this._touchList = {};
          }
          Object.defineProperty(TouchRecord.prototype, "_primitiveValue", {
            get: function () {
              return { x: 0, y: 0 };
            },
            enumerable: true,
            configurable: true,
          });
          TouchRecord.prototype.isActive = function () {
            return this._activeTouchID !== undefined;
          };
          TouchRecord.prototype.getDelta = function () {
            var tracker = this._getActiveTracker();
            if (!tracker) {
              return this._primitiveValue;
            }
            return (0, tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)(
              {},
              tracker.delta
            );
          };
          TouchRecord.prototype.getVelocity = function () {
            var tracker = this._getActiveTracker();
            if (!tracker) {
              return this._primitiveValue;
            }
            return (0, tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)(
              {},
              tracker.velocity
            );
          };
          TouchRecord.prototype.getEasingDistance = function (damping) {
            var deAcceleration = 1 - damping;
            var distance = {
              x: 0,
              y: 0,
            };
            var vel = this.getVelocity();
            Object.keys(vel).forEach(function (dir) {
              // ignore small velocity
              var v = Math.abs(vel[dir]) <= 10 ? 0 : vel[dir];
              while (v !== 0) {
                distance[dir] += v;
                v = (v * deAcceleration) | 0;
              }
            });
            return distance;
          };
          TouchRecord.prototype.track = function (evt) {
            var _this = this;
            var targetTouches = evt.targetTouches;
            Array.from(targetTouches).forEach(function (touch) {
              _this._add(touch);
            });
            return this._touchList;
          };
          TouchRecord.prototype.update = function (evt) {
            var _this = this;
            var touches = evt.touches,
              changedTouches = evt.changedTouches;
            Array.from(touches).forEach(function (touch) {
              _this._renew(touch);
            });
            this._setActiveID(changedTouches);
            return this._touchList;
          };
          TouchRecord.prototype.release = function (evt) {
            var _this = this;
            delete this._activeTouchID;
            Array.from(evt.changedTouches).forEach(function (touch) {
              _this._delete(touch);
            });
          };
          TouchRecord.prototype._add = function (touch) {
            if (this._has(touch)) {
              // reset tracker
              this._delete(touch);
            }
            var tracker = new Tracker(touch);
            this._touchList[touch.identifier] = tracker;
          };
          TouchRecord.prototype._renew = function (touch) {
            if (!this._has(touch)) {
              return;
            }
            var tracker = this._touchList[touch.identifier];
            tracker.update(touch);
          };
          TouchRecord.prototype._delete = function (touch) {
            delete this._touchList[touch.identifier];
          };
          TouchRecord.prototype._has = function (touch) {
            return this._touchList.hasOwnProperty(touch.identifier);
          };
          TouchRecord.prototype._setActiveID = function (touches) {
            this._activeTouchID = touches[touches.length - 1].identifier;
          };
          TouchRecord.prototype._getActiveTracker = function () {
            var _a = this,
              _touchList = _a._touchList,
              _activeTouchID = _a._activeTouchID;
            return _touchList[_activeTouchID];
          };
          return TouchRecord;
        })();

        //# sourceMappingURL=touch-record.js.map

        /***/
      },

    /***/ "./node_modules/@splidejs/splide/dist/css/splide.min.css":
      /*!***************************************************************!*\
  !*** ./node_modules/@splidejs/splide/dist/css/splide.min.css ***!
  \***************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! !../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"
          );
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_splide_min_css__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! !!../../../../css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!../../../../postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./splide.min.css */ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/@splidejs/splide/dist/css/splide.min.css"
          );

        var options = {};

        options.insert = "head";
        options.singleton = false;

        var update =
          _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(
            _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_splide_min_css__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ],
            options
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_splide_min_css__WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ].locals || {};

        /***/
      },

    /***/ "./node_modules/swiper/modules/navigation.css":
      /*!****************************************************!*\
  !*** ./node_modules/swiper/modules/navigation.css ***!
  \****************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! !../../style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"
          );
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_navigation_css__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! !!../../css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./navigation.css */ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/swiper/modules/navigation.css"
          );

        var options = {};

        options.insert = "head";
        options.singleton = false;

        var update =
          _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(
            _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_navigation_css__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ],
            options
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_navigation_css__WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ].locals || {};

        /***/
      },

    /***/ "./node_modules/swiper/modules/scrollbar.css":
      /*!***************************************************!*\
  !*** ./node_modules/swiper/modules/scrollbar.css ***!
  \***************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! !../../style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"
          );
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_scrollbar_css__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! !!../../css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./scrollbar.css */ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/swiper/modules/scrollbar.css"
          );

        var options = {};

        options.insert = "head";
        options.singleton = false;

        var update =
          _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(
            _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_scrollbar_css__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ],
            options
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_scrollbar_css__WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ].locals || {};

        /***/
      },

    /***/ "./node_modules/swiper/modules/thumbs.css":
      /*!************************************************!*\
  !*** ./node_modules/swiper/modules/thumbs.css ***!
  \************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! !../../style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"
          );
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_thumbs_css__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! !!../../css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./thumbs.css */ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/swiper/modules/thumbs.css"
          );

        var options = {};

        options.insert = "head";
        options.singleton = false;

        var update =
          _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(
            _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_thumbs_css__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ],
            options
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_thumbs_css__WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ].locals || {};

        /***/
      },

    /***/ "./node_modules/swiper/swiper.css":
      /*!****************************************!*\
  !*** ./node_modules/swiper/swiper.css ***!
  \****************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! !../style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"
          );
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_swiper_css__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! !!../css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!../postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./swiper.css */ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].oneOf[1].use[2]!./node_modules/swiper/swiper.css"
          );

        var options = {};

        options.insert = "head";
        options.singleton = false;

        var update =
          _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(
            _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_swiper_css__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ],
            options
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _css_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_1_postcss_loader_dist_cjs_js_ruleSet_1_rules_7_oneOf_1_use_2_swiper_css__WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ].locals || {};

        /***/
      },

    /***/ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js":
      /*!****************************************************************************!*\
  !*** ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js ***!
  \****************************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var isOldIE = (function isOldIE() {
          var memo;
          return function memorize() {
            if (typeof memo === "undefined") {
              // Test for IE <= 9 as proposed by Browserhacks
              // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
              // Tests for existence of standard globals is to allow style-loader
              // to operate correctly into non-standard environments
              // @see https://github.com/webpack-contrib/style-loader/issues/177
              memo = Boolean(
                window && document && document.all && !window.atob
              );
            }

            return memo;
          };
        })();

        var getTarget = (function getTarget() {
          var memo = {};
          return function memorize(target) {
            if (typeof memo[target] === "undefined") {
              var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

              if (
                window.HTMLIFrameElement &&
                styleTarget instanceof window.HTMLIFrameElement
              ) {
                try {
                  // This will throw an exception if access to iframe is blocked
                  // due to cross-origin restrictions
                  styleTarget = styleTarget.contentDocument.head;
                } catch (e) {
                  // istanbul ignore next
                  styleTarget = null;
                }
              }

              memo[target] = styleTarget;
            }

            return memo[target];
          };
        })();

        var stylesInDom = [];

        function getIndexByIdentifier(identifier) {
          var result = -1;

          for (var i = 0; i < stylesInDom.length; i++) {
            if (stylesInDom[i].identifier === identifier) {
              result = i;
              break;
            }
          }

          return result;
        }

        function modulesToDom(list, options) {
          var idCountMap = {};
          var identifiers = [];

          for (var i = 0; i < list.length; i++) {
            var item = list[i];
            var id = options.base ? item[0] + options.base : item[0];
            var count = idCountMap[id] || 0;
            var identifier = "".concat(id, " ").concat(count);
            idCountMap[id] = count + 1;
            var index = getIndexByIdentifier(identifier);
            var obj = {
              css: item[1],
              media: item[2],
              sourceMap: item[3],
            };

            if (index !== -1) {
              stylesInDom[index].references++;
              stylesInDom[index].updater(obj);
            } else {
              stylesInDom.push({
                identifier: identifier,
                updater: addStyle(obj, options),
                references: 1,
              });
            }

            identifiers.push(identifier);
          }

          return identifiers;
        }

        function insertStyleElement(options) {
          var style = document.createElement("style");
          var attributes = options.attributes || {};

          if (typeof attributes.nonce === "undefined") {
            var nonce = true ? __webpack_require__.nc : 0;

            if (nonce) {
              attributes.nonce = nonce;
            }
          }

          Object.keys(attributes).forEach(function (key) {
            style.setAttribute(key, attributes[key]);
          });

          if (typeof options.insert === "function") {
            options.insert(style);
          } else {
            var target = getTarget(options.insert || "head");

            if (!target) {
              throw new Error(
                "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
              );
            }

            target.appendChild(style);
          }

          return style;
        }

        function removeStyleElement(style) {
          // istanbul ignore if
          if (style.parentNode === null) {
            return false;
          }

          style.parentNode.removeChild(style);
        }
        /* istanbul ignore next  */

        var replaceText = (function replaceText() {
          var textStore = [];
          return function replace(index, replacement) {
            textStore[index] = replacement;
            return textStore.filter(Boolean).join("\n");
          };
        })();

        function applyToSingletonTag(style, index, remove, obj) {
          var css = remove
            ? ""
            : obj.media
            ? "@media ".concat(obj.media, " {").concat(obj.css, "}")
            : obj.css; // For old IE

          /* istanbul ignore if  */

          if (style.styleSheet) {
            style.styleSheet.cssText = replaceText(index, css);
          } else {
            var cssNode = document.createTextNode(css);
            var childNodes = style.childNodes;

            if (childNodes[index]) {
              style.removeChild(childNodes[index]);
            }

            if (childNodes.length) {
              style.insertBefore(cssNode, childNodes[index]);
            } else {
              style.appendChild(cssNode);
            }
          }
        }

        function applyToTag(style, options, obj) {
          var css = obj.css;
          var media = obj.media;
          var sourceMap = obj.sourceMap;

          if (media) {
            style.setAttribute("media", media);
          } else {
            style.removeAttribute("media");
          }

          if (sourceMap && typeof btoa !== "undefined") {
            css +=
              "\n/*# sourceMappingURL=data:application/json;base64,".concat(
                btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))),
                " */"
              );
          } // For old IE

          /* istanbul ignore if  */

          if (style.styleSheet) {
            style.styleSheet.cssText = css;
          } else {
            while (style.firstChild) {
              style.removeChild(style.firstChild);
            }

            style.appendChild(document.createTextNode(css));
          }
        }

        var singleton = null;
        var singletonCounter = 0;

        function addStyle(obj, options) {
          var style;
          var update;
          var remove;

          if (options.singleton) {
            var styleIndex = singletonCounter++;
            style = singleton || (singleton = insertStyleElement(options));
            update = applyToSingletonTag.bind(null, style, styleIndex, false);
            remove = applyToSingletonTag.bind(null, style, styleIndex, true);
          } else {
            style = insertStyleElement(options);
            update = applyToTag.bind(null, style, options);

            remove = function remove() {
              removeStyleElement(style);
            };
          }

          update(obj);
          return function updateStyle(newObj) {
            if (newObj) {
              if (
                newObj.css === obj.css &&
                newObj.media === obj.media &&
                newObj.sourceMap === obj.sourceMap
              ) {
                return;
              }

              update((obj = newObj));
            } else {
              remove();
            }
          };
        }

        module.exports = function (list, options) {
          options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
          // tags it will allow on a page

          if (!options.singleton && typeof options.singleton !== "boolean") {
            options.singleton = isOldIE();
          }

          list = list || [];
          var lastIdentifiers = modulesToDom(list, options);
          return function update(newList) {
            newList = newList || [];

            if (Object.prototype.toString.call(newList) !== "[object Array]") {
              return;
            }

            for (var i = 0; i < lastIdentifiers.length; i++) {
              var identifier = lastIdentifiers[i];
              var index = getIndexByIdentifier(identifier);
              stylesInDom[index].references--;
            }

            var newLastIdentifiers = modulesToDom(newList, options);

            for (var _i = 0; _i < lastIdentifiers.length; _i++) {
              var _identifier = lastIdentifiers[_i];

              var _index = getIndexByIdentifier(_identifier);

              if (stylesInDom[_index].references === 0) {
                stylesInDom[_index].updater();

                stylesInDom.splice(_index, 1);
              }
            }

            lastIdentifiers = newLastIdentifiers;
          };
        };

        /***/
      },

    /***/ "./node_modules/youtube-player/dist/FunctionStateMap.js":
      /*!**************************************************************!*\
  !*** ./node_modules/youtube-player/dist/FunctionStateMap.js ***!
  \**************************************************************/
      /***/ (module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _PlayerStates = __webpack_require__(
          /*! ./constants/PlayerStates */ "./node_modules/youtube-player/dist/constants/PlayerStates.js"
        );

        var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        exports["default"] = {
          pauseVideo: {
            acceptableStates: [
              _PlayerStates2.default.ENDED,
              _PlayerStates2.default.PAUSED,
            ],
            stateChangeRequired: false,
          },
          playVideo: {
            acceptableStates: [
              _PlayerStates2.default.ENDED,
              _PlayerStates2.default.PLAYING,
            ],
            stateChangeRequired: false,
          },
          seekTo: {
            acceptableStates: [
              _PlayerStates2.default.ENDED,
              _PlayerStates2.default.PLAYING,
              _PlayerStates2.default.PAUSED,
            ],
            stateChangeRequired: true,

            // TRICKY: `seekTo` may not cause a state change if no buffering is
            // required.
            // eslint-disable-next-line unicorn/numeric-separators-style
            timeout: 3000,
          },
        };
        module.exports = exports["default"];

        /***/
      },

    /***/ "./node_modules/youtube-player/dist/YouTubePlayer.js":
      /*!***********************************************************!*\
  !*** ./node_modules/youtube-player/dist/YouTubePlayer.js ***!
  \***********************************************************/
      /***/ (module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _debug = __webpack_require__(
          /*! debug */ "./node_modules/youtube-player/node_modules/debug/src/browser.js"
        );

        var _debug2 = _interopRequireDefault(_debug);

        var _FunctionStateMap = __webpack_require__(
          /*! ./FunctionStateMap */ "./node_modules/youtube-player/dist/FunctionStateMap.js"
        );

        var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

        var _eventNames = __webpack_require__(
          /*! ./eventNames */ "./node_modules/youtube-player/dist/eventNames.js"
        );

        var _eventNames2 = _interopRequireDefault(_eventNames);

        var _functionNames = __webpack_require__(
          /*! ./functionNames */ "./node_modules/youtube-player/dist/functionNames.js"
        );

        var _functionNames2 = _interopRequireDefault(_functionNames);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        /* eslint-disable promise/prefer-await-to-then */

        const debug = (0, _debug2.default)("youtube-player");

        const YouTubePlayer = {};

        /**
         * Construct an object that defines an event handler for all of the YouTube
         * player events. Proxy captured events through an event emitter.
         *
         * @todo Capture event parameters.
         * @see https://developers.google.com/youtube/iframe_api_reference#Events
         */
        YouTubePlayer.proxyEvents = (emitter) => {
          const events = {};

          for (const eventName of _eventNames2.default) {
            const onEventName =
              "on" + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

            events[onEventName] = (event) => {
              debug('event "%s"', onEventName, event);

              emitter.trigger(eventName, event);
            };
          }

          return events;
        };

        /**
         * Delays player API method execution until player state is ready.
         *
         * @todo Proxy all of the methods using Object.keys.
         * @todo See TRICKY below.
         * @param playerAPIReady Promise that resolves when player is ready.
         * @param strictState A flag designating whether or not to wait for
         * an acceptable state when calling supported functions.
         * @returns {object}
         */
        YouTubePlayer.promisifyPlayer = (
          playerAPIReady,
          strictState = false
        ) => {
          const functions = {};

          for (const functionName of _functionNames2.default) {
            if (strictState && _FunctionStateMap2.default[functionName]) {
              functions[functionName] = (...args) => {
                return playerAPIReady.then((player) => {
                  const stateInfo = _FunctionStateMap2.default[functionName];
                  const playerState = player.getPlayerState();

                  // eslint-disable-next-line no-warning-comments
                  // TODO: Just spread the args into the function once Babel is fixed:
                  // https://github.com/babel/babel/issues/4270
                  //
                  // eslint-disable-next-line prefer-spread
                  const value = player[functionName].apply(player, args);

                  // TRICKY: For functions like `seekTo`, a change in state must be
                  // triggered given that the resulting state could match the initial
                  // state.
                  if (
                    stateInfo.stateChangeRequired ||
                    // eslint-disable-next-line no-extra-parens
                    (Array.isArray(stateInfo.acceptableStates) &&
                      !stateInfo.acceptableStates.includes(playerState))
                  ) {
                    return new Promise((resolve) => {
                      const onPlayerStateChange = () => {
                        const playerStateAfterChange = player.getPlayerState();

                        let timeout;

                        if (typeof stateInfo.timeout === "number") {
                          timeout = setTimeout(() => {
                            player.removeEventListener(
                              "onStateChange",
                              onPlayerStateChange
                            );

                            resolve();
                          }, stateInfo.timeout);
                        }

                        if (
                          Array.isArray(stateInfo.acceptableStates) &&
                          stateInfo.acceptableStates.includes(
                            playerStateAfterChange
                          )
                        ) {
                          player.removeEventListener(
                            "onStateChange",
                            onPlayerStateChange
                          );

                          clearTimeout(timeout);

                          resolve();
                        }
                      };

                      player.addEventListener(
                        "onStateChange",
                        onPlayerStateChange
                      );
                    }).then(() => {
                      return value;
                    });
                  }

                  return value;
                });
              };
            } else {
              functions[functionName] = (...args) => {
                return playerAPIReady.then((player) => {
                  // eslint-disable-next-line no-warning-comments
                  // TODO: Just spread the args into the function once Babel is fixed:
                  // https://github.com/babel/babel/issues/4270
                  //
                  // eslint-disable-next-line prefer-spread
                  return player[functionName].apply(player, args);
                });
              };
            }
          }

          return functions;
        };

        exports["default"] = YouTubePlayer;
        module.exports = exports["default"];

        /***/
      },

    /***/ "./node_modules/youtube-player/dist/constants/PlayerStates.js":
      /*!********************************************************************!*\
  !*** ./node_modules/youtube-player/dist/constants/PlayerStates.js ***!
  \********************************************************************/
      /***/ (module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });
        exports["default"] = {
          BUFFERING: 3,
          ENDED: 0,
          PAUSED: 2,
          PLAYING: 1,
          UNSTARTED: -1,
          VIDEO_CUED: 5,
        };
        module.exports = exports["default"];

        /***/
      },

    /***/ "./node_modules/youtube-player/dist/eventNames.js":
      /*!********************************************************!*\
  !*** ./node_modules/youtube-player/dist/eventNames.js ***!
  \********************************************************/
      /***/ (module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        /**
         * @see https://developers.google.com/youtube/iframe_api_reference#Events
         * `volumeChange` is not officially supported but seems to work
         * it emits an object: `{volume: 82.6923076923077, muted: false}`
         */
        exports["default"] = [
          "ready",
          "stateChange",
          "playbackQualityChange",
          "playbackRateChange",
          "error",
          "apiChange",
          "volumeChange",
        ];
        module.exports = exports["default"];

        /***/
      },

    /***/ "./node_modules/youtube-player/dist/functionNames.js":
      /*!***********************************************************!*\
  !*** ./node_modules/youtube-player/dist/functionNames.js ***!
  \***********************************************************/
      /***/ (module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        /**
         * @see https://developers.google.com/youtube/iframe_api_reference#Functions
         */
        exports["default"] = [
          "cueVideoById",
          "loadVideoById",
          "cueVideoByUrl",
          "loadVideoByUrl",
          "playVideo",
          "pauseVideo",
          "stopVideo",
          "getVideoLoadedFraction",
          "cuePlaylist",
          "loadPlaylist",
          "nextVideo",
          "previousVideo",
          "playVideoAt",
          "setShuffle",
          "setLoop",
          "getPlaylist",
          "getPlaylistIndex",
          "setOption",
          "mute",
          "unMute",
          "isMuted",
          "setVolume",
          "getVolume",
          "seekTo",
          "getPlayerState",
          "getPlaybackRate",
          "setPlaybackRate",
          "getAvailablePlaybackRates",
          "getPlaybackQuality",
          "setPlaybackQuality",
          "getAvailableQualityLevels",
          "getCurrentTime",
          "getDuration",
          "removeEventListener",
          "getVideoUrl",
          "getVideoEmbedCode",
          "getOptions",
          "getOption",
          "addEventListener",
          "destroy",
          "setSize",
          "getIframe",
          "getSphericalProperties",
          "setSphericalProperties",
        ];
        module.exports = exports["default"];

        /***/
      },

    /***/ "./node_modules/youtube-player/dist/index.js":
      /*!***************************************************!*\
  !*** ./node_modules/youtube-player/dist/index.js ***!
  \***************************************************/
      /***/ (module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _sister = __webpack_require__(
          /*! sister */ "./node_modules/sister/src/sister.js"
        );

        var _sister2 = _interopRequireDefault(_sister);

        var _YouTubePlayer = __webpack_require__(
          /*! ./YouTubePlayer */ "./node_modules/youtube-player/dist/YouTubePlayer.js"
        );

        var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

        var _loadYouTubeIframeApi = __webpack_require__(
          /*! ./loadYouTubeIframeApi */ "./node_modules/youtube-player/dist/loadYouTubeIframeApi.js"
        );

        var _loadYouTubeIframeApi2 = _interopRequireDefault(
          _loadYouTubeIframeApi
        );

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        /**
         * @typedef YT.Player
         * @see https://developers.google.com/youtube/iframe_api_reference
         */

        /**
         * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
         */
        let youtubeIframeAPI;

        /**
         * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
         *
         * @param maybeElementId Either An existing YT.Player instance,
         * the DOM element or the id of the HTML element where the API will insert an <iframe>.
         * @param options See `options` (Ignored when using an existing YT.Player instance).
         * @param strictState A flag designating whether or not to wait for
         * an acceptable state when calling supported functions. Default: `false`.
         * See `FunctionStateMap.js` for supported functions and acceptable states.
         */

        exports["default"] = (
          maybeElementId,
          options = {},
          strictState = false
        ) => {
          const emitter = (0, _sister2.default)();

          if (!youtubeIframeAPI) {
            youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
          }

          if (options.events) {
            throw new Error("Event handlers cannot be overwritten.");
          }

          // eslint-disable-next-line unicorn/prefer-query-selector
          if (
            typeof maybeElementId === "string" &&
            !document.getElementById(maybeElementId)
          ) {
            throw new Error('Element "' + maybeElementId + '" does not exist.');
          }

          options.events = _YouTubePlayer2.default.proxyEvents(emitter);

          const playerAPIReady = new Promise((resolve) => {
            if (
              typeof maybeElementId === "object" &&
              maybeElementId.playVideo instanceof Function
            ) {
              const player = maybeElementId;

              resolve(player);
            } else {
              // asume maybeElementId can be rendered inside
              // eslint-disable-next-line promise/catch-or-return
              youtubeIframeAPI.then((YT) => {
                // eslint-disable-line promise/prefer-await-to-then
                const player = new YT.Player(maybeElementId, options);

                emitter.on("ready", () => {
                  resolve(player);
                });

                return null;
              });
            }
          });

          const playerApi = _YouTubePlayer2.default.promisifyPlayer(
            playerAPIReady,
            strictState
          );

          playerApi.on = emitter.on;
          playerApi.off = emitter.off;

          return playerApi;
        };

        module.exports = exports["default"];

        /***/
      },

    /***/ "./node_modules/youtube-player/dist/loadYouTubeIframeApi.js":
      /*!******************************************************************!*\
  !*** ./node_modules/youtube-player/dist/loadYouTubeIframeApi.js ***!
  \******************************************************************/
      /***/ (module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _loadScript = __webpack_require__(
          /*! load-script */ "./node_modules/load-script/index.js"
        );

        var _loadScript2 = _interopRequireDefault(_loadScript);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        exports["default"] = (emitter) => {
          /**
           * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
           * The promise is resolved with a reference to window.YT object.
           */
          const iframeAPIReady = new Promise((resolve) => {
            if (
              window.YT &&
              window.YT.Player &&
              window.YT.Player instanceof Function
            ) {
              resolve(window.YT);

              return;
            } else {
              const protocol =
                window.location.protocol === "http:" ? "http:" : "https:";

              (0, _loadScript2.default)(
                protocol + "//www.youtube.com/iframe_api",
                (error) => {
                  if (error) {
                    emitter.trigger("error", error);
                  }
                }
              );
            }

            const previous = window.onYouTubeIframeAPIReady;

            // The API will call this function when page has finished downloading
            // the JavaScript for the player API.
            window.onYouTubeIframeAPIReady = () => {
              if (previous) {
                previous();
              }

              resolve(window.YT);
            };
          });

          return iframeAPIReady;
        };

        module.exports = exports["default"];

        /***/
      },

    /***/ "./node_modules/youtube-player/node_modules/debug/src/browser.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/youtube-player/node_modules/debug/src/browser.js ***!
  \***********************************************************************/
      /***/ (module, exports, __webpack_require__) => {
        /* provided dependency */ var process = __webpack_require__(
          /*! process/browser.js */ "./node_modules/process/browser.js"
        );
        /* eslint-env browser */

        /**
         * This is the web browser implementation of `debug()`.
         */

        exports.formatArgs = formatArgs;
        exports.save = save;
        exports.load = load;
        exports.useColors = useColors;
        exports.storage = localstorage();
        exports.destroy = (() => {
          let warned = false;

          return () => {
            if (!warned) {
              warned = true;
              console.warn(
                "Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."
              );
            }
          };
        })();

        /**
         * Colors.
         */

        exports.colors = [
          "#0000CC",
          "#0000FF",
          "#0033CC",
          "#0033FF",
          "#0066CC",
          "#0066FF",
          "#0099CC",
          "#0099FF",
          "#00CC00",
          "#00CC33",
          "#00CC66",
          "#00CC99",
          "#00CCCC",
          "#00CCFF",
          "#3300CC",
          "#3300FF",
          "#3333CC",
          "#3333FF",
          "#3366CC",
          "#3366FF",
          "#3399CC",
          "#3399FF",
          "#33CC00",
          "#33CC33",
          "#33CC66",
          "#33CC99",
          "#33CCCC",
          "#33CCFF",
          "#6600CC",
          "#6600FF",
          "#6633CC",
          "#6633FF",
          "#66CC00",
          "#66CC33",
          "#9900CC",
          "#9900FF",
          "#9933CC",
          "#9933FF",
          "#99CC00",
          "#99CC33",
          "#CC0000",
          "#CC0033",
          "#CC0066",
          "#CC0099",
          "#CC00CC",
          "#CC00FF",
          "#CC3300",
          "#CC3333",
          "#CC3366",
          "#CC3399",
          "#CC33CC",
          "#CC33FF",
          "#CC6600",
          "#CC6633",
          "#CC9900",
          "#CC9933",
          "#CCCC00",
          "#CCCC33",
          "#FF0000",
          "#FF0033",
          "#FF0066",
          "#FF0099",
          "#FF00CC",
          "#FF00FF",
          "#FF3300",
          "#FF3333",
          "#FF3366",
          "#FF3399",
          "#FF33CC",
          "#FF33FF",
          "#FF6600",
          "#FF6633",
          "#FF9900",
          "#FF9933",
          "#FFCC00",
          "#FFCC33",
        ];

        /**
         * Currently only WebKit-based Web Inspectors, Firefox >= v31,
         * and the Firebug extension (any Firefox version) are known
         * to support "%c" CSS customizations.
         *
         * TODO: add a `localStorage` variable to explicitly enable/disable colors
         */

        // eslint-disable-next-line complexity
        function useColors() {
          // NB: In an Electron preload script, document will be defined but not fully
          // initialized. Since we know we're in Chrome, we'll just detect this case
          // explicitly
          if (
            typeof window !== "undefined" &&
            window.process &&
            (window.process.type === "renderer" || window.process.__nwjs)
          ) {
            return true;
          }

          // Internet Explorer and Edge do not support colors.
          if (
            typeof navigator !== "undefined" &&
            navigator.userAgent &&
            navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)
          ) {
            return false;
          }

          // Is webkit? http://stackoverflow.com/a/16459606/376773
          // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
          return (
            (typeof document !== "undefined" &&
              document.documentElement &&
              document.documentElement.style &&
              document.documentElement.style.WebkitAppearance) ||
            // Is firebug? http://stackoverflow.com/a/398120/376773
            (typeof window !== "undefined" &&
              window.console &&
              (window.console.firebug ||
                (window.console.exception && window.console.table))) ||
            // Is firefox >= v31?
            // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
            (typeof navigator !== "undefined" &&
              navigator.userAgent &&
              navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) &&
              parseInt(RegExp.$1, 10) >= 31) ||
            // Double check webkit in userAgent just in case we are in a worker
            (typeof navigator !== "undefined" &&
              navigator.userAgent &&
              navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/))
          );
        }

        /**
         * Colorize log arguments if enabled.
         *
         * @api public
         */

        function formatArgs(args) {
          args[0] =
            (this.useColors ? "%c" : "") +
            this.namespace +
            (this.useColors ? " %c" : " ") +
            args[0] +
            (this.useColors ? "%c " : " ") +
            "+" +
            module.exports.humanize(this.diff);

          if (!this.useColors) {
            return;
          }

          const c = "color: " + this.color;
          args.splice(1, 0, c, "color: inherit");

          // The final "%c" is somewhat tricky, because there could be other
          // arguments passed either before or after the %c, so we need to
          // figure out the correct index to insert the CSS into
          let index = 0;
          let lastC = 0;
          args[0].replace(/%[a-zA-Z%]/g, (match) => {
            if (match === "%%") {
              return;
            }
            index++;
            if (match === "%c") {
              // We only are interested in the *last* %c
              // (the user may have provided their own)
              lastC = index;
            }
          });

          args.splice(lastC, 0, c);
        }

        /**
         * Invokes `console.debug()` when available.
         * No-op when `console.debug` is not a "function".
         * If `console.debug` is not available, falls back
         * to `console.log`.
         *
         * @api public
         */
        exports.log = console.debug || console.log || (() => {});

        /**
         * Save `namespaces`.
         *
         * @param {String} namespaces
         * @api private
         */
        function save(namespaces) {
          try {
            if (namespaces) {
              exports.storage.setItem("debug", namespaces);
            } else {
              exports.storage.removeItem("debug");
            }
          } catch (error) {
            // Swallow
            // XXX (@Qix-) should we be logging these?
          }
        }

        /**
         * Load `namespaces`.
         *
         * @return {String} returns the previously persisted debug modes
         * @api private
         */
        function load() {
          let r;
          try {
            r = exports.storage.getItem("debug");
          } catch (error) {
            // Swallow
            // XXX (@Qix-) should we be logging these?
          }

          // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
          if (!r && typeof process !== "undefined" && "env" in process) {
            r = process.env.DEBUG;
          }

          return r;
        }

        /**
         * Localstorage attempts to return the localstorage.
         *
         * This is necessary because safari throws
         * when a user disables cookies/localstorage
         * and you attempt to access it.
         *
         * @return {LocalStorage}
         * @api private
         */

        function localstorage() {
          try {
            // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
            // The Browser also has localStorage in the global context.
            return localStorage;
          } catch (error) {
            // Swallow
            // XXX (@Qix-) should we be logging these?
          }
        }

        module.exports = __webpack_require__(
          /*! ./common */ "./node_modules/youtube-player/node_modules/debug/src/common.js"
        )(exports);

        const { formatters } = module.exports;

        /**
         * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
         */

        formatters.j = function (v) {
          try {
            return JSON.stringify(v);
          } catch (error) {
            return "[UnexpectedJSONParseError]: " + error.message;
          }
        };

        /***/
      },

    /***/ "./node_modules/youtube-player/node_modules/debug/src/common.js":
      /*!**********************************************************************!*\
  !*** ./node_modules/youtube-player/node_modules/debug/src/common.js ***!
  \**********************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        /**
         * This is the common logic for both the Node.js and web browser
         * implementations of `debug()`.
         */

        function setup(env) {
          createDebug.debug = createDebug;
          createDebug.default = createDebug;
          createDebug.coerce = coerce;
          createDebug.disable = disable;
          createDebug.enable = enable;
          createDebug.enabled = enabled;
          createDebug.humanize = __webpack_require__(
            /*! ms */ "./node_modules/youtube-player/node_modules/ms/index.js"
          );
          createDebug.destroy = destroy;

          Object.keys(env).forEach((key) => {
            createDebug[key] = env[key];
          });

          /**
           * The currently active debug mode names, and names to skip.
           */

          createDebug.names = [];
          createDebug.skips = [];

          /**
           * Map of special "%n" handling functions, for the debug "format" argument.
           *
           * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
           */
          createDebug.formatters = {};

          /**
           * Selects a color for a debug namespace
           * @param {String} namespace The namespace string for the debug instance to be colored
           * @return {Number|String} An ANSI color code for the given namespace
           * @api private
           */
          function selectColor(namespace) {
            let hash = 0;

            for (let i = 0; i < namespace.length; i++) {
              hash = (hash << 5) - hash + namespace.charCodeAt(i);
              hash |= 0; // Convert to 32bit integer
            }

            return createDebug.colors[
              Math.abs(hash) % createDebug.colors.length
            ];
          }
          createDebug.selectColor = selectColor;

          /**
           * Create a debugger with the given `namespace`.
           *
           * @param {String} namespace
           * @return {Function}
           * @api public
           */
          function createDebug(namespace) {
            let prevTime;
            let enableOverride = null;
            let namespacesCache;
            let enabledCache;

            function debug(...args) {
              // Disabled?
              if (!debug.enabled) {
                return;
              }

              const self = debug;

              // Set `diff` timestamp
              const curr = Number(new Date());
              const ms = curr - (prevTime || curr);
              self.diff = ms;
              self.prev = prevTime;
              self.curr = curr;
              prevTime = curr;

              args[0] = createDebug.coerce(args[0]);

              if (typeof args[0] !== "string") {
                // Anything else let's inspect with %O
                args.unshift("%O");
              }

              // Apply any `formatters` transformations
              let index = 0;
              args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") {
                  return "%";
                }
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                  const val = args[index];
                  match = formatter.call(self, val);

                  // Now we need to remove `args[index]` since it's inlined in the `format`
                  args.splice(index, 1);
                  index--;
                }
                return match;
              });

              // Apply env-specific formatting (colors, etc.)
              createDebug.formatArgs.call(self, args);

              const logFn = self.log || createDebug.log;
              logFn.apply(self, args);
            }

            debug.namespace = namespace;
            debug.useColors = createDebug.useColors();
            debug.color = createDebug.selectColor(namespace);
            debug.extend = extend;
            debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

            Object.defineProperty(debug, "enabled", {
              enumerable: true,
              configurable: false,
              get: () => {
                if (enableOverride !== null) {
                  return enableOverride;
                }
                if (namespacesCache !== createDebug.namespaces) {
                  namespacesCache = createDebug.namespaces;
                  enabledCache = createDebug.enabled(namespace);
                }

                return enabledCache;
              },
              set: (v) => {
                enableOverride = v;
              },
            });

            // Env-specific initialization logic for debug instances
            if (typeof createDebug.init === "function") {
              createDebug.init(debug);
            }

            return debug;
          }

          function extend(namespace, delimiter) {
            const newDebug = createDebug(
              this.namespace +
                (typeof delimiter === "undefined" ? ":" : delimiter) +
                namespace
            );
            newDebug.log = this.log;
            return newDebug;
          }

          /**
           * Enables a debug mode by namespaces. This can include modes
           * separated by a colon and wildcards.
           *
           * @param {String} namespaces
           * @api public
           */
          function enable(namespaces) {
            createDebug.save(namespaces);
            createDebug.namespaces = namespaces;

            createDebug.names = [];
            createDebug.skips = [];

            let i;
            const split = (
              typeof namespaces === "string" ? namespaces : ""
            ).split(/[\s,]+/);
            const len = split.length;

            for (i = 0; i < len; i++) {
              if (!split[i]) {
                // ignore empty strings
                continue;
              }

              namespaces = split[i].replace(/\*/g, ".*?");

              if (namespaces[0] === "-") {
                createDebug.skips.push(
                  new RegExp("^" + namespaces.slice(1) + "$")
                );
              } else {
                createDebug.names.push(new RegExp("^" + namespaces + "$"));
              }
            }
          }

          /**
           * Disable debug output.
           *
           * @return {String} namespaces
           * @api public
           */
          function disable() {
            const namespaces = [
              ...createDebug.names.map(toNamespace),
              ...createDebug.skips
                .map(toNamespace)
                .map((namespace) => "-" + namespace),
            ].join(",");
            createDebug.enable("");
            return namespaces;
          }

          /**
           * Returns true if the given mode name is enabled, false otherwise.
           *
           * @param {String} name
           * @return {Boolean}
           * @api public
           */
          function enabled(name) {
            if (name[name.length - 1] === "*") {
              return true;
            }

            let i;
            let len;

            for (i = 0, len = createDebug.skips.length; i < len; i++) {
              if (createDebug.skips[i].test(name)) {
                return false;
              }
            }

            for (i = 0, len = createDebug.names.length; i < len; i++) {
              if (createDebug.names[i].test(name)) {
                return true;
              }
            }

            return false;
          }

          /**
           * Convert regexp to namespace
           *
           * @param {RegExp} regxep
           * @return {String} namespace
           * @api private
           */
          function toNamespace(regexp) {
            return regexp
              .toString()
              .substring(2, regexp.toString().length - 2)
              .replace(/\.\*\?$/, "*");
          }

          /**
           * Coerce `val`.
           *
           * @param {Mixed} val
           * @return {Mixed}
           * @api private
           */
          function coerce(val) {
            if (val instanceof Error) {
              return val.stack || val.message;
            }
            return val;
          }

          /**
           * XXX DO NOT USE. This is a temporary stub function.
           * XXX It WILL be removed in the next major release.
           */
          function destroy() {
            console.warn(
              "Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."
            );
          }

          createDebug.enable(createDebug.load());

          return createDebug;
        }

        module.exports = setup;

        /***/
      },

    /***/ "./node_modules/youtube-player/node_modules/ms/index.js":
      /*!**************************************************************!*\
  !*** ./node_modules/youtube-player/node_modules/ms/index.js ***!
  \**************************************************************/
      /***/ (module) => {
        /**
         * Helpers.
         */

        var s = 1000;
        var m = s * 60;
        var h = m * 60;
        var d = h * 24;
        var w = d * 7;
        var y = d * 365.25;

        /**
         * Parse or format the given `val`.
         *
         * Options:
         *
         *  - `long` verbose formatting [false]
         *
         * @param {String|Number} val
         * @param {Object} [options]
         * @throws {Error} throw an error if val is not a non-empty string or a number
         * @return {String|Number}
         * @api public
         */

        module.exports = function (val, options) {
          options = options || {};
          var type = typeof val;
          if (type === "string" && val.length > 0) {
            return parse(val);
          } else if (type === "number" && isFinite(val)) {
            return options.long ? fmtLong(val) : fmtShort(val);
          }
          throw new Error(
            "val is not a non-empty string or a valid number. val=" +
              JSON.stringify(val)
          );
        };

        /**
         * Parse the given `str` and return milliseconds.
         *
         * @param {String} str
         * @return {Number}
         * @api private
         */

        function parse(str) {
          str = String(str);
          if (str.length > 100) {
            return;
          }
          var match =
            /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
              str
            );
          if (!match) {
            return;
          }
          var n = parseFloat(match[1]);
          var type = (match[2] || "ms").toLowerCase();
          switch (type) {
            case "years":
            case "year":
            case "yrs":
            case "yr":
            case "y":
              return n * y;
            case "weeks":
            case "week":
            case "w":
              return n * w;
            case "days":
            case "day":
            case "d":
              return n * d;
            case "hours":
            case "hour":
            case "hrs":
            case "hr":
            case "h":
              return n * h;
            case "minutes":
            case "minute":
            case "mins":
            case "min":
            case "m":
              return n * m;
            case "seconds":
            case "second":
            case "secs":
            case "sec":
            case "s":
              return n * s;
            case "milliseconds":
            case "millisecond":
            case "msecs":
            case "msec":
            case "ms":
              return n;
            default:
              return undefined;
          }
        }

        /**
         * Short format for `ms`.
         *
         * @param {Number} ms
         * @return {String}
         * @api private
         */

        function fmtShort(ms) {
          var msAbs = Math.abs(ms);
          if (msAbs >= d) {
            return Math.round(ms / d) + "d";
          }
          if (msAbs >= h) {
            return Math.round(ms / h) + "h";
          }
          if (msAbs >= m) {
            return Math.round(ms / m) + "m";
          }
          if (msAbs >= s) {
            return Math.round(ms / s) + "s";
          }
          return ms + "ms";
        }

        /**
         * Long format for `ms`.
         *
         * @param {Number} ms
         * @return {String}
         * @api private
         */

        function fmtLong(ms) {
          var msAbs = Math.abs(ms);
          if (msAbs >= d) {
            return plural(ms, msAbs, d, "day");
          }
          if (msAbs >= h) {
            return plural(ms, msAbs, h, "hour");
          }
          if (msAbs >= m) {
            return plural(ms, msAbs, m, "minute");
          }
          if (msAbs >= s) {
            return plural(ms, msAbs, s, "second");
          }
          return ms + " ms";
        }

        /**
         * Pluralization helper.
         */

        function plural(ms, msAbs, n, name) {
          var isPlural = msAbs >= n * 1.5;
          return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
        }

        /***/
      },

    /***/ "./node_modules/core-js/es/array/from.js":
      /*!***********************************************!*\
  !*** ./node_modules/core-js/es/array/from.js ***!
  \***********************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        __webpack_require__(
          /*! ../../modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js"
        );
        __webpack_require__(
          /*! ../../modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js"
        );
        var path = __webpack_require__(
          /*! ../../internals/path */ "./node_modules/core-js/internals/path.js"
        );

        module.exports = path.Array.from;

        /***/
      },

    /***/ "./node_modules/core-js/es/map/index.js":
      /*!**********************************************!*\
  !*** ./node_modules/core-js/es/map/index.js ***!
  \**********************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        __webpack_require__(
          /*! ../../modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js"
        );
        __webpack_require__(
          /*! ../../modules/es.map */ "./node_modules/core-js/modules/es.map.js"
        );
        __webpack_require__(
          /*! ../../modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js"
        );
        __webpack_require__(
          /*! ../../modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js"
        );
        var path = __webpack_require__(
          /*! ../../internals/path */ "./node_modules/core-js/internals/path.js"
        );

        module.exports = path.Map;

        /***/
      },

    /***/ "./node_modules/core-js/es/object/assign.js":
      /*!**************************************************!*\
  !*** ./node_modules/core-js/es/object/assign.js ***!
  \**************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        __webpack_require__(
          /*! ../../modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js"
        );
        var path = __webpack_require__(
          /*! ../../internals/path */ "./node_modules/core-js/internals/path.js"
        );

        module.exports = path.Object.assign;

        /***/
      },

    /***/ "./node_modules/core-js/es/set/index.js":
      /*!**********************************************!*\
  !*** ./node_modules/core-js/es/set/index.js ***!
  \**********************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        __webpack_require__(
          /*! ../../modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js"
        );
        __webpack_require__(
          /*! ../../modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js"
        );
        __webpack_require__(
          /*! ../../modules/es.set */ "./node_modules/core-js/modules/es.set.js"
        );
        __webpack_require__(
          /*! ../../modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js"
        );
        var path = __webpack_require__(
          /*! ../../internals/path */ "./node_modules/core-js/internals/path.js"
        );

        module.exports = path.Set;

        /***/
      },

    /***/ "./node_modules/core-js/es/weak-map/index.js":
      /*!***************************************************!*\
  !*** ./node_modules/core-js/es/weak-map/index.js ***!
  \***************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        __webpack_require__(
          /*! ../../modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js"
        );
        __webpack_require__(
          /*! ../../modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js"
        );
        __webpack_require__(
          /*! ../../modules/es.weak-map */ "./node_modules/core-js/modules/es.weak-map.js"
        );
        var path = __webpack_require__(
          /*! ../../internals/path */ "./node_modules/core-js/internals/path.js"
        );

        module.exports = path.WeakMap;

        /***/
      },

    /***/ "./node_modules/core-js/internals/a-callable.js":
      /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/a-callable.js ***!
  \******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var tryToString = __webpack_require__(
          /*! ../internals/try-to-string */ "./node_modules/core-js/internals/try-to-string.js"
        );

        var $TypeError = TypeError;

        // `Assert: IsCallable(argument) is true`
        module.exports = function (argument) {
          if (isCallable(argument)) return argument;
          throw new $TypeError(tryToString(argument) + " is not a function");
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/a-possible-prototype.js":
      /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/a-possible-prototype.js ***!
  \****************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );

        var $String = String;
        var $TypeError = TypeError;

        module.exports = function (argument) {
          if (typeof argument == "object" || isCallable(argument))
            return argument;
          throw new $TypeError(
            "Can't set " + $String(argument) + " as a prototype"
          );
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/add-to-unscopables.js":
      /*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/add-to-unscopables.js ***!
  \**************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var wellKnownSymbol = __webpack_require__(
          /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
        );
        var create = __webpack_require__(
          /*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js"
        );
        var defineProperty = __webpack_require__(
          /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
        ).f;

        var UNSCOPABLES = wellKnownSymbol("unscopables");
        var ArrayPrototype = Array.prototype;

        // Array.prototype[@@unscopables]
        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        if (ArrayPrototype[UNSCOPABLES] === undefined) {
          defineProperty(ArrayPrototype, UNSCOPABLES, {
            configurable: true,
            value: create(null),
          });
        }

        // add a key to Array.prototype[@@unscopables]
        module.exports = function (key) {
          ArrayPrototype[UNSCOPABLES][key] = true;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/an-instance.js":
      /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/an-instance.js ***!
  \*******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var isPrototypeOf = __webpack_require__(
          /*! ../internals/object-is-prototype-of */ "./node_modules/core-js/internals/object-is-prototype-of.js"
        );

        var $TypeError = TypeError;

        module.exports = function (it, Prototype) {
          if (isPrototypeOf(Prototype, it)) return it;
          throw new $TypeError("Incorrect invocation");
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/an-object.js":
      /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/an-object.js ***!
  \*****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );

        var $String = String;
        var $TypeError = TypeError;

        // `Assert: Type(argument) is Object`
        module.exports = function (argument) {
          if (isObject(argument)) return argument;
          throw new $TypeError($String(argument) + " is not an object");
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/array-buffer-non-extensible.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/array-buffer-non-extensible.js ***!
  \***********************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        // FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );

        module.exports = fails(function () {
          if (typeof ArrayBuffer == "function") {
            var buffer = new ArrayBuffer(8);
            // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
            if (Object.isExtensible(buffer))
              Object.defineProperty(buffer, "a", { value: 8 });
          }
        });

        /***/
      },

    /***/ "./node_modules/core-js/internals/array-from.js":
      /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/array-from.js ***!
  \******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var bind = __webpack_require__(
          /*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js"
        );
        var call = __webpack_require__(
          /*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js"
        );
        var toObject = __webpack_require__(
          /*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js"
        );
        var callWithSafeIterationClosing = __webpack_require__(
          /*! ../internals/call-with-safe-iteration-closing */ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js"
        );
        var isArrayIteratorMethod = __webpack_require__(
          /*! ../internals/is-array-iterator-method */ "./node_modules/core-js/internals/is-array-iterator-method.js"
        );
        var isConstructor = __webpack_require__(
          /*! ../internals/is-constructor */ "./node_modules/core-js/internals/is-constructor.js"
        );
        var lengthOfArrayLike = __webpack_require__(
          /*! ../internals/length-of-array-like */ "./node_modules/core-js/internals/length-of-array-like.js"
        );
        var createProperty = __webpack_require__(
          /*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js"
        );
        var getIterator = __webpack_require__(
          /*! ../internals/get-iterator */ "./node_modules/core-js/internals/get-iterator.js"
        );
        var getIteratorMethod = __webpack_require__(
          /*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js"
        );

        var $Array = Array;

        // `Array.from` method implementation
        // https://tc39.es/ecma262/#sec-array.from
        module.exports = function from(
          arrayLike /* , mapfn = undefined, thisArg = undefined */
        ) {
          var O = toObject(arrayLike);
          var IS_CONSTRUCTOR = isConstructor(this);
          var argumentsLength = arguments.length;
          var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
          var mapping = mapfn !== undefined;
          if (mapping)
            mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
          var iteratorMethod = getIteratorMethod(O);
          var index = 0;
          var length, result, step, iterator, next, value;
          // if the target is not iterable or it's an array with the default iterator - use a simple case
          if (
            iteratorMethod &&
            !(this === $Array && isArrayIteratorMethod(iteratorMethod))
          ) {
            iterator = getIterator(O, iteratorMethod);
            next = iterator.next;
            result = IS_CONSTRUCTOR ? new this() : [];
            for (; !(step = call(next, iterator)).done; index++) {
              value = mapping
                ? callWithSafeIterationClosing(
                    iterator,
                    mapfn,
                    [step.value, index],
                    true
                  )
                : step.value;
              createProperty(result, index, value);
            }
          } else {
            length = lengthOfArrayLike(O);
            result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
            for (; length > index; index++) {
              value = mapping ? mapfn(O[index], index) : O[index];
              createProperty(result, index, value);
            }
          }
          result.length = index;
          return result;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/array-includes.js":
      /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/array-includes.js ***!
  \**********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var toIndexedObject = __webpack_require__(
          /*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js"
        );
        var toAbsoluteIndex = __webpack_require__(
          /*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js"
        );
        var lengthOfArrayLike = __webpack_require__(
          /*! ../internals/length-of-array-like */ "./node_modules/core-js/internals/length-of-array-like.js"
        );

        // `Array.prototype.{ indexOf, includes }` methods implementation
        var createMethod = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIndexedObject($this);
            var length = lengthOfArrayLike(O);
            var index = toAbsoluteIndex(fromIndex, length);
            var value;
            // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare -- NaN check
            if (IS_INCLUDES && el !== el)
              while (length > index) {
                value = O[index++];
                // eslint-disable-next-line no-self-compare -- NaN check
                if (value !== value) return true;
                // Array#indexOf ignores holes, Array#includes - not
              }
            else
              for (; length > index; index++) {
                if ((IS_INCLUDES || index in O) && O[index] === el)
                  return IS_INCLUDES || index || 0;
              }
            return !IS_INCLUDES && -1;
          };
        };

        module.exports = {
          // `Array.prototype.includes` method
          // https://tc39.es/ecma262/#sec-array.prototype.includes
          includes: createMethod(true),
          // `Array.prototype.indexOf` method
          // https://tc39.es/ecma262/#sec-array.prototype.indexof
          indexOf: createMethod(false),
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/array-iteration.js":
      /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/array-iteration.js ***!
  \***********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var bind = __webpack_require__(
          /*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js"
        );
        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var IndexedObject = __webpack_require__(
          /*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js"
        );
        var toObject = __webpack_require__(
          /*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js"
        );
        var lengthOfArrayLike = __webpack_require__(
          /*! ../internals/length-of-array-like */ "./node_modules/core-js/internals/length-of-array-like.js"
        );
        var arraySpeciesCreate = __webpack_require__(
          /*! ../internals/array-species-create */ "./node_modules/core-js/internals/array-species-create.js"
        );

        var push = uncurryThis([].push);

        // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
        var createMethod = function (TYPE) {
          var IS_MAP = TYPE === 1;
          var IS_FILTER = TYPE === 2;
          var IS_SOME = TYPE === 3;
          var IS_EVERY = TYPE === 4;
          var IS_FIND_INDEX = TYPE === 6;
          var IS_FILTER_REJECT = TYPE === 7;
          var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
          return function ($this, callbackfn, that, specificCreate) {
            var O = toObject($this);
            var self = IndexedObject(O);
            var boundFunction = bind(callbackfn, that);
            var length = lengthOfArrayLike(self);
            var index = 0;
            var create = specificCreate || arraySpeciesCreate;
            var target = IS_MAP
              ? create($this, length)
              : IS_FILTER || IS_FILTER_REJECT
              ? create($this, 0)
              : undefined;
            var value, result;
            for (; length > index; index++)
              if (NO_HOLES || index in self) {
                value = self[index];
                result = boundFunction(value, index, O);
                if (TYPE) {
                  if (IS_MAP) target[index] = result; // map
                  else if (result)
                    switch (TYPE) {
                      case 3:
                        return true; // some
                      case 5:
                        return value; // find
                      case 6:
                        return index; // findIndex
                      case 2:
                        push(target, value); // filter
                    }
                  else
                    switch (TYPE) {
                      case 4:
                        return false; // every
                      case 7:
                        push(target, value); // filterReject
                    }
                }
              }
            return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
          };
        };

        module.exports = {
          // `Array.prototype.forEach` method
          // https://tc39.es/ecma262/#sec-array.prototype.foreach
          forEach: createMethod(0),
          // `Array.prototype.map` method
          // https://tc39.es/ecma262/#sec-array.prototype.map
          map: createMethod(1),
          // `Array.prototype.filter` method
          // https://tc39.es/ecma262/#sec-array.prototype.filter
          filter: createMethod(2),
          // `Array.prototype.some` method
          // https://tc39.es/ecma262/#sec-array.prototype.some
          some: createMethod(3),
          // `Array.prototype.every` method
          // https://tc39.es/ecma262/#sec-array.prototype.every
          every: createMethod(4),
          // `Array.prototype.find` method
          // https://tc39.es/ecma262/#sec-array.prototype.find
          find: createMethod(5),
          // `Array.prototype.findIndex` method
          // https://tc39.es/ecma262/#sec-array.prototype.findIndex
          findIndex: createMethod(6),
          // `Array.prototype.filterReject` method
          // https://github.com/tc39/proposal-array-filtering
          filterReject: createMethod(7),
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/array-slice-simple.js":
      /*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/array-slice-simple.js ***!
  \**************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var toAbsoluteIndex = __webpack_require__(
          /*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js"
        );
        var lengthOfArrayLike = __webpack_require__(
          /*! ../internals/length-of-array-like */ "./node_modules/core-js/internals/length-of-array-like.js"
        );
        var createProperty = __webpack_require__(
          /*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js"
        );

        var $Array = Array;
        var max = Math.max;

        module.exports = function (O, start, end) {
          var length = lengthOfArrayLike(O);
          var k = toAbsoluteIndex(start, length);
          var fin = toAbsoluteIndex(end === undefined ? length : end, length);
          var result = $Array(max(fin - k, 0));
          var n = 0;
          for (; k < fin; k++, n++) createProperty(result, n, O[k]);
          result.length = n;
          return result;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/array-species-constructor.js":
      /*!*********************************************************************!*\
  !*** ./node_modules/core-js/internals/array-species-constructor.js ***!
  \*********************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var isArray = __webpack_require__(
          /*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js"
        );
        var isConstructor = __webpack_require__(
          /*! ../internals/is-constructor */ "./node_modules/core-js/internals/is-constructor.js"
        );
        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );
        var wellKnownSymbol = __webpack_require__(
          /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
        );

        var SPECIES = wellKnownSymbol("species");
        var $Array = Array;

        // a part of `ArraySpeciesCreate` abstract operation
        // https://tc39.es/ecma262/#sec-arrayspeciescreate
        module.exports = function (originalArray) {
          var C;
          if (isArray(originalArray)) {
            C = originalArray.constructor;
            // cross-realm fallback
            if (isConstructor(C) && (C === $Array || isArray(C.prototype)))
              C = undefined;
            else if (isObject(C)) {
              C = C[SPECIES];
              if (C === null) C = undefined;
            }
          }
          return C === undefined ? $Array : C;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/array-species-create.js":
      /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/array-species-create.js ***!
  \****************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var arraySpeciesConstructor = __webpack_require__(
          /*! ../internals/array-species-constructor */ "./node_modules/core-js/internals/array-species-constructor.js"
        );

        // `ArraySpeciesCreate` abstract operation
        // https://tc39.es/ecma262/#sec-arrayspeciescreate
        module.exports = function (originalArray, length) {
          return new (arraySpeciesConstructor(originalArray))(
            length === 0 ? 0 : length
          );
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js":
      /*!****************************************************************************!*\
  !*** ./node_modules/core-js/internals/call-with-safe-iteration-closing.js ***!
  \****************************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var anObject = __webpack_require__(
          /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
        );
        var iteratorClose = __webpack_require__(
          /*! ../internals/iterator-close */ "./node_modules/core-js/internals/iterator-close.js"
        );

        // call something on iterator step with safe closing on error
        module.exports = function (iterator, fn, value, ENTRIES) {
          try {
            return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
          } catch (error) {
            iteratorClose(iterator, "throw", error);
          }
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/check-correctness-of-iteration.js":
      /*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/check-correctness-of-iteration.js ***!
  \**************************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var wellKnownSymbol = __webpack_require__(
          /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
        );

        var ITERATOR = wellKnownSymbol("iterator");
        var SAFE_CLOSING = false;

        try {
          var called = 0;
          var iteratorWithReturn = {
            next: function () {
              return { done: !!called++ };
            },
            return: function () {
              SAFE_CLOSING = true;
            },
          };
          iteratorWithReturn[ITERATOR] = function () {
            return this;
          };
          // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
          Array.from(iteratorWithReturn, function () {
            throw 2;
          });
        } catch (error) {
          /* empty */
        }

        module.exports = function (exec, SKIP_CLOSING) {
          try {
            if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
          } catch (error) {
            return false;
          } // workaround of old WebKit + `eval` bug
          var ITERATION_SUPPORT = false;
          try {
            var object = {};
            object[ITERATOR] = function () {
              return {
                next: function () {
                  return { done: (ITERATION_SUPPORT = true) };
                },
              };
            };
            exec(object);
          } catch (error) {
            /* empty */
          }
          return ITERATION_SUPPORT;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/classof-raw.js":
      /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/classof-raw.js ***!
  \*******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );

        var toString = uncurryThis({}.toString);
        var stringSlice = uncurryThis("".slice);

        module.exports = function (it) {
          return stringSlice(toString(it), 8, -1);
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/classof.js":
      /*!***************************************************!*\
  !*** ./node_modules/core-js/internals/classof.js ***!
  \***************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var TO_STRING_TAG_SUPPORT = __webpack_require__(
          /*! ../internals/to-string-tag-support */ "./node_modules/core-js/internals/to-string-tag-support.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var classofRaw = __webpack_require__(
          /*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js"
        );
        var wellKnownSymbol = __webpack_require__(
          /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
        );

        var TO_STRING_TAG = wellKnownSymbol("toStringTag");
        var $Object = Object;

        // ES3 wrong here
        var CORRECT_ARGUMENTS =
          classofRaw(
            (function () {
              return arguments;
            })()
          ) === "Arguments";

        // fallback for IE11 Script Access Denied error
        var tryGet = function (it, key) {
          try {
            return it[key];
          } catch (error) {
            /* empty */
          }
        };

        // getting tag from ES6+ `Object.prototype.toString`
        module.exports = TO_STRING_TAG_SUPPORT
          ? classofRaw
          : function (it) {
              var O, tag, result;
              return it === undefined
                ? "Undefined"
                : it === null
                ? "Null"
                : // @@toStringTag case
                typeof (tag = tryGet((O = $Object(it)), TO_STRING_TAG)) ==
                  "string"
                ? tag
                : // builtinTag case
                CORRECT_ARGUMENTS
                ? classofRaw(O)
                : // ES3 arguments fallback
                (result = classofRaw(O)) === "Object" && isCallable(O.callee)
                ? "Arguments"
                : result;
            };

        /***/
      },

    /***/ "./node_modules/core-js/internals/collection-strong.js":
      /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/collection-strong.js ***!
  \*************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var create = __webpack_require__(
          /*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js"
        );
        var defineBuiltInAccessor = __webpack_require__(
          /*! ../internals/define-built-in-accessor */ "./node_modules/core-js/internals/define-built-in-accessor.js"
        );
        var defineBuiltIns = __webpack_require__(
          /*! ../internals/define-built-ins */ "./node_modules/core-js/internals/define-built-ins.js"
        );
        var bind = __webpack_require__(
          /*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js"
        );
        var anInstance = __webpack_require__(
          /*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js"
        );
        var isNullOrUndefined = __webpack_require__(
          /*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js"
        );
        var iterate = __webpack_require__(
          /*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js"
        );
        var defineIterator = __webpack_require__(
          /*! ../internals/iterator-define */ "./node_modules/core-js/internals/iterator-define.js"
        );
        var createIterResultObject = __webpack_require__(
          /*! ../internals/create-iter-result-object */ "./node_modules/core-js/internals/create-iter-result-object.js"
        );
        var setSpecies = __webpack_require__(
          /*! ../internals/set-species */ "./node_modules/core-js/internals/set-species.js"
        );
        var DESCRIPTORS = __webpack_require__(
          /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
        );
        var fastKey = __webpack_require__(
          /*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js"
        ).fastKey;
        var InternalStateModule = __webpack_require__(
          /*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js"
        );

        var setInternalState = InternalStateModule.set;
        var internalStateGetterFor = InternalStateModule.getterFor;

        module.exports = {
          getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
            var Constructor = wrapper(function (that, iterable) {
              anInstance(that, Prototype);
              setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: create(null),
                first: undefined,
                last: undefined,
                size: 0,
              });
              if (!DESCRIPTORS) that.size = 0;
              if (!isNullOrUndefined(iterable))
                iterate(iterable, that[ADDER], {
                  that: that,
                  AS_ENTRIES: IS_MAP,
                });
            });

            var Prototype = Constructor.prototype;

            var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

            var define = function (that, key, value) {
              var state = getInternalState(that);
              var entry = getEntry(that, key);
              var previous, index;
              // change existing entry
              if (entry) {
                entry.value = value;
                // create new entry
              } else {
                state.last = entry = {
                  index: (index = fastKey(key, true)),
                  key: key,
                  value: value,
                  previous: (previous = state.last),
                  next: undefined,
                  removed: false,
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if (DESCRIPTORS) state.size++;
                else that.size++;
                // add to index
                if (index !== "F") state.index[index] = entry;
              }
              return that;
            };

            var getEntry = function (that, key) {
              var state = getInternalState(that);
              // fast case
              var index = fastKey(key);
              var entry;
              if (index !== "F") return state.index[index];
              // frozen object case
              for (entry = state.first; entry; entry = entry.next) {
                if (entry.key === key) return entry;
              }
            };

            defineBuiltIns(Prototype, {
              // `{ Map, Set }.prototype.clear()` methods
              // https://tc39.es/ecma262/#sec-map.prototype.clear
              // https://tc39.es/ecma262/#sec-set.prototype.clear
              clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var data = state.index;
                var entry = state.first;
                while (entry) {
                  entry.removed = true;
                  if (entry.previous)
                    entry.previous = entry.previous.next = undefined;
                  delete data[entry.index];
                  entry = entry.next;
                }
                state.first = state.last = undefined;
                if (DESCRIPTORS) state.size = 0;
                else that.size = 0;
              },
              // `{ Map, Set }.prototype.delete(key)` methods
              // https://tc39.es/ecma262/#sec-map.prototype.delete
              // https://tc39.es/ecma262/#sec-set.prototype.delete
              delete: function (key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                  var next = entry.next;
                  var prev = entry.previous;
                  delete state.index[entry.index];
                  entry.removed = true;
                  if (prev) prev.next = next;
                  if (next) next.previous = prev;
                  if (state.first === entry) state.first = next;
                  if (state.last === entry) state.last = prev;
                  if (DESCRIPTORS) state.size--;
                  else that.size--;
                }
                return !!entry;
              },
              // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
              // https://tc39.es/ecma262/#sec-map.prototype.foreach
              // https://tc39.es/ecma262/#sec-set.prototype.foreach
              forEach: function forEach(callbackfn /* , that = undefined */) {
                var state = getInternalState(this);
                var boundFunction = bind(
                  callbackfn,
                  arguments.length > 1 ? arguments[1] : undefined
                );
                var entry;
                while ((entry = entry ? entry.next : state.first)) {
                  boundFunction(entry.value, entry.key, this);
                  // revert to the last existing entry
                  while (entry && entry.removed) entry = entry.previous;
                }
              },
              // `{ Map, Set}.prototype.has(key)` methods
              // https://tc39.es/ecma262/#sec-map.prototype.has
              // https://tc39.es/ecma262/#sec-set.prototype.has
              has: function has(key) {
                return !!getEntry(this, key);
              },
            });

            defineBuiltIns(
              Prototype,
              IS_MAP
                ? {
                    // `Map.prototype.get(key)` method
                    // https://tc39.es/ecma262/#sec-map.prototype.get
                    get: function get(key) {
                      var entry = getEntry(this, key);
                      return entry && entry.value;
                    },
                    // `Map.prototype.set(key, value)` method
                    // https://tc39.es/ecma262/#sec-map.prototype.set
                    set: function set(key, value) {
                      return define(this, key === 0 ? 0 : key, value);
                    },
                  }
                : {
                    // `Set.prototype.add(value)` method
                    // https://tc39.es/ecma262/#sec-set.prototype.add
                    add: function add(value) {
                      return define(
                        this,
                        (value = value === 0 ? 0 : value),
                        value
                      );
                    },
                  }
            );
            if (DESCRIPTORS)
              defineBuiltInAccessor(Prototype, "size", {
                configurable: true,
                get: function () {
                  return getInternalState(this).size;
                },
              });
            return Constructor;
          },
          setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
            var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
            var getInternalCollectionState =
              internalStateGetterFor(CONSTRUCTOR_NAME);
            var getInternalIteratorState =
              internalStateGetterFor(ITERATOR_NAME);
            // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.entries
            // https://tc39.es/ecma262/#sec-map.prototype.keys
            // https://tc39.es/ecma262/#sec-map.prototype.values
            // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
            // https://tc39.es/ecma262/#sec-set.prototype.entries
            // https://tc39.es/ecma262/#sec-set.prototype.keys
            // https://tc39.es/ecma262/#sec-set.prototype.values
            // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
            defineIterator(
              Constructor,
              CONSTRUCTOR_NAME,
              function (iterated, kind) {
                setInternalState(this, {
                  type: ITERATOR_NAME,
                  target: iterated,
                  state: getInternalCollectionState(iterated),
                  kind: kind,
                  last: undefined,
                });
              },
              function () {
                var state = getInternalIteratorState(this);
                var kind = state.kind;
                var entry = state.last;
                // revert to the last existing entry
                while (entry && entry.removed) entry = entry.previous;
                // get next entry
                if (
                  !state.target ||
                  !(state.last = entry = entry ? entry.next : state.state.first)
                ) {
                  // or finish the iteration
                  state.target = undefined;
                  return createIterResultObject(undefined, true);
                }
                // return step by kind
                if (kind === "keys")
                  return createIterResultObject(entry.key, false);
                if (kind === "values")
                  return createIterResultObject(entry.value, false);
                return createIterResultObject([entry.key, entry.value], false);
              },
              IS_MAP ? "entries" : "values",
              !IS_MAP,
              true
            );

            // `{ Map, Set }.prototype[@@species]` accessors
            // https://tc39.es/ecma262/#sec-get-map-@@species
            // https://tc39.es/ecma262/#sec-get-set-@@species
            setSpecies(CONSTRUCTOR_NAME);
          },
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/collection-weak.js":
      /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/collection-weak.js ***!
  \***********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var defineBuiltIns = __webpack_require__(
          /*! ../internals/define-built-ins */ "./node_modules/core-js/internals/define-built-ins.js"
        );
        var getWeakData = __webpack_require__(
          /*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js"
        ).getWeakData;
        var anInstance = __webpack_require__(
          /*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js"
        );
        var anObject = __webpack_require__(
          /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
        );
        var isNullOrUndefined = __webpack_require__(
          /*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js"
        );
        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );
        var iterate = __webpack_require__(
          /*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js"
        );
        var ArrayIterationModule = __webpack_require__(
          /*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js"
        );
        var hasOwn = __webpack_require__(
          /*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js"
        );
        var InternalStateModule = __webpack_require__(
          /*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js"
        );

        var setInternalState = InternalStateModule.set;
        var internalStateGetterFor = InternalStateModule.getterFor;
        var find = ArrayIterationModule.find;
        var findIndex = ArrayIterationModule.findIndex;
        var splice = uncurryThis([].splice);
        var id = 0;

        // fallback for uncaught frozen keys
        var uncaughtFrozenStore = function (state) {
          return state.frozen || (state.frozen = new UncaughtFrozenStore());
        };

        var UncaughtFrozenStore = function () {
          this.entries = [];
        };

        var findUncaughtFrozen = function (store, key) {
          return find(store.entries, function (it) {
            return it[0] === key;
          });
        };

        UncaughtFrozenStore.prototype = {
          get: function (key) {
            var entry = findUncaughtFrozen(this, key);
            if (entry) return entry[1];
          },
          has: function (key) {
            return !!findUncaughtFrozen(this, key);
          },
          set: function (key, value) {
            var entry = findUncaughtFrozen(this, key);
            if (entry) entry[1] = value;
            else this.entries.push([key, value]);
          },
          delete: function (key) {
            var index = findIndex(this.entries, function (it) {
              return it[0] === key;
            });
            if (~index) splice(this.entries, index, 1);
            return !!~index;
          },
        };

        module.exports = {
          getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
            var Constructor = wrapper(function (that, iterable) {
              anInstance(that, Prototype);
              setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: id++,
                frozen: undefined,
              });
              if (!isNullOrUndefined(iterable))
                iterate(iterable, that[ADDER], {
                  that: that,
                  AS_ENTRIES: IS_MAP,
                });
            });

            var Prototype = Constructor.prototype;

            var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

            var define = function (that, key, value) {
              var state = getInternalState(that);
              var data = getWeakData(anObject(key), true);
              if (data === true) uncaughtFrozenStore(state).set(key, value);
              else data[state.id] = value;
              return that;
            };

            defineBuiltIns(Prototype, {
              // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
              // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
              // https://tc39.es/ecma262/#sec-weakset.prototype.delete
              delete: function (key) {
                var state = getInternalState(this);
                if (!isObject(key)) return false;
                var data = getWeakData(key);
                if (data === true)
                  return uncaughtFrozenStore(state)["delete"](key);
                return data && hasOwn(data, state.id) && delete data[state.id];
              },
              // `{ WeakMap, WeakSet }.prototype.has(key)` methods
              // https://tc39.es/ecma262/#sec-weakmap.prototype.has
              // https://tc39.es/ecma262/#sec-weakset.prototype.has
              has: function has(key) {
                var state = getInternalState(this);
                if (!isObject(key)) return false;
                var data = getWeakData(key);
                if (data === true) return uncaughtFrozenStore(state).has(key);
                return data && hasOwn(data, state.id);
              },
            });

            defineBuiltIns(
              Prototype,
              IS_MAP
                ? {
                    // `WeakMap.prototype.get(key)` method
                    // https://tc39.es/ecma262/#sec-weakmap.prototype.get
                    get: function get(key) {
                      var state = getInternalState(this);
                      if (isObject(key)) {
                        var data = getWeakData(key);
                        if (data === true)
                          return uncaughtFrozenStore(state).get(key);
                        return data ? data[state.id] : undefined;
                      }
                    },
                    // `WeakMap.prototype.set(key, value)` method
                    // https://tc39.es/ecma262/#sec-weakmap.prototype.set
                    set: function set(key, value) {
                      return define(this, key, value);
                    },
                  }
                : {
                    // `WeakSet.prototype.add(value)` method
                    // https://tc39.es/ecma262/#sec-weakset.prototype.add
                    add: function add(value) {
                      return define(this, value, true);
                    },
                  }
            );

            return Constructor;
          },
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/collection.js":
      /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/collection.js ***!
  \******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var $ = __webpack_require__(
          /*! ../internals/export */ "./node_modules/core-js/internals/export.js"
        );
        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );
        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var isForced = __webpack_require__(
          /*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js"
        );
        var defineBuiltIn = __webpack_require__(
          /*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js"
        );
        var InternalMetadataModule = __webpack_require__(
          /*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js"
        );
        var iterate = __webpack_require__(
          /*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js"
        );
        var anInstance = __webpack_require__(
          /*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var isNullOrUndefined = __webpack_require__(
          /*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js"
        );
        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );
        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );
        var checkCorrectnessOfIteration = __webpack_require__(
          /*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js"
        );
        var setToStringTag = __webpack_require__(
          /*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js"
        );
        var inheritIfRequired = __webpack_require__(
          /*! ../internals/inherit-if-required */ "./node_modules/core-js/internals/inherit-if-required.js"
        );

        module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
          var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
          var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
          var ADDER = IS_MAP ? "set" : "add";
          var NativeConstructor = global[CONSTRUCTOR_NAME];
          var NativePrototype =
            NativeConstructor && NativeConstructor.prototype;
          var Constructor = NativeConstructor;
          var exported = {};

          var fixMethod = function (KEY) {
            var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
            defineBuiltIn(
              NativePrototype,
              KEY,
              KEY === "add"
                ? function add(value) {
                    uncurriedNativeMethod(this, value === 0 ? 0 : value);
                    return this;
                  }
                : KEY === "delete"
                ? function (key) {
                    return IS_WEAK && !isObject(key)
                      ? false
                      : uncurriedNativeMethod(this, key === 0 ? 0 : key);
                  }
                : KEY === "get"
                ? function get(key) {
                    return IS_WEAK && !isObject(key)
                      ? undefined
                      : uncurriedNativeMethod(this, key === 0 ? 0 : key);
                  }
                : KEY === "has"
                ? function has(key) {
                    return IS_WEAK && !isObject(key)
                      ? false
                      : uncurriedNativeMethod(this, key === 0 ? 0 : key);
                  }
                : function set(key, value) {
                    uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
                    return this;
                  }
            );
          };

          var REPLACE = isForced(
            CONSTRUCTOR_NAME,
            !isCallable(NativeConstructor) ||
              !(
                IS_WEAK ||
                (NativePrototype.forEach &&
                  !fails(function () {
                    new NativeConstructor().entries().next();
                  }))
              )
          );

          if (REPLACE) {
            // create collection constructor
            Constructor = common.getConstructor(
              wrapper,
              CONSTRUCTOR_NAME,
              IS_MAP,
              ADDER
            );
            InternalMetadataModule.enable();
          } else if (isForced(CONSTRUCTOR_NAME, true)) {
            var instance = new Constructor();
            // early implementations not supports chaining
            var HASNT_CHAINING =
              instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
            // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
            var THROWS_ON_PRIMITIVES = fails(function () {
              instance.has(1);
            });
            // most early implementations doesn't supports iterables, most modern - not close it correctly
            // eslint-disable-next-line no-new -- required for testing
            var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (
              iterable
            ) {
              new NativeConstructor(iterable);
            });
            // for early implementations -0 and +0 not the same
            var BUGGY_ZERO =
              !IS_WEAK &&
              fails(function () {
                // V8 ~ Chromium 42- fails only with 5+ elements
                var $instance = new NativeConstructor();
                var index = 5;
                while (index--) $instance[ADDER](index, index);
                return !$instance.has(-0);
              });

            if (!ACCEPT_ITERABLES) {
              Constructor = wrapper(function (dummy, iterable) {
                anInstance(dummy, NativePrototype);
                var that = inheritIfRequired(
                  new NativeConstructor(),
                  dummy,
                  Constructor
                );
                if (!isNullOrUndefined(iterable))
                  iterate(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP,
                  });
                return that;
              });
              Constructor.prototype = NativePrototype;
              NativePrototype.constructor = Constructor;
            }

            if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
              fixMethod("delete");
              fixMethod("has");
              IS_MAP && fixMethod("get");
            }

            if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

            // weak collections should not contains .clear method
            if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
          }

          exported[CONSTRUCTOR_NAME] = Constructor;
          $(
            {
              global: true,
              constructor: true,
              forced: Constructor !== NativeConstructor,
            },
            exported
          );

          setToStringTag(Constructor, CONSTRUCTOR_NAME);

          if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

          return Constructor;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/copy-constructor-properties.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/copy-constructor-properties.js ***!
  \***********************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var hasOwn = __webpack_require__(
          /*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js"
        );
        var ownKeys = __webpack_require__(
          /*! ../internals/own-keys */ "./node_modules/core-js/internals/own-keys.js"
        );
        var getOwnPropertyDescriptorModule = __webpack_require__(
          /*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js"
        );
        var definePropertyModule = __webpack_require__(
          /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
        );

        module.exports = function (target, source, exceptions) {
          var keys = ownKeys(source);
          var defineProperty = definePropertyModule.f;
          var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (
              !hasOwn(target, key) &&
              !(exceptions && hasOwn(exceptions, key))
            ) {
              defineProperty(
                target,
                key,
                getOwnPropertyDescriptor(source, key)
              );
            }
          }
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/correct-prototype-getter.js":
      /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/correct-prototype-getter.js ***!
  \********************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );

        module.exports = !fails(function () {
          function F() {
            /* empty */
          }
          F.prototype.constructor = null;
          // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
          return Object.getPrototypeOf(new F()) !== F.prototype;
        });

        /***/
      },

    /***/ "./node_modules/core-js/internals/create-iter-result-object.js":
      /*!*********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-iter-result-object.js ***!
  \*********************************************************************/
      /***/ (module) => {
        "use strict";

        // `CreateIterResultObject` abstract operation
        // https://tc39.es/ecma262/#sec-createiterresultobject
        module.exports = function (value, done) {
          return { value: value, done: done };
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/create-non-enumerable-property.js":
      /*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/create-non-enumerable-property.js ***!
  \**************************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var DESCRIPTORS = __webpack_require__(
          /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
        );
        var definePropertyModule = __webpack_require__(
          /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
        );
        var createPropertyDescriptor = __webpack_require__(
          /*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js"
        );

        module.exports = DESCRIPTORS
          ? function (object, key, value) {
              return definePropertyModule.f(
                object,
                key,
                createPropertyDescriptor(1, value)
              );
            }
          : function (object, key, value) {
              object[key] = value;
              return object;
            };

        /***/
      },

    /***/ "./node_modules/core-js/internals/create-property-descriptor.js":
      /*!**********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-property-descriptor.js ***!
  \**********************************************************************/
      /***/ (module) => {
        "use strict";

        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value,
          };
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/create-property.js":
      /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/create-property.js ***!
  \***********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var toPropertyKey = __webpack_require__(
          /*! ../internals/to-property-key */ "./node_modules/core-js/internals/to-property-key.js"
        );
        var definePropertyModule = __webpack_require__(
          /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
        );
        var createPropertyDescriptor = __webpack_require__(
          /*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js"
        );

        module.exports = function (object, key, value) {
          var propertyKey = toPropertyKey(key);
          if (propertyKey in object)
            definePropertyModule.f(
              object,
              propertyKey,
              createPropertyDescriptor(0, value)
            );
          else object[propertyKey] = value;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/define-built-in-accessor.js":
      /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/define-built-in-accessor.js ***!
  \********************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var makeBuiltIn = __webpack_require__(
          /*! ../internals/make-built-in */ "./node_modules/core-js/internals/make-built-in.js"
        );
        var defineProperty = __webpack_require__(
          /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
        );

        module.exports = function (target, name, descriptor) {
          if (descriptor.get)
            makeBuiltIn(descriptor.get, name, { getter: true });
          if (descriptor.set)
            makeBuiltIn(descriptor.set, name, { setter: true });
          return defineProperty.f(target, name, descriptor);
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/define-built-in.js":
      /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/define-built-in.js ***!
  \***********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var definePropertyModule = __webpack_require__(
          /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
        );
        var makeBuiltIn = __webpack_require__(
          /*! ../internals/make-built-in */ "./node_modules/core-js/internals/make-built-in.js"
        );
        var defineGlobalProperty = __webpack_require__(
          /*! ../internals/define-global-property */ "./node_modules/core-js/internals/define-global-property.js"
        );

        module.exports = function (O, key, value, options) {
          if (!options) options = {};
          var simple = options.enumerable;
          var name = options.name !== undefined ? options.name : key;
          if (isCallable(value)) makeBuiltIn(value, name, options);
          if (options.global) {
            if (simple) O[key] = value;
            else defineGlobalProperty(key, value);
          } else {
            try {
              if (!options.unsafe) delete O[key];
              else if (O[key]) simple = true;
            } catch (error) {
              /* empty */
            }
            if (simple) O[key] = value;
            else
              definePropertyModule.f(O, key, {
                value: value,
                enumerable: false,
                configurable: !options.nonConfigurable,
                writable: !options.nonWritable,
              });
          }
          return O;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/define-built-ins.js":
      /*!************************************************************!*\
  !*** ./node_modules/core-js/internals/define-built-ins.js ***!
  \************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var defineBuiltIn = __webpack_require__(
          /*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js"
        );

        module.exports = function (target, src, options) {
          for (var key in src) defineBuiltIn(target, key, src[key], options);
          return target;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/define-global-property.js":
      /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/define-global-property.js ***!
  \******************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );

        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;

        module.exports = function (key, value) {
          try {
            defineProperty(global, key, {
              value: value,
              configurable: true,
              writable: true,
            });
          } catch (error) {
            global[key] = value;
          }
          return value;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/descriptors.js":
      /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/descriptors.js ***!
  \*******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );

        // Detect IE8's incomplete defineProperty implementation
        module.exports = !fails(function () {
          // eslint-disable-next-line es/no-object-defineproperty -- required for testing
          return (
            Object.defineProperty({}, 1, {
              get: function () {
                return 7;
              },
            })[1] !== 7
          );
        });

        /***/
      },

    /***/ "./node_modules/core-js/internals/document-all.js":
      /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/document-all.js ***!
  \********************************************************/
      /***/ (module) => {
        "use strict";

        var documentAll = typeof document == "object" && document.all;

        // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
        // eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
        var IS_HTMLDDA =
          typeof documentAll == "undefined" && documentAll !== undefined;

        module.exports = {
          all: documentAll,
          IS_HTMLDDA: IS_HTMLDDA,
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/document-create-element.js":
      /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/document-create-element.js ***!
  \*******************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );
        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );

        var document = global.document;
        // typeof document.createElement is 'object' in old IE
        var EXISTS = isObject(document) && isObject(document.createElement);

        module.exports = function (it) {
          return EXISTS ? document.createElement(it) : {};
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/engine-user-agent.js":
      /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/engine-user-agent.js ***!
  \*************************************************************/
      /***/ (module) => {
        "use strict";

        module.exports =
          (typeof navigator != "undefined" && String(navigator.userAgent)) ||
          "";

        /***/
      },

    /***/ "./node_modules/core-js/internals/engine-v8-version.js":
      /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/engine-v8-version.js ***!
  \*************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );
        var userAgent = __webpack_require__(
          /*! ../internals/engine-user-agent */ "./node_modules/core-js/internals/engine-user-agent.js"
        );

        var process = global.process;
        var Deno = global.Deno;
        var versions = (process && process.versions) || (Deno && Deno.version);
        var v8 = versions && versions.v8;
        var match, version;

        if (v8) {
          match = v8.split(".");
          // in old Chrome, versions of V8 isn't V8 = Chrome / 10
          // but their correct versions are not interesting for us
          version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
        }

        // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
        // so check `userAgent` even if `.v8` exists, but 0
        if (!version && userAgent) {
          match = userAgent.match(/Edge\/(\d+)/);
          if (!match || match[1] >= 74) {
            match = userAgent.match(/Chrome\/(\d+)/);
            if (match) version = +match[1];
          }
        }

        module.exports = version;

        /***/
      },

    /***/ "./node_modules/core-js/internals/enum-bug-keys.js":
      /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/enum-bug-keys.js ***!
  \*********************************************************/
      /***/ (module) => {
        "use strict";

        // IE8- don't enum bug keys
        module.exports = [
          "constructor",
          "hasOwnProperty",
          "isPrototypeOf",
          "propertyIsEnumerable",
          "toLocaleString",
          "toString",
          "valueOf",
        ];

        /***/
      },

    /***/ "./node_modules/core-js/internals/export.js":
      /*!**************************************************!*\
  !*** ./node_modules/core-js/internals/export.js ***!
  \**************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );
        var getOwnPropertyDescriptor = __webpack_require__(
          /*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js"
        ).f;
        var createNonEnumerableProperty = __webpack_require__(
          /*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js"
        );
        var defineBuiltIn = __webpack_require__(
          /*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js"
        );
        var defineGlobalProperty = __webpack_require__(
          /*! ../internals/define-global-property */ "./node_modules/core-js/internals/define-global-property.js"
        );
        var copyConstructorProperties = __webpack_require__(
          /*! ../internals/copy-constructor-properties */ "./node_modules/core-js/internals/copy-constructor-properties.js"
        );
        var isForced = __webpack_require__(
          /*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js"
        );

        /*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
        module.exports = function (options, source) {
          var TARGET = options.target;
          var GLOBAL = options.global;
          var STATIC = options.stat;
          var FORCED, target, key, targetProperty, sourceProperty, descriptor;
          if (GLOBAL) {
            target = global;
          } else if (STATIC) {
            target = global[TARGET] || defineGlobalProperty(TARGET, {});
          } else {
            target = (global[TARGET] || {}).prototype;
          }
          if (target)
            for (key in source) {
              sourceProperty = source[key];
              if (options.dontCallGetSet) {
                descriptor = getOwnPropertyDescriptor(target, key);
                targetProperty = descriptor && descriptor.value;
              } else targetProperty = target[key];
              FORCED = isForced(
                GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key,
                options.forced
              );
              // contained in target
              if (!FORCED && targetProperty !== undefined) {
                if (typeof sourceProperty == typeof targetProperty) continue;
                copyConstructorProperties(sourceProperty, targetProperty);
              }
              // add a flag to not completely full polyfills
              if (options.sham || (targetProperty && targetProperty.sham)) {
                createNonEnumerableProperty(sourceProperty, "sham", true);
              }
              defineBuiltIn(target, key, sourceProperty, options);
            }
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/fails.js":
      /*!*************************************************!*\
  !*** ./node_modules/core-js/internals/fails.js ***!
  \*************************************************/
      /***/ (module) => {
        "use strict";

        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (error) {
            return true;
          }
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/freezing.js":
      /*!****************************************************!*\
  !*** ./node_modules/core-js/internals/freezing.js ***!
  \****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );

        module.exports = !fails(function () {
          // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
          return Object.isExtensible(Object.preventExtensions({}));
        });

        /***/
      },

    /***/ "./node_modules/core-js/internals/function-bind-context.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/function-bind-context.js ***!
  \*****************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this-clause */ "./node_modules/core-js/internals/function-uncurry-this-clause.js"
        );
        var aCallable = __webpack_require__(
          /*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js"
        );
        var NATIVE_BIND = __webpack_require__(
          /*! ../internals/function-bind-native */ "./node_modules/core-js/internals/function-bind-native.js"
        );

        var bind = uncurryThis(uncurryThis.bind);

        // optional / simple context binding
        module.exports = function (fn, that) {
          aCallable(fn);
          return that === undefined
            ? fn
            : NATIVE_BIND
            ? bind(fn, that)
            : function (/* ...args */) {
                return fn.apply(that, arguments);
              };
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/function-bind-native.js":
      /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/function-bind-native.js ***!
  \****************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );

        module.exports = !fails(function () {
          // eslint-disable-next-line es/no-function-prototype-bind -- safe
          var test = function () {
            /* empty */
          }.bind();
          // eslint-disable-next-line no-prototype-builtins -- safe
          return typeof test != "function" || test.hasOwnProperty("prototype");
        });

        /***/
      },

    /***/ "./node_modules/core-js/internals/function-call.js":
      /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/function-call.js ***!
  \*********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var NATIVE_BIND = __webpack_require__(
          /*! ../internals/function-bind-native */ "./node_modules/core-js/internals/function-bind-native.js"
        );

        var call = Function.prototype.call;

        module.exports = NATIVE_BIND
          ? call.bind(call)
          : function () {
              return call.apply(call, arguments);
            };

        /***/
      },

    /***/ "./node_modules/core-js/internals/function-name.js":
      /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/function-name.js ***!
  \*********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var DESCRIPTORS = __webpack_require__(
          /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
        );
        var hasOwn = __webpack_require__(
          /*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js"
        );

        var FunctionPrototype = Function.prototype;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

        var EXISTS = hasOwn(FunctionPrototype, "name");
        // additional protection from minified / mangled / dropped function names
        var PROPER =
          EXISTS &&
          function something() {
            /* empty */
          }.name === "something";
        var CONFIGURABLE =
          EXISTS &&
          (!DESCRIPTORS ||
            (DESCRIPTORS &&
              getDescriptor(FunctionPrototype, "name").configurable));

        module.exports = {
          EXISTS: EXISTS,
          PROPER: PROPER,
          CONFIGURABLE: CONFIGURABLE,
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/function-uncurry-this-accessor.js":
      /*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/function-uncurry-this-accessor.js ***!
  \**************************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var aCallable = __webpack_require__(
          /*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js"
        );

        module.exports = function (object, key, method) {
          try {
            // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
            return uncurryThis(
              aCallable(Object.getOwnPropertyDescriptor(object, key)[method])
            );
          } catch (error) {
            /* empty */
          }
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/function-uncurry-this-clause.js":
      /*!************************************************************************!*\
  !*** ./node_modules/core-js/internals/function-uncurry-this-clause.js ***!
  \************************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var classofRaw = __webpack_require__(
          /*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js"
        );
        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );

        module.exports = function (fn) {
          // Nashorn bug:
          //   https://github.com/zloirock/core-js/issues/1128
          //   https://github.com/zloirock/core-js/issues/1130
          if (classofRaw(fn) === "Function") return uncurryThis(fn);
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/function-uncurry-this.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/function-uncurry-this.js ***!
  \*****************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var NATIVE_BIND = __webpack_require__(
          /*! ../internals/function-bind-native */ "./node_modules/core-js/internals/function-bind-native.js"
        );

        var FunctionPrototype = Function.prototype;
        var call = FunctionPrototype.call;
        var uncurryThisWithBind =
          NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

        module.exports = NATIVE_BIND
          ? uncurryThisWithBind
          : function (fn) {
              return function () {
                return call.apply(fn, arguments);
              };
            };

        /***/
      },

    /***/ "./node_modules/core-js/internals/get-built-in.js":
      /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/get-built-in.js ***!
  \********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );

        var aFunction = function (argument) {
          return isCallable(argument) ? argument : undefined;
        };

        module.exports = function (namespace, method) {
          return arguments.length < 2
            ? aFunction(global[namespace])
            : global[namespace] && global[namespace][method];
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/get-iterator-method.js":
      /*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/get-iterator-method.js ***!
  \***************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var classof = __webpack_require__(
          /*! ../internals/classof */ "./node_modules/core-js/internals/classof.js"
        );
        var getMethod = __webpack_require__(
          /*! ../internals/get-method */ "./node_modules/core-js/internals/get-method.js"
        );
        var isNullOrUndefined = __webpack_require__(
          /*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js"
        );
        var Iterators = __webpack_require__(
          /*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js"
        );
        var wellKnownSymbol = __webpack_require__(
          /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
        );

        var ITERATOR = wellKnownSymbol("iterator");

        module.exports = function (it) {
          if (!isNullOrUndefined(it))
            return (
              getMethod(it, ITERATOR) ||
              getMethod(it, "@@iterator") ||
              Iterators[classof(it)]
            );
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/get-iterator.js":
      /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/get-iterator.js ***!
  \********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var call = __webpack_require__(
          /*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js"
        );
        var aCallable = __webpack_require__(
          /*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js"
        );
        var anObject = __webpack_require__(
          /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
        );
        var tryToString = __webpack_require__(
          /*! ../internals/try-to-string */ "./node_modules/core-js/internals/try-to-string.js"
        );
        var getIteratorMethod = __webpack_require__(
          /*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js"
        );

        var $TypeError = TypeError;

        module.exports = function (argument, usingIterator) {
          var iteratorMethod =
            arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
          if (aCallable(iteratorMethod))
            return anObject(call(iteratorMethod, argument));
          throw new $TypeError(tryToString(argument) + " is not iterable");
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/get-method.js":
      /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/get-method.js ***!
  \******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var aCallable = __webpack_require__(
          /*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js"
        );
        var isNullOrUndefined = __webpack_require__(
          /*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js"
        );

        // `GetMethod` abstract operation
        // https://tc39.es/ecma262/#sec-getmethod
        module.exports = function (V, P) {
          var func = V[P];
          return isNullOrUndefined(func) ? undefined : aCallable(func);
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/global.js":
      /*!**************************************************!*\
  !*** ./node_modules/core-js/internals/global.js ***!
  \**************************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        "use strict";

        var check = function (it) {
          return it && it.Math === Math && it;
        };

        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        module.exports =
          // eslint-disable-next-line es/no-global-this -- safe
          check(typeof globalThis == "object" && globalThis) ||
          check(typeof window == "object" && window) ||
          // eslint-disable-next-line no-restricted-globals -- safe
          check(typeof self == "object" && self) ||
          check(
            typeof __webpack_require__.g == "object" && __webpack_require__.g
          ) ||
          // eslint-disable-next-line no-new-func -- fallback
          (function () {
            return this;
          })() ||
          this ||
          Function("return this")();

        /***/
      },

    /***/ "./node_modules/core-js/internals/has-own-property.js":
      /*!************************************************************!*\
  !*** ./node_modules/core-js/internals/has-own-property.js ***!
  \************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var toObject = __webpack_require__(
          /*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js"
        );

        var hasOwnProperty = uncurryThis({}.hasOwnProperty);

        // `HasOwnProperty` abstract operation
        // https://tc39.es/ecma262/#sec-hasownproperty
        // eslint-disable-next-line es/no-object-hasown -- safe
        module.exports =
          Object.hasOwn ||
          function hasOwn(it, key) {
            return hasOwnProperty(toObject(it), key);
          };

        /***/
      },

    /***/ "./node_modules/core-js/internals/hidden-keys.js":
      /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/hidden-keys.js ***!
  \*******************************************************/
      /***/ (module) => {
        "use strict";

        module.exports = {};

        /***/
      },

    /***/ "./node_modules/core-js/internals/html.js":
      /*!************************************************!*\
  !*** ./node_modules/core-js/internals/html.js ***!
  \************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var getBuiltIn = __webpack_require__(
          /*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js"
        );

        module.exports = getBuiltIn("document", "documentElement");

        /***/
      },

    /***/ "./node_modules/core-js/internals/ie8-dom-define.js":
      /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/ie8-dom-define.js ***!
  \**********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var DESCRIPTORS = __webpack_require__(
          /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
        );
        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );
        var createElement = __webpack_require__(
          /*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js"
        );

        // Thanks to IE8 for its funny defineProperty
        module.exports =
          !DESCRIPTORS &&
          !fails(function () {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return (
              Object.defineProperty(createElement("div"), "a", {
                get: function () {
                  return 7;
                },
              }).a !== 7
            );
          });

        /***/
      },

    /***/ "./node_modules/core-js/internals/indexed-object.js":
      /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/indexed-object.js ***!
  \**********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );
        var classof = __webpack_require__(
          /*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js"
        );

        var $Object = Object;
        var split = uncurryThis("".split);

        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        module.exports = fails(function () {
          // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
          // eslint-disable-next-line no-prototype-builtins -- safe
          return !$Object("z").propertyIsEnumerable(0);
        })
          ? function (it) {
              return classof(it) === "String" ? split(it, "") : $Object(it);
            }
          : $Object;

        /***/
      },

    /***/ "./node_modules/core-js/internals/inherit-if-required.js":
      /*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/inherit-if-required.js ***!
  \***************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );
        var setPrototypeOf = __webpack_require__(
          /*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js"
        );

        // makes subclassing work correct for wrapped built-ins
        module.exports = function ($this, dummy, Wrapper) {
          var NewTarget, NewTargetPrototype;
          if (
            // it can work only with native `setPrototypeOf`
            setPrototypeOf &&
            // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
            isCallable((NewTarget = dummy.constructor)) &&
            NewTarget !== Wrapper &&
            isObject((NewTargetPrototype = NewTarget.prototype)) &&
            NewTargetPrototype !== Wrapper.prototype
          )
            setPrototypeOf($this, NewTargetPrototype);
          return $this;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/inspect-source.js":
      /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/inspect-source.js ***!
  \**********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var store = __webpack_require__(
          /*! ../internals/shared-store */ "./node_modules/core-js/internals/shared-store.js"
        );

        var functionToString = uncurryThis(Function.toString);

        // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
        if (!isCallable(store.inspectSource)) {
          store.inspectSource = function (it) {
            return functionToString(it);
          };
        }

        module.exports = store.inspectSource;

        /***/
      },

    /***/ "./node_modules/core-js/internals/internal-metadata.js":
      /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/internal-metadata.js ***!
  \*************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var $ = __webpack_require__(
          /*! ../internals/export */ "./node_modules/core-js/internals/export.js"
        );
        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var hiddenKeys = __webpack_require__(
          /*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js"
        );
        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );
        var hasOwn = __webpack_require__(
          /*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js"
        );
        var defineProperty = __webpack_require__(
          /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
        ).f;
        var getOwnPropertyNamesModule = __webpack_require__(
          /*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js"
        );
        var getOwnPropertyNamesExternalModule = __webpack_require__(
          /*! ../internals/object-get-own-property-names-external */ "./node_modules/core-js/internals/object-get-own-property-names-external.js"
        );
        var isExtensible = __webpack_require__(
          /*! ../internals/object-is-extensible */ "./node_modules/core-js/internals/object-is-extensible.js"
        );
        var uid = __webpack_require__(
          /*! ../internals/uid */ "./node_modules/core-js/internals/uid.js"
        );
        var FREEZING = __webpack_require__(
          /*! ../internals/freezing */ "./node_modules/core-js/internals/freezing.js"
        );

        var REQUIRED = false;
        var METADATA = uid("meta");
        var id = 0;

        var setMetadata = function (it) {
          defineProperty(it, METADATA, {
            value: {
              objectID: "O" + id++, // object ID
              weakData: {}, // weak collections IDs
            },
          });
        };

        var fastKey = function (it, create) {
          // return a primitive with prefix
          if (!isObject(it))
            return typeof it == "symbol"
              ? it
              : (typeof it == "string" ? "S" : "P") + it;
          if (!hasOwn(it, METADATA)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return "F";
            // not necessary to add metadata
            if (!create) return "E";
            // add missing metadata
            setMetadata(it);
            // return object ID
          }
          return it[METADATA].objectID;
        };

        var getWeakData = function (it, create) {
          if (!hasOwn(it, METADATA)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return true;
            // not necessary to add metadata
            if (!create) return false;
            // add missing metadata
            setMetadata(it);
            // return the store of weak collections IDs
          }
          return it[METADATA].weakData;
        };

        // add metadata on freeze-family methods calling
        var onFreeze = function (it) {
          if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA))
            setMetadata(it);
          return it;
        };

        var enable = function () {
          meta.enable = function () {
            /* empty */
          };
          REQUIRED = true;
          var getOwnPropertyNames = getOwnPropertyNamesModule.f;
          var splice = uncurryThis([].splice);
          var test = {};
          test[METADATA] = 1;

          // prevent exposing of metadata key
          if (getOwnPropertyNames(test).length) {
            getOwnPropertyNamesModule.f = function (it) {
              var result = getOwnPropertyNames(it);
              for (var i = 0, length = result.length; i < length; i++) {
                if (result[i] === METADATA) {
                  splice(result, i, 1);
                  break;
                }
              }
              return result;
            };

            $(
              { target: "Object", stat: true, forced: true },
              {
                getOwnPropertyNames: getOwnPropertyNamesExternalModule.f,
              }
            );
          }
        };

        var meta = (module.exports = {
          enable: enable,
          fastKey: fastKey,
          getWeakData: getWeakData,
          onFreeze: onFreeze,
        });

        hiddenKeys[METADATA] = true;

        /***/
      },

    /***/ "./node_modules/core-js/internals/internal-state.js":
      /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/internal-state.js ***!
  \**********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var NATIVE_WEAK_MAP = __webpack_require__(
          /*! ../internals/weak-map-basic-detection */ "./node_modules/core-js/internals/weak-map-basic-detection.js"
        );
        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );
        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );
        var createNonEnumerableProperty = __webpack_require__(
          /*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js"
        );
        var hasOwn = __webpack_require__(
          /*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js"
        );
        var shared = __webpack_require__(
          /*! ../internals/shared-store */ "./node_modules/core-js/internals/shared-store.js"
        );
        var sharedKey = __webpack_require__(
          /*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js"
        );
        var hiddenKeys = __webpack_require__(
          /*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js"
        );

        var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
        var TypeError = global.TypeError;
        var WeakMap = global.WeakMap;
        var set, get, has;

        var enforce = function (it) {
          return has(it) ? get(it) : set(it, {});
        };

        var getterFor = function (TYPE) {
          return function (it) {
            var state;
            if (!isObject(it) || (state = get(it)).type !== TYPE) {
              throw new TypeError(
                "Incompatible receiver, " + TYPE + " required"
              );
            }
            return state;
          };
        };

        if (NATIVE_WEAK_MAP || shared.state) {
          var store = shared.state || (shared.state = new WeakMap());
          /* eslint-disable no-self-assign -- prototype methods protection */
          store.get = store.get;
          store.has = store.has;
          store.set = store.set;
          /* eslint-enable no-self-assign -- prototype methods protection */
          set = function (it, metadata) {
            if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
            metadata.facade = it;
            store.set(it, metadata);
            return metadata;
          };
          get = function (it) {
            return store.get(it) || {};
          };
          has = function (it) {
            return store.has(it);
          };
        } else {
          var STATE = sharedKey("state");
          hiddenKeys[STATE] = true;
          set = function (it, metadata) {
            if (hasOwn(it, STATE))
              throw new TypeError(OBJECT_ALREADY_INITIALIZED);
            metadata.facade = it;
            createNonEnumerableProperty(it, STATE, metadata);
            return metadata;
          };
          get = function (it) {
            return hasOwn(it, STATE) ? it[STATE] : {};
          };
          has = function (it) {
            return hasOwn(it, STATE);
          };
        }

        module.exports = {
          set: set,
          get: get,
          has: has,
          enforce: enforce,
          getterFor: getterFor,
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/is-array-iterator-method.js":
      /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/is-array-iterator-method.js ***!
  \********************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var wellKnownSymbol = __webpack_require__(
          /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
        );
        var Iterators = __webpack_require__(
          /*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js"
        );

        var ITERATOR = wellKnownSymbol("iterator");
        var ArrayPrototype = Array.prototype;

        // check on default Array iterator
        module.exports = function (it) {
          return (
            it !== undefined &&
            (Iterators.Array === it || ArrayPrototype[ITERATOR] === it)
          );
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/is-array.js":
      /*!****************************************************!*\
  !*** ./node_modules/core-js/internals/is-array.js ***!
  \****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var classof = __webpack_require__(
          /*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js"
        );

        // `IsArray` abstract operation
        // https://tc39.es/ecma262/#sec-isarray
        // eslint-disable-next-line es/no-array-isarray -- safe
        module.exports =
          Array.isArray ||
          function isArray(argument) {
            return classof(argument) === "Array";
          };

        /***/
      },

    /***/ "./node_modules/core-js/internals/is-callable.js":
      /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/is-callable.js ***!
  \*******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var $documentAll = __webpack_require__(
          /*! ../internals/document-all */ "./node_modules/core-js/internals/document-all.js"
        );

        var documentAll = $documentAll.all;

        // `IsCallable` abstract operation
        // https://tc39.es/ecma262/#sec-iscallable
        module.exports = $documentAll.IS_HTMLDDA
          ? function (argument) {
              return typeof argument == "function" || argument === documentAll;
            }
          : function (argument) {
              return typeof argument == "function";
            };

        /***/
      },

    /***/ "./node_modules/core-js/internals/is-constructor.js":
      /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/is-constructor.js ***!
  \**********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var classof = __webpack_require__(
          /*! ../internals/classof */ "./node_modules/core-js/internals/classof.js"
        );
        var getBuiltIn = __webpack_require__(
          /*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js"
        );
        var inspectSource = __webpack_require__(
          /*! ../internals/inspect-source */ "./node_modules/core-js/internals/inspect-source.js"
        );

        var noop = function () {
          /* empty */
        };
        var empty = [];
        var construct = getBuiltIn("Reflect", "construct");
        var constructorRegExp = /^\s*(?:class|function)\b/;
        var exec = uncurryThis(constructorRegExp.exec);
        var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

        var isConstructorModern = function isConstructor(argument) {
          if (!isCallable(argument)) return false;
          try {
            construct(noop, empty, argument);
            return true;
          } catch (error) {
            return false;
          }
        };

        var isConstructorLegacy = function isConstructor(argument) {
          if (!isCallable(argument)) return false;
          switch (classof(argument)) {
            case "AsyncFunction":
            case "GeneratorFunction":
            case "AsyncGeneratorFunction":
              return false;
          }
          try {
            // we can't check .prototype since constructors produced by .bind haven't it
            // `Function#toString` throws on some built-it function in some legacy engines
            // (for example, `DOMQuad` and similar in FF41-)
            return (
              INCORRECT_TO_STRING ||
              !!exec(constructorRegExp, inspectSource(argument))
            );
          } catch (error) {
            return true;
          }
        };

        isConstructorLegacy.sham = true;

        // `IsConstructor` abstract operation
        // https://tc39.es/ecma262/#sec-isconstructor
        module.exports =
          !construct ||
          fails(function () {
            var called;
            return (
              isConstructorModern(isConstructorModern.call) ||
              !isConstructorModern(Object) ||
              !isConstructorModern(function () {
                called = true;
              }) ||
              called
            );
          })
            ? isConstructorLegacy
            : isConstructorModern;

        /***/
      },

    /***/ "./node_modules/core-js/internals/is-forced.js":
      /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-forced.js ***!
  \*****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );

        var replacement = /#|\.prototype\./;

        var isForced = function (feature, detection) {
          var value = data[normalize(feature)];
          return value === POLYFILL
            ? true
            : value === NATIVE
            ? false
            : isCallable(detection)
            ? fails(detection)
            : !!detection;
        };

        var normalize = (isForced.normalize = function (string) {
          return String(string).replace(replacement, ".").toLowerCase();
        });

        var data = (isForced.data = {});
        var NATIVE = (isForced.NATIVE = "N");
        var POLYFILL = (isForced.POLYFILL = "P");

        module.exports = isForced;

        /***/
      },

    /***/ "./node_modules/core-js/internals/is-null-or-undefined.js":
      /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/is-null-or-undefined.js ***!
  \****************************************************************/
      /***/ (module) => {
        "use strict";

        // we can't use just `it == null` since of `document.all` special case
        // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
        module.exports = function (it) {
          return it === null || it === undefined;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/is-object.js":
      /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-object.js ***!
  \*****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var $documentAll = __webpack_require__(
          /*! ../internals/document-all */ "./node_modules/core-js/internals/document-all.js"
        );

        var documentAll = $documentAll.all;

        module.exports = $documentAll.IS_HTMLDDA
          ? function (it) {
              return typeof it == "object"
                ? it !== null
                : isCallable(it) || it === documentAll;
            }
          : function (it) {
              return typeof it == "object" ? it !== null : isCallable(it);
            };

        /***/
      },

    /***/ "./node_modules/core-js/internals/is-pure.js":
      /*!***************************************************!*\
  !*** ./node_modules/core-js/internals/is-pure.js ***!
  \***************************************************/
      /***/ (module) => {
        "use strict";

        module.exports = false;

        /***/
      },

    /***/ "./node_modules/core-js/internals/is-symbol.js":
      /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-symbol.js ***!
  \*****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var getBuiltIn = __webpack_require__(
          /*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var isPrototypeOf = __webpack_require__(
          /*! ../internals/object-is-prototype-of */ "./node_modules/core-js/internals/object-is-prototype-of.js"
        );
        var USE_SYMBOL_AS_UID = __webpack_require__(
          /*! ../internals/use-symbol-as-uid */ "./node_modules/core-js/internals/use-symbol-as-uid.js"
        );

        var $Object = Object;

        module.exports = USE_SYMBOL_AS_UID
          ? function (it) {
              return typeof it == "symbol";
            }
          : function (it) {
              var $Symbol = getBuiltIn("Symbol");
              return (
                isCallable($Symbol) &&
                isPrototypeOf($Symbol.prototype, $Object(it))
              );
            };

        /***/
      },

    /***/ "./node_modules/core-js/internals/iterate.js":
      /*!***************************************************!*\
  !*** ./node_modules/core-js/internals/iterate.js ***!
  \***************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var bind = __webpack_require__(
          /*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js"
        );
        var call = __webpack_require__(
          /*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js"
        );
        var anObject = __webpack_require__(
          /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
        );
        var tryToString = __webpack_require__(
          /*! ../internals/try-to-string */ "./node_modules/core-js/internals/try-to-string.js"
        );
        var isArrayIteratorMethod = __webpack_require__(
          /*! ../internals/is-array-iterator-method */ "./node_modules/core-js/internals/is-array-iterator-method.js"
        );
        var lengthOfArrayLike = __webpack_require__(
          /*! ../internals/length-of-array-like */ "./node_modules/core-js/internals/length-of-array-like.js"
        );
        var isPrototypeOf = __webpack_require__(
          /*! ../internals/object-is-prototype-of */ "./node_modules/core-js/internals/object-is-prototype-of.js"
        );
        var getIterator = __webpack_require__(
          /*! ../internals/get-iterator */ "./node_modules/core-js/internals/get-iterator.js"
        );
        var getIteratorMethod = __webpack_require__(
          /*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js"
        );
        var iteratorClose = __webpack_require__(
          /*! ../internals/iterator-close */ "./node_modules/core-js/internals/iterator-close.js"
        );

        var $TypeError = TypeError;

        var Result = function (stopped, result) {
          this.stopped = stopped;
          this.result = result;
        };

        var ResultPrototype = Result.prototype;

        module.exports = function (iterable, unboundFunction, options) {
          var that = options && options.that;
          var AS_ENTRIES = !!(options && options.AS_ENTRIES);
          var IS_RECORD = !!(options && options.IS_RECORD);
          var IS_ITERATOR = !!(options && options.IS_ITERATOR);
          var INTERRUPTED = !!(options && options.INTERRUPTED);
          var fn = bind(unboundFunction, that);
          var iterator, iterFn, index, length, result, next, step;

          var stop = function (condition) {
            if (iterator) iteratorClose(iterator, "normal", condition);
            return new Result(true, condition);
          };

          var callFn = function (value) {
            if (AS_ENTRIES) {
              anObject(value);
              return INTERRUPTED
                ? fn(value[0], value[1], stop)
                : fn(value[0], value[1]);
            }
            return INTERRUPTED ? fn(value, stop) : fn(value);
          };

          if (IS_RECORD) {
            iterator = iterable.iterator;
          } else if (IS_ITERATOR) {
            iterator = iterable;
          } else {
            iterFn = getIteratorMethod(iterable);
            if (!iterFn)
              throw new $TypeError(tryToString(iterable) + " is not iterable");
            // optimisation for array iterators
            if (isArrayIteratorMethod(iterFn)) {
              for (
                index = 0, length = lengthOfArrayLike(iterable);
                length > index;
                index++
              ) {
                result = callFn(iterable[index]);
                if (result && isPrototypeOf(ResultPrototype, result))
                  return result;
              }
              return new Result(false);
            }
            iterator = getIterator(iterable, iterFn);
          }

          next = IS_RECORD ? iterable.next : iterator.next;
          while (!(step = call(next, iterator)).done) {
            try {
              result = callFn(step.value);
            } catch (error) {
              iteratorClose(iterator, "throw", error);
            }
            if (
              typeof result == "object" &&
              result &&
              isPrototypeOf(ResultPrototype, result)
            )
              return result;
          }
          return new Result(false);
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/iterator-close.js":
      /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/iterator-close.js ***!
  \**********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var call = __webpack_require__(
          /*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js"
        );
        var anObject = __webpack_require__(
          /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
        );
        var getMethod = __webpack_require__(
          /*! ../internals/get-method */ "./node_modules/core-js/internals/get-method.js"
        );

        module.exports = function (iterator, kind, value) {
          var innerResult, innerError;
          anObject(iterator);
          try {
            innerResult = getMethod(iterator, "return");
            if (!innerResult) {
              if (kind === "throw") throw value;
              return value;
            }
            innerResult = call(innerResult, iterator);
          } catch (error) {
            innerError = true;
            innerResult = error;
          }
          if (kind === "throw") throw value;
          if (innerError) throw innerResult;
          anObject(innerResult);
          return value;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/iterator-create-constructor.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/iterator-create-constructor.js ***!
  \***********************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var IteratorPrototype = __webpack_require__(
          /*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js"
        ).IteratorPrototype;
        var create = __webpack_require__(
          /*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js"
        );
        var createPropertyDescriptor = __webpack_require__(
          /*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js"
        );
        var setToStringTag = __webpack_require__(
          /*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js"
        );
        var Iterators = __webpack_require__(
          /*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js"
        );

        var returnThis = function () {
          return this;
        };

        module.exports = function (
          IteratorConstructor,
          NAME,
          next,
          ENUMERABLE_NEXT
        ) {
          var TO_STRING_TAG = NAME + " Iterator";
          IteratorConstructor.prototype = create(IteratorPrototype, {
            next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next),
          });
          setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
          Iterators[TO_STRING_TAG] = returnThis;
          return IteratorConstructor;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/iterator-define.js":
      /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/iterator-define.js ***!
  \***********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var $ = __webpack_require__(
          /*! ../internals/export */ "./node_modules/core-js/internals/export.js"
        );
        var call = __webpack_require__(
          /*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js"
        );
        var IS_PURE = __webpack_require__(
          /*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js"
        );
        var FunctionName = __webpack_require__(
          /*! ../internals/function-name */ "./node_modules/core-js/internals/function-name.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var createIteratorConstructor = __webpack_require__(
          /*! ../internals/iterator-create-constructor */ "./node_modules/core-js/internals/iterator-create-constructor.js"
        );
        var getPrototypeOf = __webpack_require__(
          /*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js"
        );
        var setPrototypeOf = __webpack_require__(
          /*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js"
        );
        var setToStringTag = __webpack_require__(
          /*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js"
        );
        var createNonEnumerableProperty = __webpack_require__(
          /*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js"
        );
        var defineBuiltIn = __webpack_require__(
          /*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js"
        );
        var wellKnownSymbol = __webpack_require__(
          /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
        );
        var Iterators = __webpack_require__(
          /*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js"
        );
        var IteratorsCore = __webpack_require__(
          /*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js"
        );

        var PROPER_FUNCTION_NAME = FunctionName.PROPER;
        var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
        var IteratorPrototype = IteratorsCore.IteratorPrototype;
        var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
        var ITERATOR = wellKnownSymbol("iterator");
        var KEYS = "keys";
        var VALUES = "values";
        var ENTRIES = "entries";

        var returnThis = function () {
          return this;
        };

        module.exports = function (
          Iterable,
          NAME,
          IteratorConstructor,
          next,
          DEFAULT,
          IS_SET,
          FORCED
        ) {
          createIteratorConstructor(IteratorConstructor, NAME, next);

          var getIterationMethod = function (KIND) {
            if (KIND === DEFAULT && defaultIterator) return defaultIterator;
            if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype)
              return IterablePrototype[KIND];

            switch (KIND) {
              case KEYS:
                return function keys() {
                  return new IteratorConstructor(this, KIND);
                };
              case VALUES:
                return function values() {
                  return new IteratorConstructor(this, KIND);
                };
              case ENTRIES:
                return function entries() {
                  return new IteratorConstructor(this, KIND);
                };
            }

            return function () {
              return new IteratorConstructor(this);
            };
          };

          var TO_STRING_TAG = NAME + " Iterator";
          var INCORRECT_VALUES_NAME = false;
          var IterablePrototype = Iterable.prototype;
          var nativeIterator =
            IterablePrototype[ITERATOR] ||
            IterablePrototype["@@iterator"] ||
            (DEFAULT && IterablePrototype[DEFAULT]);
          var defaultIterator =
            (!BUGGY_SAFARI_ITERATORS && nativeIterator) ||
            getIterationMethod(DEFAULT);
          var anyNativeIterator =
            NAME === "Array"
              ? IterablePrototype.entries || nativeIterator
              : nativeIterator;
          var CurrentIteratorPrototype, methods, KEY;

          // fix native
          if (anyNativeIterator) {
            CurrentIteratorPrototype = getPrototypeOf(
              anyNativeIterator.call(new Iterable())
            );
            if (
              CurrentIteratorPrototype !== Object.prototype &&
              CurrentIteratorPrototype.next
            ) {
              if (
                !IS_PURE &&
                getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype
              ) {
                if (setPrototypeOf) {
                  setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
                  defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
                }
              }
              // Set @@toStringTag to native iterators
              setToStringTag(
                CurrentIteratorPrototype,
                TO_STRING_TAG,
                true,
                true
              );
              if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
            }
          }

          // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
          if (
            PROPER_FUNCTION_NAME &&
            DEFAULT === VALUES &&
            nativeIterator &&
            nativeIterator.name !== VALUES
          ) {
            if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
              createNonEnumerableProperty(IterablePrototype, "name", VALUES);
            } else {
              INCORRECT_VALUES_NAME = true;
              defaultIterator = function values() {
                return call(nativeIterator, this);
              };
            }
          }

          // export additional methods
          if (DEFAULT) {
            methods = {
              values: getIterationMethod(VALUES),
              keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
              entries: getIterationMethod(ENTRIES),
            };
            if (FORCED)
              for (KEY in methods) {
                if (
                  BUGGY_SAFARI_ITERATORS ||
                  INCORRECT_VALUES_NAME ||
                  !(KEY in IterablePrototype)
                ) {
                  defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
                }
              }
            else
              $(
                {
                  target: NAME,
                  proto: true,
                  forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME,
                },
                methods
              );
          }

          // define iterator
          if (
            (!IS_PURE || FORCED) &&
            IterablePrototype[ITERATOR] !== defaultIterator
          ) {
            defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, {
              name: DEFAULT,
            });
          }
          Iterators[NAME] = defaultIterator;

          return methods;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/iterators-core.js":
      /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/iterators-core.js ***!
  \**********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );
        var create = __webpack_require__(
          /*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js"
        );
        var getPrototypeOf = __webpack_require__(
          /*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js"
        );
        var defineBuiltIn = __webpack_require__(
          /*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js"
        );
        var wellKnownSymbol = __webpack_require__(
          /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
        );
        var IS_PURE = __webpack_require__(
          /*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js"
        );

        var ITERATOR = wellKnownSymbol("iterator");
        var BUGGY_SAFARI_ITERATORS = false;

        // `%IteratorPrototype%` object
        // https://tc39.es/ecma262/#sec-%iteratorprototype%-object
        var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

        /* eslint-disable es/no-array-prototype-keys -- safe */
        if ([].keys) {
          arrayIterator = [].keys();
          // Safari 8 has buggy iterators w/o `next`
          if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
          else {
            PrototypeOfArrayIteratorPrototype = getPrototypeOf(
              getPrototypeOf(arrayIterator)
            );
            if (PrototypeOfArrayIteratorPrototype !== Object.prototype)
              IteratorPrototype = PrototypeOfArrayIteratorPrototype;
          }
        }

        var NEW_ITERATOR_PROTOTYPE =
          !isObject(IteratorPrototype) ||
          fails(function () {
            var test = {};
            // FF44- legacy iterators case
            return IteratorPrototype[ITERATOR].call(test) !== test;
          });

        if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
        else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

        // `%IteratorPrototype%[@@iterator]()` method
        // https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
        if (!isCallable(IteratorPrototype[ITERATOR])) {
          defineBuiltIn(IteratorPrototype, ITERATOR, function () {
            return this;
          });
        }

        module.exports = {
          IteratorPrototype: IteratorPrototype,
          BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS,
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/iterators.js":
      /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/iterators.js ***!
  \*****************************************************/
      /***/ (module) => {
        "use strict";

        module.exports = {};

        /***/
      },

    /***/ "./node_modules/core-js/internals/length-of-array-like.js":
      /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/length-of-array-like.js ***!
  \****************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var toLength = __webpack_require__(
          /*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js"
        );

        // `LengthOfArrayLike` abstract operation
        // https://tc39.es/ecma262/#sec-lengthofarraylike
        module.exports = function (obj) {
          return toLength(obj.length);
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/make-built-in.js":
      /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/make-built-in.js ***!
  \*********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var hasOwn = __webpack_require__(
          /*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js"
        );
        var DESCRIPTORS = __webpack_require__(
          /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
        );
        var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(
          /*! ../internals/function-name */ "./node_modules/core-js/internals/function-name.js"
        ).CONFIGURABLE;
        var inspectSource = __webpack_require__(
          /*! ../internals/inspect-source */ "./node_modules/core-js/internals/inspect-source.js"
        );
        var InternalStateModule = __webpack_require__(
          /*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js"
        );

        var enforceInternalState = InternalStateModule.enforce;
        var getInternalState = InternalStateModule.get;
        var $String = String;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;
        var stringSlice = uncurryThis("".slice);
        var replace = uncurryThis("".replace);
        var join = uncurryThis([].join);

        var CONFIGURABLE_LENGTH =
          DESCRIPTORS &&
          !fails(function () {
            return (
              defineProperty(
                function () {
                  /* empty */
                },
                "length",
                { value: 8 }
              ).length !== 8
            );
          });

        var TEMPLATE = String(String).split("String");

        var makeBuiltIn = (module.exports = function (value, name, options) {
          if (stringSlice($String(name), 0, 7) === "Symbol(") {
            name =
              "[" + replace($String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
          }
          if (options && options.getter) name = "get " + name;
          if (options && options.setter) name = "set " + name;
          if (
            !hasOwn(value, "name") ||
            (CONFIGURABLE_FUNCTION_NAME && value.name !== name)
          ) {
            if (DESCRIPTORS)
              defineProperty(value, "name", {
                value: name,
                configurable: true,
              });
            else value.name = name;
          }
          if (
            CONFIGURABLE_LENGTH &&
            options &&
            hasOwn(options, "arity") &&
            value.length !== options.arity
          ) {
            defineProperty(value, "length", { value: options.arity });
          }
          try {
            if (
              options &&
              hasOwn(options, "constructor") &&
              options.constructor
            ) {
              if (DESCRIPTORS)
                defineProperty(value, "prototype", { writable: false });
              // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
            } else if (value.prototype) value.prototype = undefined;
          } catch (error) {
            /* empty */
          }
          var state = enforceInternalState(value);
          if (!hasOwn(state, "source")) {
            state.source = join(TEMPLATE, typeof name == "string" ? name : "");
          }
          return value;
        });

        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
        // eslint-disable-next-line no-extend-native -- required
        Function.prototype.toString = makeBuiltIn(function toString() {
          return (
            (isCallable(this) && getInternalState(this).source) ||
            inspectSource(this)
          );
        }, "toString");

        /***/
      },

    /***/ "./node_modules/core-js/internals/math-trunc.js":
      /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/math-trunc.js ***!
  \******************************************************/
      /***/ (module) => {
        "use strict";

        var ceil = Math.ceil;
        var floor = Math.floor;

        // `Math.trunc` method
        // https://tc39.es/ecma262/#sec-math.trunc
        // eslint-disable-next-line es/no-math-trunc -- safe
        module.exports =
          Math.trunc ||
          function trunc(x) {
            var n = +x;
            return (n > 0 ? floor : ceil)(n);
          };

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-assign.js":
      /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/object-assign.js ***!
  \*********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var DESCRIPTORS = __webpack_require__(
          /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
        );
        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var call = __webpack_require__(
          /*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js"
        );
        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );
        var objectKeys = __webpack_require__(
          /*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js"
        );
        var getOwnPropertySymbolsModule = __webpack_require__(
          /*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js"
        );
        var propertyIsEnumerableModule = __webpack_require__(
          /*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js"
        );
        var toObject = __webpack_require__(
          /*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js"
        );
        var IndexedObject = __webpack_require__(
          /*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js"
        );

        // eslint-disable-next-line es/no-object-assign -- safe
        var $assign = Object.assign;
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
        var defineProperty = Object.defineProperty;
        var concat = uncurryThis([].concat);

        // `Object.assign` method
        // https://tc39.es/ecma262/#sec-object.assign
        module.exports =
          !$assign ||
          fails(function () {
            // should have correct order of operations (Edge bug)
            if (
              DESCRIPTORS &&
              $assign(
                { b: 1 },
                $assign(
                  defineProperty({}, "a", {
                    enumerable: true,
                    get: function () {
                      defineProperty(this, "b", {
                        value: 3,
                        enumerable: false,
                      });
                    },
                  }),
                  { b: 2 }
                )
              ).b !== 1
            )
              return true;
            // should work with symbols and should have deterministic property order (V8 bug)
            var A = {};
            var B = {};
            // eslint-disable-next-line es/no-symbol -- safe
            var symbol = Symbol("assign detection");
            var alphabet = "abcdefghijklmnopqrst";
            A[symbol] = 7;
            alphabet.split("").forEach(function (chr) {
              B[chr] = chr;
            });
            return (
              $assign({}, A)[symbol] !== 7 ||
              objectKeys($assign({}, B)).join("") !== alphabet
            );
          })
            ? function assign(target, source) {
                // eslint-disable-line no-unused-vars -- required for `.length`
                var T = toObject(target);
                var argumentsLength = arguments.length;
                var index = 1;
                var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                var propertyIsEnumerable = propertyIsEnumerableModule.f;
                while (argumentsLength > index) {
                  var S = IndexedObject(arguments[index++]);
                  var keys = getOwnPropertySymbols
                    ? concat(objectKeys(S), getOwnPropertySymbols(S))
                    : objectKeys(S);
                  var length = keys.length;
                  var j = 0;
                  var key;
                  while (length > j) {
                    key = keys[j++];
                    if (!DESCRIPTORS || call(propertyIsEnumerable, S, key))
                      T[key] = S[key];
                  }
                }
                return T;
              }
            : $assign;

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-create.js":
      /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/object-create.js ***!
  \*********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        /* global ActiveXObject -- old IE, WSH */
        var anObject = __webpack_require__(
          /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
        );
        var definePropertiesModule = __webpack_require__(
          /*! ../internals/object-define-properties */ "./node_modules/core-js/internals/object-define-properties.js"
        );
        var enumBugKeys = __webpack_require__(
          /*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js"
        );
        var hiddenKeys = __webpack_require__(
          /*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js"
        );
        var html = __webpack_require__(
          /*! ../internals/html */ "./node_modules/core-js/internals/html.js"
        );
        var documentCreateElement = __webpack_require__(
          /*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js"
        );
        var sharedKey = __webpack_require__(
          /*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js"
        );

        var GT = ">";
        var LT = "<";
        var PROTOTYPE = "prototype";
        var SCRIPT = "script";
        var IE_PROTO = sharedKey("IE_PROTO");

        var EmptyConstructor = function () {
          /* empty */
        };

        var scriptTag = function (content) {
          return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
        };

        // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
        var NullProtoObjectViaActiveX = function (activeXDocument) {
          activeXDocument.write(scriptTag(""));
          activeXDocument.close();
          var temp = activeXDocument.parentWindow.Object;
          activeXDocument = null; // avoid memory leak
          return temp;
        };

        // Create object with fake `null` prototype: use iframe Object with cleared prototype
        var NullProtoObjectViaIFrame = function () {
          // Thrash, waste and sodomy: IE GC bug
          var iframe = documentCreateElement("iframe");
          var JS = "java" + SCRIPT + ":";
          var iframeDocument;
          iframe.style.display = "none";
          html.appendChild(iframe);
          // https://github.com/zloirock/core-js/issues/475
          iframe.src = String(JS);
          iframeDocument = iframe.contentWindow.document;
          iframeDocument.open();
          iframeDocument.write(scriptTag("document.F=Object"));
          iframeDocument.close();
          return iframeDocument.F;
        };

        // Check for document.domain and active x support
        // No need to use active x approach when document.domain is not set
        // see https://github.com/es-shims/es5-shim/issues/150
        // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
        // avoid IE GC bug
        var activeXDocument;
        var NullProtoObject = function () {
          try {
            activeXDocument = new ActiveXObject("htmlfile");
          } catch (error) {
            /* ignore */
          }
          NullProtoObject =
            typeof document != "undefined"
              ? document.domain && activeXDocument
                ? NullProtoObjectViaActiveX(activeXDocument) // old IE
                : NullProtoObjectViaIFrame()
              : NullProtoObjectViaActiveX(activeXDocument); // WSH
          var length = enumBugKeys.length;
          while (length--)
            delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
          return NullProtoObject();
        };

        hiddenKeys[IE_PROTO] = true;

        // `Object.create` method
        // https://tc39.es/ecma262/#sec-object.create
        // eslint-disable-next-line es/no-object-create -- safe
        module.exports =
          Object.create ||
          function create(O, Properties) {
            var result;
            if (O !== null) {
              EmptyConstructor[PROTOTYPE] = anObject(O);
              result = new EmptyConstructor();
              EmptyConstructor[PROTOTYPE] = null;
              // add "__proto__" for Object.getPrototypeOf polyfill
              result[IE_PROTO] = O;
            } else result = NullProtoObject();
            return Properties === undefined
              ? result
              : definePropertiesModule.f(result, Properties);
          };

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-define-properties.js":
      /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-properties.js ***!
  \********************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        var DESCRIPTORS = __webpack_require__(
          /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
        );
        var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(
          /*! ../internals/v8-prototype-define-bug */ "./node_modules/core-js/internals/v8-prototype-define-bug.js"
        );
        var definePropertyModule = __webpack_require__(
          /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
        );
        var anObject = __webpack_require__(
          /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
        );
        var toIndexedObject = __webpack_require__(
          /*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js"
        );
        var objectKeys = __webpack_require__(
          /*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js"
        );

        // `Object.defineProperties` method
        // https://tc39.es/ecma262/#sec-object.defineproperties
        // eslint-disable-next-line es/no-object-defineproperties -- safe
        exports.f =
          DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG
            ? Object.defineProperties
            : function defineProperties(O, Properties) {
                anObject(O);
                var props = toIndexedObject(Properties);
                var keys = objectKeys(Properties);
                var length = keys.length;
                var index = 0;
                var key;
                while (length > index)
                  definePropertyModule.f(O, (key = keys[index++]), props[key]);
                return O;
              };

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-define-property.js":
      /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-property.js ***!
  \******************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        var DESCRIPTORS = __webpack_require__(
          /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
        );
        var IE8_DOM_DEFINE = __webpack_require__(
          /*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js"
        );
        var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(
          /*! ../internals/v8-prototype-define-bug */ "./node_modules/core-js/internals/v8-prototype-define-bug.js"
        );
        var anObject = __webpack_require__(
          /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
        );
        var toPropertyKey = __webpack_require__(
          /*! ../internals/to-property-key */ "./node_modules/core-js/internals/to-property-key.js"
        );

        var $TypeError = TypeError;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var $defineProperty = Object.defineProperty;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var ENUMERABLE = "enumerable";
        var CONFIGURABLE = "configurable";
        var WRITABLE = "writable";

        // `Object.defineProperty` method
        // https://tc39.es/ecma262/#sec-object.defineproperty
        exports.f = DESCRIPTORS
          ? V8_PROTOTYPE_DEFINE_BUG
            ? function defineProperty(O, P, Attributes) {
                anObject(O);
                P = toPropertyKey(P);
                anObject(Attributes);
                if (
                  typeof O === "function" &&
                  P === "prototype" &&
                  "value" in Attributes &&
                  WRITABLE in Attributes &&
                  !Attributes[WRITABLE]
                ) {
                  var current = $getOwnPropertyDescriptor(O, P);
                  if (current && current[WRITABLE]) {
                    O[P] = Attributes.value;
                    Attributes = {
                      configurable:
                        CONFIGURABLE in Attributes
                          ? Attributes[CONFIGURABLE]
                          : current[CONFIGURABLE],
                      enumerable:
                        ENUMERABLE in Attributes
                          ? Attributes[ENUMERABLE]
                          : current[ENUMERABLE],
                      writable: false,
                    };
                  }
                }
                return $defineProperty(O, P, Attributes);
              }
            : $defineProperty
          : function defineProperty(O, P, Attributes) {
              anObject(O);
              P = toPropertyKey(P);
              anObject(Attributes);
              if (IE8_DOM_DEFINE)
                try {
                  return $defineProperty(O, P, Attributes);
                } catch (error) {
                  /* empty */
                }
              if ("get" in Attributes || "set" in Attributes)
                throw new $TypeError("Accessors not supported");
              if ("value" in Attributes) O[P] = Attributes.value;
              return O;
            };

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-get-own-property-descriptor.js":
      /*!******************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-descriptor.js ***!
  \******************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        var DESCRIPTORS = __webpack_require__(
          /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
        );
        var call = __webpack_require__(
          /*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js"
        );
        var propertyIsEnumerableModule = __webpack_require__(
          /*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js"
        );
        var createPropertyDescriptor = __webpack_require__(
          /*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js"
        );
        var toIndexedObject = __webpack_require__(
          /*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js"
        );
        var toPropertyKey = __webpack_require__(
          /*! ../internals/to-property-key */ "./node_modules/core-js/internals/to-property-key.js"
        );
        var hasOwn = __webpack_require__(
          /*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js"
        );
        var IE8_DOM_DEFINE = __webpack_require__(
          /*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js"
        );

        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
        exports.f = DESCRIPTORS
          ? $getOwnPropertyDescriptor
          : function getOwnPropertyDescriptor(O, P) {
              O = toIndexedObject(O);
              P = toPropertyKey(P);
              if (IE8_DOM_DEFINE)
                try {
                  return $getOwnPropertyDescriptor(O, P);
                } catch (error) {
                  /* empty */
                }
              if (hasOwn(O, P))
                return createPropertyDescriptor(
                  !call(propertyIsEnumerableModule.f, O, P),
                  O[P]
                );
            };

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-get-own-property-names-external.js":
      /*!**********************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-names-external.js ***!
  \**********************************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        /* eslint-disable es/no-object-getownpropertynames -- safe */
        var classof = __webpack_require__(
          /*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js"
        );
        var toIndexedObject = __webpack_require__(
          /*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js"
        );
        var $getOwnPropertyNames = __webpack_require__(
          /*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js"
        ).f;
        var arraySlice = __webpack_require__(
          /*! ../internals/array-slice-simple */ "./node_modules/core-js/internals/array-slice-simple.js"
        );

        var windowNames =
          typeof window == "object" && window && Object.getOwnPropertyNames
            ? Object.getOwnPropertyNames(window)
            : [];

        var getWindowNames = function (it) {
          try {
            return $getOwnPropertyNames(it);
          } catch (error) {
            return arraySlice(windowNames);
          }
        };

        // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
        module.exports.f = function getOwnPropertyNames(it) {
          return windowNames && classof(it) === "Window"
            ? getWindowNames(it)
            : $getOwnPropertyNames(toIndexedObject(it));
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-get-own-property-names.js":
      /*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-names.js ***!
  \*************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        var internalObjectKeys = __webpack_require__(
          /*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js"
        );
        var enumBugKeys = __webpack_require__(
          /*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js"
        );

        var hiddenKeys = enumBugKeys.concat("length", "prototype");

        // `Object.getOwnPropertyNames` method
        // https://tc39.es/ecma262/#sec-object.getownpropertynames
        // eslint-disable-next-line es/no-object-getownpropertynames -- safe
        exports.f =
          Object.getOwnPropertyNames ||
          function getOwnPropertyNames(O) {
            return internalObjectKeys(O, hiddenKeys);
          };

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-get-own-property-symbols.js":
      /*!***************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-symbols.js ***!
  \***************************************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
        exports.f = Object.getOwnPropertySymbols;

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-get-prototype-of.js":
      /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-prototype-of.js ***!
  \*******************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var hasOwn = __webpack_require__(
          /*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var toObject = __webpack_require__(
          /*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js"
        );
        var sharedKey = __webpack_require__(
          /*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js"
        );
        var CORRECT_PROTOTYPE_GETTER = __webpack_require__(
          /*! ../internals/correct-prototype-getter */ "./node_modules/core-js/internals/correct-prototype-getter.js"
        );

        var IE_PROTO = sharedKey("IE_PROTO");
        var $Object = Object;
        var ObjectPrototype = $Object.prototype;

        // `Object.getPrototypeOf` method
        // https://tc39.es/ecma262/#sec-object.getprototypeof
        // eslint-disable-next-line es/no-object-getprototypeof -- safe
        module.exports = CORRECT_PROTOTYPE_GETTER
          ? $Object.getPrototypeOf
          : function (O) {
              var object = toObject(O);
              if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
              var constructor = object.constructor;
              if (isCallable(constructor) && object instanceof constructor) {
                return constructor.prototype;
              }
              return object instanceof $Object ? ObjectPrototype : null;
            };

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-is-extensible.js":
      /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/object-is-extensible.js ***!
  \****************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );
        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );
        var classof = __webpack_require__(
          /*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js"
        );
        var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(
          /*! ../internals/array-buffer-non-extensible */ "./node_modules/core-js/internals/array-buffer-non-extensible.js"
        );

        // eslint-disable-next-line es/no-object-isextensible -- safe
        var $isExtensible = Object.isExtensible;
        var FAILS_ON_PRIMITIVES = fails(function () {
          $isExtensible(1);
        });

        // `Object.isExtensible` method
        // https://tc39.es/ecma262/#sec-object.isextensible
        module.exports =
          FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE
            ? function isExtensible(it) {
                if (!isObject(it)) return false;
                if (
                  ARRAY_BUFFER_NON_EXTENSIBLE &&
                  classof(it) === "ArrayBuffer"
                )
                  return false;
                return $isExtensible ? $isExtensible(it) : true;
              }
            : $isExtensible;

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-is-prototype-of.js":
      /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-is-prototype-of.js ***!
  \******************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );

        module.exports = uncurryThis({}.isPrototypeOf);

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-keys-internal.js":
      /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys-internal.js ***!
  \****************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var hasOwn = __webpack_require__(
          /*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js"
        );
        var toIndexedObject = __webpack_require__(
          /*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js"
        );
        var indexOf = __webpack_require__(
          /*! ../internals/array-includes */ "./node_modules/core-js/internals/array-includes.js"
        ).indexOf;
        var hiddenKeys = __webpack_require__(
          /*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js"
        );

        var push = uncurryThis([].push);

        module.exports = function (object, names) {
          var O = toIndexedObject(object);
          var i = 0;
          var result = [];
          var key;
          for (key in O)
            !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
          // Don't enum bug & hidden keys
          while (names.length > i)
            if (hasOwn(O, (key = names[i++]))) {
              ~indexOf(result, key) || push(result, key);
            }
          return result;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-keys.js":
      /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys.js ***!
  \*******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var internalObjectKeys = __webpack_require__(
          /*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js"
        );
        var enumBugKeys = __webpack_require__(
          /*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js"
        );

        // `Object.keys` method
        // https://tc39.es/ecma262/#sec-object.keys
        // eslint-disable-next-line es/no-object-keys -- safe
        module.exports =
          Object.keys ||
          function keys(O) {
            return internalObjectKeys(O, enumBugKeys);
          };

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-property-is-enumerable.js":
      /*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-property-is-enumerable.js ***!
  \*************************************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        var $propertyIsEnumerable = {}.propertyIsEnumerable;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

        // Nashorn ~ JDK8 bug
        var NASHORN_BUG =
          getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

        // `Object.prototype.propertyIsEnumerable` method implementation
        // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
        exports.f = NASHORN_BUG
          ? function propertyIsEnumerable(V) {
              var descriptor = getOwnPropertyDescriptor(this, V);
              return !!descriptor && descriptor.enumerable;
            }
          : $propertyIsEnumerable;

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-set-prototype-of.js":
      /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-set-prototype-of.js ***!
  \*******************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        /* eslint-disable no-proto -- safe */
        var uncurryThisAccessor = __webpack_require__(
          /*! ../internals/function-uncurry-this-accessor */ "./node_modules/core-js/internals/function-uncurry-this-accessor.js"
        );
        var anObject = __webpack_require__(
          /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
        );
        var aPossiblePrototype = __webpack_require__(
          /*! ../internals/a-possible-prototype */ "./node_modules/core-js/internals/a-possible-prototype.js"
        );

        // `Object.setPrototypeOf` method
        // https://tc39.es/ecma262/#sec-object.setprototypeof
        // Works with __proto__ only. Old v8 can't work with null proto objects.
        // eslint-disable-next-line es/no-object-setprototypeof -- safe
        module.exports =
          Object.setPrototypeOf ||
          ("__proto__" in {}
            ? (function () {
                var CORRECT_SETTER = false;
                var test = {};
                var setter;
                try {
                  setter = uncurryThisAccessor(
                    Object.prototype,
                    "__proto__",
                    "set"
                  );
                  setter(test, []);
                  CORRECT_SETTER = test instanceof Array;
                } catch (error) {
                  /* empty */
                }
                return function setPrototypeOf(O, proto) {
                  anObject(O);
                  aPossiblePrototype(proto);
                  if (CORRECT_SETTER) setter(O, proto);
                  else O.__proto__ = proto;
                  return O;
                };
              })()
            : undefined);

        /***/
      },

    /***/ "./node_modules/core-js/internals/object-to-string.js":
      /*!************************************************************!*\
  !*** ./node_modules/core-js/internals/object-to-string.js ***!
  \************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var TO_STRING_TAG_SUPPORT = __webpack_require__(
          /*! ../internals/to-string-tag-support */ "./node_modules/core-js/internals/to-string-tag-support.js"
        );
        var classof = __webpack_require__(
          /*! ../internals/classof */ "./node_modules/core-js/internals/classof.js"
        );

        // `Object.prototype.toString` method implementation
        // https://tc39.es/ecma262/#sec-object.prototype.tostring
        module.exports = TO_STRING_TAG_SUPPORT
          ? {}.toString
          : function toString() {
              return "[object " + classof(this) + "]";
            };

        /***/
      },

    /***/ "./node_modules/core-js/internals/ordinary-to-primitive.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/ordinary-to-primitive.js ***!
  \*****************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var call = __webpack_require__(
          /*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );
        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );

        var $TypeError = TypeError;

        // `OrdinaryToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-ordinarytoprimitive
        module.exports = function (input, pref) {
          var fn, val;
          if (
            pref === "string" &&
            isCallable((fn = input.toString)) &&
            !isObject((val = call(fn, input)))
          )
            return val;
          if (
            isCallable((fn = input.valueOf)) &&
            !isObject((val = call(fn, input)))
          )
            return val;
          if (
            pref !== "string" &&
            isCallable((fn = input.toString)) &&
            !isObject((val = call(fn, input)))
          )
            return val;
          throw new $TypeError("Can't convert object to primitive value");
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/own-keys.js":
      /*!****************************************************!*\
  !*** ./node_modules/core-js/internals/own-keys.js ***!
  \****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var getBuiltIn = __webpack_require__(
          /*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js"
        );
        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var getOwnPropertyNamesModule = __webpack_require__(
          /*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js"
        );
        var getOwnPropertySymbolsModule = __webpack_require__(
          /*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js"
        );
        var anObject = __webpack_require__(
          /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
        );

        var concat = uncurryThis([].concat);

        // all object keys, includes non-enumerable and symbols
        module.exports =
          getBuiltIn("Reflect", "ownKeys") ||
          function ownKeys(it) {
            var keys = getOwnPropertyNamesModule.f(anObject(it));
            var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
            return getOwnPropertySymbols
              ? concat(keys, getOwnPropertySymbols(it))
              : keys;
          };

        /***/
      },

    /***/ "./node_modules/core-js/internals/path.js":
      /*!************************************************!*\
  !*** ./node_modules/core-js/internals/path.js ***!
  \************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );

        module.exports = global;

        /***/
      },

    /***/ "./node_modules/core-js/internals/require-object-coercible.js":
      /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/require-object-coercible.js ***!
  \********************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var isNullOrUndefined = __webpack_require__(
          /*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js"
        );

        var $TypeError = TypeError;

        // `RequireObjectCoercible` abstract operation
        // https://tc39.es/ecma262/#sec-requireobjectcoercible
        module.exports = function (it) {
          if (isNullOrUndefined(it))
            throw new $TypeError("Can't call method on " + it);
          return it;
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/set-species.js":
      /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/set-species.js ***!
  \*******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var getBuiltIn = __webpack_require__(
          /*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js"
        );
        var defineBuiltInAccessor = __webpack_require__(
          /*! ../internals/define-built-in-accessor */ "./node_modules/core-js/internals/define-built-in-accessor.js"
        );
        var wellKnownSymbol = __webpack_require__(
          /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
        );
        var DESCRIPTORS = __webpack_require__(
          /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
        );

        var SPECIES = wellKnownSymbol("species");

        module.exports = function (CONSTRUCTOR_NAME) {
          var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

          if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
            defineBuiltInAccessor(Constructor, SPECIES, {
              configurable: true,
              get: function () {
                return this;
              },
            });
          }
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/set-to-string-tag.js":
      /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/set-to-string-tag.js ***!
  \*************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var defineProperty = __webpack_require__(
          /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
        ).f;
        var hasOwn = __webpack_require__(
          /*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js"
        );
        var wellKnownSymbol = __webpack_require__(
          /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
        );

        var TO_STRING_TAG = wellKnownSymbol("toStringTag");

        module.exports = function (target, TAG, STATIC) {
          if (target && !STATIC) target = target.prototype;
          if (target && !hasOwn(target, TO_STRING_TAG)) {
            defineProperty(target, TO_STRING_TAG, {
              configurable: true,
              value: TAG,
            });
          }
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/shared-key.js":
      /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/shared-key.js ***!
  \******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var shared = __webpack_require__(
          /*! ../internals/shared */ "./node_modules/core-js/internals/shared.js"
        );
        var uid = __webpack_require__(
          /*! ../internals/uid */ "./node_modules/core-js/internals/uid.js"
        );

        var keys = shared("keys");

        module.exports = function (key) {
          return keys[key] || (keys[key] = uid(key));
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/shared-store.js":
      /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/shared-store.js ***!
  \********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );
        var defineGlobalProperty = __webpack_require__(
          /*! ../internals/define-global-property */ "./node_modules/core-js/internals/define-global-property.js"
        );

        var SHARED = "__core-js_shared__";
        var store = global[SHARED] || defineGlobalProperty(SHARED, {});

        module.exports = store;

        /***/
      },

    /***/ "./node_modules/core-js/internals/shared.js":
      /*!**************************************************!*\
  !*** ./node_modules/core-js/internals/shared.js ***!
  \**************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var IS_PURE = __webpack_require__(
          /*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js"
        );
        var store = __webpack_require__(
          /*! ../internals/shared-store */ "./node_modules/core-js/internals/shared-store.js"
        );

        (module.exports = function (key, value) {
          return store[key] || (store[key] = value !== undefined ? value : {});
        })("versions", []).push({
          version: "3.33.2",
          mode: IS_PURE ? "pure" : "global",
          copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
          license: "https://github.com/zloirock/core-js/blob/v3.33.2/LICENSE",
          source: "https://github.com/zloirock/core-js",
        });

        /***/
      },

    /***/ "./node_modules/core-js/internals/string-multibyte.js":
      /*!************************************************************!*\
  !*** ./node_modules/core-js/internals/string-multibyte.js ***!
  \************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var toIntegerOrInfinity = __webpack_require__(
          /*! ../internals/to-integer-or-infinity */ "./node_modules/core-js/internals/to-integer-or-infinity.js"
        );
        var toString = __webpack_require__(
          /*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js"
        );
        var requireObjectCoercible = __webpack_require__(
          /*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js"
        );

        var charAt = uncurryThis("".charAt);
        var charCodeAt = uncurryThis("".charCodeAt);
        var stringSlice = uncurryThis("".slice);

        var createMethod = function (CONVERT_TO_STRING) {
          return function ($this, pos) {
            var S = toString(requireObjectCoercible($this));
            var position = toIntegerOrInfinity(pos);
            var size = S.length;
            var first, second;
            if (position < 0 || position >= size)
              return CONVERT_TO_STRING ? "" : undefined;
            first = charCodeAt(S, position);
            return first < 0xd800 ||
              first > 0xdbff ||
              position + 1 === size ||
              (second = charCodeAt(S, position + 1)) < 0xdc00 ||
              second > 0xdfff
              ? CONVERT_TO_STRING
                ? charAt(S, position)
                : first
              : CONVERT_TO_STRING
              ? stringSlice(S, position, position + 2)
              : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
          };
        };

        module.exports = {
          // `String.prototype.codePointAt` method
          // https://tc39.es/ecma262/#sec-string.prototype.codepointat
          codeAt: createMethod(false),
          // `String.prototype.at` method
          // https://github.com/mathiasbynens/String.prototype.at
          charAt: createMethod(true),
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/symbol-constructor-detection.js":
      /*!************************************************************************!*\
  !*** ./node_modules/core-js/internals/symbol-constructor-detection.js ***!
  \************************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        /* eslint-disable es/no-symbol -- required for testing */
        var V8_VERSION = __webpack_require__(
          /*! ../internals/engine-v8-version */ "./node_modules/core-js/internals/engine-v8-version.js"
        );
        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );
        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );

        var $String = global.String;

        // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
        module.exports =
          !!Object.getOwnPropertySymbols &&
          !fails(function () {
            var symbol = Symbol("symbol detection");
            // Chrome 38 Symbol has incorrect toString conversion
            // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
            // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
            // of course, fail.
            return (
              !$String(symbol) ||
              !(Object(symbol) instanceof Symbol) ||
              // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
              (!Symbol.sham && V8_VERSION && V8_VERSION < 41)
            );
          });

        /***/
      },

    /***/ "./node_modules/core-js/internals/to-absolute-index.js":
      /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-absolute-index.js ***!
  \*************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var toIntegerOrInfinity = __webpack_require__(
          /*! ../internals/to-integer-or-infinity */ "./node_modules/core-js/internals/to-integer-or-infinity.js"
        );

        var max = Math.max;
        var min = Math.min;

        // Helper for a popular repeating case of the spec:
        // Let integer be ? ToInteger(index).
        // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
        module.exports = function (index, length) {
          var integer = toIntegerOrInfinity(index);
          return integer < 0 ? max(integer + length, 0) : min(integer, length);
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/to-indexed-object.js":
      /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-indexed-object.js ***!
  \*************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        // toObject with fallback for non-array-like ES3 strings
        var IndexedObject = __webpack_require__(
          /*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js"
        );
        var requireObjectCoercible = __webpack_require__(
          /*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js"
        );

        module.exports = function (it) {
          return IndexedObject(requireObjectCoercible(it));
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/to-integer-or-infinity.js":
      /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/to-integer-or-infinity.js ***!
  \******************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var trunc = __webpack_require__(
          /*! ../internals/math-trunc */ "./node_modules/core-js/internals/math-trunc.js"
        );

        // `ToIntegerOrInfinity` abstract operation
        // https://tc39.es/ecma262/#sec-tointegerorinfinity
        module.exports = function (argument) {
          var number = +argument;
          // eslint-disable-next-line no-self-compare -- NaN check
          return number !== number || number === 0 ? 0 : trunc(number);
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/to-length.js":
      /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-length.js ***!
  \*****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var toIntegerOrInfinity = __webpack_require__(
          /*! ../internals/to-integer-or-infinity */ "./node_modules/core-js/internals/to-integer-or-infinity.js"
        );

        var min = Math.min;

        // `ToLength` abstract operation
        // https://tc39.es/ecma262/#sec-tolength
        module.exports = function (argument) {
          return argument > 0
            ? min(toIntegerOrInfinity(argument), 0x1fffffffffffff)
            : 0; // 2 ** 53 - 1 == 9007199254740991
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/to-object.js":
      /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-object.js ***!
  \*****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var requireObjectCoercible = __webpack_require__(
          /*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js"
        );

        var $Object = Object;

        // `ToObject` abstract operation
        // https://tc39.es/ecma262/#sec-toobject
        module.exports = function (argument) {
          return $Object(requireObjectCoercible(argument));
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/to-primitive.js":
      /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/to-primitive.js ***!
  \********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var call = __webpack_require__(
          /*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js"
        );
        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );
        var isSymbol = __webpack_require__(
          /*! ../internals/is-symbol */ "./node_modules/core-js/internals/is-symbol.js"
        );
        var getMethod = __webpack_require__(
          /*! ../internals/get-method */ "./node_modules/core-js/internals/get-method.js"
        );
        var ordinaryToPrimitive = __webpack_require__(
          /*! ../internals/ordinary-to-primitive */ "./node_modules/core-js/internals/ordinary-to-primitive.js"
        );
        var wellKnownSymbol = __webpack_require__(
          /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
        );

        var $TypeError = TypeError;
        var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");

        // `ToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-toprimitive
        module.exports = function (input, pref) {
          if (!isObject(input) || isSymbol(input)) return input;
          var exoticToPrim = getMethod(input, TO_PRIMITIVE);
          var result;
          if (exoticToPrim) {
            if (pref === undefined) pref = "default";
            result = call(exoticToPrim, input, pref);
            if (!isObject(result) || isSymbol(result)) return result;
            throw new $TypeError("Can't convert object to primitive value");
          }
          if (pref === undefined) pref = "number";
          return ordinaryToPrimitive(input, pref);
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/to-property-key.js":
      /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/to-property-key.js ***!
  \***********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var toPrimitive = __webpack_require__(
          /*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js"
        );
        var isSymbol = __webpack_require__(
          /*! ../internals/is-symbol */ "./node_modules/core-js/internals/is-symbol.js"
        );

        // `ToPropertyKey` abstract operation
        // https://tc39.es/ecma262/#sec-topropertykey
        module.exports = function (argument) {
          var key = toPrimitive(argument, "string");
          return isSymbol(key) ? key : key + "";
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/to-string-tag-support.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/to-string-tag-support.js ***!
  \*****************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var wellKnownSymbol = __webpack_require__(
          /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
        );

        var TO_STRING_TAG = wellKnownSymbol("toStringTag");
        var test = {};

        test[TO_STRING_TAG] = "z";

        module.exports = String(test) === "[object z]";

        /***/
      },

    /***/ "./node_modules/core-js/internals/to-string.js":
      /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-string.js ***!
  \*****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var classof = __webpack_require__(
          /*! ../internals/classof */ "./node_modules/core-js/internals/classof.js"
        );

        var $String = String;

        module.exports = function (argument) {
          if (classof(argument) === "Symbol")
            throw new TypeError("Cannot convert a Symbol value to a string");
          return $String(argument);
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/try-to-string.js":
      /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/try-to-string.js ***!
  \*********************************************************/
      /***/ (module) => {
        "use strict";

        var $String = String;

        module.exports = function (argument) {
          try {
            return $String(argument);
          } catch (error) {
            return "Object";
          }
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/uid.js":
      /*!***********************************************!*\
  !*** ./node_modules/core-js/internals/uid.js ***!
  \***********************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );

        var id = 0;
        var postfix = Math.random();
        var toString = uncurryThis((1.0).toString);

        module.exports = function (key) {
          return (
            "Symbol(" +
            (key === undefined ? "" : key) +
            ")_" +
            toString(++id + postfix, 36)
          );
        };

        /***/
      },

    /***/ "./node_modules/core-js/internals/use-symbol-as-uid.js":
      /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/use-symbol-as-uid.js ***!
  \*************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        /* eslint-disable es/no-symbol -- required for testing */
        var NATIVE_SYMBOL = __webpack_require__(
          /*! ../internals/symbol-constructor-detection */ "./node_modules/core-js/internals/symbol-constructor-detection.js"
        );

        module.exports =
          NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";

        /***/
      },

    /***/ "./node_modules/core-js/internals/v8-prototype-define-bug.js":
      /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/v8-prototype-define-bug.js ***!
  \*******************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var DESCRIPTORS = __webpack_require__(
          /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
        );
        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );

        // V8 ~ Chrome 36-
        // https://bugs.chromium.org/p/v8/issues/detail?id=3334
        module.exports =
          DESCRIPTORS &&
          fails(function () {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return (
              Object.defineProperty(
                function () {
                  /* empty */
                },
                "prototype",
                {
                  value: 42,
                  writable: false,
                }
              ).prototype !== 42
            );
          });

        /***/
      },

    /***/ "./node_modules/core-js/internals/weak-map-basic-detection.js":
      /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/weak-map-basic-detection.js ***!
  \********************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );
        var isCallable = __webpack_require__(
          /*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js"
        );

        var WeakMap = global.WeakMap;

        module.exports =
          isCallable(WeakMap) && /native code/.test(String(WeakMap));

        /***/
      },

    /***/ "./node_modules/core-js/internals/well-known-symbol.js":
      /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/well-known-symbol.js ***!
  \*************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );
        var shared = __webpack_require__(
          /*! ../internals/shared */ "./node_modules/core-js/internals/shared.js"
        );
        var hasOwn = __webpack_require__(
          /*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js"
        );
        var uid = __webpack_require__(
          /*! ../internals/uid */ "./node_modules/core-js/internals/uid.js"
        );
        var NATIVE_SYMBOL = __webpack_require__(
          /*! ../internals/symbol-constructor-detection */ "./node_modules/core-js/internals/symbol-constructor-detection.js"
        );
        var USE_SYMBOL_AS_UID = __webpack_require__(
          /*! ../internals/use-symbol-as-uid */ "./node_modules/core-js/internals/use-symbol-as-uid.js"
        );

        var Symbol = global.Symbol;
        var WellKnownSymbolsStore = shared("wks");
        var createWellKnownSymbol = USE_SYMBOL_AS_UID
          ? Symbol["for"] || Symbol
          : (Symbol && Symbol.withoutSetter) || uid;

        module.exports = function (name) {
          if (!hasOwn(WellKnownSymbolsStore, name)) {
            WellKnownSymbolsStore[name] =
              NATIVE_SYMBOL && hasOwn(Symbol, name)
                ? Symbol[name]
                : createWellKnownSymbol("Symbol." + name);
          }
          return WellKnownSymbolsStore[name];
        };

        /***/
      },

    /***/ "./node_modules/core-js/modules/es.array.from.js":
      /*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.from.js ***!
  \*******************************************************/
      /***/ (
        __unused_webpack_module,
        __unused_webpack_exports,
        __webpack_require__
      ) => {
        "use strict";

        var $ = __webpack_require__(
          /*! ../internals/export */ "./node_modules/core-js/internals/export.js"
        );
        var from = __webpack_require__(
          /*! ../internals/array-from */ "./node_modules/core-js/internals/array-from.js"
        );
        var checkCorrectnessOfIteration = __webpack_require__(
          /*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js"
        );

        var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (
          iterable
        ) {
          // eslint-disable-next-line es/no-array-from -- required for testing
          Array.from(iterable);
        });

        // `Array.from` method
        // https://tc39.es/ecma262/#sec-array.from
        $(
          { target: "Array", stat: true, forced: INCORRECT_ITERATION },
          {
            from: from,
          }
        );

        /***/
      },

    /***/ "./node_modules/core-js/modules/es.array.iterator.js":
      /*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.iterator.js ***!
  \***********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var toIndexedObject = __webpack_require__(
          /*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js"
        );
        var addToUnscopables = __webpack_require__(
          /*! ../internals/add-to-unscopables */ "./node_modules/core-js/internals/add-to-unscopables.js"
        );
        var Iterators = __webpack_require__(
          /*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js"
        );
        var InternalStateModule = __webpack_require__(
          /*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js"
        );
        var defineProperty = __webpack_require__(
          /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
        ).f;
        var defineIterator = __webpack_require__(
          /*! ../internals/iterator-define */ "./node_modules/core-js/internals/iterator-define.js"
        );
        var createIterResultObject = __webpack_require__(
          /*! ../internals/create-iter-result-object */ "./node_modules/core-js/internals/create-iter-result-object.js"
        );
        var IS_PURE = __webpack_require__(
          /*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js"
        );
        var DESCRIPTORS = __webpack_require__(
          /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
        );

        var ARRAY_ITERATOR = "Array Iterator";
        var setInternalState = InternalStateModule.set;
        var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

        // `Array.prototype.entries` method
        // https://tc39.es/ecma262/#sec-array.prototype.entries
        // `Array.prototype.keys` method
        // https://tc39.es/ecma262/#sec-array.prototype.keys
        // `Array.prototype.values` method
        // https://tc39.es/ecma262/#sec-array.prototype.values
        // `Array.prototype[@@iterator]` method
        // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
        // `CreateArrayIterator` internal method
        // https://tc39.es/ecma262/#sec-createarrayiterator
        module.exports = defineIterator(
          Array,
          "Array",
          function (iterated, kind) {
            setInternalState(this, {
              type: ARRAY_ITERATOR,
              target: toIndexedObject(iterated), // target
              index: 0, // next index
              kind: kind, // kind
            });
            // `%ArrayIteratorPrototype%.next` method
            // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
          },
          function () {
            var state = getInternalState(this);
            var target = state.target;
            var index = state.index++;
            if (!target || index >= target.length) {
              state.target = undefined;
              return createIterResultObject(undefined, true);
            }
            switch (state.kind) {
              case "keys":
                return createIterResultObject(index, false);
              case "values":
                return createIterResultObject(target[index], false);
            }
            return createIterResultObject([index, target[index]], false);
          },
          "values"
        );

        // argumentsList[@@iterator] is %ArrayProto_values%
        // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
        // https://tc39.es/ecma262/#sec-createmappedargumentsobject
        var values = (Iterators.Arguments = Iterators.Array);

        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables("keys");
        addToUnscopables("values");
        addToUnscopables("entries");

        // V8 ~ Chrome 45- bug
        if (!IS_PURE && DESCRIPTORS && values.name !== "values")
          try {
            defineProperty(values, "name", { value: "values" });
          } catch (error) {
            /* empty */
          }

        /***/
      },

    /***/ "./node_modules/core-js/modules/es.map.constructor.js":
      /*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.map.constructor.js ***!
  \************************************************************/
      /***/ (
        __unused_webpack_module,
        __unused_webpack_exports,
        __webpack_require__
      ) => {
        "use strict";

        var collection = __webpack_require__(
          /*! ../internals/collection */ "./node_modules/core-js/internals/collection.js"
        );
        var collectionStrong = __webpack_require__(
          /*! ../internals/collection-strong */ "./node_modules/core-js/internals/collection-strong.js"
        );

        // `Map` constructor
        // https://tc39.es/ecma262/#sec-map-objects
        collection(
          "Map",
          function (init) {
            return function Map() {
              return init(this, arguments.length ? arguments[0] : undefined);
            };
          },
          collectionStrong
        );

        /***/
      },

    /***/ "./node_modules/core-js/modules/es.map.js":
      /*!************************************************!*\
  !*** ./node_modules/core-js/modules/es.map.js ***!
  \************************************************/
      /***/ (
        __unused_webpack_module,
        __unused_webpack_exports,
        __webpack_require__
      ) => {
        "use strict";

        // TODO: Remove this module from `core-js@4` since it's replaced to module below
        __webpack_require__(
          /*! ../modules/es.map.constructor */ "./node_modules/core-js/modules/es.map.constructor.js"
        );

        /***/
      },

    /***/ "./node_modules/core-js/modules/es.object.assign.js":
      /*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.assign.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack_module,
        __unused_webpack_exports,
        __webpack_require__
      ) => {
        "use strict";

        var $ = __webpack_require__(
          /*! ../internals/export */ "./node_modules/core-js/internals/export.js"
        );
        var assign = __webpack_require__(
          /*! ../internals/object-assign */ "./node_modules/core-js/internals/object-assign.js"
        );

        // `Object.assign` method
        // https://tc39.es/ecma262/#sec-object.assign
        // eslint-disable-next-line es/no-object-assign -- required for testing
        $(
          {
            target: "Object",
            stat: true,
            arity: 2,
            forced: Object.assign !== assign,
          },
          {
            assign: assign,
          }
        );

        /***/
      },

    /***/ "./node_modules/core-js/modules/es.object.to-string.js":
      /*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.to-string.js ***!
  \*************************************************************/
      /***/ (
        __unused_webpack_module,
        __unused_webpack_exports,
        __webpack_require__
      ) => {
        "use strict";

        var TO_STRING_TAG_SUPPORT = __webpack_require__(
          /*! ../internals/to-string-tag-support */ "./node_modules/core-js/internals/to-string-tag-support.js"
        );
        var defineBuiltIn = __webpack_require__(
          /*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js"
        );
        var toString = __webpack_require__(
          /*! ../internals/object-to-string */ "./node_modules/core-js/internals/object-to-string.js"
        );

        // `Object.prototype.toString` method
        // https://tc39.es/ecma262/#sec-object.prototype.tostring
        if (!TO_STRING_TAG_SUPPORT) {
          defineBuiltIn(Object.prototype, "toString", toString, {
            unsafe: true,
          });
        }

        /***/
      },

    /***/ "./node_modules/core-js/modules/es.set.constructor.js":
      /*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.set.constructor.js ***!
  \************************************************************/
      /***/ (
        __unused_webpack_module,
        __unused_webpack_exports,
        __webpack_require__
      ) => {
        "use strict";

        var collection = __webpack_require__(
          /*! ../internals/collection */ "./node_modules/core-js/internals/collection.js"
        );
        var collectionStrong = __webpack_require__(
          /*! ../internals/collection-strong */ "./node_modules/core-js/internals/collection-strong.js"
        );

        // `Set` constructor
        // https://tc39.es/ecma262/#sec-set-objects
        collection(
          "Set",
          function (init) {
            return function Set() {
              return init(this, arguments.length ? arguments[0] : undefined);
            };
          },
          collectionStrong
        );

        /***/
      },

    /***/ "./node_modules/core-js/modules/es.set.js":
      /*!************************************************!*\
  !*** ./node_modules/core-js/modules/es.set.js ***!
  \************************************************/
      /***/ (
        __unused_webpack_module,
        __unused_webpack_exports,
        __webpack_require__
      ) => {
        "use strict";

        // TODO: Remove this module from `core-js@4` since it's replaced to module below
        __webpack_require__(
          /*! ../modules/es.set.constructor */ "./node_modules/core-js/modules/es.set.constructor.js"
        );

        /***/
      },

    /***/ "./node_modules/core-js/modules/es.string.iterator.js":
      /*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.iterator.js ***!
  \************************************************************/
      /***/ (
        __unused_webpack_module,
        __unused_webpack_exports,
        __webpack_require__
      ) => {
        "use strict";

        var charAt = __webpack_require__(
          /*! ../internals/string-multibyte */ "./node_modules/core-js/internals/string-multibyte.js"
        ).charAt;
        var toString = __webpack_require__(
          /*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js"
        );
        var InternalStateModule = __webpack_require__(
          /*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js"
        );
        var defineIterator = __webpack_require__(
          /*! ../internals/iterator-define */ "./node_modules/core-js/internals/iterator-define.js"
        );
        var createIterResultObject = __webpack_require__(
          /*! ../internals/create-iter-result-object */ "./node_modules/core-js/internals/create-iter-result-object.js"
        );

        var STRING_ITERATOR = "String Iterator";
        var setInternalState = InternalStateModule.set;
        var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

        // `String.prototype[@@iterator]` method
        // https://tc39.es/ecma262/#sec-string.prototype-@@iterator
        defineIterator(
          String,
          "String",
          function (iterated) {
            setInternalState(this, {
              type: STRING_ITERATOR,
              string: toString(iterated),
              index: 0,
            });
            // `%StringIteratorPrototype%.next` method
            // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
          },
          function next() {
            var state = getInternalState(this);
            var string = state.string;
            var index = state.index;
            var point;
            if (index >= string.length)
              return createIterResultObject(undefined, true);
            point = charAt(string, index);
            state.index += point.length;
            return createIterResultObject(point, false);
          }
        );

        /***/
      },

    /***/ "./node_modules/core-js/modules/es.weak-map.constructor.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/core-js/modules/es.weak-map.constructor.js ***!
  \*****************************************************************/
      /***/ (
        __unused_webpack_module,
        __unused_webpack_exports,
        __webpack_require__
      ) => {
        "use strict";

        var FREEZING = __webpack_require__(
          /*! ../internals/freezing */ "./node_modules/core-js/internals/freezing.js"
        );
        var global = __webpack_require__(
          /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
        );
        var uncurryThis = __webpack_require__(
          /*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js"
        );
        var defineBuiltIns = __webpack_require__(
          /*! ../internals/define-built-ins */ "./node_modules/core-js/internals/define-built-ins.js"
        );
        var InternalMetadataModule = __webpack_require__(
          /*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js"
        );
        var collection = __webpack_require__(
          /*! ../internals/collection */ "./node_modules/core-js/internals/collection.js"
        );
        var collectionWeak = __webpack_require__(
          /*! ../internals/collection-weak */ "./node_modules/core-js/internals/collection-weak.js"
        );
        var isObject = __webpack_require__(
          /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
        );
        var enforceInternalState = __webpack_require__(
          /*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js"
        ).enforce;
        var fails = __webpack_require__(
          /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
        );
        var NATIVE_WEAK_MAP = __webpack_require__(
          /*! ../internals/weak-map-basic-detection */ "./node_modules/core-js/internals/weak-map-basic-detection.js"
        );

        var $Object = Object;
        // eslint-disable-next-line es/no-array-isarray -- safe
        var isArray = Array.isArray;
        // eslint-disable-next-line es/no-object-isextensible -- safe
        var isExtensible = $Object.isExtensible;
        // eslint-disable-next-line es/no-object-isfrozen -- safe
        var isFrozen = $Object.isFrozen;
        // eslint-disable-next-line es/no-object-issealed -- safe
        var isSealed = $Object.isSealed;
        // eslint-disable-next-line es/no-object-freeze -- safe
        var freeze = $Object.freeze;
        // eslint-disable-next-line es/no-object-seal -- safe
        var seal = $Object.seal;

        var FROZEN = {};
        var SEALED = {};
        var IS_IE11 = !global.ActiveXObject && "ActiveXObject" in global;
        var InternalWeakMap;

        var wrapper = function (init) {
          return function WeakMap() {
            return init(this, arguments.length ? arguments[0] : undefined);
          };
        };

        // `WeakMap` constructor
        // https://tc39.es/ecma262/#sec-weakmap-constructor
        var $WeakMap = collection("WeakMap", wrapper, collectionWeak);
        var WeakMapPrototype = $WeakMap.prototype;
        var nativeSet = uncurryThis(WeakMapPrototype.set);

        // Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
        var hasMSEdgeFreezingBug = function () {
          return (
            FREEZING &&
            fails(function () {
              var frozenArray = freeze([]);
              nativeSet(new $WeakMap(), frozenArray, 1);
              return !isFrozen(frozenArray);
            })
          );
        };

        // IE11 WeakMap frozen keys fix
        // We can't use feature detection because it crash some old IE builds
        // https://github.com/zloirock/core-js/issues/485
        if (NATIVE_WEAK_MAP)
          if (IS_IE11) {
            InternalWeakMap = collectionWeak.getConstructor(
              wrapper,
              "WeakMap",
              true
            );
            InternalMetadataModule.enable();
            var nativeDelete = uncurryThis(WeakMapPrototype["delete"]);
            var nativeHas = uncurryThis(WeakMapPrototype.has);
            var nativeGet = uncurryThis(WeakMapPrototype.get);
            defineBuiltIns(WeakMapPrototype, {
              delete: function (key) {
                if (isObject(key) && !isExtensible(key)) {
                  var state = enforceInternalState(this);
                  if (!state.frozen) state.frozen = new InternalWeakMap();
                  return nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return nativeDelete(this, key);
              },
              has: function has(key) {
                if (isObject(key) && !isExtensible(key)) {
                  var state = enforceInternalState(this);
                  if (!state.frozen) state.frozen = new InternalWeakMap();
                  return nativeHas(this, key) || state.frozen.has(key);
                }
                return nativeHas(this, key);
              },
              get: function get(key) {
                if (isObject(key) && !isExtensible(key)) {
                  var state = enforceInternalState(this);
                  if (!state.frozen) state.frozen = new InternalWeakMap();
                  return nativeHas(this, key)
                    ? nativeGet(this, key)
                    : state.frozen.get(key);
                }
                return nativeGet(this, key);
              },
              set: function set(key, value) {
                if (isObject(key) && !isExtensible(key)) {
                  var state = enforceInternalState(this);
                  if (!state.frozen) state.frozen = new InternalWeakMap();
                  nativeHas(this, key)
                    ? nativeSet(this, key, value)
                    : state.frozen.set(key, value);
                } else nativeSet(this, key, value);
                return this;
              },
            });
            // Chakra Edge frozen keys fix
          } else if (hasMSEdgeFreezingBug()) {
            defineBuiltIns(WeakMapPrototype, {
              set: function set(key, value) {
                var arrayIntegrityLevel;
                if (isArray(key)) {
                  if (isFrozen(key)) arrayIntegrityLevel = FROZEN;
                  else if (isSealed(key)) arrayIntegrityLevel = SEALED;
                }
                nativeSet(this, key, value);
                if (arrayIntegrityLevel === FROZEN) freeze(key);
                if (arrayIntegrityLevel === SEALED) seal(key);
                return this;
              },
            });
          }

        /***/
      },

    /***/ "./node_modules/core-js/modules/es.weak-map.js":
      /*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/es.weak-map.js ***!
  \*****************************************************/
      /***/ (
        __unused_webpack_module,
        __unused_webpack_exports,
        __webpack_require__
      ) => {
        "use strict";

        // TODO: Remove this module from `core-js@4` since it's replaced to module below
        __webpack_require__(
          /*! ../modules/es.weak-map.constructor */ "./node_modules/core-js/modules/es.weak-map.constructor.js"
        );

        /***/
      },

    /***/ "./node_modules/axios/lib/adapters/adapters.js":
      /*!*****************************************************!*\
  !*** ./node_modules/axios/lib/adapters/adapters.js ***!
  \*****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _http_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./http.js */ "./node_modules/axios/lib/helpers/null.js"
          );
        /* harmony import */ var _xhr_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./xhr.js */ "./node_modules/axios/lib/adapters/xhr.js"
          );
        /* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js"
          );

        const knownAdapters = {
          http: _http_js__WEBPACK_IMPORTED_MODULE_0__["default"],
          xhr: _xhr_js__WEBPACK_IMPORTED_MODULE_1__["default"],
        };

        _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(
          knownAdapters,
          (fn, value) => {
            if (fn) {
              try {
                Object.defineProperty(fn, "name", { value });
              } catch (e) {
                // eslint-disable-next-line no-empty
              }
              Object.defineProperty(fn, "adapterName", { value });
            }
          }
        );

        const renderReason = (reason) => `- ${reason}`;

        const isResolvedHandle = (adapter) =>
          _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isFunction(
            adapter
          ) ||
          adapter === null ||
          adapter === false;

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          getAdapter: (adapters) => {
            adapters = _utils_js__WEBPACK_IMPORTED_MODULE_2__[
              "default"
            ].isArray(adapters)
              ? adapters
              : [adapters];

            const { length } = adapters;
            let nameOrAdapter;
            let adapter;

            const rejectedReasons = {};

            for (let i = 0; i < length; i++) {
              nameOrAdapter = adapters[i];
              let id;

              adapter = nameOrAdapter;

              if (!isResolvedHandle(nameOrAdapter)) {
                adapter =
                  knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

                if (adapter === undefined) {
                  throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__[
                    "default"
                  ](`Unknown adapter '${id}'`);
                }
              }

              if (adapter) {
                break;
              }

              rejectedReasons[id || "#" + i] = adapter;
            }

            if (!adapter) {
              const reasons = Object.entries(rejectedReasons).map(
                ([id, state]) =>
                  `adapter ${id} ` +
                  (state === false
                    ? "is not supported by the environment"
                    : "is not available in the build")
              );

              let s = length
                ? reasons.length > 1
                  ? "since :\n" + reasons.map(renderReason).join("\n")
                  : " " + renderReason(reasons[0])
                : "as no adapter specified";

              throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__[
                "default"
              ](
                `There is no suitable adapter to dispatch the request ` + s,
                "ERR_NOT_SUPPORT"
              );
            }

            return adapter;
          },
          adapters: knownAdapters,
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/adapters/xhr.js":
      /*!************************************************!*\
  !*** ./node_modules/axios/lib/adapters/xhr.js ***!
  \************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./../utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _core_settle_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./../core/settle.js */ "./node_modules/axios/lib/core/settle.js"
          );
        /* harmony import */ var _helpers_cookies_js__WEBPACK_IMPORTED_MODULE_10__ =
          __webpack_require__(
            /*! ./../helpers/cookies.js */ "./node_modules/axios/lib/helpers/cookies.js"
          );
        /* harmony import */ var _helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./../helpers/buildURL.js */ "./node_modules/axios/lib/helpers/buildURL.js"
          );
        /* harmony import */ var _core_buildFullPath_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ../core/buildFullPath.js */ "./node_modules/axios/lib/core/buildFullPath.js"
          );
        /* harmony import */ var _helpers_isURLSameOrigin_js__WEBPACK_IMPORTED_MODULE_9__ =
          __webpack_require__(
            /*! ./../helpers/isURLSameOrigin.js */ "./node_modules/axios/lib/helpers/isURLSameOrigin.js"
          );
        /* harmony import */ var _defaults_transitional_js__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! ../defaults/transitional.js */ "./node_modules/axios/lib/defaults/transitional.js"
          );
        /* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js"
          );
        /* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_11__ =
          __webpack_require__(
            /*! ../cancel/CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js"
          );
        /* harmony import */ var _helpers_parseProtocol_js__WEBPACK_IMPORTED_MODULE_12__ =
          __webpack_require__(
            /*! ../helpers/parseProtocol.js */ "./node_modules/axios/lib/helpers/parseProtocol.js"
          );
        /* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js"
          );
        /* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js"
          );
        /* harmony import */ var _helpers_speedometer_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../helpers/speedometer.js */ "./node_modules/axios/lib/helpers/speedometer.js"
          );

        function progressEventReducer(listener, isDownloadStream) {
          let bytesNotified = 0;
          const _speedometer = (0,
          _helpers_speedometer_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            50,
            250
          );

          return (e) => {
            const loaded = e.loaded;
            const total = e.lengthComputable ? e.total : undefined;
            const progressBytes = loaded - bytesNotified;
            const rate = _speedometer(progressBytes);
            const inRange = loaded <= total;

            bytesNotified = loaded;

            const data = {
              loaded,
              total,
              progress: total ? loaded / total : undefined,
              bytes: progressBytes,
              rate: rate ? rate : undefined,
              estimated:
                rate && total && inRange ? (total - loaded) / rate : undefined,
              event: e,
            };

            data[isDownloadStream ? "download" : "upload"] = true;

            listener(data);
          };
        }

        const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          isXHRAdapterSupported &&
          function (config) {
            return new Promise(function dispatchXhrRequest(resolve, reject) {
              let requestData = config.data;
              const requestHeaders =
                _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"]
                  .from(config.headers)
                  .normalize();
              const responseType = config.responseType;
              let onCanceled;
              function done() {
                if (config.cancelToken) {
                  config.cancelToken.unsubscribe(onCanceled);
                }

                if (config.signal) {
                  config.signal.removeEventListener("abort", onCanceled);
                }
              }

              let contentType;

              if (
                _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isFormData(
                  requestData
                )
              ) {
                if (
                  _platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"]
                    .isStandardBrowserEnv ||
                  _platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"]
                    .isStandardBrowserWebWorkerEnv
                ) {
                  requestHeaders.setContentType(false); // Let the browser set it
                } else if (
                  !requestHeaders.getContentType(/^\s*multipart\/form-data/)
                ) {
                  requestHeaders.setContentType("multipart/form-data"); // mobile/desktop app frameworks
                } else if (
                  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isString(
                    (contentType = requestHeaders.getContentType())
                  )
                ) {
                  // fix semicolon duplication issue for ReactNative FormData implementation
                  requestHeaders.setContentType(
                    contentType.replace(/^\s*(multipart\/form-data);+/, "$1")
                  );
                }
              }

              let request = new XMLHttpRequest();

              // HTTP basic authentication
              if (config.auth) {
                const username = config.auth.username || "";
                const password = config.auth.password
                  ? unescape(encodeURIComponent(config.auth.password))
                  : "";
                requestHeaders.set(
                  "Authorization",
                  "Basic " + btoa(username + ":" + password)
                );
              }

              const fullPath = (0,
              _core_buildFullPath_js__WEBPACK_IMPORTED_MODULE_4__["default"])(
                config.baseURL,
                config.url
              );

              request.open(
                config.method.toUpperCase(),
                (0,
                _helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_5__["default"])(
                  fullPath,
                  config.params,
                  config.paramsSerializer
                ),
                true
              );

              // Set the request timeout in MS
              request.timeout = config.timeout;

              function onloadend() {
                if (!request) {
                  return;
                }
                // Prepare the response
                const responseHeaders =
                  _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__[
                    "default"
                  ].from(
                    "getAllResponseHeaders" in request &&
                      request.getAllResponseHeaders()
                  );
                const responseData =
                  !responseType ||
                  responseType === "text" ||
                  responseType === "json"
                    ? request.responseText
                    : request.response;
                const response = {
                  data: responseData,
                  status: request.status,
                  statusText: request.statusText,
                  headers: responseHeaders,
                  config,
                  request,
                };

                (0, _core_settle_js__WEBPACK_IMPORTED_MODULE_6__["default"])(
                  function _resolve(value) {
                    resolve(value);
                    done();
                  },
                  function _reject(err) {
                    reject(err);
                    done();
                  },
                  response
                );

                // Clean up request
                request = null;
              }

              if ("onloadend" in request) {
                // Use onloadend if available
                request.onloadend = onloadend;
              } else {
                // Listen for ready state to emulate onloadend
                request.onreadystatechange = function handleLoad() {
                  if (!request || request.readyState !== 4) {
                    return;
                  }

                  // The request errored out and we didn't get a response, this will be
                  // handled by onerror instead
                  // With one exception: request that using file: protocol, most browsers
                  // will return status as 0 even though it's a successful request
                  if (
                    request.status === 0 &&
                    !(
                      request.responseURL &&
                      request.responseURL.indexOf("file:") === 0
                    )
                  ) {
                    return;
                  }
                  // readystate handler is calling before onerror or ontimeout handlers,
                  // so we should call onloadend on the next 'tick'
                  setTimeout(onloadend);
                };
              }

              // Handle browser request cancellation (as opposed to a manual cancellation)
              request.onabort = function handleAbort() {
                if (!request) {
                  return;
                }

                reject(
                  new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__[
                    "default"
                  ](
                    "Request aborted",
                    _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__[
                      "default"
                    ].ECONNABORTED,
                    config,
                    request
                  )
                );

                // Clean up request
                request = null;
              };

              // Handle low level network errors
              request.onerror = function handleError() {
                // Real errors are hidden from us by the browser
                // onerror should only fire if it's a network error
                reject(
                  new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__[
                    "default"
                  ](
                    "Network Error",
                    _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__[
                      "default"
                    ].ERR_NETWORK,
                    config,
                    request
                  )
                );

                // Clean up request
                request = null;
              };

              // Handle timeout
              request.ontimeout = function handleTimeout() {
                let timeoutErrorMessage = config.timeout
                  ? "timeout of " + config.timeout + "ms exceeded"
                  : "timeout exceeded";
                const transitional =
                  config.transitional ||
                  _defaults_transitional_js__WEBPACK_IMPORTED_MODULE_8__[
                    "default"
                  ];
                if (config.timeoutErrorMessage) {
                  timeoutErrorMessage = config.timeoutErrorMessage;
                }
                reject(
                  new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__[
                    "default"
                  ](
                    timeoutErrorMessage,
                    transitional.clarifyTimeoutError
                      ? _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__[
                          "default"
                        ].ETIMEDOUT
                      : _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__[
                          "default"
                        ].ECONNABORTED,
                    config,
                    request
                  )
                );

                // Clean up request
                request = null;
              };

              // Add xsrf header
              // This is only done if running in a standard browser environment.
              // Specifically not if we're in a web worker, or react-native.
              if (
                _platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"]
                  .isStandardBrowserEnv
              ) {
                // Add xsrf header
                // regarding CVE-2023-45857 config.withCredentials condition was removed temporarily
                const xsrfValue =
                  (0,
                  _helpers_isURLSameOrigin_js__WEBPACK_IMPORTED_MODULE_9__[
                    "default"
                  ])(fullPath) &&
                  config.xsrfCookieName &&
                  _helpers_cookies_js__WEBPACK_IMPORTED_MODULE_10__[
                    "default"
                  ].read(config.xsrfCookieName);

                if (xsrfValue) {
                  requestHeaders.set(config.xsrfHeaderName, xsrfValue);
                }
              }

              // Remove Content-Type if data is undefined
              requestData === undefined && requestHeaders.setContentType(null);

              // Add headers to the request
              if ("setRequestHeader" in request) {
                _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(
                  requestHeaders.toJSON(),
                  function setRequestHeader(val, key) {
                    request.setRequestHeader(key, val);
                  }
                );
              }

              // Add withCredentials to request if needed
              if (
                !_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isUndefined(
                  config.withCredentials
                )
              ) {
                request.withCredentials = !!config.withCredentials;
              }

              // Add responseType to request if needed
              if (responseType && responseType !== "json") {
                request.responseType = config.responseType;
              }

              // Handle progress if needed
              if (typeof config.onDownloadProgress === "function") {
                request.addEventListener(
                  "progress",
                  progressEventReducer(config.onDownloadProgress, true)
                );
              }

              // Not all browsers support upload events
              if (
                typeof config.onUploadProgress === "function" &&
                request.upload
              ) {
                request.upload.addEventListener(
                  "progress",
                  progressEventReducer(config.onUploadProgress)
                );
              }

              if (config.cancelToken || config.signal) {
                // Handle cancellation
                // eslint-disable-next-line func-names
                onCanceled = (cancel) => {
                  if (!request) {
                    return;
                  }
                  reject(
                    !cancel || cancel.type
                      ? new _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_11__[
                          "default"
                        ](null, config, request)
                      : cancel
                  );
                  request.abort();
                  request = null;
                };

                config.cancelToken && config.cancelToken.subscribe(onCanceled);
                if (config.signal) {
                  config.signal.aborted
                    ? onCanceled()
                    : config.signal.addEventListener("abort", onCanceled);
                }
              }

              const protocol = (0,
              _helpers_parseProtocol_js__WEBPACK_IMPORTED_MODULE_12__[
                "default"
              ])(fullPath);

              if (
                protocol &&
                _platform_index_js__WEBPACK_IMPORTED_MODULE_3__[
                  "default"
                ].protocols.indexOf(protocol) === -1
              ) {
                reject(
                  new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__[
                    "default"
                  ](
                    "Unsupported protocol " + protocol + ":",
                    _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__[
                      "default"
                    ].ERR_BAD_REQUEST,
                    config
                  )
                );
                return;
              }

              // Send the request
              request.send(requestData || null);
            });
          };

        /***/
      },

    /***/ "./node_modules/axios/lib/axios.js":
      /*!*****************************************!*\
  !*** ./node_modules/axios/lib/axios.js ***!
  \*****************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _helpers_bind_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./helpers/bind.js */ "./node_modules/axios/lib/helpers/bind.js"
          );
        /* harmony import */ var _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./core/Axios.js */ "./node_modules/axios/lib/core/Axios.js"
          );
        /* harmony import */ var _core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./core/mergeConfig.js */ "./node_modules/axios/lib/core/mergeConfig.js"
          );
        /* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./defaults/index.js */ "./node_modules/axios/lib/defaults/index.js"
          );
        /* harmony import */ var _helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_14__ =
          __webpack_require__(
            /*! ./helpers/formDataToJSON.js */ "./node_modules/axios/lib/helpers/formDataToJSON.js"
          );
        /* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./cancel/CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js"
          );
        /* harmony import */ var _cancel_CancelToken_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./cancel/CancelToken.js */ "./node_modules/axios/lib/cancel/CancelToken.js"
          );
        /* harmony import */ var _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ./cancel/isCancel.js */ "./node_modules/axios/lib/cancel/isCancel.js"
          );
        /* harmony import */ var _env_data_js__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! ./env/data.js */ "./node_modules/axios/lib/env/data.js"
          );
        /* harmony import */ var _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_9__ =
          __webpack_require__(
            /*! ./helpers/toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js"
          );
        /* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_10__ =
          __webpack_require__(
            /*! ./core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js"
          );
        /* harmony import */ var _helpers_spread_js__WEBPACK_IMPORTED_MODULE_11__ =
          __webpack_require__(
            /*! ./helpers/spread.js */ "./node_modules/axios/lib/helpers/spread.js"
          );
        /* harmony import */ var _helpers_isAxiosError_js__WEBPACK_IMPORTED_MODULE_12__ =
          __webpack_require__(
            /*! ./helpers/isAxiosError.js */ "./node_modules/axios/lib/helpers/isAxiosError.js"
          );
        /* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_13__ =
          __webpack_require__(
            /*! ./core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js"
          );
        /* harmony import */ var _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_15__ =
          __webpack_require__(
            /*! ./adapters/adapters.js */ "./node_modules/axios/lib/adapters/adapters.js"
          );
        /* harmony import */ var _helpers_HttpStatusCode_js__WEBPACK_IMPORTED_MODULE_16__ =
          __webpack_require__(
            /*! ./helpers/HttpStatusCode.js */ "./node_modules/axios/lib/helpers/HttpStatusCode.js"
          );

        /**
         * Create an instance of Axios
         *
         * @param {Object} defaultConfig The default config for the instance
         *
         * @returns {Axios} A new instance of Axios
         */
        function createInstance(defaultConfig) {
          const context = new _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__[
            "default"
          ](defaultConfig);
          const instance = (0,
          _helpers_bind_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
            _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype
              .request,
            context
          );

          // Copy axios.prototype to instance
          _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].extend(
            instance,
            _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype,
            context,
            { allOwnKeys: true }
          );

          // Copy context to instance
          _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].extend(
            instance,
            context,
            null,
            { allOwnKeys: true }
          );

          // Factory for creating new instances
          instance.create = function create(instanceConfig) {
            return createInstance(
              (0, _core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
                defaultConfig,
                instanceConfig
              )
            );
          };

          return instance;
        }

        // Create the default instance to be exported
        const axios = createInstance(
          _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__["default"]
        );

        // Expose Axios class to allow class inheritance
        axios.Axios = _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"];

        // Expose Cancel & CancelToken
        axios.CanceledError =
          _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_5__["default"];
        axios.CancelToken =
          _cancel_CancelToken_js__WEBPACK_IMPORTED_MODULE_6__["default"];
        axios.isCancel =
          _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_7__["default"];
        axios.VERSION = _env_data_js__WEBPACK_IMPORTED_MODULE_8__.VERSION;
        axios.toFormData =
          _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_9__["default"];

        // Expose AxiosError class
        axios.AxiosError =
          _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_10__["default"];

        // alias for CanceledError for backward compatibility
        axios.Cancel = axios.CanceledError;

        // Expose all/spread
        axios.all = function all(promises) {
          return Promise.all(promises);
        };

        axios.spread =
          _helpers_spread_js__WEBPACK_IMPORTED_MODULE_11__["default"];

        // Expose isAxiosError
        axios.isAxiosError =
          _helpers_isAxiosError_js__WEBPACK_IMPORTED_MODULE_12__["default"];

        // Expose mergeConfig
        axios.mergeConfig =
          _core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__["default"];

        axios.AxiosHeaders =
          _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_13__["default"];

        axios.formToJSON = (thing) =>
          (0,
          _helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_14__["default"])(
            _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isHTMLForm(thing)
              ? new FormData(thing)
              : thing
          );

        axios.getAdapter =
          _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_15__[
            "default"
          ].getAdapter;

        axios.HttpStatusCode =
          _helpers_HttpStatusCode_js__WEBPACK_IMPORTED_MODULE_16__["default"];

        axios.default = axios;

        // this module should only have a default export
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = axios;

        /***/
      },

    /***/ "./node_modules/axios/lib/cancel/CancelToken.js":
      /*!******************************************************!*\
  !*** ./node_modules/axios/lib/cancel/CancelToken.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _CanceledError_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js"
          );

        /**
         * A `CancelToken` is an object that can be used to request cancellation of an operation.
         *
         * @param {Function} executor The executor function.
         *
         * @returns {CancelToken}
         */
        class CancelToken {
          constructor(executor) {
            if (typeof executor !== "function") {
              throw new TypeError("executor must be a function.");
            }

            let resolvePromise;

            this.promise = new Promise(function promiseExecutor(resolve) {
              resolvePromise = resolve;
            });

            const token = this;

            // eslint-disable-next-line func-names
            this.promise.then((cancel) => {
              if (!token._listeners) return;

              let i = token._listeners.length;

              while (i-- > 0) {
                token._listeners[i](cancel);
              }
              token._listeners = null;
            });

            // eslint-disable-next-line func-names
            this.promise.then = (onfulfilled) => {
              let _resolve;
              // eslint-disable-next-line func-names
              const promise = new Promise((resolve) => {
                token.subscribe(resolve);
                _resolve = resolve;
              }).then(onfulfilled);

              promise.cancel = function reject() {
                token.unsubscribe(_resolve);
              };

              return promise;
            };

            executor(function cancel(message, config, request) {
              if (token.reason) {
                // Cancellation has already been requested
                return;
              }

              token.reason = new _CanceledError_js__WEBPACK_IMPORTED_MODULE_0__[
                "default"
              ](message, config, request);
              resolvePromise(token.reason);
            });
          }

          /**
           * Throws a `CanceledError` if cancellation has been requested.
           */
          throwIfRequested() {
            if (this.reason) {
              throw this.reason;
            }
          }

          /**
           * Subscribe to the cancel signal
           */

          subscribe(listener) {
            if (this.reason) {
              listener(this.reason);
              return;
            }

            if (this._listeners) {
              this._listeners.push(listener);
            } else {
              this._listeners = [listener];
            }
          }

          /**
           * Unsubscribe from the cancel signal
           */

          unsubscribe(listener) {
            if (!this._listeners) {
              return;
            }
            const index = this._listeners.indexOf(listener);
            if (index !== -1) {
              this._listeners.splice(index, 1);
            }
          }

          /**
           * Returns an object that contains a new `CancelToken` and a function that, when called,
           * cancels the `CancelToken`.
           */
          static source() {
            let cancel;
            const token = new CancelToken(function executor(c) {
              cancel = c;
            });
            return {
              token,
              cancel,
            };
          }
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          CancelToken;

        /***/
      },

    /***/ "./node_modules/axios/lib/cancel/CanceledError.js":
      /*!********************************************************!*\
  !*** ./node_modules/axios/lib/cancel/CanceledError.js ***!
  \********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js"
          );
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../utils.js */ "./node_modules/axios/lib/utils.js"
          );

        /**
         * A `CanceledError` is an object that is thrown when an operation is canceled.
         *
         * @param {string=} message The message.
         * @param {Object=} config The config.
         * @param {Object=} request The request.
         *
         * @returns {CanceledError} The created error.
         */
        function CanceledError(message, config, request) {
          // eslint-disable-next-line no-eq-null,eqeqeq
          _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].call(
            this,
            message == null ? "canceled" : message,
            _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"]
              .ERR_CANCELED,
            config,
            request
          );
          this.name = "CanceledError";
        }

        _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].inherits(
          CanceledError,
          _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"],
          {
            __CANCEL__: true,
          }
        );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          CanceledError;

        /***/
      },

    /***/ "./node_modules/axios/lib/cancel/isCancel.js":
      /*!***************************************************!*\
  !*** ./node_modules/axios/lib/cancel/isCancel.js ***!
  \***************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ isCancel,
          /* harmony export */
        });

        function isCancel(value) {
          return !!(value && value.__CANCEL__);
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/core/Axios.js":
      /*!**********************************************!*\
  !*** ./node_modules/axios/lib/core/Axios.js ***!
  \**********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./../utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ../helpers/buildURL.js */ "./node_modules/axios/lib/helpers/buildURL.js"
          );
        /* harmony import */ var _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./InterceptorManager.js */ "./node_modules/axios/lib/core/InterceptorManager.js"
          );
        /* harmony import */ var _dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./dispatchRequest.js */ "./node_modules/axios/lib/core/dispatchRequest.js"
          );
        /* harmony import */ var _mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./mergeConfig.js */ "./node_modules/axios/lib/core/mergeConfig.js"
          );
        /* harmony import */ var _buildFullPath_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./buildFullPath.js */ "./node_modules/axios/lib/core/buildFullPath.js"
          );
        /* harmony import */ var _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../helpers/validator.js */ "./node_modules/axios/lib/helpers/validator.js"
          );
        /* harmony import */ var _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js"
          );

        const validators =
          _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"]
            .validators;

        /**
         * Create a new instance of Axios
         *
         * @param {Object} instanceConfig The default config for the instance
         *
         * @return {Axios} A new instance of Axios
         */
        class Axios {
          constructor(instanceConfig) {
            this.defaults = instanceConfig;
            this.interceptors = {
              request: new _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__[
                "default"
              ](),
              response: new _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__[
                "default"
              ](),
            };
          }

          /**
           * Dispatch a request
           *
           * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
           * @param {?Object} config
           *
           * @returns {Promise} The Promise to be fulfilled
           */
          request(configOrUrl, config) {
            /*eslint no-param-reassign:0*/
            // Allow for axios('example/url'[, config]) a la fetch API
            if (typeof configOrUrl === "string") {
              config = config || {};
              config.url = configOrUrl;
            } else {
              config = configOrUrl || {};
            }

            config = (0,
            _mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
              this.defaults,
              config
            );

            const { transitional, paramsSerializer, headers } = config;

            if (transitional !== undefined) {
              _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__[
                "default"
              ].assertOptions(
                transitional,
                {
                  silentJSONParsing: validators.transitional(
                    validators.boolean
                  ),
                  forcedJSONParsing: validators.transitional(
                    validators.boolean
                  ),
                  clarifyTimeoutError: validators.transitional(
                    validators.boolean
                  ),
                },
                false
              );
            }

            if (paramsSerializer != null) {
              if (
                _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].isFunction(
                  paramsSerializer
                )
              ) {
                config.paramsSerializer = {
                  serialize: paramsSerializer,
                };
              } else {
                _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__[
                  "default"
                ].assertOptions(
                  paramsSerializer,
                  {
                    encode: validators.function,
                    serialize: validators.function,
                  },
                  true
                );
              }
            }

            // Set config.method
            config.method = (
              config.method ||
              this.defaults.method ||
              "get"
            ).toLowerCase();

            // Flatten headers
            let contextHeaders =
              headers &&
              _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(
                headers.common,
                headers[config.method]
              );

            headers &&
              _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(
                ["delete", "get", "head", "post", "put", "patch", "common"],
                (method) => {
                  delete headers[method];
                }
              );

            config.headers = _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_4__[
              "default"
            ].concat(contextHeaders, headers);

            // filter out skipped interceptors
            const requestInterceptorChain = [];
            let synchronousRequestInterceptors = true;
            this.interceptors.request.forEach(
              function unshiftRequestInterceptors(interceptor) {
                if (
                  typeof interceptor.runWhen === "function" &&
                  interceptor.runWhen(config) === false
                ) {
                  return;
                }

                synchronousRequestInterceptors =
                  synchronousRequestInterceptors && interceptor.synchronous;

                requestInterceptorChain.unshift(
                  interceptor.fulfilled,
                  interceptor.rejected
                );
              }
            );

            const responseInterceptorChain = [];
            this.interceptors.response.forEach(
              function pushResponseInterceptors(interceptor) {
                responseInterceptorChain.push(
                  interceptor.fulfilled,
                  interceptor.rejected
                );
              }
            );

            let promise;
            let i = 0;
            let len;

            if (!synchronousRequestInterceptors) {
              const chain = [
                _dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__[
                  "default"
                ].bind(this),
                undefined,
              ];
              chain.unshift.apply(chain, requestInterceptorChain);
              chain.push.apply(chain, responseInterceptorChain);
              len = chain.length;

              promise = Promise.resolve(config);

              while (i < len) {
                promise = promise.then(chain[i++], chain[i++]);
              }

              return promise;
            }

            len = requestInterceptorChain.length;

            let newConfig = config;

            i = 0;

            while (i < len) {
              const onFulfilled = requestInterceptorChain[i++];
              const onRejected = requestInterceptorChain[i++];
              try {
                newConfig = onFulfilled(newConfig);
              } catch (error) {
                onRejected.call(this, error);
                break;
              }
            }

            try {
              promise = _dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__[
                "default"
              ].call(this, newConfig);
            } catch (error) {
              return Promise.reject(error);
            }

            i = 0;
            len = responseInterceptorChain.length;

            while (i < len) {
              promise = promise.then(
                responseInterceptorChain[i++],
                responseInterceptorChain[i++]
              );
            }

            return promise;
          }

          getUri(config) {
            config = (0,
            _mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
              this.defaults,
              config
            );
            const fullPath = (0,
            _buildFullPath_js__WEBPACK_IMPORTED_MODULE_6__["default"])(
              config.baseURL,
              config.url
            );
            return (0,
            _helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_7__["default"])(
              fullPath,
              config.params,
              config.paramsSerializer
            );
          }
        }

        // Provide aliases for supported request methods
        _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(
          ["delete", "get", "head", "options"],
          function forEachMethodNoData(method) {
            /*eslint func-names:0*/
            Axios.prototype[method] = function (url, config) {
              return this.request(
                (0, _mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
                  config || {},
                  {
                    method,
                    url,
                    data: (config || {}).data,
                  }
                )
              );
            };
          }
        );

        _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(
          ["post", "put", "patch"],
          function forEachMethodWithData(method) {
            /*eslint func-names:0*/

            function generateHTTPMethod(isForm) {
              return function httpMethod(url, data, config) {
                return this.request(
                  (0, _mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
                    config || {},
                    {
                      method,
                      headers: isForm
                        ? {
                            "Content-Type": "multipart/form-data",
                          }
                        : {},
                      url,
                      data,
                    }
                  )
                );
              };
            }

            Axios.prototype[method] = generateHTTPMethod();

            Axios.prototype[method + "Form"] = generateHTTPMethod(true);
          }
        );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = Axios;

        /***/
      },

    /***/ "./node_modules/axios/lib/core/AxiosError.js":
      /*!***************************************************!*\
  !*** ./node_modules/axios/lib/core/AxiosError.js ***!
  \***************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils.js */ "./node_modules/axios/lib/utils.js"
          );

        /**
         * Create an Error with the specified message, config, error code, request and response.
         *
         * @param {string} message The error message.
         * @param {string} [code] The error code (for example, 'ECONNABORTED').
         * @param {Object} [config] The config.
         * @param {Object} [request] The request.
         * @param {Object} [response] The response.
         *
         * @returns {Error} The created error.
         */
        function AxiosError(message, code, config, request, response) {
          Error.call(this);

          if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
          } else {
            this.stack = new Error().stack;
          }

          this.message = message;
          this.name = "AxiosError";
          code && (this.code = code);
          config && (this.config = config);
          request && (this.request = request);
          response && (this.response = response);
        }

        _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].inherits(
          AxiosError,
          Error,
          {
            toJSON: function toJSON() {
              return {
                // Standard
                message: this.message,
                name: this.name,
                // Microsoft
                description: this.description,
                number: this.number,
                // Mozilla
                fileName: this.fileName,
                lineNumber: this.lineNumber,
                columnNumber: this.columnNumber,
                stack: this.stack,
                // Axios
                config: _utils_js__WEBPACK_IMPORTED_MODULE_0__[
                  "default"
                ].toJSONObject(this.config),
                code: this.code,
                status:
                  this.response && this.response.status
                    ? this.response.status
                    : null,
              };
            },
          }
        );

        const prototype = AxiosError.prototype;
        const descriptors = {};

        [
          "ERR_BAD_OPTION_VALUE",
          "ERR_BAD_OPTION",
          "ECONNABORTED",
          "ETIMEDOUT",
          "ERR_NETWORK",
          "ERR_FR_TOO_MANY_REDIRECTS",
          "ERR_DEPRECATED",
          "ERR_BAD_RESPONSE",
          "ERR_BAD_REQUEST",
          "ERR_CANCELED",
          "ERR_NOT_SUPPORT",
          "ERR_INVALID_URL",
          // eslint-disable-next-line func-names
        ].forEach((code) => {
          descriptors[code] = { value: code };
        });

        Object.defineProperties(AxiosError, descriptors);
        Object.defineProperty(prototype, "isAxiosError", { value: true });

        // eslint-disable-next-line func-names
        AxiosError.from = (
          error,
          code,
          config,
          request,
          response,
          customProps
        ) => {
          const axiosError = Object.create(prototype);

          _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(
            error,
            axiosError,
            function filter(obj) {
              return obj !== Error.prototype;
            },
            (prop) => {
              return prop !== "isAxiosError";
            }
          );

          AxiosError.call(
            axiosError,
            error.message,
            code,
            config,
            request,
            response
          );

          axiosError.cause = error;

          axiosError.name = error.name;

          customProps && Object.assign(axiosError, customProps);

          return axiosError;
        };

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          AxiosError;

        /***/
      },

    /***/ "./node_modules/axios/lib/core/AxiosHeaders.js":
      /*!*****************************************************!*\
  !*** ./node_modules/axios/lib/core/AxiosHeaders.js ***!
  \*****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _helpers_parseHeaders_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../helpers/parseHeaders.js */ "./node_modules/axios/lib/helpers/parseHeaders.js"
          );

        const $internals = Symbol("internals");

        function normalizeHeader(header) {
          return header && String(header).trim().toLowerCase();
        }

        function normalizeValue(value) {
          if (value === false || value == null) {
            return value;
          }

          return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(
            value
          )
            ? value.map(normalizeValue)
            : String(value);
        }

        function parseTokens(str) {
          const tokens = Object.create(null);
          const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
          let match;

          while ((match = tokensRE.exec(str))) {
            tokens[match[1]] = match[2];
          }

          return tokens;
        }

        const isValidHeaderName = (str) =>
          /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

        function matchHeaderValue(
          context,
          value,
          header,
          filter,
          isHeaderNameFilter
        ) {
          if (
            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(filter)
          ) {
            return filter.call(this, value, header);
          }

          if (isHeaderNameFilter) {
            value = header;
          }

          if (
            !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(value)
          )
            return;

          if (
            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(filter)
          ) {
            return value.indexOf(filter) !== -1;
          }

          if (
            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isRegExp(filter)
          ) {
            return filter.test(value);
          }
        }

        function formatHeader(header) {
          return header
            .trim()
            .toLowerCase()
            .replace(/([a-z\d])(\w*)/g, (w, char, str) => {
              return char.toUpperCase() + str;
            });
        }

        function buildAccessors(obj, header) {
          const accessorName = _utils_js__WEBPACK_IMPORTED_MODULE_0__[
            "default"
          ].toCamelCase(" " + header);

          ["get", "set", "has"].forEach((methodName) => {
            Object.defineProperty(obj, methodName + accessorName, {
              value: function (arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
              },
              configurable: true,
            });
          });
        }

        class AxiosHeaders {
          constructor(headers) {
            headers && this.set(headers);
          }

          set(header, valueOrRewrite, rewrite) {
            const self = this;

            function setHeader(_value, _header, _rewrite) {
              const lHeader = normalizeHeader(_header);

              if (!lHeader) {
                throw new Error("header name must be a non-empty string");
              }

              const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__[
                "default"
              ].findKey(self, lHeader);

              if (
                !key ||
                self[key] === undefined ||
                _rewrite === true ||
                (_rewrite === undefined && self[key] !== false)
              ) {
                self[key || _header] = normalizeValue(_value);
              }
            }

            const setHeaders = (headers, _rewrite) =>
              _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(
                headers,
                (_value, _header) => setHeader(_value, _header, _rewrite)
              );

            if (
              _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(
                header
              ) ||
              header instanceof this.constructor
            ) {
              setHeaders(header, valueOrRewrite);
            } else if (
              _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(
                header
              ) &&
              (header = header.trim()) &&
              !isValidHeaderName(header)
            ) {
              setHeaders(
                (0,
                _helpers_parseHeaders_js__WEBPACK_IMPORTED_MODULE_1__[
                  "default"
                ])(header),
                valueOrRewrite
              );
            } else {
              header != null && setHeader(valueOrRewrite, header, rewrite);
            }

            return this;
          }

          get(header, parser) {
            header = normalizeHeader(header);

            if (header) {
              const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__[
                "default"
              ].findKey(this, header);

              if (key) {
                const value = this[key];

                if (!parser) {
                  return value;
                }

                if (parser === true) {
                  return parseTokens(value);
                }

                if (
                  _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(
                    parser
                  )
                ) {
                  return parser.call(this, value, key);
                }

                if (
                  _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isRegExp(
                    parser
                  )
                ) {
                  return parser.exec(value);
                }

                throw new TypeError("parser must be boolean|regexp|function");
              }
            }
          }

          has(header, matcher) {
            header = normalizeHeader(header);

            if (header) {
              const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__[
                "default"
              ].findKey(this, header);

              return !!(
                key &&
                this[key] !== undefined &&
                (!matcher || matchHeaderValue(this, this[key], key, matcher))
              );
            }

            return false;
          }

          delete(header, matcher) {
            const self = this;
            let deleted = false;

            function deleteHeader(_header) {
              _header = normalizeHeader(_header);

              if (_header) {
                const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__[
                  "default"
                ].findKey(self, _header);

                if (
                  key &&
                  (!matcher || matchHeaderValue(self, self[key], key, matcher))
                ) {
                  delete self[key];

                  deleted = true;
                }
              }
            }

            if (
              _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(header)
            ) {
              header.forEach(deleteHeader);
            } else {
              deleteHeader(header);
            }

            return deleted;
          }

          clear(matcher) {
            const keys = Object.keys(this);
            let i = keys.length;
            let deleted = false;

            while (i--) {
              const key = keys[i];
              if (
                !matcher ||
                matchHeaderValue(this, this[key], key, matcher, true)
              ) {
                delete this[key];
                deleted = true;
              }
            }

            return deleted;
          }

          normalize(format) {
            const self = this;
            const headers = {};

            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(
              this,
              (value, header) => {
                const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__[
                  "default"
                ].findKey(headers, header);

                if (key) {
                  self[key] = normalizeValue(value);
                  delete self[header];
                  return;
                }

                const normalized = format
                  ? formatHeader(header)
                  : String(header).trim();

                if (normalized !== header) {
                  delete self[header];
                }

                self[normalized] = normalizeValue(value);

                headers[normalized] = true;
              }
            );

            return this;
          }

          concat(...targets) {
            return this.constructor.concat(this, ...targets);
          }

          toJSON(asStrings) {
            const obj = Object.create(null);

            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(
              this,
              (value, header) => {
                value != null &&
                  value !== false &&
                  (obj[header] =
                    asStrings &&
                    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(
                      value
                    )
                      ? value.join(", ")
                      : value);
              }
            );

            return obj;
          }

          [Symbol.iterator]() {
            return Object.entries(this.toJSON())[Symbol.iterator]();
          }

          toString() {
            return Object.entries(this.toJSON())
              .map(([header, value]) => header + ": " + value)
              .join("\n");
          }

          get [Symbol.toStringTag]() {
            return "AxiosHeaders";
          }

          static from(thing) {
            return thing instanceof this ? thing : new this(thing);
          }

          static concat(first, ...targets) {
            const computed = new this(first);

            targets.forEach((target) => computed.set(target));

            return computed;
          }

          static accessor(header) {
            const internals =
              (this[$internals] =
              this[$internals] =
                {
                  accessors: {},
                });

            const accessors = internals.accessors;
            const prototype = this.prototype;

            function defineAccessor(_header) {
              const lHeader = normalizeHeader(_header);

              if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
              }
            }

            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(header)
              ? header.forEach(defineAccessor)
              : defineAccessor(header);

            return this;
          }
        }

        AxiosHeaders.accessor([
          "Content-Type",
          "Content-Length",
          "Accept",
          "Accept-Encoding",
          "User-Agent",
          "Authorization",
        ]);

        // reserved names hotfix
        _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].reduceDescriptors(
          AxiosHeaders.prototype,
          ({ value }, key) => {
            let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
            return {
              get: () => value,
              set(headerValue) {
                this[mapped] = headerValue;
              },
            };
          }
        );

        _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].freezeMethods(
          AxiosHeaders
        );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          AxiosHeaders;

        /***/
      },

    /***/ "./node_modules/axios/lib/core/InterceptorManager.js":
      /*!***********************************************************!*\
  !*** ./node_modules/axios/lib/core/InterceptorManager.js ***!
  \***********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./../utils.js */ "./node_modules/axios/lib/utils.js"
          );

        class InterceptorManager {
          constructor() {
            this.handlers = [];
          }

          /**
           * Add a new interceptor to the stack
           *
           * @param {Function} fulfilled The function to handle `then` for a `Promise`
           * @param {Function} rejected The function to handle `reject` for a `Promise`
           *
           * @return {Number} An ID used to remove interceptor later
           */
          use(fulfilled, rejected, options) {
            this.handlers.push({
              fulfilled,
              rejected,
              synchronous: options ? options.synchronous : false,
              runWhen: options ? options.runWhen : null,
            });
            return this.handlers.length - 1;
          }

          /**
           * Remove an interceptor from the stack
           *
           * @param {Number} id The ID that was returned by `use`
           *
           * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
           */
          eject(id) {
            if (this.handlers[id]) {
              this.handlers[id] = null;
            }
          }

          /**
           * Clear all interceptors from the stack
           *
           * @returns {void}
           */
          clear() {
            if (this.handlers) {
              this.handlers = [];
            }
          }

          /**
           * Iterate over all the registered interceptors
           *
           * This method is particularly useful for skipping over any
           * interceptors that may have become `null` calling `eject`.
           *
           * @param {Function} fn The function to call for each interceptor
           *
           * @returns {void}
           */
          forEach(fn) {
            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(
              this.handlers,
              function forEachHandler(h) {
                if (h !== null) {
                  fn(h);
                }
              }
            );
          }
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          InterceptorManager;

        /***/
      },

    /***/ "./node_modules/axios/lib/core/buildFullPath.js":
      /*!******************************************************!*\
  !*** ./node_modules/axios/lib/core/buildFullPath.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ buildFullPath,
          /* harmony export */
        });
        /* harmony import */ var _helpers_isAbsoluteURL_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../helpers/isAbsoluteURL.js */ "./node_modules/axios/lib/helpers/isAbsoluteURL.js"
          );
        /* harmony import */ var _helpers_combineURLs_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../helpers/combineURLs.js */ "./node_modules/axios/lib/helpers/combineURLs.js"
          );

        /**
         * Creates a new URL by combining the baseURL with the requestedURL,
         * only when the requestedURL is not already an absolute URL.
         * If the requestURL is absolute, this function returns the requestedURL untouched.
         *
         * @param {string} baseURL The base URL
         * @param {string} requestedURL Absolute or relative URL to combine
         *
         * @returns {string} The combined full path
         */
        function buildFullPath(baseURL, requestedURL) {
          if (
            baseURL &&
            !(0,
            _helpers_isAbsoluteURL_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
              requestedURL
            )
          ) {
            return (0,
            _helpers_combineURLs_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
              baseURL,
              requestedURL
            );
          }
          return requestedURL;
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/core/dispatchRequest.js":
      /*!********************************************************!*\
  !*** ./node_modules/axios/lib/core/dispatchRequest.js ***!
  \********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ dispatchRequest,
          /* harmony export */
        });
        /* harmony import */ var _transformData_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./transformData.js */ "./node_modules/axios/lib/core/transformData.js"
          );
        /* harmony import */ var _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ../cancel/isCancel.js */ "./node_modules/axios/lib/cancel/isCancel.js"
          );
        /* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ../defaults/index.js */ "./node_modules/axios/lib/defaults/index.js"
          );
        /* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../cancel/CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js"
          );
        /* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js"
          );
        /* harmony import */ var _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../adapters/adapters.js */ "./node_modules/axios/lib/adapters/adapters.js"
          );

        /**
         * Throws a `CanceledError` if cancellation has been requested.
         *
         * @param {Object} config The config that is to be used for the request
         *
         * @returns {void}
         */
        function throwIfCancellationRequested(config) {
          if (config.cancelToken) {
            config.cancelToken.throwIfRequested();
          }

          if (config.signal && config.signal.aborted) {
            throw new _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_0__[
              "default"
            ](null, config);
          }
        }

        /**
         * Dispatch a request to the server using the configured adapter.
         *
         * @param {object} config The config that is to be used for the request
         *
         * @returns {Promise} The Promise to be fulfilled
         */
        function dispatchRequest(config) {
          throwIfCancellationRequested(config);

          config.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ].from(config.headers);

          // Transform request data
          config.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__[
            "default"
          ].call(config, config.transformRequest);

          if (["post", "put", "patch"].indexOf(config.method) !== -1) {
            config.headers.setContentType(
              "application/x-www-form-urlencoded",
              false
            );
          }

          const adapter = _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_3__[
            "default"
          ].getAdapter(
            config.adapter ||
              _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__["default"].adapter
          );

          return adapter(config).then(
            function onAdapterResolution(response) {
              throwIfCancellationRequested(config);

              // Transform response data
              response.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__[
                "default"
              ].call(config, config.transformResponse, response);

              response.headers =
                _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__[
                  "default"
                ].from(response.headers);

              return response;
            },
            function onAdapterRejection(reason) {
              if (
                !(0,
                _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_5__["default"])(
                  reason
                )
              ) {
                throwIfCancellationRequested(config);

                // Transform response data
                if (reason && reason.response) {
                  reason.response.data =
                    _transformData_js__WEBPACK_IMPORTED_MODULE_2__[
                      "default"
                    ].call(config, config.transformResponse, reason.response);
                  reason.response.headers =
                    _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__[
                      "default"
                    ].from(reason.response.headers);
                }
              }

              return Promise.reject(reason);
            }
          );
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/core/mergeConfig.js":
      /*!****************************************************!*\
  !*** ./node_modules/axios/lib/core/mergeConfig.js ***!
  \****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ mergeConfig,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js"
          );

        const headersToObject = (thing) =>
          thing instanceof
          _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_0__["default"]
            ? thing.toJSON()
            : thing;

        /**
         * Config-specific merge-function which creates a new config-object
         * by merging two configuration objects together.
         *
         * @param {Object} config1
         * @param {Object} config2
         *
         * @returns {Object} New object resulting from merging config2 to config1
         */
        function mergeConfig(config1, config2) {
          // eslint-disable-next-line no-param-reassign
          config2 = config2 || {};
          const config = {};

          function getMergedValue(target, source, caseless) {
            if (
              _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(
                target
              ) &&
              _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(
                source
              )
            ) {
              return _utils_js__WEBPACK_IMPORTED_MODULE_1__[
                "default"
              ].merge.call({ caseless }, target, source);
            } else if (
              _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(
                source
              )
            ) {
              return _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge(
                {},
                source
              );
            } else if (
              _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isArray(source)
            ) {
              return source.slice();
            }
            return source;
          }

          // eslint-disable-next-line consistent-return
          function mergeDeepProperties(a, b, caseless) {
            if (
              !_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)
            ) {
              return getMergedValue(a, b, caseless);
            } else if (
              !_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(a)
            ) {
              return getMergedValue(undefined, a, caseless);
            }
          }

          // eslint-disable-next-line consistent-return
          function valueFromConfig2(a, b) {
            if (
              !_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)
            ) {
              return getMergedValue(undefined, b);
            }
          }

          // eslint-disable-next-line consistent-return
          function defaultToConfig2(a, b) {
            if (
              !_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)
            ) {
              return getMergedValue(undefined, b);
            } else if (
              !_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(a)
            ) {
              return getMergedValue(undefined, a);
            }
          }

          // eslint-disable-next-line consistent-return
          function mergeDirectKeys(a, b, prop) {
            if (prop in config2) {
              return getMergedValue(a, b);
            } else if (prop in config1) {
              return getMergedValue(undefined, a);
            }
          }

          const mergeMap = {
            url: valueFromConfig2,
            method: valueFromConfig2,
            data: valueFromConfig2,
            baseURL: defaultToConfig2,
            transformRequest: defaultToConfig2,
            transformResponse: defaultToConfig2,
            paramsSerializer: defaultToConfig2,
            timeout: defaultToConfig2,
            timeoutMessage: defaultToConfig2,
            withCredentials: defaultToConfig2,
            adapter: defaultToConfig2,
            responseType: defaultToConfig2,
            xsrfCookieName: defaultToConfig2,
            xsrfHeaderName: defaultToConfig2,
            onUploadProgress: defaultToConfig2,
            onDownloadProgress: defaultToConfig2,
            decompress: defaultToConfig2,
            maxContentLength: defaultToConfig2,
            maxBodyLength: defaultToConfig2,
            beforeRedirect: defaultToConfig2,
            transport: defaultToConfig2,
            httpAgent: defaultToConfig2,
            httpsAgent: defaultToConfig2,
            cancelToken: defaultToConfig2,
            socketPath: defaultToConfig2,
            responseEncoding: defaultToConfig2,
            validateStatus: mergeDirectKeys,
            headers: (a, b) =>
              mergeDeepProperties(headersToObject(a), headersToObject(b), true),
          };

          _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].forEach(
            Object.keys(Object.assign({}, config1, config2)),
            function computeConfigValue(prop) {
              const merge = mergeMap[prop] || mergeDeepProperties;
              const configValue = merge(config1[prop], config2[prop], prop);
              (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(
                configValue
              ) &&
                merge !== mergeDirectKeys) ||
                (config[prop] = configValue);
            }
          );

          return config;
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/core/settle.js":
      /*!***********************************************!*\
  !*** ./node_modules/axios/lib/core/settle.js ***!
  \***********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ settle,
          /* harmony export */
        });
        /* harmony import */ var _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js"
          );

        /**
         * Resolve or reject a Promise based on response status.
         *
         * @param {Function} resolve A function that resolves the promise.
         * @param {Function} reject A function that rejects the promise.
         * @param {object} response The response.
         *
         * @returns {object} The response.
         */
        function settle(resolve, reject, response) {
          const validateStatus = response.config.validateStatus;
          if (
            !response.status ||
            !validateStatus ||
            validateStatus(response.status)
          ) {
            resolve(response);
          } else {
            reject(
              new _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"](
                "Request failed with status code " + response.status,
                [
                  _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"]
                    .ERR_BAD_REQUEST,
                  _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"]
                    .ERR_BAD_RESPONSE,
                ][Math.floor(response.status / 100) - 4],
                response.config,
                response.request,
                response
              )
            );
          }
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/core/transformData.js":
      /*!******************************************************!*\
  !*** ./node_modules/axios/lib/core/transformData.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ transformData,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./../utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../defaults/index.js */ "./node_modules/axios/lib/defaults/index.js"
          );
        /* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js"
          );

        /**
         * Transform the data for a request or a response
         *
         * @param {Array|Function} fns A single function or Array of functions
         * @param {?Object} response The response object
         *
         * @returns {*} The resulting transformed data
         */
        function transformData(fns, response) {
          const config =
            this || _defaults_index_js__WEBPACK_IMPORTED_MODULE_0__["default"];
          const context = response || config;
          const headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ].from(context.headers);
          let data = context.data;

          _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(
            fns,
            function transform(fn) {
              data = fn.call(
                config,
                data,
                headers.normalize(),
                response ? response.status : undefined
              );
            }
          );

          headers.normalize();

          return data;
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/defaults/index.js":
      /*!**************************************************!*\
  !*** ./node_modules/axios/lib/defaults/index.js ***!
  \**************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js"
          );
        /* harmony import */ var _transitional_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./transitional.js */ "./node_modules/axios/lib/defaults/transitional.js"
          );
        /* harmony import */ var _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ../helpers/toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js"
          );
        /* harmony import */ var _helpers_toURLEncodedForm_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../helpers/toURLEncodedForm.js */ "./node_modules/axios/lib/helpers/toURLEncodedForm.js"
          );
        /* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js"
          );
        /* harmony import */ var _helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../helpers/formDataToJSON.js */ "./node_modules/axios/lib/helpers/formDataToJSON.js"
          );

        /**
         * It takes a string, tries to parse it, and if it fails, it returns the stringified version
         * of the input
         *
         * @param {any} rawValue - The value to be stringified.
         * @param {Function} parser - A function that parses a string into a JavaScript object.
         * @param {Function} encoder - A function that takes a value and returns a string.
         *
         * @returns {string} A stringified version of the rawValue.
         */
        function stringifySafely(rawValue, parser, encoder) {
          if (
            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(rawValue)
          ) {
            try {
              (parser || JSON.parse)(rawValue);
              return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].trim(
                rawValue
              );
            } catch (e) {
              if (e.name !== "SyntaxError") {
                throw e;
              }
            }
          }

          return (encoder || JSON.stringify)(rawValue);
        }

        const defaults = {
          transitional:
            _transitional_js__WEBPACK_IMPORTED_MODULE_1__["default"],

          adapter: ["xhr", "http"],

          transformRequest: [
            function transformRequest(data, headers) {
              const contentType = headers.getContentType() || "";
              const hasJSONContentType =
                contentType.indexOf("application/json") > -1;
              const isObjectPayload =
                _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(
                  data
                );

              if (
                isObjectPayload &&
                _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isHTMLForm(
                  data
                )
              ) {
                data = new FormData(data);
              }

              const isFormData =
                _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFormData(
                  data
                );

              if (isFormData) {
                if (!hasJSONContentType) {
                  return data;
                }
                return hasJSONContentType
                  ? JSON.stringify(
                      (0,
                      _helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_2__[
                        "default"
                      ])(data)
                    )
                  : data;
              }

              if (
                _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBuffer(
                  data
                ) ||
                _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBuffer(
                  data
                ) ||
                _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isStream(
                  data
                ) ||
                _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFile(
                  data
                ) ||
                _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBlob(data)
              ) {
                return data;
              }
              if (
                _utils_js__WEBPACK_IMPORTED_MODULE_0__[
                  "default"
                ].isArrayBufferView(data)
              ) {
                return data.buffer;
              }
              if (
                _utils_js__WEBPACK_IMPORTED_MODULE_0__[
                  "default"
                ].isURLSearchParams(data)
              ) {
                headers.setContentType(
                  "application/x-www-form-urlencoded;charset=utf-8",
                  false
                );
                return data.toString();
              }

              let isFileList;

              if (isObjectPayload) {
                if (
                  contentType.indexOf("application/x-www-form-urlencoded") > -1
                ) {
                  return (0,
                  _helpers_toURLEncodedForm_js__WEBPACK_IMPORTED_MODULE_3__[
                    "default"
                  ])(data, this.formSerializer).toString();
                }

                if (
                  (isFileList =
                    _utils_js__WEBPACK_IMPORTED_MODULE_0__[
                      "default"
                    ].isFileList(data)) ||
                  contentType.indexOf("multipart/form-data") > -1
                ) {
                  const _FormData = this.env && this.env.FormData;

                  return (0,
                  _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_4__[
                    "default"
                  ])(
                    isFileList ? { "files[]": data } : data,
                    _FormData && new _FormData(),
                    this.formSerializer
                  );
                }
              }

              if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return stringifySafely(data);
              }

              return data;
            },
          ],

          transformResponse: [
            function transformResponse(data) {
              const transitional = this.transitional || defaults.transitional;
              const forcedJSONParsing =
                transitional && transitional.forcedJSONParsing;
              const JSONRequested = this.responseType === "json";

              if (
                data &&
                _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(
                  data
                ) &&
                ((forcedJSONParsing && !this.responseType) || JSONRequested)
              ) {
                const silentJSONParsing =
                  transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;

                try {
                  return JSON.parse(data);
                } catch (e) {
                  if (strictJSONParsing) {
                    if (e.name === "SyntaxError") {
                      throw _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__[
                        "default"
                      ].from(
                        e,
                        _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__[
                          "default"
                        ].ERR_BAD_RESPONSE,
                        this,
                        null,
                        this.response
                      );
                    }
                    throw e;
                  }
                }
              }

              return data;
            },
          ],

          /**
           * A timeout in milliseconds to abort a request. If set to 0 (default) a
           * timeout is not created.
           */
          timeout: 0,

          xsrfCookieName: "XSRF-TOKEN",
          xsrfHeaderName: "X-XSRF-TOKEN",

          maxContentLength: -1,
          maxBodyLength: -1,

          env: {
            FormData:
              _platform_index_js__WEBPACK_IMPORTED_MODULE_6__["default"].classes
                .FormData,
            Blob: _platform_index_js__WEBPACK_IMPORTED_MODULE_6__["default"]
              .classes.Blob,
          },

          validateStatus: function validateStatus(status) {
            return status >= 200 && status < 300;
          },

          headers: {
            common: {
              Accept: "application/json, text/plain, */*",
              "Content-Type": undefined,
            },
          },
        };

        _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(
          ["delete", "get", "head", "post", "put", "patch"],
          (method) => {
            defaults.headers[method] = {};
          }
        );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          defaults;

        /***/
      },

    /***/ "./node_modules/axios/lib/defaults/transitional.js":
      /*!*********************************************************!*\
  !*** ./node_modules/axios/lib/defaults/transitional.js ***!
  \*********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          silentJSONParsing: true,
          forcedJSONParsing: true,
          clarifyTimeoutError: false,
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/env/data.js":
      /*!********************************************!*\
  !*** ./node_modules/axios/lib/env/data.js ***!
  \********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ VERSION: () => /* binding */ VERSION,
          /* harmony export */
        });
        const VERSION = "1.6.0";

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/AxiosURLSearchParams.js":
      /*!****************************************************************!*\
  !*** ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js ***!
  \****************************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _toFormData_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js"
          );

        /**
         * It encodes a string by replacing all characters that are not in the unreserved set with
         * their percent-encoded equivalents
         *
         * @param {string} str - The string to encode.
         *
         * @returns {string} The encoded string.
         */
        function encode(str) {
          const charMap = {
            "!": "%21",
            "'": "%27",
            "(": "%28",
            ")": "%29",
            "~": "%7E",
            "%20": "+",
            "%00": "\x00",
          };
          return encodeURIComponent(str).replace(
            /[!'()~]|%20|%00/g,
            function replacer(match) {
              return charMap[match];
            }
          );
        }

        /**
         * It takes a params object and converts it to a FormData object
         *
         * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
         * @param {Object<string, any>} options - The options object passed to the Axios constructor.
         *
         * @returns {void}
         */
        function AxiosURLSearchParams(params, options) {
          this._pairs = [];

          params &&
            (0, _toFormData_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
              params,
              this,
              options
            );
        }

        const prototype = AxiosURLSearchParams.prototype;

        prototype.append = function append(name, value) {
          this._pairs.push([name, value]);
        };

        prototype.toString = function toString(encoder) {
          const _encode = encoder
            ? function (value) {
                return encoder.call(this, value, encode);
              }
            : encode;

          return this._pairs
            .map(function each(pair) {
              return _encode(pair[0]) + "=" + _encode(pair[1]);
            }, "")
            .join("&");
        };

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          AxiosURLSearchParams;

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/HttpStatusCode.js":
      /*!**********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/HttpStatusCode.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        const HttpStatusCode = {
          Continue: 100,
          SwitchingProtocols: 101,
          Processing: 102,
          EarlyHints: 103,
          Ok: 200,
          Created: 201,
          Accepted: 202,
          NonAuthoritativeInformation: 203,
          NoContent: 204,
          ResetContent: 205,
          PartialContent: 206,
          MultiStatus: 207,
          AlreadyReported: 208,
          ImUsed: 226,
          MultipleChoices: 300,
          MovedPermanently: 301,
          Found: 302,
          SeeOther: 303,
          NotModified: 304,
          UseProxy: 305,
          Unused: 306,
          TemporaryRedirect: 307,
          PermanentRedirect: 308,
          BadRequest: 400,
          Unauthorized: 401,
          PaymentRequired: 402,
          Forbidden: 403,
          NotFound: 404,
          MethodNotAllowed: 405,
          NotAcceptable: 406,
          ProxyAuthenticationRequired: 407,
          RequestTimeout: 408,
          Conflict: 409,
          Gone: 410,
          LengthRequired: 411,
          PreconditionFailed: 412,
          PayloadTooLarge: 413,
          UriTooLong: 414,
          UnsupportedMediaType: 415,
          RangeNotSatisfiable: 416,
          ExpectationFailed: 417,
          ImATeapot: 418,
          MisdirectedRequest: 421,
          UnprocessableEntity: 422,
          Locked: 423,
          FailedDependency: 424,
          TooEarly: 425,
          UpgradeRequired: 426,
          PreconditionRequired: 428,
          TooManyRequests: 429,
          RequestHeaderFieldsTooLarge: 431,
          UnavailableForLegalReasons: 451,
          InternalServerError: 500,
          NotImplemented: 501,
          BadGateway: 502,
          ServiceUnavailable: 503,
          GatewayTimeout: 504,
          HttpVersionNotSupported: 505,
          VariantAlsoNegotiates: 506,
          InsufficientStorage: 507,
          LoopDetected: 508,
          NotExtended: 510,
          NetworkAuthenticationRequired: 511,
        };

        Object.entries(HttpStatusCode).forEach(([key, value]) => {
          HttpStatusCode[value] = key;
        });

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          HttpStatusCode;

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/bind.js":
      /*!************************************************!*\
  !*** ./node_modules/axios/lib/helpers/bind.js ***!
  \************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ bind,
          /* harmony export */
        });

        function bind(fn, thisArg) {
          return function wrap() {
            return fn.apply(thisArg, arguments);
          };
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/buildURL.js":
      /*!****************************************************!*\
  !*** ./node_modules/axios/lib/helpers/buildURL.js ***!
  \****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ buildURL,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../helpers/AxiosURLSearchParams.js */ "./node_modules/axios/lib/helpers/AxiosURLSearchParams.js"
          );

        /**
         * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
         * URI encoded counterparts
         *
         * @param {string} val The value to be encoded.
         *
         * @returns {string} The encoded value.
         */
        function encode(val) {
          return encodeURIComponent(val)
            .replace(/%3A/gi, ":")
            .replace(/%24/g, "$")
            .replace(/%2C/gi, ",")
            .replace(/%20/g, "+")
            .replace(/%5B/gi, "[")
            .replace(/%5D/gi, "]");
        }

        /**
         * Build a URL by appending params to the end
         *
         * @param {string} url The base of the url (e.g., http://www.google.com)
         * @param {object} [params] The params to be appended
         * @param {?object} options
         *
         * @returns {string} The formatted url
         */
        function buildURL(url, params, options) {
          /*eslint no-param-reassign:0*/
          if (!params) {
            return url;
          }

          const _encode = (options && options.encode) || encode;

          const serializeFn = options && options.serialize;

          let serializedParams;

          if (serializeFn) {
            serializedParams = serializeFn(params, options);
          } else {
            serializedParams = _utils_js__WEBPACK_IMPORTED_MODULE_0__[
              "default"
            ].isURLSearchParams(params)
              ? params.toString()
              : new _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_1__[
                  "default"
                ](params, options).toString(_encode);
          }

          if (serializedParams) {
            const hashmarkIndex = url.indexOf("#");

            if (hashmarkIndex !== -1) {
              url = url.slice(0, hashmarkIndex);
            }
            url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
          }

          return url;
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/combineURLs.js":
      /*!*******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/combineURLs.js ***!
  \*******************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ combineURLs,
          /* harmony export */
        });

        /**
         * Creates a new URL by combining the specified URLs
         *
         * @param {string} baseURL The base URL
         * @param {string} relativeURL The relative URL
         *
         * @returns {string} The combined URL
         */
        function combineURLs(baseURL, relativeURL) {
          return relativeURL
            ? baseURL.replace(/\/+$/, "") +
                "/" +
                relativeURL.replace(/^\/+/, "")
            : baseURL;
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/cookies.js":
      /*!***************************************************!*\
  !*** ./node_modules/axios/lib/helpers/cookies.js ***!
  \***************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./../utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js"
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"]
            .isStandardBrowserEnv
            ? // Standard browser envs support document.cookie
              (function standardBrowserEnv() {
                return {
                  write: function write(
                    name,
                    value,
                    expires,
                    path,
                    domain,
                    secure
                  ) {
                    const cookie = [];
                    cookie.push(name + "=" + encodeURIComponent(value));

                    if (
                      _utils_js__WEBPACK_IMPORTED_MODULE_1__[
                        "default"
                      ].isNumber(expires)
                    ) {
                      cookie.push("expires=" + new Date(expires).toGMTString());
                    }

                    if (
                      _utils_js__WEBPACK_IMPORTED_MODULE_1__[
                        "default"
                      ].isString(path)
                    ) {
                      cookie.push("path=" + path);
                    }

                    if (
                      _utils_js__WEBPACK_IMPORTED_MODULE_1__[
                        "default"
                      ].isString(domain)
                    ) {
                      cookie.push("domain=" + domain);
                    }

                    if (secure === true) {
                      cookie.push("secure");
                    }

                    document.cookie = cookie.join("; ");
                  },

                  read: function read(name) {
                    const match = document.cookie.match(
                      new RegExp("(^|;\\s*)(" + name + ")=([^;]*)")
                    );
                    return match ? decodeURIComponent(match[3]) : null;
                  },

                  remove: function remove(name) {
                    this.write(name, "", Date.now() - 86400000);
                  },
                };
              })()
            : // Non standard browser env (web workers, react-native) lack needed support.
              (function nonStandardBrowserEnv() {
                return {
                  write: function write() {},
                  read: function read() {
                    return null;
                  },
                  remove: function remove() {},
                };
              })();

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/formDataToJSON.js":
      /*!**********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/formDataToJSON.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils.js */ "./node_modules/axios/lib/utils.js"
          );

        /**
         * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
         *
         * @param {string} name - The name of the property to get.
         *
         * @returns An array of strings.
         */
        function parsePropPath(name) {
          // foo[x][y][z]
          // foo.x.y.z
          // foo-x-y-z
          // foo x y z
          return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"]
            .matchAll(/\w+|\[(\w*)]/g, name)
            .map((match) => {
              return match[0] === "[]" ? "" : match[1] || match[0];
            });
        }

        /**
         * Convert an array to an object.
         *
         * @param {Array<any>} arr - The array to convert to an object.
         *
         * @returns An object with the same keys and values as the array.
         */
        function arrayToObject(arr) {
          const obj = {};
          const keys = Object.keys(arr);
          let i;
          const len = keys.length;
          let key;
          for (i = 0; i < len; i++) {
            key = keys[i];
            obj[key] = arr[key];
          }
          return obj;
        }

        /**
         * It takes a FormData object and returns a JavaScript object
         *
         * @param {string} formData The FormData object to convert to JSON.
         *
         * @returns {Object<string, any> | null} The converted object.
         */
        function formDataToJSON(formData) {
          function buildPath(path, value, target, index) {
            let name = path[index++];
            const isNumericKey = Number.isFinite(+name);
            const isLast = index >= path.length;
            name =
              !name &&
              _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(target)
                ? target.length
                : name;

            if (isLast) {
              if (
                _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].hasOwnProp(
                  target,
                  name
                )
              ) {
                target[name] = [target[name], value];
              } else {
                target[name] = value;
              }

              return !isNumericKey;
            }

            if (
              !target[name] ||
              !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(
                target[name]
              )
            ) {
              target[name] = [];
            }

            const result = buildPath(path, value, target[name], index);

            if (
              result &&
              _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(
                target[name]
              )
            ) {
              target[name] = arrayToObject(target[name]);
            }

            return !isNumericKey;
          }

          if (
            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFormData(
              formData
            ) &&
            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(
              formData.entries
            )
          ) {
            const obj = {};

            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEachEntry(
              formData,
              (name, value) => {
                buildPath(parsePropPath(name), value, obj, 0);
              }
            );

            return obj;
          }

          return null;
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          formDataToJSON;

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/isAbsoluteURL.js":
      /*!*********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \*********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ isAbsoluteURL,
          /* harmony export */
        });

        /**
         * Determines whether the specified URL is absolute
         *
         * @param {string} url The URL to test
         *
         * @returns {boolean} True if the specified URL is absolute, otherwise false
         */
        function isAbsoluteURL(url) {
          // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
          // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
          // by any combination of letters, digits, plus, period, or hyphen.
          return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/isAxiosError.js":
      /*!********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isAxiosError.js ***!
  \********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ isAxiosError,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./../utils.js */ "./node_modules/axios/lib/utils.js"
          );

        /**
         * Determines whether the payload is an error thrown by Axios
         *
         * @param {*} payload The value to test
         *
         * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
         */
        function isAxiosError(payload) {
          return (
            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(
              payload
            ) && payload.isAxiosError === true
          );
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/isURLSameOrigin.js":
      /*!***********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \***********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./../utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js"
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"]
            .isStandardBrowserEnv
            ? // Standard browser envs have full support of the APIs needed to test
              // whether the request URL is of the same origin as current location.
              (function standardBrowserEnv() {
                const msie = /(msie|trident)/i.test(navigator.userAgent);
                const urlParsingNode = document.createElement("a");
                let originURL;

                /**
                 * Parse a URL to discover it's components
                 *
                 * @param {String} url The URL to be parsed
                 * @returns {Object}
                 */
                function resolveURL(url) {
                  let href = url;

                  if (msie) {
                    // IE needs attribute set twice to normalize properties
                    urlParsingNode.setAttribute("href", href);
                    href = urlParsingNode.href;
                  }

                  urlParsingNode.setAttribute("href", href);

                  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
                  return {
                    href: urlParsingNode.href,
                    protocol: urlParsingNode.protocol
                      ? urlParsingNode.protocol.replace(/:$/, "")
                      : "",
                    host: urlParsingNode.host,
                    search: urlParsingNode.search
                      ? urlParsingNode.search.replace(/^\?/, "")
                      : "",
                    hash: urlParsingNode.hash
                      ? urlParsingNode.hash.replace(/^#/, "")
                      : "",
                    hostname: urlParsingNode.hostname,
                    port: urlParsingNode.port,
                    pathname:
                      urlParsingNode.pathname.charAt(0) === "/"
                        ? urlParsingNode.pathname
                        : "/" + urlParsingNode.pathname,
                  };
                }

                originURL = resolveURL(window.location.href);

                /**
                 * Determine if a URL shares the same origin as the current location
                 *
                 * @param {String} requestURL The URL to test
                 * @returns {boolean} True if URL shares the same origin, otherwise false
                 */
                return function isURLSameOrigin(requestURL) {
                  const parsed = _utils_js__WEBPACK_IMPORTED_MODULE_1__[
                    "default"
                  ].isString(requestURL)
                    ? resolveURL(requestURL)
                    : requestURL;
                  return (
                    parsed.protocol === originURL.protocol &&
                    parsed.host === originURL.host
                  );
                };
              })()
            : // Non standard browser envs (web workers, react-native) lack needed support.
              (function nonStandardBrowserEnv() {
                return function isURLSameOrigin() {
                  return true;
                };
              })();

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/null.js":
      /*!************************************************!*\
  !*** ./node_modules/axios/lib/helpers/null.js ***!
  \************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        // eslint-disable-next-line strict
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = null;

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/parseHeaders.js":
      /*!********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/parseHeaders.js ***!
  \********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./../utils.js */ "./node_modules/axios/lib/utils.js"
          );

        // RawAxiosHeaders whose duplicates are ignored by node
        // c.f. https://nodejs.org/api/http.html#http_message_headers
        const ignoreDuplicateOf = _utils_js__WEBPACK_IMPORTED_MODULE_0__[
          "default"
        ].toObjectSet([
          "age",
          "authorization",
          "content-length",
          "content-type",
          "etag",
          "expires",
          "from",
          "host",
          "if-modified-since",
          "if-unmodified-since",
          "last-modified",
          "location",
          "max-forwards",
          "proxy-authorization",
          "referer",
          "retry-after",
          "user-agent",
        ]);

        /**
         * Parse headers into an object
         *
         * ```
         * Date: Wed, 27 Aug 2014 08:58:49 GMT
         * Content-Type: application/json
         * Connection: keep-alive
         * Transfer-Encoding: chunked
         * ```
         *
         * @param {String} rawHeaders Headers needing to be parsed
         *
         * @returns {Object} Headers parsed into an object
         */
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (
          rawHeaders
        ) => {
          const parsed = {};
          let key;
          let val;
          let i;

          rawHeaders &&
            rawHeaders.split("\n").forEach(function parser(line) {
              i = line.indexOf(":");
              key = line.substring(0, i).trim().toLowerCase();
              val = line.substring(i + 1).trim();

              if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
                return;
              }

              if (key === "set-cookie") {
                if (parsed[key]) {
                  parsed[key].push(val);
                } else {
                  parsed[key] = [val];
                }
              } else {
                parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
              }
            });

          return parsed;
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/parseProtocol.js":
      /*!*********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/parseProtocol.js ***!
  \*********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ parseProtocol,
          /* harmony export */
        });

        function parseProtocol(url) {
          const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
          return (match && match[1]) || "";
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/speedometer.js":
      /*!*******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/speedometer.js ***!
  \*******************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });

        /**
         * Calculate data maxRate
         * @param {Number} [samplesCount= 10]
         * @param {Number} [min= 1000]
         * @returns {Function}
         */
        function speedometer(samplesCount, min) {
          samplesCount = samplesCount || 10;
          const bytes = new Array(samplesCount);
          const timestamps = new Array(samplesCount);
          let head = 0;
          let tail = 0;
          let firstSampleTS;

          min = min !== undefined ? min : 1000;

          return function push(chunkLength) {
            const now = Date.now();

            const startedAt = timestamps[tail];

            if (!firstSampleTS) {
              firstSampleTS = now;
            }

            bytes[head] = chunkLength;
            timestamps[head] = now;

            let i = tail;
            let bytesCount = 0;

            while (i !== head) {
              bytesCount += bytes[i++];
              i = i % samplesCount;
            }

            head = (head + 1) % samplesCount;

            if (head === tail) {
              tail = (tail + 1) % samplesCount;
            }

            if (now - firstSampleTS < min) {
              return;
            }

            const passed = startedAt && now - startedAt;

            return passed
              ? Math.round((bytesCount * 1000) / passed)
              : undefined;
          };
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          speedometer;

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/spread.js":
      /*!**************************************************!*\
  !*** ./node_modules/axios/lib/helpers/spread.js ***!
  \**************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ spread,
          /* harmony export */
        });

        /**
         * Syntactic sugar for invoking a function and expanding an array for arguments.
         *
         * Common use case would be to use `Function.prototype.apply`.
         *
         *  ```js
         *  function f(x, y, z) {}
         *  var args = [1, 2, 3];
         *  f.apply(null, args);
         *  ```
         *
         * With `spread` this example can be re-written.
         *
         *  ```js
         *  spread(function(x, y, z) {})([1, 2, 3]);
         *  ```
         *
         * @param {Function} callback
         *
         * @returns {Function}
         */
        function spread(callback) {
          return function wrap(arr) {
            return callback.apply(null, arr);
          };
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/toFormData.js":
      /*!******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/toFormData.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js"
          );
        /* harmony import */ var _platform_node_classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../platform/node/classes/FormData.js */ "./node_modules/axios/lib/helpers/null.js"
          );
        /* provided dependency */ var Buffer = __webpack_require__(
          /*! buffer */ "./node_modules/buffer/index.js"
        )["Buffer"];

        // temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored

        /**
         * Determines if the given thing is a array or js object.
         *
         * @param {string} thing - The object or array to be visited.
         *
         * @returns {boolean}
         */
        function isVisitable(thing) {
          return (
            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(
              thing
            ) ||
            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(thing)
          );
        }

        /**
         * It removes the brackets from the end of a string
         *
         * @param {string} key - The key of the parameter.
         *
         * @returns {string} the key without the brackets.
         */
        function removeBrackets(key) {
          return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(
            key,
            "[]"
          )
            ? key.slice(0, -2)
            : key;
        }

        /**
         * It takes a path, a key, and a boolean, and returns a string
         *
         * @param {string} path - The path to the current key.
         * @param {string} key - The key of the current object being iterated over.
         * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
         *
         * @returns {string} The path to the current key.
         */
        function renderKey(path, key, dots) {
          if (!path) return key;
          return path
            .concat(key)
            .map(function each(token, i) {
              // eslint-disable-next-line no-param-reassign
              token = removeBrackets(token);
              return !dots && i ? "[" + token + "]" : token;
            })
            .join(dots ? "." : "");
        }

        /**
         * If the array is an array and none of its elements are visitable, then it's a flat array.
         *
         * @param {Array<any>} arr - The array to check
         *
         * @returns {boolean}
         */
        function isFlatArray(arr) {
          return (
            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(arr) &&
            !arr.some(isVisitable)
          );
        }

        const predicates = _utils_js__WEBPACK_IMPORTED_MODULE_0__[
          "default"
        ].toFlatObject(
          _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"],
          {},
          null,
          function filter(prop) {
            return /^is[A-Z]/.test(prop);
          }
        );

        /**
         * Convert a data object to FormData
         *
         * @param {Object} obj
         * @param {?Object} [formData]
         * @param {?Object} [options]
         * @param {Function} [options.visitor]
         * @param {Boolean} [options.metaTokens = true]
         * @param {Boolean} [options.dots = false]
         * @param {?Boolean} [options.indexes = false]
         *
         * @returns {Object}
         **/

        /**
         * It converts an object into a FormData object
         *
         * @param {Object<any, any>} obj - The object to convert to form data.
         * @param {string} formData - The FormData object to append to.
         * @param {Object<string, any>} options
         *
         * @returns
         */
        function toFormData(obj, formData, options) {
          if (
            !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(obj)
          ) {
            throw new TypeError("target must be an object");
          }

          // eslint-disable-next-line no-param-reassign
          formData =
            formData ||
            new (_platform_node_classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ] || FormData)();

          // eslint-disable-next-line no-param-reassign
          options = _utils_js__WEBPACK_IMPORTED_MODULE_0__[
            "default"
          ].toFlatObject(
            options,
            {
              metaTokens: true,
              dots: false,
              indexes: false,
            },
            false,
            function defined(option, source) {
              // eslint-disable-next-line no-eq-null,eqeqeq
              return !_utils_js__WEBPACK_IMPORTED_MODULE_0__[
                "default"
              ].isUndefined(source[option]);
            }
          );

          const metaTokens = options.metaTokens;
          // eslint-disable-next-line no-use-before-define
          const visitor = options.visitor || defaultVisitor;
          const dots = options.dots;
          const indexes = options.indexes;
          const _Blob = options.Blob || (typeof Blob !== "undefined" && Blob);
          const useBlob =
            _Blob &&
            _utils_js__WEBPACK_IMPORTED_MODULE_0__[
              "default"
            ].isSpecCompliantForm(formData);

          if (
            !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(
              visitor
            )
          ) {
            throw new TypeError("visitor must be a function");
          }

          function convertValue(value) {
            if (value === null) return "";

            if (
              _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isDate(value)
            ) {
              return value.toISOString();
            }

            if (
              !useBlob &&
              _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBlob(value)
            ) {
              throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__[
                "default"
              ]("Blob is not supported. Use a Buffer instead.");
            }

            if (
              _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBuffer(
                value
              ) ||
              _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isTypedArray(
                value
              )
            ) {
              return useBlob && typeof Blob === "function"
                ? new Blob([value])
                : Buffer.from(value);
            }

            return value;
          }

          /**
           * Default visitor.
           *
           * @param {*} value
           * @param {String|Number} key
           * @param {Array<String|Number>} path
           * @this {FormData}
           *
           * @returns {boolean} return true to visit the each prop of the value recursively
           */
          function defaultVisitor(value, key, path) {
            let arr = value;

            if (value && !path && typeof value === "object") {
              if (
                _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(
                  key,
                  "{}"
                )
              ) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
              } else if (
                (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(
                  value
                ) &&
                  isFlatArray(value)) ||
                ((_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFileList(
                  value
                ) ||
                  _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(
                    key,
                    "[]"
                  )) &&
                  (arr =
                    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toArray(
                      value
                    )))
              ) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);

                arr.forEach(function each(el, index) {
                  !(
                    _utils_js__WEBPACK_IMPORTED_MODULE_0__[
                      "default"
                    ].isUndefined(el) || el === null
                  ) &&
                    formData.append(
                      // eslint-disable-next-line no-nested-ternary
                      indexes === true
                        ? renderKey([key], index, dots)
                        : indexes === null
                        ? key
                        : key + "[]",
                      convertValue(el)
                    );
                });
                return false;
              }
            }

            if (isVisitable(value)) {
              return true;
            }

            formData.append(renderKey(path, key, dots), convertValue(value));

            return false;
          }

          const stack = [];

          const exposedHelpers = Object.assign(predicates, {
            defaultVisitor,
            convertValue,
            isVisitable,
          });

          function build(value, path) {
            if (
              _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(
                value
              )
            )
              return;

            if (stack.indexOf(value) !== -1) {
              throw Error("Circular reference detected in " + path.join("."));
            }

            stack.push(value);

            _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(
              value,
              function each(el, key) {
                const result =
                  !(
                    _utils_js__WEBPACK_IMPORTED_MODULE_0__[
                      "default"
                    ].isUndefined(el) || el === null
                  ) &&
                  visitor.call(
                    formData,
                    el,
                    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(
                      key
                    )
                      ? key.trim()
                      : key,
                    path,
                    exposedHelpers
                  );

                if (result === true) {
                  build(el, path ? path.concat(key) : [key]);
                }
              }
            );

            stack.pop();
          }

          if (
            !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(obj)
          ) {
            throw new TypeError("data must be an object");
          }

          build(obj);

          return formData;
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          toFormData;

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/toURLEncodedForm.js":
      /*!************************************************************!*\
  !*** ./node_modules/axios/lib/helpers/toURLEncodedForm.js ***!
  \************************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ toURLEncodedForm,
          /* harmony export */
        });
        /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../utils.js */ "./node_modules/axios/lib/utils.js"
          );
        /* harmony import */ var _toFormData_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js"
          );
        /* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js"
          );

        function toURLEncodedForm(data, options) {
          return (0, _toFormData_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            data,
            new _platform_index_js__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ].classes.URLSearchParams(),
            Object.assign(
              {
                visitor: function (value, key, path, helpers) {
                  if (
                    _platform_index_js__WEBPACK_IMPORTED_MODULE_1__["default"]
                      .isNode &&
                    _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isBuffer(
                      value
                    )
                  ) {
                    this.append(key, value.toString("base64"));
                    return false;
                  }

                  return helpers.defaultVisitor.apply(this, arguments);
                },
              },
              options
            )
          );
        }

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/validator.js":
      /*!*****************************************************!*\
  !*** ./node_modules/axios/lib/helpers/validator.js ***!
  \*****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _env_data_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../env/data.js */ "./node_modules/axios/lib/env/data.js"
          );
        /* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js"
          );

        const validators = {};

        // eslint-disable-next-line func-names
        ["object", "boolean", "number", "function", "string", "symbol"].forEach(
          (type, i) => {
            validators[type] = function validator(thing) {
              return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
            };
          }
        );

        const deprecatedWarnings = {};

        /**
         * Transitional option validator
         *
         * @param {function|boolean?} validator - set to false if the transitional option has been removed
         * @param {string?} version - deprecated version / removed since version
         * @param {string?} message - some message with additional info
         *
         * @returns {function}
         */
        validators.transitional = function transitional(
          validator,
          version,
          message
        ) {
          function formatMessage(opt, desc) {
            return (
              "[Axios v" +
              _env_data_js__WEBPACK_IMPORTED_MODULE_0__.VERSION +
              "] Transitional option '" +
              opt +
              "'" +
              desc +
              (message ? ". " + message : "")
            );
          }

          // eslint-disable-next-line func-names
          return (value, opt, opts) => {
            if (validator === false) {
              throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__[
                "default"
              ](
                formatMessage(
                  opt,
                  " has been removed" + (version ? " in " + version : "")
                ),
                _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__[
                  "default"
                ].ERR_DEPRECATED
              );
            }

            if (version && !deprecatedWarnings[opt]) {
              deprecatedWarnings[opt] = true;
              // eslint-disable-next-line no-console
              console.warn(
                formatMessage(
                  opt,
                  " has been deprecated since v" +
                    version +
                    " and will be removed in the near future"
                )
              );
            }

            return validator ? validator(value, opt, opts) : true;
          };
        };

        /**
         * Assert object's properties type
         *
         * @param {object} options
         * @param {object} schema
         * @param {boolean?} allowUnknown
         *
         * @returns {object}
         */

        function assertOptions(options, schema, allowUnknown) {
          if (typeof options !== "object") {
            throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ](
              "options must be an object",
              _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__[
                "default"
              ].ERR_BAD_OPTION_VALUE
            );
          }
          const keys = Object.keys(options);
          let i = keys.length;
          while (i-- > 0) {
            const opt = keys[i];
            const validator = schema[opt];
            if (validator) {
              const value = options[opt];
              const result =
                value === undefined || validator(value, opt, options);
              if (result !== true) {
                throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__[
                  "default"
                ](
                  "option " + opt + " must be " + result,
                  _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__[
                    "default"
                  ].ERR_BAD_OPTION_VALUE
                );
              }
              continue;
            }
            if (allowUnknown !== true) {
              throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__[
                "default"
              ](
                "Unknown option " + opt,
                _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__[
                  "default"
                ].ERR_BAD_OPTION
              );
            }
          }
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          assertOptions,
          validators,
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/platform/browser/classes/Blob.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/classes/Blob.js ***!
  \*****************************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          typeof Blob !== "undefined" ? Blob : null;

        /***/
      },

    /***/ "./node_modules/axios/lib/platform/browser/classes/FormData.js":
      /*!*********************************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/classes/FormData.js ***!
  \*********************************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          typeof FormData !== "undefined" ? FormData : null;

        /***/
      },

    /***/ "./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js":
      /*!****************************************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js ***!
  \****************************************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../../../helpers/AxiosURLSearchParams.js */ "./node_modules/axios/lib/helpers/AxiosURLSearchParams.js"
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          typeof URLSearchParams !== "undefined"
            ? URLSearchParams
            : _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__[
                "default"
              ];

        /***/
      },

    /***/ "./node_modules/axios/lib/platform/browser/index.js":
      /*!**********************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/index.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _classes_URLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./classes/URLSearchParams.js */ "./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js"
          );
        /* harmony import */ var _classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./classes/FormData.js */ "./node_modules/axios/lib/platform/browser/classes/FormData.js"
          );
        /* harmony import */ var _classes_Blob_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./classes/Blob.js */ "./node_modules/axios/lib/platform/browser/classes/Blob.js"
          );

        /**
         * Determine if we're running in a standard browser environment
         *
         * This allows axios to run in a web worker, and react-native.
         * Both environments support XMLHttpRequest, but not fully standard globals.
         *
         * web workers:
         *  typeof window -> undefined
         *  typeof document -> undefined
         *
         * react-native:
         *  navigator.product -> 'ReactNative'
         * nativescript
         *  navigator.product -> 'NativeScript' or 'NS'
         *
         * @returns {boolean}
         */
        const isStandardBrowserEnv = (() => {
          let product;
          if (
            typeof navigator !== "undefined" &&
            ((product = navigator.product) === "ReactNative" ||
              product === "NativeScript" ||
              product === "NS")
          ) {
            return false;
          }

          return (
            typeof window !== "undefined" && typeof document !== "undefined"
          );
        })();

        /**
         * Determine if we're running in a standard browser webWorker environment
         *
         * Although the `isStandardBrowserEnv` method indicates that
         * `allows axios to run in a web worker`, the WebWorker will still be
         * filtered out due to its judgment standard
         * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
         * This leads to a problem when axios post `FormData` in webWorker
         */
        const isStandardBrowserWebWorkerEnv = (() => {
          return (
            typeof WorkerGlobalScope !== "undefined" &&
            // eslint-disable-next-line no-undef
            self instanceof WorkerGlobalScope &&
            typeof self.importScripts === "function"
          );
        })();

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          isBrowser: true,
          classes: {
            URLSearchParams:
              _classes_URLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__[
                "default"
              ],
            FormData:
              _classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__["default"],
            Blob: _classes_Blob_js__WEBPACK_IMPORTED_MODULE_2__["default"],
          },
          isStandardBrowserEnv,
          isStandardBrowserWebWorkerEnv,
          protocols: ["http", "https", "file", "blob", "url", "data"],
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/utils.js":
      /*!*****************************************!*\
  !*** ./node_modules/axios/lib/utils.js ***!
  \*****************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _helpers_bind_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./helpers/bind.js */ "./node_modules/axios/lib/helpers/bind.js"
          );

        // utils is a library of generic helper functions non-specific to axios

        const { toString } = Object.prototype;
        const { getPrototypeOf } = Object;

        const kindOf = ((cache) => (thing) => {
          const str = toString.call(thing);
          return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
        })(Object.create(null));

        const kindOfTest = (type) => {
          type = type.toLowerCase();
          return (thing) => kindOf(thing) === type;
        };

        const typeOfTest = (type) => (thing) => typeof thing === type;

        /**
         * Determine if a value is an Array
         *
         * @param {Object} val The value to test
         *
         * @returns {boolean} True if value is an Array, otherwise false
         */
        const { isArray } = Array;

        /**
         * Determine if a value is undefined
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if the value is undefined, otherwise false
         */
        const isUndefined = typeOfTest("undefined");

        /**
         * Determine if a value is a Buffer
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is a Buffer, otherwise false
         */
        function isBuffer(val) {
          return (
            val !== null &&
            !isUndefined(val) &&
            val.constructor !== null &&
            !isUndefined(val.constructor) &&
            isFunction(val.constructor.isBuffer) &&
            val.constructor.isBuffer(val)
          );
        }

        /**
         * Determine if a value is an ArrayBuffer
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is an ArrayBuffer, otherwise false
         */
        const isArrayBuffer = kindOfTest("ArrayBuffer");

        /**
         * Determine if a value is a view on an ArrayBuffer
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
         */
        function isArrayBufferView(val) {
          let result;
          if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
            result = ArrayBuffer.isView(val);
          } else {
            result = val && val.buffer && isArrayBuffer(val.buffer);
          }
          return result;
        }

        /**
         * Determine if a value is a String
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is a String, otherwise false
         */
        const isString = typeOfTest("string");

        /**
         * Determine if a value is a Function
         *
         * @param {*} val The value to test
         * @returns {boolean} True if value is a Function, otherwise false
         */
        const isFunction = typeOfTest("function");

        /**
         * Determine if a value is a Number
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is a Number, otherwise false
         */
        const isNumber = typeOfTest("number");

        /**
         * Determine if a value is an Object
         *
         * @param {*} thing The value to test
         *
         * @returns {boolean} True if value is an Object, otherwise false
         */
        const isObject = (thing) => thing !== null && typeof thing === "object";

        /**
         * Determine if a value is a Boolean
         *
         * @param {*} thing The value to test
         * @returns {boolean} True if value is a Boolean, otherwise false
         */
        const isBoolean = (thing) => thing === true || thing === false;

        /**
         * Determine if a value is a plain Object
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is a plain Object, otherwise false
         */
        const isPlainObject = (val) => {
          if (kindOf(val) !== "object") {
            return false;
          }

          const prototype = getPrototypeOf(val);
          return (
            (prototype === null ||
              prototype === Object.prototype ||
              Object.getPrototypeOf(prototype) === null) &&
            !(Symbol.toStringTag in val) &&
            !(Symbol.iterator in val)
          );
        };

        /**
         * Determine if a value is a Date
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is a Date, otherwise false
         */
        const isDate = kindOfTest("Date");

        /**
         * Determine if a value is a File
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is a File, otherwise false
         */
        const isFile = kindOfTest("File");

        /**
         * Determine if a value is a Blob
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is a Blob, otherwise false
         */
        const isBlob = kindOfTest("Blob");

        /**
         * Determine if a value is a FileList
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is a File, otherwise false
         */
        const isFileList = kindOfTest("FileList");

        /**
         * Determine if a value is a Stream
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is a Stream, otherwise false
         */
        const isStream = (val) => isObject(val) && isFunction(val.pipe);

        /**
         * Determine if a value is a FormData
         *
         * @param {*} thing The value to test
         *
         * @returns {boolean} True if value is an FormData, otherwise false
         */
        const isFormData = (thing) => {
          let kind;
          return (
            thing &&
            ((typeof FormData === "function" && thing instanceof FormData) ||
              (isFunction(thing.append) &&
                ((kind = kindOf(thing)) === "formdata" ||
                  // detect form-data instance
                  (kind === "object" &&
                    isFunction(thing.toString) &&
                    thing.toString() === "[object FormData]"))))
          );
        };

        /**
         * Determine if a value is a URLSearchParams object
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is a URLSearchParams object, otherwise false
         */
        const isURLSearchParams = kindOfTest("URLSearchParams");

        /**
         * Trim excess whitespace off the beginning and end of a string
         *
         * @param {String} str The String to trim
         *
         * @returns {String} The String freed of excess whitespace
         */
        const trim = (str) =>
          str.trim
            ? str.trim()
            : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");

        /**
         * Iterate over an Array or an Object invoking a function for each item.
         *
         * If `obj` is an Array callback will be called passing
         * the value, index, and complete array for each item.
         *
         * If 'obj' is an Object callback will be called passing
         * the value, key, and complete object for each property.
         *
         * @param {Object|Array} obj The object to iterate
         * @param {Function} fn The callback to invoke for each item
         *
         * @param {Boolean} [allOwnKeys = false]
         * @returns {any}
         */
        function forEach(obj, fn, { allOwnKeys = false } = {}) {
          // Don't bother if no value provided
          if (obj === null || typeof obj === "undefined") {
            return;
          }

          let i;
          let l;

          // Force an array if not already something iterable
          if (typeof obj !== "object") {
            /*eslint no-param-reassign:0*/
            obj = [obj];
          }

          if (isArray(obj)) {
            // Iterate over array values
            for (i = 0, l = obj.length; i < l; i++) {
              fn.call(null, obj[i], i, obj);
            }
          } else {
            // Iterate over object keys
            const keys = allOwnKeys
              ? Object.getOwnPropertyNames(obj)
              : Object.keys(obj);
            const len = keys.length;
            let key;

            for (i = 0; i < len; i++) {
              key = keys[i];
              fn.call(null, obj[key], key, obj);
            }
          }
        }

        function findKey(obj, key) {
          key = key.toLowerCase();
          const keys = Object.keys(obj);
          let i = keys.length;
          let _key;
          while (i-- > 0) {
            _key = keys[i];
            if (key === _key.toLowerCase()) {
              return _key;
            }
          }
          return null;
        }

        const _global = (() => {
          /*eslint no-undef:0*/
          if (typeof globalThis !== "undefined") return globalThis;
          return typeof self !== "undefined"
            ? self
            : typeof window !== "undefined"
            ? window
            : global;
        })();

        const isContextDefined = (context) =>
          !isUndefined(context) && context !== _global;

        /**
         * Accepts varargs expecting each argument to be an object, then
         * immutably merges the properties of each object and returns result.
         *
         * When multiple objects contain the same key the later object in
         * the arguments list will take precedence.
         *
         * Example:
         *
         * ```js
         * var result = merge({foo: 123}, {foo: 456});
         * console.log(result.foo); // outputs 456
         * ```
         *
         * @param {Object} obj1 Object to merge
         *
         * @returns {Object} Result of all merge properties
         */
        function merge(/* obj1, obj2, obj3, ... */) {
          const { caseless } = (isContextDefined(this) && this) || {};
          const result = {};
          const assignValue = (val, key) => {
            const targetKey = (caseless && findKey(result, key)) || key;
            if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
              result[targetKey] = merge(result[targetKey], val);
            } else if (isPlainObject(val)) {
              result[targetKey] = merge({}, val);
            } else if (isArray(val)) {
              result[targetKey] = val.slice();
            } else {
              result[targetKey] = val;
            }
          };

          for (let i = 0, l = arguments.length; i < l; i++) {
            arguments[i] && forEach(arguments[i], assignValue);
          }
          return result;
        }

        /**
         * Extends object a by mutably adding to it the properties of object b.
         *
         * @param {Object} a The object to be extended
         * @param {Object} b The object to copy properties from
         * @param {Object} thisArg The object to bind function to
         *
         * @param {Boolean} [allOwnKeys]
         * @returns {Object} The resulting value of object a
         */
        const extend = (a, b, thisArg, { allOwnKeys } = {}) => {
          forEach(
            b,
            (val, key) => {
              if (thisArg && isFunction(val)) {
                a[key] = (0,
                _helpers_bind_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                  val,
                  thisArg
                );
              } else {
                a[key] = val;
              }
            },
            { allOwnKeys }
          );
          return a;
        };

        /**
         * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
         *
         * @param {string} content with BOM
         *
         * @returns {string} content value without BOM
         */
        const stripBOM = (content) => {
          if (content.charCodeAt(0) === 0xfeff) {
            content = content.slice(1);
          }
          return content;
        };

        /**
         * Inherit the prototype methods from one constructor into another
         * @param {function} constructor
         * @param {function} superConstructor
         * @param {object} [props]
         * @param {object} [descriptors]
         *
         * @returns {void}
         */
        const inherits = (
          constructor,
          superConstructor,
          props,
          descriptors
        ) => {
          constructor.prototype = Object.create(
            superConstructor.prototype,
            descriptors
          );
          constructor.prototype.constructor = constructor;
          Object.defineProperty(constructor, "super", {
            value: superConstructor.prototype,
          });
          props && Object.assign(constructor.prototype, props);
        };

        /**
         * Resolve object with deep prototype chain to a flat object
         * @param {Object} sourceObj source object
         * @param {Object} [destObj]
         * @param {Function|Boolean} [filter]
         * @param {Function} [propFilter]
         *
         * @returns {Object}
         */
        const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
          let props;
          let i;
          let prop;
          const merged = {};

          destObj = destObj || {};
          // eslint-disable-next-line no-eq-null,eqeqeq
          if (sourceObj == null) return destObj;

          do {
            props = Object.getOwnPropertyNames(sourceObj);
            i = props.length;
            while (i-- > 0) {
              prop = props[i];
              if (
                (!propFilter || propFilter(prop, sourceObj, destObj)) &&
                !merged[prop]
              ) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
              }
            }
            sourceObj = filter !== false && getPrototypeOf(sourceObj);
          } while (
            sourceObj &&
            (!filter || filter(sourceObj, destObj)) &&
            sourceObj !== Object.prototype
          );

          return destObj;
        };

        /**
         * Determines whether a string ends with the characters of a specified string
         *
         * @param {String} str
         * @param {String} searchString
         * @param {Number} [position= 0]
         *
         * @returns {boolean}
         */
        const endsWith = (str, searchString, position) => {
          str = String(str);
          if (position === undefined || position > str.length) {
            position = str.length;
          }
          position -= searchString.length;
          const lastIndex = str.indexOf(searchString, position);
          return lastIndex !== -1 && lastIndex === position;
        };

        /**
         * Returns new array from array like object or null if failed
         *
         * @param {*} [thing]
         *
         * @returns {?Array}
         */
        const toArray = (thing) => {
          if (!thing) return null;
          if (isArray(thing)) return thing;
          let i = thing.length;
          if (!isNumber(i)) return null;
          const arr = new Array(i);
          while (i-- > 0) {
            arr[i] = thing[i];
          }
          return arr;
        };

        /**
         * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
         * thing passed in is an instance of Uint8Array
         *
         * @param {TypedArray}
         *
         * @returns {Array}
         */
        // eslint-disable-next-line func-names
        const isTypedArray = ((TypedArray) => {
          // eslint-disable-next-line func-names
          return (thing) => {
            return TypedArray && thing instanceof TypedArray;
          };
        })(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));

        /**
         * For each entry in the object, call the function with the key and value.
         *
         * @param {Object<any, any>} obj - The object to iterate over.
         * @param {Function} fn - The function to call for each entry.
         *
         * @returns {void}
         */
        const forEachEntry = (obj, fn) => {
          const generator = obj && obj[Symbol.iterator];

          const iterator = generator.call(obj);

          let result;

          while ((result = iterator.next()) && !result.done) {
            const pair = result.value;
            fn.call(obj, pair[0], pair[1]);
          }
        };

        /**
         * It takes a regular expression and a string, and returns an array of all the matches
         *
         * @param {string} regExp - The regular expression to match against.
         * @param {string} str - The string to search.
         *
         * @returns {Array<boolean>}
         */
        const matchAll = (regExp, str) => {
          let matches;
          const arr = [];

          while ((matches = regExp.exec(str)) !== null) {
            arr.push(matches);
          }

          return arr;
        };

        /* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
        const isHTMLForm = kindOfTest("HTMLFormElement");

        const toCamelCase = (str) => {
          return str
            .toLowerCase()
            .replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
              return p1.toUpperCase() + p2;
            });
        };

        /* Creating a function that will check if an object has a property. */
        const hasOwnProperty = (
          ({ hasOwnProperty }) =>
          (obj, prop) =>
            hasOwnProperty.call(obj, prop)
        )(Object.prototype);

        /**
         * Determine if a value is a RegExp object
         *
         * @param {*} val The value to test
         *
         * @returns {boolean} True if value is a RegExp object, otherwise false
         */
        const isRegExp = kindOfTest("RegExp");

        const reduceDescriptors = (obj, reducer) => {
          const descriptors = Object.getOwnPropertyDescriptors(obj);
          const reducedDescriptors = {};

          forEach(descriptors, (descriptor, name) => {
            let ret;
            if ((ret = reducer(descriptor, name, obj)) !== false) {
              reducedDescriptors[name] = ret || descriptor;
            }
          });

          Object.defineProperties(obj, reducedDescriptors);
        };

        /**
         * Makes all methods read-only
         * @param {Object} obj
         */

        const freezeMethods = (obj) => {
          reduceDescriptors(obj, (descriptor, name) => {
            // skip restricted props in strict mode
            if (
              isFunction(obj) &&
              ["arguments", "caller", "callee"].indexOf(name) !== -1
            ) {
              return false;
            }

            const value = obj[name];

            if (!isFunction(value)) return;

            descriptor.enumerable = false;

            if ("writable" in descriptor) {
              descriptor.writable = false;
              return;
            }

            if (!descriptor.set) {
              descriptor.set = () => {
                throw Error("Can not rewrite read-only method '" + name + "'");
              };
            }
          });
        };

        const toObjectSet = (arrayOrString, delimiter) => {
          const obj = {};

          const define = (arr) => {
            arr.forEach((value) => {
              obj[value] = true;
            });
          };

          isArray(arrayOrString)
            ? define(arrayOrString)
            : define(String(arrayOrString).split(delimiter));

          return obj;
        };

        const noop = () => {};

        const toFiniteNumber = (value, defaultValue) => {
          value = +value;
          return Number.isFinite(value) ? value : defaultValue;
        };

        const ALPHA = "abcdefghijklmnopqrstuvwxyz";

        const DIGIT = "0123456789";

        const ALPHABET = {
          DIGIT,
          ALPHA,
          ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT,
        };

        const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
          let str = "";
          const { length } = alphabet;
          while (size--) {
            str += alphabet[(Math.random() * length) | 0];
          }

          return str;
        };

        /**
         * If the thing is a FormData object, return true, otherwise return false.
         *
         * @param {unknown} thing - The thing to check.
         *
         * @returns {boolean}
         */
        function isSpecCompliantForm(thing) {
          return !!(
            thing &&
            isFunction(thing.append) &&
            thing[Symbol.toStringTag] === "FormData" &&
            thing[Symbol.iterator]
          );
        }

        const toJSONObject = (obj) => {
          const stack = new Array(10);

          const visit = (source, i) => {
            if (isObject(source)) {
              if (stack.indexOf(source) >= 0) {
                return;
              }

              if (!("toJSON" in source)) {
                stack[i] = source;
                const target = isArray(source) ? [] : {};

                forEach(source, (value, key) => {
                  const reducedValue = visit(value, i + 1);
                  !isUndefined(reducedValue) && (target[key] = reducedValue);
                });

                stack[i] = undefined;

                return target;
              }
            }

            return source;
          };

          return visit(obj, 0);
        };

        const isAsyncFn = kindOfTest("AsyncFunction");

        const isThenable = (thing) =>
          thing &&
          (isObject(thing) || isFunction(thing)) &&
          isFunction(thing.then) &&
          isFunction(thing.catch);

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          isArray,
          isArrayBuffer,
          isBuffer,
          isFormData,
          isArrayBufferView,
          isString,
          isNumber,
          isBoolean,
          isObject,
          isPlainObject,
          isUndefined,
          isDate,
          isFile,
          isBlob,
          isRegExp,
          isFunction,
          isStream,
          isURLSearchParams,
          isTypedArray,
          isFileList,
          forEach,
          merge,
          extend,
          trim,
          stripBOM,
          inherits,
          toFlatObject,
          kindOf,
          kindOfTest,
          endsWith,
          toArray,
          forEachEntry,
          matchAll,
          isHTMLForm,
          hasOwnProperty,
          hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
          reduceDescriptors,
          freezeMethods,
          toObjectSet,
          toCamelCase,
          noop,
          toFiniteNumber,
          findKey,
          global: _global,
          isContextDefined,
          ALPHABET,
          generateString,
          isSpecCompliantForm,
          toJSONObject,
          isAsyncFn,
          isThenable,
        };

        /***/
      },

    /***/ "./node_modules/lodash-es/_Symbol.js":
      /*!*******************************************!*\
  !*** ./node_modules/lodash-es/_Symbol.js ***!
  \*******************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./_root.js */ "./node_modules/lodash-es/_root.js"
          );

        /** Built-in value references. */
        var Symbol = _root_js__WEBPACK_IMPORTED_MODULE_0__["default"].Symbol;

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = Symbol;

        /***/
      },

    /***/ "./node_modules/lodash-es/_baseGetTag.js":
      /*!***********************************************!*\
  !*** ./node_modules/lodash-es/_baseGetTag.js ***!
  \***********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _Symbol_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./_Symbol.js */ "./node_modules/lodash-es/_Symbol.js"
          );
        /* harmony import */ var _getRawTag_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./_getRawTag.js */ "./node_modules/lodash-es/_getRawTag.js"
          );
        /* harmony import */ var _objectToString_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./_objectToString.js */ "./node_modules/lodash-es/_objectToString.js"
          );

        /** `Object#toString` result references. */
        var nullTag = "[object Null]",
          undefinedTag = "[object Undefined]";

        /** Built-in value references. */
        var symToStringTag = _Symbol_js__WEBPACK_IMPORTED_MODULE_0__["default"]
          ? _Symbol_js__WEBPACK_IMPORTED_MODULE_0__["default"].toStringTag
          : undefined;

        /**
         * The base implementation of `getTag` without fallbacks for buggy environments.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object(value)
            ? (0, _getRawTag_js__WEBPACK_IMPORTED_MODULE_1__["default"])(value)
            : (0, _objectToString_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
                value
              );
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          baseGetTag;

        /***/
      },

    /***/ "./node_modules/lodash-es/_baseTrim.js":
      /*!*********************************************!*\
  !*** ./node_modules/lodash-es/_baseTrim.js ***!
  \*********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _trimmedEndIndex_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./_trimmedEndIndex.js */ "./node_modules/lodash-es/_trimmedEndIndex.js"
          );

        /** Used to match leading whitespace. */
        var reTrimStart = /^\s+/;

        /**
         * The base implementation of `_.trim`.
         *
         * @private
         * @param {string} string The string to trim.
         * @returns {string} Returns the trimmed string.
         */
        function baseTrim(string) {
          return string
            ? string
                .slice(
                  0,
                  (0,
                  _trimmedEndIndex_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                    string
                  ) + 1
                )
                .replace(reTrimStart, "")
            : string;
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          baseTrim;

        /***/
      },

    /***/ "./node_modules/lodash-es/_freeGlobal.js":
      /*!***********************************************!*\
  !*** ./node_modules/lodash-es/_freeGlobal.js ***!
  \***********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /** Detect free variable `global` from Node.js. */
        var freeGlobal =
          typeof global == "object" &&
          global &&
          global.Object === Object &&
          global;

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          freeGlobal;

        /***/
      },

    /***/ "./node_modules/lodash-es/_getRawTag.js":
      /*!**********************************************!*\
  !*** ./node_modules/lodash-es/_getRawTag.js ***!
  \**********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _Symbol_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./_Symbol.js */ "./node_modules/lodash-es/_Symbol.js"
          );

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */
        var nativeObjectToString = objectProto.toString;

        /** Built-in value references. */
        var symToStringTag = _Symbol_js__WEBPACK_IMPORTED_MODULE_0__["default"]
          ? _Symbol_js__WEBPACK_IMPORTED_MODULE_0__["default"].toStringTag
          : undefined;

        /**
         * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the raw `toStringTag`.
         */
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag),
            tag = value[symToStringTag];

          try {
            value[symToStringTag] = undefined;
            var unmasked = true;
          } catch (e) {}

          var result = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result;
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          getRawTag;

        /***/
      },

    /***/ "./node_modules/lodash-es/_objectToString.js":
      /*!***************************************************!*\
  !*** ./node_modules/lodash-es/_objectToString.js ***!
  \***************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */
        var nativeObjectToString = objectProto.toString;

        /**
         * Converts `value` to a string using `Object.prototype.toString`.
         *
         * @private
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         */
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          objectToString;

        /***/
      },

    /***/ "./node_modules/lodash-es/_root.js":
      /*!*****************************************!*\
  !*** ./node_modules/lodash-es/_root.js ***!
  \*****************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./_freeGlobal.js */ "./node_modules/lodash-es/_freeGlobal.js"
          );

        /** Detect free variable `self`. */
        var freeSelf =
          typeof self == "object" && self && self.Object === Object && self;

        /** Used as a reference to the global object. */
        var root =
          _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__["default"] ||
          freeSelf ||
          Function("return this")();

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = root;

        /***/
      },

    /***/ "./node_modules/lodash-es/_trimmedEndIndex.js":
      /*!****************************************************!*\
  !*** ./node_modules/lodash-es/_trimmedEndIndex.js ***!
  \****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /** Used to match a single whitespace character. */
        var reWhitespace = /\s/;

        /**
         * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
         * character of `string`.
         *
         * @private
         * @param {string} string The string to inspect.
         * @returns {number} Returns the index of the last non-whitespace character.
         */
        function trimmedEndIndex(string) {
          var index = string.length;

          while (index-- && reWhitespace.test(string.charAt(index))) {}
          return index;
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          trimmedEndIndex;

        /***/
      },

    /***/ "./node_modules/lodash-es/debounce.js":
      /*!********************************************!*\
  !*** ./node_modules/lodash-es/debounce.js ***!
  \********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _isObject_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./isObject.js */ "./node_modules/lodash-es/isObject.js"
          );
        /* harmony import */ var _now_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./now.js */ "./node_modules/lodash-es/now.js"
          );
        /* harmony import */ var _toNumber_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./toNumber.js */ "./node_modules/lodash-es/toNumber.js"
          );

        /** Error message constants. */
        var FUNC_ERROR_TEXT = "Expected a function";

        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeMax = Math.max,
          nativeMin = Math.min;

        /**
         * Creates a debounced function that delays invoking `func` until after `wait`
         * milliseconds have elapsed since the last time the debounced function was
         * invoked. The debounced function comes with a `cancel` method to cancel
         * delayed `func` invocations and a `flush` method to immediately invoke them.
         * Provide `options` to indicate whether `func` should be invoked on the
         * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
         * with the last arguments provided to the debounced function. Subsequent
         * calls to the debounced function return the result of the last `func`
         * invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the debounced function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.debounce` and `_.throttle`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to debounce.
         * @param {number} [wait=0] The number of milliseconds to delay.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=false]
         *  Specify invoking on the leading edge of the timeout.
         * @param {number} [options.maxWait]
         *  The maximum time `func` is allowed to be delayed before it's invoked.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new debounced function.
         * @example
         *
         * // Avoid costly calculations while the window size is in flux.
         * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
         *
         * // Invoke `sendMail` when clicked, debouncing subsequent calls.
         * jQuery(element).on('click', _.debounce(sendMail, 300, {
         *   'leading': true,
         *   'trailing': false
         * }));
         *
         * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
         * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
         * var source = new EventSource('/stream');
         * jQuery(source).on('message', debounced);
         *
         * // Cancel the trailing debounced invocation.
         * jQuery(window).on('popstate', debounced.cancel);
         */
        function debounce(func, wait, options) {
          var lastArgs,
            lastThis,
            maxWait,
            result,
            timerId,
            lastCallTime,
            lastInvokeTime = 0,
            leading = false,
            maxing = false,
            trailing = true;

          if (typeof func != "function") {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          wait =
            (0, _toNumber_js__WEBPACK_IMPORTED_MODULE_0__["default"])(wait) ||
            0;
          if (
            (0, _isObject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(options)
          ) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing
              ? nativeMax(
                  (0, _toNumber_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                    options.maxWait
                  ) || 0,
                  wait
                )
              : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }

          function invokeFunc(time) {
            var args = lastArgs,
              thisArg = lastThis;

            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
          }

          function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time;
            // Start the timer for the trailing edge.
            timerId = setTimeout(timerExpired, wait);
            // Invoke the leading edge.
            return leading ? invokeFunc(time) : result;
          }

          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime,
              timeSinceLastInvoke = time - lastInvokeTime,
              timeWaiting = wait - timeSinceLastCall;

            return maxing
              ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
              : timeWaiting;
          }

          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime,
              timeSinceLastInvoke = time - lastInvokeTime;

            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return (
              lastCallTime === undefined ||
              timeSinceLastCall >= wait ||
              timeSinceLastCall < 0 ||
              (maxing && timeSinceLastInvoke >= maxWait)
            );
          }

          function timerExpired() {
            var time = (0, _now_js__WEBPACK_IMPORTED_MODULE_2__["default"])();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            // Restart the timer.
            timerId = setTimeout(timerExpired, remainingWait(time));
          }

          function trailingEdge(time) {
            timerId = undefined;

            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined;
            return result;
          }

          function cancel() {
            if (timerId !== undefined) {
              clearTimeout(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
          }

          function flush() {
            return timerId === undefined
              ? result
              : trailingEdge(
                  (0, _now_js__WEBPACK_IMPORTED_MODULE_2__["default"])()
                );
          }

          function debounced() {
            var time = (0, _now_js__WEBPACK_IMPORTED_MODULE_2__["default"])(),
              isInvoking = shouldInvoke(time);

            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;

            if (isInvoking) {
              if (timerId === undefined) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined) {
              timerId = setTimeout(timerExpired, wait);
            }
            return result;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          debounce;

        /***/
      },

    /***/ "./node_modules/lodash-es/fromPairs.js":
      /*!*********************************************!*\
  !*** ./node_modules/lodash-es/fromPairs.js ***!
  \*********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /**
         * The inverse of `_.toPairs`; this method returns an object composed
         * from key-value `pairs`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} pairs The key-value pairs.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.fromPairs([['a', 1], ['b', 2]]);
         * // => { 'a': 1, 'b': 2 }
         */
        function fromPairs(pairs) {
          var index = -1,
            length = pairs == null ? 0 : pairs.length,
            result = {};

          while (++index < length) {
            var pair = pairs[index];
            result[pair[0]] = pair[1];
          }
          return result;
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          fromPairs;

        /***/
      },

    /***/ "./node_modules/lodash-es/isObject.js":
      /*!********************************************!*\
  !*** ./node_modules/lodash-es/isObject.js ***!
  \********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          isObject;

        /***/
      },

    /***/ "./node_modules/lodash-es/isObjectLike.js":
      /*!************************************************!*\
  !*** ./node_modules/lodash-es/isObjectLike.js ***!
  \************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          isObjectLike;

        /***/
      },

    /***/ "./node_modules/lodash-es/isSymbol.js":
      /*!********************************************!*\
  !*** ./node_modules/lodash-es/isSymbol.js ***!
  \********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _baseGetTag_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./_baseGetTag.js */ "./node_modules/lodash-es/_baseGetTag.js"
          );
        /* harmony import */ var _isObjectLike_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./isObjectLike.js */ "./node_modules/lodash-es/isObjectLike.js"
          );

        /** `Object#toString` result references. */
        var symbolTag = "[object Symbol]";

        /**
         * Checks if `value` is classified as a `Symbol` primitive or object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
         * @example
         *
         * _.isSymbol(Symbol.iterator);
         * // => true
         *
         * _.isSymbol('abc');
         * // => false
         */
        function isSymbol(value) {
          return (
            typeof value == "symbol" ||
            ((0, _isObjectLike_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
              value
            ) &&
              (0, _baseGetTag_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
                value
              ) == symbolTag)
          );
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          isSymbol;

        /***/
      },

    /***/ "./node_modules/lodash-es/now.js":
      /*!***************************************!*\
  !*** ./node_modules/lodash-es/now.js ***!
  \***************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./_root.js */ "./node_modules/lodash-es/_root.js"
          );

        /**
         * Gets the timestamp of the number of milliseconds that have elapsed since
         * the Unix epoch (1 January 1970 00:00:00 UTC).
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Date
         * @returns {number} Returns the timestamp.
         * @example
         *
         * _.defer(function(stamp) {
         *   console.log(_.now() - stamp);
         * }, _.now());
         * // => Logs the number of milliseconds it took for the deferred invocation.
         */
        var now = function () {
          return _root_js__WEBPACK_IMPORTED_MODULE_0__["default"].Date.now();
        };

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = now;

        /***/
      },

    /***/ "./node_modules/lodash-es/throttle.js":
      /*!********************************************!*\
  !*** ./node_modules/lodash-es/throttle.js ***!
  \********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _debounce_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./debounce.js */ "./node_modules/lodash-es/debounce.js"
          );
        /* harmony import */ var _isObject_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./isObject.js */ "./node_modules/lodash-es/isObject.js"
          );

        /** Error message constants. */
        var FUNC_ERROR_TEXT = "Expected a function";

        /**
         * Creates a throttled function that only invokes `func` at most once per
         * every `wait` milliseconds. The throttled function comes with a `cancel`
         * method to cancel delayed `func` invocations and a `flush` method to
         * immediately invoke them. Provide `options` to indicate whether `func`
         * should be invoked on the leading and/or trailing edge of the `wait`
         * timeout. The `func` is invoked with the last arguments provided to the
         * throttled function. Subsequent calls to the throttled function return the
         * result of the last `func` invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the throttled function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.throttle` and `_.debounce`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to throttle.
         * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=true]
         *  Specify invoking on the leading edge of the timeout.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new throttled function.
         * @example
         *
         * // Avoid excessively updating the position while scrolling.
         * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
         *
         * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
         * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
         * jQuery(element).on('click', throttled);
         *
         * // Cancel the trailing throttled invocation.
         * jQuery(window).on('popstate', throttled.cancel);
         */
        function throttle(func, wait, options) {
          var leading = true,
            trailing = true;

          if (typeof func != "function") {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (
            (0, _isObject_js__WEBPACK_IMPORTED_MODULE_0__["default"])(options)
          ) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return (0, _debounce_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
            func,
            wait,
            {
              leading: leading,
              maxWait: wait,
              trailing: trailing,
            }
          );
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          throttle;

        /***/
      },

    /***/ "./node_modules/lodash-es/toNumber.js":
      /*!********************************************!*\
  !*** ./node_modules/lodash-es/toNumber.js ***!
  \********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _baseTrim_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./_baseTrim.js */ "./node_modules/lodash-es/_baseTrim.js"
          );
        /* harmony import */ var _isObject_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./isObject.js */ "./node_modules/lodash-es/isObject.js"
          );
        /* harmony import */ var _isSymbol_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./isSymbol.js */ "./node_modules/lodash-es/isSymbol.js"
          );

        /** Used as references for various `Number` constants. */
        var NAN = 0 / 0;

        /** Used to detect bad signed hexadecimal string values. */
        var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

        /** Used to detect binary string values. */
        var reIsBinary = /^0b[01]+$/i;

        /** Used to detect octal string values. */
        var reIsOctal = /^0o[0-7]+$/i;

        /** Built-in method references without a dependency on `root`. */
        var freeParseInt = parseInt;

        /**
         * Converts `value` to a number.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         * @example
         *
         * _.toNumber(3.2);
         * // => 3.2
         *
         * _.toNumber(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toNumber(Infinity);
         * // => Infinity
         *
         * _.toNumber('3.2');
         * // => 3.2
         */
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (
            (0, _isSymbol_js__WEBPACK_IMPORTED_MODULE_0__["default"])(value)
          ) {
            return NAN;
          }
          if (
            (0, _isObject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(value)
          ) {
            var other =
              typeof value.valueOf == "function" ? value.valueOf() : value;
            value = (0, _isObject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
              other
            )
              ? other + ""
              : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = (0, _baseTrim_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
            value
          );
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value)
            ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
            : reIsBadHex.test(value)
            ? NAN
            : +value;
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          toNumber;

        /***/
      },

    /***/ "./node_modules/swiper/modules/a11y.mjs":
      /*!**********************************************!*\
  !*** ./node_modules/swiper/modules/a11y.mjs ***!
  \**********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ A11y,
          /* harmony export */
        });
        /* harmony import */ var _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/classes-to-selector.mjs */ "./node_modules/swiper/shared/classes-to-selector.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function A11y(_ref) {
          let { swiper, extendParams, on } = _ref;
          extendParams({
            a11y: {
              enabled: true,
              notificationClass: "swiper-notification",
              prevSlideMessage: "Previous slide",
              nextSlideMessage: "Next slide",
              firstSlideMessage: "This is the first slide",
              lastSlideMessage: "This is the last slide",
              paginationBulletMessage: "Go to slide {{index}}",
              slideLabelMessage: "{{index}} / {{slidesLength}}",
              containerMessage: null,
              containerRoleDescriptionMessage: null,
              itemRoleDescriptionMessage: null,
              slideRole: "group",
              id: null,
            },
          });
          swiper.a11y = {
            clicked: false,
          };
          let liveRegion = null;
          function notify(message) {
            const notification = liveRegion;
            if (notification.length === 0) return;
            notification.innerHTML = "";
            notification.innerHTML = message;
          }
          const makeElementsArray = (el) =>
            (Array.isArray(el) ? el : [el]).filter((e) => !!e);
          function getRandomNumber(size) {
            if (size === void 0) {
              size = 16;
            }
            const randomChar = () =>
              Math.round(16 * Math.random()).toString(16);
            return "x".repeat(size).replace(/x/g, randomChar);
          }
          function makeElFocusable(el) {
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              subEl.setAttribute("tabIndex", "0");
            });
          }
          function makeElNotFocusable(el) {
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              subEl.setAttribute("tabIndex", "-1");
            });
          }
          function addElRole(el, role) {
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              subEl.setAttribute("role", role);
            });
          }
          function addElRoleDescription(el, description) {
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              subEl.setAttribute("aria-roledescription", description);
            });
          }
          function addElControls(el, controls) {
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              subEl.setAttribute("aria-controls", controls);
            });
          }
          function addElLabel(el, label) {
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              subEl.setAttribute("aria-label", label);
            });
          }
          function addElId(el, id) {
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              subEl.setAttribute("id", id);
            });
          }
          function addElLive(el, live) {
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              subEl.setAttribute("aria-live", live);
            });
          }
          function disableEl(el) {
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              subEl.setAttribute("aria-disabled", true);
            });
          }
          function enableEl(el) {
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              subEl.setAttribute("aria-disabled", false);
            });
          }
          function onEnterOrSpaceKey(e) {
            if (e.keyCode !== 13 && e.keyCode !== 32) return;
            const params = swiper.params.a11y;
            const targetEl = e.target;
            if (
              swiper.pagination &&
              swiper.pagination.el &&
              (targetEl === swiper.pagination.el ||
                swiper.pagination.el.contains(e.target))
            ) {
              if (
                !e.target.matches(
                  (0,
                  _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                    swiper.params.pagination.bulletClass
                  )
                )
              )
                return;
            }
            if (
              swiper.navigation &&
              swiper.navigation.nextEl &&
              targetEl === swiper.navigation.nextEl
            ) {
              if (!(swiper.isEnd && !swiper.params.loop)) {
                swiper.slideNext();
              }
              if (swiper.isEnd) {
                notify(params.lastSlideMessage);
              } else {
                notify(params.nextSlideMessage);
              }
            }
            if (
              swiper.navigation &&
              swiper.navigation.prevEl &&
              targetEl === swiper.navigation.prevEl
            ) {
              if (!(swiper.isBeginning && !swiper.params.loop)) {
                swiper.slidePrev();
              }
              if (swiper.isBeginning) {
                notify(params.firstSlideMessage);
              } else {
                notify(params.prevSlideMessage);
              }
            }
            if (
              swiper.pagination &&
              targetEl.matches(
                (0,
                _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                  swiper.params.pagination.bulletClass
                )
              )
            ) {
              targetEl.click();
            }
          }
          function updateNavigation() {
            if (
              swiper.params.loop ||
              swiper.params.rewind ||
              !swiper.navigation
            )
              return;
            const { nextEl, prevEl } = swiper.navigation;
            if (prevEl) {
              if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
              } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
              }
            }
            if (nextEl) {
              if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
              } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
              }
            }
          }
          function hasPagination() {
            return (
              swiper.pagination &&
              swiper.pagination.bullets &&
              swiper.pagination.bullets.length
            );
          }
          function hasClickablePagination() {
            return hasPagination() && swiper.params.pagination.clickable;
          }
          function updatePagination() {
            const params = swiper.params.a11y;
            if (!hasPagination()) return;
            swiper.pagination.bullets.forEach((bulletEl) => {
              if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                  addElRole(bulletEl, "button");
                  addElLabel(
                    bulletEl,
                    params.paginationBulletMessage.replace(
                      /\{\{index\}\}/,
                      (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.g)(
                        bulletEl
                      ) + 1
                    )
                  );
                }
              }
              if (
                bulletEl.matches(
                  (0,
                  _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                    swiper.params.pagination.bulletActiveClass
                  )
                )
              ) {
                bulletEl.setAttribute("aria-current", "true");
              } else {
                bulletEl.removeAttribute("aria-current");
              }
            });
          }
          const initNavEl = (el, wrapperId, message) => {
            makeElFocusable(el);
            if (el.tagName !== "BUTTON") {
              addElRole(el, "button");
              el.addEventListener("keydown", onEnterOrSpaceKey);
            }
            addElLabel(el, message);
            addElControls(el, wrapperId);
          };
          const handlePointerDown = () => {
            swiper.a11y.clicked = true;
          };
          const handlePointerUp = () => {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                if (!swiper.destroyed) {
                  swiper.a11y.clicked = false;
                }
              });
            });
          };
          const handleFocus = (e) => {
            if (swiper.a11y.clicked) return;
            const slideEl = e.target.closest(
              `.${swiper.params.slideClass}, swiper-slide`
            );
            if (!slideEl || !swiper.slides.includes(slideEl)) return;
            const isActive =
              swiper.slides.indexOf(slideEl) === swiper.activeIndex;
            const isVisible =
              swiper.params.watchSlidesProgress &&
              swiper.visibleSlides &&
              swiper.visibleSlides.includes(slideEl);
            if (isActive || isVisible) return;
            if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents)
              return;
            if (swiper.isHorizontal()) {
              swiper.el.scrollLeft = 0;
            } else {
              swiper.el.scrollTop = 0;
            }
            swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
          };
          const initSlides = () => {
            const params = swiper.params.a11y;
            if (params.itemRoleDescriptionMessage) {
              addElRoleDescription(
                swiper.slides,
                params.itemRoleDescriptionMessage
              );
            }
            if (params.slideRole) {
              addElRole(swiper.slides, params.slideRole);
            }
            const slidesLength = swiper.slides.length;
            if (params.slideLabelMessage) {
              swiper.slides.forEach((slideEl, index) => {
                const slideIndex = swiper.params.loop
                  ? parseInt(
                      slideEl.getAttribute("data-swiper-slide-index"),
                      10
                    )
                  : index;
                const ariaLabelMessage = params.slideLabelMessage
                  .replace(/\{\{index\}\}/, slideIndex + 1)
                  .replace(/\{\{slidesLength\}\}/, slidesLength);
                addElLabel(slideEl, ariaLabelMessage);
              });
            }
          };
          const init = () => {
            const params = swiper.params.a11y;
            swiper.el.append(liveRegion);

            // Container
            const containerEl = swiper.el;
            if (params.containerRoleDescriptionMessage) {
              addElRoleDescription(
                containerEl,
                params.containerRoleDescriptionMessage
              );
            }
            if (params.containerMessage) {
              addElLabel(containerEl, params.containerMessage);
            }

            // Wrapper
            const wrapperEl = swiper.wrapperEl;
            const wrapperId =
              params.id ||
              wrapperEl.getAttribute("id") ||
              `swiper-wrapper-${getRandomNumber(16)}`;
            const live =
              swiper.params.autoplay && swiper.params.autoplay.enabled
                ? "off"
                : "polite";
            addElId(wrapperEl, wrapperId);
            addElLive(wrapperEl, live);

            // Slide
            initSlides();

            // Navigation
            let { nextEl, prevEl } = swiper.navigation ? swiper.navigation : {};
            nextEl = makeElementsArray(nextEl);
            prevEl = makeElementsArray(prevEl);
            if (nextEl) {
              nextEl.forEach((el) =>
                initNavEl(el, wrapperId, params.nextSlideMessage)
              );
            }
            if (prevEl) {
              prevEl.forEach((el) =>
                initNavEl(el, wrapperId, params.prevSlideMessage)
              );
            }

            // Pagination
            if (hasClickablePagination()) {
              const paginationEl = Array.isArray(swiper.pagination.el)
                ? swiper.pagination.el
                : [swiper.pagination.el];
              paginationEl.forEach((el) => {
                el.addEventListener("keydown", onEnterOrSpaceKey);
              });
            }

            // Tab focus
            swiper.el.addEventListener("focus", handleFocus, true);
            swiper.el.addEventListener("pointerdown", handlePointerDown, true);
            swiper.el.addEventListener("pointerup", handlePointerUp, true);
          };
          function destroy() {
            if (liveRegion) liveRegion.remove();
            let { nextEl, prevEl } = swiper.navigation ? swiper.navigation : {};
            nextEl = makeElementsArray(nextEl);
            prevEl = makeElementsArray(prevEl);
            if (nextEl) {
              nextEl.forEach((el) =>
                el.removeEventListener("keydown", onEnterOrSpaceKey)
              );
            }
            if (prevEl) {
              prevEl.forEach((el) =>
                el.removeEventListener("keydown", onEnterOrSpaceKey)
              );
            }

            // Pagination
            if (hasClickablePagination()) {
              const paginationEl = Array.isArray(swiper.pagination.el)
                ? swiper.pagination.el
                : [swiper.pagination.el];
              paginationEl.forEach((el) => {
                el.removeEventListener("keydown", onEnterOrSpaceKey);
              });
            }

            // Tab focus
            swiper.el.removeEventListener("focus", handleFocus, true);
            swiper.el.removeEventListener(
              "pointerdown",
              handlePointerDown,
              true
            );
            swiper.el.removeEventListener("pointerup", handlePointerUp, true);
          }
          on("beforeInit", () => {
            liveRegion = (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
              "span",
              swiper.params.a11y.notificationClass
            );
            liveRegion.setAttribute("aria-live", "assertive");
            liveRegion.setAttribute("aria-atomic", "true");
          });
          on("afterInit", () => {
            if (!swiper.params.a11y.enabled) return;
            init();
          });
          on(
            "slidesLengthChange snapGridLengthChange slidesGridLengthChange",
            () => {
              if (!swiper.params.a11y.enabled) return;
              initSlides();
            }
          );
          on("fromEdge toEdge afterInit lock unlock", () => {
            if (!swiper.params.a11y.enabled) return;
            updateNavigation();
          });
          on("paginationUpdate", () => {
            if (!swiper.params.a11y.enabled) return;
            updatePagination();
          });
          on("destroy", () => {
            if (!swiper.params.a11y.enabled) return;
            destroy();
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/autoplay.mjs":
      /*!**************************************************!*\
  !*** ./node_modules/swiper/modules/autoplay.mjs ***!
  \**************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Autoplay,
          /* harmony export */
        });
        /* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs"
          );

        /* eslint no-underscore-dangle: "off" */
        /* eslint no-use-before-define: "off" */
        function Autoplay(_ref) {
          let { swiper, extendParams, on, emit, params } = _ref;
          swiper.autoplay = {
            running: false,
            paused: false,
            timeLeft: 0,
          };
          extendParams({
            autoplay: {
              enabled: false,
              delay: 3000,
              waitForTransition: true,
              disableOnInteraction: true,
              stopOnLastSlide: false,
              reverseDirection: false,
              pauseOnMouseEnter: false,
            },
          });
          let timeout;
          let raf;
          let autoplayDelayTotal =
            params && params.autoplay ? params.autoplay.delay : 3000;
          let autoplayDelayCurrent =
            params && params.autoplay ? params.autoplay.delay : 3000;
          let autoplayTimeLeft;
          let autoplayStartTime = new Date().getTime;
          let wasPaused;
          let isTouched;
          let pausedByTouch;
          let touchStartTimeout;
          let slideChanged;
          let pausedByInteraction;
          function onTransitionEnd(e) {
            if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
            if (e.target !== swiper.wrapperEl) return;
            swiper.wrapperEl.removeEventListener(
              "transitionend",
              onTransitionEnd
            );
            resume();
          }
          const calcTimeLeft = () => {
            if (swiper.destroyed || !swiper.autoplay.running) return;
            if (swiper.autoplay.paused) {
              wasPaused = true;
            } else if (wasPaused) {
              autoplayDelayCurrent = autoplayTimeLeft;
              wasPaused = false;
            }
            const timeLeft = swiper.autoplay.paused
              ? autoplayTimeLeft
              : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
            swiper.autoplay.timeLeft = timeLeft;
            emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
            raf = requestAnimationFrame(() => {
              calcTimeLeft();
            });
          };
          const getSlideDelay = () => {
            let activeSlideEl;
            if (swiper.virtual && swiper.params.virtual.enabled) {
              activeSlideEl = swiper.slides.filter((slideEl) =>
                slideEl.classList.contains("swiper-slide-active")
              )[0];
            } else {
              activeSlideEl = swiper.slides[swiper.activeIndex];
            }
            if (!activeSlideEl) return undefined;
            const currentSlideDelay = parseInt(
              activeSlideEl.getAttribute("data-swiper-autoplay"),
              10
            );
            return currentSlideDelay;
          };
          const run = (delayForce) => {
            if (swiper.destroyed || !swiper.autoplay.running) return;
            cancelAnimationFrame(raf);
            calcTimeLeft();
            let delay =
              typeof delayForce === "undefined"
                ? swiper.params.autoplay.delay
                : delayForce;
            autoplayDelayTotal = swiper.params.autoplay.delay;
            autoplayDelayCurrent = swiper.params.autoplay.delay;
            const currentSlideDelay = getSlideDelay();
            if (
              !Number.isNaN(currentSlideDelay) &&
              currentSlideDelay > 0 &&
              typeof delayForce === "undefined"
            ) {
              delay = currentSlideDelay;
              autoplayDelayTotal = currentSlideDelay;
              autoplayDelayCurrent = currentSlideDelay;
            }
            autoplayTimeLeft = delay;
            const speed = swiper.params.speed;
            const proceed = () => {
              if (!swiper || swiper.destroyed) return;
              if (swiper.params.autoplay.reverseDirection) {
                if (
                  !swiper.isBeginning ||
                  swiper.params.loop ||
                  swiper.params.rewind
                ) {
                  swiper.slidePrev(speed, true, true);
                  emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                  swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                  emit("autoplay");
                }
              } else {
                if (
                  !swiper.isEnd ||
                  swiper.params.loop ||
                  swiper.params.rewind
                ) {
                  swiper.slideNext(speed, true, true);
                  emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                  swiper.slideTo(0, speed, true, true);
                  emit("autoplay");
                }
              }
              if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(() => {
                  run();
                });
              }
            };
            if (delay > 0) {
              clearTimeout(timeout);
              timeout = setTimeout(() => {
                proceed();
              }, delay);
            } else {
              requestAnimationFrame(() => {
                proceed();
              });
            }

            // eslint-disable-next-line
            return delay;
          };
          const start = () => {
            swiper.autoplay.running = true;
            run();
            emit("autoplayStart");
          };
          const stop = () => {
            swiper.autoplay.running = false;
            clearTimeout(timeout);
            cancelAnimationFrame(raf);
            emit("autoplayStop");
          };
          const pause = (internal, reset) => {
            if (swiper.destroyed || !swiper.autoplay.running) return;
            clearTimeout(timeout);
            if (!internal) {
              pausedByInteraction = true;
            }
            const proceed = () => {
              emit("autoplayPause");
              if (swiper.params.autoplay.waitForTransition) {
                swiper.wrapperEl.addEventListener(
                  "transitionend",
                  onTransitionEnd
                );
              } else {
                resume();
              }
            };
            swiper.autoplay.paused = true;
            if (reset) {
              if (slideChanged) {
                autoplayTimeLeft = swiper.params.autoplay.delay;
              }
              slideChanged = false;
              proceed();
              return;
            }
            const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
            autoplayTimeLeft =
              delay - (new Date().getTime() - autoplayStartTime);
            if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop)
              return;
            if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
            proceed();
          };
          const resume = () => {
            if (
              (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) ||
              swiper.destroyed ||
              !swiper.autoplay.running
            )
              return;
            autoplayStartTime = new Date().getTime();
            if (pausedByInteraction) {
              pausedByInteraction = false;
              run(autoplayTimeLeft);
            } else {
              run();
            }
            swiper.autoplay.paused = false;
            emit("autoplayResume");
          };
          const onVisibilityChange = () => {
            if (swiper.destroyed || !swiper.autoplay.running) return;
            const document = (0,
            _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
            if (document.visibilityState === "hidden") {
              pausedByInteraction = true;
              pause(true);
            }
            if (document.visibilityState === "visible") {
              resume();
            }
          };
          const onPointerEnter = (e) => {
            if (e.pointerType !== "mouse") return;
            pausedByInteraction = true;
            if (swiper.animating || swiper.autoplay.paused) return;
            pause(true);
          };
          const onPointerLeave = (e) => {
            if (e.pointerType !== "mouse") return;
            if (swiper.autoplay.paused) {
              resume();
            }
          };
          const attachMouseEvents = () => {
            if (swiper.params.autoplay.pauseOnMouseEnter) {
              swiper.el.addEventListener("pointerenter", onPointerEnter);
              swiper.el.addEventListener("pointerleave", onPointerLeave);
            }
          };
          const detachMouseEvents = () => {
            swiper.el.removeEventListener("pointerenter", onPointerEnter);
            swiper.el.removeEventListener("pointerleave", onPointerLeave);
          };
          const attachDocumentEvents = () => {
            const document = (0,
            _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
            document.addEventListener("visibilitychange", onVisibilityChange);
          };
          const detachDocumentEvents = () => {
            const document = (0,
            _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
            document.removeEventListener(
              "visibilitychange",
              onVisibilityChange
            );
          };
          on("init", () => {
            if (swiper.params.autoplay.enabled) {
              attachMouseEvents();
              attachDocumentEvents();
              autoplayStartTime = new Date().getTime();
              start();
            }
          });
          on("destroy", () => {
            detachMouseEvents();
            detachDocumentEvents();
            if (swiper.autoplay.running) {
              stop();
            }
          });
          on("beforeTransitionStart", (_s, speed, internal) => {
            if (swiper.destroyed || !swiper.autoplay.running) return;
            if (internal || !swiper.params.autoplay.disableOnInteraction) {
              pause(true, true);
            } else {
              stop();
            }
          });
          on("sliderFirstMove", () => {
            if (swiper.destroyed || !swiper.autoplay.running) return;
            if (swiper.params.autoplay.disableOnInteraction) {
              stop();
              return;
            }
            isTouched = true;
            pausedByTouch = false;
            pausedByInteraction = false;
            touchStartTimeout = setTimeout(() => {
              pausedByInteraction = true;
              pausedByTouch = true;
              pause(true);
            }, 200);
          });
          on("touchEnd", () => {
            if (swiper.destroyed || !swiper.autoplay.running || !isTouched)
              return;
            clearTimeout(touchStartTimeout);
            clearTimeout(timeout);
            if (swiper.params.autoplay.disableOnInteraction) {
              pausedByTouch = false;
              isTouched = false;
              return;
            }
            if (pausedByTouch && swiper.params.cssMode) resume();
            pausedByTouch = false;
            isTouched = false;
          });
          on("slideChange", () => {
            if (swiper.destroyed || !swiper.autoplay.running) return;
            slideChanged = true;
          });
          Object.assign(swiper.autoplay, {
            start,
            stop,
            pause,
            resume,
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/controller.mjs":
      /*!****************************************************!*\
  !*** ./node_modules/swiper/modules/controller.mjs ***!
  \****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Controller,
          /* harmony export */
        });
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        /* eslint no-bitwise: ["error", { "allow": [">>"] }] */
        function Controller(_ref) {
          let { swiper, extendParams, on } = _ref;
          extendParams({
            controller: {
              control: undefined,
              inverse: false,
              by: "slide", // or 'container'
            },
          });

          swiper.controller = {
            control: undefined,
          };
          function LinearSpline(x, y) {
            const binarySearch = (function search() {
              let maxIndex;
              let minIndex;
              let guess;
              return (array, val) => {
                minIndex = -1;
                maxIndex = array.length;
                while (maxIndex - minIndex > 1) {
                  guess = (maxIndex + minIndex) >> 1;
                  if (array[guess] <= val) {
                    minIndex = guess;
                  } else {
                    maxIndex = guess;
                  }
                }
                return maxIndex;
              };
            })();
            this.x = x;
            this.y = y;
            this.lastIndex = x.length - 1;
            // Given an x value (x2), return the expected y2 value:
            // (x1,y1) is the known point before given value,
            // (x3,y3) is the known point after given value.
            let i1;
            let i3;
            this.interpolate = function interpolate(x2) {
              if (!x2) return 0;

              // Get the indexes of x1 and x3 (the array indexes before and after given x2):
              i3 = binarySearch(this.x, x2);
              i1 = i3 - 1;

              // We have our indexes i1 & i3, so we can calculate already:
              // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
              return (
                ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) /
                  (this.x[i3] - this.x[i1]) +
                this.y[i1]
              );
            };
            return this;
          }
          function getInterpolateFunction(c) {
            swiper.controller.spline = swiper.params.loop
              ? new LinearSpline(swiper.slidesGrid, c.slidesGrid)
              : new LinearSpline(swiper.snapGrid, c.snapGrid);
          }
          function setTranslate(_t, byController) {
            const controlled = swiper.controller.control;
            let multiplier;
            let controlledTranslate;
            const Swiper = swiper.constructor;
            function setControlledTranslate(c) {
              if (c.destroyed) return;

              // this will create an Interpolate function based on the snapGrids
              // x is the Grid of the scrolled scroller and y will be the controlled scroller
              // it makes sense to create this only once and recall it for the interpolation
              // the function does a lot of value caching for performance
              const translate = swiper.rtlTranslate
                ? -swiper.translate
                : swiper.translate;
              if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(
                  -translate
                );
              }
              if (
                !controlledTranslate ||
                swiper.params.controller.by === "container"
              ) {
                multiplier =
                  (c.maxTranslate() - c.minTranslate()) /
                  (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) {
                  multiplier = 1;
                }
                controlledTranslate =
                  (translate - swiper.minTranslate()) * multiplier +
                  c.minTranslate();
              }
              if (swiper.params.controller.inverse) {
                controlledTranslate = c.maxTranslate() - controlledTranslate;
              }
              c.updateProgress(controlledTranslate);
              c.setTranslate(controlledTranslate, swiper);
              c.updateActiveIndex();
              c.updateSlidesClasses();
            }
            if (Array.isArray(controlled)) {
              for (let i = 0; i < controlled.length; i += 1) {
                if (
                  controlled[i] !== byController &&
                  controlled[i] instanceof Swiper
                ) {
                  setControlledTranslate(controlled[i]);
                }
              }
            } else if (
              controlled instanceof Swiper &&
              byController !== controlled
            ) {
              setControlledTranslate(controlled);
            }
          }
          function setTransition(duration, byController) {
            const Swiper = swiper.constructor;
            const controlled = swiper.controller.control;
            let i;
            function setControlledTransition(c) {
              if (c.destroyed) return;
              c.setTransition(duration, swiper);
              if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) {
                  (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)(() => {
                    c.updateAutoHeight();
                  });
                }
                (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.i)(
                  c.wrapperEl,
                  () => {
                    if (!controlled) return;
                    c.transitionEnd();
                  }
                );
              }
            }
            if (Array.isArray(controlled)) {
              for (i = 0; i < controlled.length; i += 1) {
                if (
                  controlled[i] !== byController &&
                  controlled[i] instanceof Swiper
                ) {
                  setControlledTransition(controlled[i]);
                }
              }
            } else if (
              controlled instanceof Swiper &&
              byController !== controlled
            ) {
              setControlledTransition(controlled);
            }
          }
          function removeSpline() {
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
              swiper.controller.spline = undefined;
              delete swiper.controller.spline;
            }
          }
          on("beforeInit", () => {
            if (
              typeof window !== "undefined" &&
              // eslint-disable-line
              (typeof swiper.params.controller.control === "string" ||
                swiper.params.controller.control instanceof HTMLElement)
            ) {
              const controlElement = document.querySelector(
                swiper.params.controller.control
              );
              if (controlElement && controlElement.swiper) {
                swiper.controller.control = controlElement.swiper;
              } else if (controlElement) {
                const onControllerSwiper = (e) => {
                  swiper.controller.control = e.detail[0];
                  swiper.update();
                  controlElement.removeEventListener(
                    "init",
                    onControllerSwiper
                  );
                };
                controlElement.addEventListener("init", onControllerSwiper);
              }
              return;
            }
            swiper.controller.control = swiper.params.controller.control;
          });
          on("update", () => {
            removeSpline();
          });
          on("resize", () => {
            removeSpline();
          });
          on("observerUpdate", () => {
            removeSpline();
          });
          on("setTranslate", (_s, translate, byController) => {
            if (
              !swiper.controller.control ||
              swiper.controller.control.destroyed
            )
              return;
            swiper.controller.setTranslate(translate, byController);
          });
          on("setTransition", (_s, duration, byController) => {
            if (
              !swiper.controller.control ||
              swiper.controller.control.destroyed
            )
              return;
            swiper.controller.setTransition(duration, byController);
          });
          Object.assign(swiper.controller, {
            setTranslate,
            setTransition,
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/effect-cards.mjs":
      /*!******************************************************!*\
  !*** ./node_modules/swiper/modules/effect-cards.mjs ***!
  \******************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ EffectCards,
          /* harmony export */
        });
        /* harmony import */ var _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/create-shadow.mjs */ "./node_modules/swiper/shared/create-shadow.mjs"
          );
        /* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/effect-init.mjs */ "./node_modules/swiper/shared/effect-init.mjs"
          );
        /* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../shared/effect-target.mjs */ "./node_modules/swiper/shared/effect-target.mjs"
          );
        /* harmony import */ var _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../shared/effect-virtual-transition-end.mjs */ "./node_modules/swiper/shared/effect-virtual-transition-end.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function EffectCards(_ref) {
          let { swiper, extendParams, on } = _ref;
          extendParams({
            cardsEffect: {
              slideShadows: true,
              rotate: true,
              perSlideRotate: 2,
              perSlideOffset: 8,
            },
          });
          const setTranslate = () => {
            const { slides, activeIndex, rtlTranslate: rtl } = swiper;
            const params = swiper.params.cardsEffect;
            const { startTranslate, isTouched } = swiper.touchEventsData;
            const currentTranslate = rtl ? -swiper.translate : swiper.translate;
            for (let i = 0; i < slides.length; i += 1) {
              const slideEl = slides[i];
              const slideProgress = slideEl.progress;
              const progress = Math.min(Math.max(slideProgress, -4), 4);
              let offset = slideEl.swiperSlideOffset;
              if (swiper.params.centeredSlides && !swiper.params.cssMode) {
                swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
              }
              if (swiper.params.centeredSlides && swiper.params.cssMode) {
                offset -= slides[0].swiperSlideOffset;
              }
              let tX = swiper.params.cssMode
                ? -offset - swiper.translate
                : -offset;
              let tY = 0;
              const tZ = -100 * Math.abs(progress);
              let scale = 1;
              let rotate = -params.perSlideRotate * progress;
              let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
              const slideIndex =
                swiper.virtual && swiper.params.virtual.enabled
                  ? swiper.virtual.from + i
                  : i;
              const isSwipeToNext =
                (slideIndex === activeIndex ||
                  slideIndex === activeIndex - 1) &&
                progress > 0 &&
                progress < 1 &&
                (isTouched || swiper.params.cssMode) &&
                currentTranslate < startTranslate;
              const isSwipeToPrev =
                (slideIndex === activeIndex ||
                  slideIndex === activeIndex + 1) &&
                progress < 0 &&
                progress > -1 &&
                (isTouched || swiper.params.cssMode) &&
                currentTranslate > startTranslate;
              if (isSwipeToNext || isSwipeToPrev) {
                const subProgress =
                  (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
              }
              if (progress < 0) {
                // next
                tX = `calc(${tX}px ${rtl ? "-" : "+"} (${
                  tXAdd * Math.abs(progress)
                }%))`;
              } else if (progress > 0) {
                // prev
                tX = `calc(${tX}px ${rtl ? "-" : "+"} (-${
                  tXAdd * Math.abs(progress)
                }%))`;
              } else {
                tX = `${tX}px`;
              }
              if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
              }
              const scaleString =
                progress < 0
                  ? `${1 + (1 - scale) * progress}`
                  : `${1 - (1 - scale) * progress}`;

              /* eslint-disable */
              const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? (rtl ? -rotate : rotate) : 0}deg)
        scale(${scaleString})
      `;
              /* eslint-enable */

              if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) {
                  shadowEl = (0,
                  _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                    "cards",
                    slideEl
                  );
                }
                if (shadowEl)
                  shadowEl.style.opacity = Math.min(
                    Math.max((Math.abs(progress) - 0.5) / 0.5, 0),
                    1
                  );
              }
              slideEl.style.zIndex =
                -Math.abs(Math.round(slideProgress)) + slides.length;
              const targetEl = (0,
              _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(
                params,
                slideEl
              );
              targetEl.style.transform = transform;
            }
          };
          const setTransition = (duration) => {
            const transformElements = swiper.slides.map((slideEl) =>
              (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.k)(slideEl)
            );
            transformElements.forEach((el) => {
              el.style.transitionDuration = `${duration}ms`;
              el.querySelectorAll(".swiper-slide-shadow").forEach(
                (shadowEl) => {
                  shadowEl.style.transitionDuration = `${duration}ms`;
                }
              );
            });
            (0,
            _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__.e)(
              {
                swiper,
                duration,
                transformElements,
              }
            );
          };
          (0, _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__.e)({
            effect: "cards",
            swiper,
            on,
            setTranslate,
            setTransition,
            perspective: () => true,
            overwriteParams: () => ({
              watchSlidesProgress: true,
              virtualTranslate: !swiper.params.cssMode,
            }),
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/effect-coverflow.mjs":
      /*!**********************************************************!*\
  !*** ./node_modules/swiper/modules/effect-coverflow.mjs ***!
  \**********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ EffectCoverflow,
          /* harmony export */
        });
        /* harmony import */ var _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/create-shadow.mjs */ "./node_modules/swiper/shared/create-shadow.mjs"
          );
        /* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/effect-init.mjs */ "./node_modules/swiper/shared/effect-init.mjs"
          );
        /* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../shared/effect-target.mjs */ "./node_modules/swiper/shared/effect-target.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function EffectCoverflow(_ref) {
          let { swiper, extendParams, on } = _ref;
          extendParams({
            coverflowEffect: {
              rotate: 50,
              stretch: 0,
              depth: 100,
              scale: 1,
              modifier: 1,
              slideShadows: true,
            },
          });
          const setTranslate = () => {
            const {
              width: swiperWidth,
              height: swiperHeight,
              slides,
              slidesSizesGrid,
            } = swiper;
            const params = swiper.params.coverflowEffect;
            const isHorizontal = swiper.isHorizontal();
            const transform = swiper.translate;
            const center = isHorizontal
              ? -transform + swiperWidth / 2
              : -transform + swiperHeight / 2;
            const rotate = isHorizontal ? params.rotate : -params.rotate;
            const translate = params.depth;
            // Each slide offset from center
            for (let i = 0, length = slides.length; i < length; i += 1) {
              const slideEl = slides[i];
              const slideSize = slidesSizesGrid[i];
              const slideOffset = slideEl.swiperSlideOffset;
              const centerOffset =
                (center - slideOffset - slideSize / 2) / slideSize;
              const offsetMultiplier =
                typeof params.modifier === "function"
                  ? params.modifier(centerOffset)
                  : centerOffset * params.modifier;
              let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
              let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
              // var rotateZ = 0
              let translateZ = -translate * Math.abs(offsetMultiplier);
              let stretch = params.stretch;
              // Allow percentage to make a relative stretch for responsive sliders
              if (typeof stretch === "string" && stretch.indexOf("%") !== -1) {
                stretch = (parseFloat(params.stretch) / 100) * slideSize;
              }
              let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
              let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
              let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);

              // Fix for ultra small values
              if (Math.abs(translateX) < 0.001) translateX = 0;
              if (Math.abs(translateY) < 0.001) translateY = 0;
              if (Math.abs(translateZ) < 0.001) translateZ = 0;
              if (Math.abs(rotateY) < 0.001) rotateY = 0;
              if (Math.abs(rotateX) < 0.001) rotateX = 0;
              if (Math.abs(scale) < 0.001) scale = 0;
              const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
              const targetEl = (0,
              _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(
                params,
                slideEl
              );
              targetEl.style.transform = slideTransform;
              slideEl.style.zIndex =
                -Math.abs(Math.round(offsetMultiplier)) + 1;
              if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal
                  ? slideEl.querySelector(".swiper-slide-shadow-left")
                  : slideEl.querySelector(".swiper-slide-shadow-top");
                let shadowAfterEl = isHorizontal
                  ? slideEl.querySelector(".swiper-slide-shadow-right")
                  : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) {
                  shadowBeforeEl = (0,
                  _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                    "coverflow",
                    slideEl,
                    isHorizontal ? "left" : "top"
                  );
                }
                if (!shadowAfterEl) {
                  shadowAfterEl = (0,
                  _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                    "coverflow",
                    slideEl,
                    isHorizontal ? "right" : "bottom"
                  );
                }
                if (shadowBeforeEl)
                  shadowBeforeEl.style.opacity =
                    offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl)
                  shadowAfterEl.style.opacity =
                    -offsetMultiplier > 0 ? -offsetMultiplier : 0;
              }
            }
          };
          const setTransition = (duration) => {
            const transformElements = swiper.slides.map((slideEl) =>
              (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__.k)(slideEl)
            );
            transformElements.forEach((el) => {
              el.style.transitionDuration = `${duration}ms`;
              el.querySelectorAll(
                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
              ).forEach((shadowEl) => {
                shadowEl.style.transitionDuration = `${duration}ms`;
              });
            });
          };
          (0, _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__.e)({
            effect: "coverflow",
            swiper,
            on,
            setTranslate,
            setTransition,
            perspective: () => true,
            overwriteParams: () => ({
              watchSlidesProgress: true,
            }),
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/effect-creative.mjs":
      /*!*********************************************************!*\
  !*** ./node_modules/swiper/modules/effect-creative.mjs ***!
  \*********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ EffectCreative,
          /* harmony export */
        });
        /* harmony import */ var _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/create-shadow.mjs */ "./node_modules/swiper/shared/create-shadow.mjs"
          );
        /* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/effect-init.mjs */ "./node_modules/swiper/shared/effect-init.mjs"
          );
        /* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../shared/effect-target.mjs */ "./node_modules/swiper/shared/effect-target.mjs"
          );
        /* harmony import */ var _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../shared/effect-virtual-transition-end.mjs */ "./node_modules/swiper/shared/effect-virtual-transition-end.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function EffectCreative(_ref) {
          let { swiper, extendParams, on } = _ref;
          extendParams({
            creativeEffect: {
              limitProgress: 1,
              shadowPerProgress: false,
              progressMultiplier: 1,
              perspective: true,
              prev: {
                translate: [0, 0, 0],
                rotate: [0, 0, 0],
                opacity: 1,
                scale: 1,
              },
              next: {
                translate: [0, 0, 0],
                rotate: [0, 0, 0],
                opacity: 1,
                scale: 1,
              },
            },
          });
          const getTranslateValue = (value) => {
            if (typeof value === "string") return value;
            return `${value}px`;
          };
          const setTranslate = () => {
            const { slides, wrapperEl, slidesSizesGrid } = swiper;
            const params = swiper.params.creativeEffect;
            const { progressMultiplier: multiplier } = params;
            const isCenteredSlides = swiper.params.centeredSlides;
            if (isCenteredSlides) {
              const margin =
                slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
              wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
            }
            for (let i = 0; i < slides.length; i += 1) {
              const slideEl = slides[i];
              const slideProgress = slideEl.progress;
              const progress = Math.min(
                Math.max(slideEl.progress, -params.limitProgress),
                params.limitProgress
              );
              let originalProgress = progress;
              if (!isCenteredSlides) {
                originalProgress = Math.min(
                  Math.max(slideEl.originalProgress, -params.limitProgress),
                  params.limitProgress
                );
              }
              const offset = slideEl.swiperSlideOffset;
              const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0,
              ];
              const r = [0, 0, 0];
              let custom = false;
              if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
              }
              let data = {
                translate: [0, 0, 0],
                rotate: [0, 0, 0],
                scale: 1,
                opacity: 1,
              };
              if (progress < 0) {
                data = params.next;
                custom = true;
              } else if (progress > 0) {
                data = params.prev;
                custom = true;
              }
              // set translate
              t.forEach((value, index) => {
                t[index] = `calc(${value}px + (${getTranslateValue(
                  data.translate[index]
                )} * ${Math.abs(progress * multiplier)}))`;
              });
              // set rotates
              r.forEach((value, index) => {
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
              });
              slideEl.style.zIndex =
                -Math.abs(Math.round(slideProgress)) + slides.length;
              const translateString = t.join(", ");
              const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
              const scaleString =
                originalProgress < 0
                  ? `scale(${
                      1 + (1 - data.scale) * originalProgress * multiplier
                    })`
                  : `scale(${
                      1 - (1 - data.scale) * originalProgress * multiplier
                    })`;
              const opacityString =
                originalProgress < 0
                  ? 1 + (1 - data.opacity) * originalProgress * multiplier
                  : 1 - (1 - data.opacity) * originalProgress * multiplier;
              const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;

              // Set shadows
              if ((custom && data.shadow) || !custom) {
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) {
                  shadowEl = (0,
                  _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                    "creative",
                    slideEl
                  );
                }
                if (shadowEl) {
                  const shadowOpacity = params.shadowPerProgress
                    ? progress * (1 / params.limitProgress)
                    : progress;
                  shadowEl.style.opacity = Math.min(
                    Math.max(Math.abs(shadowOpacity), 0),
                    1
                  );
                }
              }
              const targetEl = (0,
              _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(
                params,
                slideEl
              );
              targetEl.style.transform = transform;
              targetEl.style.opacity = opacityString;
              if (data.origin) {
                targetEl.style.transformOrigin = data.origin;
              }
            }
          };
          const setTransition = (duration) => {
            const transformElements = swiper.slides.map((slideEl) =>
              (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.k)(slideEl)
            );
            transformElements.forEach((el) => {
              el.style.transitionDuration = `${duration}ms`;
              el.querySelectorAll(".swiper-slide-shadow").forEach(
                (shadowEl) => {
                  shadowEl.style.transitionDuration = `${duration}ms`;
                }
              );
            });
            (0,
            _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__.e)(
              {
                swiper,
                duration,
                transformElements,
                allSlides: true,
              }
            );
          };
          (0, _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__.e)({
            effect: "creative",
            swiper,
            on,
            setTranslate,
            setTransition,
            perspective: () => swiper.params.creativeEffect.perspective,
            overwriteParams: () => ({
              watchSlidesProgress: true,
              virtualTranslate: !swiper.params.cssMode,
            }),
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/effect-cube.mjs":
      /*!*****************************************************!*\
  !*** ./node_modules/swiper/modules/effect-cube.mjs ***!
  \*****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ EffectCube,
          /* harmony export */
        });
        /* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/effect-init.mjs */ "./node_modules/swiper/shared/effect-init.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function EffectCube(_ref) {
          let { swiper, extendParams, on } = _ref;
          extendParams({
            cubeEffect: {
              slideShadows: true,
              shadow: true,
              shadowOffset: 20,
              shadowScale: 0.94,
            },
          });
          const createSlideShadows = (slideEl, progress, isHorizontal) => {
            let shadowBefore = isHorizontal
              ? slideEl.querySelector(".swiper-slide-shadow-left")
              : slideEl.querySelector(".swiper-slide-shadow-top");
            let shadowAfter = isHorizontal
              ? slideEl.querySelector(".swiper-slide-shadow-right")
              : slideEl.querySelector(".swiper-slide-shadow-bottom");
            if (!shadowBefore) {
              shadowBefore = (0,
              _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
                "div",
                `swiper-slide-shadow-cube swiper-slide-shadow-${
                  isHorizontal ? "left" : "top"
                }`.split(" ")
              );
              slideEl.append(shadowBefore);
            }
            if (!shadowAfter) {
              shadowAfter = (0,
              _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
                "div",
                `swiper-slide-shadow-cube swiper-slide-shadow-${
                  isHorizontal ? "right" : "bottom"
                }`.split(" ")
              );
              slideEl.append(shadowAfter);
            }
            if (shadowBefore)
              shadowBefore.style.opacity = Math.max(-progress, 0);
            if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
          };
          const recreateShadows = () => {
            // create new ones
            const isHorizontal = swiper.isHorizontal();
            swiper.slides.forEach((slideEl) => {
              const progress = Math.max(Math.min(slideEl.progress, 1), -1);
              createSlideShadows(slideEl, progress, isHorizontal);
            });
          };
          const setTranslate = () => {
            const {
              el,
              wrapperEl,
              slides,
              width: swiperWidth,
              height: swiperHeight,
              rtlTranslate: rtl,
              size: swiperSize,
              browser,
            } = swiper;
            const params = swiper.params.cubeEffect;
            const isHorizontal = swiper.isHorizontal();
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            let wrapperRotate = 0;
            let cubeShadowEl;
            if (params.shadow) {
              if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector(
                  ".swiper-cube-shadow"
                );
                if (!cubeShadowEl) {
                  cubeShadowEl = (0,
                  _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
                    "div",
                    "swiper-cube-shadow"
                  );
                  swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
              } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                  cubeShadowEl = (0,
                  _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
                    "div",
                    "swiper-cube-shadow"
                  );
                  el.append(cubeShadowEl);
                }
              }
            }
            for (let i = 0; i < slides.length; i += 1) {
              const slideEl = slides[i];
              let slideIndex = i;
              if (isVirtual) {
                slideIndex = parseInt(
                  slideEl.getAttribute("data-swiper-slide-index"),
                  10
                );
              }
              let slideAngle = slideIndex * 90;
              let round = Math.floor(slideAngle / 360);
              if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
              }
              const progress = Math.max(Math.min(slideEl.progress, 1), -1);
              let tx = 0;
              let ty = 0;
              let tz = 0;
              if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
              } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
              } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
              } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
              }
              if (rtl) {
                tx = -tx;
              }
              if (!isHorizontal) {
                ty = tx;
                tx = 0;
              }
              const transform = `rotateX(${
                isHorizontal ? 0 : -slideAngle
              }deg) rotateY(${
                isHorizontal ? slideAngle : 0
              }deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
              if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
              }
              slideEl.style.transform = transform;
              if (params.slideShadows) {
                createSlideShadows(slideEl, progress, isHorizontal);
              }
            }
            wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
            wrapperEl.style["-webkit-transform-origin"] = `50% 50% -${
              swiperSize / 2
            }px`;
            if (params.shadow) {
              if (isHorizontal) {
                cubeShadowEl.style.transform = `translate3d(0px, ${
                  swiperWidth / 2 + params.shadowOffset
                }px, ${
                  -swiperWidth / 2
                }px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`;
              } else {
                const shadowAngle =
                  Math.abs(wrapperRotate) -
                  Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier =
                  1.5 -
                  (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2 +
                    Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${
                  swiperHeight / 2 + offset
                }px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`;
              }
            }
            const zFactor =
              (browser.isSafari || browser.isWebView) &&
              browser.needPerspectiveFix
                ? -swiperSize / 2
                : 0;
            wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${
              swiper.isHorizontal() ? 0 : wrapperRotate
            }deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`;
            wrapperEl.style.setProperty(
              "--swiper-cube-translate-z",
              `${zFactor}px`
            );
          };
          const setTransition = (duration) => {
            const { el, slides } = swiper;
            slides.forEach((slideEl) => {
              slideEl.style.transitionDuration = `${duration}ms`;
              slideEl
                .querySelectorAll(
                  ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                )
                .forEach((subEl) => {
                  subEl.style.transitionDuration = `${duration}ms`;
                });
            });
            if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
              const shadowEl = el.querySelector(".swiper-cube-shadow");
              if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
            }
          };
          (0, _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_0__.e)({
            effect: "cube",
            swiper,
            on,
            setTranslate,
            setTransition,
            recreateShadows,
            getEffectParams: () => swiper.params.cubeEffect,
            perspective: () => true,
            overwriteParams: () => ({
              slidesPerView: 1,
              slidesPerGroup: 1,
              watchSlidesProgress: true,
              resistanceRatio: 0,
              spaceBetween: 0,
              centeredSlides: false,
              virtualTranslate: true,
            }),
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/effect-fade.mjs":
      /*!*****************************************************!*\
  !*** ./node_modules/swiper/modules/effect-fade.mjs ***!
  \*****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ EffectFade,
          /* harmony export */
        });
        /* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/effect-init.mjs */ "./node_modules/swiper/shared/effect-init.mjs"
          );
        /* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/effect-target.mjs */ "./node_modules/swiper/shared/effect-target.mjs"
          );
        /* harmony import */ var _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../shared/effect-virtual-transition-end.mjs */ "./node_modules/swiper/shared/effect-virtual-transition-end.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function EffectFade(_ref) {
          let { swiper, extendParams, on } = _ref;
          extendParams({
            fadeEffect: {
              crossFade: false,
            },
          });
          const setTranslate = () => {
            const { slides } = swiper;
            const params = swiper.params.fadeEffect;
            for (let i = 0; i < slides.length; i += 1) {
              const slideEl = swiper.slides[i];
              const offset = slideEl.swiperSlideOffset;
              let tx = -offset;
              if (!swiper.params.virtualTranslate) tx -= swiper.translate;
              let ty = 0;
              if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
              }
              const slideOpacity = swiper.params.fadeEffect.crossFade
                ? Math.max(1 - Math.abs(slideEl.progress), 0)
                : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
              const targetEl = (0,
              _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
                params,
                slideEl
              );
              targetEl.style.opacity = slideOpacity;
              targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
            }
          };
          const setTransition = (duration) => {
            const transformElements = swiper.slides.map((slideEl) =>
              (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__.k)(slideEl)
            );
            transformElements.forEach((el) => {
              el.style.transitionDuration = `${duration}ms`;
            });
            (0,
            _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(
              {
                swiper,
                duration,
                transformElements,
                allSlides: true,
              }
            );
          };
          (0, _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_0__.e)({
            effect: "fade",
            swiper,
            on,
            setTranslate,
            setTransition,
            overwriteParams: () => ({
              slidesPerView: 1,
              slidesPerGroup: 1,
              watchSlidesProgress: true,
              spaceBetween: 0,
              virtualTranslate: !swiper.params.cssMode,
            }),
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/effect-flip.mjs":
      /*!*****************************************************!*\
  !*** ./node_modules/swiper/modules/effect-flip.mjs ***!
  \*****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ EffectFlip,
          /* harmony export */
        });
        /* harmony import */ var _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/create-shadow.mjs */ "./node_modules/swiper/shared/create-shadow.mjs"
          );
        /* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/effect-init.mjs */ "./node_modules/swiper/shared/effect-init.mjs"
          );
        /* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../shared/effect-target.mjs */ "./node_modules/swiper/shared/effect-target.mjs"
          );
        /* harmony import */ var _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../shared/effect-virtual-transition-end.mjs */ "./node_modules/swiper/shared/effect-virtual-transition-end.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function EffectFlip(_ref) {
          let { swiper, extendParams, on } = _ref;
          extendParams({
            flipEffect: {
              slideShadows: true,
              limitRotation: true,
            },
          });
          const createSlideShadows = (slideEl, progress) => {
            let shadowBefore = swiper.isHorizontal()
              ? slideEl.querySelector(".swiper-slide-shadow-left")
              : slideEl.querySelector(".swiper-slide-shadow-top");
            let shadowAfter = swiper.isHorizontal()
              ? slideEl.querySelector(".swiper-slide-shadow-right")
              : slideEl.querySelector(".swiper-slide-shadow-bottom");
            if (!shadowBefore) {
              shadowBefore = (0,
              _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                "flip",
                slideEl,
                swiper.isHorizontal() ? "left" : "top"
              );
            }
            if (!shadowAfter) {
              shadowAfter = (0,
              _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                "flip",
                slideEl,
                swiper.isHorizontal() ? "right" : "bottom"
              );
            }
            if (shadowBefore)
              shadowBefore.style.opacity = Math.max(-progress, 0);
            if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
          };
          const recreateShadows = () => {
            // Set shadows
            swiper.params.flipEffect;
            swiper.slides.forEach((slideEl) => {
              let progress = slideEl.progress;
              if (swiper.params.flipEffect.limitRotation) {
                progress = Math.max(Math.min(slideEl.progress, 1), -1);
              }
              createSlideShadows(slideEl, progress);
            });
          };
          const setTranslate = () => {
            const { slides, rtlTranslate: rtl } = swiper;
            const params = swiper.params.flipEffect;
            for (let i = 0; i < slides.length; i += 1) {
              const slideEl = slides[i];
              let progress = slideEl.progress;
              if (swiper.params.flipEffect.limitRotation) {
                progress = Math.max(Math.min(slideEl.progress, 1), -1);
              }
              const offset = slideEl.swiperSlideOffset;
              const rotate = -180 * progress;
              let rotateY = rotate;
              let rotateX = 0;
              let tx = swiper.params.cssMode
                ? -offset - swiper.translate
                : -offset;
              let ty = 0;
              if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
              } else if (rtl) {
                rotateY = -rotateY;
              }
              slideEl.style.zIndex =
                -Math.abs(Math.round(progress)) + slides.length;
              if (params.slideShadows) {
                createSlideShadows(slideEl, progress);
              }
              const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
              const targetEl = (0,
              _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(
                params,
                slideEl
              );
              targetEl.style.transform = transform;
            }
          };
          const setTransition = (duration) => {
            const transformElements = swiper.slides.map((slideEl) =>
              (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.k)(slideEl)
            );
            transformElements.forEach((el) => {
              el.style.transitionDuration = `${duration}ms`;
              el.querySelectorAll(
                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
              ).forEach((shadowEl) => {
                shadowEl.style.transitionDuration = `${duration}ms`;
              });
            });
            (0,
            _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__.e)(
              {
                swiper,
                duration,
                transformElements,
              }
            );
          };
          (0, _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__.e)({
            effect: "flip",
            swiper,
            on,
            setTranslate,
            setTransition,
            recreateShadows,
            getEffectParams: () => swiper.params.flipEffect,
            perspective: () => true,
            overwriteParams: () => ({
              slidesPerView: 1,
              slidesPerGroup: 1,
              watchSlidesProgress: true,
              spaceBetween: 0,
              virtualTranslate: !swiper.params.cssMode,
            }),
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/free-mode.mjs":
      /*!***************************************************!*\
  !*** ./node_modules/swiper/modules/free-mode.mjs ***!
  \***************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ freeMode,
          /* harmony export */
        });
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function freeMode(_ref) {
          let { swiper, extendParams, emit, once } = _ref;
          extendParams({
            freeMode: {
              enabled: false,
              momentum: true,
              momentumRatio: 1,
              momentumBounce: true,
              momentumBounceRatio: 1,
              momentumVelocityRatio: 1,
              sticky: false,
              minimumVelocity: 0.02,
            },
          });
          function onTouchStart() {
            if (swiper.params.cssMode) return;
            const translate = swiper.getTranslate();
            swiper.setTranslate(translate);
            swiper.setTransition(0);
            swiper.touchEventsData.velocities.length = 0;
            swiper.freeMode.onTouchEnd({
              currentPos: swiper.rtl ? swiper.translate : -swiper.translate,
            });
          }
          function onTouchMove() {
            if (swiper.params.cssMode) return;
            const { touchEventsData: data, touches } = swiper;
            // Velocity
            if (data.velocities.length === 0) {
              data.velocities.push({
                position: touches[swiper.isHorizontal() ? "startX" : "startY"],
                time: data.touchStartTime,
              });
            }
            data.velocities.push({
              position:
                touches[swiper.isHorizontal() ? "currentX" : "currentY"],
              time: (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.d)(),
            });
          }
          function onTouchEnd(_ref2) {
            let { currentPos } = _ref2;
            if (swiper.params.cssMode) return;
            const {
              params,
              wrapperEl,
              rtlTranslate: rtl,
              snapGrid,
              touchEventsData: data,
            } = swiper;
            // Time diff
            const touchEndTime = (0,
            _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.d)();
            const timeDiff = touchEndTime - data.touchStartTime;
            if (currentPos < -swiper.minTranslate()) {
              swiper.slideTo(swiper.activeIndex);
              return;
            }
            if (currentPos > -swiper.maxTranslate()) {
              if (swiper.slides.length < snapGrid.length) {
                swiper.slideTo(snapGrid.length - 1);
              } else {
                swiper.slideTo(swiper.slides.length - 1);
              }
              return;
            }
            if (params.freeMode.momentum) {
              if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance =
                  lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (
                  Math.abs(swiper.velocity) < params.freeMode.minimumVelocity
                ) {
                  swiper.velocity = 0;
                }
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (
                  time > 150 ||
                  (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.d)() -
                    lastMoveEvent.time >
                    300
                ) {
                  swiper.velocity = 0;
                }
              } else {
                swiper.velocity = 0;
              }
              swiper.velocity *= params.freeMode.momentumVelocityRatio;
              data.velocities.length = 0;
              let momentumDuration = 1000 * params.freeMode.momentumRatio;
              const momentumDistance = swiper.velocity * momentumDuration;
              let newPosition = swiper.translate + momentumDistance;
              if (rtl) newPosition = -newPosition;
              let doBounce = false;
              let afterBouncePosition;
              const bounceAmount =
                Math.abs(swiper.velocity) *
                20 *
                params.freeMode.momentumBounceRatio;
              let needsLoopFix;
              if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                  if (newPosition + swiper.maxTranslate() < -bounceAmount) {
                    newPosition = swiper.maxTranslate() - bounceAmount;
                  }
                  afterBouncePosition = swiper.maxTranslate();
                  doBounce = true;
                  data.allowMomentumBounce = true;
                } else {
                  newPosition = swiper.maxTranslate();
                }
                if (params.loop && params.centeredSlides) needsLoopFix = true;
              } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                  if (newPosition - swiper.minTranslate() > bounceAmount) {
                    newPosition = swiper.minTranslate() + bounceAmount;
                  }
                  afterBouncePosition = swiper.minTranslate();
                  doBounce = true;
                  data.allowMomentumBounce = true;
                } else {
                  newPosition = swiper.minTranslate();
                }
                if (params.loop && params.centeredSlides) needsLoopFix = true;
              } else if (params.freeMode.sticky) {
                let nextSlide;
                for (let j = 0; j < snapGrid.length; j += 1) {
                  if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                  }
                }
                if (
                  Math.abs(snapGrid[nextSlide] - newPosition) <
                    Math.abs(snapGrid[nextSlide - 1] - newPosition) ||
                  swiper.swipeDirection === "next"
                ) {
                  newPosition = snapGrid[nextSlide];
                } else {
                  newPosition = snapGrid[nextSlide - 1];
                }
                newPosition = -newPosition;
              }
              if (needsLoopFix) {
                once("transitionEnd", () => {
                  swiper.loopFix();
                });
              }
              // Fix duration
              if (swiper.velocity !== 0) {
                if (rtl) {
                  momentumDuration = Math.abs(
                    (-newPosition - swiper.translate) / swiper.velocity
                  );
                } else {
                  momentumDuration = Math.abs(
                    (newPosition - swiper.translate) / swiper.velocity
                  );
                }
                if (params.freeMode.sticky) {
                  // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                  // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                  // It's easy to see this when simulating touch with mouse events. To fix this,
                  // limit single-slide swipes to the default slide duration. This also has the
                  // nice side effect of matching slide speed if the user stopped moving before
                  // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                  // For faster swipes, also apply limits (albeit higher ones).
                  const moveDistance = Math.abs(
                    (rtl ? -newPosition : newPosition) - swiper.translate
                  );
                  const currentSlideSize =
                    swiper.slidesSizesGrid[swiper.activeIndex];
                  if (moveDistance < currentSlideSize) {
                    momentumDuration = params.speed;
                  } else if (moveDistance < 2 * currentSlideSize) {
                    momentumDuration = params.speed * 1.5;
                  } else {
                    momentumDuration = params.speed * 2.5;
                  }
                }
              } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
              }
              if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.i)(
                  wrapperEl,
                  () => {
                    if (
                      !swiper ||
                      swiper.destroyed ||
                      !data.allowMomentumBounce
                    )
                      return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(() => {
                      swiper.setTranslate(afterBouncePosition);
                      (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.i)(
                        wrapperEl,
                        () => {
                          if (!swiper || swiper.destroyed) return;
                          swiper.transitionEnd();
                        }
                      );
                    }, 0);
                  }
                );
              } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                  swiper.animating = true;
                  (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.i)(
                    wrapperEl,
                    () => {
                      if (!swiper || swiper.destroyed) return;
                      swiper.transitionEnd();
                    }
                  );
                }
              } else {
                swiper.updateProgress(newPosition);
              }
              swiper.updateActiveIndex();
              swiper.updateSlidesClasses();
            } else if (params.freeMode.sticky) {
              swiper.slideToClosest();
              return;
            } else if (params.freeMode) {
              emit("_freeModeNoMomentumRelease");
            }
            if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
              swiper.updateProgress();
              swiper.updateActiveIndex();
              swiper.updateSlidesClasses();
            }
          }
          Object.assign(swiper, {
            freeMode: {
              onTouchStart,
              onTouchMove,
              onTouchEnd,
            },
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/grid.mjs":
      /*!**********************************************!*\
  !*** ./node_modules/swiper/modules/grid.mjs ***!
  \**********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Grid,
          /* harmony export */
        });
        function Grid(_ref) {
          let { swiper, extendParams, on } = _ref;
          extendParams({
            grid: {
              rows: 1,
              fill: "column",
            },
          });
          let slidesNumberEvenToRows;
          let slidesPerRow;
          let numFullColumns;
          let wasMultiRow;
          const getSpaceBetween = () => {
            let spaceBetween = swiper.params.spaceBetween;
            if (
              typeof spaceBetween === "string" &&
              spaceBetween.indexOf("%") >= 0
            ) {
              spaceBetween =
                (parseFloat(spaceBetween.replace("%", "")) / 100) * swiper.size;
            } else if (typeof spaceBetween === "string") {
              spaceBetween = parseFloat(spaceBetween);
            }
            return spaceBetween;
          };
          const initSlides = (slidesLength) => {
            const { slidesPerView } = swiper.params;
            const { rows, fill } = swiper.params.grid;
            numFullColumns = Math.floor(slidesLength / rows);
            if (Math.floor(slidesLength / rows) === slidesLength / rows) {
              slidesNumberEvenToRows = slidesLength;
            } else {
              slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
            }
            if (slidesPerView !== "auto" && fill === "row") {
              slidesNumberEvenToRows = Math.max(
                slidesNumberEvenToRows,
                slidesPerView * rows
              );
            }
            slidesPerRow = slidesNumberEvenToRows / rows;
          };
          const updateSlide = (i, slide, slidesLength, getDirectionLabel) => {
            const { slidesPerGroup } = swiper.params;
            const spaceBetween = getSpaceBetween();
            const { rows, fill } = swiper.params.grid;
            // Set slides order
            let newSlideOrderIndex;
            let column;
            let row;
            if (fill === "row" && slidesPerGroup > 1) {
              const groupIndex = Math.floor(i / (slidesPerGroup * rows));
              const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
              const columnsInGroup =
                groupIndex === 0
                  ? slidesPerGroup
                  : Math.min(
                      Math.ceil(
                        (slidesLength - groupIndex * rows * slidesPerGroup) /
                          rows
                      ),
                      slidesPerGroup
                    );
              row = Math.floor(slideIndexInGroup / columnsInGroup);
              column =
                slideIndexInGroup -
                row * columnsInGroup +
                groupIndex * slidesPerGroup;
              newSlideOrderIndex =
                column + (row * slidesNumberEvenToRows) / rows;
              slide.style.order = newSlideOrderIndex;
            } else if (fill === "column") {
              column = Math.floor(i / rows);
              row = i - column * rows;
              if (
                column > numFullColumns ||
                (column === numFullColumns && row === rows - 1)
              ) {
                row += 1;
                if (row >= rows) {
                  row = 0;
                  column += 1;
                }
              }
            } else {
              row = Math.floor(i / slidesPerRow);
              column = i - row * slidesPerRow;
            }
            slide.row = row;
            slide.column = column;
            slide.style[getDirectionLabel("margin-top")] =
              row !== 0 ? spaceBetween && `${spaceBetween}px` : "";
          };
          const updateWrapperSize = (
            slideSize,
            snapGrid,
            getDirectionLabel
          ) => {
            const { centeredSlides, roundLengths } = swiper.params;
            const spaceBetween = getSpaceBetween();
            const { rows } = swiper.params.grid;
            swiper.virtualSize =
              (slideSize + spaceBetween) * slidesNumberEvenToRows;
            swiper.virtualSize =
              Math.ceil(swiper.virtualSize / rows) - spaceBetween;
            swiper.wrapperEl.style[getDirectionLabel("width")] = `${
              swiper.virtualSize + spaceBetween
            }px`;
            if (centeredSlides) {
              const newSlidesGrid = [];
              for (let i = 0; i < snapGrid.length; i += 1) {
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0])
                  newSlidesGrid.push(slidesGridItem);
              }
              snapGrid.splice(0, snapGrid.length);
              snapGrid.push(...newSlidesGrid);
            }
          };
          const onInit = () => {
            wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
          };
          const onUpdate = () => {
            const { params, el } = swiper;
            const isMultiRow = params.grid && params.grid.rows > 1;
            if (wasMultiRow && !isMultiRow) {
              el.classList.remove(
                `${params.containerModifierClass}grid`,
                `${params.containerModifierClass}grid-column`
              );
              numFullColumns = 1;
              swiper.emitContainerClasses();
            } else if (!wasMultiRow && isMultiRow) {
              el.classList.add(`${params.containerModifierClass}grid`);
              if (params.grid.fill === "column") {
                el.classList.add(`${params.containerModifierClass}grid-column`);
              }
              swiper.emitContainerClasses();
            }
            wasMultiRow = isMultiRow;
          };
          on("init", onInit);
          on("update", onUpdate);
          swiper.grid = {
            initSlides,
            updateSlide,
            updateWrapperSize,
          };
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/hash-navigation.mjs":
      /*!*********************************************************!*\
  !*** ./node_modules/swiper/modules/hash-navigation.mjs ***!
  \*********************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ HashNavigation,
          /* harmony export */
        });
        /* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function HashNavigation(_ref) {
          let { swiper, extendParams, emit, on } = _ref;
          let initialized = false;
          const document = (0,
          _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
          const window = (0,
          _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          extendParams({
            hashNavigation: {
              enabled: false,
              replaceState: false,
              watchState: false,
              getSlideIndex(_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                  const slideWithHash = swiper.slides.filter(
                    (slideEl) => slideEl.getAttribute("data-hash") === hash
                  )[0];
                  if (!slideWithHash) return 0;
                  const index = parseInt(
                    slideWithHash.getAttribute("data-swiper-slide-index"),
                    10
                  );
                  return index;
                }
                return swiper.getSlideIndex(
                  (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
                    swiper.slidesEl,
                    `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`
                  )[0]
                );
              },
            },
          });
          const onHashChange = () => {
            emit("hashChange");
            const newHash = document.location.hash.replace("#", "");
            const activeSlideEl =
              swiper.virtual && swiper.params.virtual.enabled
                ? swiper.slidesEl.querySelector(
                    `[data-swiper-slide-index="${swiper.activeIndex}"]`
                  )
                : swiper.slides[swiper.activeIndex];
            const activeSlideHash = activeSlideEl
              ? activeSlideEl.getAttribute("data-hash")
              : "";
            if (newHash !== activeSlideHash) {
              const newIndex = swiper.params.hashNavigation.getSlideIndex(
                swiper,
                newHash
              );
              if (typeof newIndex === "undefined" || Number.isNaN(newIndex))
                return;
              swiper.slideTo(newIndex);
            }
          };
          const setHash = () => {
            if (!initialized || !swiper.params.hashNavigation.enabled) return;
            const activeSlideEl =
              swiper.virtual && swiper.params.virtual.enabled
                ? swiper.slidesEl.querySelector(
                    `[data-swiper-slide-index="${swiper.activeIndex}"]`
                  )
                : swiper.slides[swiper.activeIndex];
            const activeSlideHash = activeSlideEl
              ? activeSlideEl.getAttribute("data-hash") ||
                activeSlideEl.getAttribute("data-history")
              : "";
            if (
              swiper.params.hashNavigation.replaceState &&
              window.history &&
              window.history.replaceState
            ) {
              window.history.replaceState(
                null,
                null,
                `#${activeSlideHash}` || ""
              );
              emit("hashSet");
            } else {
              document.location.hash = activeSlideHash || "";
              emit("hashSet");
            }
          };
          const init = () => {
            if (
              !swiper.params.hashNavigation.enabled ||
              (swiper.params.history && swiper.params.history.enabled)
            )
              return;
            initialized = true;
            const hash = document.location.hash.replace("#", "");
            if (hash) {
              const speed = 0;
              const index = swiper.params.hashNavigation.getSlideIndex(
                swiper,
                hash
              );
              swiper.slideTo(
                index || 0,
                speed,
                swiper.params.runCallbacksOnInit,
                true
              );
            }
            if (swiper.params.hashNavigation.watchState) {
              window.addEventListener("hashchange", onHashChange);
            }
          };
          const destroy = () => {
            if (swiper.params.hashNavigation.watchState) {
              window.removeEventListener("hashchange", onHashChange);
            }
          };
          on("init", () => {
            if (swiper.params.hashNavigation.enabled) {
              init();
            }
          });
          on("destroy", () => {
            if (swiper.params.hashNavigation.enabled) {
              destroy();
            }
          });
          on("transitionEnd _freeModeNoMomentumRelease", () => {
            if (initialized) {
              setHash();
            }
          });
          on("slideChange", () => {
            if (initialized && swiper.params.cssMode) {
              setHash();
            }
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/history.mjs":
      /*!*************************************************!*\
  !*** ./node_modules/swiper/modules/history.mjs ***!
  \*************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ History,
          /* harmony export */
        });
        /* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs"
          );

        function History(_ref) {
          let { swiper, extendParams, on } = _ref;
          extendParams({
            history: {
              enabled: false,
              root: "",
              replaceState: false,
              key: "slides",
              keepQuery: false,
            },
          });
          let initialized = false;
          let paths = {};
          const slugify = (text) => {
            return text
              .toString()
              .replace(/\s+/g, "-")
              .replace(/[^\w-]+/g, "")
              .replace(/--+/g, "-")
              .replace(/^-+/, "")
              .replace(/-+$/, "");
          };
          const getPathValues = (urlOverride) => {
            const window = (0,
            _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
            let location;
            if (urlOverride) {
              location = new URL(urlOverride);
            } else {
              location = window.location;
            }
            const pathArray = location.pathname
              .slice(1)
              .split("/")
              .filter((part) => part !== "");
            const total = pathArray.length;
            const key = pathArray[total - 2];
            const value = pathArray[total - 1];
            return {
              key,
              value,
            };
          };
          const setHistory = (key, index) => {
            const window = (0,
            _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
            if (!initialized || !swiper.params.history.enabled) return;
            let location;
            if (swiper.params.url) {
              location = new URL(swiper.params.url);
            } else {
              location = window.location;
            }
            const slide = swiper.slides[index];
            let value = slugify(slide.getAttribute("data-history"));
            if (swiper.params.history.root.length > 0) {
              let root = swiper.params.history.root;
              if (root[root.length - 1] === "/")
                root = root.slice(0, root.length - 1);
              value = `${root}/${key ? `${key}/` : ""}${value}`;
            } else if (!location.pathname.includes(key)) {
              value = `${key ? `${key}/` : ""}${value}`;
            }
            if (swiper.params.history.keepQuery) {
              value += location.search;
            }
            const currentState = window.history.state;
            if (currentState && currentState.value === value) {
              return;
            }
            if (swiper.params.history.replaceState) {
              window.history.replaceState(
                {
                  value,
                },
                null,
                value
              );
            } else {
              window.history.pushState(
                {
                  value,
                },
                null,
                value
              );
            }
          };
          const scrollToSlide = (speed, value, runCallbacks) => {
            if (value) {
              for (
                let i = 0, length = swiper.slides.length;
                i < length;
                i += 1
              ) {
                const slide = swiper.slides[i];
                const slideHistory = slugify(
                  slide.getAttribute("data-history")
                );
                if (slideHistory === value) {
                  const index = swiper.getSlideIndex(slide);
                  swiper.slideTo(index, speed, runCallbacks);
                }
              }
            } else {
              swiper.slideTo(0, speed, runCallbacks);
            }
          };
          const setHistoryPopState = () => {
            paths = getPathValues(swiper.params.url);
            scrollToSlide(swiper.params.speed, paths.value, false);
          };
          const init = () => {
            const window = (0,
            _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
            if (!swiper.params.history) return;
            if (!window.history || !window.history.pushState) {
              swiper.params.history.enabled = false;
              swiper.params.hashNavigation.enabled = true;
              return;
            }
            initialized = true;
            paths = getPathValues(swiper.params.url);
            if (!paths.key && !paths.value) {
              if (!swiper.params.history.replaceState) {
                window.addEventListener("popstate", setHistoryPopState);
              }
              return;
            }
            scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
            if (!swiper.params.history.replaceState) {
              window.addEventListener("popstate", setHistoryPopState);
            }
          };
          const destroy = () => {
            const window = (0,
            _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
            if (!swiper.params.history.replaceState) {
              window.removeEventListener("popstate", setHistoryPopState);
            }
          };
          on("init", () => {
            if (swiper.params.history.enabled) {
              init();
            }
          });
          on("destroy", () => {
            if (swiper.params.history.enabled) {
              destroy();
            }
          });
          on("transitionEnd _freeModeNoMomentumRelease", () => {
            if (initialized) {
              setHistory(swiper.params.history.key, swiper.activeIndex);
            }
          });
          on("slideChange", () => {
            if (initialized && swiper.params.cssMode) {
              setHistory(swiper.params.history.key, swiper.activeIndex);
            }
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/index.mjs":
      /*!***********************************************!*\
  !*** ./node_modules/swiper/modules/index.mjs ***!
  \***********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ A11y: () =>
            /* reexport safe */ _a11y_mjs__WEBPACK_IMPORTED_MODULE_9__[
              "default"
            ],
          /* harmony export */ Autoplay: () =>
            /* reexport safe */ _autoplay_mjs__WEBPACK_IMPORTED_MODULE_12__[
              "default"
            ],
          /* harmony export */ Controller: () =>
            /* reexport safe */ _controller_mjs__WEBPACK_IMPORTED_MODULE_8__[
              "default"
            ],
          /* harmony export */ EffectCards: () =>
            /* reexport safe */ _effect_cards_mjs__WEBPACK_IMPORTED_MODULE_22__[
              "default"
            ],
          /* harmony export */ EffectCoverflow: () =>
            /* reexport safe */ _effect_coverflow_mjs__WEBPACK_IMPORTED_MODULE_20__[
              "default"
            ],
          /* harmony export */ EffectCreative: () =>
            /* reexport safe */ _effect_creative_mjs__WEBPACK_IMPORTED_MODULE_21__[
              "default"
            ],
          /* harmony export */ EffectCube: () =>
            /* reexport safe */ _effect_cube_mjs__WEBPACK_IMPORTED_MODULE_18__[
              "default"
            ],
          /* harmony export */ EffectFade: () =>
            /* reexport safe */ _effect_fade_mjs__WEBPACK_IMPORTED_MODULE_17__[
              "default"
            ],
          /* harmony export */ EffectFlip: () =>
            /* reexport safe */ _effect_flip_mjs__WEBPACK_IMPORTED_MODULE_19__[
              "default"
            ],
          /* harmony export */ FreeMode: () =>
            /* reexport safe */ _free_mode_mjs__WEBPACK_IMPORTED_MODULE_14__[
              "default"
            ],
          /* harmony export */ Grid: () =>
            /* reexport safe */ _grid_mjs__WEBPACK_IMPORTED_MODULE_15__[
              "default"
            ],
          /* harmony export */ HashNavigation: () =>
            /* reexport safe */ _hash_navigation_mjs__WEBPACK_IMPORTED_MODULE_11__[
              "default"
            ],
          /* harmony export */ History: () =>
            /* reexport safe */ _history_mjs__WEBPACK_IMPORTED_MODULE_10__[
              "default"
            ],
          /* harmony export */ Keyboard: () =>
            /* reexport safe */ _keyboard_mjs__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ],
          /* harmony export */ Manipulation: () =>
            /* reexport safe */ _manipulation_mjs__WEBPACK_IMPORTED_MODULE_16__[
              "default"
            ],
          /* harmony export */ Mousewheel: () =>
            /* reexport safe */ _mousewheel_mjs__WEBPACK_IMPORTED_MODULE_2__[
              "default"
            ],
          /* harmony export */ Navigation: () =>
            /* reexport safe */ _navigation_mjs__WEBPACK_IMPORTED_MODULE_3__[
              "default"
            ],
          /* harmony export */ Pagination: () =>
            /* reexport safe */ _pagination_mjs__WEBPACK_IMPORTED_MODULE_4__[
              "default"
            ],
          /* harmony export */ Parallax: () =>
            /* reexport safe */ _parallax_mjs__WEBPACK_IMPORTED_MODULE_6__[
              "default"
            ],
          /* harmony export */ Scrollbar: () =>
            /* reexport safe */ _scrollbar_mjs__WEBPACK_IMPORTED_MODULE_5__[
              "default"
            ],
          /* harmony export */ Thumbs: () =>
            /* reexport safe */ _thumbs_mjs__WEBPACK_IMPORTED_MODULE_13__[
              "default"
            ],
          /* harmony export */ Virtual: () =>
            /* reexport safe */ _virtual_mjs__WEBPACK_IMPORTED_MODULE_0__[
              "default"
            ],
          /* harmony export */ Zoom: () =>
            /* reexport safe */ _zoom_mjs__WEBPACK_IMPORTED_MODULE_7__[
              "default"
            ],
          /* harmony export */
        });
        /* harmony import */ var _virtual_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./virtual.mjs */ "./node_modules/swiper/modules/virtual.mjs"
          );
        /* harmony import */ var _keyboard_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./keyboard.mjs */ "./node_modules/swiper/modules/keyboard.mjs"
          );
        /* harmony import */ var _mousewheel_mjs__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./mousewheel.mjs */ "./node_modules/swiper/modules/mousewheel.mjs"
          );
        /* harmony import */ var _navigation_mjs__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./navigation.mjs */ "./node_modules/swiper/modules/navigation.mjs"
          );
        /* harmony import */ var _pagination_mjs__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./pagination.mjs */ "./node_modules/swiper/modules/pagination.mjs"
          );
        /* harmony import */ var _scrollbar_mjs__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./scrollbar.mjs */ "./node_modules/swiper/modules/scrollbar.mjs"
          );
        /* harmony import */ var _parallax_mjs__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./parallax.mjs */ "./node_modules/swiper/modules/parallax.mjs"
          );
        /* harmony import */ var _zoom_mjs__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ./zoom.mjs */ "./node_modules/swiper/modules/zoom.mjs"
          );
        /* harmony import */ var _controller_mjs__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! ./controller.mjs */ "./node_modules/swiper/modules/controller.mjs"
          );
        /* harmony import */ var _a11y_mjs__WEBPACK_IMPORTED_MODULE_9__ =
          __webpack_require__(
            /*! ./a11y.mjs */ "./node_modules/swiper/modules/a11y.mjs"
          );
        /* harmony import */ var _history_mjs__WEBPACK_IMPORTED_MODULE_10__ =
          __webpack_require__(
            /*! ./history.mjs */ "./node_modules/swiper/modules/history.mjs"
          );
        /* harmony import */ var _hash_navigation_mjs__WEBPACK_IMPORTED_MODULE_11__ =
          __webpack_require__(
            /*! ./hash-navigation.mjs */ "./node_modules/swiper/modules/hash-navigation.mjs"
          );
        /* harmony import */ var _autoplay_mjs__WEBPACK_IMPORTED_MODULE_12__ =
          __webpack_require__(
            /*! ./autoplay.mjs */ "./node_modules/swiper/modules/autoplay.mjs"
          );
        /* harmony import */ var _thumbs_mjs__WEBPACK_IMPORTED_MODULE_13__ =
          __webpack_require__(
            /*! ./thumbs.mjs */ "./node_modules/swiper/modules/thumbs.mjs"
          );
        /* harmony import */ var _free_mode_mjs__WEBPACK_IMPORTED_MODULE_14__ =
          __webpack_require__(
            /*! ./free-mode.mjs */ "./node_modules/swiper/modules/free-mode.mjs"
          );
        /* harmony import */ var _grid_mjs__WEBPACK_IMPORTED_MODULE_15__ =
          __webpack_require__(
            /*! ./grid.mjs */ "./node_modules/swiper/modules/grid.mjs"
          );
        /* harmony import */ var _manipulation_mjs__WEBPACK_IMPORTED_MODULE_16__ =
          __webpack_require__(
            /*! ./manipulation.mjs */ "./node_modules/swiper/modules/manipulation.mjs"
          );
        /* harmony import */ var _effect_fade_mjs__WEBPACK_IMPORTED_MODULE_17__ =
          __webpack_require__(
            /*! ./effect-fade.mjs */ "./node_modules/swiper/modules/effect-fade.mjs"
          );
        /* harmony import */ var _effect_cube_mjs__WEBPACK_IMPORTED_MODULE_18__ =
          __webpack_require__(
            /*! ./effect-cube.mjs */ "./node_modules/swiper/modules/effect-cube.mjs"
          );
        /* harmony import */ var _effect_flip_mjs__WEBPACK_IMPORTED_MODULE_19__ =
          __webpack_require__(
            /*! ./effect-flip.mjs */ "./node_modules/swiper/modules/effect-flip.mjs"
          );
        /* harmony import */ var _effect_coverflow_mjs__WEBPACK_IMPORTED_MODULE_20__ =
          __webpack_require__(
            /*! ./effect-coverflow.mjs */ "./node_modules/swiper/modules/effect-coverflow.mjs"
          );
        /* harmony import */ var _effect_creative_mjs__WEBPACK_IMPORTED_MODULE_21__ =
          __webpack_require__(
            /*! ./effect-creative.mjs */ "./node_modules/swiper/modules/effect-creative.mjs"
          );
        /* harmony import */ var _effect_cards_mjs__WEBPACK_IMPORTED_MODULE_22__ =
          __webpack_require__(
            /*! ./effect-cards.mjs */ "./node_modules/swiper/modules/effect-cards.mjs"
          );

        /***/
      },

    /***/ "./node_modules/swiper/modules/keyboard.mjs":
      /*!**************************************************!*\
  !*** ./node_modules/swiper/modules/keyboard.mjs ***!
  \**************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Keyboard,
          /* harmony export */
        });
        /* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        /* eslint-disable consistent-return */
        function Keyboard(_ref) {
          let { swiper, extendParams, on, emit } = _ref;
          const document = (0,
          _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
          const window = (0,
          _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          swiper.keyboard = {
            enabled: false,
          };
          extendParams({
            keyboard: {
              enabled: false,
              onlyInViewport: true,
              pageUpDown: true,
            },
          });
          function handle(event) {
            if (!swiper.enabled) return;
            const { rtlTranslate: rtl } = swiper;
            let e = event;
            if (e.originalEvent) e = e.originalEvent; // jquery fix
            const kc = e.keyCode || e.charCode;
            const pageUpDown = swiper.params.keyboard.pageUpDown;
            const isPageUp = pageUpDown && kc === 33;
            const isPageDown = pageUpDown && kc === 34;
            const isArrowLeft = kc === 37;
            const isArrowRight = kc === 39;
            const isArrowUp = kc === 38;
            const isArrowDown = kc === 40;
            // Directions locks
            if (
              !swiper.allowSlideNext &&
              ((swiper.isHorizontal() && isArrowRight) ||
                (swiper.isVertical() && isArrowDown) ||
                isPageDown)
            ) {
              return false;
            }
            if (
              !swiper.allowSlidePrev &&
              ((swiper.isHorizontal() && isArrowLeft) ||
                (swiper.isVertical() && isArrowUp) ||
                isPageUp)
            ) {
              return false;
            }
            if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
              return undefined;
            }
            if (
              document.activeElement &&
              document.activeElement.nodeName &&
              (document.activeElement.nodeName.toLowerCase() === "input" ||
                document.activeElement.nodeName.toLowerCase() === "textarea")
            ) {
              return undefined;
            }
            if (
              swiper.params.keyboard.onlyInViewport &&
              (isPageUp ||
                isPageDown ||
                isArrowLeft ||
                isArrowRight ||
                isArrowUp ||
                isArrowDown)
            ) {
              let inView = false;
              // Check that swiper should be inside of visible area of window
              if (
                (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(
                  swiper.el,
                  `.${swiper.params.slideClass}, swiper-slide`
                ).length > 0 &&
                (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(
                  swiper.el,
                  `.${swiper.params.slideActiveClass}`
                ).length === 0
              ) {
                return undefined;
              }
              const el = swiper.el;
              const swiperWidth = el.clientWidth;
              const swiperHeight = el.clientHeight;
              const windowWidth = window.innerWidth;
              const windowHeight = window.innerHeight;
              const swiperOffset = (0,
              _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.b)(el);
              if (rtl) swiperOffset.left -= el.scrollLeft;
              const swiperCoord = [
                [swiperOffset.left, swiperOffset.top],
                [swiperOffset.left + swiperWidth, swiperOffset.top],
                [swiperOffset.left, swiperOffset.top + swiperHeight],
                [
                  swiperOffset.left + swiperWidth,
                  swiperOffset.top + swiperHeight,
                ],
              ];
              for (let i = 0; i < swiperCoord.length; i += 1) {
                const point = swiperCoord[i];
                if (
                  point[0] >= 0 &&
                  point[0] <= windowWidth &&
                  point[1] >= 0 &&
                  point[1] <= windowHeight
                ) {
                  if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                  inView = true;
                }
              }
              if (!inView) return undefined;
            }
            if (swiper.isHorizontal()) {
              if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
              }
              if (
                ((isPageDown || isArrowRight) && !rtl) ||
                ((isPageUp || isArrowLeft) && rtl)
              )
                swiper.slideNext();
              if (
                ((isPageUp || isArrowLeft) && !rtl) ||
                ((isPageDown || isArrowRight) && rtl)
              )
                swiper.slidePrev();
            } else {
              if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
              }
              if (isPageDown || isArrowDown) swiper.slideNext();
              if (isPageUp || isArrowUp) swiper.slidePrev();
            }
            emit("keyPress", kc);
            return undefined;
          }
          function enable() {
            if (swiper.keyboard.enabled) return;
            document.addEventListener("keydown", handle);
            swiper.keyboard.enabled = true;
          }
          function disable() {
            if (!swiper.keyboard.enabled) return;
            document.removeEventListener("keydown", handle);
            swiper.keyboard.enabled = false;
          }
          on("init", () => {
            if (swiper.params.keyboard.enabled) {
              enable();
            }
          });
          on("destroy", () => {
            if (swiper.keyboard.enabled) {
              disable();
            }
          });
          Object.assign(swiper.keyboard, {
            enable,
            disable,
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/manipulation.mjs":
      /*!******************************************************!*\
  !*** ./node_modules/swiper/modules/manipulation.mjs ***!
  \******************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Manipulation,
          /* harmony export */
        });
        function appendSlide(slides) {
          const swiper = this;
          const { params, slidesEl } = swiper;
          if (params.loop) {
            swiper.loopDestroy();
          }
          const appendElement = (slideEl) => {
            if (typeof slideEl === "string") {
              const tempDOM = document.createElement("div");
              tempDOM.innerHTML = slideEl;
              slidesEl.append(tempDOM.children[0]);
              tempDOM.innerHTML = "";
            } else {
              slidesEl.append(slideEl);
            }
          };
          if (typeof slides === "object" && "length" in slides) {
            for (let i = 0; i < slides.length; i += 1) {
              if (slides[i]) appendElement(slides[i]);
            }
          } else {
            appendElement(slides);
          }
          swiper.recalcSlides();
          if (params.loop) {
            swiper.loopCreate();
          }
          if (!params.observer || swiper.isElement) {
            swiper.update();
          }
        }

        function prependSlide(slides) {
          const swiper = this;
          const { params, activeIndex, slidesEl } = swiper;
          if (params.loop) {
            swiper.loopDestroy();
          }
          let newActiveIndex = activeIndex + 1;
          const prependElement = (slideEl) => {
            if (typeof slideEl === "string") {
              const tempDOM = document.createElement("div");
              tempDOM.innerHTML = slideEl;
              slidesEl.prepend(tempDOM.children[0]);
              tempDOM.innerHTML = "";
            } else {
              slidesEl.prepend(slideEl);
            }
          };
          if (typeof slides === "object" && "length" in slides) {
            for (let i = 0; i < slides.length; i += 1) {
              if (slides[i]) prependElement(slides[i]);
            }
            newActiveIndex = activeIndex + slides.length;
          } else {
            prependElement(slides);
          }
          swiper.recalcSlides();
          if (params.loop) {
            swiper.loopCreate();
          }
          if (!params.observer || swiper.isElement) {
            swiper.update();
          }
          swiper.slideTo(newActiveIndex, 0, false);
        }

        function addSlide(index, slides) {
          const swiper = this;
          const { params, activeIndex, slidesEl } = swiper;
          let activeIndexBuffer = activeIndex;
          if (params.loop) {
            activeIndexBuffer -= swiper.loopedSlides;
            swiper.loopDestroy();
            swiper.recalcSlides();
          }
          const baseLength = swiper.slides.length;
          if (index <= 0) {
            swiper.prependSlide(slides);
            return;
          }
          if (index >= baseLength) {
            swiper.appendSlide(slides);
            return;
          }
          let newActiveIndex =
            activeIndexBuffer > index
              ? activeIndexBuffer + 1
              : activeIndexBuffer;
          const slidesBuffer = [];
          for (let i = baseLength - 1; i >= index; i -= 1) {
            const currentSlide = swiper.slides[i];
            currentSlide.remove();
            slidesBuffer.unshift(currentSlide);
          }
          if (typeof slides === "object" && "length" in slides) {
            for (let i = 0; i < slides.length; i += 1) {
              if (slides[i]) slidesEl.append(slides[i]);
            }
            newActiveIndex =
              activeIndexBuffer > index
                ? activeIndexBuffer + slides.length
                : activeIndexBuffer;
          } else {
            slidesEl.append(slides);
          }
          for (let i = 0; i < slidesBuffer.length; i += 1) {
            slidesEl.append(slidesBuffer[i]);
          }
          swiper.recalcSlides();
          if (params.loop) {
            swiper.loopCreate();
          }
          if (!params.observer || swiper.isElement) {
            swiper.update();
          }
          if (params.loop) {
            swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
          } else {
            swiper.slideTo(newActiveIndex, 0, false);
          }
        }

        function removeSlide(slidesIndexes) {
          const swiper = this;
          const { params, activeIndex } = swiper;
          let activeIndexBuffer = activeIndex;
          if (params.loop) {
            activeIndexBuffer -= swiper.loopedSlides;
            swiper.loopDestroy();
          }
          let newActiveIndex = activeIndexBuffer;
          let indexToRemove;
          if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
            for (let i = 0; i < slidesIndexes.length; i += 1) {
              indexToRemove = slidesIndexes[i];
              if (swiper.slides[indexToRemove])
                swiper.slides[indexToRemove].remove();
              if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
            }
            newActiveIndex = Math.max(newActiveIndex, 0);
          } else {
            indexToRemove = slidesIndexes;
            if (swiper.slides[indexToRemove])
              swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
            newActiveIndex = Math.max(newActiveIndex, 0);
          }
          swiper.recalcSlides();
          if (params.loop) {
            swiper.loopCreate();
          }
          if (!params.observer || swiper.isElement) {
            swiper.update();
          }
          if (params.loop) {
            swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
          } else {
            swiper.slideTo(newActiveIndex, 0, false);
          }
        }

        function removeAllSlides() {
          const swiper = this;
          const slidesIndexes = [];
          for (let i = 0; i < swiper.slides.length; i += 1) {
            slidesIndexes.push(i);
          }
          swiper.removeSlide(slidesIndexes);
        }

        function Manipulation(_ref) {
          let { swiper } = _ref;
          Object.assign(swiper, {
            appendSlide: appendSlide.bind(swiper),
            prependSlide: prependSlide.bind(swiper),
            addSlide: addSlide.bind(swiper),
            removeSlide: removeSlide.bind(swiper),
            removeAllSlides: removeAllSlides.bind(swiper),
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/mousewheel.mjs":
      /*!****************************************************!*\
  !*** ./node_modules/swiper/modules/mousewheel.mjs ***!
  \****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Mousewheel,
          /* harmony export */
        });
        /* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        /* eslint-disable consistent-return */
        function Mousewheel(_ref) {
          let { swiper, extendParams, on, emit } = _ref;
          const window = (0,
          _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          extendParams({
            mousewheel: {
              enabled: false,
              releaseOnEdges: false,
              invert: false,
              forceToAxis: false,
              sensitivity: 1,
              eventsTarget: "container",
              thresholdDelta: null,
              thresholdTime: null,
              noMousewheelClass: "swiper-no-mousewheel",
            },
          });
          swiper.mousewheel = {
            enabled: false,
          };
          let timeout;
          let lastScrollTime = (0,
          _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)();
          let lastEventBeforeSnap;
          const recentWheelEvents = [];
          function normalize(e) {
            // Reasonable defaults
            const PIXEL_STEP = 10;
            const LINE_HEIGHT = 40;
            const PAGE_HEIGHT = 800;
            let sX = 0;
            let sY = 0; // spinX, spinY
            let pX = 0;
            let pY = 0; // pixelX, pixelY

            // Legacy
            if ("detail" in e) {
              sY = e.detail;
            }
            if ("wheelDelta" in e) {
              sY = -e.wheelDelta / 120;
            }
            if ("wheelDeltaY" in e) {
              sY = -e.wheelDeltaY / 120;
            }
            if ("wheelDeltaX" in e) {
              sX = -e.wheelDeltaX / 120;
            }

            // side scrolling on FF with DOMMouseScroll
            if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
              sX = sY;
              sY = 0;
            }
            pX = sX * PIXEL_STEP;
            pY = sY * PIXEL_STEP;
            if ("deltaY" in e) {
              pY = e.deltaY;
            }
            if ("deltaX" in e) {
              pX = e.deltaX;
            }
            if (e.shiftKey && !pX) {
              // if user scrolls with shift he wants horizontal scroll
              pX = pY;
              pY = 0;
            }
            if ((pX || pY) && e.deltaMode) {
              if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
              } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
              }
            }

            // Fall-back if spin cannot be determined
            if (pX && !sX) {
              sX = pX < 1 ? -1 : 1;
            }
            if (pY && !sY) {
              sY = pY < 1 ? -1 : 1;
            }
            return {
              spinX: sX,
              spinY: sY,
              pixelX: pX,
              pixelY: pY,
            };
          }
          function handleMouseEnter() {
            if (!swiper.enabled) return;
            swiper.mouseEntered = true;
          }
          function handleMouseLeave() {
            if (!swiper.enabled) return;
            swiper.mouseEntered = false;
          }
          function animateSlider(newEvent) {
            if (
              swiper.params.mousewheel.thresholdDelta &&
              newEvent.delta < swiper.params.mousewheel.thresholdDelta
            ) {
              // Prevent if delta of wheel scroll delta is below configured threshold
              return false;
            }
            if (
              swiper.params.mousewheel.thresholdTime &&
              (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)() -
                lastScrollTime <
                swiper.params.mousewheel.thresholdTime
            ) {
              // Prevent if time between scrolls is below configured threshold
              return false;
            }

            // If the movement is NOT big enough and
            // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
            //   Don't go any further (avoid insignificant scroll movement).
            if (
              newEvent.delta >= 6 &&
              (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)() -
                lastScrollTime <
                60
            ) {
              // Return false as a default
              return true;
            }
            // If user is scrolling towards the end:
            //   If the slider hasn't hit the latest slide or
            //   if the slider is a loop and
            //   if the slider isn't moving right now:
            //     Go to next slide and
            //     emit a scroll event.
            // Else (the user is scrolling towards the beginning) and
            // if the slider hasn't hit the first slide or
            // if the slider is a loop and
            // if the slider isn't moving right now:
            //   Go to prev slide and
            //   emit a scroll event.
            if (newEvent.direction < 0) {
              if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
              }
            } else if (
              (!swiper.isBeginning || swiper.params.loop) &&
              !swiper.animating
            ) {
              swiper.slidePrev();
              emit("scroll", newEvent.raw);
            }
            // If you got here is because an animation has been triggered so store the current time
            lastScrollTime = new window.Date().getTime();
            // Return false as a default
            return false;
          }
          function releaseScroll(newEvent) {
            const params = swiper.params.mousewheel;
            if (newEvent.direction < 0) {
              if (
                swiper.isEnd &&
                !swiper.params.loop &&
                params.releaseOnEdges
              ) {
                // Return true to animate scroll on edges
                return true;
              }
            } else if (
              swiper.isBeginning &&
              !swiper.params.loop &&
              params.releaseOnEdges
            ) {
              // Return true to animate scroll on edges
              return true;
            }
            return false;
          }
          function handle(event) {
            let e = event;
            let disableParentSwiper = true;
            if (!swiper.enabled) return;

            // Ignore event if the target or its parents have the swiper-no-mousewheel class
            if (
              event.target.closest(
                `.${swiper.params.mousewheel.noMousewheelClass}`
              )
            )
              return;
            const params = swiper.params.mousewheel;
            if (swiper.params.cssMode) {
              e.preventDefault();
            }
            let targetEl = swiper.el;
            if (swiper.params.mousewheel.eventsTarget !== "container") {
              targetEl = document.querySelector(
                swiper.params.mousewheel.eventsTarget
              );
            }
            const targetElContainsTarget =
              targetEl && targetEl.contains(e.target);
            if (
              !swiper.mouseEntered &&
              !targetElContainsTarget &&
              !params.releaseOnEdges
            )
              return true;
            if (e.originalEvent) e = e.originalEvent; // jquery fix
            let delta = 0;
            const rtlFactor = swiper.rtlTranslate ? -1 : 1;
            const data = normalize(e);
            if (params.forceToAxis) {
              if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY))
                  delta = -data.pixelX * rtlFactor;
                else return true;
              } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX))
                delta = -data.pixelY;
              else return true;
            } else {
              delta =
                Math.abs(data.pixelX) > Math.abs(data.pixelY)
                  ? -data.pixelX * rtlFactor
                  : -data.pixelY;
            }
            if (delta === 0) return true;
            if (params.invert) delta = -delta;

            // Get the scroll positions
            let positions = swiper.getTranslate() + delta * params.sensitivity;
            if (positions >= swiper.minTranslate())
              positions = swiper.minTranslate();
            if (positions <= swiper.maxTranslate())
              positions = swiper.maxTranslate();

            // When loop is true:
            //     the disableParentSwiper will be true.
            // When loop is false:
            //     if the scroll positions is not on edge,
            //     then the disableParentSwiper will be true.
            //     if the scroll on edge positions,
            //     then the disableParentSwiper will be false.
            disableParentSwiper = swiper.params.loop
              ? true
              : !(
                  positions === swiper.minTranslate() ||
                  positions === swiper.maxTranslate()
                );
            if (disableParentSwiper && swiper.params.nested)
              e.stopPropagation();
            if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
              // Register the new event in a variable which stores the relevant data
              const newEvent = {
                time: (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event,
              };

              // Keep the most recent events
              if (recentWheelEvents.length >= 2) {
                recentWheelEvents.shift(); // only store the last N events
              }

              const prevEvent = recentWheelEvents.length
                ? recentWheelEvents[recentWheelEvents.length - 1]
                : undefined;
              recentWheelEvents.push(newEvent);

              // If there is at least one previous recorded event:
              //   If direction has changed or
              //   if the scroll is quicker than the previous one:
              //     Animate the slider.
              // Else (this is the first time the wheel is moved):
              //     Animate the slider.
              if (prevEvent) {
                if (
                  newEvent.direction !== prevEvent.direction ||
                  newEvent.delta > prevEvent.delta ||
                  newEvent.time > prevEvent.time + 150
                ) {
                  animateSlider(newEvent);
                }
              } else {
                animateSlider(newEvent);
              }

              // If it's time to release the scroll:
              //   Return now so you don't hit the preventDefault.
              if (releaseScroll(newEvent)) {
                return true;
              }
            } else {
              // Freemode or scrollContainer:

              // If we recently snapped after a momentum scroll, then ignore wheel events
              // to give time for the deceleration to finish. Stop ignoring after 500 msecs
              // or if it's a new scroll (larger delta or inverse sign as last event before
              // an end-of-momentum snap).
              const newEvent = {
                time: (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
              };
              const ignoreWheelEvents =
                lastEventBeforeSnap &&
                newEvent.time < lastEventBeforeSnap.time + 500 &&
                newEvent.delta <= lastEventBeforeSnap.delta &&
                newEvent.direction === lastEventBeforeSnap.direction;
              if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position =
                  swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate())
                  position = swiper.minTranslate();
                if (position <= swiper.maxTranslate())
                  position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (
                  (!wasBeginning && swiper.isBeginning) ||
                  (!wasEnd && swiper.isEnd)
                ) {
                  swiper.updateSlidesClasses();
                }
                if (swiper.params.loop) {
                  swiper.loopFix({
                    direction: newEvent.direction < 0 ? "next" : "prev",
                    byMousewheel: true,
                  });
                }
                if (swiper.params.freeMode.sticky) {
                  // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                  // the end of a momentum scroll by storing recent (N=15?) wheel events.
                  // 1. do all N events have decreasing or same (absolute value) delta?
                  // 2. did all N events arrive in the last M (M=500?) msecs?
                  // 3. does the earliest event have an (absolute value) delta that's
                  //    at least P (P=1?) larger than the most recent event's delta?
                  // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                  // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                  // Snap immediately and ignore remaining wheel events in this scroll.
                  // See comment above for "remaining wheel events in this scroll" determination.
                  // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                  clearTimeout(timeout);
                  timeout = undefined;
                  if (recentWheelEvents.length >= 15) {
                    recentWheelEvents.shift(); // only store the last N events
                  }

                  const prevEvent = recentWheelEvents.length
                    ? recentWheelEvents[recentWheelEvents.length - 1]
                    : undefined;
                  const firstEvent = recentWheelEvents[0];
                  recentWheelEvents.push(newEvent);
                  if (
                    prevEvent &&
                    (newEvent.delta > prevEvent.delta ||
                      newEvent.direction !== prevEvent.direction)
                  ) {
                    // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                  } else if (
                    recentWheelEvents.length >= 15 &&
                    newEvent.time - firstEvent.time < 500 &&
                    firstEvent.delta - newEvent.delta >= 1 &&
                    newEvent.delta <= 6
                  ) {
                    // We're at the end of the deceleration of a momentum scroll, so there's no need
                    // to wait for more events. Snap ASAP on the next tick.
                    // Also, because there's some remaining momentum we'll bias the snap in the
                    // direction of the ongoing scroll because it's better UX for the scroll to snap
                    // in the same direction as the scroll instead of reversing to snap.  Therefore,
                    // if it's already scrolled more than 20% in the current direction, keep going.
                    const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                    lastEventBeforeSnap = newEvent;
                    recentWheelEvents.splice(0);
                    timeout = (0,
                    _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
                      swiper.slideToClosest(
                        swiper.params.speed,
                        true,
                        undefined,
                        snapToThreshold
                      );
                    }, 0); // no delay; move on next tick
                  }

                  if (!timeout) {
                    // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0,
                    _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
                      const snapToThreshold = 0.5;
                      lastEventBeforeSnap = newEvent;
                      recentWheelEvents.splice(0);
                      swiper.slideToClosest(
                        swiper.params.speed,
                        true,
                        undefined,
                        snapToThreshold
                      );
                    }, 500);
                  }
                }

                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);

                // Stop autoplay
                if (
                  swiper.params.autoplay &&
                  swiper.params.autoplayDisableOnInteraction
                )
                  swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (
                  params.releaseOnEdges &&
                  (position === swiper.minTranslate() ||
                    position === swiper.maxTranslate())
                ) {
                  return true;
                }
              }
            }
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
            return false;
          }
          function events(method) {
            let targetEl = swiper.el;
            if (swiper.params.mousewheel.eventsTarget !== "container") {
              targetEl = document.querySelector(
                swiper.params.mousewheel.eventsTarget
              );
            }
            targetEl[method]("mouseenter", handleMouseEnter);
            targetEl[method]("mouseleave", handleMouseLeave);
            targetEl[method]("wheel", handle);
          }
          function enable() {
            if (swiper.params.cssMode) {
              swiper.wrapperEl.removeEventListener("wheel", handle);
              return true;
            }
            if (swiper.mousewheel.enabled) return false;
            events("addEventListener");
            swiper.mousewheel.enabled = true;
            return true;
          }
          function disable() {
            if (swiper.params.cssMode) {
              swiper.wrapperEl.addEventListener(event, handle);
              return true;
            }
            if (!swiper.mousewheel.enabled) return false;
            events("removeEventListener");
            swiper.mousewheel.enabled = false;
            return true;
          }
          on("init", () => {
            if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
              disable();
            }
            if (swiper.params.mousewheel.enabled) enable();
          });
          on("destroy", () => {
            if (swiper.params.cssMode) {
              enable();
            }
            if (swiper.mousewheel.enabled) disable();
          });
          Object.assign(swiper.mousewheel, {
            enable,
            disable,
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/navigation.mjs":
      /*!****************************************************!*\
  !*** ./node_modules/swiper/modules/navigation.mjs ***!
  \****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Navigation,
          /* harmony export */
        });
        /* harmony import */ var _shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/create-element-if-not-defined.mjs */ "./node_modules/swiper/shared/create-element-if-not-defined.mjs"
          );

        function Navigation(_ref) {
          let { swiper, extendParams, on, emit } = _ref;
          extendParams({
            navigation: {
              nextEl: null,
              prevEl: null,
              hideOnClick: false,
              disabledClass: "swiper-button-disabled",
              hiddenClass: "swiper-button-hidden",
              lockClass: "swiper-button-lock",
              navigationDisabledClass: "swiper-navigation-disabled",
            },
          });
          swiper.navigation = {
            nextEl: null,
            prevEl: null,
          };
          const makeElementsArray = (el) =>
            (Array.isArray(el) ? el : [el]).filter((e) => !!e);
          function getEl(el) {
            let res;
            if (el && typeof el === "string" && swiper.isElement) {
              res = swiper.el.querySelector(el);
              if (res) return res;
            }
            if (el) {
              if (typeof el === "string")
                res = [...document.querySelectorAll(el)];
              if (
                swiper.params.uniqueNavElements &&
                typeof el === "string" &&
                res.length > 1 &&
                swiper.el.querySelectorAll(el).length === 1
              ) {
                res = swiper.el.querySelector(el);
              }
            }
            if (el && !res) return el;
            // if (Array.isArray(res) && res.length === 1) res = res[0];
            return res;
          }
          function toggleEl(el, disabled) {
            const params = swiper.params.navigation;
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              if (subEl) {
                subEl.classList[disabled ? "add" : "remove"](
                  ...params.disabledClass.split(" ")
                );
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) {
                  subEl.classList[swiper.isLocked ? "add" : "remove"](
                    params.lockClass
                  );
                }
              }
            });
          }
          function update() {
            // Update Navigation Buttons
            const { nextEl, prevEl } = swiper.navigation;
            if (swiper.params.loop) {
              toggleEl(prevEl, false);
              toggleEl(nextEl, false);
              return;
            }
            toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
            toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
          }
          function onPrevClick(e) {
            e.preventDefault();
            if (
              swiper.isBeginning &&
              !swiper.params.loop &&
              !swiper.params.rewind
            )
              return;
            swiper.slidePrev();
            emit("navigationPrev");
          }
          function onNextClick(e) {
            e.preventDefault();
            if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind)
              return;
            swiper.slideNext();
            emit("navigationNext");
          }
          function init() {
            const params = swiper.params.navigation;
            swiper.params.navigation = (0,
            _shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
              swiper,
              swiper.originalParams.navigation,
              swiper.params.navigation,
              {
                nextEl: "swiper-button-next",
                prevEl: "swiper-button-prev",
              }
            );
            if (!(params.nextEl || params.prevEl)) return;
            let nextEl = getEl(params.nextEl);
            let prevEl = getEl(params.prevEl);
            Object.assign(swiper.navigation, {
              nextEl,
              prevEl,
            });
            nextEl = makeElementsArray(nextEl);
            prevEl = makeElementsArray(prevEl);
            const initButton = (el, dir) => {
              if (el) {
                el.addEventListener(
                  "click",
                  dir === "next" ? onNextClick : onPrevClick
                );
              }
              if (!swiper.enabled && el) {
                el.classList.add(...params.lockClass.split(" "));
              }
            };
            nextEl.forEach((el) => initButton(el, "next"));
            prevEl.forEach((el) => initButton(el, "prev"));
          }
          function destroy() {
            let { nextEl, prevEl } = swiper.navigation;
            nextEl = makeElementsArray(nextEl);
            prevEl = makeElementsArray(prevEl);
            const destroyButton = (el, dir) => {
              el.removeEventListener(
                "click",
                dir === "next" ? onNextClick : onPrevClick
              );
              el.classList.remove(
                ...swiper.params.navigation.disabledClass.split(" ")
              );
            };
            nextEl.forEach((el) => destroyButton(el, "next"));
            prevEl.forEach((el) => destroyButton(el, "prev"));
          }
          on("init", () => {
            if (swiper.params.navigation.enabled === false) {
              // eslint-disable-next-line
              disable();
            } else {
              init();
              update();
            }
          });
          on("toEdge fromEdge lock unlock", () => {
            update();
          });
          on("destroy", () => {
            destroy();
          });
          on("enable disable", () => {
            let { nextEl, prevEl } = swiper.navigation;
            nextEl = makeElementsArray(nextEl);
            prevEl = makeElementsArray(prevEl);
            if (swiper.enabled) {
              update();
              return;
            }
            [...nextEl, ...prevEl]
              .filter((el) => !!el)
              .forEach((el) =>
                el.classList.add(swiper.params.navigation.lockClass)
              );
          });
          on("click", (_s, e) => {
            let { nextEl, prevEl } = swiper.navigation;
            nextEl = makeElementsArray(nextEl);
            prevEl = makeElementsArray(prevEl);
            const targetEl = e.target;
            if (
              swiper.params.navigation.hideOnClick &&
              !prevEl.includes(targetEl) &&
              !nextEl.includes(targetEl)
            ) {
              if (
                swiper.pagination &&
                swiper.params.pagination &&
                swiper.params.pagination.clickable &&
                (swiper.pagination.el === targetEl ||
                  swiper.pagination.el.contains(targetEl))
              )
                return;
              let isHidden;
              if (nextEl.length) {
                isHidden = nextEl[0].classList.contains(
                  swiper.params.navigation.hiddenClass
                );
              } else if (prevEl.length) {
                isHidden = prevEl[0].classList.contains(
                  swiper.params.navigation.hiddenClass
                );
              }
              if (isHidden === true) {
                emit("navigationShow");
              } else {
                emit("navigationHide");
              }
              [...nextEl, ...prevEl]
                .filter((el) => !!el)
                .forEach((el) =>
                  el.classList.toggle(swiper.params.navigation.hiddenClass)
                );
            }
          });
          const enable = () => {
            swiper.el.classList.remove(
              ...swiper.params.navigation.navigationDisabledClass.split(" ")
            );
            init();
            update();
          };
          const disable = () => {
            swiper.el.classList.add(
              ...swiper.params.navigation.navigationDisabledClass.split(" ")
            );
            destroy();
          };
          Object.assign(swiper.navigation, {
            enable,
            disable,
            update,
            init,
            destroy,
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/pagination.mjs":
      /*!****************************************************!*\
  !*** ./node_modules/swiper/modules/pagination.mjs ***!
  \****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Pagination,
          /* harmony export */
        });
        /* harmony import */ var _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/classes-to-selector.mjs */ "./node_modules/swiper/shared/classes-to-selector.mjs"
          );
        /* harmony import */ var _shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/create-element-if-not-defined.mjs */ "./node_modules/swiper/shared/create-element-if-not-defined.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function Pagination(_ref) {
          let { swiper, extendParams, on, emit } = _ref;
          const pfx = "swiper-pagination";
          extendParams({
            pagination: {
              el: null,
              bulletElement: "span",
              clickable: false,
              hideOnClick: false,
              renderBullet: null,
              renderProgressbar: null,
              renderFraction: null,
              renderCustom: null,
              progressbarOpposite: false,
              type: "bullets",
              // 'bullets' or 'progressbar' or 'fraction' or 'custom'
              dynamicBullets: false,
              dynamicMainBullets: 1,
              formatFractionCurrent: (number) => number,
              formatFractionTotal: (number) => number,
              bulletClass: `${pfx}-bullet`,
              bulletActiveClass: `${pfx}-bullet-active`,
              modifierClass: `${pfx}-`,
              currentClass: `${pfx}-current`,
              totalClass: `${pfx}-total`,
              hiddenClass: `${pfx}-hidden`,
              progressbarFillClass: `${pfx}-progressbar-fill`,
              progressbarOppositeClass: `${pfx}-progressbar-opposite`,
              clickableClass: `${pfx}-clickable`,
              lockClass: `${pfx}-lock`,
              horizontalClass: `${pfx}-horizontal`,
              verticalClass: `${pfx}-vertical`,
              paginationDisabledClass: `${pfx}-disabled`,
            },
          });
          swiper.pagination = {
            el: null,
            bullets: [],
          };
          let bulletSize;
          let dynamicBulletIndex = 0;
          const makeElementsArray = (el) =>
            (Array.isArray(el) ? el : [el]).filter((e) => !!e);
          function isPaginationDisabled() {
            return (
              !swiper.params.pagination.el ||
              !swiper.pagination.el ||
              (Array.isArray(swiper.pagination.el) &&
                swiper.pagination.el.length === 0)
            );
          }
          function setSideBullets(bulletEl, position) {
            const { bulletActiveClass } = swiper.params.pagination;
            if (!bulletEl) return;
            bulletEl =
              bulletEl[
                `${position === "prev" ? "previous" : "next"}ElementSibling`
              ];
            if (bulletEl) {
              bulletEl.classList.add(`${bulletActiveClass}-${position}`);
              bulletEl =
                bulletEl[
                  `${position === "prev" ? "previous" : "next"}ElementSibling`
                ];
              if (bulletEl) {
                bulletEl.classList.add(
                  `${bulletActiveClass}-${position}-${position}`
                );
              }
            }
          }
          function onBulletClick(e) {
            const bulletEl = e.target.closest(
              (0,
              _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                swiper.params.pagination.bulletClass
              )
            );
            if (!bulletEl) {
              return;
            }
            e.preventDefault();
            const index =
              (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.g)(bulletEl) *
              swiper.params.slidesPerGroup;
            if (swiper.params.loop) {
              if (swiper.realIndex === index) return;
              const realIndex = swiper.realIndex;
              const newSlideIndex = swiper.getSlideIndexByData(index);
              const currentSlideIndex = swiper.getSlideIndexByData(
                swiper.realIndex
              );
              const loopFix = (dir) => {
                const indexBeforeLoopFix = swiper.activeIndex;
                swiper.loopFix({
                  direction: dir,
                  activeSlideIndex: newSlideIndex,
                  slideTo: false,
                });
                const indexAfterFix = swiper.activeIndex;
                if (indexBeforeLoopFix === indexAfterFix) {
                  swiper.slideToLoop(realIndex, 0, false, true);
                }
              };
              if (newSlideIndex > swiper.slides.length - swiper.loopedSlides) {
                loopFix(newSlideIndex > currentSlideIndex ? "next" : "prev");
              } else if (swiper.params.centeredSlides) {
                const slidesPerView =
                  swiper.params.slidesPerView === "auto"
                    ? swiper.slidesPerViewDynamic()
                    : Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (newSlideIndex < Math.floor(slidesPerView / 2)) {
                  loopFix("prev");
                }
              }
              swiper.slideToLoop(index);
            } else {
              swiper.slideTo(index);
            }
          }
          function update() {
            // Render || Update Pagination bullets/items
            const rtl = swiper.rtl;
            const params = swiper.params.pagination;
            if (isPaginationDisabled()) return;
            let el = swiper.pagination.el;
            el = makeElementsArray(el);
            // Current/Total
            let current;
            let previousIndex;
            const slidesLength =
              swiper.virtual && swiper.params.virtual.enabled
                ? swiper.virtual.slides.length
                : swiper.slides.length;
            const total = swiper.params.loop
              ? Math.ceil(slidesLength / swiper.params.slidesPerGroup)
              : swiper.snapGrid.length;
            if (swiper.params.loop) {
              previousIndex = swiper.previousRealIndex || 0;
              current =
                swiper.params.slidesPerGroup > 1
                  ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup)
                  : swiper.realIndex;
            } else if (typeof swiper.snapIndex !== "undefined") {
              current = swiper.snapIndex;
              previousIndex = swiper.previousSnapIndex;
            } else {
              previousIndex = swiper.previousIndex || 0;
              current = swiper.activeIndex || 0;
            }
            // Types
            if (
              params.type === "bullets" &&
              swiper.pagination.bullets &&
              swiper.pagination.bullets.length > 0
            ) {
              const bullets = swiper.pagination.bullets;
              let firstIndex;
              let lastIndex;
              let midIndex;
              if (params.dynamicBullets) {
                bulletSize = (0,
                _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.f)(
                  bullets[0],
                  swiper.isHorizontal() ? "width" : "height",
                  true
                );
                el.forEach((subEl) => {
                  subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${
                    bulletSize * (params.dynamicMainBullets + 4)
                  }px`;
                });
                if (
                  params.dynamicMainBullets > 1 &&
                  previousIndex !== undefined
                ) {
                  dynamicBulletIndex += current - (previousIndex || 0);
                  if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
                    dynamicBulletIndex = params.dynamicMainBullets - 1;
                  } else if (dynamicBulletIndex < 0) {
                    dynamicBulletIndex = 0;
                  }
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex =
                  firstIndex +
                  (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
              }
              bullets.forEach((bulletEl) => {
                const classesToRemove = [
                  ...[
                    "",
                    "-next",
                    "-next-next",
                    "-prev",
                    "-prev-prev",
                    "-main",
                  ].map((suffix) => `${params.bulletActiveClass}${suffix}`),
                ]
                  .map((s) =>
                    typeof s === "string" && s.includes(" ") ? s.split(" ") : s
                  )
                  .flat();
                bulletEl.classList.remove(...classesToRemove);
              });
              if (el.length > 1) {
                bullets.forEach((bullet) => {
                  const bulletIndex = (0,
                  _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.g)(bullet);
                  if (bulletIndex === current) {
                    bullet.classList.add(
                      ...params.bulletActiveClass.split(" ")
                    );
                  } else if (swiper.isElement) {
                    bullet.setAttribute("part", "bullet");
                  }
                  if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                      bullet.classList.add(
                        ...`${params.bulletActiveClass}-main`.split(" ")
                      );
                    }
                    if (bulletIndex === firstIndex) {
                      setSideBullets(bullet, "prev");
                    }
                    if (bulletIndex === lastIndex) {
                      setSideBullets(bullet, "next");
                    }
                  }
                });
              } else {
                const bullet = bullets[current];
                if (bullet) {
                  bullet.classList.add(...params.bulletActiveClass.split(" "));
                }
                if (swiper.isElement) {
                  bullets.forEach((bulletEl, bulletIndex) => {
                    bulletEl.setAttribute(
                      "part",
                      bulletIndex === current ? "bullet-active" : "bullet"
                    );
                  });
                }
                if (params.dynamicBullets) {
                  const firstDisplayedBullet = bullets[firstIndex];
                  const lastDisplayedBullet = bullets[lastIndex];
                  for (let i = firstIndex; i <= lastIndex; i += 1) {
                    if (bullets[i]) {
                      bullets[i].classList.add(
                        ...`${params.bulletActiveClass}-main`.split(" ")
                      );
                    }
                  }
                  setSideBullets(firstDisplayedBullet, "prev");
                  setSideBullets(lastDisplayedBullet, "next");
                }
              }
              if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(
                  bullets.length,
                  params.dynamicMainBullets + 4
                );
                const bulletsOffset =
                  (bulletSize * dynamicBulletsLength - bulletSize) / 2 -
                  midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.forEach((bullet) => {
                  bullet.style[
                    swiper.isHorizontal() ? offsetProp : "top"
                  ] = `${bulletsOffset}px`;
                });
              }
            }
            el.forEach((subEl, subElIndex) => {
              if (params.type === "fraction") {
                subEl
                  .querySelectorAll(
                    (0,
                    _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                      params.currentClass
                    )
                  )
                  .forEach((fractionEl) => {
                    fractionEl.textContent = params.formatFractionCurrent(
                      current + 1
                    );
                  });
                subEl
                  .querySelectorAll(
                    (0,
                    _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                      params.totalClass
                    )
                  )
                  .forEach((totalEl) => {
                    totalEl.textContent = params.formatFractionTotal(total);
                  });
              }
              if (params.type === "progressbar") {
                let progressbarDirection;
                if (params.progressbarOpposite) {
                  progressbarDirection = swiper.isHorizontal()
                    ? "vertical"
                    : "horizontal";
                } else {
                  progressbarDirection = swiper.isHorizontal()
                    ? "horizontal"
                    : "vertical";
                }
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === "horizontal") {
                  scaleX = scale;
                } else {
                  scaleY = scale;
                }
                subEl
                  .querySelectorAll(
                    (0,
                    _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                      params.progressbarFillClass
                    )
                  )
                  .forEach((progressEl) => {
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                  });
              }
              if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(
                  swiper,
                  current + 1,
                  total
                );
                if (subElIndex === 0) emit("paginationRender", subEl);
              } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
              }
              if (swiper.params.watchOverflow && swiper.enabled) {
                subEl.classList[swiper.isLocked ? "add" : "remove"](
                  params.lockClass
                );
              }
            });
          }
          function render() {
            // Render Container
            const params = swiper.params.pagination;
            if (isPaginationDisabled()) return;
            const slidesLength =
              swiper.virtual && swiper.params.virtual.enabled
                ? swiper.virtual.slides.length
                : swiper.slides.length;
            let el = swiper.pagination.el;
            el = makeElementsArray(el);
            let paginationHTML = "";
            if (params.type === "bullets") {
              let numberOfBullets = swiper.params.loop
                ? Math.ceil(slidesLength / swiper.params.slidesPerGroup)
                : swiper.snapGrid.length;
              if (
                swiper.params.freeMode &&
                swiper.params.freeMode.enabled &&
                numberOfBullets > slidesLength
              ) {
                numberOfBullets = slidesLength;
              }
              for (let i = 0; i < numberOfBullets; i += 1) {
                if (params.renderBullet) {
                  paginationHTML += params.renderBullet.call(
                    swiper,
                    i,
                    params.bulletClass
                  );
                } else {
                  // prettier-ignore
                  paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
                }
              }
            }
            if (params.type === "fraction") {
              if (params.renderFraction) {
                paginationHTML = params.renderFraction.call(
                  swiper,
                  params.currentClass,
                  params.totalClass
                );
              } else {
                paginationHTML =
                  `<span class="${params.currentClass}"></span>` +
                  " / " +
                  `<span class="${params.totalClass}"></span>`;
              }
            }
            if (params.type === "progressbar") {
              if (params.renderProgressbar) {
                paginationHTML = params.renderProgressbar.call(
                  swiper,
                  params.progressbarFillClass
                );
              } else {
                paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
              }
            }
            swiper.pagination.bullets = [];
            el.forEach((subEl) => {
              if (params.type !== "custom") {
                subEl.innerHTML = paginationHTML || "";
              }
              if (params.type === "bullets") {
                swiper.pagination.bullets.push(
                  ...subEl.querySelectorAll(
                    (0,
                    _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                      params.bulletClass
                    )
                  )
                );
              }
            });
            if (params.type !== "custom") {
              emit("paginationRender", el[0]);
            }
          }
          function init() {
            swiper.params.pagination = (0,
            _shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
              swiper,
              swiper.originalParams.pagination,
              swiper.params.pagination,
              {
                el: "swiper-pagination",
              }
            );
            const params = swiper.params.pagination;
            if (!params.el) return;
            let el;
            if (typeof params.el === "string" && swiper.isElement) {
              el = swiper.el.querySelector(params.el);
            }
            if (!el && typeof params.el === "string") {
              el = [...document.querySelectorAll(params.el)];
            }
            if (!el) {
              el = params.el;
            }
            if (!el || el.length === 0) return;
            if (
              swiper.params.uniqueNavElements &&
              typeof params.el === "string" &&
              Array.isArray(el) &&
              el.length > 1
            ) {
              el = [...swiper.el.querySelectorAll(params.el)];
              // check if it belongs to another nested Swiper
              if (el.length > 1) {
                el = el.filter((subEl) => {
                  if (
                    (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.a)(
                      subEl,
                      ".swiper"
                    )[0] !== swiper.el
                  )
                    return false;
                  return true;
                })[0];
              }
            }
            if (Array.isArray(el) && el.length === 1) el = el[0];
            Object.assign(swiper.pagination, {
              el,
            });
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              if (params.type === "bullets" && params.clickable) {
                subEl.classList.add(
                  ...(params.clickableClass || "").split(" ")
                );
              }
              subEl.classList.add(params.modifierClass + params.type);
              subEl.classList.add(
                swiper.isHorizontal()
                  ? params.horizontalClass
                  : params.verticalClass
              );
              if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add(
                  `${params.modifierClass}${params.type}-dynamic`
                );
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) {
                  params.dynamicMainBullets = 1;
                }
              }
              if (params.type === "progressbar" && params.progressbarOpposite) {
                subEl.classList.add(params.progressbarOppositeClass);
              }
              if (params.clickable) {
                subEl.addEventListener("click", onBulletClick);
              }
              if (!swiper.enabled) {
                subEl.classList.add(params.lockClass);
              }
            });
          }
          function destroy() {
            const params = swiper.params.pagination;
            if (isPaginationDisabled()) return;
            let el = swiper.pagination.el;
            if (el) {
              el = makeElementsArray(el);
              el.forEach((subEl) => {
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(
                  swiper.isHorizontal()
                    ? params.horizontalClass
                    : params.verticalClass
                );
                if (params.clickable) {
                  subEl.classList.remove(
                    ...(params.clickableClass || "").split(" ")
                  );
                  subEl.removeEventListener("click", onBulletClick);
                }
              });
            }
            if (swiper.pagination.bullets)
              swiper.pagination.bullets.forEach((subEl) =>
                subEl.classList.remove(...params.bulletActiveClass.split(" "))
              );
          }
          on("changeDirection", () => {
            if (!swiper.pagination || !swiper.pagination.el) return;
            const params = swiper.params.pagination;
            let { el } = swiper.pagination;
            el = makeElementsArray(el);
            el.forEach((subEl) => {
              subEl.classList.remove(
                params.horizontalClass,
                params.verticalClass
              );
              subEl.classList.add(
                swiper.isHorizontal()
                  ? params.horizontalClass
                  : params.verticalClass
              );
            });
          });
          on("init", () => {
            if (swiper.params.pagination.enabled === false) {
              // eslint-disable-next-line
              disable();
            } else {
              init();
              render();
              update();
            }
          });
          on("activeIndexChange", () => {
            if (typeof swiper.snapIndex === "undefined") {
              update();
            }
          });
          on("snapIndexChange", () => {
            update();
          });
          on("snapGridLengthChange", () => {
            render();
            update();
          });
          on("destroy", () => {
            destroy();
          });
          on("enable disable", () => {
            let { el } = swiper.pagination;
            if (el) {
              el = makeElementsArray(el);
              el.forEach((subEl) =>
                subEl.classList[swiper.enabled ? "remove" : "add"](
                  swiper.params.pagination.lockClass
                )
              );
            }
          });
          on("lock unlock", () => {
            update();
          });
          on("click", (_s, e) => {
            const targetEl = e.target;
            const el = makeElementsArray(swiper.pagination.el);
            if (
              swiper.params.pagination.el &&
              swiper.params.pagination.hideOnClick &&
              el &&
              el.length > 0 &&
              !targetEl.classList.contains(swiper.params.pagination.bulletClass)
            ) {
              if (
                swiper.navigation &&
                ((swiper.navigation.nextEl &&
                  targetEl === swiper.navigation.nextEl) ||
                  (swiper.navigation.prevEl &&
                    targetEl === swiper.navigation.prevEl))
              )
                return;
              const isHidden = el[0].classList.contains(
                swiper.params.pagination.hiddenClass
              );
              if (isHidden === true) {
                emit("paginationShow");
              } else {
                emit("paginationHide");
              }
              el.forEach((subEl) =>
                subEl.classList.toggle(swiper.params.pagination.hiddenClass)
              );
            }
          });
          const enable = () => {
            swiper.el.classList.remove(
              swiper.params.pagination.paginationDisabledClass
            );
            let { el } = swiper.pagination;
            if (el) {
              el = makeElementsArray(el);
              el.forEach((subEl) =>
                subEl.classList.remove(
                  swiper.params.pagination.paginationDisabledClass
                )
              );
            }
            init();
            render();
            update();
          };
          const disable = () => {
            swiper.el.classList.add(
              swiper.params.pagination.paginationDisabledClass
            );
            let { el } = swiper.pagination;
            if (el) {
              el = makeElementsArray(el);
              el.forEach((subEl) =>
                subEl.classList.add(
                  swiper.params.pagination.paginationDisabledClass
                )
              );
            }
            destroy();
          };
          Object.assign(swiper.pagination, {
            enable,
            disable,
            render,
            update,
            init,
            destroy,
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/parallax.mjs":
      /*!**************************************************!*\
  !*** ./node_modules/swiper/modules/parallax.mjs ***!
  \**************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Parallax,
          /* harmony export */
        });
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function Parallax(_ref) {
          let { swiper, extendParams, on } = _ref;
          extendParams({
            parallax: {
              enabled: false,
            },
          });
          const elementsSelector =
            "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]";
          const setTransform = (el, progress) => {
            const { rtl } = swiper;
            const rtlFactor = rtl ? -1 : 1;
            const p = el.getAttribute("data-swiper-parallax") || "0";
            let x = el.getAttribute("data-swiper-parallax-x");
            let y = el.getAttribute("data-swiper-parallax-y");
            const scale = el.getAttribute("data-swiper-parallax-scale");
            const opacity = el.getAttribute("data-swiper-parallax-opacity");
            const rotate = el.getAttribute("data-swiper-parallax-rotate");
            if (x || y) {
              x = x || "0";
              y = y || "0";
            } else if (swiper.isHorizontal()) {
              x = p;
              y = "0";
            } else {
              y = p;
              x = "0";
            }
            if (x.indexOf("%") >= 0) {
              x = `${parseInt(x, 10) * progress * rtlFactor}%`;
            } else {
              x = `${x * progress * rtlFactor}px`;
            }
            if (y.indexOf("%") >= 0) {
              y = `${parseInt(y, 10) * progress}%`;
            } else {
              y = `${y * progress}px`;
            }
            if (typeof opacity !== "undefined" && opacity !== null) {
              const currentOpacity =
                opacity - (opacity - 1) * (1 - Math.abs(progress));
              el.style.opacity = currentOpacity;
            }
            let transform = `translate3d(${x}, ${y}, 0px)`;
            if (typeof scale !== "undefined" && scale !== null) {
              const currentScale =
                scale - (scale - 1) * (1 - Math.abs(progress));
              transform += ` scale(${currentScale})`;
            }
            if (rotate && typeof rotate !== "undefined" && rotate !== null) {
              const currentRotate = rotate * progress * -1;
              transform += ` rotate(${currentRotate}deg)`;
            }
            el.style.transform = transform;
          };
          const setTranslate = () => {
            const { el, slides, progress, snapGrid, isElement } = swiper;
            const elements = (0,
            _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(
              el,
              elementsSelector
            );
            if (swiper.isElement) {
              elements.push(
                ...(0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(
                  swiper.hostEl,
                  elementsSelector
                )
              );
            }
            elements.forEach((subEl) => {
              setTransform(subEl, progress);
            });
            slides.forEach((slideEl, slideIndex) => {
              let slideProgress = slideEl.progress;
              if (
                swiper.params.slidesPerGroup > 1 &&
                swiper.params.slidesPerView !== "auto"
              ) {
                slideProgress +=
                  Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
              }
              slideProgress = Math.min(Math.max(slideProgress, -1), 1);
              slideEl
                .querySelectorAll(
                  `${elementsSelector}, [data-swiper-parallax-rotate]`
                )
                .forEach((subEl) => {
                  setTransform(subEl, slideProgress);
                });
            });
          };
          const setTransition = function (duration) {
            if (duration === void 0) {
              duration = swiper.params.speed;
            }
            const { el, hostEl } = swiper;
            const elements = [...el.querySelectorAll(elementsSelector)];
            if (swiper.isElement) {
              elements.push(...hostEl.querySelectorAll(elementsSelector));
            }
            elements.forEach((parallaxEl) => {
              let parallaxDuration =
                parseInt(
                  parallaxEl.getAttribute("data-swiper-parallax-duration"),
                  10
                ) || duration;
              if (duration === 0) parallaxDuration = 0;
              parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
            });
          };
          on("beforeInit", () => {
            if (!swiper.params.parallax.enabled) return;
            swiper.params.watchSlidesProgress = true;
            swiper.originalParams.watchSlidesProgress = true;
          });
          on("init", () => {
            if (!swiper.params.parallax.enabled) return;
            setTranslate();
          });
          on("setTranslate", () => {
            if (!swiper.params.parallax.enabled) return;
            setTranslate();
          });
          on("setTransition", (_swiper, duration) => {
            if (!swiper.params.parallax.enabled) return;
            setTransition(duration);
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/scrollbar.mjs":
      /*!***************************************************!*\
  !*** ./node_modules/swiper/modules/scrollbar.mjs ***!
  \***************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Scrollbar,
          /* harmony export */
        });
        /* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );
        /* harmony import */ var _shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../shared/create-element-if-not-defined.mjs */ "./node_modules/swiper/shared/create-element-if-not-defined.mjs"
          );

        function Scrollbar(_ref) {
          let { swiper, extendParams, on, emit } = _ref;
          const document = (0,
          _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
          let isTouched = false;
          let timeout = null;
          let dragTimeout = null;
          let dragStartPos;
          let dragSize;
          let trackSize;
          let divider;
          extendParams({
            scrollbar: {
              el: null,
              dragSize: "auto",
              hide: false,
              draggable: false,
              snapOnRelease: true,
              lockClass: "swiper-scrollbar-lock",
              dragClass: "swiper-scrollbar-drag",
              scrollbarDisabledClass: "swiper-scrollbar-disabled",
              horizontalClass: `swiper-scrollbar-horizontal`,
              verticalClass: `swiper-scrollbar-vertical`,
            },
          });
          swiper.scrollbar = {
            el: null,
            dragEl: null,
          };
          function setTranslate() {
            if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
            const { scrollbar, rtlTranslate: rtl } = swiper;
            const { dragEl, el } = scrollbar;
            const params = swiper.params.scrollbar;
            const progress = swiper.params.loop
              ? swiper.progressLoop
              : swiper.progress;
            let newSize = dragSize;
            let newPos = (trackSize - dragSize) * progress;
            if (rtl) {
              newPos = -newPos;
              if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
              } else if (-newPos + dragSize > trackSize) {
                newSize = trackSize + newPos;
              }
            } else if (newPos < 0) {
              newSize = dragSize + newPos;
              newPos = 0;
            } else if (newPos + dragSize > trackSize) {
              newSize = trackSize - newPos;
            }
            if (swiper.isHorizontal()) {
              dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
              dragEl.style.width = `${newSize}px`;
            } else {
              dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
              dragEl.style.height = `${newSize}px`;
            }
            if (params.hide) {
              clearTimeout(timeout);
              el.style.opacity = 1;
              timeout = setTimeout(() => {
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
              }, 1000);
            }
          }
          function setTransition(duration) {
            if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
            swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
          }
          function updateSize() {
            if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
            const { scrollbar } = swiper;
            const { dragEl, el } = scrollbar;
            dragEl.style.width = "";
            dragEl.style.height = "";
            trackSize = swiper.isHorizontal()
              ? el.offsetWidth
              : el.offsetHeight;
            divider =
              swiper.size /
              (swiper.virtualSize +
                swiper.params.slidesOffsetBefore -
                (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
            if (swiper.params.scrollbar.dragSize === "auto") {
              dragSize = trackSize * divider;
            } else {
              dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
            }
            if (swiper.isHorizontal()) {
              dragEl.style.width = `${dragSize}px`;
            } else {
              dragEl.style.height = `${dragSize}px`;
            }
            if (divider >= 1) {
              el.style.display = "none";
            } else {
              el.style.display = "";
            }
            if (swiper.params.scrollbar.hide) {
              el.style.opacity = 0;
            }
            if (swiper.params.watchOverflow && swiper.enabled) {
              scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](
                swiper.params.scrollbar.lockClass
              );
            }
          }
          function getPointerPosition(e) {
            return swiper.isHorizontal() ? e.clientX : e.clientY;
          }
          function setDragPosition(e) {
            const { scrollbar, rtlTranslate: rtl } = swiper;
            const { el } = scrollbar;
            let positionRatio;
            positionRatio =
              (getPointerPosition(e) -
                (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.b)(el)[
                  swiper.isHorizontal() ? "left" : "top"
                ] -
                (dragStartPos !== null ? dragStartPos : dragSize / 2)) /
              (trackSize - dragSize);
            positionRatio = Math.max(Math.min(positionRatio, 1), 0);
            if (rtl) {
              positionRatio = 1 - positionRatio;
            }
            const position =
              swiper.minTranslate() +
              (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
            swiper.updateProgress(position);
            swiper.setTranslate(position);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
          }
          function onDragStart(e) {
            const params = swiper.params.scrollbar;
            const { scrollbar, wrapperEl } = swiper;
            const { el, dragEl } = scrollbar;
            isTouched = true;
            dragStartPos =
              e.target === dragEl
                ? getPointerPosition(e) -
                  e.target.getBoundingClientRect()[
                    swiper.isHorizontal() ? "left" : "top"
                  ]
                : null;
            e.preventDefault();
            e.stopPropagation();
            wrapperEl.style.transitionDuration = "100ms";
            dragEl.style.transitionDuration = "100ms";
            setDragPosition(e);
            clearTimeout(dragTimeout);
            el.style.transitionDuration = "0ms";
            if (params.hide) {
              el.style.opacity = 1;
            }
            if (swiper.params.cssMode) {
              swiper.wrapperEl.style["scroll-snap-type"] = "none";
            }
            emit("scrollbarDragStart", e);
          }
          function onDragMove(e) {
            const { scrollbar, wrapperEl } = swiper;
            const { el, dragEl } = scrollbar;
            if (!isTouched) return;
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
            setDragPosition(e);
            wrapperEl.style.transitionDuration = "0ms";
            el.style.transitionDuration = "0ms";
            dragEl.style.transitionDuration = "0ms";
            emit("scrollbarDragMove", e);
          }
          function onDragEnd(e) {
            const params = swiper.params.scrollbar;
            const { scrollbar, wrapperEl } = swiper;
            const { el } = scrollbar;
            if (!isTouched) return;
            isTouched = false;
            if (swiper.params.cssMode) {
              swiper.wrapperEl.style["scroll-snap-type"] = "";
              wrapperEl.style.transitionDuration = "";
            }
            if (params.hide) {
              clearTimeout(dragTimeout);
              dragTimeout = (0,
              _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
              }, 1000);
            }
            emit("scrollbarDragEnd", e);
            if (params.snapOnRelease) {
              swiper.slideToClosest();
            }
          }
          function events(method) {
            const { scrollbar, params } = swiper;
            const el = scrollbar.el;
            if (!el) return;
            const target = el;
            const activeListener = params.passiveListeners
              ? {
                  passive: false,
                  capture: false,
                }
              : false;
            const passiveListener = params.passiveListeners
              ? {
                  passive: true,
                  capture: false,
                }
              : false;
            if (!target) return;
            const eventMethod =
              method === "on" ? "addEventListener" : "removeEventListener";
            target[eventMethod]("pointerdown", onDragStart, activeListener);
            document[eventMethod]("pointermove", onDragMove, activeListener);
            document[eventMethod]("pointerup", onDragEnd, passiveListener);
          }
          function enableDraggable() {
            if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
            events("on");
          }
          function disableDraggable() {
            if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
            events("off");
          }
          function init() {
            const { scrollbar, el: swiperEl } = swiper;
            swiper.params.scrollbar = (0,
            _shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
              swiper,
              swiper.originalParams.scrollbar,
              swiper.params.scrollbar,
              {
                el: "swiper-scrollbar",
              }
            );
            const params = swiper.params.scrollbar;
            if (!params.el) return;
            let el;
            if (typeof params.el === "string" && swiper.isElement) {
              el = swiper.el.querySelector(params.el);
            }
            if (!el && typeof params.el === "string") {
              el = document.querySelectorAll(params.el);
            } else if (!el) {
              el = params.el;
            }
            if (
              swiper.params.uniqueNavElements &&
              typeof params.el === "string" &&
              el.length > 1 &&
              swiperEl.querySelectorAll(params.el).length === 1
            ) {
              el = swiperEl.querySelector(params.el);
            }
            if (el.length > 0) el = el[0];
            el.classList.add(
              swiper.isHorizontal()
                ? params.horizontalClass
                : params.verticalClass
            );
            let dragEl;
            if (el) {
              dragEl = el.querySelector(
                `.${swiper.params.scrollbar.dragClass}`
              );
              if (!dragEl) {
                dragEl = (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
                  "div",
                  swiper.params.scrollbar.dragClass
                );
                el.append(dragEl);
              }
            }
            Object.assign(scrollbar, {
              el,
              dragEl,
            });
            if (params.draggable) {
              enableDraggable();
            }
            if (el) {
              el.classList[swiper.enabled ? "remove" : "add"](
                swiper.params.scrollbar.lockClass
              );
            }
          }
          function destroy() {
            const params = swiper.params.scrollbar;
            const el = swiper.scrollbar.el;
            if (el) {
              el.classList.remove(
                swiper.isHorizontal()
                  ? params.horizontalClass
                  : params.verticalClass
              );
            }
            disableDraggable();
          }
          on("init", () => {
            if (swiper.params.scrollbar.enabled === false) {
              // eslint-disable-next-line
              disable();
            } else {
              init();
              updateSize();
              setTranslate();
            }
          });
          on("update resize observerUpdate lock unlock", () => {
            updateSize();
          });
          on("setTranslate", () => {
            setTranslate();
          });
          on("setTransition", (_s, duration) => {
            setTransition(duration);
          });
          on("enable disable", () => {
            const { el } = swiper.scrollbar;
            if (el) {
              el.classList[swiper.enabled ? "remove" : "add"](
                swiper.params.scrollbar.lockClass
              );
            }
          });
          on("destroy", () => {
            destroy();
          });
          const enable = () => {
            swiper.el.classList.remove(
              swiper.params.scrollbar.scrollbarDisabledClass
            );
            if (swiper.scrollbar.el) {
              swiper.scrollbar.el.classList.remove(
                swiper.params.scrollbar.scrollbarDisabledClass
              );
            }
            init();
            updateSize();
            setTranslate();
          };
          const disable = () => {
            swiper.el.classList.add(
              swiper.params.scrollbar.scrollbarDisabledClass
            );
            if (swiper.scrollbar.el) {
              swiper.scrollbar.el.classList.add(
                swiper.params.scrollbar.scrollbarDisabledClass
              );
            }
            destroy();
          };
          Object.assign(swiper.scrollbar, {
            enable,
            disable,
            updateSize,
            setTranslate,
            init,
            destroy,
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/thumbs.mjs":
      /*!************************************************!*\
  !*** ./node_modules/swiper/modules/thumbs.mjs ***!
  \************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Thumb,
          /* harmony export */
        });
        /* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function Thumb(_ref) {
          let { swiper, extendParams, on } = _ref;
          extendParams({
            thumbs: {
              swiper: null,
              multipleActiveThumbs: true,
              autoScrollOffset: 0,
              slideThumbActiveClass: "swiper-slide-thumb-active",
              thumbsContainerClass: "swiper-thumbs",
            },
          });
          let initialized = false;
          let swiperCreated = false;
          swiper.thumbs = {
            swiper: null,
          };
          function onThumbClick() {
            const thumbsSwiper = swiper.thumbs.swiper;
            if (!thumbsSwiper || thumbsSwiper.destroyed) return;
            const clickedIndex = thumbsSwiper.clickedIndex;
            const clickedSlide = thumbsSwiper.clickedSlide;
            if (
              clickedSlide &&
              clickedSlide.classList.contains(
                swiper.params.thumbs.slideThumbActiveClass
              )
            )
              return;
            if (typeof clickedIndex === "undefined" || clickedIndex === null)
              return;
            let slideToIndex;
            if (thumbsSwiper.params.loop) {
              slideToIndex = parseInt(
                thumbsSwiper.clickedSlide.getAttribute(
                  "data-swiper-slide-index"
                ),
                10
              );
            } else {
              slideToIndex = clickedIndex;
            }
            if (swiper.params.loop) {
              swiper.slideToLoop(slideToIndex);
            } else {
              swiper.slideTo(slideToIndex);
            }
          }
          function init() {
            const { thumbs: thumbsParams } = swiper.params;
            if (initialized) return false;
            initialized = true;
            const SwiperClass = swiper.constructor;
            if (thumbsParams.swiper instanceof SwiperClass) {
              swiper.thumbs.swiper = thumbsParams.swiper;
              Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false,
              });
              Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false,
              });
              swiper.thumbs.swiper.update();
            } else if (
              (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.j)(
                thumbsParams.swiper
              )
            ) {
              const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
              Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false,
              });
              swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
              swiperCreated = true;
            }
            swiper.thumbs.swiper.el.classList.add(
              swiper.params.thumbs.thumbsContainerClass
            );
            swiper.thumbs.swiper.on("tap", onThumbClick);
            return true;
          }
          function update(initial) {
            const thumbsSwiper = swiper.thumbs.swiper;
            if (!thumbsSwiper || thumbsSwiper.destroyed) return;
            const slidesPerView =
              thumbsSwiper.params.slidesPerView === "auto"
                ? thumbsSwiper.slidesPerViewDynamic()
                : thumbsSwiper.params.slidesPerView;

            // Activate thumbs
            let thumbsToActivate = 1;
            const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
            if (
              swiper.params.slidesPerView > 1 &&
              !swiper.params.centeredSlides
            ) {
              thumbsToActivate = swiper.params.slidesPerView;
            }
            if (!swiper.params.thumbs.multipleActiveThumbs) {
              thumbsToActivate = 1;
            }
            thumbsToActivate = Math.floor(thumbsToActivate);
            thumbsSwiper.slides.forEach((slideEl) =>
              slideEl.classList.remove(thumbActiveClass)
            );
            if (
              thumbsSwiper.params.loop ||
              (thumbsSwiper.params.virtual &&
                thumbsSwiper.params.virtual.enabled)
            ) {
              for (let i = 0; i < thumbsToActivate; i += 1) {
                (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
                  thumbsSwiper.slidesEl,
                  `[data-swiper-slide-index="${swiper.realIndex + i}"]`
                ).forEach((slideEl) => {
                  slideEl.classList.add(thumbActiveClass);
                });
              }
            } else {
              for (let i = 0; i < thumbsToActivate; i += 1) {
                if (thumbsSwiper.slides[swiper.realIndex + i]) {
                  thumbsSwiper.slides[swiper.realIndex + i].classList.add(
                    thumbActiveClass
                  );
                }
              }
            }
            const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
            const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
            if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
              const currentThumbsIndex = thumbsSwiper.activeIndex;
              let newThumbsIndex;
              let direction;
              if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.filter(
                  (slideEl) =>
                    slideEl.getAttribute("data-swiper-slide-index") ===
                    `${swiper.realIndex}`
                )[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction =
                  swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
              } else {
                newThumbsIndex = swiper.realIndex;
                direction =
                  newThumbsIndex > swiper.previousIndex ? "next" : "prev";
              }
              if (useOffset) {
                newThumbsIndex +=
                  direction === "next"
                    ? autoScrollOffset
                    : -1 * autoScrollOffset;
              }
              if (
                thumbsSwiper.visibleSlidesIndexes &&
                thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0
              ) {
                if (thumbsSwiper.params.centeredSlides) {
                  if (newThumbsIndex > currentThumbsIndex) {
                    newThumbsIndex =
                      newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                  } else {
                    newThumbsIndex =
                      newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                  }
                } else if (
                  newThumbsIndex > currentThumbsIndex &&
                  thumbsSwiper.params.slidesPerGroup === 1
                );
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
              }
            }
          }
          on("beforeInit", () => {
            const { thumbs } = swiper.params;
            if (!thumbs || !thumbs.swiper) return;
            if (
              typeof thumbs.swiper === "string" ||
              thumbs.swiper instanceof HTMLElement
            ) {
              const document = (0,
              _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
              const getThumbsElementAndInit = () => {
                const thumbsElement =
                  typeof thumbs.swiper === "string"
                    ? document.querySelector(thumbs.swiper)
                    : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                  thumbs.swiper = thumbsElement.swiper;
                  init();
                  update(true);
                } else if (thumbsElement) {
                  const onThumbsSwiper = (e) => {
                    thumbs.swiper = e.detail[0];
                    thumbsElement.removeEventListener("init", onThumbsSwiper);
                    init();
                    update(true);
                    thumbs.swiper.update();
                    swiper.update();
                  };
                  thumbsElement.addEventListener("init", onThumbsSwiper);
                }
                return thumbsElement;
              };
              const watchForThumbsToAppear = () => {
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) {
                  requestAnimationFrame(watchForThumbsToAppear);
                }
              };
              requestAnimationFrame(watchForThumbsToAppear);
            } else {
              init();
              update(true);
            }
          });
          on("slideChange update resize observerUpdate", () => {
            update();
          });
          on("setTransition", (_s, duration) => {
            const thumbsSwiper = swiper.thumbs.swiper;
            if (!thumbsSwiper || thumbsSwiper.destroyed) return;
            thumbsSwiper.setTransition(duration);
          });
          on("beforeDestroy", () => {
            const thumbsSwiper = swiper.thumbs.swiper;
            if (!thumbsSwiper || thumbsSwiper.destroyed) return;
            if (swiperCreated) {
              thumbsSwiper.destroy();
            }
          });
          Object.assign(swiper.thumbs, {
            init,
            update,
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/virtual.mjs":
      /*!*************************************************!*\
  !*** ./node_modules/swiper/modules/virtual.mjs ***!
  \*************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Virtual,
          /* harmony export */
        });
        /* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function Virtual(_ref) {
          let { swiper, extendParams, on, emit } = _ref;
          extendParams({
            virtual: {
              enabled: false,
              slides: [],
              cache: true,
              renderSlide: null,
              renderExternal: null,
              renderExternalUpdate: true,
              addSlidesBefore: 0,
              addSlidesAfter: 0,
            },
          });
          let cssModeTimeout;
          const document = (0,
          _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
          swiper.virtual = {
            cache: {},
            from: undefined,
            to: undefined,
            slides: [],
            offset: 0,
            slidesGrid: [],
          };
          const tempDOM = document.createElement("div");
          function renderSlide(slide, index) {
            const params = swiper.params.virtual;
            if (params.cache && swiper.virtual.cache[index]) {
              return swiper.virtual.cache[index];
            }
            // eslint-disable-next-line
            let slideEl;
            if (params.renderSlide) {
              slideEl = params.renderSlide.call(swiper, slide, index);
              if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
              }
            } else if (swiper.isElement) {
              slideEl = (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
                "swiper-slide"
              );
            } else {
              slideEl = (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
                "div",
                swiper.params.slideClass
              );
            }
            slideEl.setAttribute("data-swiper-slide-index", index);
            if (!params.renderSlide) {
              slideEl.innerHTML = slide;
            }
            if (params.cache) {
              swiper.virtual.cache[index] = slideEl;
            }
            return slideEl;
          }
          function update(force) {
            const {
              slidesPerView,
              slidesPerGroup,
              centeredSlides,
              loop: isLoop,
            } = swiper.params;
            const { addSlidesBefore, addSlidesAfter } = swiper.params.virtual;
            const {
              from: previousFrom,
              to: previousTo,
              slides,
              slidesGrid: previousSlidesGrid,
              offset: previousOffset,
            } = swiper.virtual;
            if (!swiper.params.cssMode) {
              swiper.updateActiveIndex();
            }
            const activeIndex = swiper.activeIndex || 0;
            let offsetProp;
            if (swiper.rtlTranslate) offsetProp = "right";
            else offsetProp = swiper.isHorizontal() ? "left" : "top";
            let slidesAfter;
            let slidesBefore;
            if (centeredSlides) {
              slidesAfter =
                Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
              slidesBefore =
                Math.floor(slidesPerView / 2) +
                slidesPerGroup +
                addSlidesBefore;
            } else {
              slidesAfter =
                slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
              slidesBefore =
                (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
            }
            let from = activeIndex - slidesBefore;
            let to = activeIndex + slidesAfter;
            if (!isLoop) {
              from = Math.max(from, 0);
              to = Math.min(to, slides.length - 1);
            }
            let offset =
              (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
            if (isLoop && activeIndex >= slidesBefore) {
              from -= slidesBefore;
              if (!centeredSlides) offset += swiper.slidesGrid[0];
            } else if (isLoop && activeIndex < slidesBefore) {
              from = -slidesBefore;
              if (centeredSlides) offset += swiper.slidesGrid[0];
            }
            Object.assign(swiper.virtual, {
              from,
              to,
              offset,
              slidesGrid: swiper.slidesGrid,
              slidesBefore,
              slidesAfter,
            });
            function onRendered() {
              swiper.updateSlides();
              swiper.updateProgress();
              swiper.updateSlidesClasses();
              emit("virtualUpdate");
            }
            if (previousFrom === from && previousTo === to && !force) {
              if (
                swiper.slidesGrid !== previousSlidesGrid &&
                offset !== previousOffset
              ) {
                swiper.slides.forEach((slideEl) => {
                  slideEl.style[offsetProp] = `${
                    offset - Math.abs(swiper.cssOverflowAdjustment())
                  }px`;
                });
              }
              swiper.updateProgress();
              emit("virtualUpdate");
              return;
            }
            if (swiper.params.virtual.renderExternal) {
              swiper.params.virtual.renderExternal.call(swiper, {
                offset,
                from,
                to,
                slides: (function getSlides() {
                  const slidesToRender = [];
                  for (let i = from; i <= to; i += 1) {
                    slidesToRender.push(slides[i]);
                  }
                  return slidesToRender;
                })(),
              });
              if (swiper.params.virtual.renderExternalUpdate) {
                onRendered();
              } else {
                emit("virtualUpdate");
              }
              return;
            }
            const prependIndexes = [];
            const appendIndexes = [];
            const getSlideIndex = (index) => {
              let slideIndex = index;
              if (index < 0) {
                slideIndex = slides.length + index;
              } else if (slideIndex >= slides.length) {
                // eslint-disable-next-line
                slideIndex = slideIndex - slides.length;
              }
              return slideIndex;
            };
            if (force) {
              swiper.slides
                .filter((el) =>
                  el.matches(`.${swiper.params.slideClass}, swiper-slide`)
                )
                .forEach((slideEl) => {
                  slideEl.remove();
                });
            } else {
              for (let i = previousFrom; i <= previousTo; i += 1) {
                if (i < from || i > to) {
                  const slideIndex = getSlideIndex(i);
                  swiper.slides
                    .filter((el) =>
                      el.matches(
                        `.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`
                      )
                    )
                    .forEach((slideEl) => {
                      slideEl.remove();
                    });
                }
              }
            }
            const loopFrom = isLoop ? -slides.length : 0;
            const loopTo = isLoop ? slides.length * 2 : slides.length;
            for (let i = loopFrom; i < loopTo; i += 1) {
              if (i >= from && i <= to) {
                const slideIndex = getSlideIndex(i);
                if (typeof previousTo === "undefined" || force) {
                  appendIndexes.push(slideIndex);
                } else {
                  if (i > previousTo) appendIndexes.push(slideIndex);
                  if (i < previousFrom) prependIndexes.push(slideIndex);
                }
              }
            }
            appendIndexes.forEach((index) => {
              swiper.slidesEl.append(renderSlide(slides[index], index));
            });
            if (isLoop) {
              for (let i = prependIndexes.length - 1; i >= 0; i -= 1) {
                const index = prependIndexes[i];
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
              }
            } else {
              prependIndexes.sort((a, b) => b - a);
              prependIndexes.forEach((index) => {
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
              });
            }
            (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
              swiper.slidesEl,
              ".swiper-slide, swiper-slide"
            ).forEach((slideEl) => {
              slideEl.style[offsetProp] = `${
                offset - Math.abs(swiper.cssOverflowAdjustment())
              }px`;
            });
            onRendered();
          }
          function appendSlide(slides) {
            if (typeof slides === "object" && "length" in slides) {
              for (let i = 0; i < slides.length; i += 1) {
                if (slides[i]) swiper.virtual.slides.push(slides[i]);
              }
            } else {
              swiper.virtual.slides.push(slides);
            }
            update(true);
          }
          function prependSlide(slides) {
            const activeIndex = swiper.activeIndex;
            let newActiveIndex = activeIndex + 1;
            let numberOfNewSlides = 1;
            if (Array.isArray(slides)) {
              for (let i = 0; i < slides.length; i += 1) {
                if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
              }
              newActiveIndex = activeIndex + slides.length;
              numberOfNewSlides = slides.length;
            } else {
              swiper.virtual.slides.unshift(slides);
            }
            if (swiper.params.virtual.cache) {
              const cache = swiper.virtual.cache;
              const newCache = {};
              Object.keys(cache).forEach((cachedIndex) => {
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute(
                  "data-swiper-slide-index"
                );
                if (cachedElIndex) {
                  cachedEl.setAttribute(
                    "data-swiper-slide-index",
                    parseInt(cachedElIndex, 10) + numberOfNewSlides
                  );
                }
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] =
                  cachedEl;
              });
              swiper.virtual.cache = newCache;
            }
            update(true);
            swiper.slideTo(newActiveIndex, 0);
          }
          function removeSlide(slidesIndexes) {
            if (typeof slidesIndexes === "undefined" || slidesIndexes === null)
              return;
            let activeIndex = swiper.activeIndex;
            if (Array.isArray(slidesIndexes)) {
              for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
                if (swiper.params.virtual.cache) {
                  delete swiper.virtual.cache[slidesIndexes[i]];
                  // shift cache indexes
                  Object.keys(swiper.virtual.cache).forEach((key) => {
                    if (key > slidesIndexes) {
                      swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                      swiper.virtual.cache[key - 1].setAttribute(
                        "data-swiper-slide-index",
                        key - 1
                      );
                      delete swiper.virtual.cache[key];
                    }
                  });
                }
                swiper.virtual.slides.splice(slidesIndexes[i], 1);
                if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
                activeIndex = Math.max(activeIndex, 0);
              }
            } else {
              if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key) => {
                  if (key > slidesIndexes) {
                    swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                    swiper.virtual.cache[key - 1].setAttribute(
                      "data-swiper-slide-index",
                      key - 1
                    );
                    delete swiper.virtual.cache[key];
                  }
                });
              }
              swiper.virtual.slides.splice(slidesIndexes, 1);
              if (slidesIndexes < activeIndex) activeIndex -= 1;
              activeIndex = Math.max(activeIndex, 0);
            }
            update(true);
            swiper.slideTo(activeIndex, 0);
          }
          function removeAllSlides() {
            swiper.virtual.slides = [];
            if (swiper.params.virtual.cache) {
              swiper.virtual.cache = {};
            }
            update(true);
            swiper.slideTo(0, 0);
          }
          on("beforeInit", () => {
            if (!swiper.params.virtual.enabled) return;
            let domSlidesAssigned;
            if (typeof swiper.passedParams.virtual.slides === "undefined") {
              const slides = [...swiper.slidesEl.children].filter((el) =>
                el.matches(`.${swiper.params.slideClass}, swiper-slide`)
              );
              if (slides && slides.length) {
                swiper.virtual.slides = [...slides];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex) => {
                  slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                  swiper.virtual.cache[slideIndex] = slideEl;
                  slideEl.remove();
                });
              }
            }
            if (!domSlidesAssigned) {
              swiper.virtual.slides = swiper.params.virtual.slides;
            }
            swiper.classNames.push(
              `${swiper.params.containerModifierClass}virtual`
            );
            swiper.params.watchSlidesProgress = true;
            swiper.originalParams.watchSlidesProgress = true;
            update();
          });
          on("setTranslate", () => {
            if (!swiper.params.virtual.enabled) return;
            if (swiper.params.cssMode && !swiper._immediateVirtual) {
              clearTimeout(cssModeTimeout);
              cssModeTimeout = setTimeout(() => {
                update();
              }, 100);
            } else {
              update();
            }
          });
          on("init update resize", () => {
            if (!swiper.params.virtual.enabled) return;
            if (swiper.params.cssMode) {
              (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(
                swiper.wrapperEl,
                "--swiper-virtual-size",
                `${swiper.virtualSize}px`
              );
            }
          });
          Object.assign(swiper.virtual, {
            appendSlide,
            prependSlide,
            removeSlide,
            removeAllSlides,
            update,
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/modules/zoom.mjs":
      /*!**********************************************!*\
  !*** ./node_modules/swiper/modules/zoom.mjs ***!
  \**********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Zoom,
          /* harmony export */
        });
        /* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs"
          );
        /* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function Zoom(_ref) {
          let { swiper, extendParams, on, emit } = _ref;
          const window = (0,
          _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          extendParams({
            zoom: {
              enabled: false,
              maxRatio: 3,
              minRatio: 1,
              toggle: true,
              containerClass: "swiper-zoom-container",
              zoomedSlideClass: "swiper-slide-zoomed",
            },
          });
          swiper.zoom = {
            enabled: false,
          };
          let currentScale = 1;
          let isScaling = false;
          let fakeGestureTouched;
          let fakeGestureMoved;
          const evCache = [];
          const gesture = {
            originX: 0,
            originY: 0,
            slideEl: undefined,
            slideWidth: undefined,
            slideHeight: undefined,
            imageEl: undefined,
            imageWrapEl: undefined,
            maxRatio: 3,
          };
          const image = {
            isTouched: undefined,
            isMoved: undefined,
            currentX: undefined,
            currentY: undefined,
            minX: undefined,
            minY: undefined,
            maxX: undefined,
            maxY: undefined,
            width: undefined,
            height: undefined,
            startX: undefined,
            startY: undefined,
            touchesStart: {},
            touchesCurrent: {},
          };
          const velocity = {
            x: undefined,
            y: undefined,
            prevPositionX: undefined,
            prevPositionY: undefined,
            prevTime: undefined,
          };
          let scale = 1;
          Object.defineProperty(swiper.zoom, "scale", {
            get() {
              return scale;
            },
            set(value) {
              if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
              }
              scale = value;
            },
          });
          function getDistanceBetweenTouches() {
            if (evCache.length < 2) return 1;
            const x1 = evCache[0].pageX;
            const y1 = evCache[0].pageY;
            const x2 = evCache[1].pageX;
            const y2 = evCache[1].pageY;
            const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
            return distance;
          }
          function getScaleOrigin() {
            if (evCache.length < 2)
              return {
                x: null,
                y: null,
              };
            const box = gesture.imageEl.getBoundingClientRect();
            return [
              (evCache[0].pageX +
                (evCache[1].pageX - evCache[0].pageX) / 2 -
                box.x -
                window.scrollX) /
                currentScale,
              (evCache[0].pageY +
                (evCache[1].pageY - evCache[0].pageY) / 2 -
                box.y -
                window.scrollY) /
                currentScale,
            ];
          }
          function getSlideSelector() {
            return swiper.isElement
              ? `swiper-slide`
              : `.${swiper.params.slideClass}`;
          }
          function eventWithinSlide(e) {
            const slideSelector = getSlideSelector();
            if (e.target.matches(slideSelector)) return true;
            if (
              swiper.slides.filter((slideEl) => slideEl.contains(e.target))
                .length > 0
            )
              return true;
            return false;
          }
          function eventWithinZoomContainer(e) {
            const selector = `.${swiper.params.zoom.containerClass}`;
            if (e.target.matches(selector)) return true;
            if (
              [...swiper.hostEl.querySelectorAll(selector)].filter(
                (containerEl) => containerEl.contains(e.target)
              ).length > 0
            )
              return true;
            return false;
          }

          // Events
          function onGestureStart(e) {
            if (e.pointerType === "mouse") {
              evCache.splice(0, evCache.length);
            }
            if (!eventWithinSlide(e)) return;
            const params = swiper.params.zoom;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
            evCache.push(e);
            if (evCache.length < 2) {
              return;
            }
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches();
            if (!gesture.slideEl) {
              gesture.slideEl = e.target.closest(
                `.${swiper.params.slideClass}, swiper-slide`
              );
              if (!gesture.slideEl)
                gesture.slideEl = swiper.slides[swiper.activeIndex];
              let imageEl = gesture.slideEl.querySelector(
                `.${params.containerClass}`
              );
              if (imageEl) {
                imageEl = imageEl.querySelectorAll(
                  "picture, img, svg, canvas, .swiper-zoom-target"
                )[0];
              }
              gesture.imageEl = imageEl;
              if (imageEl) {
                gesture.imageWrapEl = (0,
                _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(
                  gesture.imageEl,
                  `.${params.containerClass}`
                )[0];
              } else {
                gesture.imageWrapEl = undefined;
              }
              if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
              }
              gesture.maxRatio =
                gesture.imageWrapEl.getAttribute("data-swiper-zoom") ||
                params.maxRatio;
            }
            if (gesture.imageEl) {
              const [originX, originY] = getScaleOrigin();
              gesture.originX = originX;
              gesture.originY = originY;
              gesture.imageEl.style.transitionDuration = "0ms";
            }
            isScaling = true;
          }
          function onGestureChange(e) {
            if (!eventWithinSlide(e)) return;
            const params = swiper.params.zoom;
            const zoom = swiper.zoom;
            const pointerIndex = evCache.findIndex(
              (cachedEv) => cachedEv.pointerId === e.pointerId
            );
            if (pointerIndex >= 0) evCache[pointerIndex] = e;
            if (evCache.length < 2) {
              return;
            }
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches();
            if (!gesture.imageEl) {
              return;
            }
            zoom.scale =
              (gesture.scaleMove / gesture.scaleStart) * currentScale;
            if (zoom.scale > gesture.maxRatio) {
              zoom.scale =
                gesture.maxRatio -
                1 +
                (zoom.scale - gesture.maxRatio + 1) ** 0.5;
            }
            if (zoom.scale < params.minRatio) {
              zoom.scale =
                params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
            }
            gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
          }
          function onGestureEnd(e) {
            if (!eventWithinSlide(e)) return;
            if (e.pointerType === "mouse" && e.type === "pointerout") return;
            const params = swiper.params.zoom;
            const zoom = swiper.zoom;
            const pointerIndex = evCache.findIndex(
              (cachedEv) => cachedEv.pointerId === e.pointerId
            );
            if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
            if (!fakeGestureTouched || !fakeGestureMoved) {
              return;
            }
            fakeGestureTouched = false;
            fakeGestureMoved = false;
            if (!gesture.imageEl) return;
            zoom.scale = Math.max(
              Math.min(zoom.scale, gesture.maxRatio),
              params.minRatio
            );
            gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
            gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
            currentScale = zoom.scale;
            isScaling = false;
            if (zoom.scale > 1 && gesture.slideEl) {
              gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
            } else if (zoom.scale <= 1 && gesture.slideEl) {
              gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
            }
            if (zoom.scale === 1) {
              gesture.originX = 0;
              gesture.originY = 0;
              gesture.slideEl = undefined;
            }
          }
          function onTouchStart(e) {
            const device = swiper.device;
            if (!gesture.imageEl) return;
            if (image.isTouched) return;
            if (device.android && e.cancelable) e.preventDefault();
            image.isTouched = true;
            const event = evCache.length > 0 ? evCache[0] : e;
            image.touchesStart.x = event.pageX;
            image.touchesStart.y = event.pageY;
          }
          function onTouchMove(e) {
            if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
            const zoom = swiper.zoom;
            if (!gesture.imageEl) return;
            if (!image.isTouched || !gesture.slideEl) return;
            if (!image.isMoved) {
              image.width = gesture.imageEl.offsetWidth;
              image.height = gesture.imageEl.offsetHeight;
              image.startX =
                (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(
                  gesture.imageWrapEl,
                  "x"
                ) || 0;
              image.startY =
                (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(
                  gesture.imageWrapEl,
                  "y"
                ) || 0;
              gesture.slideWidth = gesture.slideEl.offsetWidth;
              gesture.slideHeight = gesture.slideEl.offsetHeight;
              gesture.imageWrapEl.style.transitionDuration = "0ms";
            }
            // Define if we need image drag
            const scaledWidth = image.width * zoom.scale;
            const scaledHeight = image.height * zoom.scale;
            if (
              scaledWidth < gesture.slideWidth &&
              scaledHeight < gesture.slideHeight
            )
              return;
            image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
            image.maxX = -image.minX;
            image.minY = Math.min(
              gesture.slideHeight / 2 - scaledHeight / 2,
              0
            );
            image.maxY = -image.minY;
            image.touchesCurrent.x =
              evCache.length > 0 ? evCache[0].pageX : e.pageX;
            image.touchesCurrent.y =
              evCache.length > 0 ? evCache[0].pageY : e.pageY;
            const touchesDiff = Math.max(
              Math.abs(image.touchesCurrent.x - image.touchesStart.x),
              Math.abs(image.touchesCurrent.y - image.touchesStart.y)
            );
            if (touchesDiff > 5) {
              swiper.allowClick = false;
            }
            if (!image.isMoved && !isScaling) {
              if (
                swiper.isHorizontal() &&
                ((Math.floor(image.minX) === Math.floor(image.startX) &&
                  image.touchesCurrent.x < image.touchesStart.x) ||
                  (Math.floor(image.maxX) === Math.floor(image.startX) &&
                    image.touchesCurrent.x > image.touchesStart.x))
              ) {
                image.isTouched = false;
                return;
              }
              if (
                !swiper.isHorizontal() &&
                ((Math.floor(image.minY) === Math.floor(image.startY) &&
                  image.touchesCurrent.y < image.touchesStart.y) ||
                  (Math.floor(image.maxY) === Math.floor(image.startY) &&
                    image.touchesCurrent.y > image.touchesStart.y))
              ) {
                image.isTouched = false;
                return;
              }
            }
            if (e.cancelable) {
              e.preventDefault();
            }
            e.stopPropagation();
            image.isMoved = true;
            const scaleRatio =
              (zoom.scale - currentScale) /
              (gesture.maxRatio - swiper.params.zoom.minRatio);
            const { originX, originY } = gesture;
            image.currentX =
              image.touchesCurrent.x -
              image.touchesStart.x +
              image.startX +
              scaleRatio * (image.width - originX * 2);
            image.currentY =
              image.touchesCurrent.y -
              image.touchesStart.y +
              image.startY +
              scaleRatio * (image.height - originY * 2);
            if (image.currentX < image.minX) {
              image.currentX =
                image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
            }
            if (image.currentX > image.maxX) {
              image.currentX =
                image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
            }
            if (image.currentY < image.minY) {
              image.currentY =
                image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
            }
            if (image.currentY > image.maxY) {
              image.currentY =
                image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
            }

            // Velocity
            if (!velocity.prevPositionX)
              velocity.prevPositionX = image.touchesCurrent.x;
            if (!velocity.prevPositionY)
              velocity.prevPositionY = image.touchesCurrent.y;
            if (!velocity.prevTime) velocity.prevTime = Date.now();
            velocity.x =
              (image.touchesCurrent.x - velocity.prevPositionX) /
              (Date.now() - velocity.prevTime) /
              2;
            velocity.y =
              (image.touchesCurrent.y - velocity.prevPositionY) /
              (Date.now() - velocity.prevTime) /
              2;
            if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2)
              velocity.x = 0;
            if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2)
              velocity.y = 0;
            velocity.prevPositionX = image.touchesCurrent.x;
            velocity.prevPositionY = image.touchesCurrent.y;
            velocity.prevTime = Date.now();
            gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
          }
          function onTouchEnd() {
            const zoom = swiper.zoom;
            if (!gesture.imageEl) return;
            if (!image.isTouched || !image.isMoved) {
              image.isTouched = false;
              image.isMoved = false;
              return;
            }
            image.isTouched = false;
            image.isMoved = false;
            let momentumDurationX = 300;
            let momentumDurationY = 300;
            const momentumDistanceX = velocity.x * momentumDurationX;
            const newPositionX = image.currentX + momentumDistanceX;
            const momentumDistanceY = velocity.y * momentumDurationY;
            const newPositionY = image.currentY + momentumDistanceY;

            // Fix duration
            if (velocity.x !== 0)
              momentumDurationX = Math.abs(
                (newPositionX - image.currentX) / velocity.x
              );
            if (velocity.y !== 0)
              momentumDurationY = Math.abs(
                (newPositionY - image.currentY) / velocity.y
              );
            const momentumDuration = Math.max(
              momentumDurationX,
              momentumDurationY
            );
            image.currentX = newPositionX;
            image.currentY = newPositionY;
            // Define if we need image drag
            const scaledWidth = image.width * zoom.scale;
            const scaledHeight = image.height * zoom.scale;
            image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
            image.maxX = -image.minX;
            image.minY = Math.min(
              gesture.slideHeight / 2 - scaledHeight / 2,
              0
            );
            image.maxY = -image.minY;
            image.currentX = Math.max(
              Math.min(image.currentX, image.maxX),
              image.minX
            );
            image.currentY = Math.max(
              Math.min(image.currentY, image.maxY),
              image.minY
            );
            gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
            gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
          }
          function onTransitionEnd() {
            const zoom = swiper.zoom;
            if (
              gesture.slideEl &&
              swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)
            ) {
              if (gesture.imageEl) {
                gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
              }
              if (gesture.imageWrapEl) {
                gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
              }
              gesture.slideEl.classList.remove(
                `${swiper.params.zoom.zoomedSlideClass}`
              );
              zoom.scale = 1;
              currentScale = 1;
              gesture.slideEl = undefined;
              gesture.imageEl = undefined;
              gesture.imageWrapEl = undefined;
              gesture.originX = 0;
              gesture.originY = 0;
            }
          }
          function zoomIn(e) {
            const zoom = swiper.zoom;
            const params = swiper.params.zoom;
            if (!gesture.slideEl) {
              if (e && e.target) {
                gesture.slideEl = e.target.closest(
                  `.${swiper.params.slideClass}, swiper-slide`
                );
              }
              if (!gesture.slideEl) {
                if (
                  swiper.params.virtual &&
                  swiper.params.virtual.enabled &&
                  swiper.virtual
                ) {
                  gesture.slideEl = (0,
                  _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
                    swiper.slidesEl,
                    `.${swiper.params.slideActiveClass}`
                  )[0];
                } else {
                  gesture.slideEl = swiper.slides[swiper.activeIndex];
                }
              }
              let imageEl = gesture.slideEl.querySelector(
                `.${params.containerClass}`
              );
              if (imageEl) {
                imageEl = imageEl.querySelectorAll(
                  "picture, img, svg, canvas, .swiper-zoom-target"
                )[0];
              }
              gesture.imageEl = imageEl;
              if (imageEl) {
                gesture.imageWrapEl = (0,
                _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(
                  gesture.imageEl,
                  `.${params.containerClass}`
                )[0];
              } else {
                gesture.imageWrapEl = undefined;
              }
            }
            if (!gesture.imageEl || !gesture.imageWrapEl) return;
            if (swiper.params.cssMode) {
              swiper.wrapperEl.style.overflow = "hidden";
              swiper.wrapperEl.style.touchAction = "none";
            }
            gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
            let touchX;
            let touchY;
            let offsetX;
            let offsetY;
            let diffX;
            let diffY;
            let translateX;
            let translateY;
            let imageWidth;
            let imageHeight;
            let scaledWidth;
            let scaledHeight;
            let translateMinX;
            let translateMinY;
            let translateMaxX;
            let translateMaxY;
            let slideWidth;
            let slideHeight;
            if (typeof image.touchesStart.x === "undefined" && e) {
              touchX = e.pageX;
              touchY = e.pageY;
            } else {
              touchX = image.touchesStart.x;
              touchY = image.touchesStart.y;
            }
            const forceZoomRatio = typeof e === "number" ? e : null;
            if (currentScale === 1 && forceZoomRatio) {
              touchX = undefined;
              touchY = undefined;
            }
            zoom.scale =
              forceZoomRatio ||
              gesture.imageWrapEl.getAttribute("data-swiper-zoom") ||
              params.maxRatio;
            currentScale =
              forceZoomRatio ||
              gesture.imageWrapEl.getAttribute("data-swiper-zoom") ||
              params.maxRatio;
            if (e && !(currentScale === 1 && forceZoomRatio)) {
              slideWidth = gesture.slideEl.offsetWidth;
              slideHeight = gesture.slideEl.offsetHeight;
              offsetX =
                (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.b)(
                  gesture.slideEl
                ).left + window.scrollX;
              offsetY =
                (0, _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.b)(
                  gesture.slideEl
                ).top + window.scrollY;
              diffX = offsetX + slideWidth / 2 - touchX;
              diffY = offsetY + slideHeight / 2 - touchY;
              imageWidth = gesture.imageEl.offsetWidth;
              imageHeight = gesture.imageEl.offsetHeight;
              scaledWidth = imageWidth * zoom.scale;
              scaledHeight = imageHeight * zoom.scale;
              translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
              translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
              translateMaxX = -translateMinX;
              translateMaxY = -translateMinY;
              translateX = diffX * zoom.scale;
              translateY = diffY * zoom.scale;
              if (translateX < translateMinX) {
                translateX = translateMinX;
              }
              if (translateX > translateMaxX) {
                translateX = translateMaxX;
              }
              if (translateY < translateMinY) {
                translateY = translateMinY;
              }
              if (translateY > translateMaxY) {
                translateY = translateMaxY;
              }
            } else {
              translateX = 0;
              translateY = 0;
            }
            if (forceZoomRatio && zoom.scale === 1) {
              gesture.originX = 0;
              gesture.originY = 0;
            }
            gesture.imageWrapEl.style.transitionDuration = "300ms";
            gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
            gesture.imageEl.style.transitionDuration = "300ms";
            gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
          }
          function zoomOut() {
            const zoom = swiper.zoom;
            const params = swiper.params.zoom;
            if (!gesture.slideEl) {
              if (
                swiper.params.virtual &&
                swiper.params.virtual.enabled &&
                swiper.virtual
              ) {
                gesture.slideEl = (0,
                _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
                  swiper.slidesEl,
                  `.${swiper.params.slideActiveClass}`
                )[0];
              } else {
                gesture.slideEl = swiper.slides[swiper.activeIndex];
              }
              let imageEl = gesture.slideEl.querySelector(
                `.${params.containerClass}`
              );
              if (imageEl) {
                imageEl = imageEl.querySelectorAll(
                  "picture, img, svg, canvas, .swiper-zoom-target"
                )[0];
              }
              gesture.imageEl = imageEl;
              if (imageEl) {
                gesture.imageWrapEl = (0,
                _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(
                  gesture.imageEl,
                  `.${params.containerClass}`
                )[0];
              } else {
                gesture.imageWrapEl = undefined;
              }
            }
            if (!gesture.imageEl || !gesture.imageWrapEl) return;
            if (swiper.params.cssMode) {
              swiper.wrapperEl.style.overflow = "";
              swiper.wrapperEl.style.touchAction = "";
            }
            zoom.scale = 1;
            currentScale = 1;
            gesture.imageWrapEl.style.transitionDuration = "300ms";
            gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.imageEl.style.transitionDuration = "300ms";
            gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
            gesture.slideEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
          }

          // Toggle Zoom
          function zoomToggle(e) {
            const zoom = swiper.zoom;
            if (zoom.scale && zoom.scale !== 1) {
              // Zoom Out
              zoomOut();
            } else {
              // Zoom In
              zoomIn(e);
            }
          }
          function getListeners() {
            const passiveListener = swiper.params.passiveListeners
              ? {
                  passive: true,
                  capture: false,
                }
              : false;
            const activeListenerWithCapture = swiper.params.passiveListeners
              ? {
                  passive: false,
                  capture: true,
                }
              : true;
            return {
              passiveListener,
              activeListenerWithCapture,
            };
          }

          // Attach/Detach Events
          function enable() {
            const zoom = swiper.zoom;
            if (zoom.enabled) return;
            zoom.enabled = true;
            const { passiveListener, activeListenerWithCapture } =
              getListeners();

            // Scale image
            swiper.wrapperEl.addEventListener(
              "pointerdown",
              onGestureStart,
              passiveListener
            );
            swiper.wrapperEl.addEventListener(
              "pointermove",
              onGestureChange,
              activeListenerWithCapture
            );
            ["pointerup", "pointercancel", "pointerout"].forEach(
              (eventName) => {
                swiper.wrapperEl.addEventListener(
                  eventName,
                  onGestureEnd,
                  passiveListener
                );
              }
            );

            // Move image
            swiper.wrapperEl.addEventListener(
              "pointermove",
              onTouchMove,
              activeListenerWithCapture
            );
          }
          function disable() {
            const zoom = swiper.zoom;
            if (!zoom.enabled) return;
            zoom.enabled = false;
            const { passiveListener, activeListenerWithCapture } =
              getListeners();

            // Scale image
            swiper.wrapperEl.removeEventListener(
              "pointerdown",
              onGestureStart,
              passiveListener
            );
            swiper.wrapperEl.removeEventListener(
              "pointermove",
              onGestureChange,
              activeListenerWithCapture
            );
            ["pointerup", "pointercancel", "pointerout"].forEach(
              (eventName) => {
                swiper.wrapperEl.removeEventListener(
                  eventName,
                  onGestureEnd,
                  passiveListener
                );
              }
            );

            // Move image
            swiper.wrapperEl.removeEventListener(
              "pointermove",
              onTouchMove,
              activeListenerWithCapture
            );
          }
          on("init", () => {
            if (swiper.params.zoom.enabled) {
              enable();
            }
          });
          on("destroy", () => {
            disable();
          });
          on("touchStart", (_s, e) => {
            if (!swiper.zoom.enabled) return;
            onTouchStart(e);
          });
          on("touchEnd", (_s, e) => {
            if (!swiper.zoom.enabled) return;
            onTouchEnd();
          });
          on("doubleTap", (_s, e) => {
            if (
              !swiper.animating &&
              swiper.params.zoom.enabled &&
              swiper.zoom.enabled &&
              swiper.params.zoom.toggle
            ) {
              zoomToggle(e);
            }
          });
          on("transitionEnd", () => {
            if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
              onTransitionEnd();
            }
          });
          on("slideChange", () => {
            if (
              swiper.zoom.enabled &&
              swiper.params.zoom.enabled &&
              swiper.params.cssMode
            ) {
              onTransitionEnd();
            }
          });
          Object.assign(swiper.zoom, {
            enable,
            disable,
            in: zoomIn,
            out: zoomOut,
            toggle: zoomToggle,
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/shared/classes-to-selector.mjs":
      /*!************************************************************!*\
  !*** ./node_modules/swiper/shared/classes-to-selector.mjs ***!
  \************************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ c: () => /* binding */ classesToSelector,
          /* harmony export */
        });
        function classesToSelector(classes) {
          if (classes === void 0) {
            classes = "";
          }
          return `.${classes
            .trim()
            .replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
            .replace(/ /g, ".")}`;
        }

        /***/
      },

    /***/ "./node_modules/swiper/shared/create-element-if-not-defined.mjs":
      /*!**********************************************************************!*\
  !*** ./node_modules/swiper/shared/create-element-if-not-defined.mjs ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ c: () => /* binding */ createElementIfNotDefined,
          /* harmony export */
        });
        /* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function createElementIfNotDefined(
          swiper,
          originalParams,
          params,
          checkProps
        ) {
          if (swiper.params.createElements) {
            Object.keys(checkProps).forEach((key) => {
              if (!params[key] && params.auto === true) {
                let element = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(
                  swiper.el,
                  `.${checkProps[key]}`
                )[0];
                if (!element) {
                  element = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
                    "div",
                    checkProps[key]
                  );
                  element.className = checkProps[key];
                  swiper.el.append(element);
                }
                params[key] = element;
                originalParams[key] = element;
              }
            });
          }
          return params;
        }

        /***/
      },

    /***/ "./node_modules/swiper/shared/create-shadow.mjs":
      /*!******************************************************!*\
  !*** ./node_modules/swiper/shared/create-shadow.mjs ***!
  \******************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ c: () => /* binding */ createShadow,
          /* harmony export */
        });
        /* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function createShadow(suffix, slideEl, side) {
          const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}${
            suffix ? ` swiper-slide-shadow-${suffix}` : ""
          }`;
          const shadowContainer = (0,
          _utils_mjs__WEBPACK_IMPORTED_MODULE_0__.k)(slideEl);
          let shadowEl = shadowContainer.querySelector(
            `.${shadowClass.split(" ").join(".")}`
          );
          if (!shadowEl) {
            shadowEl = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(
              "div",
              shadowClass.split(" ")
            );
            shadowContainer.append(shadowEl);
          }
          return shadowEl;
        }

        /***/
      },

    /***/ "./node_modules/swiper/shared/effect-init.mjs":
      /*!****************************************************!*\
  !*** ./node_modules/swiper/shared/effect-init.mjs ***!
  \****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ e: () => /* binding */ effectInit,
          /* harmony export */
        });
        function effectInit(params) {
          const {
            effect,
            swiper,
            on,
            setTranslate,
            setTransition,
            overwriteParams,
            perspective,
            recreateShadows,
            getEffectParams,
          } = params;
          on("beforeInit", () => {
            if (swiper.params.effect !== effect) return;
            swiper.classNames.push(
              `${swiper.params.containerModifierClass}${effect}`
            );
            if (perspective && perspective()) {
              swiper.classNames.push(
                `${swiper.params.containerModifierClass}3d`
              );
            }
            const overwriteParamsResult = overwriteParams
              ? overwriteParams()
              : {};
            Object.assign(swiper.params, overwriteParamsResult);
            Object.assign(swiper.originalParams, overwriteParamsResult);
          });
          on("setTranslate", () => {
            if (swiper.params.effect !== effect) return;
            setTranslate();
          });
          on("setTransition", (_s, duration) => {
            if (swiper.params.effect !== effect) return;
            setTransition(duration);
          });
          on("transitionEnd", () => {
            if (swiper.params.effect !== effect) return;
            if (recreateShadows) {
              if (!getEffectParams || !getEffectParams().slideShadows) return;
              // remove shadows
              swiper.slides.forEach((slideEl) => {
                slideEl
                  .querySelectorAll(
                    ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                  )
                  .forEach((shadowEl) => shadowEl.remove());
              });
              // create new one
              recreateShadows();
            }
          });
          let requireUpdateOnVirtual;
          on("virtualUpdate", () => {
            if (swiper.params.effect !== effect) return;
            if (!swiper.slides.length) {
              requireUpdateOnVirtual = true;
            }
            requestAnimationFrame(() => {
              if (
                requireUpdateOnVirtual &&
                swiper.slides &&
                swiper.slides.length
              ) {
                setTranslate();
                requireUpdateOnVirtual = false;
              }
            });
          });
        }

        /***/
      },

    /***/ "./node_modules/swiper/shared/effect-target.mjs":
      /*!******************************************************!*\
  !*** ./node_modules/swiper/shared/effect-target.mjs ***!
  \******************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ e: () => /* binding */ effectTarget,
          /* harmony export */
        });
        /* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function effectTarget(effectParams, slideEl) {
          const transformEl = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_0__.k)(
            slideEl
          );
          if (transformEl !== slideEl) {
            transformEl.style.backfaceVisibility = "hidden";
            transformEl.style["-webkit-backface-visibility"] = "hidden";
          }
          return transformEl;
        }

        /***/
      },

    /***/ "./node_modules/swiper/shared/effect-virtual-transition-end.mjs":
      /*!**********************************************************************!*\
  !*** ./node_modules/swiper/shared/effect-virtual-transition-end.mjs ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ e: () =>
            /* binding */ effectVirtualTransitionEnd,
          /* harmony export */
        });
        /* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        function effectVirtualTransitionEnd(_ref) {
          let { swiper, duration, transformElements, allSlides } = _ref;
          const { activeIndex } = swiper;
          const getSlide = (el) => {
            if (!el.parentElement) {
              // assume shadow root
              const slide = swiper.slides.filter(
                (slideEl) =>
                  slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode
              )[0];
              return slide;
            }
            return el.parentElement;
          };
          if (swiper.params.virtualTranslate && duration !== 0) {
            let eventTriggered = false;
            let transitionEndTarget;
            if (allSlides) {
              transitionEndTarget = transformElements;
            } else {
              transitionEndTarget = transformElements.filter((transformEl) => {
                const el = transformEl.classList.contains(
                  "swiper-slide-transform"
                )
                  ? getSlide(transformEl)
                  : transformEl;
                return swiper.getSlideIndex(el) === activeIndex;
              });
            }
            transitionEndTarget.forEach((el) => {
              (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_0__.i)(el, () => {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent("transitionend", {
                  bubbles: true,
                  cancelable: true,
                });
                swiper.wrapperEl.dispatchEvent(evt);
              });
            });
          }
        }

        /***/
      },

    /***/ "./node_modules/swiper/shared/ssr-window.esm.mjs":
      /*!*******************************************************!*\
  !*** ./node_modules/swiper/shared/ssr-window.esm.mjs ***!
  \*******************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ a: () => /* binding */ getWindow,
          /* harmony export */ g: () => /* binding */ getDocument,
          /* harmony export */
        });
        /**
         * SSR Window 4.0.2
         * Better handling for window object in SSR environment
         * https://github.com/nolimits4web/ssr-window
         *
         * Copyright 2021, Vladimir Kharlampidi
         *
         * Licensed under MIT
         *
         * Released on: December 13, 2021
         */
        /* eslint-disable no-param-reassign */
        function isObject(obj) {
          return (
            obj !== null &&
            typeof obj === "object" &&
            "constructor" in obj &&
            obj.constructor === Object
          );
        }
        function extend(target, src) {
          if (target === void 0) {
            target = {};
          }
          if (src === void 0) {
            src = {};
          }
          Object.keys(src).forEach((key) => {
            if (typeof target[key] === "undefined") target[key] = src[key];
            else if (
              isObject(src[key]) &&
              isObject(target[key]) &&
              Object.keys(src[key]).length > 0
            ) {
              extend(target[key], src[key]);
            }
          });
        }
        const ssrDocument = {
          body: {},
          addEventListener() {},
          removeEventListener() {},
          activeElement: {
            blur() {},
            nodeName: "",
          },
          querySelector() {
            return null;
          },
          querySelectorAll() {
            return [];
          },
          getElementById() {
            return null;
          },
          createEvent() {
            return {
              initEvent() {},
            };
          },
          createElement() {
            return {
              children: [],
              childNodes: [],
              style: {},
              setAttribute() {},
              getElementsByTagName() {
                return [];
              },
            };
          },
          createElementNS() {
            return {};
          },
          importNode() {
            return null;
          },
          location: {
            hash: "",
            host: "",
            hostname: "",
            href: "",
            origin: "",
            pathname: "",
            protocol: "",
            search: "",
          },
        };
        function getDocument() {
          const doc = typeof document !== "undefined" ? document : {};
          extend(doc, ssrDocument);
          return doc;
        }
        const ssrWindow = {
          document: ssrDocument,
          navigator: {
            userAgent: "",
          },
          location: {
            hash: "",
            host: "",
            hostname: "",
            href: "",
            origin: "",
            pathname: "",
            protocol: "",
            search: "",
          },
          history: {
            replaceState() {},
            pushState() {},
            go() {},
            back() {},
          },
          CustomEvent: function CustomEvent() {
            return this;
          },
          addEventListener() {},
          removeEventListener() {},
          getComputedStyle() {
            return {
              getPropertyValue() {
                return "";
              },
            };
          },
          Image() {},
          Date() {},
          screen: {},
          setTimeout() {},
          clearTimeout() {},
          matchMedia() {
            return {};
          },
          requestAnimationFrame(callback) {
            if (typeof setTimeout === "undefined") {
              callback();
              return null;
            }
            return setTimeout(callback, 0);
          },
          cancelAnimationFrame(id) {
            if (typeof setTimeout === "undefined") {
              return;
            }
            clearTimeout(id);
          },
        };
        function getWindow() {
          const win = typeof window !== "undefined" ? window : {};
          extend(win, ssrWindow);
          return win;
        }

        /***/
      },

    /***/ "./node_modules/swiper/shared/swiper-core.mjs":
      /*!****************************************************!*\
  !*** ./node_modules/swiper/shared/swiper-core.mjs ***!
  \****************************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ S: () => /* binding */ Swiper,
          /* harmony export */ d: () => /* binding */ defaults,
          /* harmony export */
        });
        /* harmony import */ var _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs"
          );
        /* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./utils.mjs */ "./node_modules/swiper/shared/utils.mjs"
          );

        let support;
        function calcSupport() {
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          const document = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
          return {
            smoothScroll:
              document.documentElement &&
              document.documentElement.style &&
              "scrollBehavior" in document.documentElement.style,
            touch: !!(
              "ontouchstart" in window ||
              (window.DocumentTouch && document instanceof window.DocumentTouch)
            ),
          };
        }
        function getSupport() {
          if (!support) {
            support = calcSupport();
          }
          return support;
        }

        let deviceCached;
        function calcDevice(_temp) {
          let { userAgent } = _temp === void 0 ? {} : _temp;
          const support = getSupport();
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          const platform = window.navigator.platform;
          const ua = userAgent || window.navigator.userAgent;
          const device = {
            ios: false,
            android: false,
          };
          const screenWidth = window.screen.width;
          const screenHeight = window.screen.height;
          const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
          let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
          const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
          const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
          const windows = platform === "Win32";
          let macos = platform === "MacIntel";

          // iPadOs 13 fix
          const iPadScreens = [
            "1024x1366",
            "1366x1024",
            "834x1194",
            "1194x834",
            "834x1112",
            "1112x834",
            "768x1024",
            "1024x768",
            "820x1180",
            "1180x820",
            "810x1080",
            "1080x810",
          ];
          if (
            !ipad &&
            macos &&
            support.touch &&
            iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0
          ) {
            ipad = ua.match(/(Version)\/([\d.]+)/);
            if (!ipad) ipad = [0, 1, "13_0_0"];
            macos = false;
          }

          // Android
          if (android && !windows) {
            device.os = "android";
            device.android = true;
          }
          if (ipad || iphone || ipod) {
            device.os = "ios";
            device.ios = true;
          }

          // Export object
          return device;
        }
        function getDevice(overrides) {
          if (overrides === void 0) {
            overrides = {};
          }
          if (!deviceCached) {
            deviceCached = calcDevice(overrides);
          }
          return deviceCached;
        }

        let browser;
        function calcBrowser() {
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          let needPerspectiveFix = false;
          function isSafari() {
            const ua = window.navigator.userAgent.toLowerCase();
            return (
              ua.indexOf("safari") >= 0 &&
              ua.indexOf("chrome") < 0 &&
              ua.indexOf("android") < 0
            );
          }
          if (isSafari()) {
            const ua = String(window.navigator.userAgent);
            if (ua.includes("Version/")) {
              const [major, minor] = ua
                .split("Version/")[1]
                .split(" ")[0]
                .split(".")
                .map((num) => Number(num));
              needPerspectiveFix = major < 16 || (major === 16 && minor < 2);
            }
          }
          return {
            isSafari: needPerspectiveFix || isSafari(),
            needPerspectiveFix,
            isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
              window.navigator.userAgent
            ),
          };
        }
        function getBrowser() {
          if (!browser) {
            browser = calcBrowser();
          }
          return browser;
        }

        function Resize(_ref) {
          let { swiper, on, emit } = _ref;
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          let observer = null;
          let animationFrame = null;
          const resizeHandler = () => {
            if (!swiper || swiper.destroyed || !swiper.initialized) return;
            emit("beforeResize");
            emit("resize");
          };
          const createObserver = () => {
            if (!swiper || swiper.destroyed || !swiper.initialized) return;
            observer = new ResizeObserver((entries) => {
              animationFrame = window.requestAnimationFrame(() => {
                const { width, height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2) => {
                  let { contentBoxSize, contentRect, target } = _ref2;
                  if (target && target !== swiper.el) return;
                  newWidth = contentRect
                    ? contentRect.width
                    : (contentBoxSize[0] || contentBoxSize).inlineSize;
                  newHeight = contentRect
                    ? contentRect.height
                    : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) {
                  resizeHandler();
                }
              });
            });
            observer.observe(swiper.el);
          };
          const removeObserver = () => {
            if (animationFrame) {
              window.cancelAnimationFrame(animationFrame);
            }
            if (observer && observer.unobserve && swiper.el) {
              observer.unobserve(swiper.el);
              observer = null;
            }
          };
          const orientationChangeHandler = () => {
            if (!swiper || swiper.destroyed || !swiper.initialized) return;
            emit("orientationchange");
          };
          on("init", () => {
            if (
              swiper.params.resizeObserver &&
              typeof window.ResizeObserver !== "undefined"
            ) {
              createObserver();
              return;
            }
            window.addEventListener("resize", resizeHandler);
            window.addEventListener(
              "orientationchange",
              orientationChangeHandler
            );
          });
          on("destroy", () => {
            removeObserver();
            window.removeEventListener("resize", resizeHandler);
            window.removeEventListener(
              "orientationchange",
              orientationChangeHandler
            );
          });
        }

        function Observer(_ref) {
          let { swiper, extendParams, on, emit } = _ref;
          const observers = [];
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          const attach = function (target, options) {
            if (options === void 0) {
              options = {};
            }
            const ObserverFunc =
              window.MutationObserver || window.WebkitMutationObserver;
            const observer = new ObserverFunc((mutations) => {
              // The observerUpdate event should only be triggered
              // once despite the number of mutations.  Additional
              // triggers are redundant and are very costly
              if (swiper.__preventObserver__) return;
              if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
              }
              const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
              };
              if (window.requestAnimationFrame) {
                window.requestAnimationFrame(observerUpdate);
              } else {
                window.setTimeout(observerUpdate, 0);
              }
            });
            observer.observe(target, {
              attributes:
                typeof options.attributes === "undefined"
                  ? true
                  : options.attributes,
              childList:
                typeof options.childList === "undefined"
                  ? true
                  : options.childList,
              characterData:
                typeof options.characterData === "undefined"
                  ? true
                  : options.characterData,
            });
            observers.push(observer);
          };
          const init = () => {
            if (!swiper.params.observer) return;
            if (swiper.params.observeParents) {
              const containerParents = (0,
              _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(swiper.hostEl);
              for (let i = 0; i < containerParents.length; i += 1) {
                attach(containerParents[i]);
              }
            }
            // Observe container
            attach(swiper.hostEl, {
              childList: swiper.params.observeSlideChildren,
            });

            // Observe wrapper
            attach(swiper.wrapperEl, {
              attributes: false,
            });
          };
          const destroy = () => {
            observers.forEach((observer) => {
              observer.disconnect();
            });
            observers.splice(0, observers.length);
          };
          extendParams({
            observer: false,
            observeParents: false,
            observeSlideChildren: false,
          });
          on("init", init);
          on("destroy", destroy);
        }

        /* eslint-disable no-underscore-dangle */

        var eventsEmitter = {
          on(events, handler, priority) {
            const self = this;
            if (!self.eventsListeners || self.destroyed) return self;
            if (typeof handler !== "function") return self;
            const method = priority ? "unshift" : "push";
            events.split(" ").forEach((event) => {
              if (!self.eventsListeners[event])
                self.eventsListeners[event] = [];
              self.eventsListeners[event][method](handler);
            });
            return self;
          },
          once(events, handler, priority) {
            const self = this;
            if (!self.eventsListeners || self.destroyed) return self;
            if (typeof handler !== "function") return self;
            function onceHandler() {
              self.off(events, onceHandler);
              if (onceHandler.__emitterProxy) {
                delete onceHandler.__emitterProxy;
              }
              for (
                var _len = arguments.length, args = new Array(_len), _key = 0;
                _key < _len;
                _key++
              ) {
                args[_key] = arguments[_key];
              }
              handler.apply(self, args);
            }
            onceHandler.__emitterProxy = handler;
            return self.on(events, onceHandler, priority);
          },
          onAny(handler, priority) {
            const self = this;
            if (!self.eventsListeners || self.destroyed) return self;
            if (typeof handler !== "function") return self;
            const method = priority ? "unshift" : "push";
            if (self.eventsAnyListeners.indexOf(handler) < 0) {
              self.eventsAnyListeners[method](handler);
            }
            return self;
          },
          offAny(handler) {
            const self = this;
            if (!self.eventsListeners || self.destroyed) return self;
            if (!self.eventsAnyListeners) return self;
            const index = self.eventsAnyListeners.indexOf(handler);
            if (index >= 0) {
              self.eventsAnyListeners.splice(index, 1);
            }
            return self;
          },
          off(events, handler) {
            const self = this;
            if (!self.eventsListeners || self.destroyed) return self;
            if (!self.eventsListeners) return self;
            events.split(" ").forEach((event) => {
              if (typeof handler === "undefined") {
                self.eventsListeners[event] = [];
              } else if (self.eventsListeners[event]) {
                self.eventsListeners[event].forEach((eventHandler, index) => {
                  if (
                    eventHandler === handler ||
                    (eventHandler.__emitterProxy &&
                      eventHandler.__emitterProxy === handler)
                  ) {
                    self.eventsListeners[event].splice(index, 1);
                  }
                });
              }
            });
            return self;
          },
          emit() {
            const self = this;
            if (!self.eventsListeners || self.destroyed) return self;
            if (!self.eventsListeners) return self;
            let events;
            let data;
            let context;
            for (
              var _len2 = arguments.length, args = new Array(_len2), _key2 = 0;
              _key2 < _len2;
              _key2++
            ) {
              args[_key2] = arguments[_key2];
            }
            if (typeof args[0] === "string" || Array.isArray(args[0])) {
              events = args[0];
              data = args.slice(1, args.length);
              context = self;
            } else {
              events = args[0].events;
              data = args[0].data;
              context = args[0].context || self;
            }
            data.unshift(context);
            const eventsArray = Array.isArray(events)
              ? events
              : events.split(" ");
            eventsArray.forEach((event) => {
              if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
                self.eventsAnyListeners.forEach((eventHandler) => {
                  eventHandler.apply(context, [event, ...data]);
                });
              }
              if (self.eventsListeners && self.eventsListeners[event]) {
                self.eventsListeners[event].forEach((eventHandler) => {
                  eventHandler.apply(context, data);
                });
              }
            });
            return self;
          },
        };

        function updateSize() {
          const swiper = this;
          let width;
          let height;
          const el = swiper.el;
          if (
            typeof swiper.params.width !== "undefined" &&
            swiper.params.width !== null
          ) {
            width = swiper.params.width;
          } else {
            width = el.clientWidth;
          }
          if (
            typeof swiper.params.height !== "undefined" &&
            swiper.params.height !== null
          ) {
            height = swiper.params.height;
          } else {
            height = el.clientHeight;
          }
          if (
            (width === 0 && swiper.isHorizontal()) ||
            (height === 0 && swiper.isVertical())
          ) {
            return;
          }

          // Subtract paddings
          width =
            width -
            parseInt(
              (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.l)(
                el,
                "padding-left"
              ) || 0,
              10
            ) -
            parseInt(
              (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.l)(
                el,
                "padding-right"
              ) || 0,
              10
            );
          height =
            height -
            parseInt(
              (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.l)(
                el,
                "padding-top"
              ) || 0,
              10
            ) -
            parseInt(
              (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.l)(
                el,
                "padding-bottom"
              ) || 0,
              10
            );
          if (Number.isNaN(width)) width = 0;
          if (Number.isNaN(height)) height = 0;
          Object.assign(swiper, {
            width,
            height,
            size: swiper.isHorizontal() ? width : height,
          });
        }

        function updateSlides() {
          const swiper = this;
          function getDirectionLabel(property) {
            if (swiper.isHorizontal()) {
              return property;
            }
            // prettier-ignore
            return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
          }
          function getDirectionPropertyValue(node, label) {
            return parseFloat(
              node.getPropertyValue(getDirectionLabel(label)) || 0
            );
          }
          const params = swiper.params;
          const {
            wrapperEl,
            slidesEl,
            size: swiperSize,
            rtlTranslate: rtl,
            wrongRTL,
          } = swiper;
          const isVirtual = swiper.virtual && params.virtual.enabled;
          const previousSlidesLength = isVirtual
            ? swiper.virtual.slides.length
            : swiper.slides.length;
          const slides = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
            slidesEl,
            `.${swiper.params.slideClass}, swiper-slide`
          );
          const slidesLength = isVirtual
            ? swiper.virtual.slides.length
            : slides.length;
          let snapGrid = [];
          const slidesGrid = [];
          const slidesSizesGrid = [];
          let offsetBefore = params.slidesOffsetBefore;
          if (typeof offsetBefore === "function") {
            offsetBefore = params.slidesOffsetBefore.call(swiper);
          }
          let offsetAfter = params.slidesOffsetAfter;
          if (typeof offsetAfter === "function") {
            offsetAfter = params.slidesOffsetAfter.call(swiper);
          }
          const previousSnapGridLength = swiper.snapGrid.length;
          const previousSlidesGridLength = swiper.slidesGrid.length;
          let spaceBetween = params.spaceBetween;
          let slidePosition = -offsetBefore;
          let prevSlideSize = 0;
          let index = 0;
          if (typeof swiperSize === "undefined") {
            return;
          }
          if (
            typeof spaceBetween === "string" &&
            spaceBetween.indexOf("%") >= 0
          ) {
            spaceBetween =
              (parseFloat(spaceBetween.replace("%", "")) / 100) * swiperSize;
          } else if (typeof spaceBetween === "string") {
            spaceBetween = parseFloat(spaceBetween);
          }
          swiper.virtualSize = -spaceBetween;

          // reset margins
          slides.forEach((slideEl) => {
            if (rtl) {
              slideEl.style.marginLeft = "";
            } else {
              slideEl.style.marginRight = "";
            }
            slideEl.style.marginBottom = "";
            slideEl.style.marginTop = "";
          });

          // reset cssMode offsets
          if (params.centeredSlides && params.cssMode) {
            (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(
              wrapperEl,
              "--swiper-centered-offset-before",
              ""
            );
            (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(
              wrapperEl,
              "--swiper-centered-offset-after",
              ""
            );
          }
          const gridEnabled =
            params.grid && params.grid.rows > 1 && swiper.grid;
          if (gridEnabled) {
            swiper.grid.initSlides(slidesLength);
          }

          // Calc slides
          let slideSize;
          const shouldResetSlideSize =
            params.slidesPerView === "auto" &&
            params.breakpoints &&
            Object.keys(params.breakpoints).filter((key) => {
              return (
                typeof params.breakpoints[key].slidesPerView !== "undefined"
              );
            }).length > 0;
          for (let i = 0; i < slidesLength; i += 1) {
            slideSize = 0;
            let slide;
            if (slides[i]) slide = slides[i];
            if (gridEnabled) {
              swiper.grid.updateSlide(
                i,
                slide,
                slidesLength,
                getDirectionLabel
              );
            }
            if (
              slides[i] &&
              (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.l)(
                slide,
                "display"
              ) === "none"
            )
              continue; // eslint-disable-line

            if (params.slidesPerView === "auto") {
              if (shouldResetSlideSize) {
                slides[i].style[getDirectionLabel("width")] = ``;
              }
              const slideStyles = getComputedStyle(slide);
              const currentTransform = slide.style.transform;
              const currentWebKitTransform = slide.style.webkitTransform;
              if (currentTransform) {
                slide.style.transform = "none";
              }
              if (currentWebKitTransform) {
                slide.style.webkitTransform = "none";
              }
              if (params.roundLengths) {
                slideSize = swiper.isHorizontal()
                  ? (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)(
                      slide,
                      "width",
                      true
                    )
                  : (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)(
                      slide,
                      "height",
                      true
                    );
              } else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(
                  slideStyles,
                  "padding-left"
                );
                const paddingRight = getDirectionPropertyValue(
                  slideStyles,
                  "padding-right"
                );
                const marginLeft = getDirectionPropertyValue(
                  slideStyles,
                  "margin-left"
                );
                const marginRight = getDirectionPropertyValue(
                  slideStyles,
                  "margin-right"
                );
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") {
                  slideSize = width + marginLeft + marginRight;
                } else {
                  const { clientWidth, offsetWidth } = slide;
                  slideSize =
                    width +
                    paddingLeft +
                    paddingRight +
                    marginLeft +
                    marginRight +
                    (offsetWidth - clientWidth);
                }
              }
              if (currentTransform) {
                slide.style.transform = currentTransform;
              }
              if (currentWebKitTransform) {
                slide.style.webkitTransform = currentWebKitTransform;
              }
              if (params.roundLengths) slideSize = Math.floor(slideSize);
            } else {
              slideSize =
                (swiperSize - (params.slidesPerView - 1) * spaceBetween) /
                params.slidesPerView;
              if (params.roundLengths) slideSize = Math.floor(slideSize);
              if (slides[i]) {
                slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
              }
            }
            if (slides[i]) {
              slides[i].swiperSlideSize = slideSize;
            }
            slidesSizesGrid.push(slideSize);
            if (params.centeredSlides) {
              slidePosition =
                slidePosition +
                slideSize / 2 +
                prevSlideSize / 2 +
                spaceBetween;
              if (prevSlideSize === 0 && i !== 0)
                slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
              if (i === 0)
                slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
              if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
              if (params.roundLengths)
                slidePosition = Math.floor(slidePosition);
              if (index % params.slidesPerGroup === 0)
                snapGrid.push(slidePosition);
              slidesGrid.push(slidePosition);
            } else {
              if (params.roundLengths)
                slidePosition = Math.floor(slidePosition);
              if (
                (index - Math.min(swiper.params.slidesPerGroupSkip, index)) %
                  swiper.params.slidesPerGroup ===
                0
              )
                snapGrid.push(slidePosition);
              slidesGrid.push(slidePosition);
              slidePosition = slidePosition + slideSize + spaceBetween;
            }
            swiper.virtualSize += slideSize + spaceBetween;
            prevSlideSize = slideSize;
            index += 1;
          }
          swiper.virtualSize =
            Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
          if (
            rtl &&
            wrongRTL &&
            (params.effect === "slide" || params.effect === "coverflow")
          ) {
            wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
          }
          if (params.setWrapperSize) {
            wrapperEl.style[getDirectionLabel("width")] = `${
              swiper.virtualSize + spaceBetween
            }px`;
          }
          if (gridEnabled) {
            swiper.grid.updateWrapperSize(
              slideSize,
              snapGrid,
              getDirectionLabel
            );
          }

          // Remove last grid elements depending on width
          if (!params.centeredSlides) {
            const newSlidesGrid = [];
            for (let i = 0; i < snapGrid.length; i += 1) {
              let slidesGridItem = snapGrid[i];
              if (params.roundLengths)
                slidesGridItem = Math.floor(slidesGridItem);
              if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
                newSlidesGrid.push(slidesGridItem);
              }
            }
            snapGrid = newSlidesGrid;
            if (
              Math.floor(swiper.virtualSize - swiperSize) -
                Math.floor(snapGrid[snapGrid.length - 1]) >
              1
            ) {
              snapGrid.push(swiper.virtualSize - swiperSize);
            }
          }
          if (isVirtual && params.loop) {
            const size = slidesSizesGrid[0] + spaceBetween;
            if (params.slidesPerGroup > 1) {
              const groups = Math.ceil(
                (swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) /
                  params.slidesPerGroup
              );
              const groupSize = size * params.slidesPerGroup;
              for (let i = 0; i < groups; i += 1) {
                snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
              }
            }
            for (
              let i = 0;
              i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter;
              i += 1
            ) {
              if (params.slidesPerGroup === 1) {
                snapGrid.push(snapGrid[snapGrid.length - 1] + size);
              }
              slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
              swiper.virtualSize += size;
            }
          }
          if (snapGrid.length === 0) snapGrid = [0];
          if (spaceBetween !== 0) {
            const key =
              swiper.isHorizontal() && rtl
                ? "marginLeft"
                : getDirectionLabel("marginRight");
            slides
              .filter((_, slideIndex) => {
                if (!params.cssMode || params.loop) return true;
                if (slideIndex === slides.length - 1) {
                  return false;
                }
                return true;
              })
              .forEach((slideEl) => {
                slideEl.style[key] = `${spaceBetween}px`;
              });
          }
          if (params.centeredSlides && params.centeredSlidesBounds) {
            let allSlidesSize = 0;
            slidesSizesGrid.forEach((slideSizeValue) => {
              allSlidesSize += slideSizeValue + (spaceBetween || 0);
            });
            allSlidesSize -= spaceBetween;
            const maxSnap = allSlidesSize - swiperSize;
            snapGrid = snapGrid.map((snap) => {
              if (snap <= 0) return -offsetBefore;
              if (snap > maxSnap) return maxSnap + offsetAfter;
              return snap;
            });
          }
          if (params.centerInsufficientSlides) {
            let allSlidesSize = 0;
            slidesSizesGrid.forEach((slideSizeValue) => {
              allSlidesSize += slideSizeValue + (spaceBetween || 0);
            });
            allSlidesSize -= spaceBetween;
            if (allSlidesSize < swiperSize) {
              const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
              snapGrid.forEach((snap, snapIndex) => {
                snapGrid[snapIndex] = snap - allSlidesOffset;
              });
              slidesGrid.forEach((snap, snapIndex) => {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
              });
            }
          }
          Object.assign(swiper, {
            slides,
            snapGrid,
            slidesGrid,
            slidesSizesGrid,
          });
          if (
            params.centeredSlides &&
            params.cssMode &&
            !params.centeredSlidesBounds
          ) {
            (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(
              wrapperEl,
              "--swiper-centered-offset-before",
              `${-snapGrid[0]}px`
            );
            (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(
              wrapperEl,
              "--swiper-centered-offset-after",
              `${
                swiper.size / 2 -
                slidesSizesGrid[slidesSizesGrid.length - 1] / 2
              }px`
            );
            const addToSnapGrid = -swiper.snapGrid[0];
            const addToSlidesGrid = -swiper.slidesGrid[0];
            swiper.snapGrid = swiper.snapGrid.map((v) => v + addToSnapGrid);
            swiper.slidesGrid = swiper.slidesGrid.map(
              (v) => v + addToSlidesGrid
            );
          }
          if (slidesLength !== previousSlidesLength) {
            swiper.emit("slidesLengthChange");
          }
          if (snapGrid.length !== previousSnapGridLength) {
            if (swiper.params.watchOverflow) swiper.checkOverflow();
            swiper.emit("snapGridLengthChange");
          }
          if (slidesGrid.length !== previousSlidesGridLength) {
            swiper.emit("slidesGridLengthChange");
          }
          if (params.watchSlidesProgress) {
            swiper.updateSlidesOffset();
          }
          if (
            !isVirtual &&
            !params.cssMode &&
            (params.effect === "slide" || params.effect === "fade")
          ) {
            const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
            const hasClassBackfaceClassAdded =
              swiper.el.classList.contains(backFaceHiddenClass);
            if (slidesLength <= params.maxBackfaceHiddenSlides) {
              if (!hasClassBackfaceClassAdded)
                swiper.el.classList.add(backFaceHiddenClass);
            } else if (hasClassBackfaceClassAdded) {
              swiper.el.classList.remove(backFaceHiddenClass);
            }
          }
        }

        function updateAutoHeight(speed) {
          const swiper = this;
          const activeSlides = [];
          const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
          let newHeight = 0;
          let i;
          if (typeof speed === "number") {
            swiper.setTransition(speed);
          } else if (speed === true) {
            swiper.setTransition(swiper.params.speed);
          }
          const getSlideByIndex = (index) => {
            if (isVirtual) {
              return swiper.slides[swiper.getSlideIndexByData(index)];
            }
            return swiper.slides[index];
          };
          // Find slides currently in view
          if (
            swiper.params.slidesPerView !== "auto" &&
            swiper.params.slidesPerView > 1
          ) {
            if (swiper.params.centeredSlides) {
              (swiper.visibleSlides || []).forEach((slide) => {
                activeSlides.push(slide);
              });
            } else {
              for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
                const index = swiper.activeIndex + i;
                if (index > swiper.slides.length && !isVirtual) break;
                activeSlides.push(getSlideByIndex(index));
              }
            }
          } else {
            activeSlides.push(getSlideByIndex(swiper.activeIndex));
          }

          // Find new height from highest slide in view
          for (i = 0; i < activeSlides.length; i += 1) {
            if (typeof activeSlides[i] !== "undefined") {
              const height = activeSlides[i].offsetHeight;
              newHeight = height > newHeight ? height : newHeight;
            }
          }

          // Update Height
          if (newHeight || newHeight === 0)
            swiper.wrapperEl.style.height = `${newHeight}px`;
        }

        function updateSlidesOffset() {
          const swiper = this;
          const slides = swiper.slides;
          // eslint-disable-next-line
          const minusOffset = swiper.isElement
            ? swiper.isHorizontal()
              ? swiper.wrapperEl.offsetLeft
              : swiper.wrapperEl.offsetTop
            : 0;
          for (let i = 0; i < slides.length; i += 1) {
            slides[i].swiperSlideOffset =
              (swiper.isHorizontal()
                ? slides[i].offsetLeft
                : slides[i].offsetTop) -
              minusOffset -
              swiper.cssOverflowAdjustment();
          }
        }

        function updateSlidesProgress(translate) {
          if (translate === void 0) {
            translate = (this && this.translate) || 0;
          }
          const swiper = this;
          const params = swiper.params;
          const { slides, rtlTranslate: rtl, snapGrid } = swiper;
          if (slides.length === 0) return;
          if (typeof slides[0].swiperSlideOffset === "undefined")
            swiper.updateSlidesOffset();
          let offsetCenter = -translate;
          if (rtl) offsetCenter = translate;

          // Visible Slides
          slides.forEach((slideEl) => {
            slideEl.classList.remove(params.slideVisibleClass);
          });
          swiper.visibleSlidesIndexes = [];
          swiper.visibleSlides = [];
          let spaceBetween = params.spaceBetween;
          if (
            typeof spaceBetween === "string" &&
            spaceBetween.indexOf("%") >= 0
          ) {
            spaceBetween =
              (parseFloat(spaceBetween.replace("%", "")) / 100) * swiper.size;
          } else if (typeof spaceBetween === "string") {
            spaceBetween = parseFloat(spaceBetween);
          }
          for (let i = 0; i < slides.length; i += 1) {
            const slide = slides[i];
            let slideOffset = slide.swiperSlideOffset;
            if (params.cssMode && params.centeredSlides) {
              slideOffset -= slides[0].swiperSlideOffset;
            }
            const slideProgress =
              (offsetCenter +
                (params.centeredSlides ? swiper.minTranslate() : 0) -
                slideOffset) /
              (slide.swiperSlideSize + spaceBetween);
            const originalSlideProgress =
              (offsetCenter -
                snapGrid[0] +
                (params.centeredSlides ? swiper.minTranslate() : 0) -
                slideOffset) /
              (slide.swiperSlideSize + spaceBetween);
            const slideBefore = -(offsetCenter - slideOffset);
            const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
            const isVisible =
              (slideBefore >= 0 && slideBefore < swiper.size - 1) ||
              (slideAfter > 1 && slideAfter <= swiper.size) ||
              (slideBefore <= 0 && slideAfter >= swiper.size);
            if (isVisible) {
              swiper.visibleSlides.push(slide);
              swiper.visibleSlidesIndexes.push(i);
              slides[i].classList.add(params.slideVisibleClass);
            }
            slide.progress = rtl ? -slideProgress : slideProgress;
            slide.originalProgress = rtl
              ? -originalSlideProgress
              : originalSlideProgress;
          }
        }

        function updateProgress(translate) {
          const swiper = this;
          if (typeof translate === "undefined") {
            const multiplier = swiper.rtlTranslate ? -1 : 1;
            // eslint-disable-next-line
            translate =
              (swiper && swiper.translate && swiper.translate * multiplier) ||
              0;
          }
          const params = swiper.params;
          const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
          let { progress, isBeginning, isEnd, progressLoop } = swiper;
          const wasBeginning = isBeginning;
          const wasEnd = isEnd;
          if (translatesDiff === 0) {
            progress = 0;
            isBeginning = true;
            isEnd = true;
          } else {
            progress = (translate - swiper.minTranslate()) / translatesDiff;
            const isBeginningRounded =
              Math.abs(translate - swiper.minTranslate()) < 1;
            const isEndRounded =
              Math.abs(translate - swiper.maxTranslate()) < 1;
            isBeginning = isBeginningRounded || progress <= 0;
            isEnd = isEndRounded || progress >= 1;
            if (isBeginningRounded) progress = 0;
            if (isEndRounded) progress = 1;
          }
          if (params.loop) {
            const firstSlideIndex = swiper.getSlideIndexByData(0);
            const lastSlideIndex = swiper.getSlideIndexByData(
              swiper.slides.length - 1
            );
            const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
            const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
            const translateMax =
              swiper.slidesGrid[swiper.slidesGrid.length - 1];
            const translateAbs = Math.abs(translate);
            if (translateAbs >= firstSlideTranslate) {
              progressLoop =
                (translateAbs - firstSlideTranslate) / translateMax;
            } else {
              progressLoop =
                (translateAbs + translateMax - lastSlideTranslate) /
                translateMax;
            }
            if (progressLoop > 1) progressLoop -= 1;
          }
          Object.assign(swiper, {
            progress,
            progressLoop,
            isBeginning,
            isEnd,
          });
          if (
            params.watchSlidesProgress ||
            (params.centeredSlides && params.autoHeight)
          )
            swiper.updateSlidesProgress(translate);
          if (isBeginning && !wasBeginning) {
            swiper.emit("reachBeginning toEdge");
          }
          if (isEnd && !wasEnd) {
            swiper.emit("reachEnd toEdge");
          }
          if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
            swiper.emit("fromEdge");
          }
          swiper.emit("progress", progress);
        }

        function updateSlidesClasses() {
          const swiper = this;
          const { slides, params, slidesEl, activeIndex } = swiper;
          const isVirtual = swiper.virtual && params.virtual.enabled;
          const getFilteredSlide = (selector) => {
            return (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
              slidesEl,
              `.${params.slideClass}${selector}, swiper-slide${selector}`
            )[0];
          };
          slides.forEach((slideEl) => {
            slideEl.classList.remove(
              params.slideActiveClass,
              params.slideNextClass,
              params.slidePrevClass
            );
          });
          let activeSlide;
          if (isVirtual) {
            if (params.loop) {
              let slideIndex = activeIndex - swiper.virtual.slidesBefore;
              if (slideIndex < 0)
                slideIndex = swiper.virtual.slides.length + slideIndex;
              if (slideIndex >= swiper.virtual.slides.length)
                slideIndex -= swiper.virtual.slides.length;
              activeSlide = getFilteredSlide(
                `[data-swiper-slide-index="${slideIndex}"]`
              );
            } else {
              activeSlide = getFilteredSlide(
                `[data-swiper-slide-index="${activeIndex}"]`
              );
            }
          } else {
            activeSlide = slides[activeIndex];
          }
          if (activeSlide) {
            // Active classes
            activeSlide.classList.add(params.slideActiveClass);

            // Next Slide
            let nextSlide = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(
              activeSlide,
              `.${params.slideClass}, swiper-slide`
            )[0];
            if (params.loop && !nextSlide) {
              nextSlide = slides[0];
            }
            if (nextSlide) {
              nextSlide.classList.add(params.slideNextClass);
            }
            // Prev Slide
            let prevSlide = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.o)(
              activeSlide,
              `.${params.slideClass}, swiper-slide`
            )[0];
            if (params.loop && !prevSlide === 0) {
              prevSlide = slides[slides.length - 1];
            }
            if (prevSlide) {
              prevSlide.classList.add(params.slidePrevClass);
            }
          }
          swiper.emitSlidesClasses();
        }

        const processLazyPreloader = (swiper, imageEl) => {
          if (!swiper || swiper.destroyed || !swiper.params) return;
          const slideSelector = () =>
            swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
          const slideEl = imageEl.closest(slideSelector());
          if (slideEl) {
            let lazyEl = slideEl.querySelector(
              `.${swiper.params.lazyPreloaderClass}`
            );
            if (!lazyEl && swiper.isElement) {
              if (slideEl.shadowRoot) {
                lazyEl = slideEl.shadowRoot.querySelector(
                  `.${swiper.params.lazyPreloaderClass}`
                );
              } else {
                // init later
                requestAnimationFrame(() => {
                  if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(
                      `.${swiper.params.lazyPreloaderClass}`
                    );
                    if (lazyEl) lazyEl.remove();
                  }
                });
              }
            }
            if (lazyEl) lazyEl.remove();
          }
        };
        const unlazy = (swiper, index) => {
          if (!swiper.slides[index]) return;
          const imageEl =
            swiper.slides[index].querySelector('[loading="lazy"]');
          if (imageEl) imageEl.removeAttribute("loading");
        };
        const preload = (swiper) => {
          if (!swiper || swiper.destroyed || !swiper.params) return;
          let amount = swiper.params.lazyPreloadPrevNext;
          const len = swiper.slides.length;
          if (!len || !amount || amount < 0) return;
          amount = Math.min(amount, len);
          const slidesPerView =
            swiper.params.slidesPerView === "auto"
              ? swiper.slidesPerViewDynamic()
              : Math.ceil(swiper.params.slidesPerView);
          const activeIndex = swiper.activeIndex;
          if (swiper.params.grid && swiper.params.grid.rows > 1) {
            const activeColumn = activeIndex;
            const preloadColumns = [activeColumn - amount];
            preloadColumns.push(
              ...Array.from({
                length: amount,
              }).map((_, i) => {
                return activeColumn + slidesPerView + i;
              })
            );
            swiper.slides.forEach((slideEl, i) => {
              if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
            });
            return;
          }
          const slideIndexLastInView = activeIndex + slidesPerView - 1;
          if (swiper.params.rewind || swiper.params.loop) {
            for (
              let i = activeIndex - amount;
              i <= slideIndexLastInView + amount;
              i += 1
            ) {
              const realIndex = ((i % len) + len) % len;
              if (realIndex < activeIndex || realIndex > slideIndexLastInView)
                unlazy(swiper, realIndex);
            }
          } else {
            for (
              let i = Math.max(activeIndex - amount, 0);
              i <= Math.min(slideIndexLastInView + amount, len - 1);
              i += 1
            ) {
              if (
                i !== activeIndex &&
                (i > slideIndexLastInView || i < activeIndex)
              ) {
                unlazy(swiper, i);
              }
            }
          }
        };

        function getActiveIndexByTranslate(swiper) {
          const { slidesGrid, params } = swiper;
          const translate = swiper.rtlTranslate
            ? swiper.translate
            : -swiper.translate;
          let activeIndex;
          for (let i = 0; i < slidesGrid.length; i += 1) {
            if (typeof slidesGrid[i + 1] !== "undefined") {
              if (
                translate >= slidesGrid[i] &&
                translate <
                  slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2
              ) {
                activeIndex = i;
              } else if (
                translate >= slidesGrid[i] &&
                translate < slidesGrid[i + 1]
              ) {
                activeIndex = i + 1;
              }
            } else if (translate >= slidesGrid[i]) {
              activeIndex = i;
            }
          }
          // Normalize slideIndex
          if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === "undefined")
              activeIndex = 0;
          }
          return activeIndex;
        }
        function updateActiveIndex(newActiveIndex) {
          const swiper = this;
          const translate = swiper.rtlTranslate
            ? swiper.translate
            : -swiper.translate;
          const {
            snapGrid,
            params,
            activeIndex: previousIndex,
            realIndex: previousRealIndex,
            snapIndex: previousSnapIndex,
          } = swiper;
          let activeIndex = newActiveIndex;
          let snapIndex;
          const getVirtualRealIndex = (aIndex) => {
            let realIndex = aIndex - swiper.virtual.slidesBefore;
            if (realIndex < 0) {
              realIndex = swiper.virtual.slides.length + realIndex;
            }
            if (realIndex >= swiper.virtual.slides.length) {
              realIndex -= swiper.virtual.slides.length;
            }
            return realIndex;
          };
          if (typeof activeIndex === "undefined") {
            activeIndex = getActiveIndexByTranslate(swiper);
          }
          if (snapGrid.indexOf(translate) >= 0) {
            snapIndex = snapGrid.indexOf(translate);
          } else {
            const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
            snapIndex =
              skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
          }
          if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
          if (activeIndex === previousIndex) {
            if (snapIndex !== previousSnapIndex) {
              swiper.snapIndex = snapIndex;
              swiper.emit("snapIndexChange");
            }
            if (
              swiper.params.loop &&
              swiper.virtual &&
              swiper.params.virtual.enabled
            ) {
              swiper.realIndex = getVirtualRealIndex(activeIndex);
            }
            return;
          }
          // Get real index
          let realIndex;
          if (swiper.virtual && params.virtual.enabled && params.loop) {
            realIndex = getVirtualRealIndex(activeIndex);
          } else if (swiper.slides[activeIndex]) {
            realIndex = parseInt(
              swiper.slides[activeIndex].getAttribute(
                "data-swiper-slide-index"
              ) || activeIndex,
              10
            );
          } else {
            realIndex = activeIndex;
          }
          Object.assign(swiper, {
            previousSnapIndex,
            snapIndex,
            previousRealIndex,
            realIndex,
            previousIndex,
            activeIndex,
          });
          if (swiper.initialized) {
            preload(swiper);
          }
          swiper.emit("activeIndexChange");
          swiper.emit("snapIndexChange");
          if (swiper.initialized || swiper.params.runCallbacksOnInit) {
            if (previousRealIndex !== realIndex) {
              swiper.emit("realIndexChange");
            }
            swiper.emit("slideChange");
          }
        }

        function updateClickedSlide(el, path) {
          const swiper = this;
          const params = swiper.params;
          let slide = el.closest(`.${params.slideClass}, swiper-slide`);
          if (
            !slide &&
            swiper.isElement &&
            path &&
            path.length > 1 &&
            path.includes(el)
          ) {
            [...path.slice(path.indexOf(el) + 1, path.length)].forEach(
              (pathEl) => {
                if (
                  !slide &&
                  pathEl.matches &&
                  pathEl.matches(`.${params.slideClass}, swiper-slide`)
                ) {
                  slide = pathEl;
                }
              }
            );
          }
          let slideFound = false;
          let slideIndex;
          if (slide) {
            for (let i = 0; i < swiper.slides.length; i += 1) {
              if (swiper.slides[i] === slide) {
                slideFound = true;
                slideIndex = i;
                break;
              }
            }
          }
          if (slide && slideFound) {
            swiper.clickedSlide = slide;
            if (swiper.virtual && swiper.params.virtual.enabled) {
              swiper.clickedIndex = parseInt(
                slide.getAttribute("data-swiper-slide-index"),
                10
              );
            } else {
              swiper.clickedIndex = slideIndex;
            }
          } else {
            swiper.clickedSlide = undefined;
            swiper.clickedIndex = undefined;
            return;
          }
          if (
            params.slideToClickedSlide &&
            swiper.clickedIndex !== undefined &&
            swiper.clickedIndex !== swiper.activeIndex
          ) {
            swiper.slideToClickedSlide();
          }
        }

        var update = {
          updateSize,
          updateSlides,
          updateAutoHeight,
          updateSlidesOffset,
          updateSlidesProgress,
          updateProgress,
          updateSlidesClasses,
          updateActiveIndex,
          updateClickedSlide,
        };

        function getSwiperTranslate(axis) {
          if (axis === void 0) {
            axis = this.isHorizontal() ? "x" : "y";
          }
          const swiper = this;
          const { params, rtlTranslate: rtl, translate, wrapperEl } = swiper;
          if (params.virtualTranslate) {
            return rtl ? -translate : translate;
          }
          if (params.cssMode) {
            return translate;
          }
          let currentTranslate = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(
            wrapperEl,
            axis
          );
          currentTranslate += swiper.cssOverflowAdjustment();
          if (rtl) currentTranslate = -currentTranslate;
          return currentTranslate || 0;
        }

        function setTranslate(translate, byController) {
          const swiper = this;
          const { rtlTranslate: rtl, params, wrapperEl, progress } = swiper;
          let x = 0;
          let y = 0;
          const z = 0;
          if (swiper.isHorizontal()) {
            x = rtl ? -translate : translate;
          } else {
            y = translate;
          }
          if (params.roundLengths) {
            x = Math.floor(x);
            y = Math.floor(y);
          }
          swiper.previousTranslate = swiper.translate;
          swiper.translate = swiper.isHorizontal() ? x : y;
          if (params.cssMode) {
            wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] =
              swiper.isHorizontal() ? -x : -y;
          } else if (!params.virtualTranslate) {
            if (swiper.isHorizontal()) {
              x -= swiper.cssOverflowAdjustment();
            } else {
              y -= swiper.cssOverflowAdjustment();
            }
            wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
          }

          // Check if we need to update progress
          let newProgress;
          const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
          if (translatesDiff === 0) {
            newProgress = 0;
          } else {
            newProgress = (translate - swiper.minTranslate()) / translatesDiff;
          }
          if (newProgress !== progress) {
            swiper.updateProgress(translate);
          }
          swiper.emit("setTranslate", swiper.translate, byController);
        }

        function minTranslate() {
          return -this.snapGrid[0];
        }

        function maxTranslate() {
          return -this.snapGrid[this.snapGrid.length - 1];
        }

        function translateTo(
          translate,
          speed,
          runCallbacks,
          translateBounds,
          internal
        ) {
          if (translate === void 0) {
            translate = 0;
          }
          if (speed === void 0) {
            speed = this.params.speed;
          }
          if (runCallbacks === void 0) {
            runCallbacks = true;
          }
          if (translateBounds === void 0) {
            translateBounds = true;
          }
          const swiper = this;
          const { params, wrapperEl } = swiper;
          if (swiper.animating && params.preventInteractionOnTransition) {
            return false;
          }
          const minTranslate = swiper.minTranslate();
          const maxTranslate = swiper.maxTranslate();
          let newTranslate;
          if (translateBounds && translate > minTranslate)
            newTranslate = minTranslate;
          else if (translateBounds && translate < maxTranslate)
            newTranslate = maxTranslate;
          else newTranslate = translate;

          // Update progress
          swiper.updateProgress(newTranslate);
          if (params.cssMode) {
            const isH = swiper.isHorizontal();
            if (speed === 0) {
              wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
            } else {
              if (!swiper.support.smoothScroll) {
                (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.p)({
                  swiper,
                  targetPosition: -newTranslate,
                  side: isH ? "left" : "top",
                });
                return true;
              }
              wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth",
              });
            }
            return true;
          }
          if (speed === 0) {
            swiper.setTransition(0);
            swiper.setTranslate(newTranslate);
            if (runCallbacks) {
              swiper.emit("beforeTransitionStart", speed, internal);
              swiper.emit("transitionEnd");
            }
          } else {
            swiper.setTransition(speed);
            swiper.setTranslate(newTranslate);
            if (runCallbacks) {
              swiper.emit("beforeTransitionStart", speed, internal);
              swiper.emit("transitionStart");
            }
            if (!swiper.animating) {
              swiper.animating = true;
              if (!swiper.onTranslateToWrapperTransitionEnd) {
                swiper.onTranslateToWrapperTransitionEnd =
                  function transitionEnd(e) {
                    if (!swiper || swiper.destroyed) return;
                    if (e.target !== this) return;
                    swiper.wrapperEl.removeEventListener(
                      "transitionend",
                      swiper.onTranslateToWrapperTransitionEnd
                    );
                    swiper.onTranslateToWrapperTransitionEnd = null;
                    delete swiper.onTranslateToWrapperTransitionEnd;
                    if (runCallbacks) {
                      swiper.emit("transitionEnd");
                    }
                  };
              }
              swiper.wrapperEl.addEventListener(
                "transitionend",
                swiper.onTranslateToWrapperTransitionEnd
              );
            }
          }
          return true;
        }

        var translate = {
          getTranslate: getSwiperTranslate,
          setTranslate,
          minTranslate,
          maxTranslate,
          translateTo,
        };

        function setTransition(duration, byController) {
          const swiper = this;
          if (!swiper.params.cssMode) {
            swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
            swiper.wrapperEl.style.transitionDelay =
              duration === 0 ? `0ms` : "";
          }
          swiper.emit("setTransition", duration, byController);
        }

        function transitionEmit(_ref) {
          let { swiper, runCallbacks, direction, step } = _ref;
          const { activeIndex, previousIndex } = swiper;
          let dir = direction;
          if (!dir) {
            if (activeIndex > previousIndex) dir = "next";
            else if (activeIndex < previousIndex) dir = "prev";
            else dir = "reset";
          }
          swiper.emit(`transition${step}`);
          if (runCallbacks && activeIndex !== previousIndex) {
            if (dir === "reset") {
              swiper.emit(`slideResetTransition${step}`);
              return;
            }
            swiper.emit(`slideChangeTransition${step}`);
            if (dir === "next") {
              swiper.emit(`slideNextTransition${step}`);
            } else {
              swiper.emit(`slidePrevTransition${step}`);
            }
          }
        }

        function transitionStart(runCallbacks, direction) {
          if (runCallbacks === void 0) {
            runCallbacks = true;
          }
          const swiper = this;
          const { params } = swiper;
          if (params.cssMode) return;
          if (params.autoHeight) {
            swiper.updateAutoHeight();
          }
          transitionEmit({
            swiper,
            runCallbacks,
            direction,
            step: "Start",
          });
        }

        function transitionEnd(runCallbacks, direction) {
          if (runCallbacks === void 0) {
            runCallbacks = true;
          }
          const swiper = this;
          const { params } = swiper;
          swiper.animating = false;
          if (params.cssMode) return;
          swiper.setTransition(0);
          transitionEmit({
            swiper,
            runCallbacks,
            direction,
            step: "End",
          });
        }

        var transition = {
          setTransition,
          transitionStart,
          transitionEnd,
        };

        function slideTo(index, speed, runCallbacks, internal, initial) {
          if (index === void 0) {
            index = 0;
          }
          if (speed === void 0) {
            speed = this.params.speed;
          }
          if (runCallbacks === void 0) {
            runCallbacks = true;
          }
          if (typeof index === "string") {
            index = parseInt(index, 10);
          }
          const swiper = this;
          let slideIndex = index;
          if (slideIndex < 0) slideIndex = 0;
          const {
            params,
            snapGrid,
            slidesGrid,
            previousIndex,
            activeIndex,
            rtlTranslate: rtl,
            wrapperEl,
            enabled,
          } = swiper;
          if (
            (swiper.animating && params.preventInteractionOnTransition) ||
            (!enabled && !internal && !initial)
          ) {
            return false;
          }
          const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
          let snapIndex =
            skip +
            Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
          if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
          const translate = -snapGrid[snapIndex];
          // Normalize slideIndex
          if (params.normalizeSlideIndex) {
            for (let i = 0; i < slidesGrid.length; i += 1) {
              const normalizedTranslate = -Math.floor(translate * 100);
              const normalizedGrid = Math.floor(slidesGrid[i] * 100);
              const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
              if (typeof slidesGrid[i + 1] !== "undefined") {
                if (
                  normalizedTranslate >= normalizedGrid &&
                  normalizedTranslate <
                    normalizedGridNext -
                      (normalizedGridNext - normalizedGrid) / 2
                ) {
                  slideIndex = i;
                } else if (
                  normalizedTranslate >= normalizedGrid &&
                  normalizedTranslate < normalizedGridNext
                ) {
                  slideIndex = i + 1;
                }
              } else if (normalizedTranslate >= normalizedGrid) {
                slideIndex = i;
              }
            }
          }
          // Directions locks
          if (swiper.initialized && slideIndex !== activeIndex) {
            if (
              !swiper.allowSlideNext &&
              (rtl
                ? translate > swiper.translate &&
                  translate > swiper.minTranslate()
                : translate < swiper.translate &&
                  translate < swiper.minTranslate())
            ) {
              return false;
            }
            if (
              !swiper.allowSlidePrev &&
              translate > swiper.translate &&
              translate > swiper.maxTranslate()
            ) {
              if ((activeIndex || 0) !== slideIndex) {
                return false;
              }
            }
          }
          if (slideIndex !== (previousIndex || 0) && runCallbacks) {
            swiper.emit("beforeSlideChangeStart");
          }

          // Update progress
          swiper.updateProgress(translate);
          let direction;
          if (slideIndex > activeIndex) direction = "next";
          else if (slideIndex < activeIndex) direction = "prev";
          else direction = "reset";

          // Update Index
          if (
            (rtl && -translate === swiper.translate) ||
            (!rtl && translate === swiper.translate)
          ) {
            swiper.updateActiveIndex(slideIndex);
            // Update Height
            if (params.autoHeight) {
              swiper.updateAutoHeight();
            }
            swiper.updateSlidesClasses();
            if (params.effect !== "slide") {
              swiper.setTranslate(translate);
            }
            if (direction !== "reset") {
              swiper.transitionStart(runCallbacks, direction);
              swiper.transitionEnd(runCallbacks, direction);
            }
            return false;
          }
          if (params.cssMode) {
            const isH = swiper.isHorizontal();
            const t = rtl ? translate : -translate;
            if (speed === 0) {
              const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
              if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
              }
              if (
                isVirtual &&
                !swiper._cssModeVirtualInitialSet &&
                swiper.params.initialSlide > 0
              ) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(() => {
                  wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
              } else {
                wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
              }
              if (isVirtual) {
                requestAnimationFrame(() => {
                  swiper.wrapperEl.style.scrollSnapType = "";
                  swiper._immediateVirtual = false;
                });
              }
            } else {
              if (!swiper.support.smoothScroll) {
                (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.p)({
                  swiper,
                  targetPosition: t,
                  side: isH ? "left" : "top",
                });
                return true;
              }
              wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth",
              });
            }
            return true;
          }
          swiper.setTransition(speed);
          swiper.setTranslate(translate);
          swiper.updateActiveIndex(slideIndex);
          swiper.updateSlidesClasses();
          swiper.emit("beforeTransitionStart", speed, internal);
          swiper.transitionStart(runCallbacks, direction);
          if (speed === 0) {
            swiper.transitionEnd(runCallbacks, direction);
          } else if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onSlideToWrapperTransitionEnd) {
              swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener(
                  "transitionend",
                  swiper.onSlideToWrapperTransitionEnd
                );
                swiper.onSlideToWrapperTransitionEnd = null;
                delete swiper.onSlideToWrapperTransitionEnd;
                swiper.transitionEnd(runCallbacks, direction);
              };
            }
            swiper.wrapperEl.addEventListener(
              "transitionend",
              swiper.onSlideToWrapperTransitionEnd
            );
          }
          return true;
        }

        function slideToLoop(index, speed, runCallbacks, internal) {
          if (index === void 0) {
            index = 0;
          }
          if (speed === void 0) {
            speed = this.params.speed;
          }
          if (runCallbacks === void 0) {
            runCallbacks = true;
          }
          if (typeof index === "string") {
            const indexAsNumber = parseInt(index, 10);
            index = indexAsNumber;
          }
          const swiper = this;
          let newIndex = index;
          if (swiper.params.loop) {
            if (swiper.virtual && swiper.params.virtual.enabled) {
              // eslint-disable-next-line
              newIndex = newIndex + swiper.virtual.slidesBefore;
            } else {
              newIndex = swiper.getSlideIndexByData(newIndex);
            }
          }
          return swiper.slideTo(newIndex, speed, runCallbacks, internal);
        }

        /* eslint no-unused-vars: "off" */
        function slideNext(speed, runCallbacks, internal) {
          if (speed === void 0) {
            speed = this.params.speed;
          }
          if (runCallbacks === void 0) {
            runCallbacks = true;
          }
          const swiper = this;
          const { enabled, params, animating } = swiper;
          if (!enabled) return swiper;
          let perGroup = params.slidesPerGroup;
          if (
            params.slidesPerView === "auto" &&
            params.slidesPerGroup === 1 &&
            params.slidesPerGroupAuto
          ) {
            perGroup = Math.max(
              swiper.slidesPerViewDynamic("current", true),
              1
            );
          }
          const increment =
            swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
          const isVirtual = swiper.virtual && params.virtual.enabled;
          if (params.loop) {
            if (animating && !isVirtual && params.loopPreventsSliding)
              return false;
            swiper.loopFix({
              direction: "next",
            });
            // eslint-disable-next-line
            swiper._clientLeft = swiper.wrapperEl.clientLeft;
            if (
              swiper.activeIndex === swiper.slides.length - 1 &&
              params.cssMode
            ) {
              requestAnimationFrame(() => {
                swiper.slideTo(
                  swiper.activeIndex + increment,
                  speed,
                  runCallbacks,
                  internal
                );
              });
              return true;
            }
          }
          if (params.rewind && swiper.isEnd) {
            return swiper.slideTo(0, speed, runCallbacks, internal);
          }
          return swiper.slideTo(
            swiper.activeIndex + increment,
            speed,
            runCallbacks,
            internal
          );
        }

        /* eslint no-unused-vars: "off" */
        function slidePrev(speed, runCallbacks, internal) {
          if (speed === void 0) {
            speed = this.params.speed;
          }
          if (runCallbacks === void 0) {
            runCallbacks = true;
          }
          const swiper = this;
          const {
            params,
            snapGrid,
            slidesGrid,
            rtlTranslate,
            enabled,
            animating,
          } = swiper;
          if (!enabled) return swiper;
          const isVirtual = swiper.virtual && params.virtual.enabled;
          if (params.loop) {
            if (animating && !isVirtual && params.loopPreventsSliding)
              return false;
            swiper.loopFix({
              direction: "prev",
            });
            // eslint-disable-next-line
            swiper._clientLeft = swiper.wrapperEl.clientLeft;
          }
          const translate = rtlTranslate ? swiper.translate : -swiper.translate;
          function normalize(val) {
            if (val < 0) return -Math.floor(Math.abs(val));
            return Math.floor(val);
          }
          const normalizedTranslate = normalize(translate);
          const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
          let prevSnap =
            snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
          if (typeof prevSnap === "undefined" && params.cssMode) {
            let prevSnapIndex;
            snapGrid.forEach((snap, snapIndex) => {
              if (normalizedTranslate >= snap) {
                // prevSnap = snap;
                prevSnapIndex = snapIndex;
              }
            });
            if (typeof prevSnapIndex !== "undefined") {
              prevSnap =
                snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
            }
          }
          let prevIndex = 0;
          if (typeof prevSnap !== "undefined") {
            prevIndex = slidesGrid.indexOf(prevSnap);
            if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
            if (
              params.slidesPerView === "auto" &&
              params.slidesPerGroup === 1 &&
              params.slidesPerGroupAuto
            ) {
              prevIndex =
                prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
              prevIndex = Math.max(prevIndex, 0);
            }
          }
          if (params.rewind && swiper.isBeginning) {
            const lastIndex =
              swiper.params.virtual &&
              swiper.params.virtual.enabled &&
              swiper.virtual
                ? swiper.virtual.slides.length - 1
                : swiper.slides.length - 1;
            return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
          } else if (
            params.loop &&
            swiper.activeIndex === 0 &&
            params.cssMode
          ) {
            requestAnimationFrame(() => {
              swiper.slideTo(prevIndex, speed, runCallbacks, internal);
            });
            return true;
          }
          return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        }

        /* eslint no-unused-vars: "off" */
        function slideReset(speed, runCallbacks, internal) {
          if (speed === void 0) {
            speed = this.params.speed;
          }
          if (runCallbacks === void 0) {
            runCallbacks = true;
          }
          const swiper = this;
          return swiper.slideTo(
            swiper.activeIndex,
            speed,
            runCallbacks,
            internal
          );
        }

        /* eslint no-unused-vars: "off" */
        function slideToClosest(speed, runCallbacks, internal, threshold) {
          if (speed === void 0) {
            speed = this.params.speed;
          }
          if (runCallbacks === void 0) {
            runCallbacks = true;
          }
          if (threshold === void 0) {
            threshold = 0.5;
          }
          const swiper = this;
          let index = swiper.activeIndex;
          const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
          const snapIndex =
            skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
          const translate = swiper.rtlTranslate
            ? swiper.translate
            : -swiper.translate;
          if (translate >= swiper.snapGrid[snapIndex]) {
            // The current translate is on or after the current snap index, so the choice
            // is between the current index and the one after it.
            const currentSnap = swiper.snapGrid[snapIndex];
            const nextSnap = swiper.snapGrid[snapIndex + 1];
            if (
              translate - currentSnap >
              (nextSnap - currentSnap) * threshold
            ) {
              index += swiper.params.slidesPerGroup;
            }
          } else {
            // The current translate is before the current snap index, so the choice
            // is between the current index and the one before it.
            const prevSnap = swiper.snapGrid[snapIndex - 1];
            const currentSnap = swiper.snapGrid[snapIndex];
            if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
              index -= swiper.params.slidesPerGroup;
            }
          }
          index = Math.max(index, 0);
          index = Math.min(index, swiper.slidesGrid.length - 1);
          return swiper.slideTo(index, speed, runCallbacks, internal);
        }

        function slideToClickedSlide() {
          const swiper = this;
          const { params, slidesEl } = swiper;
          const slidesPerView =
            params.slidesPerView === "auto"
              ? swiper.slidesPerViewDynamic()
              : params.slidesPerView;
          let slideToIndex = swiper.clickedIndex;
          let realIndex;
          const slideSelector = swiper.isElement
            ? `swiper-slide`
            : `.${params.slideClass}`;
          if (params.loop) {
            if (swiper.animating) return;
            realIndex = parseInt(
              swiper.clickedSlide.getAttribute("data-swiper-slide-index"),
              10
            );
            if (params.centeredSlides) {
              if (
                slideToIndex < swiper.loopedSlides - slidesPerView / 2 ||
                slideToIndex >
                  swiper.slides.length - swiper.loopedSlides + slidesPerView / 2
              ) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex(
                  (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
                    slidesEl,
                    `${slideSelector}[data-swiper-slide-index="${realIndex}"]`
                  )[0]
                );
                (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
                  swiper.slideTo(slideToIndex);
                });
              } else {
                swiper.slideTo(slideToIndex);
              }
            } else if (slideToIndex > swiper.slides.length - slidesPerView) {
              swiper.loopFix();
              slideToIndex = swiper.getSlideIndex(
                (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
                  slidesEl,
                  `${slideSelector}[data-swiper-slide-index="${realIndex}"]`
                )[0]
              );
              (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
                swiper.slideTo(slideToIndex);
              });
            } else {
              swiper.slideTo(slideToIndex);
            }
          } else {
            swiper.slideTo(slideToIndex);
          }
        }

        var slide = {
          slideTo,
          slideToLoop,
          slideNext,
          slidePrev,
          slideReset,
          slideToClosest,
          slideToClickedSlide,
        };

        function loopCreate(slideRealIndex) {
          const swiper = this;
          const { params, slidesEl } = swiper;
          if (!params.loop || (swiper.virtual && swiper.params.virtual.enabled))
            return;
          const slides = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
            slidesEl,
            `.${params.slideClass}, swiper-slide`
          );
          slides.forEach((el, index) => {
            el.setAttribute("data-swiper-slide-index", index);
          });
          swiper.loopFix({
            slideRealIndex,
            direction: params.centeredSlides ? undefined : "next",
          });
        }

        function loopFix(_temp) {
          let {
            slideRealIndex,
            slideTo = true,
            direction,
            setTranslate,
            activeSlideIndex,
            byController,
            byMousewheel,
          } = _temp === void 0 ? {} : _temp;
          const swiper = this;
          if (!swiper.params.loop) return;
          swiper.emit("beforeLoopFix");
          const { slides, allowSlidePrev, allowSlideNext, slidesEl, params } =
            swiper;
          swiper.allowSlidePrev = true;
          swiper.allowSlideNext = true;
          if (swiper.virtual && params.virtual.enabled) {
            if (slideTo) {
              if (!params.centeredSlides && swiper.snapIndex === 0) {
                swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
              } else if (
                params.centeredSlides &&
                swiper.snapIndex < params.slidesPerView
              ) {
                swiper.slideTo(
                  swiper.virtual.slides.length + swiper.snapIndex,
                  0,
                  false,
                  true
                );
              } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
                swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
              }
            }
            swiper.allowSlidePrev = allowSlidePrev;
            swiper.allowSlideNext = allowSlideNext;
            swiper.emit("loopFix");
            return;
          }
          const slidesPerView =
            params.slidesPerView === "auto"
              ? swiper.slidesPerViewDynamic()
              : Math.ceil(parseFloat(params.slidesPerView, 10));
          let loopedSlides = params.loopedSlides || slidesPerView;
          if (loopedSlides % params.slidesPerGroup !== 0) {
            loopedSlides +=
              params.slidesPerGroup - (loopedSlides % params.slidesPerGroup);
          }
          swiper.loopedSlides = loopedSlides;
          const prependSlidesIndexes = [];
          const appendSlidesIndexes = [];
          let activeIndex = swiper.activeIndex;
          if (typeof activeSlideIndex === "undefined") {
            activeSlideIndex = swiper.getSlideIndex(
              swiper.slides.filter((el) =>
                el.classList.contains(params.slideActiveClass)
              )[0]
            );
          } else {
            activeIndex = activeSlideIndex;
          }
          const isNext = direction === "next" || !direction;
          const isPrev = direction === "prev" || !direction;
          let slidesPrepended = 0;
          let slidesAppended = 0;
          // prepend last slides before start
          if (activeSlideIndex < loopedSlides) {
            slidesPrepended = Math.max(
              loopedSlides - activeSlideIndex,
              params.slidesPerGroup
            );
            for (let i = 0; i < loopedSlides - activeSlideIndex; i += 1) {
              const index = i - Math.floor(i / slides.length) * slides.length;
              prependSlidesIndexes.push(slides.length - index - 1);
            }
          } else if (
            activeSlideIndex /* + slidesPerView */ >
            swiper.slides.length - loopedSlides * 2
          ) {
            slidesAppended = Math.max(
              activeSlideIndex - (swiper.slides.length - loopedSlides * 2),
              params.slidesPerGroup
            );
            for (let i = 0; i < slidesAppended; i += 1) {
              const index = i - Math.floor(i / slides.length) * slides.length;
              appendSlidesIndexes.push(index);
            }
          }
          if (isPrev) {
            prependSlidesIndexes.forEach((index) => {
              swiper.slides[index].swiperLoopMoveDOM = true;
              slidesEl.prepend(swiper.slides[index]);
              swiper.slides[index].swiperLoopMoveDOM = false;
            });
          }
          if (isNext) {
            appendSlidesIndexes.forEach((index) => {
              swiper.slides[index].swiperLoopMoveDOM = true;
              slidesEl.append(swiper.slides[index]);
              swiper.slides[index].swiperLoopMoveDOM = false;
            });
          }
          swiper.recalcSlides();
          if (params.slidesPerView === "auto") {
            swiper.updateSlides();
          }
          if (params.watchSlidesProgress) {
            swiper.updateSlidesOffset();
          }
          if (slideTo) {
            if (prependSlidesIndexes.length > 0 && isPrev) {
              if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate =
                  swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) {
                  swiper.setTranslate(swiper.translate - diff);
                } else {
                  swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
                  if (setTranslate) {
                    swiper.touches[
                      swiper.isHorizontal() ? "startX" : "startY"
                    ] += diff;
                    swiper.touchEventsData.currentTranslate = swiper.translate;
                  }
                }
              } else {
                if (setTranslate) {
                  swiper.slideToLoop(slideRealIndex, 0, false, true);
                  swiper.touchEventsData.currentTranslate = swiper.translate;
                }
              }
            } else if (appendSlidesIndexes.length > 0 && isNext) {
              if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate =
                  swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) {
                  swiper.setTranslate(swiper.translate - diff);
                } else {
                  swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                  if (setTranslate) {
                    swiper.touches[
                      swiper.isHorizontal() ? "startX" : "startY"
                    ] += diff;
                    swiper.touchEventsData.currentTranslate = swiper.translate;
                  }
                }
              } else {
                swiper.slideToLoop(slideRealIndex, 0, false, true);
              }
            }
          }
          swiper.allowSlidePrev = allowSlidePrev;
          swiper.allowSlideNext = allowSlideNext;
          if (swiper.controller && swiper.controller.control && !byController) {
            const loopParams = {
              slideRealIndex,
              direction,
              setTranslate,
              activeSlideIndex,
              byController: true,
            };
            if (Array.isArray(swiper.controller.control)) {
              swiper.controller.control.forEach((c) => {
                if (!c.destroyed && c.params.loop)
                  c.loopFix({
                    ...loopParams,
                    slideTo:
                      c.params.slidesPerView === params.slidesPerView
                        ? slideTo
                        : false,
                  });
              });
            } else if (
              swiper.controller.control instanceof swiper.constructor &&
              swiper.controller.control.params.loop
            ) {
              swiper.controller.control.loopFix({
                ...loopParams,
                slideTo:
                  swiper.controller.control.params.slidesPerView ===
                  params.slidesPerView
                    ? slideTo
                    : false,
              });
            }
          }
          swiper.emit("loopFix");
        }

        function loopDestroy() {
          const swiper = this;
          const { params, slidesEl } = swiper;
          if (!params.loop || (swiper.virtual && swiper.params.virtual.enabled))
            return;
          swiper.recalcSlides();
          const newSlidesOrder = [];
          swiper.slides.forEach((slideEl) => {
            const index =
              typeof slideEl.swiperSlideIndex === "undefined"
                ? slideEl.getAttribute("data-swiper-slide-index") * 1
                : slideEl.swiperSlideIndex;
            newSlidesOrder[index] = slideEl;
          });
          swiper.slides.forEach((slideEl) => {
            slideEl.removeAttribute("data-swiper-slide-index");
          });
          newSlidesOrder.forEach((slideEl) => {
            slidesEl.append(slideEl);
          });
          swiper.recalcSlides();
          swiper.slideTo(swiper.realIndex, 0);
        }

        var loop = {
          loopCreate,
          loopFix,
          loopDestroy,
        };

        function setGrabCursor(moving) {
          const swiper = this;
          if (
            !swiper.params.simulateTouch ||
            (swiper.params.watchOverflow && swiper.isLocked) ||
            swiper.params.cssMode
          )
            return;
          const el =
            swiper.params.touchEventsTarget === "container"
              ? swiper.el
              : swiper.wrapperEl;
          if (swiper.isElement) {
            swiper.__preventObserver__ = true;
          }
          el.style.cursor = "move";
          el.style.cursor = moving ? "grabbing" : "grab";
          if (swiper.isElement) {
            requestAnimationFrame(() => {
              swiper.__preventObserver__ = false;
            });
          }
        }

        function unsetGrabCursor() {
          const swiper = this;
          if (
            (swiper.params.watchOverflow && swiper.isLocked) ||
            swiper.params.cssMode
          ) {
            return;
          }
          if (swiper.isElement) {
            swiper.__preventObserver__ = true;
          }
          swiper[
            swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"
          ].style.cursor = "";
          if (swiper.isElement) {
            requestAnimationFrame(() => {
              swiper.__preventObserver__ = false;
            });
          }
        }

        var grabCursor = {
          setGrabCursor,
          unsetGrabCursor,
        };

        // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
        function closestElement(selector, base) {
          if (base === void 0) {
            base = this;
          }
          function __closestFrom(el) {
            if (
              !el ||
              el ===
                (0, _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)() ||
              el === (0, _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)()
            )
              return null;
            if (el.assignedSlot) el = el.assignedSlot;
            const found = el.closest(selector);
            if (!found && !el.getRootNode) {
              return null;
            }
            return found || __closestFrom(el.getRootNode().host);
          }
          return __closestFrom(base);
        }
        function onTouchStart(event) {
          const swiper = this;
          const document = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          const data = swiper.touchEventsData;
          data.evCache.push(event);
          const { params, touches, enabled } = swiper;
          if (!enabled) return;
          if (!params.simulateTouch && event.pointerType === "mouse") return;
          if (swiper.animating && params.preventInteractionOnTransition) {
            return;
          }
          if (!swiper.animating && params.cssMode && params.loop) {
            swiper.loopFix();
          }
          let e = event;
          if (e.originalEvent) e = e.originalEvent;
          let targetEl = e.target;
          if (params.touchEventsTarget === "wrapper") {
            if (!swiper.wrapperEl.contains(targetEl)) return;
          }
          if ("which" in e && e.which === 3) return;
          if ("button" in e && e.button > 0) return;
          if (data.isTouched && data.isMoved) return;

          // change target el for shadow root component
          const swipingClassHasValue =
            !!params.noSwipingClass && params.noSwipingClass !== "";
          // eslint-disable-next-line
          const eventPath = event.composedPath
            ? event.composedPath()
            : event.path;
          if (
            swipingClassHasValue &&
            e.target &&
            e.target.shadowRoot &&
            eventPath
          ) {
            targetEl = eventPath[0];
          }
          const noSwipingSelector = params.noSwipingSelector
            ? params.noSwipingSelector
            : `.${params.noSwipingClass}`;
          const isTargetShadow = !!(e.target && e.target.shadowRoot);

          // use closestElement for shadow root element to get the actual closest for nested shadow root element
          if (
            params.noSwiping &&
            (isTargetShadow
              ? closestElement(noSwipingSelector, targetEl)
              : targetEl.closest(noSwipingSelector))
          ) {
            swiper.allowClick = true;
            return;
          }
          if (params.swipeHandler) {
            if (!targetEl.closest(params.swipeHandler)) return;
          }
          touches.currentX = e.pageX;
          touches.currentY = e.pageY;
          const startX = touches.currentX;
          const startY = touches.currentY;

          // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

          const edgeSwipeDetection =
            params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
          const edgeSwipeThreshold =
            params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
          if (
            edgeSwipeDetection &&
            (startX <= edgeSwipeThreshold ||
              startX >= window.innerWidth - edgeSwipeThreshold)
          ) {
            if (edgeSwipeDetection === "prevent") {
              event.preventDefault();
            } else {
              return;
            }
          }
          Object.assign(data, {
            isTouched: true,
            isMoved: false,
            allowTouchCallbacks: true,
            isScrolling: undefined,
            startMoving: undefined,
          });
          touches.startX = startX;
          touches.startY = startY;
          data.touchStartTime = (0,
          _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)();
          swiper.allowClick = true;
          swiper.updateSize();
          swiper.swipeDirection = undefined;
          if (params.threshold > 0) data.allowThresholdMove = false;
          let preventDefault = true;
          if (targetEl.matches(data.focusableElements)) {
            preventDefault = false;
            if (targetEl.nodeName === "SELECT") {
              data.isTouched = false;
            }
          }
          if (
            document.activeElement &&
            document.activeElement.matches(data.focusableElements) &&
            document.activeElement !== targetEl
          ) {
            document.activeElement.blur();
          }
          const shouldPreventDefault =
            preventDefault &&
            swiper.allowTouchMove &&
            params.touchStartPreventDefault;
          if (
            (params.touchStartForcePreventDefault || shouldPreventDefault) &&
            !targetEl.isContentEditable
          ) {
            e.preventDefault();
          }
          if (
            params.freeMode &&
            params.freeMode.enabled &&
            swiper.freeMode &&
            swiper.animating &&
            !params.cssMode
          ) {
            swiper.freeMode.onTouchStart();
          }
          swiper.emit("touchStart", e);
        }

        function onTouchMove(event) {
          const document = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
          const swiper = this;
          const data = swiper.touchEventsData;
          const { params, touches, rtlTranslate: rtl, enabled } = swiper;
          if (!enabled) return;
          if (!params.simulateTouch && event.pointerType === "mouse") return;
          let e = event;
          if (e.originalEvent) e = e.originalEvent;
          if (!data.isTouched) {
            if (data.startMoving && data.isScrolling) {
              swiper.emit("touchMoveOpposite", e);
            }
            return;
          }
          const pointerIndex = data.evCache.findIndex(
            (cachedEv) => cachedEv.pointerId === e.pointerId
          );
          if (pointerIndex >= 0) data.evCache[pointerIndex] = e;
          const targetTouch = data.evCache.length > 1 ? data.evCache[0] : e;
          const pageX = targetTouch.pageX;
          const pageY = targetTouch.pageY;
          if (e.preventedByNestedSwiper) {
            touches.startX = pageX;
            touches.startY = pageY;
            return;
          }
          if (!swiper.allowTouchMove) {
            if (!e.target.matches(data.focusableElements)) {
              swiper.allowClick = false;
            }
            if (data.isTouched) {
              Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                prevX: swiper.touches.currentX,
                prevY: swiper.touches.currentY,
                currentX: pageX,
                currentY: pageY,
              });
              data.touchStartTime = (0,
              _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)();
            }
            return;
          }
          if (params.touchReleaseOnEdges && !params.loop) {
            if (swiper.isVertical()) {
              // Vertical
              if (
                (pageY < touches.startY &&
                  swiper.translate <= swiper.maxTranslate()) ||
                (pageY > touches.startY &&
                  swiper.translate >= swiper.minTranslate())
              ) {
                data.isTouched = false;
                data.isMoved = false;
                return;
              }
            } else if (
              (pageX < touches.startX &&
                swiper.translate <= swiper.maxTranslate()) ||
              (pageX > touches.startX &&
                swiper.translate >= swiper.minTranslate())
            ) {
              return;
            }
          }
          if (document.activeElement) {
            if (
              e.target === document.activeElement &&
              e.target.matches(data.focusableElements)
            ) {
              data.isMoved = true;
              swiper.allowClick = false;
              return;
            }
          }
          if (data.allowTouchCallbacks) {
            swiper.emit("touchMove", e);
          }
          if (e.targetTouches && e.targetTouches.length > 1) return;
          touches.currentX = pageX;
          touches.currentY = pageY;
          const diffX = touches.currentX - touches.startX;
          const diffY = touches.currentY - touches.startY;
          if (
            swiper.params.threshold &&
            Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold
          )
            return;
          if (typeof data.isScrolling === "undefined") {
            let touchAngle;
            if (
              (swiper.isHorizontal() && touches.currentY === touches.startY) ||
              (swiper.isVertical() && touches.currentX === touches.startX)
            ) {
              data.isScrolling = false;
            } else {
              // eslint-disable-next-line
              if (diffX * diffX + diffY * diffY >= 25) {
                touchAngle =
                  (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) /
                  Math.PI;
                data.isScrolling = swiper.isHorizontal()
                  ? touchAngle > params.touchAngle
                  : 90 - touchAngle > params.touchAngle;
              }
            }
          }
          if (data.isScrolling) {
            swiper.emit("touchMoveOpposite", e);
          }
          if (typeof data.startMoving === "undefined") {
            if (
              touches.currentX !== touches.startX ||
              touches.currentY !== touches.startY
            ) {
              data.startMoving = true;
            }
          }
          if (
            data.isScrolling ||
            (swiper.zoom &&
              swiper.params.zoom &&
              swiper.params.zoom.enabled &&
              data.evCache.length > 1)
          ) {
            data.isTouched = false;
            return;
          }
          if (!data.startMoving) {
            return;
          }
          swiper.allowClick = false;
          if (!params.cssMode && e.cancelable) {
            e.preventDefault();
          }
          if (params.touchMoveStopPropagation && !params.nested) {
            e.stopPropagation();
          }
          let diff = swiper.isHorizontal() ? diffX : diffY;
          let touchesDiff = swiper.isHorizontal()
            ? touches.currentX - touches.previousX
            : touches.currentY - touches.previousY;
          if (params.oneWayMovement) {
            diff = Math.abs(diff) * (rtl ? 1 : -1);
            touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
          }
          touches.diff = diff;
          diff *= params.touchRatio;
          if (rtl) {
            diff = -diff;
            touchesDiff = -touchesDiff;
          }
          const prevTouchesDirection = swiper.touchesDirection;
          swiper.swipeDirection = diff > 0 ? "prev" : "next";
          swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
          const isLoop = swiper.params.loop && !params.cssMode;
          const allowLoopFix =
            (swiper.swipeDirection === "next" && swiper.allowSlideNext) ||
            (swiper.swipeDirection === "prev" && swiper.allowSlidePrev);
          if (!data.isMoved) {
            if (isLoop && allowLoopFix) {
              swiper.loopFix({
                direction: swiper.swipeDirection,
              });
            }
            data.startTranslate = swiper.getTranslate();
            swiper.setTransition(0);
            if (swiper.animating) {
              const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true,
              });
              swiper.wrapperEl.dispatchEvent(evt);
            }
            data.allowMomentumBounce = false;
            // Grab Cursor
            if (
              params.grabCursor &&
              (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)
            ) {
              swiper.setGrabCursor(true);
            }
            swiper.emit("sliderFirstMove", e);
          }
          let loopFixed;
          if (
            data.isMoved &&
            prevTouchesDirection !== swiper.touchesDirection &&
            isLoop &&
            allowLoopFix &&
            Math.abs(diff) >= 1
          ) {
            // need another loop fix
            swiper.loopFix({
              direction: swiper.swipeDirection,
              setTranslate: true,
            });
            loopFixed = true;
          }
          swiper.emit("sliderMove", e);
          data.isMoved = true;
          data.currentTranslate = diff + data.startTranslate;
          let disableParentSwiper = true;
          let resistanceRatio = params.resistanceRatio;
          if (params.touchReleaseOnEdges) {
            resistanceRatio = 0;
          }
          if (diff > 0) {
            if (
              isLoop &&
              allowLoopFix &&
              !loopFixed &&
              data.currentTranslate >
                (params.centeredSlides
                  ? swiper.minTranslate() - swiper.size / 2
                  : swiper.minTranslate())
            ) {
              swiper.loopFix({
                direction: "prev",
                setTranslate: true,
                activeSlideIndex: 0,
              });
            }
            if (data.currentTranslate > swiper.minTranslate()) {
              disableParentSwiper = false;
              if (params.resistance) {
                data.currentTranslate =
                  swiper.minTranslate() -
                  1 +
                  (-swiper.minTranslate() + data.startTranslate + diff) **
                    resistanceRatio;
              }
            }
          } else if (diff < 0) {
            if (
              isLoop &&
              allowLoopFix &&
              !loopFixed &&
              data.currentTranslate <
                (params.centeredSlides
                  ? swiper.maxTranslate() + swiper.size / 2
                  : swiper.maxTranslate())
            ) {
              swiper.loopFix({
                direction: "next",
                setTranslate: true,
                activeSlideIndex:
                  swiper.slides.length -
                  (params.slidesPerView === "auto"
                    ? swiper.slidesPerViewDynamic()
                    : Math.ceil(parseFloat(params.slidesPerView, 10))),
              });
            }
            if (data.currentTranslate < swiper.maxTranslate()) {
              disableParentSwiper = false;
              if (params.resistance) {
                data.currentTranslate =
                  swiper.maxTranslate() +
                  1 -
                  (swiper.maxTranslate() - data.startTranslate - diff) **
                    resistanceRatio;
              }
            }
          }
          if (disableParentSwiper) {
            e.preventedByNestedSwiper = true;
          }

          // Directions locks
          if (
            !swiper.allowSlideNext &&
            swiper.swipeDirection === "next" &&
            data.currentTranslate < data.startTranslate
          ) {
            data.currentTranslate = data.startTranslate;
          }
          if (
            !swiper.allowSlidePrev &&
            swiper.swipeDirection === "prev" &&
            data.currentTranslate > data.startTranslate
          ) {
            data.currentTranslate = data.startTranslate;
          }
          if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
            data.currentTranslate = data.startTranslate;
          }

          // Threshold
          if (params.threshold > 0) {
            if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
              if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal()
                  ? touches.currentX - touches.startX
                  : touches.currentY - touches.startY;
                return;
              }
            } else {
              data.currentTranslate = data.startTranslate;
              return;
            }
          }
          if (!params.followFinger || params.cssMode) return;

          // Update active index in free mode
          if (
            (params.freeMode && params.freeMode.enabled && swiper.freeMode) ||
            params.watchSlidesProgress
          ) {
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
          }
          if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
            swiper.freeMode.onTouchMove();
          }
          // Update progress
          swiper.updateProgress(data.currentTranslate);
          // Update translate
          swiper.setTranslate(data.currentTranslate);
        }

        function onTouchEnd(event) {
          const swiper = this;
          const data = swiper.touchEventsData;
          const pointerIndex = data.evCache.findIndex(
            (cachedEv) => cachedEv.pointerId === event.pointerId
          );
          if (pointerIndex >= 0) {
            data.evCache.splice(pointerIndex, 1);
          }
          if (
            [
              "pointercancel",
              "pointerout",
              "pointerleave",
              "contextmenu",
            ].includes(event.type)
          ) {
            const proceed =
              ["pointercancel", "contextmenu"].includes(event.type) &&
              (swiper.browser.isSafari || swiper.browser.isWebView);
            if (!proceed) {
              return;
            }
          }
          const {
            params,
            touches,
            rtlTranslate: rtl,
            slidesGrid,
            enabled,
          } = swiper;
          if (!enabled) return;
          if (!params.simulateTouch && event.pointerType === "mouse") return;
          let e = event;
          if (e.originalEvent) e = e.originalEvent;
          if (data.allowTouchCallbacks) {
            swiper.emit("touchEnd", e);
          }
          data.allowTouchCallbacks = false;
          if (!data.isTouched) {
            if (data.isMoved && params.grabCursor) {
              swiper.setGrabCursor(false);
            }
            data.isMoved = false;
            data.startMoving = false;
            return;
          }
          // Return Grab Cursor
          if (
            params.grabCursor &&
            data.isMoved &&
            data.isTouched &&
            (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)
          ) {
            swiper.setGrabCursor(false);
          }

          // Time diff
          const touchEndTime = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)();
          const timeDiff = touchEndTime - data.touchStartTime;

          // Tap, doubleTap, Click
          if (swiper.allowClick) {
            const pathTree = e.path || (e.composedPath && e.composedPath());
            swiper.updateClickedSlide(
              (pathTree && pathTree[0]) || e.target,
              pathTree
            );
            swiper.emit("tap click", e);
            if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
              swiper.emit("doubleTap doubleClick", e);
            }
          }
          data.lastClickTime = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)();
          (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
            if (!swiper.destroyed) swiper.allowClick = true;
          });
          if (
            !data.isTouched ||
            !data.isMoved ||
            !swiper.swipeDirection ||
            touches.diff === 0 ||
            data.currentTranslate === data.startTranslate
          ) {
            data.isTouched = false;
            data.isMoved = false;
            data.startMoving = false;
            return;
          }
          data.isTouched = false;
          data.isMoved = false;
          data.startMoving = false;
          let currentPos;
          if (params.followFinger) {
            currentPos = rtl ? swiper.translate : -swiper.translate;
          } else {
            currentPos = -data.currentTranslate;
          }
          if (params.cssMode) {
            return;
          }
          if (params.freeMode && params.freeMode.enabled) {
            swiper.freeMode.onTouchEnd({
              currentPos,
            });
            return;
          }

          // Find current slide
          let stopIndex = 0;
          let groupSize = swiper.slidesSizesGrid[0];
          for (
            let i = 0;
            i < slidesGrid.length;
            i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup
          ) {
            const increment =
              i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
            if (typeof slidesGrid[i + increment] !== "undefined") {
              if (
                currentPos >= slidesGrid[i] &&
                currentPos < slidesGrid[i + increment]
              ) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
              }
            } else if (currentPos >= slidesGrid[i]) {
              stopIndex = i;
              groupSize =
                slidesGrid[slidesGrid.length - 1] -
                slidesGrid[slidesGrid.length - 2];
            }
          }
          let rewindFirstIndex = null;
          let rewindLastIndex = null;
          if (params.rewind) {
            if (swiper.isBeginning) {
              rewindLastIndex =
                params.virtual && params.virtual.enabled && swiper.virtual
                  ? swiper.virtual.slides.length - 1
                  : swiper.slides.length - 1;
            } else if (swiper.isEnd) {
              rewindFirstIndex = 0;
            }
          }
          // Find current slide size
          const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
          const increment =
            stopIndex < params.slidesPerGroupSkip - 1
              ? 1
              : params.slidesPerGroup;
          if (timeDiff > params.longSwipesMs) {
            // Long touches
            if (!params.longSwipes) {
              swiper.slideTo(swiper.activeIndex);
              return;
            }
            if (swiper.swipeDirection === "next") {
              if (ratio >= params.longSwipesRatio)
                swiper.slideTo(
                  params.rewind && swiper.isEnd
                    ? rewindFirstIndex
                    : stopIndex + increment
                );
              else swiper.slideTo(stopIndex);
            }
            if (swiper.swipeDirection === "prev") {
              if (ratio > 1 - params.longSwipesRatio) {
                swiper.slideTo(stopIndex + increment);
              } else if (
                rewindLastIndex !== null &&
                ratio < 0 &&
                Math.abs(ratio) > params.longSwipesRatio
              ) {
                swiper.slideTo(rewindLastIndex);
              } else {
                swiper.slideTo(stopIndex);
              }
            }
          } else {
            // Short swipes
            if (!params.shortSwipes) {
              swiper.slideTo(swiper.activeIndex);
              return;
            }
            const isNavButtonTarget =
              swiper.navigation &&
              (e.target === swiper.navigation.nextEl ||
                e.target === swiper.navigation.prevEl);
            if (!isNavButtonTarget) {
              if (swiper.swipeDirection === "next") {
                swiper.slideTo(
                  rewindFirstIndex !== null
                    ? rewindFirstIndex
                    : stopIndex + increment
                );
              }
              if (swiper.swipeDirection === "prev") {
                swiper.slideTo(
                  rewindLastIndex !== null ? rewindLastIndex : stopIndex
                );
              }
            } else if (e.target === swiper.navigation.nextEl) {
              swiper.slideTo(stopIndex + increment);
            } else {
              swiper.slideTo(stopIndex);
            }
          }
        }

        function onResize() {
          const swiper = this;
          const { params, el } = swiper;
          if (el && el.offsetWidth === 0) return;

          // Breakpoints
          if (params.breakpoints) {
            swiper.setBreakpoint();
          }

          // Save locks
          const { allowSlideNext, allowSlidePrev, snapGrid } = swiper;
          const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

          // Disable locks on resize
          swiper.allowSlideNext = true;
          swiper.allowSlidePrev = true;
          swiper.updateSize();
          swiper.updateSlides();
          swiper.updateSlidesClasses();
          const isVirtualLoop = isVirtual && params.loop;
          if (
            (params.slidesPerView === "auto" || params.slidesPerView > 1) &&
            swiper.isEnd &&
            !swiper.isBeginning &&
            !swiper.params.centeredSlides &&
            !isVirtualLoop
          ) {
            swiper.slideTo(swiper.slides.length - 1, 0, false, true);
          } else {
            if (swiper.params.loop && !isVirtual) {
              swiper.slideToLoop(swiper.realIndex, 0, false, true);
            } else {
              swiper.slideTo(swiper.activeIndex, 0, false, true);
            }
          }
          if (
            swiper.autoplay &&
            swiper.autoplay.running &&
            swiper.autoplay.paused
          ) {
            clearTimeout(swiper.autoplay.resizeTimeout);
            swiper.autoplay.resizeTimeout = setTimeout(() => {
              if (
                swiper.autoplay &&
                swiper.autoplay.running &&
                swiper.autoplay.paused
              ) {
                swiper.autoplay.resume();
              }
            }, 500);
          }
          // Return locks after resize
          swiper.allowSlidePrev = allowSlidePrev;
          swiper.allowSlideNext = allowSlideNext;
          if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
            swiper.checkOverflow();
          }
        }

        function onClick(e) {
          const swiper = this;
          if (!swiper.enabled) return;
          if (!swiper.allowClick) {
            if (swiper.params.preventClicks) e.preventDefault();
            if (swiper.params.preventClicksPropagation && swiper.animating) {
              e.stopPropagation();
              e.stopImmediatePropagation();
            }
          }
        }

        function onScroll() {
          const swiper = this;
          const { wrapperEl, rtlTranslate, enabled } = swiper;
          if (!enabled) return;
          swiper.previousTranslate = swiper.translate;
          if (swiper.isHorizontal()) {
            swiper.translate = -wrapperEl.scrollLeft;
          } else {
            swiper.translate = -wrapperEl.scrollTop;
          }
          // eslint-disable-next-line
          if (swiper.translate === 0) swiper.translate = 0;
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
          let newProgress;
          const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
          if (translatesDiff === 0) {
            newProgress = 0;
          } else {
            newProgress =
              (swiper.translate - swiper.minTranslate()) / translatesDiff;
          }
          if (newProgress !== swiper.progress) {
            swiper.updateProgress(
              rtlTranslate ? -swiper.translate : swiper.translate
            );
          }
          swiper.emit("setTranslate", swiper.translate, false);
        }

        function onLoad(e) {
          const swiper = this;
          processLazyPreloader(swiper, e.target);
          if (
            swiper.params.cssMode ||
            (swiper.params.slidesPerView !== "auto" &&
              !swiper.params.autoHeight)
          ) {
            return;
          }
          swiper.update();
        }

        let dummyEventAttached = false;
        function dummyEventListener() {}
        const events = (swiper, method) => {
          const document = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
          const { params, el, wrapperEl, device } = swiper;
          const capture = !!params.nested;
          const domMethod =
            method === "on" ? "addEventListener" : "removeEventListener";
          const swiperMethod = method;

          // Touch Events
          el[domMethod]("pointerdown", swiper.onTouchStart, {
            passive: false,
          });
          document[domMethod]("pointermove", swiper.onTouchMove, {
            passive: false,
            capture,
          });
          document[domMethod]("pointerup", swiper.onTouchEnd, {
            passive: true,
          });
          document[domMethod]("pointercancel", swiper.onTouchEnd, {
            passive: true,
          });
          document[domMethod]("pointerout", swiper.onTouchEnd, {
            passive: true,
          });
          document[domMethod]("pointerleave", swiper.onTouchEnd, {
            passive: true,
          });
          document[domMethod]("contextmenu", swiper.onTouchEnd, {
            passive: true,
          });

          // Prevent Links Clicks
          if (params.preventClicks || params.preventClicksPropagation) {
            el[domMethod]("click", swiper.onClick, true);
          }
          if (params.cssMode) {
            wrapperEl[domMethod]("scroll", swiper.onScroll);
          }

          // Resize handler
          if (params.updateOnWindowResize) {
            swiper[swiperMethod](
              device.ios || device.android
                ? "resize orientationchange observerUpdate"
                : "resize observerUpdate",
              onResize,
              true
            );
          } else {
            swiper[swiperMethod]("observerUpdate", onResize, true);
          }

          // Images loader
          el[domMethod]("load", swiper.onLoad, {
            capture: true,
          });
        };
        function attachEvents() {
          const swiper = this;
          const document = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
          const { params } = swiper;
          swiper.onTouchStart = onTouchStart.bind(swiper);
          swiper.onTouchMove = onTouchMove.bind(swiper);
          swiper.onTouchEnd = onTouchEnd.bind(swiper);
          if (params.cssMode) {
            swiper.onScroll = onScroll.bind(swiper);
          }
          swiper.onClick = onClick.bind(swiper);
          swiper.onLoad = onLoad.bind(swiper);
          if (!dummyEventAttached) {
            document.addEventListener("touchstart", dummyEventListener);
            dummyEventAttached = true;
          }
          events(swiper, "on");
        }
        function detachEvents() {
          const swiper = this;
          events(swiper, "off");
        }
        var events$1 = {
          attachEvents,
          detachEvents,
        };

        const isGridEnabled = (swiper, params) => {
          return swiper.grid && params.grid && params.grid.rows > 1;
        };
        function setBreakpoint() {
          const swiper = this;
          const { realIndex, initialized, params, el } = swiper;
          const breakpoints = params.breakpoints;
          if (
            !breakpoints ||
            (breakpoints && Object.keys(breakpoints).length === 0)
          )
            return;

          // Get breakpoint for window width and update parameters
          const breakpoint = swiper.getBreakpoint(
            breakpoints,
            swiper.params.breakpointsBase,
            swiper.el
          );
          if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
          const breakpointOnlyParams =
            breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
          const breakpointParams =
            breakpointOnlyParams || swiper.originalParams;
          const wasMultiRow = isGridEnabled(swiper, params);
          const isMultiRow = isGridEnabled(swiper, breakpointParams);
          const wasEnabled = params.enabled;
          if (wasMultiRow && !isMultiRow) {
            el.classList.remove(
              `${params.containerModifierClass}grid`,
              `${params.containerModifierClass}grid-column`
            );
            swiper.emitContainerClasses();
          } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (
              (breakpointParams.grid.fill &&
                breakpointParams.grid.fill === "column") ||
              (!breakpointParams.grid.fill && params.grid.fill === "column")
            ) {
              el.classList.add(`${params.containerModifierClass}grid-column`);
            }
            swiper.emitContainerClasses();
          }

          // Toggle navigation, pagination, scrollbar
          ["navigation", "pagination", "scrollbar"].forEach((prop) => {
            if (typeof breakpointParams[prop] === "undefined") return;
            const wasModuleEnabled = params[prop] && params[prop].enabled;
            const isModuleEnabled =
              breakpointParams[prop] && breakpointParams[prop].enabled;
            if (wasModuleEnabled && !isModuleEnabled) {
              swiper[prop].disable();
            }
            if (!wasModuleEnabled && isModuleEnabled) {
              swiper[prop].enable();
            }
          });
          const directionChanged =
            breakpointParams.direction &&
            breakpointParams.direction !== params.direction;
          const needsReLoop =
            params.loop &&
            (breakpointParams.slidesPerView !== params.slidesPerView ||
              directionChanged);
          const wasLoop = params.loop;
          if (directionChanged && initialized) {
            swiper.changeDirection();
          }
          (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(
            swiper.params,
            breakpointParams
          );
          const isEnabled = swiper.params.enabled;
          const hasLoop = swiper.params.loop;
          Object.assign(swiper, {
            allowTouchMove: swiper.params.allowTouchMove,
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
          });
          if (wasEnabled && !isEnabled) {
            swiper.disable();
          } else if (!wasEnabled && isEnabled) {
            swiper.enable();
          }
          swiper.currentBreakpoint = breakpoint;
          swiper.emit("_beforeBreakpoint", breakpointParams);
          if (initialized) {
            if (needsReLoop) {
              swiper.loopDestroy();
              swiper.loopCreate(realIndex);
              swiper.updateSlides();
            } else if (!wasLoop && hasLoop) {
              swiper.loopCreate(realIndex);
              swiper.updateSlides();
            } else if (wasLoop && !hasLoop) {
              swiper.loopDestroy();
            }
          }
          swiper.emit("breakpoint", breakpointParams);
        }

        function getBreakpoint(breakpoints, base, containerEl) {
          if (base === void 0) {
            base = "window";
          }
          if (!breakpoints || (base === "container" && !containerEl))
            return undefined;
          let breakpoint = false;
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          const currentHeight =
            base === "window" ? window.innerHeight : containerEl.clientHeight;
          const points = Object.keys(breakpoints).map((point) => {
            if (typeof point === "string" && point.indexOf("@") === 0) {
              const minRatio = parseFloat(point.substr(1));
              const value = currentHeight * minRatio;
              return {
                value,
                point,
              };
            }
            return {
              value: point,
              point,
            };
          });
          points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
          for (let i = 0; i < points.length; i += 1) {
            const { point, value } = points[i];
            if (base === "window") {
              if (window.matchMedia(`(min-width: ${value}px)`).matches) {
                breakpoint = point;
              }
            } else if (value <= containerEl.clientWidth) {
              breakpoint = point;
            }
          }
          return breakpoint || "max";
        }

        var breakpoints = {
          setBreakpoint,
          getBreakpoint,
        };

        function prepareClasses(entries, prefix) {
          const resultClasses = [];
          entries.forEach((item) => {
            if (typeof item === "object") {
              Object.keys(item).forEach((classNames) => {
                if (item[classNames]) {
                  resultClasses.push(prefix + classNames);
                }
              });
            } else if (typeof item === "string") {
              resultClasses.push(prefix + item);
            }
          });
          return resultClasses;
        }
        function addClasses() {
          const swiper = this;
          const { classNames, params, rtl, el, device } = swiper;
          // prettier-ignore
          const suffixes = prepareClasses(['initialized', params.direction, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
          classNames.push(...suffixes);
          el.classList.add(...classNames);
          swiper.emitContainerClasses();
        }

        function removeClasses() {
          const swiper = this;
          const { el, classNames } = swiper;
          el.classList.remove(...classNames);
          swiper.emitContainerClasses();
        }

        var classes = {
          addClasses,
          removeClasses,
        };

        function checkOverflow() {
          const swiper = this;
          const { isLocked: wasLocked, params } = swiper;
          const { slidesOffsetBefore } = params;
          if (slidesOffsetBefore) {
            const lastSlideIndex = swiper.slides.length - 1;
            const lastSlideRightEdge =
              swiper.slidesGrid[lastSlideIndex] +
              swiper.slidesSizesGrid[lastSlideIndex] +
              slidesOffsetBefore * 2;
            swiper.isLocked = swiper.size > lastSlideRightEdge;
          } else {
            swiper.isLocked = swiper.snapGrid.length === 1;
          }
          if (params.allowSlideNext === true) {
            swiper.allowSlideNext = !swiper.isLocked;
          }
          if (params.allowSlidePrev === true) {
            swiper.allowSlidePrev = !swiper.isLocked;
          }
          if (wasLocked && wasLocked !== swiper.isLocked) {
            swiper.isEnd = false;
          }
          if (wasLocked !== swiper.isLocked) {
            swiper.emit(swiper.isLocked ? "lock" : "unlock");
          }
        }
        var checkOverflow$1 = {
          checkOverflow,
        };

        var defaults = {
          init: true,
          direction: "horizontal",
          oneWayMovement: false,
          touchEventsTarget: "wrapper",
          initialSlide: 0,
          speed: 300,
          cssMode: false,
          updateOnWindowResize: true,
          resizeObserver: true,
          nested: false,
          createElements: false,
          enabled: true,
          focusableElements:
            "input, select, option, textarea, button, video, label",
          // Overrides
          width: null,
          height: null,
          //
          preventInteractionOnTransition: false,
          // ssr
          userAgent: null,
          url: null,
          // To support iOS's swipe-to-go-back gesture (when being used in-app).
          edgeSwipeDetection: false,
          edgeSwipeThreshold: 20,
          // Autoheight
          autoHeight: false,
          // Set wrapper width
          setWrapperSize: false,
          // Virtual Translate
          virtualTranslate: false,
          // Effects
          effect: "slide",
          // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

          // Breakpoints
          breakpoints: undefined,
          breakpointsBase: "window",
          // Slides grid
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: false,
          centeredSlides: false,
          centeredSlidesBounds: false,
          slidesOffsetBefore: 0,
          // in px
          slidesOffsetAfter: 0,
          // in px
          normalizeSlideIndex: true,
          centerInsufficientSlides: false,
          // Disable swiper and hide navigation when container not overflow
          watchOverflow: true,
          // Round length
          roundLengths: false,
          // Touches
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: true,
          shortSwipes: true,
          longSwipes: true,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: true,
          allowTouchMove: true,
          threshold: 5,
          touchMoveStopPropagation: false,
          touchStartPreventDefault: true,
          touchStartForcePreventDefault: false,
          touchReleaseOnEdges: false,
          // Unique Navigation Elements
          uniqueNavElements: true,
          // Resistance
          resistance: true,
          resistanceRatio: 0.85,
          // Progress
          watchSlidesProgress: false,
          // Cursor
          grabCursor: false,
          // Clicks
          preventClicks: true,
          preventClicksPropagation: true,
          slideToClickedSlide: false,
          // loop
          loop: false,
          loopedSlides: null,
          loopPreventsSliding: true,
          // rewind
          rewind: false,
          // Swiping/no swiping
          allowSlidePrev: true,
          allowSlideNext: true,
          swipeHandler: null,
          // '.swipe-handler',
          noSwiping: true,
          noSwipingClass: "swiper-no-swiping",
          noSwipingSelector: null,
          // Passive Listeners
          passiveListeners: true,
          maxBackfaceHiddenSlides: 10,
          // NS
          containerModifierClass: "swiper-",
          // NEW
          slideClass: "swiper-slide",
          slideActiveClass: "swiper-slide-active",
          slideVisibleClass: "swiper-slide-visible",
          slideNextClass: "swiper-slide-next",
          slidePrevClass: "swiper-slide-prev",
          wrapperClass: "swiper-wrapper",
          lazyPreloaderClass: "swiper-lazy-preloader",
          lazyPreloadPrevNext: 0,
          // Callbacks
          runCallbacksOnInit: true,
          // Internals
          _emitClasses: false,
        };

        function moduleExtendParams(params, allModulesParams) {
          return function extendParams(obj) {
            if (obj === void 0) {
              obj = {};
            }
            const moduleParamName = Object.keys(obj)[0];
            const moduleParams = obj[moduleParamName];
            if (typeof moduleParams !== "object" || moduleParams === null) {
              (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(
                allModulesParams,
                obj
              );
              return;
            }
            if (params[moduleParamName] === true) {
              params[moduleParamName] = {
                enabled: true,
              };
            }
            if (
              moduleParamName === "navigation" &&
              params[moduleParamName] &&
              params[moduleParamName].enabled &&
              !params[moduleParamName].prevEl &&
              !params[moduleParamName].nextEl
            ) {
              params[moduleParamName].auto = true;
            }
            if (
              ["pagination", "scrollbar"].indexOf(moduleParamName) >= 0 &&
              params[moduleParamName] &&
              params[moduleParamName].enabled &&
              !params[moduleParamName].el
            ) {
              params[moduleParamName].auto = true;
            }
            if (!(moduleParamName in params && "enabled" in moduleParams)) {
              (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(
                allModulesParams,
                obj
              );
              return;
            }
            if (
              typeof params[moduleParamName] === "object" &&
              !("enabled" in params[moduleParamName])
            ) {
              params[moduleParamName].enabled = true;
            }
            if (!params[moduleParamName])
              params[moduleParamName] = {
                enabled: false,
              };
            (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(
              allModulesParams,
              obj
            );
          };
        }

        /* eslint no-param-reassign: "off" */
        const prototypes = {
          eventsEmitter,
          update,
          translate,
          transition,
          slide,
          loop,
          grabCursor,
          events: events$1,
          breakpoints,
          checkOverflow: checkOverflow$1,
          classes,
        };
        const extendedDefaults = {};
        class Swiper {
          constructor() {
            let el;
            let params;
            for (
              var _len = arguments.length, args = new Array(_len), _key = 0;
              _key < _len;
              _key++
            ) {
              args[_key] = arguments[_key];
            }
            if (
              args.length === 1 &&
              args[0].constructor &&
              Object.prototype.toString.call(args[0]).slice(8, -1) === "Object"
            ) {
              params = args[0];
            } else {
              [el, params] = args;
            }
            if (!params) params = {};
            params = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)({}, params);
            if (el && !params.el) params.el = el;
            const document = (0,
            _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
            if (
              params.el &&
              typeof params.el === "string" &&
              document.querySelectorAll(params.el).length > 1
            ) {
              const swipers = [];
              document.querySelectorAll(params.el).forEach((containerEl) => {
                const newParams = (0,
                _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)({}, params, {
                  el: containerEl,
                });
                swipers.push(new Swiper(newParams));
              });
              // eslint-disable-next-line no-constructor-return
              return swipers;
            }

            // Swiper Instance
            const swiper = this;
            swiper.__swiper__ = true;
            swiper.support = getSupport();
            swiper.device = getDevice({
              userAgent: params.userAgent,
            });
            swiper.browser = getBrowser();
            swiper.eventsListeners = {};
            swiper.eventsAnyListeners = [];
            swiper.modules = [...swiper.__modules__];
            if (params.modules && Array.isArray(params.modules)) {
              swiper.modules.push(...params.modules);
            }
            const allModulesParams = {};
            swiper.modules.forEach((mod) => {
              mod({
                params,
                swiper,
                extendParams: moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper),
              });
            });

            // Extend defaults with modules params
            const swiperParams = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(
              {},
              defaults,
              allModulesParams
            );

            // Extend defaults with passed params
            swiper.params = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(
              {},
              swiperParams,
              extendedDefaults,
              params
            );
            swiper.originalParams = (0,
            _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)({}, swiper.params);
            swiper.passedParams = (0,
            _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)({}, params);

            // add event listeners
            if (swiper.params && swiper.params.on) {
              Object.keys(swiper.params.on).forEach((eventName) => {
                swiper.on(eventName, swiper.params.on[eventName]);
              });
            }
            if (swiper.params && swiper.params.onAny) {
              swiper.onAny(swiper.params.onAny);
            }

            // Extend Swiper
            Object.assign(swiper, {
              enabled: swiper.params.enabled,
              el,
              // Classes
              classNames: [],
              // Slides
              slides: [],
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              // isDirection
              isHorizontal() {
                return swiper.params.direction === "horizontal";
              },
              isVertical() {
                return swiper.params.direction === "vertical";
              },
              // Indexes
              activeIndex: 0,
              realIndex: 0,
              //
              isBeginning: true,
              isEnd: false,
              // Props
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: false,
              cssOverflowAdjustment() {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
              },
              // Locks
              allowSlideNext: swiper.params.allowSlideNext,
              allowSlidePrev: swiper.params.allowSlidePrev,
              // Touch Events
              touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                evCache: [],
              },
              // Clicks
              allowClick: true,
              // Touches
              allowTouchMove: swiper.params.allowTouchMove,
              touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
              },
              // Images
              imagesToLoad: [],
              imagesLoaded: 0,
            });
            swiper.emit("_swiper");

            // Init
            if (swiper.params.init) {
              swiper.init();
            }

            // Return app instance
            // eslint-disable-next-line no-constructor-return
            return swiper;
          }
          getSlideIndex(slideEl) {
            const { slidesEl, params } = this;
            const slides = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
              slidesEl,
              `.${params.slideClass}, swiper-slide`
            );
            const firstSlideIndex = (0,
            _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.g)(slides[0]);
            return (
              (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.g)(slideEl) -
              firstSlideIndex
            );
          }
          getSlideIndexByData(index) {
            return this.getSlideIndex(
              this.slides.filter(
                (slideEl) =>
                  slideEl.getAttribute("data-swiper-slide-index") * 1 === index
              )[0]
            );
          }
          recalcSlides() {
            const swiper = this;
            const { slidesEl, params } = swiper;
            swiper.slides = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
              slidesEl,
              `.${params.slideClass}, swiper-slide`
            );
          }
          enable() {
            const swiper = this;
            if (swiper.enabled) return;
            swiper.enabled = true;
            if (swiper.params.grabCursor) {
              swiper.setGrabCursor();
            }
            swiper.emit("enable");
          }
          disable() {
            const swiper = this;
            if (!swiper.enabled) return;
            swiper.enabled = false;
            if (swiper.params.grabCursor) {
              swiper.unsetGrabCursor();
            }
            swiper.emit("disable");
          }
          setProgress(progress, speed) {
            const swiper = this;
            progress = Math.min(Math.max(progress, 0), 1);
            const min = swiper.minTranslate();
            const max = swiper.maxTranslate();
            const current = (max - min) * progress + min;
            swiper.translateTo(
              current,
              typeof speed === "undefined" ? 0 : speed
            );
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
          }
          emitContainerClasses() {
            const swiper = this;
            if (!swiper.params._emitClasses || !swiper.el) return;
            const cls = swiper.el.className.split(" ").filter((className) => {
              return (
                className.indexOf("swiper") === 0 ||
                className.indexOf(swiper.params.containerModifierClass) === 0
              );
            });
            swiper.emit("_containerClasses", cls.join(" "));
          }
          getSlideClasses(slideEl) {
            const swiper = this;
            if (swiper.destroyed) return "";
            return slideEl.className
              .split(" ")
              .filter((className) => {
                return (
                  className.indexOf("swiper-slide") === 0 ||
                  className.indexOf(swiper.params.slideClass) === 0
                );
              })
              .join(" ");
          }
          emitSlidesClasses() {
            const swiper = this;
            if (!swiper.params._emitClasses || !swiper.el) return;
            const updates = [];
            swiper.slides.forEach((slideEl) => {
              const classNames = swiper.getSlideClasses(slideEl);
              updates.push({
                slideEl,
                classNames,
              });
              swiper.emit("_slideClass", slideEl, classNames);
            });
            swiper.emit("_slideClasses", updates);
          }
          slidesPerViewDynamic(view, exact) {
            if (view === void 0) {
              view = "current";
            }
            if (exact === void 0) {
              exact = false;
            }
            const swiper = this;
            const {
              params,
              slides,
              slidesGrid,
              slidesSizesGrid,
              size: swiperSize,
              activeIndex,
            } = swiper;
            let spv = 1;
            if (typeof params.slidesPerView === "number")
              return params.slidesPerView;
            if (params.centeredSlides) {
              let slideSize = slides[activeIndex]
                ? slides[activeIndex].swiperSlideSize
                : 0;
              let breakLoop;
              for (let i = activeIndex + 1; i < slides.length; i += 1) {
                if (slides[i] && !breakLoop) {
                  slideSize += slides[i].swiperSlideSize;
                  spv += 1;
                  if (slideSize > swiperSize) breakLoop = true;
                }
              }
              for (let i = activeIndex - 1; i >= 0; i -= 1) {
                if (slides[i] && !breakLoop) {
                  slideSize += slides[i].swiperSlideSize;
                  spv += 1;
                  if (slideSize > swiperSize) breakLoop = true;
                }
              }
            } else {
              // eslint-disable-next-line
              if (view === "current") {
                for (let i = activeIndex + 1; i < slides.length; i += 1) {
                  const slideInView = exact
                    ? slidesGrid[i] +
                        slidesSizesGrid[i] -
                        slidesGrid[activeIndex] <
                      swiperSize
                    : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                  if (slideInView) {
                    spv += 1;
                  }
                }
              } else {
                // previous
                for (let i = activeIndex - 1; i >= 0; i -= 1) {
                  const slideInView =
                    slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                  if (slideInView) {
                    spv += 1;
                  }
                }
              }
            }
            return spv;
          }
          update() {
            const swiper = this;
            if (!swiper || swiper.destroyed) return;
            const { snapGrid, params } = swiper;
            // Breakpoints
            if (params.breakpoints) {
              swiper.setBreakpoint();
            }
            [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach(
              (imageEl) => {
                if (imageEl.complete) {
                  processLazyPreloader(swiper, imageEl);
                }
              }
            );
            swiper.updateSize();
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            function setTranslate() {
              const translateValue = swiper.rtlTranslate
                ? swiper.translate * -1
                : swiper.translate;
              const newTranslate = Math.min(
                Math.max(translateValue, swiper.maxTranslate()),
                swiper.minTranslate()
              );
              swiper.setTranslate(newTranslate);
              swiper.updateActiveIndex();
              swiper.updateSlidesClasses();
            }
            let translated;
            if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
              setTranslate();
              if (params.autoHeight) {
                swiper.updateAutoHeight();
              }
            } else {
              if (
                (params.slidesPerView === "auto" || params.slidesPerView > 1) &&
                swiper.isEnd &&
                !params.centeredSlides
              ) {
                const slides =
                  swiper.virtual && params.virtual.enabled
                    ? swiper.virtual.slides
                    : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
              } else {
                translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
              }
              if (!translated) {
                setTranslate();
              }
            }
            if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
              swiper.checkOverflow();
            }
            swiper.emit("update");
          }
          changeDirection(newDirection, needUpdate) {
            if (needUpdate === void 0) {
              needUpdate = true;
            }
            const swiper = this;
            const currentDirection = swiper.params.direction;
            if (!newDirection) {
              // eslint-disable-next-line
              newDirection =
                currentDirection === "horizontal" ? "vertical" : "horizontal";
            }
            if (
              newDirection === currentDirection ||
              (newDirection !== "horizontal" && newDirection !== "vertical")
            ) {
              return swiper;
            }
            swiper.el.classList.remove(
              `${swiper.params.containerModifierClass}${currentDirection}`
            );
            swiper.el.classList.add(
              `${swiper.params.containerModifierClass}${newDirection}`
            );
            swiper.emitContainerClasses();
            swiper.params.direction = newDirection;
            swiper.slides.forEach((slideEl) => {
              if (newDirection === "vertical") {
                slideEl.style.width = "";
              } else {
                slideEl.style.height = "";
              }
            });
            swiper.emit("changeDirection");
            if (needUpdate) swiper.update();
            return swiper;
          }
          changeLanguageDirection(direction) {
            const swiper = this;
            if (
              (swiper.rtl && direction === "rtl") ||
              (!swiper.rtl && direction === "ltr")
            )
              return;
            swiper.rtl = direction === "rtl";
            swiper.rtlTranslate =
              swiper.params.direction === "horizontal" && swiper.rtl;
            if (swiper.rtl) {
              swiper.el.classList.add(
                `${swiper.params.containerModifierClass}rtl`
              );
              swiper.el.dir = "rtl";
            } else {
              swiper.el.classList.remove(
                `${swiper.params.containerModifierClass}rtl`
              );
              swiper.el.dir = "ltr";
            }
            swiper.update();
          }
          mount(element) {
            const swiper = this;
            if (swiper.mounted) return true;

            // Find el
            let el = element || swiper.params.el;
            if (typeof el === "string") {
              el = document.querySelector(el);
            }
            if (!el) {
              return false;
            }
            el.swiper = swiper;
            if (
              el.parentNode &&
              el.parentNode.host &&
              el.parentNode.host.nodeName === "SWIPER-CONTAINER"
            ) {
              swiper.isElement = true;
            }
            const getWrapperSelector = () => {
              return `.${(swiper.params.wrapperClass || "")
                .trim()
                .split(" ")
                .join(".")}`;
            };
            const getWrapper = () => {
              if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
              }
              return (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
                el,
                getWrapperSelector()
              )[0];
            };
            // Find Wrapper
            let wrapperEl = getWrapper();
            if (!wrapperEl && swiper.params.createElements) {
              wrapperEl = (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
                "div",
                swiper.params.wrapperClass
              );
              el.append(wrapperEl);
              (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(
                el,
                `.${swiper.params.slideClass}`
              ).forEach((slideEl) => {
                wrapperEl.append(slideEl);
              });
            }
            Object.assign(swiper, {
              el,
              wrapperEl,
              slidesEl:
                swiper.isElement && !el.parentNode.host.slideSlots
                  ? el.parentNode.host
                  : wrapperEl,
              hostEl: swiper.isElement ? el.parentNode.host : el,
              mounted: true,
              // RTL
              rtl:
                el.dir.toLowerCase() === "rtl" ||
                (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.l)(
                  el,
                  "direction"
                ) === "rtl",
              rtlTranslate:
                swiper.params.direction === "horizontal" &&
                (el.dir.toLowerCase() === "rtl" ||
                  (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.l)(
                    el,
                    "direction"
                  ) === "rtl"),
              wrongRTL:
                (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.l)(
                  wrapperEl,
                  "display"
                ) === "-webkit-box",
            });
            return true;
          }
          init(el) {
            const swiper = this;
            if (swiper.initialized) return swiper;
            const mounted = swiper.mount(el);
            if (mounted === false) return swiper;
            swiper.emit("beforeInit");

            // Set breakpoint
            if (swiper.params.breakpoints) {
              swiper.setBreakpoint();
            }

            // Add Classes
            swiper.addClasses();

            // Update size
            swiper.updateSize();

            // Update slides
            swiper.updateSlides();
            if (swiper.params.watchOverflow) {
              swiper.checkOverflow();
            }

            // Set Grab Cursor
            if (swiper.params.grabCursor && swiper.enabled) {
              swiper.setGrabCursor();
            }

            // Slide To Initial Slide
            if (
              swiper.params.loop &&
              swiper.virtual &&
              swiper.params.virtual.enabled
            ) {
              swiper.slideTo(
                swiper.params.initialSlide + swiper.virtual.slidesBefore,
                0,
                swiper.params.runCallbacksOnInit,
                false,
                true
              );
            } else {
              swiper.slideTo(
                swiper.params.initialSlide,
                0,
                swiper.params.runCallbacksOnInit,
                false,
                true
              );
            }

            // Create loop
            if (swiper.params.loop) {
              swiper.loopCreate();
            }

            // Attach events
            swiper.attachEvents();
            const lazyElements = [
              ...swiper.el.querySelectorAll('[loading="lazy"]'),
            ];
            if (swiper.isElement) {
              lazyElements.push(
                ...swiper.hostEl.querySelectorAll('[loading="lazy"]')
              );
            }
            lazyElements.forEach((imageEl) => {
              if (imageEl.complete) {
                processLazyPreloader(swiper, imageEl);
              } else {
                imageEl.addEventListener("load", (e) => {
                  processLazyPreloader(swiper, e.target);
                });
              }
            });
            preload(swiper);

            // Init Flag
            swiper.initialized = true;
            preload(swiper);

            // Emit
            swiper.emit("init");
            swiper.emit("afterInit");
            return swiper;
          }
          destroy(deleteInstance, cleanStyles) {
            if (deleteInstance === void 0) {
              deleteInstance = true;
            }
            if (cleanStyles === void 0) {
              cleanStyles = true;
            }
            const swiper = this;
            const { params, el, wrapperEl, slides } = swiper;
            if (typeof swiper.params === "undefined" || swiper.destroyed) {
              return null;
            }
            swiper.emit("beforeDestroy");

            // Init Flag
            swiper.initialized = false;

            // Detach events
            swiper.detachEvents();

            // Destroy loop
            if (params.loop) {
              swiper.loopDestroy();
            }

            // Cleanup styles
            if (cleanStyles) {
              swiper.removeClasses();
              el.removeAttribute("style");
              wrapperEl.removeAttribute("style");
              if (slides && slides.length) {
                slides.forEach((slideEl) => {
                  slideEl.classList.remove(
                    params.slideVisibleClass,
                    params.slideActiveClass,
                    params.slideNextClass,
                    params.slidePrevClass
                  );
                  slideEl.removeAttribute("style");
                  slideEl.removeAttribute("data-swiper-slide-index");
                });
              }
            }
            swiper.emit("destroy");

            // Detach emitter events
            Object.keys(swiper.eventsListeners).forEach((eventName) => {
              swiper.off(eventName);
            });
            if (deleteInstance !== false) {
              swiper.el.swiper = null;
              (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.r)(swiper);
            }
            swiper.destroyed = true;
            return null;
          }
          static extendDefaults(newDefaults) {
            (0, _utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(
              extendedDefaults,
              newDefaults
            );
          }
          static get extendedDefaults() {
            return extendedDefaults;
          }
          static get defaults() {
            return defaults;
          }
          static installModule(mod) {
            if (!Swiper.prototype.__modules__)
              Swiper.prototype.__modules__ = [];
            const modules = Swiper.prototype.__modules__;
            if (typeof mod === "function" && modules.indexOf(mod) < 0) {
              modules.push(mod);
            }
          }
          static use(module) {
            if (Array.isArray(module)) {
              module.forEach((m) => Swiper.installModule(m));
              return Swiper;
            }
            Swiper.installModule(module);
            return Swiper;
          }
        }
        Object.keys(prototypes).forEach((prototypeGroup) => {
          Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
            Swiper.prototype[protoMethod] =
              prototypes[prototypeGroup][protoMethod];
          });
        });
        Swiper.use([Resize, Observer]);

        /***/
      },

    /***/ "./node_modules/swiper/shared/utils.mjs":
      /*!**********************************************!*\
  !*** ./node_modules/swiper/shared/utils.mjs ***!
  \**********************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ a: () => /* binding */ elementParents,
          /* harmony export */ b: () => /* binding */ elementOffset,
          /* harmony export */ c: () => /* binding */ createElement,
          /* harmony export */ d: () => /* binding */ now,
          /* harmony export */ e: () => /* binding */ elementChildren,
          /* harmony export */ f: () => /* binding */ elementOuterSize,
          /* harmony export */ g: () => /* binding */ elementIndex,
          /* harmony export */ h: () => /* binding */ getTranslate,
          /* harmony export */ i: () => /* binding */ elementTransitionEnd,
          /* harmony export */ j: () => /* binding */ isObject,
          /* harmony export */ k: () => /* binding */ getSlideTransformEl,
          /* harmony export */ l: () => /* binding */ elementStyle,
          /* harmony export */ m: () => /* binding */ elementNextAll,
          /* harmony export */ n: () => /* binding */ nextTick,
          /* harmony export */ o: () => /* binding */ elementPrevAll,
          /* harmony export */ p: () => /* binding */ animateCSSModeScroll,
          /* harmony export */ q: () => /* binding */ extend,
          /* harmony export */ r: () => /* binding */ deleteProps,
          /* harmony export */ s: () => /* binding */ setCSSProperty,
          /* harmony export */
        });
        /* harmony import */ var _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs"
          );

        function deleteProps(obj) {
          const object = obj;
          Object.keys(object).forEach((key) => {
            try {
              object[key] = null;
            } catch (e) {
              // no getter for object
            }
            try {
              delete object[key];
            } catch (e) {
              // something got wrong
            }
          });
        }
        function nextTick(callback, delay) {
          if (delay === void 0) {
            delay = 0;
          }
          return setTimeout(callback, delay);
        }
        function now() {
          return Date.now();
        }
        function getComputedStyle(el) {
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          let style;
          if (window.getComputedStyle) {
            style = window.getComputedStyle(el, null);
          }
          if (!style && el.currentStyle) {
            style = el.currentStyle;
          }
          if (!style) {
            style = el.style;
          }
          return style;
        }
        function getTranslate(el, axis) {
          if (axis === void 0) {
            axis = "x";
          }
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          let matrix;
          let curTransform;
          let transformMatrix;
          const curStyle = getComputedStyle(el);
          if (window.WebKitCSSMatrix) {
            curTransform = curStyle.transform || curStyle.webkitTransform;
            if (curTransform.split(",").length > 6) {
              curTransform = curTransform
                .split(", ")
                .map((a) => a.replace(",", "."))
                .join(", ");
            }
            // Some old versions of Webkit choke when 'none' is passed; pass
            // empty string instead in this case
            transformMatrix = new window.WebKitCSSMatrix(
              curTransform === "none" ? "" : curTransform
            );
          } else {
            transformMatrix =
              curStyle.MozTransform ||
              curStyle.OTransform ||
              curStyle.MsTransform ||
              curStyle.msTransform ||
              curStyle.transform ||
              curStyle
                .getPropertyValue("transform")
                .replace("translate(", "matrix(1, 0, 0, 1,");
            matrix = transformMatrix.toString().split(",");
          }
          if (axis === "x") {
            // Latest Chrome and webkits Fix
            if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
            // Crazy IE10 Matrix
            else if (matrix.length === 16)
              curTransform = parseFloat(matrix[12]);
            // Normal Browsers
            else curTransform = parseFloat(matrix[4]);
          }
          if (axis === "y") {
            // Latest Chrome and webkits Fix
            if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
            // Crazy IE10 Matrix
            else if (matrix.length === 16)
              curTransform = parseFloat(matrix[13]);
            // Normal Browsers
            else curTransform = parseFloat(matrix[5]);
          }
          return curTransform || 0;
        }
        function isObject(o) {
          return (
            typeof o === "object" &&
            o !== null &&
            o.constructor &&
            Object.prototype.toString.call(o).slice(8, -1) === "Object"
          );
        }
        function isNode(node) {
          // eslint-disable-next-line
          if (
            typeof window !== "undefined" &&
            typeof window.HTMLElement !== "undefined"
          ) {
            return node instanceof HTMLElement;
          }
          return node && (node.nodeType === 1 || node.nodeType === 11);
        }
        function extend() {
          const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
          const noExtend = ["__proto__", "constructor", "prototype"];
          for (let i = 1; i < arguments.length; i += 1) {
            const nextSource =
              i < 0 || arguments.length <= i ? undefined : arguments[i];
            if (
              nextSource !== undefined &&
              nextSource !== null &&
              !isNode(nextSource)
            ) {
              const keysArray = Object.keys(Object(nextSource)).filter(
                (key) => noExtend.indexOf(key) < 0
              );
              for (
                let nextIndex = 0, len = keysArray.length;
                nextIndex < len;
                nextIndex += 1
              ) {
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(
                  nextSource,
                  nextKey
                );
                if (desc !== undefined && desc.enumerable) {
                  if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                    if (nextSource[nextKey].__swiper__) {
                      to[nextKey] = nextSource[nextKey];
                    } else {
                      extend(to[nextKey], nextSource[nextKey]);
                    }
                  } else if (
                    !isObject(to[nextKey]) &&
                    isObject(nextSource[nextKey])
                  ) {
                    to[nextKey] = {};
                    if (nextSource[nextKey].__swiper__) {
                      to[nextKey] = nextSource[nextKey];
                    } else {
                      extend(to[nextKey], nextSource[nextKey]);
                    }
                  } else {
                    to[nextKey] = nextSource[nextKey];
                  }
                }
              }
            }
          }
          return to;
        }
        function setCSSProperty(el, varName, varValue) {
          el.style.setProperty(varName, varValue);
        }
        function animateCSSModeScroll(_ref) {
          let { swiper, targetPosition, side } = _ref;
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          const startPosition = -swiper.translate;
          let startTime = null;
          let time;
          const duration = swiper.params.speed;
          swiper.wrapperEl.style.scrollSnapType = "none";
          window.cancelAnimationFrame(swiper.cssModeFrameID);
          const dir = targetPosition > startPosition ? "next" : "prev";
          const isOutOfBound = (current, target) => {
            return (
              (dir === "next" && current >= target) ||
              (dir === "prev" && current <= target)
            );
          };
          const animate = () => {
            time = new Date().getTime();
            if (startTime === null) {
              startTime = time;
            }
            const progress = Math.max(
              Math.min((time - startTime) / duration, 1),
              0
            );
            const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
            let currentPosition =
              startPosition + easeProgress * (targetPosition - startPosition);
            if (isOutOfBound(currentPosition, targetPosition)) {
              currentPosition = targetPosition;
            }
            swiper.wrapperEl.scrollTo({
              [side]: currentPosition,
            });
            if (isOutOfBound(currentPosition, targetPosition)) {
              swiper.wrapperEl.style.overflow = "hidden";
              swiper.wrapperEl.style.scrollSnapType = "";
              setTimeout(() => {
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                  [side]: currentPosition,
                });
              });
              window.cancelAnimationFrame(swiper.cssModeFrameID);
              return;
            }
            swiper.cssModeFrameID = window.requestAnimationFrame(animate);
          };
          animate();
        }
        function getSlideTransformEl(slideEl) {
          return (
            slideEl.querySelector(".swiper-slide-transform") ||
            (slideEl.shadowRoot &&
              slideEl.shadowRoot.querySelector(".swiper-slide-transform")) ||
            slideEl
          );
        }
        function elementChildren(element, selector) {
          if (selector === void 0) {
            selector = "";
          }
          return [...element.children].filter((el) => el.matches(selector));
        }
        function createElement(tag, classes) {
          if (classes === void 0) {
            classes = [];
          }
          const el = document.createElement(tag);
          el.classList.add(...(Array.isArray(classes) ? classes : [classes]));
          return el;
        }
        function elementOffset(el) {
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          const document = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
          const box = el.getBoundingClientRect();
          const body = document.body;
          const clientTop = el.clientTop || body.clientTop || 0;
          const clientLeft = el.clientLeft || body.clientLeft || 0;
          const scrollTop = el === window ? window.scrollY : el.scrollTop;
          const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
          return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft,
          };
        }
        function elementPrevAll(el, selector) {
          const prevEls = [];
          while (el.previousElementSibling) {
            const prev = el.previousElementSibling; // eslint-disable-line
            if (selector) {
              if (prev.matches(selector)) prevEls.push(prev);
            } else prevEls.push(prev);
            el = prev;
          }
          return prevEls;
        }
        function elementNextAll(el, selector) {
          const nextEls = [];
          while (el.nextElementSibling) {
            const next = el.nextElementSibling; // eslint-disable-line
            if (selector) {
              if (next.matches(selector)) nextEls.push(next);
            } else nextEls.push(next);
            el = next;
          }
          return nextEls;
        }
        function elementStyle(el, prop) {
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          return window.getComputedStyle(el, null).getPropertyValue(prop);
        }
        function elementIndex(el) {
          let child = el;
          let i;
          if (child) {
            i = 0;
            // eslint-disable-next-line
            while ((child = child.previousSibling) !== null) {
              if (child.nodeType === 1) i += 1;
            }
            return i;
          }
          return undefined;
        }
        function elementParents(el, selector) {
          const parents = []; // eslint-disable-line
          let parent = el.parentElement; // eslint-disable-line
          while (parent) {
            if (selector) {
              if (parent.matches(selector)) parents.push(parent);
            } else {
              parents.push(parent);
            }
            parent = parent.parentElement;
          }
          return parents;
        }
        function elementTransitionEnd(el, callback) {
          function fireCallBack(e) {
            if (e.target !== el) return;
            callback.call(el, e);
            el.removeEventListener("transitionend", fireCallBack);
          }
          if (callback) {
            el.addEventListener("transitionend", fireCallBack);
          }
        }
        function elementOuterSize(el, size, includeMargins) {
          const window = (0,
          _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
          if (includeMargins) {
            return (
              el[size === "width" ? "offsetWidth" : "offsetHeight"] +
              parseFloat(
                window
                  .getComputedStyle(el, null)
                  .getPropertyValue(
                    size === "width" ? "margin-right" : "margin-top"
                  )
              ) +
              parseFloat(
                window
                  .getComputedStyle(el, null)
                  .getPropertyValue(
                    size === "width" ? "margin-left" : "margin-bottom"
                  )
              )
            );
          }
          return el.offsetWidth;
        }

        /***/
      },

    /***/ "./node_modules/swiper/swiper.mjs":
      /*!****************************************!*\
  !*** ./node_modules/swiper/swiper.mjs ***!
  \****************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ Swiper: () =>
            /* reexport safe */ _shared_swiper_core_mjs__WEBPACK_IMPORTED_MODULE_0__.S,
          /* harmony export */ default: () =>
            /* reexport safe */ _shared_swiper_core_mjs__WEBPACK_IMPORTED_MODULE_0__.S,
          /* harmony export */
        });
        /* harmony import */ var _shared_swiper_core_mjs__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./shared/swiper-core.mjs */ "./node_modules/swiper/shared/swiper-core.mjs"
          );
        /**
         * Swiper 10.3.1
         * Most modern mobile touch slider and framework with hardware accelerated transitions
         * https://swiperjs.com
         *
         * Copyright 2014-2023 Vladimir Kharlampidi
         *
         * Released under the MIT License
         *
         * Released on: September 28, 2023
         */

        /***/
      },

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/ var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = __webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) {
      /******/ return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (__webpack_module_cache__[moduleId] = {
      /******/ id: moduleId,
      /******/ // no module.loaded needed
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ __webpack_modules__[moduleId].call(
      module.exports,
      module,
      module.exports,
      __webpack_require__
    );
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/ __webpack_require__.m = __webpack_modules__;
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/chunk loaded */
  /******/ (() => {
    /******/ var deferred = [];
    /******/ __webpack_require__.O = (result, chunkIds, fn, priority) => {
      /******/ if (chunkIds) {
        /******/ priority = priority || 0;
        /******/ for (
          var i = deferred.length;
          i > 0 && deferred[i - 1][2] > priority;
          i--
        )
          deferred[i] = deferred[i - 1];
        /******/ deferred[i] = [chunkIds, fn, priority];
        /******/ return;
        /******/
      }
      /******/ var notFulfilled = Infinity;
      /******/ for (var i = 0; i < deferred.length; i++) {
        /******/ var [chunkIds, fn, priority] = deferred[i];
        /******/ var fulfilled = true;
        /******/ for (var j = 0; j < chunkIds.length; j++) {
          /******/ if (
            (priority & (1 === 0) || notFulfilled >= priority) &&
            Object.keys(__webpack_require__.O).every((key) =>
              __webpack_require__.O[key](chunkIds[j])
            )
          ) {
            /******/ chunkIds.splice(j--, 1);
            /******/
          } else {
            /******/ fulfilled = false;
            /******/ if (priority < notFulfilled) notFulfilled = priority;
            /******/
          }
          /******/
        }
        /******/ if (fulfilled) {
          /******/ deferred.splice(i--, 1);
          /******/ var r = fn();
          /******/ if (r !== undefined) result = r;
          /******/
        }
        /******/
      }
      /******/ return result;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/compat get default export */
  /******/ (() => {
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ __webpack_require__.n = (module) => {
      /******/ var getter =
        module && module.__esModule
          ? /******/ () => module["default"]
          : /******/ () => module;
      /******/ __webpack_require__.d(getter, { a: getter });
      /******/ return getter;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/ (() => {
    /******/ // define getter functions for harmony exports
    /******/ __webpack_require__.d = (exports, definition) => {
      /******/ for (var key in definition) {
        /******/ if (
          __webpack_require__.o(definition, key) &&
          !__webpack_require__.o(exports, key)
        ) {
          /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key],
          });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/global */
  /******/ (() => {
    /******/ __webpack_require__.g = (function () {
      /******/ if (typeof globalThis === "object") return globalThis;
      /******/ try {
        /******/ return this || new Function("return this")();
        /******/
      } catch (e) {
        /******/ if (typeof window === "object") return window;
        /******/
      }
      /******/
    })();
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/ (() => {
    /******/ __webpack_require__.o = (obj, prop) =>
      Object.prototype.hasOwnProperty.call(obj, prop);
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/make namespace object */
  /******/ (() => {
    /******/ // define __esModule on exports
    /******/ __webpack_require__.r = (exports) => {
      /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        /******/ Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module",
        });
        /******/
      }
      /******/ Object.defineProperty(exports, "__esModule", { value: true });
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/jsonp chunk loading */
  /******/ (() => {
    /******/ // no baseURI
    /******/
    /******/ // object to store loaded and loading chunks
    /******/ // undefined = chunk not loaded, null = chunk preloaded/prefetched
    /******/ // [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
    /******/ var installedChunks = {
      /******/ "/assets/main": 0,
      /******/ "assets/gift-card": 0,
      /******/ "assets/main": 0,
      /******/
    };
    /******/
    /******/ // no chunk on demand loading
    /******/
    /******/ // no prefetching
    /******/
    /******/ // no preloaded
    /******/
    /******/ // no HMR
    /******/
    /******/ // no HMR manifest
    /******/
    /******/ __webpack_require__.O.j = (chunkId) =>
      installedChunks[chunkId] === 0;
    /******/
    /******/ // install a JSONP callback for chunk loading
    /******/ var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
      /******/ var [chunkIds, moreModules, runtime] = data;
      /******/ // add "moreModules" to the modules object,
      /******/ // then flag all "chunkIds" as loaded and fire callback
      /******/ var moduleId,
        chunkId,
        i = 0;
      /******/ if (chunkIds.some((id) => installedChunks[id] !== 0)) {
        /******/ for (moduleId in moreModules) {
          /******/ if (__webpack_require__.o(moreModules, moduleId)) {
            /******/ __webpack_require__.m[moduleId] = moreModules[moduleId];
            /******/
          }
          /******/
        }
        /******/ if (runtime) var result = runtime(__webpack_require__);
        /******/
      }
      /******/ if (parentChunkLoadingFunction) parentChunkLoadingFunction(data);
      /******/ for (; i < chunkIds.length; i++) {
        /******/ chunkId = chunkIds[i];
        /******/ if (
          __webpack_require__.o(installedChunks, chunkId) &&
          installedChunks[chunkId]
        ) {
          /******/ installedChunks[chunkId][0]();
          /******/
        }
        /******/ installedChunks[chunkId] = 0;
        /******/
      }
      /******/ return __webpack_require__.O(result);
      /******/
    };
    /******/
    /******/ var chunkLoadingGlobal = (self["webpackChunksupertheme"] =
      self["webpackChunksupertheme"] || []);
    /******/ chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
    /******/ chunkLoadingGlobal.push = webpackJsonpCallback.bind(
      null,
      chunkLoadingGlobal.push.bind(chunkLoadingGlobal)
    );
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/nonce */
  /******/ (() => {
    /******/ __webpack_require__.nc = undefined;
    /******/
  })();
  /******/
  /************************************************************************/
  /******/
  /******/ // startup
  /******/ // Load entry module and return exports
  /******/ // This entry module depends on other loaded chunks and execution need to be delayed
  /******/ __webpack_require__.O(
    undefined,
    ["assets/gift-card", "assets/main"],
    () => __webpack_require__("./src/scripts/main.js")
  );
  /******/ __webpack_require__.O(
    undefined,
    ["assets/gift-card", "assets/main"],
    () => __webpack_require__("./src/styles/main.scss")
  );
  /******/ var __webpack_exports__ = __webpack_require__.O(
    undefined,
    ["assets/gift-card", "assets/main"],
    () => __webpack_require__("./src/styles/gift-card.scss")
  );
  /******/ __webpack_exports__ = __webpack_require__.O(__webpack_exports__);
  /******/
  /******/
})();

/* ---------------------------------CART NOTE SCRIPT------------------------------- */
function cartNoteHandler() {
  return {
    note: "", // Holds the cart note text

    // Initialize the cart note on page load
    async initializeNote() {
      try {
        const response = await fetch("/cart.js", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const cart = await response.json();
          this.note = cart.note || ""; // Set note or empty string if null
        } else {
          console.error("Error fetching cart data:", response.statusText);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    },

    // Update the cart note dynamically
    async updateCartNote() {
      try {
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            note: this.note,
          }),
        });

        if (response.ok) {
          const cart = await response.json();
          console.log("Cart note updated:", cart.note);
        } else {
          console.error("Error updating cart note:", response.statusText);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    },
  };
}
/* ---------------------------------CART NOTE SCRIPT------------------------------- */
console.log("test#--3");
/* ---------------------------------DONATION SCRIPT------------------------------- */
document.querySelector(".product__form")?.addEventListener("submit", (event) => {
  const upsellDonation = document.querySelector(".upsell-donation");
  if (!upsellDonation) return; // Donation upsell disabled in theme settings

  const lastDeclined = localStorage.getItem("upsellDeclined");
  const now = Date.now();

  // Check if 10 minutes (600000 ms) have passed since last decline
  if (lastDeclined && now - parseInt(lastDeclined) < ( 120 * 60000 )) {
    return; // Do not show the popup
  }

  // Fetch the cart.json (you can use Shopify's AJAX API to get the cart)
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      // Check if the cart contains a product with the title "One Cup of Porridge: 20,000 Bright Starts"
      const productInCart = cart.items.some((item) =>
        item.title.includes("One Cup of Porridge: 20,000 Bright Starts")
      );

      if (!productInCart) {
        // If the product is not in the cart, apply styles
        upsellDonation.style.display = "flex";
        upsellDonation.style.zIndex = "102";
      }
    })
    .catch((error) => console.error("Error fetching cart:", error));
});

// Function to handle declining the upsell
function declineUpsell() {
  localStorage.setItem("upsellDeclined", Date.now());
  document.querySelector(".upsell-donation").style.display = "none";
  document.querySelector(".upsell-donation").style.zIndex = "0";
}

// Attach event listener to all close buttons
document.querySelectorAll(".close_donation").forEach((button) => {
  button.addEventListener("click", declineUpsell);
});

/* ---------------------------------DONATION SCRIPT------------------------------- */

/* ---------------------------------CART DRAWER UPSELL------------------------------- */


// function initUpsellButtons() {
//   const addUpsellButtons = document.querySelectorAll(".addupsell");

//   if (addUpsellButtons.length) {
//     addUpsellButtons.forEach((button) => {
//       button.addEventListener("click", function () {
//         console.log("Upsell button clicked:", this.id);
//         Alpine.store("cart").addToCart({
//           quantity: 1,
//           variantId: this.id,
//         });
//       });
//     });
//   } else {
//     console.warn("No upsell buttons found in DOM.");
//   }
// }
// document.addEventListener("cart:updated", function (event) {
//   console.log("cart updated!");
// });

function initUpsellButtons() {
  const addUpsellButtons = document.querySelectorAll(".addupsell");

  if (!addUpsellButtons.length) {
    console.warn("No upsell buttons found in DOM.");
    return;
  }

  addUpsellButtons.forEach((button) => {

    // ❗ prevent multiple event binding
    if (button.dataset.upsellBound === "true") return;
    button.dataset.upsellBound = "true";

    button.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      console.log("Upsell button clicked:", this.id);

      Alpine.store("cart").addToCart({
        variantId: this.id,
        quantity: 1 // ✅ ALWAYS 1
      });
    });
  });
}

document.addEventListener("cart:updated", function () {
  console.log("cart updated!");
});


/* ---------------------------------CART DRAWER UPSELL------------------------------- */
